import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          npiRoster: {
            columnHeader: "NPI",
            nameHint: "Enter your name exactly as it appears in the NPPES NPI Registry.",
            title: "NPI roster — {{name}}",
            viewRoster: "Provider NPI",
            edgeCaseHint:
              "If verification didn't complete but the NPI is correct, you can manually clear it. This never affects whether orders can be placed.",
            loading: "Loading providers…",
            noProviders: "No providers with an NPI on file for this account.",
            noNpi: "No NPI on file",
            orgNpi: "Organization NPI",
            verified: "Verified",
            manuallyCleared: "Manually cleared",
            manuallyClearedBy: "Manually cleared by {{name}}",
            unverified: "Unverified",
            manualClear: "Manually clear",
            clearing: "Clearing…",
            clearedToast: "Provider NPI cleared.",
            clearFailedToast: "Couldn't clear this NPI. Please try again.",
            confirmTitle: "Manually clear NPI",
            confirmBody: "Confirm that {{name}}'s NPI is correct and clear it manually? This is recorded with your name.",
            allClearedTooltip: "All providers cleared",
            someUnverifiedTooltip: "{{n}} provider(s) need review",
            noProvidersTooltip: "No providers with an NPI on file",
            notApplicableTooltip: "Not applicable",
            loadErrorTooltip: "Couldn't load NPI status",
            registeredTo: "Registered to",
            failureReason: {
              NOT_FOUND: "NPI not found in NPPES",
              INACTIVE: "NPI inactive in NPPES",
              NAME_MISMATCH: "Name doesn't match NPPES",
              WRONG_TYPE: "Not an individual NPI",
              UNKNOWN: "Couldn't verify NPI",
            },
          },
          "2026-03-01": "2026-04-01",
          "2026-04-01": "2026-04-01",
          "2026-05-01": "2026-04-01",
          UNMANAGED_ERROR: "WARNING",
          aiAgent: {
            activeSwitch: {
              label: "Active",
              active: "Active",
              inactive: "Inactive",
              activatedToast: "Agent activated",
              deactivatedToast: "Agent deactivated",
              supervisorOnly: "Only supervisors can activate agents",
            },
            agentList: {
              addAgent: "Add Agent",
              backToAgents: "Back to Agents",
              defaultAgentName: "Default Agent",
              deleteForever: "Delete forever",
              deletedPrefix: "Deleted",
              empty: "No agents yet",
              emptyTrashBtn: "Empty Trash",
              newAgentName: "New Agent",
              noMatch: "No agents match your search",
              restore: "Restore",
              searchPlaceholder: "Search agents...",
              statusActive: "Active",
              statusInactive: "Inactive — won't accept patient calls",
              trash: "Trash",
              trashEmpty: "Trash is empty",
              untitled: "Untitled Agent",
            },
            builder: {
              flow: {
                closingMessageLabel: "Closing Message",
                closingMessagePlaceholder: "e.g. Thank you for calling. Have a great day!",
                hint: "Design the step-by-step flow of each conversation.",
                openingMessageLabel: "Opening Message",
                openingMessagePlaceholder: "e.g. Thank you for calling Sunrise Medical. How can I help you today?",
                rulesLabel: "Conversation Rules",
                rulesPlaceholder: "Add a conversation rule...",
                stepsLabel: "Conversation Steps",
                title: "Conversation Flow",
              },
              goals: {
                hint: "Define what your agent should accomplish in each conversation.",
                primaryGoalLabel: "Primary Goal",
                primaryGoalPlaceholder: "e.g. Schedule appointments for new and returning patients",
                secondaryGoalsLabel: "Secondary Goals",
                secondaryGoalsPlaceholder: "Add a secondary goal...",
                successCriteriaLabel: "Success Criteria",
                successCriteriaPlaceholder: "Add a success criterion...",
                title: "Goals",
              },
              identity: {
                agentNameIntro: "Hello my name is",
                agentNameLabel: "Agent Name",
                agentNameOutro: "your doctor's virtual assistant",
                agentNamePlaceholder: "e.g. Sofia",
                hint: "Define who your agent is and what role it plays.",
                organizationLabel: "Organization",
                organizationPlaceholder: "e.g. Sunrise Medical Clinic",
                roleDescriptionLabel: "Role Description",
                roleDescriptionPlaceholder: "Describe what this agent does in more detail...",
                roleTitleLabel: "Role Title",
                roleTitlePlaceholder: "e.g. Front Desk Receptionist",
                title: "Identity",
              },
              personality: {
                communicationSpeedLabel: "Communication Speed",
                customToneLabel: "Custom Tone Details",
                customTonePlaceholder: "Add specific tone instructions...",
                emotionalBoundariesLabel: "Emotional Boundaries",
                emotionalBoundariesPlaceholder: "e.g. Stay calm if caller is frustrated, never raise voice",
                hint: "Shape how your agent communicates with callers.",
                languageStyleTagsLabel: "Language Style Tags",
                speedConcise: "Concise — Short, direct responses",
                speedModerate: "Moderate — Balanced detail",
                speedThorough: "Thorough — Detailed explanations",
                title: "Personality & Tone",
                tonePresetLabel: "Tone Preset",
              },
              questions: {
                addPlaceholder: "Add a question...",
                confirmTypeChange: "Changing this type will remove all follow-up questions. Continue?",
                hint: "Build the questions your agent will ask during conversations.",
                title: "Questions",
              },
              responseTypes: {
                choice: "Choice",
                clarification: "Follow-up",
                info_capture: "Info capture",
                narrative: "Open-ended",
                yes_no: "Yes / No",
              },
              rules: {
                additionalLabel: "Additional Instructions",
                additionalPlaceholder: "Any other instructions or context for the agent...",
                conditionalLabel: "Conditional Rules",
                hint: "Set hard rules and boundaries your agent must follow or avoid.",
                mustAlwaysLabel: "Must Always",
                mustAlwaysPlaceholder: "e.g. Verify caller identity before sharing info",
                mustNeverLabel: "Must Never",
                mustNeverPlaceholder: "e.g. Never provide medical diagnoses",
                title: "Guardrails",
              },
              sections: {
                conversationFlow: "Flow",
                goals: "Goals",
                identity: "Identity",
                personality: "Personality",
                questions: "Questions",
                rules: "Guardrails",
              },
              tonePresets: {
                authoritative: "Authoritative",
                casual: "Casual",
                clinical: "Clinical",
                custom: "Custom",
                empathetic: "Empathetic",
                friendly: "Friendly",
                professional: "Professional",
              },
            },
            config: {
              conversationStyle: {
                advanced: "Advanced Tuning",
                auto: "Auto",
                autoDesc: "Adjusts timing automatically",
                hint: "How the agent takes turns in conversation.",
                manual: "Manual",
                manualDesc: "Only responds when explicitly triggered",
                moderate: "Moderate",
                moderateDesc: "Balanced response timing",
                patient: "Patient",
                patientDesc: "Waits longer before replying",
                pauseBefore: "Pause Before Speech",
                quick: "Quick",
                quickDesc: "Responds as soon as possible",
                replySpeedHint: "How quickly the agent jumps in after you stop speaking.",
                replySpeedLabel: "Reply Speed",
                sensitivity: "Sensitivity",
                silenceBefore: "Silence Before Reply",
                smart: "Smart",
                smartDesc: "Waits until you finish your thought before responding",
                standard: "Standard",
                standardDesc: "Responds after detecting pauses in speech",
                title: "Conversation Style",
              },
              creativity: {
                balanced: "Balanced",
                balancedDesc: "Good mix of consistency and natural variation",
                brief: "Brief",
                briefDesc: "Short, concise replies",
                creative: "Creative",
                creativeDesc: "More natural and varied responses",
                detailed: "Detailed",
                detailedDesc: "Thorough explanations",
                extended: "Extended",
                extendedDesc: "Long, comprehensive responses",
                hint: "Control how predictable or varied the agent's responses are.",
                moderate: "Moderate",
                moderateDesc: "Standard conversation length",
                precise: "Precise",
                preciseDesc: "Sticks closely to instructions, very predictable",
                responseLengthHint: "How long the agent's replies should be.",
                responseLengthLabel: "Response Length",
                title: "Creativity",
                veryCreative: "Very Creative",
                veryCreativeDesc: "Maximum variety, less predictable",
              },
              empty: "Select an agent to configure",
              languages: {
                auto: "Auto",
                en: "English",
                es: "Spanish",
                it: "Italian",
                ko: "Korean",
                pt: "Portuguese",
              },
              listening: {
                hint: "How the agent listens and what languages it understands.",
                languageLabel: "Language",
                title: "Listening & Language",
                transcriptionHint: "How accurately the agent converts speech to text.",
                transcriptionLabel: "Transcription Quality",
              },
              noise: {
                closeRange: "Close Range",
                closeRangeDesc: "Best for headsets and close microphones",
                hint: "Filter out background sounds during calls.",
                off: "Off",
                offDesc: "No noise filtering",
                room: "Room",
                roomDesc: "Best for speakerphones and room microphones",
                title: "Background Noise",
              },
              phoneMode: "Phone Mode",
              phoneModeHint: "Enable when this agent will handle phone calls instead of browser voice chat.",
              title: "Configuration",
              voiceIntelligence: {
                hint: "Choose how your agent sounds and how smart it is.",
                intelligenceHint: "Higher intelligence is more accurate but costs more per call.",
                intelligenceLabel: "Intelligence",
                title: "Voice & Intelligence",
                voiceHint: "The voice your agent will use when speaking.",
                voiceLabel: "Voice",
              },
            },
            dialogs: {
              cancel: "Cancel",
              emptyTrashConfirm: "Empty Trash",
              emptyTrashMessage: "Permanently delete all {{count}} trashed agent(s)? This cannot be undone.",
              emptyTrashTitle: "Empty Trash",
              fallbackAgent: "Agent",
              fallbackAgentName: "this agent",
              moveTrashConfirm: "Move to Trash",
              moveTrashMessage: 'Move "{{name}}" to trash? You can restore it later.',
              moveTrashTitle: "Move to Trash",
              movedToTrashToast: '"{{name}}" moved to trash',
              permanentDeleteConfirm: "Delete Forever",
              permanentDeleteMessage: 'Permanently delete "{{name}}"? This cannot be undone.',
              permanentDeleteTitle: "Permanently Delete",
              permanentlyDeletedToast: '"{{name}}" permanently deleted',
              restoredToast: '"{{name}}" restored',
              trashEmptiedToast: "Trash emptied",
              unsavedChanges: "You have unsaved changes. Are you sure you want to leave?",
            },
            encounterPortal: {
              inactive: "This intake link isn't ready yet. Please contact your provider.",
            },
            labels: {
              aiAgentSettings: "AI Agent Settings",
              kpiMetricName: "KPI metric name",
              patientFirstName: "Patient first name",
              phoneNumber: "Phone number",
              prefixPadding: "Prefix padding",
              silenceDuration: "Silence duration",
              stepInstructions: "Step Instructions",
              stepInstructionsPlaceholder:
                'Behavioral guidance for this step, e.g. "Ask one question at a time", conditional logic, framework descriptions...',
              threshold: "Threshold",
            },
            legacyActivationNotice: "Existing agents have been set to Inactive for safety. Activate each one before use.",
            nav: {
              buildManage: "Build & Manage",
              campaigns: "Campaigns",
              campaignsComingSoon: "Coming soon",
              patients: "Patients",
              sessionQueue: "Session Queue",
              test: "Test",
            },
            patients: {
              agentLabel: "AI Agent",
              backToSearch: "Back to search",
              defaultFirstName: "there",
              dobLabel: "DOB",
              encounterName: "Voice Encounter",
              launchDescription:
                "An SMS will be sent to the patient with a link to start a voice conversation. The AI agent will collect encounter information and automatically generate the encounter note.",
              launchNote: "The link is single-use and expires once the encounter is submitted.",
              noPatients: "No patients found",
              panelTitle: "Patients",
              patientLabel: "Patient",
              phoneLabel: "Phone Number",
              remindersTitle: "Reminders",
              searchPlaceholder: "Search patients...",
              searching: "Searching...",
              sendSms: "Send SMS",
              sending: "Sending...",
              smsLabel: "SMS Message",
              smsTemplate:
                "Hi {{name}}, your provider has sent you a link to complete a pre-visit voice check-in. Click the link below to start:",
              toasts: {
                createFailed: "Failed to create encounter. Please try again.",
                linkSent: "Voice encounter link sent via SMS",
                loadFailed: "Failed to load patients. Please try again.",
                sendFailed: "Failed to send link. Please try again.",
              },
            },
            promptEditor: {
              agentNameLabel: "Agent Name",
              agentNamePlaceholder: "Enter agent name",
              builder: "Builder",
              compiledPreviewTitle: "Compiled Prompt Preview",
              configTitle: "Configuration",
              descriptionLabel: "Description",
              descriptionPlaceholder: "Optional description",
              initializeBuilder: "Initialize Builder",
              previewEmpty: "No prompt content yet. Fill in the builder sections to generate a prompt.",
              previewTitle: "Preview prompt",
              raw: "Raw",
              selectAgent: "Select an agent to edit its prompt",
              systemPromptLabel: "System Prompt",
              systemPromptPlaceholder: "Enter system instructions for this agent...",
              title: "Prompt Editor",
            },
            reminders: {
              durationLabel: "Duration",
              durationSuffix: "days",
              enableLabel: "Enable Reminders",
              errors: {
                duration: "Duration must be between 1 and 14 days",
                message: "Message must contain {original_link}",
                window: "Start time must be before end time",
              },
              exhaustedLabel: "When Exhausted",
              exhaustionActions: {
                CLOSE: "Close Session",
                NOTIFY: "Notify Provider",
                QUEUE: "Move to Incomplete Queue",
              },
              frequencies: {
                EVERY_OTHER_DAY: "Every other day",
                ONCE_DAILY: "Once per day",
                TWICE_DAILY: "Twice per day",
              },
              frequencyLabel: "Frequency",
              messageLabel: "Reminder Message",
              variables: {
                attempt: "Current attempt number",
                maxAttempts: "Maximum attempts",
                orgName: "Organization name",
                originalLink: "Voice encounter link",
                patientFirstName: "Patient first name",
              },
              windowLabel: "Reminder Window",
              windowSeparator: "to",
            },
            saveErrorToast: "Error saving agent settings",
            savedToast: "Agent settings saved",
            sessionQueue: {
              actions: {
                closeSession: "Close Session",
                copyLink: "Copy Link",
              },
              columns: {
                actions: "Actions",
                agent: "Agent",
                lastActivity: "Last Activity",
                patient: "Patient",
                reminders: "Reminders",
                sent: "Sent",
                status: "Status",
              },
              defaultAgent: "Voice Encounter",
              empty: "No sessions found",
              noEvents: "No events",
              remindersDisabled: "Disabled",
              stats: {
                active: "Active",
                exhausted: "Exhausted",
                inProgress: "In Progress",
                notClicked: "Not Clicked",
              },
              tabs: {
                abandoned: "Abandoned",
                all: "All",
                expired: "Expired",
                inProgress: "In Progress",
                notClicked: "Not Clicked",
              },
              title: "Session Queue",
              toasts: {
                closeFailed: "Failed to close session",
                closeTitle: "Close Session",
                closed: "Session closed",
                confirmClose: "Close this session? This cannot be undone.",
                copyFailed: "Failed to copy link",
                linkCopied: "Link copied",
                loadFailed: "Failed to load session queue",
                noLink: "No link available for this session",
              },
              unknownPatient: "Unknown",
            },
            sessionStatus: {
              ABANDONED: "Abandoned",
              CLICKED: "Clicked",
              COMPLETED: "Completed",
              DELIVERED: "Delivered",
              EXPIRED: "Expired",
              FAILED: "Failed",
              IN_PROGRESS: "In Progress",
              SENT: "Sent",
              UNDELIVERED: "Undelivered",
            },
            status: {
              connected: "Connected",
              listening: "Listening...",
              speaking: "Speaking...",
              thinking: "Thinking...",
            },
            test: {
              agentsHeader: "Agents",
              callScriptTitle: "Call Script",
              noAgents: "No agents yet — go to <1>Build & Manage</1> to create one.",
              readyBody: "Click Start Voice Chat above to begin a conversation with your AI Assistant.",
              readyHeading: "Ready to listen",
              saveChanges: "Save Changes",
              startVoiceChat: "Start Voice Chat",
              stopVoiceChat: "Stop Voice Chat",
            },
            title: "AI Agent",
          },
          attachments: {
            addDocument: "Add Document",
            noDocumentsUploaded: "No documents uploaded",
            openPdf: "Open PDF",
            rename: "Rename",
            renameDocument: "Rename document",
            title: "Uploads",
            titleLabel: "Title",
            toast: {
              documentDeleted: "Document deleted",
              errorDeletingDocument: "Error deleting document",
              errorLoadingFile: "Error loading file",
              errorRenamingDocument: "Error renaming document",
            },
          },
          auth: {
            changePassword: {
              changeButton: "Change Password",
              confirmPassword: "Confirm Password",
              error: "Error changing password",
              forUserInBrain: "For {{user}} in {{brain}}",
              mismatch: "Password does not match",
              newPassword: "New Password",
              req: {
                length: "Between 12 and 50 characters long",
                lowercase: "It must contain at least one lowercase letter",
                number: "It must contain at least one number",
                special: "It must contain at least one special character",
                uppercase: "It must contain at least one uppercase letter",
              },
              requirementsLead: "Select a password that satisfies the following requirements:",
              success: "Password changed",
              successSubtitle: "Please go back and login with the new password",
              successTitle: "Password changed",
              title: "Change Password",
            },
            common: {
              backToLogin: "Back To Login",
            },
            resetPassword: {
              email: "E-mail",
              error: "Error sending reset link",
              organization: "Organization",
              sendLink: "Send Link",
              subtitle:
                "Please enter the email address and the organization for your account, and we will send you a link to reset your password.",
              success: "Reset link sent to your email",
              title: "Forgot Password?",
            },
          },
          baa: {
            notSigned: "Business Associate Agreement not signed",
            sign: "Sign BAA",
            signedBadge: "BAA Version {{version}} signed on {{date}} by {{name}}",
          },
          brand: "orders",
          chatDetail: {
            actions: "Actions",
            addDocument: "Add Document",
            afterVisitSummary: "After Visit Summary",
            aiNote: "AI Note",
            applyReportCard: "Apply Report Card",
            assignedTo: "Assigned to:",
            createFollowUp: "Create Follow Up",
            debug: "Debug",
            delete: "Delete",
            discard: "Discard",
            editEncounter: "Edit Encounter",
            generate: "Generate",
            generateLoader: "Generating note",
            humanInputs: "Human Inputs",
            lock: "Lock",
            notAssigned: "Not Assigned",
            orderDme: "Order DME",
            outputData: "Output Data",
            recording: "Recording",
            reportCardTitle: "Report Card",
            restore: "Restore",
            sendToEHR: "Send To EHR",
            sexGate: {
              assignFailed: "Could not save the patient's sex. Please try again.",
              tooltip:
                "Sex-specific diagnosis codes were detected, but this patient has no sex on file. Set it to enable sex-incompatible code checking.",
            },
            stopRecording: "Stop recording",
            syncEHR: "Sync EHR",
            tooltips: {
              accountNotEnabled: "Account not enabled to sign",
              accountNotEnabledRestore: "Account not enabled to restore",
              alreadyLocked: "Already locked",
              disabled: "Disabled",
              encounterDeleted: "Encounter deleted",
              encounterLocked: "Encounter locked",
              generationInProgress: "Genearation in progress",
              lockToEnable: "Lock to enable",
              notAllowedToDelete: "Not allowed to delete",
              orderDmeComingSoon: "Coming soon",
              requiredActions: "Required actions before creating follow-up",
              noteStale: "New audio was recorded after this note was generated. Regenerate to include it.",
              stopRecordingToDelete: "Stop the recording before deleting",
              unlockEncounter: "Unlock encounter",
              uploadNotSupported: "Upload not supported for this note type",
              waitForGeneration: "Wait for generation",
              waitForTranscription: "Wait for transcription to finish",
            },
            unlock: "Unlock",
          },
          chatEdit: {
            dmeCheck: {
              missing: "Missing: {{label}} — {{hint}}",
              complete: "Documentation complete",
              dxNotInClaim: "Supporting diagnosis {{code}} isn't in the ICD-10 codes",
              addToIcd: "Add to ICD-10 codes",
              dxAdded: "Added {{code}} to the ICD-10 codes",
              dxNoCode: "The diagnosis line has no ICD-10 code",
              dxCategory: "{{code}} is a category code — choose a more specific billable code",
              labels: {
                diagnosis: "Diagnosis",
                functionalLimitation: "Functional limitation",
                durationOfNeed: "Duration of need",
                faceToFace: "Face-to-face",
                alternativesTried: "Alternatives tried",
                dailyActivities: "Daily activities impact",
                safeUse: "Safe use",
                ambulationBenefit: "Ambulation benefit",
                caneWalkerInsufficient: "Cane/walker insufficient",
                homeAccessibility: "Home accessibility",
                propulsion: "Propulsion",
                positioningNeed: "Positioning need",
                medication: "Medication",
                frequency: "Frequency",
                confinement: "Confinement",
              },
              hints: {
                diagnosis: "the ICD-10 diagnosis that supports the equipment",
                functionalLimitation: "how the condition limits mobility or daily activities",
                durationOfNeed: "how long the equipment is needed (months or lifetime)",
                faceToFace: "the in-person evaluation that supports the order",
                alternativesTried: "lesser equipment or treatments tried or ruled out",
                dailyActivities: "which in-home daily activities (toileting, feeding, dressing, grooming, bathing) are impaired",
                safeUse: "that the patient can use the device safely",
                ambulationBenefit: "how walking improves with the device",
                caneWalkerInsufficient: "why a cane or walker is not enough",
                homeAccessibility: "that the home can accommodate a wheelchair",
                propulsion: "that the patient or a caregiver can and will propel it",
                positioningNeed: "the positioning need an ordinary bed cannot meet",
                medication: "the inhaled medication prescribed",
                frequency: "how often the nebulizer is used",
                confinement: "that the patient is confined to bed or room, or can't reach a toilet",
              },
            },
            download: "Download",
            icd10ClaimFold: "Professional claims carry 12 diagnoses. Codes below this line will not reach the claim.",
            codeRemoved: "Code removed",
            undo: "Undo",
            deleteCode: "Delete code",
            labels: {
              allIcd10Codes: "All the ICD-10 Codes",
              annualCode: "Annual Code",
              code: "Code",
              dropToCreateGroup: "Drop here to create a new group",
              emCode: "E/M Code",
              enableMicrophoneAccess: "Enable Microphone Access",
              modifier25: "Modifier +25",
              noteInfo: "Note Info",
              noteSections: "Note Sections",
              pasteSequence: "Paste Sequence",
              visitTime: "Visit Time",
            },
            magicTransfer: {
              deleteGroup: "Delete group and items",
              dragHere: "Drag sections here",
              ungroup: "Ungroup (keep items)",
            },
            magicTransferInstructions:
              "Click + to add a section, or drag and drop from the left into the paste sequence. Drop onto the dashed box below to create a group — grouped sections paste together as one block. Double-click a group name to rename. Each Ctrl+V automatically pastes the next item in the sequence — no need to copy again.",
            magicTransferTitle: "Magic Transfer",
            oasis: {
              markCompleted: "Mark as completed",
              suggestedValue: "Suggested value:",
            },
            qcodes: {
              area: "Area",
              areaWasted: "Area Wasted",
              cptHeader: "CPT",
              editTitle: "Edit Q-Code",
              icd10Header: "ICD-10",
              makePrimary: "Make Primary",
              noCptAttached: "No CPT code attached. Claims that bill a Q code without its CPT code may be rejected.",
              noCptConfirmMessage:
                "This Q code has no CPT code attached. Claims that bill a Q code without its CPT code may be rejected. Save anyway?",
              noCptConfirmTitle: "No CPT code attached",
              noCptGoBack: "Go back",
              noCptSaveAnyway: "Save anyway",
              noIcd10Codes: "No ICD-10 codes added",
              noIcd10ForCpt: "No ICD-10 codes added for this CPT",
              notSavedNoteChanged: "Q code not saved. The note changed or the editor closed while the confirmation was open.",
              reset: "Reset",
              used: "Used",
              wasted: "Wasted",
            },
            recording: {
              allowMicAccess: "To record audio messages, please allow microphone access in your browser settings.",
              close: "Close",
              enableTitle: "Enable Recordings",
            },
            reviewedCleared: "Reviewed & Cleared",
            toasts: {
              errorChangingDisposition: "Error changing disposition",
              errorCreatingEncounter: "Error creating the encounter",
              fileDownloaded: "File downloaded",
              magicTransferLoaded: "Magic Transfer Loaded",
            },
            billingRules: {
              title: "Billing check",
              venipuncture: "Venipuncture ({{code}}) should not be billed. Remove it before syncing.",
              missingUnits: "{{code}} has no units set. Set units in Edit Codes before syncing.",
              modifierMismatch: "{{code}}: modifier {{actual}} on the note, billing rules expect {{expected}}.",
              modifierMissing: "{{code}}: billing rules expect modifier {{expected}}.",
              notBilled: "Not billed",
            },
          },
          chatInput: {
            conversation: {
              doctor: "Assistant",
              patient: "Patient",
            },
            copyTranscript: "Copy Transcript",
            deleteEntry: {
              auditNote: "Note: The original transcript will be preserved in the audit trail for record-keeping purposes.",
              cancel: "Cancel",
              confirm: "Delete",
              message: "Are you sure you want to delete this transcript entry?",
              title: "Delete Transcript Entry",
              tooltip: "Delete this transcript entry",
            },
            documents: {
              title: "Documents",
            },
            historicalContext: {
              title: "Historical Context",
            },
            manualTranscription: {
              addCurrent: "Add Current Context",
              addHistorical: "Add Historical Context",
              placeholder: "Insert here a transcription ",
              title: "Manual Transcription",
            },
            toast: {
              entryDeleted: "Transcript entry deleted",
              errorDeletingEntry: "Error deleting transcript entry",
              errorDeletingReassessment: "Error deleting reassessment",
              errorGeneratingReassessment: "Error generating reassessment",
              generatingReassessment: "Generating Reassessment",
              reassessmentDeleted: "Reassessment deleted",
            },
            transcript: {
              recordPromptAfter: " to see the transcription.",
              recordPromptBefore: "Please ",
              recordPromptLink: "record a note",
              title: "Transcript",
              totalTime: "Total recording time: ",
              transcribing: "Transcribing",
            },
          },
          chatList: {
            errorLoading: "Error loading chat {{id}}",
            noteTypeNotFound: "{{type}} note type not found",
            today: "Today",
            unknownDate: "Unknown date",
            upcoming: "Upcoming",
          },
          autoCorrect: {
            title: "Corrections applied",
            reviewTitle: "Items to review",
            undo: "Undo",
            undoAll: "Undo all",
            dismiss: "Dismiss",
            locateHint: "Click to find in note",
            unifiedTag: "unified spelling",
            replacedTag: "replaced everywhere",
            allergyTitle: "Not auto-corrected: possible allergy conflict",
            allergyLooksLike: "looks like",
            allergyConflict: "Left unchanged. May conflict with a stated allergy",
            allergyReview: "Please review and correct manually.",
            why: {
              "in-note": "spelled correctly elsewhere in this note",
              route: "matched the administration route",
              class: "matched the drug class",
              consistency: "unified with the spelling used elsewhere",
              match: "closest medication match",
            },
          },
          noteCorrect: {
            replaceEverywhere: "Replace everywhere…",
            replaceLabel: 'Replace "{{word}}" everywhere with:',
            replacePlaceholder: "Correct word",
            replaceApply: "Replace all",
            notRecognized: '"{{word}}" is not in the medication library',
            lowConfidence: "low confidence",
            addToLibrary: "Add to medication library",
            addedToLibrary: '"{{name}}" added to your terminology library',
            addFailed: "Could not update the terminology library",
          },
          seriousDx: {
            title: "Confirm these diagnoses",
            locate: "Find",
            confirm: "Confirm",
          },
          signGate: {
            title: "Confirm AI drug-name changes",
            body: "Lucas auto-corrected these drug names in this note. Please confirm before signing:",
            review: "Review first",
            confirm: "Confirm and sign",
          },
          prevent: {
            title: "PREVENT Cardiovascular Risk (10 & 30 Year)",
            model: {
              base: "AHA PREVENT base model",
            },
            section: {
              demographics: "Demographics",
              labs: "Lab values",
              vitals: "Vitals & history",
            },
            field: {
              sex: "Sex",
              age: "Age",
              totalC: "Total cholesterol",
              hdlC: "HDL cholesterol",
              sbp: "Systolic blood pressure",
              dm: "Diabetes",
              smoking: "Current smoker",
              egfr: "eGFR",
              bpTx: "On blood pressure medication",
              statin: "On statin",
              bmi: "Body mass index (BMI)",
            },
            value: {
              select: "Select",
              female: "Female",
              male: "Male",
            },
            unit: {
              years: "years",
              mgdl: "mg/dL",
              mmhg: "mm Hg",
              egfr: "mL/min/1.73m²",
              bmi: "kg/m²",
            },
            yes: "Yes",
            no: "No",
            fromChart: "from chart",
            fromCodes: "from encounter codes",
            fromLabs: "from labs {{value}}",
            fromLabsEarlier: "from labs {{value}} (earlier visit)",
            fromLabsUndated: "from labs",
            fromMedList: "from med list",
            fromNote: "from note",
            fromA1c: "from A1c {{value}}",
            fromA1cEarlier: "from A1c {{value}} (earlier visit)",
            results: {
              heading: "Estimated risk",
              tenYear: "10-year",
              thirtyYear: "30-year",
              spectrum: "10-yr ASCVD",
              spectrum30: "30-yr ASCVD",
              yr10: "10-yr",
              yr30: "30-yr",
              longTerm:
                "Long-term (30-year) risk is most useful for younger patients, where 10-year risk understates lifetime exposure.",
            },
            scale: {
              lower: "Lower risk",
              higher: "Higher risk",
            },
            outcome: {
              totalCvd: "Total cardiovascular disease",
              ascvd: "Atherosclerotic CVD (ASCVD)",
              heartFailure: "Heart failure",
            },
            outcomeShort: {
              totalCvd: "Total CVD",
              ascvd: "ASCVD",
              heartFailure: "Heart failure",
            },
            band: {
              low: "Low",
              borderline: "Borderline",
              intermediate: "Intermediate",
              high: "High",
            },
            guidance: {
              low: "Below the risk level where a statin is favored by risk alone; focus on lifestyle.",
              borderline: "Shared decision-making zone — weigh risk-enhancing factors before starting therapy.",
              intermediate: "A statin is generally favored alongside lifestyle counseling.",
              high: "Intensive risk-factor modification, including a high-intensity statin, is generally recommended.",
            },
            hf: {
              needsBmi: "Requires BMI 18.5–39.9 to estimate",
            },
            notice: {
              ageRange: "PREVENT applies to ages 30–79. Enter an age in this range to see results.",
            },
            missing: {
              heading: "Complete the required fields to see results",
            },
            empty: {
              hint: "Enter the remaining values to calculate 10- and 30-year risk.",
            },
            range: {
              between: "Must be between {{min}} and {{max}}",
            },
            disclaimer: "Risk estimates support shared decision-making and do not replace clinical judgment — AHA PREVENT™.",
            copy: {
              button: "Copy results",
              copying: "Copying…",
              success: "PREVENT results copied to the clipboard.",
              error: "Couldn’t copy PREVENT results. Try again.",
              summaryHeading: "PREVENT RESULT SUMMARY:",
              totalCvd10: "10-Year Total CVD Risk {{value}}",
              ascvd10: "10-Year ASCVD Risk: {{value}}",
              heartFailure10: "10-Year Heart Failure Risk: {{value}}",
              totalCvd30: "30-Year Total CVD Risk {{value}}",
              ascvd30: "30-Year ASCVD Risk: {{value}}",
              heartFailure30: "30-Year Heart Failure Risk: {{value}}",
              ageUnavailable30: "30-Year Risk: Not available for ages 60–79.",
              bmiUnavailable: "Not available — BMI 18.5–39.9 required.",
            },
            download: "Download patient handout (PDF)",
            pdf: {
              heading: "Your Heart Health Numbers",
              subtitle: "A summary of your 10- and 30-year heart risk",
              patient: "Patient",
              date: "Date",
              heroLabel: "Your 10-year heart risk",
              ascvdCaption: "10-year risk of heart attack or stroke (ASCVD)",
              numbersHeading: "Your numbers",
              tenYear: "Next 10 years",
              thirtyYear: "Next 30 years",
              spectrumHeading: "Where you land",
              yourPosition: "Your 10-year risk of heart attack or stroke is",
              meaningHeading: "What this means",
              interpretationLead:
                "Out of 100 people with numbers like yours, about {{count}} may have a heart or blood-vessel problem in the next 10 years.",
              interpretationLeadRare:
                "Fewer than 1 in 100 people with numbers like yours may have a heart or blood-vessel problem in the next 10 years.",
              bandExplanation: {
                low: "This is considered a low risk level. Keep up your healthy habits.",
                borderline: "This is considered a borderline risk level. Small changes can help keep it low.",
                intermediate: "This is considered an intermediate risk level. Ask your provider about steps to lower it.",
                high: "This is considered a high risk level. Your provider may recommend treatment to lower it.",
              },
              tipsHeading: "Ways to protect your heart",
              tips: {
                smoking: "Avoid smoking and vaping",
                move: "Move most days of the week",
                eat: "Eat more vegetables, fruit, and whole grains",
                numbers: "Know your blood pressure and cholesterol",
                meds: "Take any medicines as prescribed",
              },
              inputsHeading: "The numbers we used",
              notProvided: "Not provided",
              footer: "Talk with your provider before making any changes.",
              citation: "Based on the American Heart Association PREVENT™ risk equations.",
              error: "Failed to generate patient handout",
              ageUnavailable30: "30-year risk is not available for ages 60–79.",
            },
          },
          chatNote: {
            addAssessment: "Add assessment",
            addAssessmentPick: "Choose the diagnosis",
            addAssessmentNoCodes: "Add an ICD-10 code first, then add its assessment here.",
            addAssessmentFailed: "The assessment could not be saved. Please try again.",
            assignedTo: "Assigned to:",
            changeDispo: "Change Dispo",
            procedureNote: "Procedure Note",
            sectionErrorHint: "Tap the highlighted regenerate button above to rebuild this section",
            copy: {
              all: "Copy All",
              ap: "Copy A/P",
              course: "Copy Course",
              custom: "Copy Custom",
              magic: "Magic Transfer",
              obj: "Copy Obj",
              subj: "Copy Subj",
            },
            customizeNote: "Customize Note",
            edit: "Edit",
            editEncounter: "Edit Encounter",
            exportPdf: "Export PDF",
            preventCta: "PREVENT CV Risk",
            filters: {
              missingOnly: "Show only missing informations",
              suggestionsOnly: "Show only suggestions",
            },
            insuranceGrid: "Insurance Grid",
            magicTransfer: {
              allPasted: "All items pasted!",
              remaining: "Transfer Loaded — {{remaining}}/{{total}} remaining",
            },
            notAssigned: "Not Assigned",
            notGenerated: {
              after: " button.",
              before: "Note has not been generated yet, please add some context or ",
              generateLink: "generate",
              middle: " and then click on ",
              recordLink: "record a note",
            },
            noteFallback: {
              title: "This note couldn't be displayed",
              refresh: "Refresh",
              regenerate: "Regenerate note",
            },
            oasis: {
              complete: "Section complete",
              missing: "{{count}} missing",
            },
            orderDme: {
              comingSoon: "Coming soon",
              create: "Order DME",
            },
            originEncounters: "Origin Encounters",
            patientProfile: {
              medications: "Medications",
              none: "No Patient Profile available",
              problems: "Problems",
              title: "Patient Profile",
            },
            previousEncounters: {
              back: "Back to list",
              backShort: "Back",
              close: "Close patient history",
              drawerTitle: "Patient history",
              hide: "Hide",
              loadError: "Couldn't load encounters",
              loadMore: "Load more",
              noteFallback: "Encounter note",
              none: "No previous encounters",
              openFull: "Open full encounter",
              openShort: "Open",
              previewError: "Couldn't load this note",
              retry: "Retry",
              showMore: "Show More",
              signed: "Signed",
              title: "Previous encounters",
              viewAll: "View all",
            },
            priorAuth: {
              create: "Create Prior Auth",
              lockToEnable: "Lock to enable",
            },
            reassign: {
              assignedTo: "This chat is assigned to",
              confirm: "Reassign",
              confirmQuestion: "Do you want to reassign it?",
              inOrderToEdit: "In order to edit it you must assign it to yourself.",
              title: "Reassign Chat",
            },
            reportCard: "Report Card",
            requests: {
              review: "Review",
              title: "Requests to Approve",
            },
            reviewSpelling: "Review Spelling",
            toast: {
              originalRestored: "Original content restored",
            },
            errors: {
              regenerateFailed: "Couldn't regenerate {{section}}. Original content restored.",
            },
            regenStatus: {
              // Phase 1 — typical happy path
              phaseDrafting: "Drafting",
              phaseComposing: "Composing",
              phaseWriting: "Writing",
              phaseOutlining: "Outlining",
              // Phase 2 — model retry / secondary in flight
              phaseThinking: "Thinking",
              phaseAnalyzing: "Analyzing",
              phaseReviewing: "Reviewing",
              phaseReasoning: "Reasoning",
              // Phase 3 — tertiary thinking process
              phaseThinkingHarder: "Thinking harder",
              phaseCrossReferencing: "Cross-referencing",
              phaseConsidering: "Considering options",
              phaseConnectingDots: "Connecting the dots",
              phaseReasoningCarefully: "Reasoning carefully",
              // Phase 4 — long-running, reassuring
              phaseStillWorking: "Still working",
              phasePolishing: "Polishing",
              phaseRefining: "Refining the wording",
              phaseDoubleChecking: "Double-checking",
              phaseAlmostThere: "Almost there",
              phaseHangTight: "Hang tight, we're on it",
              phaseWorkingNuance: "Working through the nuance",
              // Completing flash
              phaseDone: "Done",
              // Aborted (sync API error or 90s hard timeout)
              phaseAborted: "Please edit manually",
            },
            tooltips: {
              copySection: "Copy section",
              editByVoice: "Edit section by voice",
              editICD10: "Edit Code",
              editSection: "Edit section",
              editVitals: "Edit Vitals",
              optimizeFromICD10: "Optimize Note from ICD-10 Codes",
              optimizeICD10: "Optimize ICD-10 Codes",
              regenerateSection: "Regenerate section",
              revertSection: "Revert section",
            },
            visitSummary: "Visit Summary",
            vitals: {
              bmi: "BMI",
              bp: "BP",
              height: "Height",
              none: "No vitals available",
              pulse: "Pulse",
              rr: "RR",
              spO2: "SpO2",
              temp: "Temp",
              title: "Vitals",
              weight: "Weight",
            },
            trends: {
              viewButton: "View trends",
              viewButtonDisabledTooltip: "Needs at least 2 encounters with vitals or wound data",
              title: "Patient trends",
              historyCap: "Based on the most recent 50 encounters on file for this patient.",
              tabs: {
                vitals: "Vitals",
                wound: "Wound",
              },
              rangeLabel: "Time range",
              range: {
                all: "All time",
                90: "Last 90 days",
                180: "Last 6 months",
                365: "Last year",
              },
              metrics: {
                temp: "Temp",
                hr: "Pulse",
                bpSystolic: "BP (systolic)",
                bpDiastolic: "BP (diastolic)",
                spo2: "SpO2",
                rr: "RR",
                weight: "Weight",
                bmi: "BMI",
                totalSurfaceArea: "Total Surface Area",
                totalAreaWithDepth: "Total Area w/ Depth",
                percentImprovement: "% Improvement",
                percentImprovementDerived: "% Improvement (vs. baseline)",
                lengthCm: "Length (cm)",
                widthCm: "Width (cm)",
                depthCm: "Depth (cm)",
                areaCm2: "Surface Area (cm²)",
                areaWithDepthCm3: "Area w/ Depth (cm³)",
                granulationPct: "Granulation (%)",
                sloughPct: "Slough (%)",
                necroticPct: "Necrotic Tissue (%)",
                epitheliumPct: "Epithelium (%)",
                escharPct: "Eschar (%)",
                exudateAmount: "Exudate Amount",
                odor: "Odor",
                percentImprovementBaseline: "% Improvement (vs. baseline)",
                percentImprovementInterval: "% Improvement (vs. last visit)",
                percentImprovementRecorded: "% Improvement (recorded for the visit, not wound-specific)",
                painLevel: "Pain Level (0–10)",
                progress: "Progress",
                infectionSigns: "Signs of Infection",
                tunneling: "Tunneling",
                undermining: "Undermining",
                drainageType: "Drainage Type",
              },
              table: {
                date: "Date",
              },
              noData: "Not enough data to chart yet.",
              deltaUp: "Increased since last visit",
              deltaDown: "Decreased since last visit",
              deltaFlat: "No change since last visit",
              woundSelector: "Wound",
              axisPercent: "%",
              woundAmbiguous: "Two wounds were documented at this site, so changes over time can't be attributed to one of them.",
              tissueIncomplete: "Only documented tissue is shown; the total may be under 100%.",
              legacyHistoryHeading: "Additional recorded measurements",
              flagOnset: "{{flag}} noted",
              flagResolved: "{{flag}} resolved",
            },
            skeletonSimulation: {
              phaseTranscript: "Reviewing transcript…",
              phaseChiefComplaint: "Identifying chief complaint…",
              phaseHPI: "Drafting history of present illness…",
              phaseROS: "Reviewing systems…",
              phaseExam: "Summarizing exam findings…",
              phaseAssessment: "Compiling assessment…",
              phasePlan: "Drafting plan of care…",
              phaseCoding: "Mapping ICD-10 codes…",
              phaseRefinement: "Cross-checking the note…",
              phaseFinalizing: "Finalizing the note…",
            },
          },
          common: {
            all: "All",
            areYouSure: "Are you sure?",
            back: "Back",
            cancel: "Cancel",
            changeIsSaved: "Change is saved",
            close: "Close",
            confirm: "Confirm",
            create: "Create",
            creating: "Creating...",
            delete: "Delete",
            dismiss: "Dismiss",
            done: "Done",
            edit: "Edit",
            errorLoadingContent: "Error loading the content",
            errorReference: "Reference",
            isRequired: "is required",
            labels: {
              completeRequiredDocuments: "Complete Required Documents",
              dataFields: "Data Fields",
              emailSubject: "Email Subject",
              messageBody: "Message Body",
              templateName: "Template Name",
            },
            loadMore: "Load more...",
            loading: "Loading...",
            messageBuilder: {
              charCount: "{{count}} chars",
              composePlaceholder: "Compose your message...",
              noFieldsMatch: "No fields match your search.",
              searchFields: "Search fields...",
              subjectPlaceholder: "e.g. Action Required: Prior Authorization Expiring",
              templateNamePlaceholder: "e.g. Auth Expiration Warning",
            },
            medicalLicense: {
              statePlaceholder: "Search state…",
              numberPlaceholder: "License number",
              add: "Add",
              primary: "Primary",
              setPrimary: "Set primary",
              removeAria: "Remove license",
              hint: "Add a license for each state where you hold one. Re-adding a state updates it.",
            },
            icd10Picker: {
              searchPlaceholder: "Search code or name (try HTN, e119, high blood pressure)",
              typeToSearch: "Type at least 2 characters to search the code index",
              noResults: "No matching codes",
              loading: "Searching codes…",
              searchError: "Couldn't reach the code index. Check your connection and try again.",
              familyHeader: "Codes in the {{root}} family",
              orgBadge: "Org",
              nonBillableBadge: "Non-billable",
              nonBillableHidden: "{{count}} non-billable code(s) hidden",
              matchedVia: "matched {{term}}",
              pickCode: "Pick a code",
              swapHint: "Choose a different code",
              noteCompliance: "Pick only codes this note's documentation supports.",
            },
            mustBeValidYear: "Must be a valid year",
            next: "Next",
            no: "No",
            noItemsToShow: "No items to show",
            noResults: "No results",
            offlineActionNotAllowed: "Action not allowed while offline",
            openCalendar: "Open calendar",
            phoneNumber: "Phone number",
            pleaseWait: "Please wait...",
            reloadApp: "Reload app",
            searching: "Searching...",
            remove: "Remove",
            requiredDocs: {
              benefit1: "Complete your new account setup",
              benefit2: "Sign required agreements digitally",
              benefit3: "Enable product ordering for your organization",
              completeNow: "Complete Now",
              message:
                "Your organization has required documents that need to be completed. This includes the New Account Form, ACH Authorization, BAA, and Purchase Agreement.",
            },
            psaReminder: {
              title: "Sign your Product Service Agreement",
              message:
                "Your manufacturer requires an electronic Product Service Agreement on file before orders can ship. Signing takes about a minute.",
              benefit1: "Activates your DME ordering capability",
              benefit2: "Recorded with a timestamp and audit trail for compliance",
              benefit3: "You can review the full contract before signing",
              later: "Later",
              signNow: "Sign now",
            },
            receivedContractsReminder: {
              title: "You have a contract to sign",
              message:
                "Your manufacturer has sent you a contract to review and sign before orders can ship. It takes about a minute.",
              messagePlural: "Your manufacturer has sent you {{count}} contracts to review and sign before orders can ship.",
              benefit1: "Required before your orders can be processed",
              benefit2: "Recorded with a timestamp and audit trail for compliance",
              benefit3: "You can review the full contract before signing",
              later: "Later",
              reviewNow: "Review & sign",
            },
            save: "Save",
            saving: "Saving...",
            search: "Search",
            today: "Today",
            skip: "Skip",
            testing: "Testing...",
            toasts: {
              copiedToClipboard: "Copied to clipboard",
              errorCopyingNotAuthorized: "Error copying to clipboard: Not Authorized",
            },
            unknown: "Unknown",
            update: "Update",
            upload: {
              browseFolder: "Browse Folder",
              singlePageWarning: "This file type supports only a single page upload",
            },
            name: "Name",
            requiredDocsLock: {
              badge: {
                actionRequired: "Action required",
                daysLeft_one: "{{count}} day left",
                daysLeft_other: "{{count}} days left",
              },
              buttons: {
                close: "Close",
                maybeLater: "Maybe later",
                signNow: "Sign now",
              },
              description: {
                locked: "Your signing window has ended. Until the documents below are signed, orders can't be signed or placed.",
                nonSigner: "Your account holder needs to sign these before your organization can sign or place orders.",
                reminder: "Your signing window is closing. Sign the documents below to keep signing and placing orders.",
              },
              docs: {
                contract: "Contract",
                naf: "New Account Form",
                psa: "Product Service Agreement",
              },
              orderBlocked: "Your required documents are overdue. Sign them to sign or place orders.",
              pill: {
                locked: "Locked until signed",
                reminder: "Sign to keep ordering",
              },
              status: {
                due: "Due {{date}}",
                outstanding: "Outstanding",
                overdueSince: "Overdue since {{date}}",
                signed: "Signed",
                signedExternally: "Signed externally",
              },
              title: "Sign your required documents",
            },
          },
          demo: {
            bannerMessage: "You are viewing the platform in demo mode — no real data or API calls",
            exitDemo: "Exit Demo",
            roles: {
              manufacturer: "Manufacturer",
              manufacturerDesc: "Order Management & Shipping",
              peptidesManufacturer: "Peptide Manufacturer",
              peptidesManufacturerDesc: "Manage catalog, pricing, fulfillment, analytics",
              peptidesPatient: "Peptide Patient",
              peptidesPatientDesc: "Patient self-serve catalog and checkout",
              peptidesProvider: "Peptide Provider",
              peptidesProviderDesc: "Clinic ordering peptides for patients",
              peptidesSalesDashboard: "Peptide Sales Rep",
              peptidesSalesDashboardDesc: "Sales dashboard + personal peptide ordering",
              provider: "Provider",
              providerDesc: "DME Orders & Wound Care",
              salesDashboard: "Sales Dashboard",
              salesDashboardDesc: "Accounts & Performance",
            },
            roleGroups: {
              dme: "DME",
              peptides: "Peptides",
            },
            switchRole: "Switch Role",
          },
          dme: "true",
          impersonation: {
            badge: "SUPPORT SESSION",
            bannerMessage: "You are viewing this account as {{user}}. Everything you do is recorded under {{impersonator}}.",
            exit: "Exit",
            leaving: "Leaving…",
          },
          subscriptionLapsed: {
            message:
              "Your subscription has expired, so you cannot generate new encounters. Click Subscription to renew your plan or contact {{email}}.",
            askAdmin:
              "Your subscription has expired, so you cannot generate new encounters. Ask your account administrator to renew the plan or contact {{email}}.",
            subscription: "Subscription",
          },
          dmeBilling: {
            reminder: {
              benefit1: "Enable product ordering for your organization",
              benefit2: "Set up compliant billing arrangements",
              benefit3: "Get credentialing support if needed",
              later: "Remind Me Later",
              message:
                "To start ordering collagen products, you need to complete your DME billing setup. This only takes a few minutes.",
              setupNow: "Set Up Now",
              title: "Complete Your DME Billing Setup",
            },
            settings: {
              configured: {
                address: "Address",
                companyName: "Company",
                defaultButton: "Default",
                editButton: "Edit DME Billing",
                email: "Billing Email",
                manufacturerDme: "Manufacturer's DME",
                npi: "DME NPI",
                nscNumber: "NSC Number",
                ownDme: "Own DME Company",
                ptan: "PTAN",
                removeButton: "Remove DME Billing",
                setDefaultButton: "Set as Default",
                setupDate: "Setup Date",
                status: "Status",
                statusButton: "Complete Setup",
                taxId: "Tax ID",
                title: "Billing Configured",
                type: "Billing Type",
                usingManufacturer: "Using manufacturer's DME for billing",
              },
              info: {
                credentialing: "Our team can help you get DME certification if needed.",
                description:
                  "Durable Medical Equipment (DME) billing is required for ordering collagen products. This setting applies to all providers in your organization.",
                manufacturerDme: "If you don't have a DME company, the manufacturer's DME will handle billing.",
                ownDme: "If you have your own DME company, billing will go through your company.",
                title: "About DME Billing",
              },
              notConfigured: {
                button: "Add DME Billing",
                description:
                  "Set up your DME billing to start ordering collagen products. This configuration applies to your entire organization.",
                supervisorOnly: "Only supervisors can configure DME billing. Please contact your supervisor to set this up.",
                title: "Billing Not Configured",
              },
              title: "DME Billing",
            },
            statusModal: {
              title: "Credentialing Status",
            },
            wizard: {
              confirmation: {
                address: "Address",
                credentialingPending: "Credentialing team will contact you for DME certification",
                manufacturerDme: "Manufacturer's DME",
                ownDme: "Own DME Company",
                status: "Status",
                title: "Confirm Your DME Billing Setup",
                type: "Billing Type",
              },
              error: "Failed to save DME information",
              manufacturer: {
                bridgeText:
                  "While you don't have your own DME company, you can use the manufacturer's DME for billing collagen products. Our credentialing team will assist you in obtaining DME certification so you can eventually bill under your own DME.",
                bridgeTitle: "Bridge Solution",
                complianceText:
                  "Federal Anti-Kickback regulations prohibit sharing profits from DME billing. This means we cannot provide any portion of DME reimbursements to your practice.",
                complianceTitle: "Anti-Kickback Compliance",
                disclaimer:
                  "By proceeding, you authorize the credentialing team to begin the DME certification process for your practice. The manufacturer will be notified to initiate the credentialing workflow.",
                helpText:
                  "Our team will guide you through the DME certification process at no additional cost. This typically takes 90-120 days.",
                helpTitle: "Credentialing Support",
                title: "Use Manufacturer's DME",
              },
              ownDme: {
                address: "Address",
                city: "City",
                companyName: "Company Name",
                email: "Billing Email",
                npi: "DME NPI",
                npiPlaceholder: "10 digits",
                nscNumber: "NSC Number",
                nscNumberPlaceholder: "10 digits",
                phone: "Phone",
                ptan: "PTAN #",
                ptanPlaceholder: "6-10 characters",
                selectState: "Select State",
                state: "State",
                subtitle: "Please provide your DME company details for billing purposes.",
                taxId: "Tax ID / EIN",
                title: "DME Company Information",
                zip: "Zip Code",
              },
              question: {
                no: "No, I don't have a DME company",
                noShort: "No",
                subtitle: "This helps us set up the correct billing method for collagen products.",
                title: "Do you have your own DME company?",
                yes: "Yes, I have my own DME company",
                yesShort: "Yes",
              },
              success: "DME billing setup complete",
              title: "DME Billing Setup",
              validation: {
                address: "Address is required",
                agreement: "Please agree to the terms to continue",
                city: "City is required",
                companyName: "Company name is required",
                email: "Billing email is required",
                nscNumber: "NSC Number must be exactly 10 digits",
                phone: "Phone is required",
                ptan: "PTAN must be between 6 and 10 characters",
                selectOption: "Please select an option",
                state: "State is required",
                taxId: "Tax ID must be in format XX-XXXXXXX",
                zip: "Zip code is required",
              },
            },
          },
          dmeCredentialing: {
            actions: {
              approve: "Approve Credentialing",
              completed: "Completed",
              markComplete: "Mark Complete",
              startProcess: "Start Processing",
            },
            checklist: {
              accreditation: {
                accreditationCert: "CMS-approved Certification (ACHC, HQAA, BOC, etc.)",
                financialProFormas: "Financial Pro Formas (if required by state)",
                liabilityInsurance: "Liability Insurance Certificate ($300K min)",
                policyManual: "Policy & Procedure Manual (SOPs)",
                suretyBond: "DMEPOS Surety Bond ($50,000)",
                title: "Certification & Quality Standards",
              },
              add: "Add",
              addError: "Failed to add task",
              addTask: "Add Custom Task",
              cancel: "Cancel",
              completed: "completed",
              completedBy: "Completed by",
              corporate: {
                articles: "Articles of Incorporation / Organization",
                ein: "Federal Tax ID (EIN) - IRS Letter CP-575 or Form 147-C",
                lease: "Lease Agreement (brick-and-mortar location)",
                npi: "NPI Number (National Provider Identifier)",
                title: "Corporate & Business Foundation",
                zoning: "Zoning Permit",
              },
              deleteError: "Failed to delete task",
              deleteTask: "Delete task",
              documentUploaded: "Document uploaded",
              medicare: {
                backgroundCheck: "Background Check / Fingerprints",
                cms588: "CMS-588 Form (EFT Authorization)",
                cms855s: "CMS-855S Form",
                title: "Medicare Enrollment (CMS-855S)",
                voidedCheck: "Voided Business Check",
              },
              of: "of",
              other: {
                title: "Other",
              },
              replaceDoc: "Replace document",
              sendReminder: "Send reminder to provider",
              state: {
                dmeStateLicense: "State DME Provider License",
                foreignEntity: "Foreign Entity Registration (if multi-state)",
                professionalLicense: "Professional Licenses (if applicable)",
                salesTax: "Sales Tax Permit / Resale Certificate",
                title: "State-Level Licensing",
              },
              taskAdded: "Task added",
              taskDeleted: "Task deleted",
              taskLabel: "Enter task description...",
              updateError: "Failed to update checklist",
              uploadDoc: "Upload document",
              uploadError: "Failed to upload document",
              viewDoc: "View document",
              viewError: "Failed to load document",
            },
            documents: {
              accreditation: "Certification Certificate",
              businessLicense: "Business License",
              liability: "Liability Insurance",
              npi: "NPI Documentation",
              other: "Other Documents",
              taxId: "Tax ID / W-9",
            },
            drawer: {
              accreditationComplete: "Approved",
              awaitingDocs: "Document Collection",
              awaitingDocsInfo: "Waiting for provider to upload required documents",
              contactInfo: "Contact Information",
              contactName: "Contact Name",
              credentialingComplete: "Credentialing Approved",
              documentRequest: "Document Request",
              documentRequested: "Document requested",
              email: "Email",
              inReview: "In Review",
              messageError: "Failed to send message",
              messageSent: "Message sent",
              needsDocs: "Awaiting uploads",
              noMessages: "No messages yet. Start the conversation to begin the credentialing process.",
              notUploaded: "Not uploaded",
              phone: "Phone",
              processing: "Processing",
              reminderError: "Failed to send reminder",
              request: "Request",
              requestDate: "Request Date",
              requestDoc: "Request:",
              requestError: "Failed to request document",
              submitted: "Request Submitted",
              tabs: {
                checklist: "Checklist",
                conversation: "Conversation",
                details: "Details",
                documents: "Documents",
              },
              timeline: "Timeline",
              typePlaceholder: "Type a message...",
              uploadedOn: "Uploaded",
              view: "View",
              reminderSent: "Reminder sent",
            },
            errorFetching: "Error fetching credentialing requests",
            errorUpdating: "Error updating status",
            filter: {
              all: "All",
              approved: "Approved",
              awaitingDocuments: "Awaiting Documents",
              completed: "Completed",
              inProgress: "In Progress",
              pending: "Pending",
              pendingReview: "Pending Review",
              processing: "Processing",
            },
            kanban: {
              dropHere: "Drop here to change status",
              emptyColumn: "No requests",
            },
            noRequests: "No credentialing requests",
            noRequestsDescription: "No provider organizations have requested DME credentialing yet.",
            noRequestsFiltered: "No requests match the current filter.",
            reminder: {
              add: "Add",
              cancel: "Cancel",
              days: "days",
              inApp: "In-app notification",
              message: "Message",
              messagePlaceholder: "Enter reminder message...",
              noIntervals: "Select at least one reminder interval",
              notifyVia: "Notify via",
              schedule: "Reminder Schedule",
              send: "Send Reminder",
              title: "Send Reminder",
              email: "Email (supervisor accounts)",
            },
            requestedOn: "Requested",
            requests: "Requests",
            status: {
              approved: "Approved",
              awaitingDocuments: "Awaiting Documents",
              completed: "Completed",
              inProgress: "In Progress",
              pending: "Pending",
              pendingReview: "Pending Initial Review",
              processing: "Processing",
            },
            statusUpdated: "Status updated successfully",
            subtitle: "Provider organizations that have requested DME credentialing assistance",
            table: {
              actions: "Actions",
              contact: "Contact",
              email: "Email",
              organization: "Organization",
              phone: "Phone",
              requestDate: "Request Date",
              status: "Status",
            },
            title: "DME Credentialing Requests",
            viewMode: {
              grid: "Table View",
              kanban: "Kanban View",
            },
          },
          doctorTypes: {
            allergyImmunology: "Allergy and Immunology",
            behavioral: "Behavioral",
            cardiologist: "Cardiologist",
            dentist: "Dentist",
            dermatology: "Dermatology",
            endocrinologist: "Endocrinologist",
            er: "ER",
            gastroenterologist: "Gastroenterologist",
            generalSubspecialty: "General Subspecialty",
            generalSurgery: "General Surgery",
            homeHealth: "Home Health",
            hospitalist: "Hospitalist",
            infectiousDiseases: "Infectious Diseases",
            intensivist: "Intensivist",
            internist: "Internist",
            medicalOncology: "Medical Oncology",
            nephrologist: "Nephrologist",
            neuroOrthoSpine: "Neuro/Ortho Spine",
            neurologist: "Neurologist",
            obgyn: "OBGYN",
            oncologist: "Medical Oncologist",
            orthopedicSurgeon: "Orthopedic Surgeon",
            otolaryngologists: "Otolaryngologists",
            painmgmt: "Pain Management",
            paramedics: "Paramedics",
            pediatrician: "Pediatrician",
            physicalTherapist: "Physical Therapist",
            podiatry: "Podiatrist",
            primaryCare: "Primary Care",
            radonc: "Radiation Oncologist",
            rheumatologist: "Rheumatologist",
            urologist: "Urologist",
            woundCare: "Wound Care",
          },
          ehr: {
            editField: {
              alwaysInclude: "Always Include",
              conditionType: "Condition Type",
              conditionValue: "Condition Value",
              description: "Description",
              ehrExistingElements: "EHR Existing Elements",
              ehrNewElement: "EHR New Element",
              element: "Element",
              elementType: "Element Type",
              enabled: "Enabled",
              enabledHint: "Off skips this action during sync without removing it from the template.",
              enterJSCode: "Enter JavaScript code here...",
              eventType: "Event Type",
              execute: "Execute",
              expression: "Expression",
              expressionInJS: "Expression in JS",
              fingerprint: {
                cssSelector: "CSS Selector",
                dataAttributes: "Data Attributes",
                fieldType: "Field Type",
                hash: "Fingerprint Hash",
                label: "Label (detected)",
                noData: "No fingerprint captured. Re-map this field to capture fingerprint data.",
              },
              fingerprintData: "Fingerprint Data",
              getFieldFromPanel: "Get field from Left Panel",
              highlightInPanel: "Highlight field in Left Panel",
              javascript: "Javascript",
              javascriptCode: "JavaScript Code",
              jsonConfiguration: "JSON Configuration",
              milliseconds: "Milliseconds",
              notEmpty: "Not Empty",
              options: {
                blur: "Blur",
                class: "Class",
                click: "Click",
                clickIfExists: "Click If Exists",
                focus: "Focus",
                focusout: "FocusOut",
                id: "Id",
                input: "Input",
                keydown: "KeyDown",
                keyup: "KeyUp",
                name: "Name",
                tinymce: "Tinymce",
                wysihtml: "WYSIHTML",
                xpath: "XPath",
              },
              pageConfiguration: "Page Configuration (JSON)",
              prompt: "Prompt",
              rawJson: "Action JSON",
              rawJsonApply: "Apply JSON",
              rawJsonFallbackInfo:
                'No dedicated editor exists for action type "{{type}}". Edit the raw JSON below, then click Apply to save.',
              rawJsonMustBeArray: "This field must be a JSON array.",
              rawJsonMustBeObject: "Action JSON must be an object.",
              rawJsonRequiresType: 'Action JSON must include a "type" field.',
              rawJsonSaved: "Saved",
              rawJsonUnsaved: "Unsaved JSON changes",
              sectionName: "Section Name",
              title: "Edit {{type}}",
              unsupportedActionType: "Unsupported action type: {{type}}",
              useCDP: "Use CDP (Trusted Click)",
              verifySelector: "Verify selector",
              verifySelectorHint: "Element that must appear after the click",
              verifyElementType: "Verify element type",
              verifyTimeoutMs: "Verify timeout (ms)",
              verifyTimeoutMsHint: "Default 10000, max 60000",
              retryClicks: "Re-click attempts",
              retryClicksHint: "0–20, 0 = click once (+1 CDP click if escalation is on)",
              retryWaitMs: "Re-click wait (ms)",
              retryWaitMsHint: "Default 2000",
              allowCdpEscalation: "Allow CDP escalation",
              disabledSelector: "Disabled selector",
              disabledSelectorHint: "Optional. A visible match means the control is greyed out",
              useCopyAll: "Use Copy All format (bypasses Value, formats note like the Copy All button)",
              value: "Value",
              valueIgnoredCopyAll: "Ignored — using Copy All formatter instead",
              variableName: "Variable Name",
              valueSource: "Value Source",
              codeProperty: "Code Property",
              valueProperty: "Value Property",
              fixedValue: "Fixed Value",
              numericOnly: "Numeric Only",
              fieldSelectorTemplate: "Field Selector Template",
              treatAsSingle: "Treat As Single",
              waitTime: "Wait Time",
              targetVariable: "Target variable",
              carrierSources: "Carrier read sources (JSON)",
              planSources: "Plan read sources (JSON)",
              dobSources: "Date-of-birth read sources (JSON)",
              insuranceRules: "Insurance rule table (JSON)",
            },
            executeTestEHR: {
              chatLabel: "Chat",
              description: "This will execute the configuration steps only.",
              execute: "Execute",
              selectTab: "Select a tab",
              tabLabel: "Tab",
              testDescription: "This is useful to test the configuration without running the full template.",
              title: "Execute Config",
              tooltip: {
                highlightInPanel: "Highlight in Left Panel",
              },
            },
            selectTab: {
              chatLabel: "Chat",
              execute: "Execute",
              selectTab: "Select a tab",
              tabLabel: "Tab",
              title: "Select Execution Params",
              toast: {
                selectChat: "Please select a chat to execute",
                selectTab: "Please select a tab to execute",
              },
            },
            smartPaste: {
              appliedSuccess: "{{section}} applied successfully. Click Next.",
              apply: "Apply",
              applyFailed: "Apply failed. {{section}} copied to clipboard instead. Paste into your EHR, then click Next.",
              applying: "Applying...",
              confirmDismiss: "Are you sure? Sections were not synced.",
              copiedToClipboard: "{{section}} copied to clipboard. Paste into your EHR, then click Next.",
              copyAgain: "Copy Again",
              description: "Smart Paste will guide you through each section. Apply or paste each into your EHR.",
              navigateAndApply: "Navigate to {{section}} in your EHR, then click Apply.",
              sectionsNotSynced: "{{count}} section could not be synced",
              selectDropdown: "Select {{content}} from the {{section}} dropdown in your EHR, then click Next.",
              title: "Smart Paste",
            },
            syncEhr: {
              close: "Close",
              currentStep: "Current Step: {{current}} / {{total}}",
              doNotChangeTab: "Do not change tab",
              errorOccurred: "An error occurred during synchronization",
              errors_one: "{{count}} Error:",
              errors_other: "{{count}} Errors:",
              retry: "Retry",
              section: "Section: {{section}}",
              showTab: "Show Tab",
              stop: "Stop",
              synchronized: "The encounter has been synchronized with the EHR",
              synchronizing: "The encounter is being synchronized with the EHR.",
              title: "Sync EHR",
              errors: "Errors",
            },
          },
          ehrTemplates: {
            actions: {
              createNewTemplate: "Create New Template",
            },
            columns: {
              encounterType: "Encounter Type",
            },
            filters: {
              encounterType: "Encounter Type",
              name: "Name",
              system: "System",
            },
            title: "EHR Templates",
          },
          filters: {
            filterBy: "Filter By",
            group: {
              label: "Group",
              myPatients: "My Patients",
              team: "Team",
            },
            order: {
              alphabetical: "Alphabetical",
              createdOn: "Created On",
              lastUpdate: "Last Update",
              visitTime: "Visit Time",
            },
            orderBy: "Order By",
            reverse: "Reverse",
            status: {
              deleted: "Deleted",
              draft: "Draft",
              generated: "Generated",
              locked: "Locked",
            },
          },
          header: {
            importingEncounter: "Importing encounter...",
            notesLeft: "{{count}} Notes Left",
            switchToDark: "Switch to dark mode",
            switchToLight: "Switch to light mode",
            upgradeNow: "Upgrade Now",
          },
          healthCheck: {
            close: "Close",
            internet: {
              belowRecommended: "Connection below recommended speed",
              connectionIssue: "Connection issue",
              download: "Download",
              failed: "Speed test failed",
              fix: {
                apps: "Close bandwidth-heavy apps",
                restart: "Restart router if needed",
                router: "Move closer to your router",
                wifi: "Check WiFi or ethernet connection",
              },
              label: "Internet",
              latency: "Latency",
              measuringLatency: "Measuring latency...",
              testingDownload: "Testing download speed...",
              timedOut: "Test timed out",
              warmingUp: "Warming up...",
            },
            mic: {
              accessDenied: "Microphone access denied",
              busy: "Microphone is currently in use",
              checkedOnRecord: "Microphone permission will be checked when recording starts",
              checkFailed: "Microphone check failed",
              stopped: "Microphone check stopped",
              notCurrent: "Microphone check is no longer active",
              checking: "Checking microphone...",
              fix: {
                allowPermissions: "Allow microphone permissions",
                lockIcon: "Click lock icon in address bar",
                mobileOtherApp: "Make sure no other app is using the microphone",
                mobileRestart: "Restart the app and try again",
                mobileSettings: "Go to Settings and allow microphone permissions",
                pluggedIn: "Check microphone is plugged in",
                refreshPage: "Refresh page after granting access",
              },
              label: "Microphone",
              noAudio: "No audio detected",
              noDevice: "No microphone found",
              notConfirmed: "Not confirmed",
              notSupported: "Microphone not supported",
              speakToTest: "Speak to test...",
              timedOut: "Microphone check timed out. Please try again.",
              unavailable: "Microphone is unavailable. Close other apps and try again.",
              working: "Microphone working",
            },
            notTested: "Not tested",
            recheck: "Recheck",
            recheckSystem: "Recheck System",
            runningChecks: "Running checks...",
            services: {
              checking: "Checking...",
              connected: "Connected",
              degraded: "Degraded",
              fix: {
                contactIT: "Contact IT if issue persists",
                logOut: "Try logging out and back in",
                verifyNetwork: "Verify network connection",
              },
              label: "{{brand}} Services",
              labelGeneric: "Services",
              unavailable: "Unavailable",
              unreachable: "Unable to reach services",
            },
            summary: {
              allReady: "All Systems Ready",
              criticalIssues: "Critical Issues Detected",
              fixIssues: "Please fix issues below before recording",
              moment: "This will just take a moment",
              readyToRecord: "You're ready to start recording",
              reviewIssues: "Please review issues below",
              running: "Running System Checks",
              someIssues: "Some Issues Detected",
              subtitle: "We run a quick test on your connection and devices",
              title: "System Health Check",
            },
            test: "Test",
          },
          hooks: {
            useChats: {
              changesStoredOffline: "Changes stored offline",
              chatNotFoundForGeneration: "Chat not found for generation",
              customNoteTemplateNotFound: "Custom note template not found. It may have been deleted.",
              encounterNotSelected: "Encounter not selected",
              emptyTranscriptCantGenerate:
                "The transcript is empty — the recording may not have saved. Record again, check Local Recordings, or add manual input first.",
              errorProcessingRecording: "Error processing recording",
              errorTranscribing: "Error transcribing: {{error}}",
              errorUpdatingChat: "Error updating chat",
              errorUpdatingEncounter: "Error updating encounter",
              generateNoteFirst: "Please generate the note first",
              generatingNote: "Generating note for {{lastName}} {{firstName}}",
              generationComplete: "Generation complete",
              generationError: "Generation error",
              loadingError: "Loading Error",
              noOptionsFoundToUpdate: "No options found to update",
              noteSigned: "Note signed for {{lastName}} {{firstName}}",
              noteUpdated: "Note updated",
              encounterAssignedToYou: "Encounter assigned to you",
              encounterStaysAssignedOffline:
                "Saved offline. Your change will sync, but this encounter stays assigned to its current clinician.",
              encounterAssignmentRefused: "This encounter could not be assigned to you, so your change was not saved",
              icd10Updated: "ICD-10 codes were updated",
              processingRecording: "Processing recording...",
              recordNoteFirstOrAddDocument: "Please record a note first or add any document",
              recordingParsedWhenOnline: "Recording will be parsed when online",
              recordingReady: "Recording ready",
              reportCardUpdated: "Report card updated successfully",
              selectEncounterTypeFirst: "Please select an encounter type first",
              transcriptionCompleted: "Transcription completed",
              transcriptionReady: "Your transcription is ready",
              transcriptionNotSaved: "Transcription didn't save — your audio is kept on the device. Retry from Local Recordings.",
              transcriptionStalled: "Transcription didn't finish — your audio is saved. Tap here to reload.",
              unableToLoadEncounters: "Unable to load encounters",
              wrongPin: "Wrong PIN",
            },
            useEHR: {
              cannotFindActiveTab: "Cannot find the active tab",
              chromeExtensionNotAvailable: "Chrome Extension not available",
              errorDuringImport: "Error during import, please try again.",
              errorFindingFields: "Error finding the requested fields in the left panel",
              errorParsingTemplateConfig: "Error parsing EHR template configuration",
              extensionNotAvailable: "Extension not available",
              extensionNotAvailableInstall: "LucasAI extension not available, please install it from the Chrome store.",
              extensionNotConnected: "Extension not connected",
              fieldNotFound: "Field not found",
              fieldsHighlighted: "Fields highlighted in the EHR interface",
              importNotSupported: "Import not supported for {{ehrSystem}} EHR.",
              noEhrTemplatesFound: "No EHR templates found for '{{encounterType}}' note on '{{ehrSystem}}' EHR.",
              noElementSelected: "No element was selected in the left panel",
              noEncountersFound: "No encounters found, please open the schedule on the EHR",
              templateNoActions: "This template has no actions, please edit it in the settings page.",
            },
            useIndexDb: {
              recordingUndecodable:
                "A recording's audio could not be processed. It stays on this device — open Local recordings to save or retry it.",
              errorAddingRecording: "Error adding recording to the store",
              errorSavingRecording: "Error saving recording",
              recordingSyncedLater: "Recording will be synced later",
              recordingUploadPending: "A recording could not be uploaded yet. It is saved and will keep retrying automatically.",
              sessionExpiredRelogin: "Your session expired. Please sign in again to upload your saved recordings.",
              recordingEncounterGone:
                "A saved recording belongs to an encounter that no longer exists. It won't retry automatically — you can review or remove it in Recordings.",
              recordingIdentityParked:
                "A saved recording does not appear to belong to its encounter, so it was not attached. It stays in Recordings for you to review.",
              recordingPartiallyProcessed:
                "Part of this recording couldn't be processed. The note was saved from the audio we could read — please review it for gaps.",
              recordingsUploadSummary: "Recordings still uploading ({{count}}) — tap to manage",
              recoveredCouldNotAttachSigned: "A recovered recording couldn't be attached — the note is already signed.",
              recoverFailed: "Couldn't recover the recording. Try again, or open the device where it was recorded.",
            },
            useJobs: {
              newRequestReceived: "New request received",
            },
            useMediaLibrary: {
              cannotMoveIntoSelf: "Cannot move a folder into itself",
              cannotMoveIntoSubfolder: "Cannot move a folder into its own subfolder",
              failedToCreateFolder: "Failed to create folder",
              failedToDelete: "Failed to delete",
              failedToMoveItems: "Failed to move items",
              failedToRename: "Failed to rename",
              failedToUpload: 'Failed to upload "{{filename}}"',
              folderCreated: "Folder created",
              itemDeleted: "Item deleted",
              itemMoved: "Item moved",
              itemsDeleted: "{{count}} items deleted",
              itemsMoved: "{{count}} items moved",
              renamedSuccessfully: "Renamed successfully",
            },
            useOrdersStats: {
              failedToLoadAccountData: "Failed to load account data",
            },
            usePeptideCart: {
              itemsFromLastSession: "{{count}} item(s) from your last session",
              selectFormTypeMigration: "Select Active or Lyophilized for each product before checkout.",
            },
            usePeptidePricing: {
              failedToSaveProviderTier: "Failed to save provider tier",
              failedToSaveCustomPricing: "Failed to save custom pricing",
              failedToLoadOwnedCustomPricing: "Could not load saved custom prices. Refresh to retry.",
              failedToSaveRetailPricing: "Could not save patient prices.",
            },
            usePostMessages: {
              backOnline: "You are back online",
              done: "Done",
              encountersSynced: "{{count}} Encounter(s) Synced",
              errorSyncingOfflineData: "Error syncing offline data for {{chatId}}",
              offlineDiffGivenUp:
                "Offline changes to encounter {{chatId}} could not be saved after several attempts and were discarded. Please re-enter them.",
              errorSyncingRecording: "Error syncing recording {{recordingId}}",
              recordingEncounterGone:
                "Recording {{recordingId}} belongs to an encounter that no longer exists. It won't retry automatically; the audio stays on your device.",
              microphoneNotAvailable: "Microphone not available",
              nowOffline: "You are now offline",
              optimizingRecording: "Optimizing your recording",
              preparingTranscription: "Preparing your transcription",
              reAuthRequired: "Re-authentication required",
              recordingNotSavedRetry:
                "This recording hasn't been saved yet. Your audio is safe on this device — tap to retry now.",
              savedOfflineWillSync: "Saved to this device — it will sync when you're back online",
              syncingRecording: "Syncing recording {{recordingId}}...",
              uploadingRecording: "Uploading your recording",
            },
            useRecorder: {
              cannotStartRecording: "Cannot start recording",
              cannotStartRecordingDevice: "Cannot start recording with the selected device",
              errorSavingRecording: "Error saving recording",
              errorSavingRecordingWeb: "Error saving recording from web",
              lostRecordingTitle: "Recording not saved",
              lostRecordingBody:
                "We haven't confirmed that the recording started at {{when}} was saved. It may still be recoverable on this device.",
              lostRecordingStartBlocked:
                "New recordings are paused until this recording is recovered. Closing this message keeps that protection in place.",
              lostRecordingTryRecover: "Try to recover",
              lostRecordingRecovering: "Recovering…",
              lostRecordingCheckLocal: "Check Local Recordings",
              lostRecordingDismiss: "Close",
              lostRecordingVerifyTitle: "Verify recovered recording",
              lostRecordingVerifyBody:
                "A recording for this encounter was saved. Check that the transcript from your recording started at {{when}} is complete. Confirming allows you to start new recordings.",
              lostRecordingConfirmRecovered: "I verified the transcript",
              lostRecordingStartFailedTitle: "Check recording start",
              lostRecordingStartFailedBody:
                "The microphone reported a problem starting your recording at {{when}}. If no audio was recorded, confirm below to clear this attempt and allow a new recording. If any audio was recorded, check Local Recordings instead.",
              lostRecordingStartFailedBlocked:
                "New recordings are paused until you confirm no audio was recorded or recover the recording. Closing this message keeps that protection in place.",
              lostRecordingConfirmEmptyStart: "No audio was recorded",
              lostRecordingNotRecovered:
                "Automatic recovery did not finish. Check Local Recordings. If the recording remains stuck, contact support for help recovering it.",
              lostRecordingNoAudioHint:
                "Check Local Recordings first. If the recording ({{when}}) is not in the list, you can confirm below.",
              lostRecordingRelease: "No recording to recover",
              lostRecordingReleaseArm: "Tap again to confirm",
              lostRecordingReleaseWarning:
                "This stops protecting the recording ({{when}}) so you can record again. If the audio appears on this device later, it will still be saved.",
              lostRecordingUnknownTime: "time unknown",
              micDisconnectedSwitching: "Microphone disconnected. Switching to default mic.",
              micRequestTimedOut: "Microphone request timed out. Please allow microphone access and try again.",
              notSupportedOnBrowser: "Not supported on your browser!",
              recordingNotQueuedOffline:
                "The server is unreachable and this recording could NOT be saved for later — it was not kept. Please record it again once you're back online.",
              recordingUploadedWhenOnline: "Recording will be uploaded when online",
              recordingSavedAfterSignIn:
                "You were signed out before this recording could be saved. It is safe on this phone and will upload after you sign in.",
              previousRecordingSaving:
                "Your previous recording is still being saved. Please wait before starting another recording.",
              webRecordingBusy:
                "A recording is active or still saving in another LucasAI window. Return to that window to stop it and finish saving.",
              webRecordingUnavailable:
                "Recording is paused because this browser could not protect your recording. Reload and try again. If this continues, contact support.",
              webRecordingOtherAccount:
                "An interrupted recording belongs to another account. Sign back into that account to review it before starting a new recording.",
              webRecordingRecoveryTitle: "Review interrupted recording",
              webRecordingSaveTitle: "Recording needs to finish saving",
              webRecordingSaveBody: "Audio has not finished saving. Keep this window open and retry saving.",
              webRecordingSaveRetry: "Retry saving",
              webRecordingSaveRetrying: "Saving…",
              webRecordingRecoveryBody:
                "The recording started at {{when}} was interrupted. Saved audio may be incomplete, including the end of the recording. Review the saved audio and encounter transcript before continuing.",
              webRecordingRecoveryMissingAudio:
                "No saved audio was found on this device for this recording. Check the encounter transcript before continuing.",
              webRecordingRecoveryUnknownAudio:
                "We could not check the saved audio on this device. Close this message and try starting again to check it before continuing.",
              webRecordingRecoveryBlocked:
                "New recordings are paused until you review this interruption. Continuing allows a new recording and keeps any audio already saved. Closing this message keeps that protection in place.",
              webRecordingRecoveryReview: "Review saved audio",
              webRecordingRecoveryContinue: "I reviewed the interrupted recording",
              webRecordingRecoveryClose: "Close",
              lowStorageWarning:
                "This device is low on storage — about {{minutes}} min of recording left. Free up space before a long encounter.",
              microphoneWentSilent:
                "Your microphone has stopped sending audio — another app may be using it. Check it now: nothing is being recorded.",
              segmentStorageFailed: "Couldn't save part of the recording — check this device's storage and your connection.",
            },
            useSalesRepsData: {
              failedToLoadSalesRepData: "Failed to load sales rep data",
            },
          },
          icd10Optimizer: {
            docs: "Docs",
            evidence: "Evidence",
            hpi: "HPI",
            noAlternatives: "No alternative codes found",
            original: "Original",
            quality: "Quality",
            reset: "Reset",
            save: "Save",
            selectAlternative: "Select Alternative",
            selectBest: "Select Best",
            selectDescription:
              "Select the most appropriate ICD-10 codes based on the generated score, v28, specificity and evidence in HPI and PLAN",
            showAlternatives: "Show {{count}} Alternatives",
            specificity: "Specificity",
            title: "Optimize ICD-10 Codes",
            v28Codes: "V28 Codes",
          },
          icd10OptimizerNote: {
            clinicalGuidelines: "These suggestions are based on clinical guidelines and documentation requirements.",
            createAddendums: "Create Addendums",
            deselectAll: "Deselect all",
            generatingNote: "Generating a better HPI and Plan Of Care note based on the ICD-10 Codes:",
            hpi: "HPI",
            newHPI: "New HPI",
            newPlanOfCare: "New Plan Of Care",
            noSuggestions: "We couldn't create suggestions for these codes. Please try again.",
            planOfCare: "Plan Of Care",
            reviewAddendums: "Review Addendums",
            reviewing: "Reviewing...",
            save: "Save",
            selectAll: "Select all",
            selectICD10Description: "Select the ICD10 Codes for which you want to create addendum on HPI and Plan Of Care note.",
            selectItems: "Select the items you would like to add to your note.",
            title: "Optimize Docs From ICD-10 Codes",
          },
          importEvent: {
            fileUploaded: "1 file uploaded",
            form: {
              import: "Import",
              type: "Type",
              visitTime: "Visit Time",
            },
            importFromEHR: "Import from EHR",
            or: "OR",
            title: "Create Schedule",
            search: "Search patients…",
            colPatient: "Patient",
            sortBy: "Sort",
            sort: { lastName: "Last name", firstName: "First name", visitTime: "Visit time" },
            summary: {
              selected: "{{selected}} of {{total}} selected",
              needInfo: "{{count}} need info",
              footerNote: "{{count}} still need info before they can be created",
            },
            needsInfo: "needs info",
            selectAll: "Select all",
            createCount: "Create {{count}} Encounters",
            selectPrompt: "Select a patient to edit",
            editor: {
              editing: "Editing — {{name}}",
              attention: "{{count}} fields need attention before import",
              unnamed: "Unnamed patient",
              sexGuessed: "Guessed from the first name — please check",
            },
            sexGuessedShort: "guessed",
            missingLabel: {
              firstName: "first name",
              lastName: "last name",
              dob: "DOB",
              sex: "sex",
              type: "type",
              visitDate: "visit date",
              visitDateRange: "visit date outside today to {{days}} days ahead",
            },
            bulkDate: { label: "Visit date for all rows", apply: "Apply to all rows", hint: "Keeps each row's time" },
            toast: {
              errorImportingData: "Error importing data",
              errorImportingSchedule: "Error importing schedule. Please try again.",
              importingSchedule: "Importing schedule. This can take a while...",
            },
            uploadDescription:
              "Upload a picture or document of your schedule and we will create the encounters for you. Works for today or any day in the next two weeks.",
            scheduleDate: {
              label: "Schedule date",
              hint: "Defaults to today. Change it when this is a future day's schedule.",
              invalid: "Pick a schedule date between today and {{days}} days ahead.",
            },
            uploadTitle: {
              desktop: "Upload an image",
              mobile: "Upload image or take a photo",
            },
            duplicateInList: "Same patient appears in another row",
            duplicateExisting: "Already has an encounter that day at {{time}}",
            duplicateThirdVisit: "Patient already has 2 encounters this day",
            duplicateSecondVisit: "2nd visit that day",
            duplicatesSkipped: "{{count}} duplicates skipped",
            alreadyImportedBanner:
              "This schedule looks already imported — {{dup}} of {{total}} patients already have encounters that day.",
            creatingProgress: "Creating {{done}} of {{total}}…",
            retryFailed: "Retry {{count}} failed",
            createdBadge: "Created",
            partialFailToast: "{{count}} encounters failed to create. Review the list and retry.",
            needInfoSkipped: "{{count}} weren't created — they still need required info.",
          },
          layout: {
            appUpdate: {
              laterButton: "Later",
              message:
                "A new version of the app is required. Please update to continue using Lucas AI.\n\nCurrent version: {{current}}\nRequired version: {{required}}",
              title: "Update Required",
              titleOptional: "Update Available",
              updateButton: "Update Now",
            },
            devSettings: {
              auth: "Auth",
              enableDebug: "Enable debug",
              env: "Env",
              envVars: "Env vars",
              goLocal: "Go to local website",
              iframeUrl: "IFrame URL",
              isOnline: "Is Online",
              save: "Save",
              saveExtensionId: "Save Extension ID",
              title: "Dev Settings",
            },
            mobileAppAlert: {
              android:
                "Lucas AI is available on Google Play! Download our app for a better experience with offline support and native recording.\n\nWould you like to download the app?",
              ios: "Lucas AI is available on the App Store! Download our app for a better experience with offline support and native recording.\n\nWould you like to download the app?",
            },
            offlineBar: "Offline Mode",
            serverUnreachableBar:
              "Server unavailable — working offline. Your work is saved on this device and will sync automatically.",
            recordingRecovery: {
              message: "A recording from {{when}} is still on your {{device}}. Open that device to finish saving it.",
              messageFor: "{{name}}'s recording from {{when}} is still on your {{device}}. Open that device to finish saving it.",
              anotherDevice: "other device",
              hide: "Don't show this again",
              recoverNudge:
                "Part of a recording from {{when}} was saved from another device. Recover the saved part? The rest may be missing.",
              recoverNudgeFor:
                "Part of {{name}}'s recording from {{when}} was saved from another device. Recover the saved part? The rest may be missing.",
              recover: "Recover",
              recovering: "Recovering…",
              openOriginDevice: "This recording was made on a different device — open {{device}} to finish it.",
              openEncounter: "Open this encounter",
            },
            recordingsBacklog: {
              title: "Recordings still on this device",
              body: "We found about {{duration}} of audio in {{count}} recording(s) that hasn't reached your encounters yet.",
              approx: "Lengths are approximate.",
              explain:
                "It stays on this device until it uploads. Review it to retry or save it, or clear it out if you no longer need it.",
              review: "Review recordings",
              later: "Not now",
              saveAll: "Save them first",
              deleteAll: "Delete all {{count}}",
              deleteAllConfirm:
                "Delete all {{count}} recording(s) — about {{duration}} of audio? This can't be undone, and anything that never uploaded is gone for good.",
              confirmDeleteAll: "Delete all {{count}} permanently",
              deleteAllDone: "Deleted {{count}} recording(s) from this device.",
              deleteAllFailed: "Couldn't delete the recordings.",
            },
            recordingsManager: {
              title: "Local recordings",
              empty: "No saved recordings.",
              close: "Close",
              retry: "Retry now",
              retryAll: "Retry all",
              saveAudio: "Save audio",
              saving: "Saving…",
              saveFailed: "Couldn't save the audio file to this device.",
              saveAll: "Save all ({{count}})",
              savingProgress: "Saving {{done}} of {{total}}…",
              saveAllDone: "Saved {{count}} recording(s) to this device.",
              saveAllPartial: "Saved {{saved}}, but {{failed}} could not be saved. Don't delete those yet.",
              saveAllHandedToBrowser:
                "Handed {{count}} file(s) to your browser's downloads. Check your Downloads folder before deleting anything.",
              saveAllHandedToBrowserPartial:
                "Handed {{count}} file(s) to your browser's downloads, but {{failed}} could not be saved. Check your Downloads folder before deleting anything.",
              unfinished: "Unfinished",
              unfinishedNoRetry: "Can't be retried — save the audio or delete it",
              deleteOld: "Delete {{count}} older than {{days}} days",
              deleteOldConfirm:
                "Delete {{count}} recording(s) older than {{days}} days? The audio can't be recovered. Save them first if you still need them.",
              confirmDeleteOld: "Delete {{count}} permanently",
              deleteOldDone: "Deleted {{count}} old recording(s).",
              deleteOldFailed: "Couldn't delete the old recordings.",
              delete: "Delete",
              confirmDelete: "Delete permanently",
              cancel: "Cancel",
              deleteConfirm: "Delete this recording? The audio can't be recovered.",
              attempts: "Attempts: {{count}}",
              parked: "Not attached",
              parkedPredatesEncounter: "Recorded {{recorded}}, before this encounter existed ({{created}}). Not attached.",
              parkedPatientMismatch: "Recorded for a different patient than this encounter's. Not attached.",
              parkedEncounterMismatch: "Recorded for an encounter that no longer exists. Not attached.",
              parkedTooOld: "Recorded {{recorded}}, more than 15 days ago. Not attached automatically.",
              attachConfirm: "This recording may belong to a different visit. Attach it to this encounter anyway?",
              attachRecording: "Recording: {{date}} · {{patient}}",
              attachTarget: "Encounter: {{date}} · {{patient}}",
              attachUnknown: "unknown",
              keepParked: "Keep parked",
              attachAnyway: "Attach anyway",
              patientFromEncounter: "Name taken from the encounter this recording is queued for, not stored with the recording",
              status: {
                pending: "Pending",
                retrying: "Retrying",
                error: "Upload failed",
              },
            },
            recorder: {
              generate: "Generate",
              microphone: "Microphone {{id}}",
              noAudioWarning: "No audio detected - check your microphone",
              ruralMode: "Offline Mode",
              stop: "Stop",
            },
            toasts: {
              officeAddressRequired: "Office address is required for supervisors",
              officeNameRequired: "Office name is required for supervisors",
              selectClinicalRole: "Please select whether you have a clinical or non-clinical role",
              stateRequired: "State is required for US-based supervisors",
              zipCodeRequired: "Zip code is required for US-based supervisors",
            },
          },
          locationSelect: {
            ariaSelect: "Select a location",
            continue: "Continue",
            doNotAsk: "Do not ask anymore",
            lastUsedAccount: "Last used on your account:",
            lastUsedDevice: "Last used on this device:",
            preferenceStoredMessage:
              "You selected to not ask for location change on start. You can revert this setting any time from your profile settings.",
            preferenceStoredTitle: "Preference Stored",
            choosePlaceholder: "Select a location...",
            requiredSubtitle:
              "Your organization has several locations. Choose the one you work in — new encounters are filed against it, and an encounter without a location will not appear in any location-filtered list.",
            requiredTitle: "Set Your Location",
            subtitle: "Select the location you want to work in for this session.",
            title: "Choose Your Location",
          },
          locations: {
            actions: {
              createLocation: "Create Location",
            },
            allLocations: "All Locations",
            encounterRequiresLocation:
              "This encounter needs a location before it can be created. Pick your location from the selector in the header, then try again.",
            filters: {
              search: "Search",
            },
            title: "Locations",
            subtitle: "Full list of locations",
            locationCount_one: "{{count}} Location",
            locationCount_other: "{{count}} Locations",
          },
          login: {
            btn: "Login",
            checkSpamFolder: "If you don't see the email in the next minute, please check your spam folder.",
            confirm: "Confirm",
            didntGetCode: "Didn't get the code?",
            email: "E-mail",
            forgotPassword: "Forgot Password?",
            insertPinCode: "INSERT PIN CODE",
            loginByEmail: "Login by E-mail",
            loginBySms: "Login by SMS",
            loginWithFaceId: "Login with FaceId",
            noCodeOnClipboard: "No verification code found on your clipboard.",
            openEmail: "Open E-mail",
            organization: "Organization",
            password: "Password",
            pasteCode: "Paste code",
            pasteCodeManually: "Now long-press or Ctrl+V to paste your code.",
            rememberLogin: "Remember Login",
            resendCodeByEmail: "Resend code by E-mail",
            resendCodeBySms: "Resend code by SMS",
            resendEmail: "Resend email",
            resendSms: "Resend SMS",
            verificationEmailSent: "An email has been sent to your address with the verification code.",
            verifyCodeSentNeutral: "We sent a 6-digit code to your email or phone on file.",
            verifyCodeSentSms: "We sent a 6-digit code to your phone",
            verifyCodeSentEmail: "We sent a 6-digit code to your email",
            codeMayAutofill: "Your code may fill in automatically.",
            codeIncorrect: "That code wasn't right. Check it and try again, or request a new one.",
            codeExpired: "This code has expired. Tap resend to get a new one.",
            verifyServerError: "We couldn't reach the server. Check your connection and try again.",
            noMobileOnFile: 'No mobile number on file. Use "Resend via email" to get your code.',
            resendInSeconds: "Resend in {{n}}s",
            verifyDevice: "Verify The Current Device",
          },
          modals: {
            afterVisitSummary: {
              charsLimit: "{{count}} / 1600 chars",
              email: "Email",
              generating: "Generating After Visit Summary...",
              language: "Language",
              phoneNumber: "Phone Number",
              regenerate: "Regenerate",
              selectLanguagePrompt: "Select the language to translate the After Visit Summary into:",
              selectTranslationLanguage: "Select Translation Language",
              send: "Send",
              sendBy: "Send By",
              sms: "SMS",
              title: "After Visit Summary",
              toast: {
                sendError: "Error sending After Visit Summary: {{error}}",
                sentTo: "After Visit Summary sent to {{recipient}}",
                smsLimitExceeded: "SMS content exceeds 1600 characters limit.",
              },
              translate: "Translate",
              translating: "Translating After Visit Summary...",
            },
            changeDispo: {
              description: "Select a new disposition. The current disposition sections will be replaced.",
              title: "Change Disposition",
            },
            copySelection: {
              copySelected: "Copy Selected",
              separator: "--- Separator ---",
              title: "Copy Selection",
            },
            createFollowUp: {
              creating: "Creating follow up note...",
              title: "Create Follow Up Note",
              toast: {
                createError: "Error creating the encounter",
                selectNoteType: "Please select a note type",
              },
              typeLabel: "Type {{type}}",
            },
            createPriorAuth: {
              reasonLabel: "Enter the reason for the authorization",
              start: "Start",
              title: "Create Prior Authorization",
              toast: {
                createError: "Error creating prior auth encounter",
                specifyReason: "Please specify a reason",
              },
            },
            customizeNote: {
              changesSaved: "Changes saved here will be applied to all note types",
              customizePrompt: "Customize the note by enabling and disabling the sections",
              resetAll: "Reset All",
              save: "Save",
              separator: "--- Separator ---",
              title: "Customize Note",
            },
            editContextVariable: {
              toast: {
                selectValue: "Plese select a value",
              },
              update: "Update",
              updateWithCount: "Update ({{count}})",
              moreSimilarCodes: "{{count}} more",
              hideAlternatives: "Hide",
              pickOneOf: "1 of {{total}}",
              pickAnyOf: "any of {{total}}",
              alternativesAffordance: "Show alternative codes",
              keepCurrent: "Keep current selection",
              alternativesHeading: "Alternative codes for {{description}}",
              confirmTitle: "Confirm diagnosis codes",
              confirmedCount_one: "{{count}} confirmed",
              confirmedCount_other: "{{count}} confirmed",
              suggestedCount_one: "{{count}} suggested",
              suggestedCount_other: "{{count}} suggested",
              tapToRemove: "tap a row to remove",
              dismissSuggestions: "Dismiss suggestions",
              optimizeDocs: "Optimize docs",
            },
            editInlineVariable: {
              title: "Edit value",
              update: "Update",
            },
            editPatient: {
              assignedTo: "Assigned To",
              fin: "FIN",
              identification: "Room Number",
              incidentDate: "Incident Date",
              location: "Location",
              notDefined: "Not Defined",
              noteInfo: "Note Info",
              title: "Edit Patient",
              toast: {
                completeInfo: "Complete patient information before continuing",
                errorFetching: "Error fetching patient",
                errorUpdatingChat: "Error updating chat",
                errorUpdatingPatient: "Error updating patient",
                patientUpdated: "Patient updated",
              },
              type: "Type",
              update: "Update",
              visitTime: "Visit Time",
              warning: {
                anonymousName: "Patient name must not be anonymous to create a follow-up.",
                dobRequired: "Patient date of birth is required to create a follow-up encounter.",
              },
            },
            erPhase: {
              defaultTitle: "Select a recording type",
              phase: {
                erAdmit: "Disposition: Admit",
                erCriticalCare: "Critical Care",
                erDischarge: "Disposition: Discharge",
                erHPI: "HPI/Initial ER-MDM",
                erHandoff: "Disposition: Handoff",
                erPreHospital: "Pre-Hospital",
                erProcedure: "Procedure",
                erReassessment: "Reassessment",
                erTransfer: "Disposition: Transfer",
              },
            },
            procedureNote: {
              title: "Add Procedure Note",
              searchPlaceholder: "Search procedures...",
              dictate: "Dictate procedure",
              inserted: "Procedure note added. Regenerate the note to include it",
              insertError: "Error adding procedure note",
              noMatches: "No matching procedures",
              templates: {
                lacerationRepair: "Laceration Repair",
                incisionDrainage: "Incision & Drainage",
                splintApplication: "Splint Application",
                reduction: "Fracture/Dislocation Reduction",
                centralLine: "Central Venous Catheter",
                intubation: "Endotracheal Intubation",
                lumbarPuncture: "Lumbar Puncture",
                cardioversion: "Synchronized Cardioversion",
                proceduralSedation: "Procedural Sedation",
                foreignBodyRemoval: "Foreign Body Removal",
                chestTube: "Chest Tube (Thoracostomy)",
              },
            },
            icd10AddCode: {
              actuals: "Actuals",
              add: "Add",
              addCodePlaceholder: "Add a Code",
              codeAdded: "Code added",
              codeAlreadyPresent: "Code already present",
              codesToAdd: "Codes To Add",
              createNewGroup: "Create new group...",
              editCodes: "Edit Codes",
              favorites: "Favorites",
              groupName: "Group name",
              hideFavorites: "Hide Favorites",
              moveToGroup: "Move to group",
              noCodes: "No codes to add yet",
              noCodesAdded: "No codes added",
              noFavorites: "No favorite codes saved",
              save: "Save",
              orgTag: "Org",
              sexConflict:
                "{{code}} is a {{codeSex}}-only diagnosis, but this patient is recorded as {{recordedSex}}. Update the patient's sex from the pencil next to their name, or choose a different code.",
              sexConflictMirror:
                "{{code}} is a {{codeSex}}-only diagnosis, but this patient is recorded as {{recordedSex}}. Use {{mirrorCode}} - {{mirrorDescription}} instead, or update the patient's sex from the pencil next to their name.",
              sexFemale: "female",
              sexMale: "male",
              showFavorites: "Show Favorites",
              title: "Add Code",
              tooltip: {
                addCode: "Add Code",
                moveGroup: "Move favorite group",
                removeFavorite: "Remove from favorites",
              },
              units: "Units",
              unitsPlaceholder: "Units",
              unitsRange: "Units: 1 to {{max}}",
              modifier: "Modifier",
              noModifier: "No mod",
              nonBillableHint: "Billable injections belong in Office Procedures.",
            },
            icd10Optimizer: {
              docs: "Docs",
              hpi: "HPI",
              meta: "Select the most appropriate ICD-10 codes based on the generated score, v28, specificity and evidence in HPI and PLAN",
              noAlternatives: "No alternative codes found",
              original: "Original",
              plan: "PLAN",
              quality: "Quality",
              reset: "Reset",
              save: "Save",
              selectBest: "Select best codes",
              showAlternatives_one: "Show {{count}} Alternative",
              showAlternatives_other: "Show {{count}} Alternatives",
              spec: "SPEC",
              specificity: "Specificity",
              title: "Optimize ICD-10 Codes",
              v28: "V28",
              v28Codes: "V28 Codes",
            },
            icd10OptimizerNote: {
              createAddendums: "Create Addendums",
              generating: "Generating a better HPI and Plan Of Care note based on the ICD-10 Codes:",
              hpi: "HPI",
              meta: "Select the ICD10 Codes for which you want to create addendum on HPI and Plan Of Care note.",
              metaGuidelines: "These suggestions are based on clinical guidelines and documentation requirements.",
              metaSelect: "Select the items you would like to add to your note.",
              planOfCare: "Plan Of Care",
              pleaseWait: "Please wait...",
              reviewAddendums: "Review Addendums",
              title: "Optimize Docs From ICD-10 Codes",
              updateNote: "Update Note",
            },
            installExtension: {
              download: "Download",
              message: "The LucasAI Chrome extension is required to sync with the EHR.",
              title: "LucasAI Extension",
            },
            legalCopyAcknowledgment: {
              accept: "I Acknowledge",
              accepting: "Processing...",
              acknowledgment:
                "By clicking 'I Acknowledge', you confirm that you understand and accept full responsibility for reviewing and validating all AI-generated content before use.",
              cancel: "Cancel",
              disclaimerBody:
                "Our AI system is designed to assist healthcare providers but does not replace your professional medical judgment or clinical responsibilities.",
              disclaimerTitle: "Important Legal Notice",
              point1:
                "You are solely responsible for reviewing all AI-generated clinical notes for accuracy, completeness, and appropriateness.",
              point2:
                "The AI system does not relieve you of liability for errors, omissions, or inappropriate medical documentation.",
              point3:
                "You have a professional and legal obligation to ensure all documentation meets clinical standards and accurately reflects patient care.",
              title: "Provider Accountability Notice",
              toast: {
                error: "Error recording acknowledgment. Please try again.",
                success: "Legal acknowledgment recorded successfully",
              },
            },
            outputData: {
              aliasPlaceholder: "Rename field...",
              collapseAll: "Collapse All",
              configureEndpoint: "Configure an MLLP endpoint in organization settings to enable sending",
              copiedToClipboard: "Copied to clipboard",
              copy: "Copy",
              copyFailed: "Failed to copy",
              deselectAll: "None",
              download: "Download",
              expandAll: "Expand All",
              globalDeselectAll: "Deselect All",
              globalSelectAll: "Select All",
              hl7AssigningAuthority: "Assigning Authority",
              hl7BuildError: "Error building HL7 message",
              hl7DeselectAllSections: "None",
              hl7FacilitySystem: "Facility & System",
              hl7MissingFields: "Required fields missing",
              hl7Mrn: "MRN",
              hl7MrnHelper: "Patient MRN is never saved — enter each time",
              hl7NoSections: "No sections available",
              hl7NoteSections: "Note Sections",
              hl7ObxDivider: "Clinical Observations",
              hl7PatientIdentifiers: "Patient Identifiers",
              hl7Provider: "Provider",
              hl7ProviderFirstName: "First Name",
              hl7ProviderLastName: "Last Name",
              hl7ProviderNpi: "NPI",
              hl7ProviderPrefix: "Prefix",
              hl7ReceivingApplication: "Receiving Application",
              hl7ReceivingFacility: "Receiving Facility",
              hl7SelectAllSections: "All",
              hl7SendingFacility: "Sending Facility",
              hl7Version: "HL7 Version",
              noFieldsSelected: "No fields selected",
              preview: "Preview",
              previewStats: "{{fields}} fields | {{kb}} KB",
              resetDefaults: "Reset to Defaults",
              selectAll: "All",
              sendToEndpoint: "Send",
              sendToEndpointDisabled: "Endpoint not configured",
              stripHtml: "Strip HTML",
              stripHtmlHelper: "Remove HTML tags from exported text fields",
              title: "Export Data",
            },
            previousEncounter: {
              cancel: "Cancel",
              createFollowUp: "Create Follow Up",
              createFollowUpInfo:
                "To create a follow-up of type {{type}}, the patient must have a previous encounter of the following types:",
              encounterPreview: "Encounter Preview",
              goBack: "Go Back",
              last30Days: "Last 30 days",
              last60Days: "Last 60 days",
              last90Days: "Last 90 days",
              loading: "Loading previous encounters...",
              noEncounters: "No previous encounters available.",
              noEncountersTimeframe: "No previous encounters available in this timeframe.",
              noteContext: "Select the encounters to include in the note:",
              preview: "Preview",
              selectAll: "Select All",
              selectEncounter: "Select the encounter you want to use as reference for this follow-up.",
              timeframe: "Timeframe",
              title: "Create Follow-up",
            },
            reviewUserAction: {
              approve: "Approve",
              cancelEdit: "Cancel Edit",
              changes: "Changes",
              date: "Date",
              edit: "Edit",
              edited: "Edited",
              from: "From",
              label: "Label",
              new: "New",
              original: "Original",
              reject: "Reject",
              rejectReason: {
                options: {
                  clinicalDisagree: "I Clinically disagree at this time with this suggestion",
                  needExplanation: "I dont understand why you want this change, can you explain",
                  putInError: "I think this was put in error and not applicable",
                },
                placeholder: "Please select or enter a reason for rejection...",
                required: "Please provide a reason for rejection",
                title: "Reject Reason",
              },
              revertToAI: "Revert to AI Suggestion",
              saveChanges: "Accept with modifications",
              showComparison: "Show Comparison",
              showOriginal: "Show Original",
              title: "Review Request",
              toast: {
                approved: "Request approved successfully",
                error: "Error approving request",
                rejected: "Request rejected successfully",
              },
            },
            selectEHRTemplate: {
              selectTemplate: "Select a template",
              syncToEHR: "Sync To EHR",
              title: "Select A Template",
              toast: {
                downloadLink: "Download extension",
                generateNoteFirst: "Please generate the AI note before syncing to the EHR.",
                installExtension: "LucasAI extension not detected.",
                selectTemplate: "Please select a template",
              },
            },
            selectEncounterType: {
              addType: "Add An Encounter Type",
              title: "Select Encounter Type",
              toast: {
                error: "Error updating chat",
                updated: "Chat updated",
              },
              type: "Type",
              update: "Update",
            },
            uploadDocument: {
              addPage: "Add a page",
              additionalAngle: "Additional Angle",
              billingWorksheet: "Billing Worksheet",
              browseComputer: "Browse files",
              cancel: "Cancel",
              clinicalDocumentation: "Clinical Documentation",
              deleteWound: "Delete wound",
              discardBody: "You have a file that hasn't been uploaded yet. If you close now, it will be discarded.",
              discardConfirm: "Discard",
              discardKeep: "Keep editing",
              discardTitle: "Discard document?",
              documentType: "Document Type",
              dropFiles: "Drag & drop files here",
              dropFilesSubtitle: "or click to browse from your device",
              eob: "EOB",
              existing: "Existing",
              faceSheet: "Face Sheet",
              getScreenshot: "Get Screenshot",
              hcfaForms: "HCFA Forms",
              imaging: "Radiology",
              insuranceCard: "Insurance Card",
              invoices: "Invoices",
              labs: "Labs",
              linkPostImage: "Link Post Image",
              medList: "Med List",
              newWound: "New Wound",
              noImagesYet: "No images yet",
              orderForms: "Order Forms",
              others: "Others",
              pickTypeFirst: "Select a document type first",
              postLabel: "Post",
              preLabel: "Pre",
              records: "Records",
              submit: "Submit",
              submitAs: "Submit as {{type}}",
              title: "Upload a document",
              toast: {
                parseError: "Error parsing document",
                passwordProtected:
                  "This PDF is password-protected. Remove the password (e.g. print or save it as a new PDF) and try again.",
                screenshotError: "Error getting screenshot from extension",
                uploadError: "Error uploading document",
                woundDeleted: "Wound Deleted",
                deleteError: "Delete Error",
              },
              togglePrePost: "Toggle between Pre and Post",
              upload: "Upload",
              uploadPhoto: "Upload Photo",
              uploadTitle: {
                desktop: "Upload an image",
                mobile: "Upload image or take a photo",
              },
              uploaded_one: "Uploaded a document of {{count}} page",
              uploaded_other: "Uploaded a document of {{count}} pages",
              vob: "VOB",
              woundDefaultLabel: "Wound {{count}}",
              woundPhotos: "Wound Photos",
              wounds: "Wounds",
            },
            userActions: {
              noRequests: "No requests to approve",
              title: "Requests to Approve",
            },
            vitals: {
              allergies: "Allergies",
              bmi: "BMI",
              bp: "BP",
              currentMedications: "Current Medications",
              height: "Height",
              patientProfile: "Patient Profile",
              problems: "Problems",
              pulse: "Pulse",
              rr: "RR",
              save: "Save",
              spo2: "SpO2",
              surgeries: "Surgeries",
              temp: "Temp",
              title: "Vitals",
              titleWithSummary: "Vitals & Summary",
              toast: {
                storedOffline: "Changes stored offline",
              },
              visitSummary: "Visit Summary",
              vitalsTitle: "Vitals",
              weight: "Weight",
            },
            inviteToDashboard: {
              title: "Invite patient to dashboard",
              titleRelink: "Relink pricing access",
              bodyPending: "Send an invite to {{email}} so they can claim this profile and access their patient dashboard.",
              bodyAlreadyInvited: "An invite was already sent. You can resend the email or generate a fresh link.",
              bodyLinked:
                "This patient already has an account. Sending a new link refreshes their pricing access — it won't affect their existing account or orders.",
              copyLinkOnly: "Copy link only",
              sendEmail: "Send email",
              resendEmail: "Resend email",
              generateNewLink: "Generate new link",
              confirmRegenerate:
                "This will invalidate the previous invite link. The patient won't be able to use any earlier email. Send a new email with a fresh link?",
              copyLink: "Copy",
              linkCopied: "Invite link copied to clipboard",
              linkReady: "Invite link ready to copy",
              emailSent: "Invite email sent to {{email}}",
              emailDelivered: "Email delivered to {{email}}",
              errorPromoting: "Could not generate invite. Please try again.",
              errorCopying: "Could not copy link. Try selecting the URL manually.",
              done: "Done",
            },
          },
          newChat: {
            createFollowUp: "Create Follow Up",
            form: {
              assignedTo: "Assigned To",
              context: "Context",
              dob: "Date Of Birth",
              dobUnknown: "Unknown",
              duplicatePatientFound: "Duplicate patient found",
              encounterType: "Encounter Type",
              female: "Female",
              firstName: "First Name",
              hideDuplicateList: "Hide Duplicates",
              identification: "Room Number",
              incidentDate: "Incident Date",
              lastName: "Last Name",
              location: "Location",
              male: "Male",
              multiplePatientsSameName: "Multiple patients with same name found",
              patient: "Patient",
              patientSelectedFromDuplicates: "Patient selected from duplicate check",
              phone: "Phone",
              selectNoteType: "Select a note type",
              selectPatient: "Search by name or date of birth",
              selectPatientDuplicate: "Show Duplicates",
              sex: "Sex",
              similarPatientFound: "Similar patient found — '{{name}}' (DOB: {{dob}}). Verify this is a new patient.",
              switchToEstablished: "Switch to Established Patient",
            },
            newProblem: "New Problem",
            notAssigned: "Not Assigned",
            patientType: "Patient Type",
            title: "New Patient Encounter",
            toast: {
              encounterNotCreated: "Encounter not created, please try again",
              encounterWithoutId: "Encounter created without identifier",
              enterFirstName: "Please enter a first name",
              enterLastName: "Please enter a last name",
              errorCreatingEncounter: "Error creating the encounter",
              errorCreatingPatient: "Error creating patient",
              errorImportingFile: "Error importing file",
              errorUpdatingEncounter: "Error updating the encounter",
              importingFile: "Importing file...",
              selectLocation: "Please select a location",
              selectNoteType: "Please select a note type",
              selectPatient: "Please select a patient",
              uploadImage: "Please upload an image",
            },
            type: {
              anonymous: "Anonymous",
              established: "Established",
              establishedSubtitle: "in Lucas system",
              import: "Import",
              newPatient: "New patient",
              newPatientSubtitle: "to Lucas",
            },
            uploadDescription: "Import in prior past documentation, so this encounter starts with the complete patient history.",
            uploadTitle: {
              desktop: "Upload an image",
              mobile: "Upload image or take a photo",
            },
            uploaded_one: "Uploaded {{count}} document",
            uploaded_other: "Uploaded {{count}} documents",
          },
          noteElementCategories: {
            assessmentPlan: "Assessment & Plan",
            billingCoding: "Billing & Coding",
            clinicalCourse: "Clinical Course",
            examination: "Examination",
            formatting: "Formatting",
            history: "History",
            ordersFollowup: "Orders & Follow-up",
            specialty: "Specialty",
          },
          noteElements: {
            allergies: {
              description: "Known allergies and adverse reactions",
              title: "Allergies",
            },
            assessmentPlan: {
              description: "Clinical assessment",
              title: "Assessment",
            },
            barriersToDischarge: {
              description: "Impediments to patient discharge",
              title: "Barriers to Discharge",
            },
            billableCodesICD10: {
              description: "ICD-10 diagnosis codes",
              title: "ICD-10 Codes",
            },
            categories: {
              assessment: "Assessment",
              billing: "Billing & Coding",
              clinicalCourse: "Clinical Course",
              custom: "Custom",
              exam: "Examination",
              formatting: "Formatting",
              history: "History",
              orders: "Orders & Follow-up",
              specialty: "Specialty",
            },
            chiefComplaint: {
              description: "Primary reason for the patient's visit",
              title: "Chief Complaint",
            },
            consent: {
              description: "Informed consent with procedure, risks, benefits, and alternatives",
              title: "Informed Consent",
            },
            cpt2codes: {
              description: "CPT procedure codes",
              title: "CPT Codes",
            },
            cptLevel2: {
              description: "HCPCS Level II codes for supplies and services",
              title: "CPT Level II / HCPCS",
            },
            criticalCareInterventions: {
              description: "Critical care interventions performed",
              title: "Critical Care Interventions",
            },
            criticalCareTime: {
              description: "Critical care time documentation (time-based billing)",
              title: "Critical Care Time",
            },
            currentMedications: {
              description: "Active medications and dosages",
              title: "Current Medications",
            },
            customSection: {
              description: "Create a custom AI-generated section with your own description",
              title: "Custom Section",
            },
            diagnostics: {
              description: "Diagnostic tests and results reviewed",
              title: "Diagnostics",
            },
            differentialDiagnosis: {
              description: "List of possible diagnoses under consideration",
              title: "Differential Diagnosis",
            },
            dischargeCondition: {
              description: "Patient's condition at time of discharge",
              title: "Discharge Condition",
            },
            dischargeDisposition: {
              description: "Patient discharge disposition",
              title: "Discharge Disposition",
            },
            dischargeInstructions: {
              description: "Patient discharge instructions and follow-up",
              title: "Discharge Instructions",
            },
            educationCounseling: {
              description: "Patient education, counseling, and time spent documentation",
              title: "Education & Counseling",
            },
            familyHistory: {
              description: "Relevant family medical history",
              title: "Family History",
            },
            followUp: {
              description: "Follow-up appointment instructions and timeline",
              title: "Follow Up",
            },
            handoff: {
              description: "Clinical handoff summary for care transitions",
              title: "Handoff",
            },
            hospitalCourse: {
              description: "Summary of the patient's hospital stay",
              title: "Hospital Course",
            },
            hpi: {
              description: "Detailed narrative of the patient's current illness",
              title: "History of Present Illness",
            },
            imagingOrdered: {
              description: "Imaging studies ordered",
              title: "Imaging Ordered",
            },
            inOfficeProcedures: {
              description: "In-office procedure codes performed today",
              title: "Office Procedures",
            },
            labsImaging: {
              description: "Laboratory results and imaging findings",
              title: "Labs / Imaging",
            },
            labsOrdered: {
              description: "Laboratory tests and studies ordered",
              title: "Labs Ordered",
            },
            legalDisclaimer: {
              description: "AI documentation legal disclaimer for patient records",
              title: "Legal Disclaimer",
            },
            levelOfService: {
              description: "E&M level of service documentation",
              title: "Level of Service",
            },
            mccCcCodes: {
              description: "Major Complication/Comorbidity and CC codes for DRG",
              title: "MCC / CC Designation",
            },
            medicalDecisionMaking: {
              description: "Documentation of clinical decision making complexity",
              title: "Medical Decision Making",
            },
            pastMedicalHistory: {
              description: "Patient's prior medical conditions and diagnoses",
              title: "Past Medical History",
            },
            pastSurgicalHistory: {
              description: "Patient's prior surgical procedures",
              title: "Past Surgical History",
            },
            patientComplexity: {
              description: "Overall patient complexity level (Low, Moderate, High)",
              title: "Patient Complexity",
            },
            physicalExam: {
              description: "Documentation of physical examination findings",
              title: "Physical Exam",
            },
            planOfCare: {
              description: "Detailed treatment and follow-up plan",
              title: "Plan of Care",
            },
            prescriptionsOrdered: {
              description: "New prescriptions and medication changes",
              title: "Prescriptions Ordered",
            },
            problemList: {
              description: "Active and resolved problem list",
              title: "Problem List",
            },
            procedures: {
              description: "Procedure documentation",
              title: "Procedures",
            },
            referrals: {
              description: "Specialist referrals and consult orders",
              title: "Referrals",
            },
            ros: {
              description: "Systematic review of body systems",
              title: "Review of Systems",
            },
            safetyPlan: {
              description: "Patient safety plan documentation",
              title: "Safety Plan",
            },
            separator: {
              description: "Visual divider between note sections",
              title: "Separator",
            },
            socialHistory: {
              description: "Patient's social and lifestyle factors",
              title: "Social History",
            },
            summaryPrescriptionsOrders: {
              description: "Combined summary of all prescriptions and orders placed",
              title: "Summary of Prescriptions & Orders",
            },
            timeSpent: {
              description: "Total encounter time documentation",
              title: "Time Spent",
            },
            vitals: {
              bloodPressure: "Blood Pressure",
              bmi: "BMI",
              description: "Patient vital signs",
              heartRate: "Heart Rate",
              height: "Height",
              respiratoryRate: "Respiratory Rate",
              spo2: "SpO2",
              temperature: "Temperature",
              title: "Vitals",
              weight: "Weight",
            },
            woundAssessment: {
              description: "Wound measurements, tissue characteristics, and staging",
              title: "Wound Assessment",
            },
          },
          noteNotEnabled: {
            body1: "The note type {{type}} is not currently enabled in your account preferences.",
            body2: "Would you like to activate it so you can create and manage this type of note in the future?",
            enable: "Enable",
            title: "Note Type Not Enabled",
          },
          notePatientTypes: {
            established: "Established Patient",
            new: "New Patient",
          },
          noteSettings: {
            ed: "Emergency Department",
            inpatient: "Inpatient",
            outpatient: "Outpatient / Clinic",
          },
          noteSpecialties: {
            allergy: "Allergy & Immunology",
            behavioral: "Behavioral Health",
            cardiology: "Cardiology",
            dental: "Dental",
            dermatology: "Dermatology",
            endocrinology: "Endocrinology",
            ent: "ENT / Otolaryngology",
            er: "Emergency Medicine",
            gastroenterology: "Gastroenterology",
            generalSurgery: "General Surgery",
            homeHealth: "Home Health",
            hospitalist: "Hospitalist",
            infectiousDiseases: "Infectious Diseases",
            nephrology: "Nephrology",
            neuroOrthoSpine: "Neuro/Ortho Spine",
            neurology: "Neurology",
            obgyn: "OB/GYN",
            orthopedics: "Orthopedics",
            painManagement: "Pain Management",
            pediatrics: "Pediatrics",
            physicalTherapy: "Physical Therapy",
            podiatry: "Podiatry",
            primaryCare: "Primary Care",
            psychiatry: "Psychiatry",
            pulmonology: "Pulmonology",
            radonc: "Radiation Oncology",
            rheumatology: "Rheumatology",
            urology: "Urology",
            woundCare: "Wound Care",
          },
          noteTypes: {
            "alf-home-followup": {
              description: "Follow-up visit for ALF Home",
              label: "ALF/Home - Follow-up",
            },
            "alf-home-new": {
              description: "New patient - ALF/Home",
              label: "ALF/Home - Admit",
            },
            "allergy-followup": {
              description: "Allergy & Immunology follow-up visit and ongoing care documentation",
              label: "Allergy - Follow Up",
            },
            "allergy-new": {
              description: "Allergy & Immunology new patient evaluation and documentation",
              label: "Allergy - New Patient",
            },
            "annual-wellness": {
              description: "Annual Wellness note",
              label: "Annual - Wellness",
            },
            "attending-att-dc": {
              description: "Attending Attestation Note - DC Summary",
              label: "Attending Attestation - DC Summary",
            },
            "attending-att": {
              description: "Attending Attestation Note",
              label: "Attending Attestation",
            },
            "case-conference": {
              description: "Case Conference",
              label: "Case Conference",
            },
            chat: {
              description: "Patient initiated chat",
              label: "Chat",
            },
            "clinic-followup-cardiology": {
              description: "Returning clinic visit for cardiology",
              label: "Cardiology - Follow-up",
            },
            "clinic-followup-gastroenterology": {
              description: "Returning clinic visit for gastroenterology",
              label: "Gastroenterology - Follow-up",
            },
            "clinic-followup-nephrology": {
              description: "Returning clinic visit for nephrology",
              label: "Nephrology - Follow-up",
            },
            "clinic-followup-podiatry": {
              description: "Returning clinic visit for podiatry",
              label: "Podiatry - Follow-up",
            },
            "clinic-followup-pulmonology": {
              description: "Returning clinic visit for pulmonology",
              label: "Pulmonology - Follow-up",
            },
            "clinic-new-cardiology": {
              description: "New patient clinic visit for cardiology",
              label: "Cardiology - New patient",
            },
            "clinic-new-gastroenterology": {
              description: "New patient clinic visit for gastroenterology",
              label: "Gastroenterology - New patient",
            },
            "clinic-new-nephrology": {
              description: "New patient clinic visit for nephrology",
              label: "Nephrology - New patient",
            },
            "clinic-new-podiatry": {
              description: "New patient clinic visit for podiatry",
              label: "Podiatry - New patient",
            },
            "clinic-new-pulmonology": {
              description: "New patient clinic visit for pulmonology",
              label: "Pulmonology - New patient",
            },
            "clinic-new-subspecialty": {
              description: "New patient clinic visit for subspecialty",
              label: "Subspecialty - New patient",
            },
            "clinic-new": {
              description: "New patient note",
              label: "Primary Care - New patient",
            },
            "clinic-phone": {
              description: "Phone message/conversation documentation",
              label: "Phone",
            },
            "clinic-subspecialty": {
              description: "Returning clinic visit for subspecialty",
              label: "Subspecialty - Follow-up",
            },
            "clinic-telemed-audio": {
              description: "Telemedicine audio only note",
              label: "Telemed Audio only",
            },
            "clinic-telemed": {
              description: "Telemedicine note",
              label: "Telemed",
            },
            clinic: {
              description: "Generic clinic note for acute visits, follow-up, health maintenance",
              label: "Primary Care - Follow-up",
            },
            "code-rescue": {
              description:
                "Real-time documentation of critical events, such as code rescue and code blue with detailed audio to text transcription of participants, thoughts and actions",
              label: "Code Rescue",
            },
            "concierge-medicine": {
              description: "Concierge Medicine Visit - Primary Care with screenings",
              label: "Concierge Medicine",
            },
            "consult-hp-cardiology": {
              description: "Initial consult for cardiologist",
              label: "Cardiology - Consult - HP",
            },
            "consult-hp-nephrology": {
              description: "Initial consult for nephrologist",
              label: "Nephrology - Consult - HP",
            },
            "consult-hp-podiatry": {
              description: "Initial consult for podiatry",
              label: "Podiatry - Consult - HP",
            },
            "consult-progress-cardiology": {
              description: "Progress note for cardiologist",
              label: "Cardiology - Consult - Progress",
            },
            "consult-progress-nephrology": {
              description: "Progress note for nephrologist",
              label: "Nephrology - Consult - Progress",
            },
            "consult-progress-podiatry": {
              description: "Progress note for podiatrist",
              label: "Podiatry - Consult - Progress",
            },
            "consult-progress": {
              description: "Inpatient progress note for consultants",
              label: "Consult - Progress",
            },
            consult: {
              description: "Inpatient consult HP",
              label: "Consult - HP",
            },
            cpe: {
              description: "Comprehensive Physical Exam note",
              label: "Comprehensive Physical Exam",
            },
            "critical-care-hp": {
              description: "Admission hp to the icu or step down",
              label: "Critical Care - Admit",
            },
            "critical-care-progress": {
              description: "Progress Critical care progress note",
              label: "Critical Care - Progress",
            },
            custom: {
              description: "Custom note template",
            },
            death: {
              description: "Discharge summary for expired patients",
              label: "Medical - Discharge - Death",
            },
            "dental-care-progress": {
              description: "Progress note for dentist",
              label: "Dental - Care",
            },
            "derm-followup": {
              description: "Dermatology follow-up visit and ongoing care documentation",
              label: "Derm - Follow Up",
            },
            "derm-new": {
              description: "Dermatology new patient evaluation and documentation",
              label: "Derm - New Patient",
            },
            "derm-procedure": {
              description: "Dermatology procedure documentation including minor surgeries, biopsies, or treatments",
              label: "Derm - Procedure",
            },
            "derm-soap": {
              description: "Simplified dermatology SOAP note for concise clinical documentation",
              label: "Derm - SOAP (Simplified)",
            },
            "diagnostic-cath": {
              description: "Diagnostic Angiogram, no interventions",
              label: "Cardiology - Diag. Cath",
            },
            discharge: {
              description: "Discharge inpatient medical note",
              label: "Medical - Discharge - Summary",
            },
            "discseel-eval": {
              description: "Evaluation for therapeutic intervention with Discseel",
              label: "Discseel - Evaluation",
            },
            "endocrinology-followup": {
              description: "Returning clinic visit for endocrinology",
              label: "Endocrine - Follow-up",
            },
            "endocrinology-new": {
              description: "New patient clinic visit for endocrinology",
              label: "Endocrine - New patient",
            },
            "ent-followup": {
              description: "Returning clinic visit for ENT",
              label: "ENT - Follow-up",
            },
            "ent-new": {
              description: "New patient clinic visit for ENT",
              label: "ENT - New patient",
            },
            er: {
              description: "ER documentation",
              label: "ER Note",
            },
            "gynecology-followup": {
              description: "Returning clinic visit for Gynecology",
              label: "Gynecology - Follow-up",
            },
            "gynecology-new": {
              description: "New patient clinic visit for Gynecology",
              label: "Gynecology - New patient",
            },
            handoff: {
              description: "Hand off of encounter",
              label: "Handoff",
            },
            history: {
              description: "Generic inpatient medical admission note",
              label: "Medical - Admit",
            },
            "hospice-discharge": {
              description: "Discharge note for Hospice patients",
              label: "Hospice - Discharge",
            },
            "hospice-his": {
              description: "Hospice HIS note",
              label: "Hospice - HIS",
            },
            "hospice-hp": {
              description: "Admission to Hospice IPU",
              label: "Hospice - Admit",
            },
            "hospice-progress": {
              description: "Progress note for Hospice patients",
              label: "Hospice - Progress",
            },
            "hospice-recert": {
              description: "Recertification note for Hospice patients",
              label: "Hospice - Recertification",
            },
            "infection-followup": {
              description: "Returning clinic visit for Infectious Diseases",
              label: "Infection Disease - Follow-up",
            },
            "infection-initial": {
              description: "Initial intake visit for Infectious Diseases",
              label: "Infection Disease - Consult Initial",
            },
            "infection-new": {
              description: "New patient clinic visit for Infectious Diseases",
              label: "Infection Disease - New patient",
            },
            "infection-progress": {
              description: "Progress note for Infectious Diseases",
              label: "Infection Disease - Consult Progress",
            },
            "ivim-therapy": {
              description: "Documentation of IV/IM procedures",
              label: "IV/IM Therapy",
            },
            "ltach-discharge": {
              description: "Discharge LTACH medical note",
              label: "LTACH - Discharge",
            },
            "ltach-hp": {
              description: "LTACH HP medical note",
              label: "LTACH - Admit",
            },
            "ltach-progress": {
              description: "LTACH progress note",
              label: "LTACH - Progress",
            },
            "medicare-wellness-initial": {
              description: "Medicare Wellness Initial note",
              label: "Medicare - Wellness Initial",
            },
            "medicare-wellness-welcome": {
              description: "Medicare Wellness - Welcome note",
              label: "Medicare - Wellness Welcome",
            },
            "medicare-wellness": {
              description: "Medicare Wellness Subsequent note",
              label: "Medicare - Wellness Subsequent",
            },
            "neuro-followup": {
              description: "Neurologist followup note",
              label: "Neuro - Follow-up",
            },
            "neuro-new": {
              description: "Neurologist new patient note",
              label: "Neuro - New patient",
            },
            "neuro-ortho-spine-followup-complex": {
              description: "Complex Follow up for specialist",
              label: "Ortho-spine - complex",
            },
            "neuro-ortho-spine-followup": {
              description: "Returning clinic visit for Neuro Ortho Spine surgeons",
              label: "Neuro/Ortho Spine - Follow-up",
            },
            "neuro-ortho-spine-new": {
              description: "New patient clinic visit for Neuro Ortho Spine surgeons",
              label: "Neuro/Ortho Spine - New patient",
            },
            "neuro-ortho-spine-preop": {
              description: "Pre operation evaluation for Neuro Ortho Spine surgeons",
              label: "Neuro/Ortho Spine - Pre-Op Eval",
            },
            "neuro-telestroke": {
              description: "Neurology telestroke note",
              label: "Neuro - TeleStroke",
            },
            "oasis-pt-soc": {
              description: "OASIS Physical Therapy Start Of Care note",
              label: "Oasis - PT SoC",
            },
            "oasis-start": {
              description: "OASIS Start Of Care note",
              label: "Oasis - SoC",
            },
            "obstetrics-followup": {
              description: "Returning clinic visit for Obstetrics",
              label: "Obstetrics - Follow-up",
            },
            "obstetrics-new": {
              description: "New patient clinic visit for Obstetrics",
              label: "Obstetrics - New patient",
            },
            "ortho-injury-followup": {
              description: "Orthopedic Injury follow up note",
              label: "Orthopedic Injury - Follow-up",
            },
            "ortho-injury-new": {
              description: "Orthopedic Injury new patient note",
              label: "Orthopedic Injury - New Patient",
            },
            "ortho-surgery-followup": {
              description: "Orthopedic Surgery follow up note",
              label: "Orthopedic Surgery - Follow-up",
            },
            "ortho-surgery-new": {
              description: "Orthopedic Surgery new patient note",
              label: "Orthopedic Surgery - New Patient",
            },
            "ortho-surgery-postop": {
              description: "Orthopedic Surgery post operation note",
              label: "Orthopedic Surgery - Post-op",
            },
            "ortho-surgery-preop": {
              description: "Orthopedic Injury pre operation note",
              label: "Orthopedic Injury - Pre-op",
            },
            "pah-followup": {
              description: "Returning clinic visit for pulmonology PAH",
              label: "Pulmonology PAH - Follow-up",
            },
            "pah-new": {
              description: "New patient clinic visit for pulmonology PAH",
              label: "Pulmonology PAH - New patient",
            },
            "painmgmt-followup": {
              description: "Follow-up visit for pain management",
              label: "Pain Mgmt - Follow-up",
            },
            "painmgmt-new": {
              description: "New patient visit for pain management",
              label: "Pain Mgmt - New patient",
            },
            paramedics: {
              description: "Paramedics documentation",
              label: "Paramedics Note",
            },
            "patient-meeting": {
              description:
                "Document any important discussions, example risk and benefits, procedure consent, AMA, plan of care, goals of care",
              label: "Patient Meeting",
            },
            "pediatric-followup": {
              description: "Follow-up visit for pediatric",
              label: "Pediatric - Follow-up",
            },
            "pediatric-new": {
              description: "New patient visit for pediatric",
              label: "Pediatric - New patient",
            },
            "pediatric-wellchild-followup": {
              description: "Pediatric well child follow-up visit",
              label: "Pediatric WellChild - Follow-up",
            },
            "pediatric-wellchild-new": {
              description: "Pediatric well child new visit",
              label: "Pediatric WellChild - New",
            },
            "prior-auth": {
              description: "Request for Prior Authorization",
              label: "Prior Authorization",
            },
            "procedure-bronch": {
              description: "Bronchoscopy procedure",
              label: "Pulmonology - Bronchoscopy",
            },
            "procedure-egd": {
              description: "Gastroenterology EGD Procedure",
              label: "Gastroenterology - EGD",
            },
            "procedure-generic": {
              description: "Generic procedure",
              label: "Procedure - Generic",
            },
            progress: {
              description: "Generic inpatient medical progress note",
              label: "Medical - Progress",
            },
            "psych-birp": {
              description: "Behavioral intervention response and plan note",
              label: "BIRP",
            },
            "psych-followup": {
              description: "Behavioral followup note",
              label: "Psych - Follow-up",
            },
            "psych-full-assessment": {
              description: "Psych Full Assessment",
              label: "Psych - Full Assessment",
            },
            "psych-girp": {
              description: "Behavioral goals intervention response and plan note",
              label: "GIRP",
            },
            "psych-icanotes": {
              description: "Psych ICANotes",
              label: "Psych - ICANotes",
            },
            "psych-intake": {
              description: "Behavioral intake note",
              label: "Psych - Intake",
            },
            "pt-assessment": {
              description: "Physical Therapy Assessment",
              label: "PTA note",
            },
            "pt-followup": {
              description: "Follow-up visit for physical therapy",
              label: "Physical Therapy - Follow-up",
            },
            "pt-new": {
              description: "New patient visit for physical therapy",
              label: "Physical Therapy - New patient",
            },
            "pulmonology-consult-hp": {
              description: "Initial consult for pulmonologist",
              label: "Pulmonology - Consult - HP",
            },
            "pulmonology-consult-progress": {
              description: "Progress note for pulmonologist",
              label: "Pulmonology - Consult - Progress",
            },
            "radonc-followup": {
              description: "Radiation Oncology clinic follow-up note",
              label: "RadOnc - Follow-up",
            },
            "radonc-new": {
              description: "Radiation Oncology clinic first visit note",
              label: "RadOnc - New patient",
            },
            "rehab-hp": {
              description: "Rehab admission note",
              label: "Rehab - Admit",
            },
            "rehab-progress": {
              description: "Progress note for Rehab",
              label: "Rehab - Progress",
            },
            "rheumatology-followup": {
              description: "Returning clinic visit for Rheumatology",
              label: "Rheumatology - Follow-up",
            },
            "rheumatology-new": {
              description: "New patient clinic visit for Rheumatology",
              label: "Rheumatology - New Patient",
            },
            "snf-discharge": {
              description: "Discharge note for SNF",
              label: "SNF - Discharge",
            },
            "snf-new": {
              description: "New patient note for SNF",
              label: "SNF - Admit",
            },
            "snf-progress": {
              description: "Progress note for SNF",
              label: "SNF - Progress",
            },
            soap: {
              description: "SOAP note",
              label: "SOAP",
            },
            "surgery-followup": {
              description: "Returning clinic visit for surgeons",
              label: "Surgery - Follow-up",
            },
            "surgery-hp": {
              description: "Initial admission documentation",
              label: "Surgery - Admit",
            },
            "surgery-new": {
              description: "New patient clinic visit for surgeons",
              label: "Surgery - New patient",
            },
            "surgery-preop": {
              description: "Pre operation evaluation for surgeons",
              label: "Surgery - Pre-Op Eval",
            },
            "surgery-progress": {
              description: "Progress note for surgery patients",
              label: "Surgery - Progress",
            },
            "team-meeting": {
              description: "Summarize conversations with your team/colleagues with detailed summary, action points, deadlines",
              label: "Team Meeting",
            },
            test: {
              description: "Generic test note",
              label: "Test",
            },
            "therapy-followup": {
              description: "Behavioral therapy followup note",
              label: "Therapy - Follow-up",
            },
            "therapy-intake": {
              description: "Behavioral therapy intake note",
              label: "Therapy - Intake",
            },
            transfer: {
              description: "Transfer to outside facility",
              label: "Medical - Discharge - Transfer",
            },
            "transition-care": {
              description: "Transition of Care",
              label: "Transition of Care",
            },
            "transitionalist-followup": {
              description: "Follow-up care for patients transitioning between care settings",
              label: "Transitionalist Follow up",
            },
            "urgent-care-simplified": {
              description: "Urgent Care simplified note",
              label: "Urgent Care - Simplified",
            },
            "urology-followup": {
              description: "Returning clinic visit for urology",
              label: "Urology - Follow-up",
            },
            "urology-new": {
              description: "New patient clinic visit for urology",
              label: "Urology - New patient",
            },
            "well-woman-gyn": {
              description: "Annual well woman gynecology screening visit",
              label: "Well Woman GYN",
            },
            "well-woman": {
              description: "Annual well woman screening visit",
              label: "Well Woman",
            },
            "woundcare-followup": {
              description: "Follow-up visit for wound care",
              label: "Wound Care - Follow-up",
            },
            "woundcare-home-visit": {
              description: "Wound care home visit",
              label: "Wound Care - Home visit",
            },
            "woundcare-new": {
              description: "New patient visit for wound care",
              label: "Wound Care - New patient",
            },
            "woundcare-procedure": {
              description: "Procedure for wound care",
              label: "Procedure - Wound Care",
            },
          },
          noteVisitTypes: {
            annualWellness: "Annual Wellness",
            standard: "Standard",
            wellChild: "Well Child",
            wellWoman: "Well Woman",
          },
          orders: {
            buttons: {
              addIcd10Code: "Add ICD-10 Code",
              addNote: "Add Note",
              addWound: "Add Wound",
              addWoundPhoto: "Add Wound Photo",
              additionalInfoNeeded: "Additional Info Needed",
              approveOrder: "Approve Order",
              archive: "Archive",
              archiveOrder: "Archive Order",
              backToList: "Back to List",
              amendAddendum: "Amend Addendum",
              signAmendment: "Sign Amendment",
              confirmReceipt: "I confirm receipt of the above items",
              continue: "Continue",
              createReminders: "Create Reminders",
              deliveryConfirmedArchive: "Delivery Confirmed, Archive",
              undo: "Undo",
              discard: "Discard",
              downloadPdf: "Download PDF",
              downloadZip: "Download ZIP",
              editAndSubmitOrder: "Edit and Submit Order",
              generatePackingSlip: "Generate Packing Slip",
              manageSuspension: "Manage Suspension",
              markIncomplete: "Mark as incomplete",
              orderShipped: "Order Shipped",
              moveToShipped: "Move to shipped",
              regenerate: "Regenerate",
              remove: "Remove",
              requestSignature: "Request Signature",
              reviewAndSignOrder: "Review and Sign Order",
              reviewDenied: "Review & Denied",
              reviewedCleared: "Reviewed & Cleared",
              sendComment: "Send Comment",
              attachFiles: "Attach files",
              openAttachment: "Open attachment: {{name}}",
              removeAttachment: "Remove attachment",
              dismiss: "Dismiss",
              signAddendum: "Sign Addendum",
              signOrder: "Sign Order",
              suspendOrder: "Suspend Order",
              unarchive: "Unarchive",
              view1500Form: "View 1500 Form",
              viewOrder: "View Order",
              viewIncompleteOrder: "View Incomplete Order",
              reviewOrderBeforeSig: "Review Order Before Sending to Signature",
              viewRejectionReasons: "View Rejection Reasons",
              continueAddendum: "Continue Addendum",
              viewAddendum: "View Addendum",
              pendingAddendum: "Pending Addendum",
              needsAttention: "Needs Attention",
              noAddendumSubmitted: "No Addendum Submitted",
              generateAddendum: "Generate Addendum",
              viewAddendums: "View Addendums ({{count}})",
              amendmentNeeded: "Amendment Needed",
              generating: "Generating…",
              copyTracking: "Copy tracking number",
              trackOnCarrier: "Track on {{carrier}}",
              dictate: "Dictate",
              done: "Done",
              stopDictation: "Stop dictation",
              emoji: "Add emoji",
              unlockToEdit: "Unlock to Edit",
              editOrder: "Edit Order",
              unlock: "Unlock",
              usePatientAddress: "Use patient address",
            },
            banner: {
              assignedToProvider: "Assigned to {{name}}",
              assignedToYou: "Assigned to you",
              signedByProvider: "Signed by {{name}}",
              signedByYou: "Signed by you",
              changeAssignee: "Change",
              disabledReasonArchived: "This order is archived. Unarchive to edit.",
              disabledReasonManufacturer: "Read-only — you are viewing this order as the manufacturer.",
              disabledReasonStatusLocked: "Read-only — this order is {{statusLabel}}. Changes are no longer allowed.",
              signatureVoided: "Signature voided by {{name}} on {{date}}: {{reason}}. Edit and re-sign.",
              providerRevising: "The provider is revising this order. Approve is disabled until it is re-signed.",
            },
            statusLabels: {
              draft: "Draft",
              submitted: "Pending Signature",
              signed: "Signed",
              rejected: "Rejected",
              approved: "Approved",
              shipped: "Shipped",
              delivered: "Delivered",
            },
            signProgress: {
              completeRequiredFields: "Complete required fields",
              formComplete: "Form complete",
              progressLabel: "{{done}} of 2 — {{status}}",
              reviewed: "Reviewed",
              reviewToSign: "Review order to sign",
              scrollToReview: "Scroll to review the full order",
              signOrder: "Sign order",
            },
            autocalc: {
              dropdownNarrowed: "Showing sizes for {{L}} × {{W}} cm wound. Change measurements to see other sizes.",
              linkedToProduct: "Linked to product",
              linkExplain: "When linked, this auto-updates with the primary product.",
              partialDimensions: "Enter both length and width to see recommended sizes.",
              secondaryAdjusted: "Auto-adjusted to fit primary product.",
              supervisorSizeOverride:
                "Selected size is outside the wound sizing matrix — supervisor override. This may draw scrutiny on audit.",
              undo: "Undo",
              unlinked: "Unlinked",
            },
            productRestrictions: {
              currentProductUnavailable:
                "{{product}} is no longer available for this account. Choose a different product before submitting.",
              powderUnavailable:
                "Collagen Powder is not enabled for this account, so the dressing was sized from the wound measurements.",
              matrixSizeUnavailable: "Collagen {{size}} is not enabled for this account. Choose from the available sizes.",
              noSecondaryAvailable: "No secondary dressing is enabled for this account for this wound.",
              submitBlocked: "This account cannot order the selected product(s):",
              submitBlockedItem: "Wound {{wound}}: {{product}}",
            },
            sectionIndex: {
              ariaLabel: "Order sections",
              history: "History",
              necessity: "Necessity",
              patient: "Patient",
              sign: "Sign",
              wounds: "Wounds",
            },
            tunneling: {
              confirmTitle: "Confirm change",
              confirmBody: "Switching tunneling to No will clear the selected product and secondary dressing. Continue?",
              confirmContinue: "Yes, clear product",
              confirmCancel: "Keep tunneling Yes",
            },
            form: {
              activeVasculitis: "Active Vasculitis or 3rd Degree Burns present at wound site?",
              anemia: "Anemia",
              anotherProvider: "another provider",
              anteriorPosterior: "Anterior/Posterior",
              areaCm2: "Area (cm²)",
              autoLinkedToWound: "Auto-linked to wound characteristics",
              bloodLossPlaceholder: "e.g., 400 mL",
              bothExudateNoneError:
                'Both exudate type and amount are "None." This order cannot be submitted — LCD L33831 requires documented exudate for collagen dressing coverage. Change exudate values or provide alternative coverage documentation.',
              cellulitis: "Cellulitis",
              chf: "CHF",
              chiefComplaint: "Chief Complaint",
              chills: "Chills",
              classification: "Classification",
              collagenContraindicated: "Collagen is contraindicated",
              confirm: "Confirm",
              copd: "COPD",
              cvd: "CVD",
              dateOfService: "Date of Service",
              decreasedMobility: "Decreased Mobility",
              depthCm: "Depth (cm)",
              depthExposure: "Depth Exposure",
              describePlanAndMaterials: "Describe plan and materials",
              diabetes: "Diabetes",
              dorsalPlantar: "Dorsal/Plantar",
              drainage: "Drainage",
              edema: "Edema",
              enterPinToConfirm: "Enter the PIN to confirm",
              erythema: "Erythema",
              eschar: "Eschar",
              estimatedBloodLoss: "Estimated Blood Loss (mL)",
              exudateAmt: "Exudate Amt",
              exudateType: "Exudate Type",
              fever: "Fever",
              followUpDays: "Follow Up (Days)",
              frequencyOtherPlaceholder: "e.g., As needed, Every 4 days",
              heavyExudateWarning: "This wound may not be admissible because of heavy exudate.",
              homeHealthShipWarning:
                "Home Health patient — dressings must ship before the HH episode start date. Ship date will be validated against HH start date at fulfillment.",
              homeHealthStartDate: "Home Health Start Date",
              icd10Codes: "ICD-10 Codes",
              infection: "Infection",
              inferiorSuperior: "Inferior/Superior",
              isPatientAtSNF: "Is Patient at SNF?",
              isReceivingHomeHealth: "Is Receiving Home Health?",
              isUsingShorelineInsurance: "Is using shoreline insurance",
              lengthCm: "Length (cm)",
              markAsPrimaryCode: "Mark as Primary Code",
              medialLateral: "Medial/Lateral",
              medicalNecessity: "Medical Necessity and Justification",
              nausea: "Nausea",
              no: "No",
              noExudateAmountWarningChronic:
                "No exudate amount documented. If this is a stalled or non-progressing wound, ensure stalled wound status and documentation are captured.",
              noExudateAmountWarningSurgical:
                "LCD L33831 generally requires light-to-moderate exudate for collagen dressing coverage on surgical wounds. Consider whether the wound meets other coverage criteria (full-thickness, stalled).",
              noExudateTypeWarningChronic:
                "No exudate type documented. If this is a stalled or non-progressing wound, ensure stalled wound status and documentation are captured.",
              noExudateTypeWarningSurgical:
                "LCD L33831 generally requires light-to-moderate exudate for collagen dressing coverage on surgical wounds. Consider whether the wound meets other coverage criteria (full-thickness, stalled).",
              noProductSelected: "No product selected",
              noneOfAbove: "None of the above",
              notesOnDrainage: "Notes on drainage",
              numbness: "Numbness",
              odor: "Odor",
              orderAssignedTo: "This order is currently assigned to {{name}}.",
              other: "Other",
              otherMedicalConditions: "Other Medical Conditions",
              pain: "Pain",
              partialThicknessWarning: "This wound may not be admissible because of partial thickness depth.",
              patientFirstName: "Patient First Name",
              patientLastName: "Patient Last Name",
              pinConfirmation: "PIN Confirmation",
              pleaseSelectProvider: "Please select a provider to reassign this order.",
              probableDischargeDate: "Probable Discharge Date",
              productSelectionDisabled: "Product selection disabled due to contraindication",
              proximalDistal: "Proximal/Distal",
              qualifyingWoundType: "Qualifying Wound Type",
              reassignOrder: "Reassign Order",
              reassignSubtitle: "Reassign to yourself to sign, or reassign to another provider for their signature.",
              reassignToAnotherProvider: "Reassign to Another Provider",
              reassignToMeAndSign: "Reassign to Me & Sign",
              reassignToOtherAndSubmit: "Reassign to Other & Submit",
              relink: "Re-link",
              relinkToAutoCalc: "Re-link to auto-calculate based on wound characteristics",
              secondaryNotRecommendedHeavy: "Secondary dressing not recommended for heavy exudate",
              selectAllThatApply: "Select all that apply",
              selectBloodThinners: "Select Blood Thinners",
              selectDMEProvider: "Select a DME Provider",
              useManufacturersDme: "Use Manufacturer's DME",
              selectManufacturerDmeProvider: "Select Manufacturer's DME Provider",
              manufacturerDmeRequired: "Select a credentialed DME before approving",
              addCredentialedDmeHint: "Add credentialed DMEs in Settings",
              selectCredentialedDme: "Select a credentialed DME",
              selectOption: "Select...",
              selectProduct: "Select a product...",
              selectProviderPlaceholder: "Select a provider...",
              selectSecondaryDressing: "Select secondary dressing...",
              side: "Side",
              site: "Site",
              sitePlaceholder: "e.g. Left Lower Leg",
              skinAtrophic: "Atrophic",
              skinCondition: "Skin Condition",
              skinIschemic: "Ischemic",
              skinNormal: "Normal",
              skinSealantBarrier: "Skin Sealant/Barrier (Dermabond)",
              skinStasis: "Stasis",
              skinThin: "Thin",
              snfAdmissionDate: "SNF Admission Date",
              specifyOtherBloodThinner: "Specify Other Blood Thinner",
              stage1: "Stage 1",
              stage2: "Stage 2",
              stage3: "Stage 3",
              stage4: "Stage 4",
              stagingWarning: "This wound may not be admissible due to its current identified staging.",
              surgicalProcedureDate: "Surgical Procedure Date",
              surgicalProcedureName: "Surgical Procedure Name",
              surrSkin: "Surr. Skin",
              temperature: "Temperature",
              treatmentPlan: "Treatment Plan",
              tunneling: "Tunneling",
              undermining: "Undermining",
              useBloodThinners: "Use of Blood Thinners",
              widthCm: "Width (cm)",
              withSecondaryDressings: "{{count}} with secondary dressings",
              woundNumber: "Wound {{number}}",
              woundStaging: "Wound Staging",
              woundVisit: "Wound Visit #",
              woundsHaveProducts: "{{count}} of {{total}} wounds have products",
              yes: "Yes",
            },
            headings: {
              additionalClinicalNotes: "Additional Clinical Notes",
              additionalDocumentation: "Additional Documentation",
              archiveThisOrder: "Archive this order?",
              auditLog: "Audit Log",
              authorizationReferral: "Authorization & Referral Requirements",
              characteristics: "Characteristics",
              claimLinePreview: "Claim Line Preview",
              clinicalJustification: "Clinical Justification",
              amendedAddendum: "Amended Addendum",
              coinsurance: "Coinsurance",
              complianceDetails: "Compliance Details",
              coverageDetails: "Coverage Details",
              deductible: "Deductible",
              dmeContactInfo: "DME Contact Info",
              dmeSupplierInformation: "DME Supplier Information",
              documents: "Documents",
              electronicSignatureConsent: "Electronic Signature Consent",
              existingAuthorization: "Existing Authorization",
              financialResponsibility: "Financial Responsibility",
              frequencyOfDressingChange: "Frequency of Dressing Change",
              identityVerification: "Identity Verification",
              internalNotes: "Internal Notes",
              location: "Location",
              measurements: "Measurements",
              medicalHistory: "Medical History",
              notes: "Notes",
              orderDeliveryInformation: "Order & Delivery Information",
              orderSubjectiveSymptoms: "Order Subjective Symptoms",
              originalClinicalAddendum: "Original Clinical Addendum",
              outOfPocketMax: "Out-of-Pocket Maximum",
              patientInformation: "Patient Information",
              podRecorded: "Proof of Delivery Recorded",
              prescriberInformation: "Prescriber Information",
              productForWound: "Product for this Wound",
              productOrderSummary: "Product Order Summary",
              productsDelivered: "Products Delivered",
              providerFacilitySpecifics: "Provider & Facility Specifics",
              reviewDeliveryDetails: "Review Delivery Details",
              secondaryDressing: "Secondary Dressing",
              signBelow: "Sign Below",
              skinAndStaging: "Skin & Staging",
              somethingWentWrong: "Something went wrong",
              status: "Status",
              treatmentDuration: "Treatment Duration (Days)",
              verificationMetadata: "Verification Metadata",
              woundPhotos: "Wound Photos",
              woundType: "Wound Type",
              wounds: "Wounds",
            },
            errors: {
              attachmentTooLarge: "Too large to attach (max 10 MB): {{names}}",
              attachmentTypeNotAllowed: "File type not allowed: {{names}}",
              attachmentMaxCount: "Reached max 5 attachments per comment — skipped: {{names}}",
              attachmentMaxAggregate: "Combined attachments exceed 20 MB — skipped: {{names}}",
              attachmentOpenFailed: "Couldn't open attachment",
              attachmentScanPending: "Still scanning — try again in a moment",
              attachmentInfected: "File was quarantined — contact support",
              attachmentNotFound: "Attachment no longer available",
              voiceNotSupported: "Voice input isn't supported in this browser. Try Chrome or Safari.",
              voicePermissionDenied: "Microphone permission denied",
              voiceFailed: "Voice input failed: {{error}}",
              micBlocked: "Microphone access is blocked. Enable it in your browser settings.",
              micNoDevice: "No microphone found.",
              voiceUnsupported: "Voice dictation isn't supported in this browser. Try Chrome, Edge, or Safari.",
            },
            mic: {
              noDeviceTitle: "No microphone detected",
              noDeviceBody:
                "We couldn't find a microphone connected to this device. Plug in a mic or check your system audio settings, then try again.",
              unsupportedTitle: "Voice input not available",
              unsupportedBody: "This browser doesn't support voice input. Switch to Chrome, Edge, or Safari to dictate comments.",
              deniedTitle: "Microphone access is blocked",
              deniedBody:
                "Your browser is blocking microphone access for this site. Follow the steps below to re-enable it, then click Try again.",
              tryAgain: "Try again",
              steps: {
                chrome1: "Click the lock or tune icon to the left of the URL",
                chrome2: "Find Microphone in the dropdown",
                chrome3: "Switch it to Allow",
                chrome4: "Reload the page",
                safari1: "Open Safari → Settings (Cmd+,)",
                safari2: "Go to the Websites tab → Microphone",
                safari3: "Set this site to Allow",
                safari4: "Reload the page",
                generic1: "Open your browser's site settings for this page",
                generic2: "Set Microphone permission to Allow",
                generic3: "Reload the page",
              },
            },
            labels: {
              addCommentPlaceholder: "Add a comment...",
              attachment: "Attachment",
              attachments: "Attachments",
              addNotePlaceholder: "Add an internal note...",
              addendumSignedSubmitted: "This addendum has been signed and submitted.",
              additionalDocs: "Additional Docs",
              additionalIvrInfo: "Additional IVR Info",
              allClinicalAddendums: "All clinical addendums for this order.",
              amendRequired: "This order changed after the addendum was signed. New flag(s) need a signed amendment:",
              amendSubtitle:
                "The order changed after the addendum was signed. Justify the new flag(s) below and sign a separate amendment — the original signed addendum is unchanged.",
              andTrackingCode: "and Tracking Code",
              approvedOn: "Approved On",
              archiveDescription: "This will move the order to the archive. No notifications will be sent.",
              archived: "Archived",
              by: "by",
              chooseHowToHandle: "Choose how you want to handle this order:",
              chronic: "Chronic",
              clinic: "Clinic",
              correctedToNo: "Corrected to No in order form",
              clinicalDocs: "Clinical Docs",
              clinicalNoteSignedSubmitted: "This clinical note has been signed and submitted.",
              commercial: "Commercial",
              completeFollowingItems: "Complete the following items to submit for signature:",
              conditionalSuspensionDesc: "Notify provider. Auto-restores when they respond.",
              creatingOrder: "Creating Order",
              criteriaProgress: "Criteria Progress:",
              dateOfService: "Date of Service",
              deliveredOn: "Delivered On",
              enterClinicalNote: "Enter your clinical note below. This will be signed and attached to the order.",
              eob: "EOB",
              facesheet: "Facesheet",
              fedexLabel: "FedEx Label",
              form1500: "1500 Form",
              generating: "Generating...",
              govtIns: "Govt Ins.",
              invoiceReceipt: "Invoice Receipt",
              manufacturer: "Manufacturer",
              manufacturerDmeBilling: "Bills through your DME",
              markUrgentDesc: "Quick toggle to flag this order as urgent",
              newOrder: "New Order",
              noCommentsYet: "No comments yet",
              noHistory: "No history available",
              signatureVoided: "Signature voided",
              noIcd10Codes: "No ICD-10 codes added",
              icd10CodeMissing: "Missing code",
              noInternalNotes: "No internal notes yet",
              noWoundPhotos: "No wound photos uploaded",
              notArchived: "Not Archived",
              orderArchivedReadOnly: "Order is archived and cannot be modified.",
              orderAuditReady: "Order is Audit-Ready",
              orderForm: "Order Form",
              orderSentForSignature: "The order will be sent to the selected provider for review and signature.",
              otherRecords: "Other Records",
              packagingSlip: "Packaging Slip",
              packingSlip: "Packing Slip",
              photoAttestation: "I attest that these wound photographs were taken within 30 days of the Date of Service",
              postSurgical: "Post-Surgical",
              proofOfDelivery: "Proof of Delivery",
              provideClinicalJustification: "Provide clinical justification for flagged items and/or additional clinical notes.",
              reasons: "Reasons:",
              removeUrgentDesc: "Remove the urgent flag from this order",
              requestingProviderSignature: "You are requesting provider signature of DME order",
              salesReceipt: "Sales Receipt",
              scheduleRemindersDesc: "Schedule email reminders at custom intervals",
              scrollDownToSign: "Scroll down to sign",
              selectPlanType: "Select Plan Type",
              carrier: "Carrier",
              deliveryDate: "Delivery Date",
              editShipmentDateNote: "Changes are recorded in the order history.",
              shipmentDate: "Shipment Date",
              shippedOn: "Shipped On",
              specifyCarrier: "Specify Carrier",
              trackingCode: "Tracking Code",
              shippingQrCode: "Shipping QR Code",
              signedOn: "Signed On",
              standardArchiveDesc: "Permanently archive. No notifications sent.",
              useShorelineInsurance: "Use Shoreline Insurance",
              withCarrier: "with Carrier",
              withTrackingCode: "with Tracking Code",
              wouldYouLikeToRestore: "Would you like to restore it?",
              woundPhotosOptional: "Wound photographs are optional for post-surgical wounds",
              woundPhotosRequired: "Wound photographs are required for chronic wounds",
              woundType: "Wound Type",
              patientFacesheet: "Patient Facesheet",
              insuranceDemographics: "Insurance Demographics",
              dragAndDropFiles: "Drag And Drop Files",
              multiplePagesAllowed: "Multiple Pages Allowed",
              woundPictures: "Wound Pictures",
              requiredForChronicWounds: "Required For Chronic Wounds",
              multipleImagesAllowed: "Multiple Images Allowed",
              additionalDocument: "Additional Document",
              woundPicture: "Wound Picture",
              ivrVerification: "IVR Verification",
              wound: "Wound",
              updated: "Updated",
              clinicalDocumentation: "Clinical Documentation",
              system: "System",
              insuranceAutoVerify: "Insurance will be verified automatically.",
              ivrStatusPending: "Verifying coverage with pVerify…",
              ivrStatusVerified: "Auto-filled from pVerify on {{timestamp}}",
              ivrStatusDiscovered:
                "Original payer not found — pVerify Insurance Discovery suggested {{payerName}}. Apply suggested values?",
              ivrStatusFailed: "Verification unavailable. Please fill in manually.",
              ivrApply: "Apply suggested values",
              ivrDismiss: "Dismiss",
              ivrRerun: "Re-run verification",
              ivrRunDiscovery: "Run Insurance Discovery",
              ivrDiscoveryRunning: "Discovery running…",
              tracking: "Tracking",
              trackingComingSoon: "Tracking info coming soon",
              unlockReason: "Reason for unlocking",
              unlockReasonHelp:
                "This voids the current signature. The order stays in Additional Info Needed and must be re-signed before the manufacturer can approve it.",
              shipsTo: "Ships to",
              shipToOverride: "Override",
              shippingAddress: "Street address",
              shippingCity: "City",
              shippingState: "State",
              shippingZip: "ZIP",
              editShipToNote:
                "This records the corrected ship-to on the order and in its history. It does not reroute a package already with the carrier, and DME shipping labels are produced outside the app. The patient address of record is not changed.",
            },
            validation: {
              completedCount: "{{completed}} of {{total}} completed",
              completed: "Completed",
              clickToComplete: "Click to complete",
              clickToSelectDoctor: "Click to select a doctor",
              nextIncomplete: "Next Incomplete",
              labels: {
                assignToDoctor: "Assign to Doctor",
                patientFirstName: "Patient First Name",
                patientLastName: "Patient Last Name",
                dateOfService: "Date of Service",
                woundVisitNumber: "Wound Visit Number",
                chiefComplaint: "Chief Complaint",
                hasContraindications: "Contraindications Status",
                isReceivingHomeCare: "Home Health Status",
                homeHealthStartDate: "Home Health Start Date",
                isAtSNF: "SNF Status",
                snfAdmissionDate: "SNF Admission Date",
                subjectiveSymptoms: "Subjective Symptoms",
                medicalConditions: "Medical Conditions",
                bloodThinnersEnabled: "Use of Blood Thinners",
                bloodThinners: "Blood Thinners Selection",
                bloodThinnersOther: "Other Blood Thinner Details",
                woundAssessment: "Wound Assessment",
                medicalNecessity: "Medical Necessity",
                icd10Codes: "ICD-10 Codes",
                followUpDays: "Follow-up Plan",
                clinicalDocumentationFile: "Clinical Documentation Upload",
                faceSheetFile: "Patient Face Sheet Upload",
                woundField: "Wound {{num}}: {{field}}",
                site: "Site",
                side: "Side",
                length: "Length",
                width: "Width",
                depthExposure: "Depth Exposure",
                exudateType: "Exudate Type",
                exudateAmount: "Exudate Amount",
                exudateConflict: "Exudate Conflict",
                cgsWoundType: "CGS Qualifying Wound Type",
                surgicalProcedureName: "Surgical Procedure Name",
                skinSealantBarrier: "Skin Sealant / Barrier",
                product: "Product",
                dressingChangeFrequency: "Dressing Change Frequency",
                treatmentDuration: "Length of Need",
                secondaryDressing: "Secondary Dressing",
              },
            },
            statuses: {
              approvedByManufacturer: "This order has been approved by the manufacturer",
              completeAndSubmit: "Please complete all required fields and submit the order for processing.",
              draftStatus: "This order is in Draft status",
              needsManufacturerReview: "This order needs to be reviewed from the manufacturer",
              needsReview: "This order needs to be reviewed",
              orderApproved: "This order has been approved",
              orderArchived: "This order is archived.",
              orderDelivered: "This order has been delivered",
              orderIsArchived: "This order is archived",
              orderShipped: "This order has been shipped",
              orderSuspended: "This order is suspended",
              requiresAdditionalInfo: "This order requires additional information",
              review1500AndDeliver: "Please review the 1500 Form and notify if delivered.",
              review1500AndShip: "Please review the 1500 Form and notify if shipped.",
              reviewAndSign: "Please review and sign the order for processing.",
              reviewAndSubmitAdditionalInfo:
                "Please review the order and submit the order for processing with the additional info requested.",
              reviewAndTakeAction: "Please review the order details and take the necessary actions.",
              shippedByManufacturer: "This order has been shipped by the manufacturer",
              suspended: "Suspended",
              waitForClinicAdditionalInfo:
                "Please wait for the clinic to review and submit the order with additional information.",
              waitForClinicSubmit: "Please wait for the clinic to review and submit the order.",
              waitForDelivery: "Please wait for delivery date.",
              waitForDoctorSign: "Please wait for the doctor to review and sign the order.",
              waitForShipping: "Please wait for shipping date.",
              waitingForSignature: "This order is waiting for Signature",
            },
            tabs: {
              attachments: "Attachments",
              conversation: "Conversation",
              history: "History",
              internalNotes: "Internal Notes",
              overview: "Overview",
            },
            titles: {
              activeReminders: "Active Reminders",
              additionalClinicalNotes: "Additional Clinical Notes",
              additionalIvrInfo: "Additional IVR Info",
              archiveOrSuspend: "Archive or Suspend Order",
              archiveOrder: "Archive Order",
              clinicalAddendum: "Clinical Addendum",
              amendAddendum: "Amend Addendum",
              clinicalAddendums: "Clinical Addendums",
              clinicalDocsUploaded: "Clinical Documentation Uploaded",
              conditionalSuspension: "Conditional Suspension",
              createOrder: "Create Order",
              editDeliveryInfo: "Edit Delivery Info",
              editOrder: "Edit Order",
              editShipmentDate: "Edit Shipment Date",
              editShipmentInfo: "Edit Shipment Info",
              facesheetUploaded: "Facesheet Uploaded",
              ivrCleared: "IVR Cleared",
              ivrDenied: "IVR Denied",
              ivrInReview: "IVR In Review",
              ivrNotStarted: "IVR Not Started",
              markNotUrgent: "Mark as not urgent",
              markUrgent: "Mark as urgent",
              notUrgent: "Not Urgent",
              orderArchived: "Order Archived",
              orderCompletionGuide: "Order Completion Guide",
              regenerateWithUpdatedInfo: "Regenerate with updated information",
              removeUrgentFlag: "Remove Urgent Flag",
              replaceDocument: "Replace Document",
              replaceProofOfDelivery: "Replace Proof of Delivery",
              reviewOrderDraft: "Review Order - Draft",
              reviewSignedOrder: "Review Signed Order",
              setUpReminders: "Set Up Reminders",
              standardArchive: "Standard Archive",
              suspendOrder: "Suspend Order",
              unreviewedComments: "Unreviewed Comments",
              urgent: "Urgent",
              urgentOptions: "Urgent Options",
              viewActiveReminders: "View Active Reminders",
              woundPhotos: "Wound Photos",
              unlockSignedOrder: "Unlock order for editing",
              signatureVoidedAwaiting: "Signature voided — awaiting re-signature",
              editShipTo: "Edit Ship-To Address",
            },
            toasts: {
              addendumSaveFailed: "Failed to save addendum. Please try again.",
              addendumSignFailed: "Failed to sign addendum",
              addendumSignedSuccess: "Addendum signed successfully",
              allFieldsCompleted: "All required fields completed! You can now submit the order.",
              approveFailed: "Failed to approve order",
              archiveFailed: "Failed to archive order",
              assignOrderFailed: "Failed to assign order",
              auditPacketDownloaded: "Audit Packet downloaded",
              auditPacketFailed: "Failed to generate audit packet",
              cameraAccessDenied: "Unable to access camera. Please allow camera permissions.",
              clinicalDocsRequired: "Please upload clinical documentation before submitting the order.",
              clinicalNoteSaveFailed: "Failed to save clinical note.",
              clinicalNoteSignFailed: "Failed to sign clinical note",
              clinicalNoteSignedSuccess: "Clinical note signed successfully",
              commentAdded: "Comment added successfully",
              commentFailed: "Failed to add comment",
              attachmentsPartialDrop: "Comment saved, but {{count}} attachment(s) failed to upload: {{names}}",
              dateOfServiceRequired: "Date of service is required",
              demoOrderCreated: "Demo order created successfully",
              discardDraftFailed: "Failed to discard draft.",
              documentLoadFailed: "Failed to load document",
              documentProcessing: "Document is being processed. It may take a few moments to appear in the order details.",
              documentProcessingComplete: "Document processing complete.",
              documentProcessingLong: "Document processing is taking longer than expected. Please refresh to check status.",
              documentReplaced: "Document replaced and logged to order history",
              documentReplaceLogFailed: "Document replaced, but failed to log the change to order history",
              facesheetRequired: "Please upload a facesheet before submitting the order.",
              invalidAddendumData: "Invalid addendum data",
              ivrSaveFailed: "Failed to save IVR info. Please try again.",
              markDeliveredFailed: "Failed to mark order as delivered. Please try again.",
              markedNotUrgent: "Order marked as not urgent",
              markedUrgent: "Order marked as urgent",
              noteAdded: "Internal note added successfully",
              noteFailed: "Failed to add internal note",
              npiRequiredForAddendum: "Only providers with NPI can sign addendums",
              operationFailed: "Operation failed",
              orderApprovedSuccess: "Order approved successfully",
              orderArchived: "Order archived",
              orderAssignedToAnother: "This order is assigned to another provider. Open the order to reassign and sign.",
              orderCreationFailed: "Order creation failed",
              orderMovedTo: "Order moved to {{status}}",
              orderReassignedAndSubmitted: "Order reassigned to {{name}} and moved to Pending Signature.",
              orderRestoredFromArchive: "Order restored from archive",
              orderSignFailed: "Failed to sign order",
              orderSignedSuccess: "Order signed successfully",
              orderStatusUpdated: "Order status updated",
              orderSubmitFailed: "Failed to submit order",
              orderSubmittedForSignature: "Order submitted for signature",
              orderSubmittedSuccess: "Order submitted successfully",
              orderUnarchived: "Order unarchived",
              packingSlipCleared: "Packing slip reviewed and cleared",
              packingSlipGenerateFailed: "Failed to generate packing slip",
              packingSlipGenerated: "Packing slip generated",
              packingSlipGenerationFailed: "Order shipped but packing slip failed to generate",
              packingSlipUploadFailed: "Packing slip generated but upload failed",
              pdfGenerationFailed: "Failed to generate PDF",
              photoAttestationRequired: "Please confirm the wound photo attestation",
              podSubmitFailed: "Failed to submit. Please try again.",
              printFailed: "Failed to print",
              providerProfileNotFound: "Could not find your provider profile",
              reassignFailed: "Failed to reassign order",
              reminderCancelFailed: "Failed to cancel reminder",
              reminderCancelled: "Reminder cancelled",
              reminderMessageRequired: "Please provide a reminder message",
              reminderScheduleFailed: "Failed to schedule reminders",
              manufacturerDmeAutoSuggested:
                "Manufacturer DME auto-filled from your last pick: {{name}}. You can change it before approving.",
              remindersScheduled: "{{count}} reminder(s) scheduled",
              saveChangesFailed: "Failed to save changes",
              secondaryDressingAutoUpdated:
                "Wound {{woundNumber}}: Secondary dressing auto-updated to match the primary product size.",
              selectReminderInterval: "Select at least one reminder interval",
              deliveryInfoUpdateFailed: "Failed to update delivery info",
              deliveryInfoUpdated: "Delivery info updated and logged to order history",
              shipmentDateUpdateFailed: "Failed to update shipment date",
              shipmentDateUpdated: "Shipment date updated and logged to order history",
              shipmentInfoUpdateFailed: "Failed to update shipment info",
              shipmentInfoUpdated: "Shipment info updated and logged to order history",
              signatureRequired: "Please provide your signature",
              statusUpdateFailed: "Failed to update order status",
              suspensionNoticeFailed: "Failed to send suspension notice",
              suspensionNoticeSent: "Suspension notice sent to provider",
              urgentStatusFailed: "Failed to update urgent status",
              urlDataLoadFailed: "Failed to load data from URL",
              verificationPhotoRequired: "Please take a verification photo",
              woundAssessmentRequired: "Please add at least one wound assessment before submitting the order.",
              woundPicturesRequired: "Wound Pictures are required for chronic wounds",
              woundTypeRequired: "Please select the wound type",
              medicalNecessityRegenerateFailed: "Couldn't regenerate medical necessity — please try again.",
              medicalNecessityRefreshedSign:
                "Medical necessity updated from the completed form. Review it, then click Sign again.",
              medicalNecessityRefreshedSubmit:
                "Medical necessity updated from the completed form. Review it, then click Submit again.",
              medicalNecessityRefreshFailed:
                "Couldn't update the medical necessity. Retry with Regenerate, or continue with the current text.",
              medicalNecessityOpenToSign: "The medical necessity is out of date. Open the order to refresh it before signing.",
              orderUnlockedForEditing: "Order unlocked. Edit it and have the doctor re-sign.",
              orderAssignedForResign: "Order assigned to {{name}}. They can now re-sign it.",
              unlockFailed: "Could not unlock the order. Please try again.",
              unlockStatusChanged:
                "This order is no longer in Additional Info Needed, so it can't be unlocked. Refresh to see its current status.",
              shipToUpdated: "Ship-to address updated and logged to order history",
              shipToCleared: "Ship-to reset to the patient address and logged to order history",
              shipToUpdateFailed: "Failed to update ship-to address",
            },
            narrativeFreshness: {
              title: "Medical necessity is out of date",
              body: "The order changed after this medical necessity text was written, and the text was edited by hand. Regenerate it from the completed form, or keep your text and continue.",
              bodyAfterFailure:
                "The order changed after this medical necessity text was written, and the last attempt to regenerate it did not complete. Try again, or keep the current text and continue.",
              bodyUnverified:
                "There is no record of when this medical necessity text was written, so it may not match the completed form. Regenerate it from the completed form, or keep the current text and continue.",
              regenerate: "Regenerate from the completed form",
              keep: "Keep my text and continue",
            },
            list: {
              searchFilter: "Search Filter",
            },
            openOrder: "Open order",
            sinceYouveBeenGone: {
              buttonLabel: "Recent activity",
              buttonTitle: "{{newCount}} new of {{totalCount}} in the last 7 days",
              drawerTitle: "Recent activity",
              subtitle: "Last 7 days",
              unknownPatient: "Unknown patient",
              emptySeen: "No reviewed activity yet.",
              narrative: {
                empty: "No activity in the last 7 days.",
                noNew: "{{total}} events in the last 7 days. You're all caught up.",
                newCount: "{{count}} new",
                totalInWindow: "of {{total}} in the last 7 days",
              },
              sections: {
                needsAttention: "Needs attention",
                allActivity: "All activity",
              },
              tabs: {
                new: "New",
                recentlySeen: "Recently seen",
              },
              row: {
                newMessages_one: "{{count}} message",
                newMessages_other: "{{count}} messages",
                newNotes_one: "{{count}} note",
                newNotes_other: "{{count}} notes",
                newCardChip: "Created",
                newPill_one: "{{count}} new",
                newPill_other: "{{count}} new",
                reviewedBy: "Reviewed by {{name}} · {{time}}",
                unknownReviewer: "Unknown reviewer",
                reviewedChip: "Reviewed",
              },
              timeline: {
                movedTo: "{{actor}} moved to {{status}}",
                commented: "{{actor}} added a comment",
                addedNote: "{{actor}} added a note",
                urgent: "{{actor}} flagged as urgent",
                created: "{{actor}} created this order",
                ivrApproved: "{{actor}} approved the IVR",
                ivrDenied: "{{actor}} denied the IVR",
                ivrReopened: "{{actor}} reopened the IVR",
                ivrUpdated: "{{actor}} updated the IVR",
                auditPacketApproved: "{{actor}} approved the audit packet",
                auditPacketDenied: "{{actor}} denied the audit packet",
                auditPacketReopened: "{{actor}} reopened the audit packet",
                auditPacketUpdated: "{{actor}} updated the audit packet",
                addendumAdded: "{{actor}} added an addendum",
                documentUploaded: "{{actor}} uploaded {{doc}}",
                documentReplaced: "{{actor}} replaced {{doc}}",
                archived: "{{actor}} cleared order from board",
                unarchived: "{{actor}} restored order to board",
              },
              footer: {
                markNewSeen: "Mark new as seen",
                close: "Close",
              },
              toasts: {
                reviewFailed: "Couldn't update reviewed status. Please try again.",
              },
              orderDrawerBackLink: "← Back to recent activity",
            },
            lane: {
              // Labels mirror statusLabels.* so kanban headers and status badges read the same text.
              // "pending" maps to the backend "pending" status whose display name is "Creating..."
              pending: { label: "Creating...", caption: "Awaiting next action" },
              draft: { label: "Draft", caption: "Not yet submitted" },
              submitted: { label: "Pending Signature", caption: "Awaiting review" },
              signed: { label: "Manufacturer Review", caption: "Signed by provider" },
              approved: { label: "Approved", caption: "Ready to ship" },
              shipped: { label: "Shipped", caption: "In transit" },
              delivered: { label: "Delivered", caption: "Confirmed receipt" },
              rejected: { label: "Additional Info Needed", caption: "Action required" },
              fallback: { label: "Other" },
            },
            filterSheet: {
              title: "Filters",
              status: "Status",
              sort: "Sort",
              view: "View",
              apply: "Apply",
              reset: "Reset",
              close: "Close",
              archived: "Show archived",
              allLabel: "All",
              urgent: "Urgent only",
            },
            statusArt: {
              decorativeAriaLabel: "Status illustration",
            },
            kanban: {
              emptyColumn: "No {{status}} orders",
              scrollToTop: "Scroll to top of {{status}}",
              scrollToBottom: "Scroll to bottom of {{status}}",
              pills: {
                pending: "Pending",
                draft: "Draft",
                submitted: "Action Required",
                signed: "Processing",
                approved: "Approved",
                shipped: "In Transit",
                delivered: "Complete",
                rejected: "Action Required",
              },
              descriptions: {
                pending: "Awaiting next action",
                draft: "Not yet submitted",
                submitted: "Awaiting provider signature",
                signed: "Under manufacturer review",
                approved: "Ready to ship",
                shipped: "Your order is on its way",
                rejected: "Provider response needed",
              },
              captions: {
                pending: "Awaiting action",
                draft: "Draft order",
                submitted: "Pending signature",
                signed: "Manufacturer review",
                approved: "Ready to ship",
                shipped: "In transit",
                rejected: "Additional info needed",
              },
            },
            notifSettings: {
              title: "DME order notifications",
              userSectionTitle: "My DME order notifications",
              userSectionDesc: "Personal settings for how you hear about DME orders.",
              assignedOnly: {
                label: "Only notify me about orders assigned to me",
                desc: "In-app alerts for order reviews and EOBs are shown only when the order is assigned to you.",
              },
              subtitle: "Choose how your practice hears about order reviews and newly received EOBs.",
              loading: "Loading…",
              save: "Save",
              saving: "Saving…",
              saveSuccess: "Notification settings saved.",
              emailLocked: "Email for these can't be turned off.",
              cat: {
                orderProgress: "Order progress",
                actionNeeded: "Action needed",
                eobReceived: "EOB received",
              },
              desc: {
                orderProgress: "IVR cleared and 1500 form cleared",
                actionNeeded: "IVR denied and 1500 form returned for corrections",
                eobReceived: "An Explanation of Benefits is attached to an order",
              },
              channel: {
                both: "Email + in-app",
                email: "Email only",
                in_app: "In-app only",
                none: "Off",
              },
              toast: {
                ivrCompleted: "IVR cleared for order {{orderId}}",
                ivrDenied: "IVR denied for order {{orderId}}",
                form1500Cleared: "1500 form cleared for order {{orderId}}",
                form1500Incomplete: "1500 form needs corrections for order {{orderId}}",
                eobReceived: "EOB received for order {{orderId}}",
              },
              errors: {
                loadFailed: "Couldn't load notification settings.",
                saveFailed: "Couldn't save notification settings.",
              },
            },
            export: {
              button: "Export orders",
              title: "Export orders",
              subtitle: "Export these orders to a spreadsheet or a printable PDF. Nothing leaves this page until you export.",
              sections: {
                dateRange: "Date range",
                status: "Status",
                organizations: "Organizations",
                columns: "Columns",
                output: "Output",
              },
              noOrganization: "(No organization)",
              orgAll: "All organizations",
              orgSelected: "{{count}} selected",
              orgSearch: "Search organizations",
              dateBasis: {
                label: "Filter dates by",
                dateOfService: "Date of service",
                createdOn: "Created on",
              },
              range: {
                all: "All time",
                last7: "Last 7 days",
                last30: "Last 30 days",
                last90: "Last 90 days",
                mtd: "Month to date",
                ytd: "Year to date",
                custom: "Custom",
                from: "From",
                to: "To",
              },
              status: {
                selectAll: "Select all",
                clear: "Clear",
                includeArchived: "Include archived orders",
              },
              columns: {
                selectAll: "All",
                none: "None",
                atLeastOne: "Pick at least one column to export.",
              },
              presets: {
                basic: "Basic",
                shipping: "Shipping",
                billing: "Billing",
                everything: "Everything",
              },
              categories: {
                patient: "Patient",
                order: "Order",
                clinical: "Clinical",
                office: "Provider / office",
              },
              fields: {
                patientFirstName: "First name",
                patientLastName: "Last name",
                patientDOB: "Date of birth",
                patientAddress: "Address",
                patientCity: "City",
                patientState: "State",
                patientZipCode: "ZIP",
                id: "Order #",
                dateOfService: "Date of service",
                createdOn: "Created on",
                status: "Status",
                isUrgent: "Urgent",
                signedOn: "Signed on",
                signedBy: "Signed by",
                signedUserNPI: "Signer NPI",
                approvedOn: "Approved on",
                shipmentDate: "Shipment date",
                trackingCode: "Tracking #",
                deliveryDate: "Delivery date",
                products: "Products",
                icd10Codes: "ICD-10 codes",
                woundCount: "Wounds",
                lengthOfNeedDays: "Length of need (days)",
                organization: "Organization",
                officeName: "Office name",
                officeAddress: "Office address",
                officeCity: "Office city",
                officeState: "Office state",
                officeZip: "Office ZIP",
                assignedTo: "Assigned to",
                productName: "Product",
                productSize: "Size",
                productHcpcs: "HCPCS",
                productQuantity: "Qty",
              },
              rowShape: {
                label: "Rows",
                perOrder: "One row per order",
                perProduct: "One row per product line",
              },
              format: {
                label: "Format",
                csv: "CSV",
                pdf: "PDF",
              },
              matchCount_one: "{{count}} order matches",
              matchCount_other: "{{count}} orders match",
              noMatches: "No orders match these filters",
              pdfColumnWarning: "{{count}} columns is a lot for one PDF page — CSV keeps every column readable.",
              exportAction: "Export",
              cancel: "Cancel",
              errors: {
                failed: "Couldn't generate the export. Try a narrower date range or fewer columns.",
              },
              pdf: {
                title: "Orders Export",
                generated: "Generated {{date}}",
                page: "Page {{page}} of {{pages}}",
                empty: "No orders matched.",
              },
            },
            fieldNames: {
              signature: "Signature",
              shippingAddress: "Ship-to address",
              shippingCity: "Ship-to city",
              shippingState: "Ship-to state",
              shippingZip: "Ship-to ZIP",
            },
            badges: {
              revising: "Revising",
            },
          },
          pages: {
            analytics: {
              actionNotCompliant: "Action taken but not compliant",
              activeProvider: "Active Provider(s)",
              allEncountersCompliant: "All encounters are compliant",
              applicableNotDiscussed: "Applicable but not discussed",
              avgEfficiencyTooltip: "Avg efficiency of encounters",
              avgEncounters: "Avg Encounters",
              avgEncountersTooltip: "Avg encounters generated per day",
              avgTime: "AVG Time",
              avgTimeTooltip: "Avg time spent recording transcript (mm:ss)",
              compliance: "Compliance",
              complianceMeasures: "Compliance Measures",
              compliant: "Compliant",
              compliantWithMeasure: "Compliant with measure",
              deployAgent: {
                agent: "AI Agent",
                allFailed: "All deployments failed",
                cancel: "Cancel",
                defaultSms:
                  "Hi {name}, your provider has sent you a link to complete a follow-up regarding {metric}. Click the link below to start:",
                deploy: "Deploy Agent",
                deploySelectedBtn: "Deploy to Selected",
                deploying: "Deploying...",
                dob: "DOB",
                encounters: "Encounters",
                loading: "Loading patient info...",
                massSuccess: "Agent deployed to all encounters",
                massTitle: "Deploy Agent — Multiple Encounters",
                noPhone: "No phone",
                partialSuccess: "Deployed with some errors",
                patientName: "Name",
                phone: "Phone",
                progress: "Deploying",
                reminders: "Reminders",
                singleSuccess: "Agent deployed successfully",
                singleTitle: "Deploy Agent",
                smsMessage: "SMS Message",
                deploySelected: "Deploy Selected",
              },
              deployAgentSingle: "Deploy Agent",
              deployAll: "Deploy All",
              deploySelected: "Deploy Agent",
              discussedNoAction: "Discussed but no action taken",
              efficiency: "Efficiency",
              efficiencyTooltip: "Time spent over gaps in compliance measures",
              elapsed: "elapsed",
              encounters: "Encounters",
              encountersGeneratedTooltip: "Encounters generated in the selected period",
              expected: "expected",
              good: "Good",
              id: "ID",
              kpi: "KPI",
              kpiMetrics: "KPIs metrics",
              kpiPoints: "KPI points",
              last12Months: "Last 12 Months",
              metricA1c: "A1c screening",
              metricBMI: "BMI screening",
              metricBP: "Blood Pressure screening",
              metricBreast: "Breast cancer screening",
              metricColonoscopy: "Colonoscopy screening",
              metricDepression: "Depression screening",
              metricFall: "Fall risk assessment",
              metricFlu: "Flu vaccine",
              metricMedAdherence: "Medication reconciliation",
              metricTobacco: "Tobacco assessment",
              missingV28: "Missing V28",
              missingV28Tooltip: "Encounters without V28 code",
              monitorPhysician: "Monitor physician efficiency, compliance, and quality metrics",
              name: "Name",
              needsAttention: "Needs Attention",
              noKPIMetrics: "No KPI metrics available",
              notCompliant: "Not Compliant",
              notCompliantHeader: "Not compliant",
              notCompliantTooltip: "KPIs not compliant",
              openCharts: "Open Charts",
              openChartsTooltip: "Encounters not synced to EHR or copied to sections",
              openChat: "Open Note",
              patient: "Patient",
              period: "Time Period",
              physician: "Physician",
              providerPerformance: "Provider Performance",
              quality: "Quality",
              qualityMetrics: "Quality Metrics",
              recentEncounters: "Recent Encounters",
              selectAll: "Select All",
              singleV28Code: "Single V28 Code",
              singleV28CodeTooltip: "Encounters with a single V28 code",
              speciality: "Speciality",
              status: "Status",
              thisMonth: "This Month",
              thisQuarter: "This Quarter",
              thisWeek: "This Week",
              timeEfficiency: "Time Efficiency",
              today: "Today",
              totalTime: "Total Time",
              tresholdEfficiency: "Efficiency Threshold",
              tresholdGaps: "Gap Threshold",
              twoOrMoreV28: "2+ V28 Codes",
              twoOrMoreV28Tooltip: "Encounters with 2 or more V28 codes",
              type: "Type",
              unableToLoad: "Unable to load analytics",
              viewChat: "View Note",
              year: "Year",
              ytd: "YTD",
            },
            clinicalProfileDetail: {
              accountCreationFailed: "Account creation failed — no user ID returned",
              clinicalProfile: "Clinical Profile",
              couldNotLoadProfile: "Could not load clinical profile",
              createPatientAccount: "Create Patient Account",
              creating: "Creating...",
              failedToCreateAccount: "Failed to create patient account",
              groups: {
                activity: "Activity",
                lifestyle: "Lifestyle & systems",
                medicalHistory: "Medical history",
                overview: "Overview",
              },
              patientAccountCreated: "Patient account created",
              profileNotFound: "Clinical profile not found",
              inviteToDashboard: "Invite to dashboard",
              resendInvite: "Resend invite",
              relinkPricingAccess: "Relink pricing access",
              statusPending: "Pending",
              statusInvited: "Invited",
              statusLinked: "Linked",
              statusArchived: "Archived",
              archive: "Archive",
              permanentlyDelete: "Permanently delete",
              confirmArchive: "Archive this profile? It will be hidden from the active list.",
              confirmPermanentDelete: "Permanently delete this profile? This cannot be undone.",
              archivedSuccess: "Profile archived",
              deletedSuccess: "Profile deleted",
              archiveFailed: "Could not archive profile",
              deleteFailed: "Could not delete profile",
            },
            bootstrap: {
              inviteInvalid: "Your clinical profile invite is no longer valid. Please ask your provider for a new link.",
            },
            createAccount: {
              backToLogin: "Back To Login",
              emailPlaceholder: "Your E-mail",
              errorCreatingAccount: "Error creating the account",
              errorInvalidEmail: "Please insert a valid email",
              errorInvalidPracticeName: "Please enter your practice name",
              practiceNamePlaceholder: "Practice Name",
              registerButton: "Register",
              successCheckEmail: "Please check your email",
              title: "Create An Account",
            },
            ehrTemplates: {
              enterJSON: "Please enter JSON to import",
              errorDeleting: "Error deleting the template",
              errorImporting: "Error importing the template. Please make sure the JSON is valid.",
              errorSaving: "Error saving the template",
              invalidJSON: "Invalid template JSON",
              saveBeforeCloning: "Please save your changes before cloning",
              templateDeleted: "Template deleted",
              templateImported: "Template imported",
              templateSaved: "Template saved",
            },
            ehrTemplatesEdit: {
              add: "Add",
              addNext: "Add next",
              addStep: "Add Step",
              cancel: "Cancel",
              cloneTemplateTitle: "Clone Template To Other Templates",
              cloneTo: "Clone To",
              cloneModalSearchPlaceholder: "Search templates",
              cloneModalSelectAllShown: "Select all shown",
              cloneModalEmptyValue: "—",
              cloneModalNoOtherTemplates: "There are no other templates to clone to.",
              cloneModalNoMatches: "No templates match your search.",
              cloneModalConfirm:
                "This will overwrite the following {{count}} template(s):\n\n{{names}}\n\nAre you sure you want to continue?",
              cloneModalConfirmSystemSwitch: "The following will also be switched to {{system}}:\n\n{{names}}",
              cloneModalPartialFailureToast: "Cloned to {{succeeded}} of {{total}}. Failed: {{names}}",
              cloneModalButton_one: "Clone to {{count}} template",
              cloneModalButton_other: "Clone to {{count}} templates",
              cloneModalSuccessToast_one: "Cloned to {{count}} template",
              cloneModalSuccessToast_other: "Cloned to {{count}} templates",
              copySection: "Copy Section",
              delete: "Delete",
              editInfo: "Edit Info",
              editStepInfo: "Edit Step Info",
              execute: "Execute",
              executeConfig: "Execute Config",
              executing: "Executing",
              exitWithoutSaving: "Exit Without Saving",
              export: "Export",
              dragToReorder: "Drag to reorder",
              highlightInLeftPanel: "Highlight in Left Panel",
              import: "Import",
              importTemplate: "Import Template",
              reset: "Reset",
              sectionDuplicated: "Section duplicated",
              showTab: "Show Tab",
              syncCompleted: "Sync Completed",
              templateNotFound: "Template not found",
              unsavedMessage: "You have unsaved changes. Are you sure you want to leave?",
              unsavedTitle: "Unsaved changes",
              presetCptModifier: "Set Modifier Per Line (Office Procedures)",
              presetOpUnits: "Set Units By Code (Office Procedures)",
              presetAnnualModifier: "Set Preventive Line Modifier",
            },
            home: {
              cancel: "Cancel",
              deleteEncounter: "Do you want to delete this encounter?",
              deleteEncounters: "Do you want to delete {{count}} encounters?",
              deleteSelected: "Delete ({{count}})",
              deselectAll: "Deselect All",
              encounterDeleted: "Encounter deleted successfully",
              encountersDeleted: "{{count}} encounters deleted successfully",
              enterPin: "Enter the 4 digit PIN code to lock the encounter and archive it.",
              errorDeletingEncounter: "Error deleting encounter. Please try again.",
              generate: "Generate",
              howToStart: "How to start",
              lock: "Lock",
              lockAndFinalize: "Lock and Finalize The Encounter",
              newPatient: "New Patient",
              no: "No",
              pleaseUpgrade: "Please upgrade your plan",
              reachedLimit: "You reached the note limit of your plan",
              subscriptionInactive: "Your subscription is not active. Add a payment method to keep generating notes.",
              recordButton: "Record Button",
              selectAll: "Select All",
              selectedCount: "{{count}} selected",
              step1: "Click on the",
              step1b: "button to start an encounter.",
              step2: "Select the note type and then click on",
              step3:
                "If you're recording from your phone, be sure to put it between you and the patient to get the best audio quality.",
              step4: "Talk to the patient",
              step4b:
                ". Please include details about the patient, their symptoms, etc. Remember, the platform is listening to create a detailed note for you. Talk about everything you want the platform to take into account regarding the encounter.",
              step5: "When finished, click the",
              step5b: "button to create the note.",
              upgrade: "Upgrade",
              upgradePlan: "Upgrade plan",
              yesDelete: "Yes, Delete",
            },
            locations: {
              cancel: "Cancel",
              confirmDelete: "Are you sure you want to delete this location?",
              createLocation: "Create Location",
              delete: "Delete",
              deleteLocation: "Delete Location",
              editLocation: "Edit Location",
              errorCreating: "Error creating the location",
              errorDeleting: "Error deleting the location",
              errorUpdating: "Error updating the location",
              locationName: "Location Name",
              pleaseAddName: "Please add the Location Name",
              save: "Save",
              update: "Update",
            },
            login: {
              errorDuringLogin: "Error during Login",
              errorSendingLoginLink: "Error sending login link.",
              loginLinkSentEmail: "A login link has been sent to your email.",
              loginLinkSentPhone: "A login link has been sent to your phone.",
              loginNotValid: "Login not valid",
              credentialsOrOrgInvalid: "Email, password, or organization is incorrect.",
              serverUnreachable: "We can't reach the server right now. Check your connection and try again.",
              serverError: "Something went wrong on our end. Please try again in a moment.",
              tooManyAttempts: "Too many attempts. Please wait a moment and try again.",
              capsLockOn: "Caps Lock is on",
              sessionLimit:
                "This account is already signed in on {{max}} devices at the same time, the maximum allowed. Sign out on one of them, or wait {{minutes}} minutes after it was last used, then try again. If other people use this account, each of them needs their own login.",
              signOutOtherDevices: "Sign out my other devices and sign in here",
            },
            orders: {
              clinicalDocUploadedSuccess: "Clinical documentation uploaded successfully",
              createdOn: "Created On",
              dateOfService: "Date of Service",
              dme: "DME",
              title: "Orders",
              allOrdersSubmitted: "All orders submitted by associated clinics",
              ordersToManufacturer: "Orders to send to the manufacturer ({{manufacturer}})",
              orderCount_one: "{{count}} Order",
              orderCount_other: "{{count}} Orders",
              errorCreatingOrder: "Error creating order",
              facesheetUploadedSuccess: "Facesheet uploaded successfully",
              failedToFetchOrders: "Failed to fetch orders",
              firstName: "First Name",
              lastName: "Last Name",
              newOrder: "New Order",
              onlyArchived: "Only Archived",
              onlyUrgent: "Only Urgent",
              newest: "Newest",
              oldest: "Oldest",
              filterBy: "Filter By",
              orderCreatedSuccess: "Order created successfully",
              orderId: "Order ID",
              peptides: "Peptides",
              showStatus: "Show Status",
              status: "Status",
              statusApproved: "Approved",
              statusDelivered: "Delivered",
              statusDraft: "Draft",
              statusPending: "Creating...",
              statusRejected: "Additional Info Needed",
              statusShipped: "Shipped",
              statusSigned: "Manufacturer Review",
              statusSubmitted: "Pending Signature",
              viewBoard: "View Board",
              viewLabel: "View",
              viewTable: "View Table",
            },
            patients: {
              back: "Back",
              cachedAsOf: "Patient list as of {{date}}",
              checkDuplicates: "Check duplicates",
              clinicalProfile: "Clinical Profile",
              clinicalProfiles: "Clinical Profiles",
              fullListOfPatients: "Full list of patients",
              loadFailed: "Couldn't load patients. Please try again.",
              patient: "Patient",
              patientCount: "Patient",
              profileCount: "Profile",
              source: "Source",
              status: "Status",
              title: "Patients",
            },
            patientsEdit: {
              couldNotLoadProfile: "Could not load patient profile",
              patientDetail: "Patient detail",
              viewClinicalProfile: "View Clinical Profile",
            },
            settings: {
              exit: "Exit",
              pleaseInsertZipcode: "Please insert the zipcode",
              pleaseSelectState: "Please select a state",
              saveAndClose: "Save & Close",
              unsavedMessage: "You have unsaved changes. Would you like to exit or save before leaving?",
              unsavedTitle: "Unsaved changes",
            },
          },
          patient: "true",
          patients: {
            detail: {
              address: "Address",
              age: "Age",
              call: "Phone Call",
              city: "City",
              country: "Country",
              dateOfBirth: "Date Of Birth",
              email: "Email",
              female: "Female",
              firstName: "First Name",
              groupNumber: "Group Number",
              insuranceCarrier: "Insurance Carrier",
              insuredCity: "Insured City",
              insuredDob: "Insured DOB",
              insuredName: "Insured Name",
              insuredState: "Insured State",
              insuredStreetAddress: "Insured Street Address",
              insuredZip: "Insured Zip",
              language: "Language",
              lastName: "Last Name",
              male: "Male",
              patientSaved: "Patient saved",
              phone: "Phone",
              policyNumber: "Policy Number",
              prefComm: "Pref. Comm.",
              save: "Save",
              sex: "Sex",
              state: "State",
              text: "Text Message",
              zip: "Zip",
            },
            edit: {
              assignedTo: "Assigned To",
              cancel: "Cancel",
              completePatientInfo: "Complete patient information before continuing",
              dateOfBirth: "Date Of Birth",
              encounterType: "Encounter Type",
              errorFetchingPatient: "Error fetching patient",
              errorUpdatingChat: "Error updating chat",
              errorUpdatingPatient: "Error updating patient",
              fin: "FIN",
              firstName: "First Name",
              gender: "Gender",
              identityWarningAnonymous: "Patient name must not be anonymous to create a follow-up.",
              identityWarningDOB: "Patient date of birth is required to create a follow-up encounter.",
              incidentDate: "Incident Date",
              lastName: "Last Name",
              location: "Location",
              mobilePhone: "Mobile Phone",
              notAssigned: "Not assigned",
              notDefined: "Not Defined",
              patientIdentification: "Patient Identification",
              patientUpdated: "Patient updated",
              title: "Edit Patient",
              update: "Update",
              visitTime: "Visit Time",
            },
            list: {
              dob: "DOB",
              firstName: "First Name",
              gender: "Gender",
              lastName: "Last Name",
              phone: "Phone",
              search: "Search",
              searchFilter: "Search with the filter to see all the patients",
            },
            modal: {
              title: "Edit Patient",
            },
            toasts: {
              failedCloseSession: "Failed to close session",
              failedCreateEncounter: "Failed to create encounter. Please try again.",
              failedLoadDuplicates: "Failed to load duplicate patients. Please retry.",
              failedLoadSessions: "Failed to load outbound sessions.",
              failedMergePatients: "Unable to merge selected patients. Please retry.",
              failedResendSms: "Failed to resend SMS",
              failedSendLink: "Failed to send link. Please try again.",
              failedUpdateReminders: "Failed to update reminders",
              remindersUpdated: "Reminders updated",
              sessionClosed: "Session closed",
              smsResentSuccess: "SMS resent successfully",
              usersMergedSuccess: "{{count}} users merged successfully",
              voiceLinkSent: "Voice encounter link sent via SMS",
            },
          },
          recon: {
            title: "Reconstitution & Dosing Calculator",
            subtitle:
              "Enter your vial strength and diluent for the concentration, then a target dose for the units to draw on a U-100 syringe.",
            viewDisclaimer: "View signed disclaimer",
            reset: "Reset all",
            toolsLabel: "Tools",
            footnote:
              "Clinical decision support only. Independently verify every value against the manufacturer's prescribing information before use.",
            step1: { label: "What's in the vial?", hint: "Select the strength printed on the peptide vial." },
            step2: {
              label: "How much diluent?",
              hint: "Bacteriostatic water added — this sets the concentration.",
              mixture: "The mixture will be",
            },
            step3: {
              label: "Target dose per administration",
              hint: "Choose the dose you want to draw each time.",
              conversion: "Unit conversion",
            },
            conclusion: {
              title: "Conclusion",
              empty: "Select a vial strength, diluent volume, and target dose to see your draw.",
              tagPrep: "One-time prep",
              tagDose: "Each dose",
              diluent: "Add to the vial",
              diluentSub: "Bacteriostatic water — mix into the vial once. Never injected on its own.",
              draw: "Draw into the syringe",
              units: "units",
              drawSub: "On a U-100 insulin syringe — this is what you inject.",
              dose: "That delivers",
              dosesPerVial: "doses per vial",
              barrel: "Syringe size",
              howto:
                "Step 1 is a one-time mixing step — add the bacteriostatic water to the vial and swirl gently. For every dose, draw only the units shown in step 2 into the syringe. Never inject the bacteriostatic water on its own.",
            },
            warning: {
              doseExceedsVial: "The target dose is larger than the entire vial. Check your inputs.",
              exceedsBarrel: "This dose exceeds the selected syringe capacity. Use more diluent or a larger syringe.",
            },
            tech: {
              show: "Show technical details",
              hide: "Hide technical details",
              concentration: "Concentration",
              volume: "Volume to draw",
            },
            disclaimer: {
              title: "Reconstitution Calculator — Terms of Use",
              captureNotice:
                "To verify your acceptance, we record your name, the date and time, your IP address, and your device and browser information, and keep this on file for our internal records.",
              scrollToContinue: "Scroll to the bottom to continue",
              ack: "I have read, understand, and agree to be legally bound by these Terms of Use, including the disclaimer of warranties, limitation of liability, indemnification, jury-trial waiver, and class-action waiver.",
              effective: "Effective",
              agree: "I Agree",
              maybeLater: "Maybe later",
              cancel: "Cancel",
              saving: "Recording…",
              saveError: "Could not record your acceptance. Please try again.",
            },
            records: {
              menuLabel: "Reconstitution Calculator Disclaimer",
              statusSigned: "Accepted",
              signedBadge: "Accepted v{{version}} on {{date}} by {{name}}",
              revokedBadge: "Revoked on {{date}} — open the calculator to accept again.",
              outdated: "A newer version is in effect. Open the calculator to review and re-accept.",
              notSigned: "Not yet accepted. Open the Reconstitution Calculator to review and accept.",
              openCalculator: "Open the calculator",
              revoke: "Revoke access",
              revoking: "Revoking…",
              revoked: "Your acceptance has been revoked.",
              revokeConfirm:
                "Revoke your acceptance? You will lose access to the Reconstitution Calculator until you accept again.",
              revokeError: "Could not revoke. Please try again.",
            },
          },
          peptides: {
            analytics: {
              activeClients: "Active Clients",
              avgFulfillment: "Avg Fulfillment",
              avgOrderValue: "Avg Order Value",
              cancelled: "cancelled",
              client: "Client",
              clientLeaderboard: "Client Leaderboard",
              delivered: "delivered",
              draft: "draft",
              mostPurchased: "Most Purchased",
              newClients: "New Clients",
              noClientsFound: "No clients found",
              ordersByStatus: "Orders by Status",
              paid: "paid",
              pickup: "pickup",
              pipeline: "Pipeline",
              placed: "placed",
              recurringRate: "Recurring Rate",
              revenueTrend: "Revenue Trend",
              searchClients: "Search clients...",
              shipped: "shipped",
              submitToShip: "submit to ship",
              thisPeriod: "this period",
              topClient: "Top Client",
              topRevenueProduct: "Top Revenue Product",
              totalRevenue: "Total Revenue",
              totalUnits: "Total Items",
              unconfirmed: "unconfirmed",
              units: "items",
              vsPriorPeriod: "vs prior period",
              title: "Peptide Analytics",
              subtitle: "Operations, reordering, and revenue at a glance.",
              tabs: {
                overview: "Overview",
                operations: "Operations",
                reorder: "Reorder",
                customers: "Customers",
                products: "Products",
                reps: "Reps",
                payments: "Payments",
                reports: "Reports",
              },
              phase2: {
                stageTiming: "Stage-by-stage timing requires the status-history audit log — coming in Phase 2.",
                scheduledReports: "Scheduling requires a backend cron job + email template — landing in Phase 2.",
                customReports: "Persisted report definitions require a new backend store — landing in Phase 2.",
              },
              export: {
                trigger: "Export",
                csv: "Download CSV",
                pdf: "Download PDF",
              },
              period: {
                dateRangeLabel: "Date range",
                granularityLabel: "Granularity",
              },
              operations: {
                kpi: {
                  totalOrders: "Total orders",
                  totalOrdersDetail: "in selected period",
                  medianFulfillment: "Median fulfillment",
                  estBadge: "Est.",
                  medianFulfillmentTitle:
                    "Derived from updatedAt — any post-delivery edit shifts this number. Pending audit-log integration.",
                  medianFulfillmentDetail_one: "based on {{count}} shipped/delivered",
                  medianFulfillmentDetail_other: "based on {{count}} shipped/delivered",
                  onTime: "On-time ship (≤ {{days}}d)",
                  onTimeDetail: "{{onTime}} of {{total}}",
                  lostRevenue: "Lost revenue (cancelled)",
                  lostRevenueDetail_one: "{{paid}} of {{total}} cancellation was paid",
                  lostRevenueDetail_other: "{{paid}} of {{total}} cancellations were paid",
                },
                sections: {
                  fulfillmentTime: "Fulfillment time",
                  fulfillmentTimeSubtitle: "Days from order placed to shipped or delivered.",
                  pipeline: "Pipeline funnel",
                  pipelineSubtitle:
                    "Trunk path (payment → confirmed) splits into pickup and ship fulfillment tracks. Each track's conversion reads independently.",
                  cancellations: "Cancellations",
                  cancellationsSubtitle_one: "{{count}} cancelled this period.",
                  cancellationsSubtitle_other: "{{count}} cancelled this period.",
                },
                track: { ship: "Ship track", pickup: "Pickup track" },
                cancel: {
                  prePayment: "Pre-payment (draft)",
                  prePaymentDetail: "No revenue impact",
                  postPayment: "Post-payment",
                  postPaymentDetail: "{{amount}} lost",
                  topReasons: "Top reasons",
                  emptyReasons: "No reason data captured.",
                },
                empty: {
                  fulfillment: "No shipped or delivered orders in this period yet.",
                  funnel: "No orders flowed through the pipeline this period.",
                  cancellations: "No cancellations in this period.",
                },
                chart: { orders: "Orders" },
              },
              products: {
                kpi: {
                  skusSold: "SKUs sold",
                  skusSoldDetail: "in selected period",
                  belowCost: "Below cost SKUs",
                  belowCostDetail_one: "{{count}} SKU pricing below cost",
                  belowCostDetail_other: "{{count}} SKUs pricing below cost",
                  periodRevenue: "Period revenue",
                  avgMargin: "Avg margin",
                  avgMarginDetail: "weighted across SKUs",
                },
                sections: {
                  bundles: "Frequently bought together",
                  bundlesSubtitle: "Pairs of SKUs that appear together in multi-item orders.",
                },
                empty: { bundles: "No multi-item orders in this period." },
                bundle: { orders_one: "{{count}} order", orders_other: "{{count}} orders" },
                table: { product: "Product", dosage: "Dosage" },
              },
              reorder: {
                rate: {
                  daily: "units/day",
                  weekly: "units/week",
                  monthly: "units/month",
                },
              },
              customers: {
                kpi: {
                  totalClients: "Total clients",
                  totalClientsDetail: "with a delivered order",
                  newestCohort: "Newest cohort",
                  churnRisk: "Churn risk",
                  topRegion: "Top region",
                },
                sections: {
                  cohort: "Cohort retention",
                  cohortSubtitle: "Share of each month's new clients still active in subsequent months.",
                  ltv: "Lifetime value by tier",
                  ltvSubtitle:
                    "Average lifetime delivered revenue per client, grouped by the provider tier their orders came from. Not scoped to the selected period — figures cover the client's full order history.",
                  geography: "Geographic distribution",
                  geographySubtitle: "Top US states by collected revenue, where shipping addresses are parseable.",
                },
                table: {
                  cohort: "Cohort",
                  size: "Size",
                  client: "Client",
                  cadence: "Cadence",
                  lastOrder: "Last order",
                  score: "Score",
                  lifetime: "Lifetime",
                },
                empty: {
                  cohorts: "No cohorts to display yet.",
                  ltv: "No tier-tagged orders yet.",
                  geo: "No address data available to map.",
                },
                client: { one: "client", other: "clients" },
              },
              reps: {
                kpi: {
                  activeReps: "Active reps",
                  activeRepsDetail: "Reps with orders this period",
                  periodRevenue: "Period revenue",
                  periodRevenueDetail: "Across all rep portfolios",
                  commission: "Estimated commission",
                  commissionDetail: "Sum of per-order commissions",
                  topRep: "Top rep",
                  topRepDetailDelivered: "{{amount}} delivered",
                  topRepDetailNoFirst: "Need first orders",
                },
                sections: {
                  performance: "Rep performance",
                  performanceSubtitle:
                    "Each rep's portfolio in the selected period. Commission uses each rep's flat/percent/lesser setting.",
                },
                empty: { reps: "No reps in the directory yet." },
                table: {
                  rep: "Rep",
                  accounts: "Accounts",
                  orders: "Orders",
                  conversion: "Conversion",
                  revenue: "Revenue",
                  commission: "Commission",
                  tierMix: "Tier mix",
                  lastOrder: "Last order",
                  conversionNoData: "No terminal-state orders yet — wait for first delivery or post-payment cancellation",
                  conversionTitle: "{{delivered}} delivered / {{terminal}} terminal-state",
                },
              },
              reports: {
                quickExports: "Quick exports",
                quickExportsSubtitle: "Every tab's data, all in one place. CSV opens in Numbers/Excel; PDF is print-ready.",
                scheduled: "Scheduled reports",
                custom: "Custom reports",
                comingSoon: "Coming soon",
                loading: "Loading data…",
                csv: "CSV",
                pdf: "PDF",
                cards: {
                  operations: {
                    title: "Operations",
                    desc: "Fulfillment time, on-time rate, pipeline funnel, cancellation reasons.",
                  },
                  reorder: { title: "Reorder forecast", desc: "Per-client cadence, days since last order, churn-risk score." },
                  customers: { title: "Customers & retention", desc: "Cohort retention, LTV by tier, churn risk, geography." },
                  products: { title: "Products & margins", desc: "Velocity, margin coverage, frequently-bought-together pairs." },
                  reps: { title: "Sales reps", desc: "Per-rep revenue, conversion, commission, tier mix." },
                },
              },
              payments: {
                kpi: {
                  pending: "Pending",
                  pendingDetail: "all time",
                  card: "Card",
                  cardDetail_one: "{{count}} order",
                  cardDetail_other: "{{count}} orders",
                  zelle: "Zelle",
                  zelleDetail_one: "{{count}} order",
                  zelleDetail_other: "{{count}} orders",
                  fees: "Fees",
                  feesDetail: "{{rate}} effective",
                  feesBadge: "est.",
                  netRevenue: "Net revenue",
                  netRevenueDetail: "collected − fees",
                },
                sections: {
                  paymentsOverTime: "Payments over time",
                  paymentsOverTimeSubtitle: "Collected by payment method, bucketed by selected granularity.",
                  methodBreakdown: "Payment method",
                  methodBreakdownSubtitle: "Share of collected revenue.",
                  pending: "Pending payments",
                  pendingSubtitle: "Open orders awaiting payment. State, not period.",
                  aging: "Aging",
                  agingSubtitle: "How long pending orders have been waiting.",
                  feesTrend: "Fees trend",
                  feesTrendSubtitle: "Estimated processor fees and effective rate.",
                  failedRetry: "Card retries",
                  failedRetrySubtitle: "Pending cards with at least one prior charge attempt.",
                  recent: "Recent transactions",
                  recentSubtitle: "Last collected payments in the selected period.",
                  byRep: "Payments by rep",
                  byRepSubtitle: "Collected, fees, and net by sales rep.",
                  byOrg: "Payments by organization",
                  byOrgSubtitle: "Collected, fees, and net by provider organization.",
                },
                table: {
                  customer: "Customer",
                  org: "Organization",
                  rep: "Rep",
                  method: "Method",
                  age: "Age",
                  ageDays_one: "{{count}} day",
                  ageDays_other: "{{count}} days",
                  attempts: "Attempts",
                  amount: "Amount",
                  fee: "Fee (est.)",
                  net: "Net",
                  date: "Date",
                  orders: "Orders",
                  collected: "Collected",
                  actions: "Actions",
                  emptyPending: "No pending payments.",
                  emptyFailed: "No card retries in flight.",
                  emptyRecent: "No collected payments in this period.",
                  emptyByRep: "No paid orders attributed to reps in this period.",
                  emptyByOrg: "No paid orders in this period.",
                },
                actions: {
                  charge: "Charge order",
                  retry: "Retry charge",
                  remind: "Send reminder",
                  viewOrder: "View order",
                },
                methodBadge: {
                  card: "Card",
                  zelle: "Zelle",
                  unknown: "—",
                },
                aging: {
                  bucket0to3: "0–3d",
                  bucket4to7: "4–7d",
                  bucket8to14: "8–14d",
                  bucket15plus: "15d+",
                },
                reminder: {
                  title: "Send payment reminder",
                  subtitle:
                    "Copy this message and send it to the provider through your preferred channel. We don't have a built-in send action yet.",
                  emailLabel: "Email",
                  smsLabel: "SMS",
                  copy: "Copy",
                  copied: "Copied to clipboard",
                  copyFailed: "Copy failed — select text manually",
                  close: "Close",
                  emailSubject: "Payment receipt needed — Order #{{orderId}}",
                  emailBody:
                    "Hi {{name}},\n\nWe still need a Zelle receipt for order #{{orderId}} ({{amount}}). Could you upload it at your earliest convenience?\n\nThank you,\nLucas Health",
                  smsBody:
                    "Hi {{name}}, we need a Zelle receipt for order #{{orderId}} ({{amount}}). Please upload when you can. — Lucas Health",
                },
                chart: {
                  collected: "Collected",
                  fees: "Fees",
                  rate: "Effective rate",
                  count: "Count",
                  noData: "No payments in this period.",
                },
                feeNote: "Fees are estimated at {{rate}} for cards and $0 for Zelle. Actual Maverick fees may vary.",
              },
              provider: {
                title: "Your Analytics",
                subtitle: "Track your profit and sales at a glance.",
                totalProfit: "Total Profit",
                revenue: "Revenue",
                margin: "Margin",
                units: "Units Sold",
                aov: "Avg Order Value",
                profit: "Profit",
                product: "Product",
                topProducts: "Top Products by Profit",
                deliveredDetail: "Delivered orders this period",
              },
            },
            recs: {
              completeProtocol: "Complete your protocol",
              completeProtocolSub: "Add these complementary products to round out your protocol.",
              otherAddOns: "Other add-ons",
              pairsWith: "Pairs well with your order",
              pairsWithSub: "Products commonly chosen with items in your cart.",
              addAll: "Add all",
              addedAll: "{{count}} products added to cart",
              addProduct: "Add {{name}}",
              addAllAria: "Add all recommended products",
              productFallback: "Product",
              dosageUnavailable: "Dosage unavailable",
              selectForm: "Select form for {{name}}",
            },
            quickAdd: {
              addMore: "Add More Products",
              addProduct: "Add {{name}}",
              increaseProduct: "Increase {{name}} quantity",
              decreaseProduct: "Decrease {{name}} quantity",
              removeProduct: "Remove {{name}} from cart",
              selectDosage: "Select dosage for {{name}}",
            },
            cart: {
              checkout: "Proceed to Checkout",
              continueShopping: "Continue Shopping",
              empty: "Your cart is empty",
              qty: "Qty",
              quantityLabel: "Quantity",
              remove: "Remove",
              selectFormType: "Select a form type for this product",
              subtotal: "Subtotal",
              title: "Your Cart",
              pricingTier: "Pricing Tier",
              tierAutoApplied: "Tier auto-applied from provider assignment",
              recurringOrder: "Recurring Order",
              recurringHint: "Auto-reorder on a schedule",
              formActive: "Active",
              formLyophilized: "Lyophilized",
              formLabel: "Form",
              chooseFormType: "Choose form type",
              lineTotal: "total",
              clearToTier: "clear",
              editUnitPrice: "Edit unit price",
              customPricing: "Custom pricing",
              customBadge: "Custom",
              activeForm: "active",
              backOrder: {
                summary_one:
                  "{{count}} of {{total}} item will be back-ordered — you'll be charged now and notified when it ships.",
                summary_other:
                  "{{count}} of {{total}} items will be back-ordered — you'll be charged now and notified when it ships.",
                noticeHeading: "Will back-order",
                noticeBody: "charged now, ships when stock returns.",
                removeFromCart: "Remove from cart",
              },
              // Phase 1 split-ship cart UX
              splitShip: {
                noticeHeading: "Will partially back-order",
                noticeBody: "{{shipNow}}, {{backOrder}}. Charged now, ships when stock returns.",
                shipNowClause_one: "ship {{count}} unit now",
                shipNowClause_other: "ship {{count}} units now",
                backOrderClause_one: "back-order {{count}} unit",
                backOrderClause_other: "back-order {{count}} units",
                radioSplit: "Ship {{available}} now, back-order {{deficit}}",
                radioRemove: "Remove from cart",
                summaryChip_one:
                  "{{count}} item will be partially back-ordered — you'll be charged now and notified when the rest ships.",
                summaryChip_other:
                  "{{count}} items will be partially back-ordered — you'll be charged now and notified when the rest ships.",
                hint: "Back-ordered units ship as soon as stock returns.",
              },
              perUnit: "unit",
              activeSurchargeNote: "Includes {{amount}}/unit prep surcharge.",
              bacWaterPrompt: "Lyophilized peptides need bacteriostatic water for reconstitution. Add it to your order?",
              addBacWater: "Add bacteriostatic water",
              bacWaterAdded: "Bacteriostatic water added to cart",
              reconKitPrompt:
                "This vial needs reconstituting. The Reconstitution Kit has the bacteriostatic water, syringes and loading needle for it. Add it?",
              addReconKit: "Add reconstitution kit",
              reconKitAdded: "Reconstitution kit added to cart",
              addedToCart: "{{name}} added to cart",
              itemRemoved: "{{name}} removed from cart",
              recommendedTitle: "Recommended add-ons",
              recommendedSubtitle: "Curated by your manufacturer",
              addToCart: "Add",
            },
            catalog: {
              recommended: "Recommended add-on",
              markAsRecommended: "Mark as recommended",
              recommendedHint: "Shown in the shopper's cart as a suggested add-on.",
              addBenefit: "Add Benefit",
              addProduct: "Add Product",
              addToCart: "Add to Cart",
              addVariant: "Add Variant",
              added: "Added to cart",
              all: "All",
              badge: "Badge",
              badges: {
                "Best Seller": "Best Seller",
                Blend: "Blend",
                New: "New",
                Popular: "Popular",
              },
              basicInfo: "Basic Info",
              benefits: "Benefits",
              blends: "Blends",
              cancel: "Cancel",
              category: "Category",
              filterCategories: "Filter categories",
              activeCategory: "Category: {{category}}",
              createProduct: "Create Product",
              description: "Description",
              dosage: "Dosage",
              dosingProtocol: "Dosing Protocol",
              howItWorks: "How It Works",
              noResults: "No peptides found",
              productCount: "{{count}} products",
              productImage: "Product Image",
              replace: "Replace",
              saveChanges: "Save Changes",
              search: "Search peptides...",
              selectDosage: "Select dosage",
              singles: "Singles",
              subtitle: "Subtitle",
              tags: "Tags",
              title: "Peptide Catalog",
              viewGrid: "Grid",
              viewList: "List",
              viewMode: "Catalog view",
              uploadImage: "Upload Image",
              uploading: "Uploading...",
              variantsPricing: "Variants & Pricing",
              editProduct: "Edit Product",
              productIdentity: "Identity",
              dropImageOrClick: "Drop image or click to upload",
              dropImageHint: "PNG · JPG · up to 5MB",
              idAuto: "auto",
              crumbNew: "Catalog · New Product",
              crumbEditing: "Catalog · Editing {{name}}",
              tierFlowsToProviders: "Tier prices flow to providers",
              name: "Name",
              namePlaceholder: "Product name",
              subtitlePlaceholder: "Short subtitle",
              id: "ID",
              supplies: "Supplies",
              badgeNone: "None",
              benefitPlaceholder: "Benefit...",
              dosagePlaceholder: "e.g. 10MG",
              retailColumn: "Retail ($)",
              tierColumn: "Tier {{tier}} ($)",
              distribColumn: "Distrib ($)",
              variantCount_one: "1 variant",
              variantCount_other: "{{count}} variants",
              variantsInfoLabel: "About variants and pricing",
              variantsInfoTip:
                "Each variant is a dosage at a specific price. Retail ($) is what patients pay. Tier columns A through W are wholesale rates that flow to providers based on their plan tier. Distrib ($) is the distributor cost.",
              removeImage: "Remove image",
              remove: "Remove",
              errorAtLeastOneVariant: "Please add at least one variant with a dosage",
              errorRetailRequired: "Please set a retail price for all variants",
              errorCostFlushFailed: "Failed to save cost — please try again.",
              errorImageUpload: "Image upload failed — please try again.",
              errorSaveFailed: "Save failed — please try again",
              creating: "Creating...",
              saving: "Saving...",
              cost: "Cost ($)",
              costHintExtended:
                "Your cost per unit — drives all margins. Tier prices can be set below cost; you'll see a warning if you're losing margin.",
              dosageRequiredHint: "Set a dosage first",
              recalculateMarginsPrompt: "Cost changed. Recalculate all tier prices to recommended margins?",
              recalculateMarginsApply: "Apply",
              recalculateMarginsDismiss: "Dismiss",
              // eslint-disable-next-line no-template-curly-in-string
              belowCostWarn: "Below cost — losing ${{loss}} per unit",
              adjustAllTiers: "Adjust all tiers together",
              lockSpreadHelp: "What does this do?",
              lockSpreadTip:
                "When on, dragging any tier sets every tier to the same margin — a quick way to set a uniform discount across all partner tiers.",
              lockStatusOn: "Tiers move together — drag any slider, all tiers match its value.",
              lockStatusOff: "Tiers move independently — set each one on its own.",
              tierLadderCostHint:
                "Enter Cost above to see margins for each tier. You can set tier prices either way — independently per tier, or together using the toggle on top.",
              variantLabel: "Variant",
              removeVariant: "Remove variant",
              tierMarginSlider: "Tier {{tier}} margin",
              tierName: {
                min: "Minimum",
                A: "Preferred",
                B: "Established",
                C: "Standard",
                D: "New",
                W: "Retail",
              },
              tierDesc: {
                min: "Floor price",
                A: "Top partners",
                B: "Established partners",
                C: "Standard partners",
                D: "New partners",
                W: "Public website price",
              },
              manage: "Manage",
            },
            checkout: {
              redesign: {
                yourCart: "Your Cart",
                reviewOrder: "Review Order",
                stepItems: "Items",
                stepOrderFor: "Order For",
                stepReview: "Review",
                setAllProducts: "Set all products to",
                chooseForm: "Choose form",
                addAnother: "Add another product",
                addOnsTitle: "Recommended add-ons",
                addOnsBy: "Curated by your manufacturer",
                add: "Add",
                recipientTitle: "Order for",
                recipientProvider: "Provider",
                recipientPatient: "Patient",
                recipientInStore: "In-store sale",
                recipientChoose: "Choose recipient",
                recipientWalkIn: "Walk-in counter sale",
                deliveryTitle: "Delivery method",
                ship: "Ship",
                shipDesc: "Send via carrier",
                pickup: "Pickup",
                pickupDesc: "Pick up at location",
                addressShip: "Shipping address",
                addressPickup: "Pickup location",
                edit: "Edit",
                done: "Done",
                promoTitle: "Promo code",
                addACode: "Add a code",
                apply: "Apply",
                promoComingSoon: "Promo codes are coming soon.",
                shippingTo: "Shipping to",
                payment: "Payment",
                paymentDraft: "Billed to provider",
                arrives: "Arrives",
                subtotal: "Subtotal",
                shipping: "Shipping",
                free: "Free",
                tax: "Tax",
                calculatedAtCheckout: "Calculated at checkout",
                total: "Total",
                continue: "Continue",
                placeOrder: "Place Order",
                itemOne: "item",
                itemOther: "items",
                selectFormFirst: "Select a form type for every product first.",
                selectRecipient: "Choose who this order is for first.",
                completeAddress: "Complete the shipping address first.",
                noAddress: "No address set",
              },
              address: "Street Address",
              backToCart: "Back to cart",
              browseCatalog: "Browse Catalog",
              cardDetails: "Card Details",
              cartEmpty: "Your cart is empty",
              city: "City",
              email: "Email",
              emptyCart: "Your cart is empty",
              firstName: "First Name",
              free: "Free",
              fulfillmentMethod: "Fulfillment Method",
              incompleteShipping: "Please complete all shipping fields",
              lastName: "Last Name",
              noReferral: "A provider referral is required to place an order.",
              orderFailed: "Failed to place order. Please try again.",
              orderSuccess: "Order placed successfully!",
              orderSummary: "Order Summary",
              patientInfo: "Patient Information",
              payment: "Payment",
              paymentFailed: "Payment failed",
              paymentUnavailable: "Payment system is not available. Please try again later.",
              phone: "Phone",
              pickupInClinic: "Pickup in Clinic",
              placeOrder: "Place Order",
              pricingError: "Unable to determine pricing. Please try again later.",
              processing: "Processing...",
              qty: "Qty",
              referralRequired: "A referring provider is required to place an order",
              referredBy: "Referred by",
              shipToAddress: "Ship to Address",
              shipToMe: "Ship to My Address",
              shipToProvider: "My Provider / Clinic",
              shipping: "Shipping",
              shippingMethod: "Shipping method",
              estimatedDelivery: "Estimated delivery",
              selectState: "Select state",
              noShippingMethodsForState:
                "No shipping methods are available for your shipping address. Please check the address or contact your provider.",
              shippingAddress: "Shipping Address",
              shippingDestination: "Ship To",
              shippingInfo: "Shipping Information",
              state: "State",
              subtotal: "Subtotal",
              title: "Checkout",
              total: "Total",
              zip: "ZIP Code",
              cardIncomplete: "Please complete the card details",
              submitFailed: "Could not place the order",
              demoNotice: "Demo mode — no real card will be charged.",
              payAtSubmitNotice:
                "Your card will be authorized for {{amount}} today. We'll only charge it after your provider approves your order — usually within 1–3 business days. If they decline, the authorization is released back to your card.",
              authorizeButton: "Authorize {{amount}}",
              authorizing: "Authorizing…",
              authorizeError: "Couldn't authorize your card. Please check your details and try again.",
              paymentMethodSection: "Payment method",
              orderReceived: "Order received — provider review in 1–3 business days",
              useSavedAddress: "Use saved address",
              savedShippingAddress: "Saved shipping address",
              shipSomewhereElse: "Ship somewhere else",
              shipSomewhereElseSubtitle: "Use a different address for this order",
              alternateShippingAddress: "Shipping address",
              shipToPickup: "Pick up at provider",
              shipToPickupSubtitle: "{{clinicName}}",
              chargeTodayNotice:
                "Your card will be charged {{amount}} today. Your provider will review your order within 1–3 business days.",
              pay: "Pay {{amount}}",
              cardDeclined: "Your card was declined. Please check your details and try again.",
              totalUpdated: "The total updated to {{amount}}. Please review and confirm before paying.",
              totalUpdatedBanner:
                "The total updated to {{amount}} based on your provider's current pricing. Review it, then tap Pay to confirm.",
            },
            clinicalProfile: {
              clinicalSummary: "Clinical Summary",
              invalidLink: "Invalid link. Please request a new Clinical Profile link from your provider.",
              noData: "No data found. Please request a Clinical Profile link from your provider.",
              profileSaved: "Profile Saved",
              profileSavedDesc:
                "Your clinical profile has been submitted successfully and is available for your provider to review.",
              return: {
                continueWhereLeft: "Continue Where You Left Off",
                or: "or",
                resumeForm: "Resume the form from your last saved section",
                startFresh: "Start fresh with a blank form",
                welcomeBack: "Welcome Back",
              },
              review: {
                alcohol: "Alcohol",
                description: "Please review your information before submitting.",
                edit: "Edit",
                exercise: "Exercise",
                noFamilyHistory: "No significant family history",
                noPriorSurgeries: "No prior surgeries",
                noSignificantHistory: "No significant history",
                notProvided: "Not provided",
                notReviewed: "Not reviewed",
                notTakingAny: "Not taking any",
                occupation: "Occupation",
                substances: "Substances",
                title: "Review & Submit",
                tobacco: "Tobacco",
                nkda: "NKDA (No Known Drug Allergies)",
                additionalInfo: "Additional info",
              },
              saveProfile: "Save Clinical Profile",
              saving: "Saving...",
              sections: "Sections",
              sentBy: "Sent by {{orgName}}",
              title: "Clinical Profile",
            },
            confirmation: {
              backToCatalog: "Back to Catalog",
              orderNumber: "Order Number",
              orderPlaced: "Order placed",
              pleaseWait: "Please wait while we finalize everything",
              preparing: "Preparing",
              processing: "Processing your order...",
              shipped: "Shipped",
              thankYou: "Thank you for your order. You will receive a confirmation email shortly.",
              title: "Order Confirmed!",
              viewOrders: "View Orders",
            },
            detail: {
              dosingProtocol: "Dosing Protocol",
              howItWorks: "How It Works",
              keyBenefits: "Key Benefits",
            },
            errorBoundary: {
              message: "Something went wrong loading this section.",
              tryAgain: "Try Again",
            },
            intake: {
              allergies: "Allergies",
              approveFinalize: "Approve & Finalize",
              approving: "Approving...",
              conditions: "Conditions",
              copyError: "Error copying to clipboard",
              copyLink: "Copy Intake Link",
              dob: "Date of Birth",
              downloadQr: "Download",
              draftReview: "Draft Order Review",
              generateQr: "Generate QR Code",
              generatingQr: "Generating...",
              goals: "Health Goals",
              linkCopied: "Intake link copied to clipboard",
              loading: "Loading...",
              medicalHistory: "Medical History",
              medications: "Medications",
              name: "Name",
              orderNotFound: "Order not found",
              patientInfo: "Patient Information",
              shippingInfo: "Shipping Info",
              collectPayment: "Collect Payment",
              collectPaymentNow: "Collect payment now",
              collectPaymentDesc:
                "Charge the buyer at submission. Leave off to save the order as a draft for the recipient to pay later.",
              popupBlocked: "Popup blocked. Please allow popups for this site.",
              pregnant: "Pregnant",
              previousUse: "Previous Peptide Use",
              printQr: "Print",
              products: "Products",
              qrError: "Failed to generate QR code",
              regenerateQr: "New QR Code",
              sendLink: "Send Intake Link",
              sendLinkDesc:
                "Share this link with your patient to complete their clinical profile. Once submitted, the profile will be available for your review.",
              sendLinkTitle: "Send Patient Intake Link",
              uniqueNote: "Each link and QR code is unique. Generate a new one for each patient.",
            },
            kanban: {
              approved: "Pending Shipment",
              archive: "Archive",
              cancelled: "Cancelled",
              delivered: "Delivered",
              denied: "Denied",
              draft: "Draft",
              moveFailed: "Failed to update order status",
              moveSuccess: "Order moved successfully",
              needsReview: "Needs manufacturer review",
              orderPlaced: "Pending Payment",
              paid: "Paid",
              paymentIssues: "Payment Issues",
              processing: "Processing",
              readyForPickup: "Pickup",
              review: "Review",
              searchPlaceholder: "Search orders...",
              shipped: "Shipped",
              patientTag: "PATIENT",
              practice: "Practice:",
              patient: "Patient:",
              hasConversation: "Has conversation — open for details",
              commentsCount_one: "{{count}} comment — open conversation",
              commentsCount_other: "{{count}} comments — open conversation",
              toPatientShort: "D2C",
              toPatientFull: "Direct-to-consumer — ships straight to the patient",
              awaitingRestock: "Awaiting Restock",
              awaitingRestockChip: "Awaiting restock",
              // Abbreviated lane titles, shown when a lane is too narrow for the
              // full label (responsive — see the @container rules in _kanban.scss).
              abbr: {
                review: "Review",
                orderPlaced: "Pending $",
                approved: "Pend. Shipment",
                awaitingRestock: "Pend. Restock",
                readyForPickup: "Pickup",
                shipped: "Shipped",
                delivered: "Delivered",
                cancelled: "Canc",
              },
              pills: {
                review: "Review Required",
                draft: "Draft",
                orderPlaced: "Action Required",
                approved: "Processing",
                readyForPickup: "At Your Clinic",
                awaitingRestock: "Queued",
                shipped: "In Transit",
                delivered: "Complete",
                cancelled: "Review Refunds",
                archive: "Archived",
              },
              descriptions: {
                review: "This order needs your review.",
                draft: "Finish placing this order.",
                orderPlaced: "We're waiting for your payment to be completed.",
                approved: "Your order is being prepared for shipment.",
                readyForPickup: "Your order is ready at the clinic.",
                awaitingRestock: "Some items are on back-order and queued.",
                shipped: "Your order is on its way.",
                archive: "This order has been archived.",
              },
              captions: {
                review: "Needs review",
                draft: "Draft order",
                orderPlaced: "Awaiting payment",
                approved: "Preparing shipment",
                readyForPickup: "Pickup",
                awaitingRestock: "Awaiting restock",
                shipped: "In transit",
                archive: "Archived",
              },
              placedBy: "Placed by",
              orderFor: "Order for:",
              metaLabel: {
                for: "For",
                by: "By",
                patient: "Patient",
                clinic: "Clinic",
                instore: "In-store Sale",
                dob: "DOB",
                paidVia: "Paid via",
                qty: "Qty",
              },
              card: {
                boChip: "BO",
                boChipAriaLabel: "Back-order card",
              },
              restocked: "RESTOCK",
              restockedTooltip: "Waited since {{date}}",
              restockedNew: "Back in stock — mandatory restock order",
              restockedAck: "Restock acknowledged",
              fromManufacturer: "From Manufacturer",
              fromManufacturerFull: "Placed by the manufacturer for your clinic",
              readyButton: "Ready",
              readyTooltip: "Mark as packed — visual tracker only, does not change the order",
              readyMarkedTooltip: "Packed by {{name}} · {{date}}",
              readyUnknownPacker: "staff",
              units_one: "{{count}} unit",
              units_other: "{{count}} units",
            },
            internalNotes: {
              title: "Internal Notes",
              staffOnly: "Staff only — never shown to customers",
              empty: "No internal notes yet. Add packing, payment, or handoff context for your team.",
              placeholder: "Write an internal note…",
              add: "Add note",
              saveEdit: "Save changes",
              cancelEdit: "Cancel edit",
              edit: "Edit note",
              saving: "Saving…",
              added: "Internal note added",
              updated: "Internal note updated",
              updatedBy: "Updated {{date}} · {{name}}",
              unknownAuthor: "Staff",
              saveFailed: "Couldn't save the note — try again",
            },
            filter: {
              all: "All",
              myOrders: "My Orders",
              patientOrders: "Patient Orders",
              providerOrders: "Provider Orders",
            },
            nav: {
              navigationLabel: "Peptides navigation",
              protocols: "Protocols",
              analytics: "Analytics",
              approvals: "Approvals",
              approvalsWithCount_one: "Approvals, {{count}} pending approval",
              approvalsWithCount_other: "Approvals, {{count}} pending approvals",
              cart: "Cart",
              cartWithCount_one: "Cart, {{count}} item",
              cartWithCount_other: "Cart, {{count}} items",
              catalog: "Catalog",
              directToPatient: "Direct to Patient",
              myOrders: "My Orders",
              orders: "Orders",
              patientPanel: "Patient Panel",
              pricing: "Pricing",
              providerOnboarding: "Provider Onboarding",
              inventory: "Inventory",
              manageCatalog: "Manage Catalog",
              orderHistory: "Order History",
              more: "More",
              surchargeSettings: "Active-Form Surcharge",
              notifications: "Notifications",
              mobileOrders: "Orders",
              mobileOrderHistory: "History",
              mobileApprovals: "Approve",
              mobileMyOrders: "Orders",
              mobileProtocols: "Protocols",
              mobileCatalog: "Catalog",
              mobileCart: "Cart",
              mobileTools: "Tools",
              mobileMore: "More",
            },
            providerPricing: {
              title: "Your Patient Pricing",
              help: "Set what your patients pay per product. You keep the margin above your cost; this never changes what you pay the manufacturer.",
            },
            patientPricing: {
              retail: "Retail pricing",
              customSingular: "1 custom price",
              customPlural: "{{count}} custom prices",
              custom: "Custom",
              retailShort: "Retail",
              fallback: "Blank prices use your clinic retail pricing. Changes apply only to this patient and future orders.",
              lastUpdated: "Last updated by",
              authorizedUser: "Authorized user",
              loading: "Loading patient pricing…",
              readOnlyLimit: "Pricing is read-only because the merchant price limit is unavailable.",
              authorizationExpired: "Your access to patient pricing expired. Sign in again to continue.",
              loadFailed: "Patient pricing could not be loaded safely.",
              history: "History",
              edit: "Edit pricing",
              relinkAccessHint: "Manage pricing access",
              cardLabel: "Patient pricing",
              backToPatient: "Back to patient",
              unnamedProduct: "Unnamed product",
              unavailableProduct: "Unavailable product",
              clinicRetail: "Clinic retail",
              minimum: "Minimum",
              estimatedEarnings: "Est. earnings",
              customPrice: "Custom price",
              inputLabel: "Custom price for {{product}}",
              editorLabel: "Patient pricing",
              editorTitle: "Set custom prices",
              editorHint:
                "Leave a price blank to use clinic retail. Custom prices may be above retail, but not below the minimum.",
              guardrail: "Financial guardrails active",
              limitBlocked: "Editing is disabled because authoritative price limits are unavailable.",
              uncertainSave: "We could not confirm whether the save completed. Review the current values before trying again.",
              authSaveFailed: "Your pricing access expired. Sign in again.",
              saveFailed: "Prices were not saved. Review the highlighted rows.",
              saveAnnouncing: "Saving patient prices",
              saveComplete: "Patient prices saved",
              catalogUnavailableTitle: "Product catalog unavailable",
              catalogUnavailable: "Pricing cannot be edited until the current peptide catalog loads safely.",
              conflictTitle: "Pricing changed in another session",
              conflictCopy:
                "Your entries are still here. Load the latest saved version, reconcile the differences, then review again.",
              yourPrice: "Your price",
              latestSaved: "Latest saved",
              reconcile: "Load latest and reconcile",
              search: "Search products",
              searchPlaceholder: "Search product or dosage",
              retiredCopy: "This saved item is no longer in the active catalog. Clear its price before saving.",
              retiredProduct: "Unavailable product",
              groupPeptides: "Peptides",
              groupGlp: "GLP-1",
              groupSupplies: "Supplies",
              groupUnavailable: "Unavailable / retired",
              changedCount: "{{count}} changed",
              attentionCount: "{{count}} needs attention",
              noMatch: "No matching products in this group.",
              attentionSummary_one: "1 price needs attention",
              attentionSummary_other: "{{count}} prices need attention",
              changeSummary_one: "1 change ready to review",
              changeSummary_other: "{{count}} changes ready to review",
              noUnsavedChanges: "No unsaved changes",
              returnAll: "Return all to retail",
              reviewSave: "Review & save",
              reviewTitle: "Review pricing changes",
              futureOrdersOnly: "These prices apply only to future orders. Existing orders will not change.",
              saving: "Saving…",
              savePrices: "Save prices",
              resetTitle: "Return all prices to retail?",
              resetCopy: "This removes {{countLabel}} for this patient.",
              resetFuture: "Future orders will use clinic retail pricing.",
              keepCustom: "Keep custom prices",
              returnRetail: "Return to retail",
              oneCustomPrice: "1 custom price",
              customPriceCount: "{{count}} custom prices",
              unsavedTitle: "Unsaved patient pricing",
              unsavedCopy: "Discard the custom pricing changes for this patient?",
              keepEditing: "Keep editing",
              discardChanges: "Discard changes",
              historyTitle: "Patient pricing history",
              historyIntro: "Saved patient-specific price changes appear here.",
              historyLoading: "Loading pricing history…",
              historyFailed: "Pricing history could not be loaded safely.",
              noHistory: "No saved pricing changes yet.",
              historyChange: "Pricing change",
              historyActionCreate: "Custom pricing created",
              historyActionUpdate: "Custom pricing updated",
              historyActionReturnToRetail: "Returned to retail",
              historyActionFloorAdjustment: "Minimum price adjustment",
              historyActionIdentityLink: "Patient identity linked",
              roleProvider: "Provider",
              roleSupervisor: "Supervisor",
              roleSystem: "System",
              dateUnavailable: "Date unavailable",
              identityLinked: "Authorized account",
              errorUnavailableOverride: "This item is no longer available. Clear its custom price.",
              errorRejected: "This price was rejected. Review the current limits.",
              errorRetailUnavailable: "Clinic retail pricing is unavailable for this item.",
              noticeRetailUnavailable: "No clinic retail price \u2014 set one here or in clinic pricing.",
              errorMinimumUnavailable: "The minimum price is unavailable for this item.",
              errorLimitUnavailable: "The merchant price limit is unavailable.",
              errorMaximum: "Maximum is {{price}}.",
              errorPositive: "Enter an amount greater than $0.00.",
              errorOutOfRange: "This amount is too large.",
              errorFormat: "Enter a price with no commas, signs, or more than two decimal places.",
              errorMinimum: "Minimum is {{price}}.",
              paymentLink: {
                creating: "Creating secure payment link…",
                ready: "Payment link ready",
                expired: "This payment link expired. Create a new one.",
                failed: "The payment link could not be created.",
              },
            },
            patientPanel: {
              title: "Patient Panel",
              backToList: "All patients",
              close: "Close",
              profileCount_one: "{{count}} Profile",
              profileCount_other: "{{count}} Profiles",
              openFullChart: "Open full chart",
              contactInfo: "Contact & demographics",
              intakeAnswers: "Clinical summary",
              noIntake: "No clinical answers on file",
              noResults: "No patients found",
              noProfiles: "No clinical profiles found",
              create: {
                newPatient: "New patient",
                title: "New patient",
                dob: "Date of birth",
                possibleMatch: "This patient may already exist",
                selectInstead: "Select instead",
                duplicateEmail: "An account with this email already exists.",
                invalidEmail: "Enter a valid email address",
                invalidPhone: "Enter a valid mobile number",
                success: "Patient created.",
                chartFailed:
                  "Patient created, but their chart record could not be set up — patient pricing will not load until it is.",
                failed: "Couldn't create the patient. Please try again.",
                cancel: "Cancel",
                save: "Create patient",
                saving: "Creating…",
                intakeDescription:
                  "Send a secure intake link. The patient will enter their demographics and clinical information before activating their peptide patient account.",
                deliveryMethod: "Send by",
                deliveryEmail: "Email",
                deliverySms: "Text message (SMS)",
                sendIntake: "Send clinical intake",
                sendingIntake: "Sending…",
                intakeSent: "Clinical intake sent to {{destination}}.",
                intakeFailed: "Couldn't send the clinical intake. Please try again.",
              },
            },
            screening: {
              sectionTitle: "Health questions",
              sectionSubtitle: "Your provider reviews these answers before approving your order.",
              loadingOnFile: "Loading your health info…",
              onFileTitle: "Health info on file",
              onFileSubtitle: "We'll use the health answers from your account. Update them if anything has changed.",
              onFileUpdate: "Update",
              conditionsLabel: "Do you have any of the following conditions? (Select all that apply)",
              conditionsOther: "Please specify other condition(s)",
              allergies: "Allergies",
              allergiesPlaceholder: "List any known allergies (or type 'None')",
              currentMedications: "Current medications",
              medicationsPlaceholder: "List all current medications and supplements (or type 'None')",
              pregnant: "Are you currently pregnant or planning to become pregnant?",
              previousPeptideUse: "Have you used peptide therapy before?",
              glpNote: "Your order includes a GLP-1 medication. These questions are required for your provider's safety review.",
              incomplete: "Please answer all health questions before placing your order",
              thyroidCancerHistory: "Have you ever been diagnosed with medullary thyroid carcinoma (thyroid cancer)?",
              men2FamilyHistory: "Do you or any family members have Multiple Endocrine Neoplasia syndrome type 2 (MEN2)?",
              pancreatitisHistory: "Have you ever had pancreatitis (inflammation of the pancreas)?",
              gallbladderDisease: "Do you have gallbladder disease or have you had your gallbladder removed?",
              eatingDisorderHistory: "Do you have a history of an eating disorder (e.g. anorexia, bulimia)?",
              breastfeeding: "Are you currently breastfeeding?",
              conditionOptions: {
                diabetes: "Diabetes",
                heartDisease: "Heart disease",
                highBloodPressure: "High blood pressure",
                thyroidDisorder: "Thyroid disorder",
                kidneyDisease: "Kidney disease",
                liverDisease: "Liver disease",
                cancer: "Cancer",
                autoimmuneDisorder: "Autoimmune disorder",
                seizuresEpilepsy: "Seizures / Epilepsy",
                bleedingDisorder: "Bleeding disorder",
                depressionAnxiety: "Depression / Anxiety / Mental health",
                other: "Other",
              },
            },
            approvals: {
              callLog: {
                title: "Call log",
                logCall: "Log call",
                save: "Save call",
                min: "min",
                durationPlaceholder: "Minutes (optional)",
                notesPlaceholder: "What was discussed, consent, decision…",
                calledBadge: "Called",
                reminder: "Queued for a {{callType}} call. Log the outcome to document the encounter.",
                outcomeCompleted: "Reached patient",
                outcomeVoicemail: "Left voicemail",
                outcomeNoAnswer: "No answer",
                outcomeDeclined: "Patient declined",
                outcomeRescheduled: "Rescheduled",
              },
              historyTitle: "Recent decisions",
              historySearch: "Search past approvals and denials",
              historyWindow: "Showing the last 3 days. Search to find older records.",
              historyEmpty: "No recent decisions.",
              historyApproved: "Approved",
              historyDenied: "Denied",
              title: "Order Approvals",
              subtitle: "Patient-placed orders awaiting your clinical review",
              sortLabel: "Sort orders",
              sortOldest: "Oldest first",
              sortNewest: "Newest first",
              emptyTitle: "No orders awaiting review",
              emptyBody: "New patient orders will appear here for clinical review.",
              viewBoard: "View orders board",
              paymentReady: "Card authorized, ready for review",
              paymentPending: "Awaiting payment authorization",
              noQuestionnaire: "No questionnaire",
              noFlags: "No flags",
              criticalCount_one: "{{count}} critical",
              criticalCount_other: "{{count}} critical",
              highCount_one: "{{count}} high",
              highCount_other: "{{count}} high",
              infoCount_one: "{{count}} info",
              infoCount_other: "{{count}} info",
              ageDays_one: "{{count}}d ago",
              ageDays_other: "{{count}}d ago",
              loadingItems: "Loading items…",
              clinicalTab: "Clinical Review",
              orderTab: "Order",
              noneReported: "None reported",
              noIntakeCallout:
                "No questionnaire on file. This order predates clinical screening, so review using your own records.",
              dismiss: "Dismiss",
              dismissTitle: "Dismiss this flag",
              dismissed: "Dismissed",
              removeFlag: "Remove",
              flagAnswer: "Flag",
              flagTitle: "Flag this answer",
              flagNotePlaceholder: "Add a note (required)",
              flagsNotPersisted: "Flags saved locally, but the server didn't store them yet. They'll reset on reload.",
              flagSaveFailed: "Couldn't save the flag. Please try again.",
              requestInfo: "Request more info",
              requestInfoTitle: "Request more information",
              requestInfoLabel: "Message to patient",
              requestInfoPlaceholder:
                "e.g. Can you tell me more about your thyroid history? Your order stays on hold until we hear back.",
              requestInfoSend: "Send",
              infoRequested: "Message sent to patient",
              criticalAck_one: "{{count}} critical flag active. I have reviewed the flagged responses.",
              criticalAck_other: "{{count}} critical flags active. I have reviewed the flagged responses.",
              notActionable: "Approve/Deny unlocks once the patient's card authorization completes.",
              severity: {
                critical: "Critical",
                high: "High",
                info: "Info",
              },
              flags: {
                mtcHistory: "Personal history of medullary thyroid carcinoma. Boxed-warning contraindication for GLP-1 agonists.",
                men2Family: "Personal or family history of MEN2. Boxed-warning contraindication for GLP-1 agonists.",
                pancreatitis: "History of pancreatitis. GLP-1 agonists carry a pancreatitis risk.",
                pregnant: "Patient reports pregnancy or pregnancy planning. Peptide therapy is contraindicated.",
                breastfeeding: "Patient reports breastfeeding. Peptide therapy is not recommended.",
                cancer: "Reported cancer history. Confirm type and status before approving.",
                eatingDisorder: "History of an eating disorder. Weight-loss therapy needs careful evaluation.",
                gallbladder: "Gallbladder disease reported. GLP-1 agonists increase gallbladder event risk.",
                thyroidDisorder: "Thyroid disorder reported. Confirm it is not medullary thyroid carcinoma.",
                kidney: "Kidney disease reported. GLP-1 GI effects can worsen renal function through dehydration.",
              },
            },
            orderDetail: {
              back: "Back to orders",
              backToOrders: "Back to Orders",
              productPickList: "Product Pick List",
              cancelButton: "Cancel order",
              cancelConfirm: "Are you sure you want to cancel order #{{id}}?",
              cancelError: "Failed to cancel order",
              cancelOrder: "Cancel Order",
              cancelOrderBtn: "Cancel Order",
              cancelSuccess: "Order cancelled",
              cancelTitle: "Cancel Order",
              cancelled: "This order has been cancelled",
              cancelling: "Cancelling...",
              cardSuffix: "{{brand}} ending {{last4}}",
              clinic: "Clinic",
              deliverHere: "Deliver Here",
              deliveredOn: "Delivered {{date}}",
              dosage: "Dosage",
              eventsHeading: "Events",
              eventOrderPlaced: "Order placed · {{amount}} authorized",
              eventApproved: "Approved by {{providerName}} · payment captured",
              eventShipped: "Shipped via {{carrier}} · ETA {{eta}}",
              eventDelivered: "Delivered",
              eventReAuthorized: "Card re-authorized (auth window refreshed)",
              eventCanceledByPatient: "Canceled by you · auth released",
              eventDenied: "Denied by {{providerName}} · auth released",
              eventPaymentFailed: "Card authorization failed",
              form: "Form Type",
              items: "Items",
              keepOrder: "Keep Order",
              lineItems: "Line Items",
              loadError: "Failed to load order details",
              notFound: "Order not found",
              orderNumber: "Order #{{id}}",
              patient: "Patient",
              payment: "Payment",
              paymentAuthorized: "Authorized",
              paymentCaptured: "Captured",
              paymentCardEnding: "{{cardBrand}} ending {{last4}}",
              pickupHere: "Pickup Here",
              pickupLocation: "Pickup Location",
              price: "Price",
              product: "Product",
              provider: "Provider",
              qty: "Qty",
              status: "Status",
              shipTo: "Ship To",
              shipToMe: "Shipping to My Address",
              shipToProvider: "Shipping to Provider/Clinic",
              shipping: "Shipping",
              shippingAddress: "Shipping Address",
              title: "Order Detail",
              total: "Total",
              totalUnits: "Total Items",
              cancelReasonPlaceholder: "Reason for cancellation (optional)",
              pickup: "Pickup",
              pickupAt: "Pick up at {{location}}",
              pickupReadySince: "Ready since {{date}}",
              pickupInstructions: "Bring a photo ID. Hours: {{hours}}.",
              eventReadyForPickup: "Pickup at {{location}}",
              eventPickedUp: "Picked up",
              tracking: "Tracking",
              trackingWithValue: "Tracking · {{value}}",
              placedOn: "Placed {{date}}",
              yourProvider: "your provider",
              backToMyOrders: "Back to My Orders",
              linkedBackOrder: "Linked back-order: #{{displayId}} →",
              backToParent: "← Back to parent order #{{displayId}}",
              paidVia: "Paid via #{{displayId}}",
              paidViaTooltip: "Payment is held on the parent order.",
              destDropShip: "Drop-shipped to patient",
              destClinicStock: "Clinic stock",
              copyEmailAria: "Copy email — {{email}}",
              copyEmailTitle: "Click to copy {{email}}",
              emailCopyFailed: "Couldn't copy — try again",
              emailCopiedShort: "Copied",
              email: "Email",
            },
            orderType: {
              collagen: "Collagen (DME)",
              collagenDesc: "Insurance-based wound care products with compliance documentation",
              peptidesDesc: "Direct cash-pay peptide ordering with Stripe checkout",
              peptidesTitle: "Peptides (Cash Pay)",
              title: "What type of order?",
            },
            orders: {
              browseCatalog: "Browse Catalog",
              cancel: "Cancel",
              cancelConfirm: "Are you sure you want to cancel this order?",
              cancelError: "Failed to cancel order",
              cancelOrder: "Cancel Order",
              cancelSuccess: "Order cancelled",
              cancelTitle: "Cancel Order",
              cancelling: "Cancelling...",
              clearFilter: "Clear filter",
              date: "Date",
              empty: "No peptide orders yet",
              filteredByPatient: "Filtered by patient",
              items: "Items",
              keepOrder: "Keep Order",
              loadError: "Couldn't load your orders. Try again.",
              loadErrorRetry: "Refresh",
              loadEventsRetry: "Retry",
              myOrders: "My Orders",
              today: "Today",
              yesterday: "Yesterday",
              noOrders: "No orders yet",
              noOrdersDesc: "Browse the catalog to find products recommended by your provider.",
              orderId: "Order ID",
              retry: "Retry",
              showStatus: "Show Status",
              status: "Status",
              tabAll: "All",
              tabActive: "Active",
              tabDelivered: "Delivered",
              tabCanceled: "Canceled",
              emptyAll: "No orders yet. Start with the catalog.",
              emptyActive: "Nothing active right now.",
              emptyDelivered: "No delivered orders yet.",
              emptyCanceled: "No canceled orders.",
              title: "Peptide Orders",
              toMe: "To Me",
              toProvider: "To Provider",
              total: "Total",
              viewDetail: "View Details",
              viewOrder: "View order {{id}}",
              orderPlacedLabel: "Order placed",
              reportProblem: "Report a problem",
              messagesHeading: "Messages",
              orderNumberLabel: "Order",
              forLabel: "For",
              sortByLabel: "Sort by",
              sortPlacedAt: "Date placed",
              sortTotal: "Total",
              sortStatus: "Status",
              sortDirectionAsc: "Sort direction: ascending",
              sortDirectionDesc: "Sort direction: descending",
              expandOrder: "Expand order {{id}}",
              collapseOrder: "Collapse order {{id}}",
              moreItems: "{{count}} more items",
              headline: {
                draft: "Draft — not yet processed",
                awaitingApproval: "Awaiting provider approval",
                approving: "Approving your order",
                preparing: "Approved — preparing your order",
                awaitingRestock: "Waiting on restock",
                onItsWay: "On its way",
                readyForPickup: "Pickup",
                deliveredToday: "Delivered today",
                deliveredYesterday: "Delivered yesterday",
                deliveredOn: "Delivered {{date}}",
                canceled: "Canceled",
                denied: "Not approved by your provider",
                paymentIssue: "Payment issue — action needed",
              },
              cancelReasonPlaceholder: "Reason for cancellation (optional)",
              notCharged: "not charged",
              searchPlaceholder: "Search orders, patients, products…",
              newest: "Newest",
              oldest: "Oldest",
              viewListShort: "List",
              viewTableShort: "Table",
              // viewLabel / viewBoard / viewTable belong here in peptides.orders
              // (consumed as peptides.orders.*). They were previously only in
              // pages.orders, so the lookups fell through to inline defaults and
              // the Spanish strings never applied.
              viewLabel: "View",
              viewBoard: "View Board",
              viewTable: "View Table",
              filtersTitle: "Filters",
              done: "Done",
              showAll: "Show all",
              hideAll: "Hide all",
              statusCount: "{{count}}/{{total}}",
            },
            reorder: {
              buyAgain: "Buy again",
              buyAllAgain: "Buy all again",
              buyItemAgain: "Buy {{name}} again",
              reviewTitle: "Review your reorder",
              reviewIntro: "Some items changed since your last order. Choose what to add to your cart.",
              priceChanged: "Price changed",
              unavailable: "No longer available",
              addToCart: "Add to cart",
              cancel: "Cancel",
              noneAvailable: "None of these items are available to reorder.",
              catalogUnavailable: "Product catalog is still loading — please try again in a moment.",
            },
            orderHistory: {
              title: "Order History",
              empty: "You haven't placed any orders yet.",
              noPatient: "—",
              loadError: "Couldn't load your order history. Try again.",
              loadErrorRetry: "Refresh",
              mobileSearch: "Search orders",
              mobileClearSearch: "Clear search",
              mobileFilterOrders: "Filter orders. {{status}}",
              mobileFilteredCount: "{{count}} of {{total}} orders",
              mobileCount_one: "{{count}} order",
              mobileCount_other: "{{count}} orders",
              mobileClear: "Clear",
              mobileFiltersTitle: "Filters",
              mobileStatusLabel: "Status",
              mobileSortLabel: "Sort by",
              mobileSortNewest: "Newest first",
              mobileSortOldest: "Oldest first",
              mobileSortHighest: "Highest total",
              mobileSortLowest: "Lowest total",
              mobileSortStatus: "Status",
              mobileReset: "Reset",
              mobileShowOrders_one: "Show {{count}} order",
              mobileShowOrders_other: "Show {{count}} orders",
              mobileItemCount_one: "{{count}} item",
              mobileItemCount_other: "{{count}} items",
              mobileClinicStock: "clinic stock",
              mobileNoSearchMatches: 'No orders match "{{query}}".',
              mobileNoFilteredSearchMatches: 'No {{status}} orders match "{{query}}".',
              mobileSearchAll_one: "Search all {{count}} order",
              mobileSearchAll_other: "Search all {{count}} orders",
            },
            journey: {
              progress: "Checkout progress",
              itemCount: "{{count}} items",
              placing: "Placing order…",
              step: {
                items: "Items",
                orderFor: "Order For",
                payment: "Payment",
                review: "Review",
              },
              cta: {
                chooseFormTypes: "Choose form types",
                removeUnavailable: "Remove unavailable items",
                continueToOrderDetails: "Continue to Order Details",
                chooseOrderType: "Choose order type",
                selectProvider: "Select a provider",
                selectPatient: "Select a patient",
                continueToCheckout: "Continue to Checkout",
                addPaymentDetails: "Add payment details",
                continueToReview: "Continue to Review",
                placeOrder: "Place Order",
              },
            },
            productLines: {
              collagen: "Collagen (DME)",
              collagenDesc: "Insurance-based wound care ordering.",
              comingSoon: "Coming Soon",
              confirmDisableDme:
                "Disable DME / Collagen ordering for your organization? Providers will no longer be able to create insurance-based wound care orders.",
              description: "Enable or disable product lines for your organization.",
              dmeLockedHelp: "Contact your sales rep to enable DME for this account.",
              exosomes: "Exosomes",
              manageCatalog: "Manage Catalog",
              neuroStim: "Neuro Pain Stimulator",
              peptidesDesc: "Direct cash-pay peptide ordering with online checkout.",
              peptidesLockedHelp: "Contact your sales rep to enable Peptides for this account.",
              peptidesToggle: "Peptides (Cash Pay)",
              saved: "Product lines updated",
              title: "Product Lines",
            },
            receipt: {
              fileTooLarge: "File is too large. Maximum size is 10MB.",
              imageAlt: "Payment receipt",
              invalidType: "Invalid file type. Please upload a JPEG, PNG, WebP, or PDF file.",
              selectFile: "Select File",
              title: "Payment Receipt",
              uploadFailed: "Failed to upload receipt",
              uploadHint: "Image or PDF, max 10MB",
              uploadPrompt: "Upload your Zelle transfer receipt",
              zelleRecipient: "Send your Zelle payment to alphabiopayments@gmail.com",
              uploadSuccess: "Payment receipt uploaded",
              uploaded: "Receipt uploaded",
              uploadedOn: "Uploaded",
              uploading: "Uploading...",
              viewPdf: "View PDF Receipt",
              viewReceipt: "View Receipt",
              view: "View",
              download: "Download",
              downloadUnavailable: "Receipt isn't available to download yet.",
              downloadFailed: "Couldn't download receipt.",
              viewFailed: "Couldn't open receipt.",
              loading: "Loading receipt...",
              sortBy: "Sort By",
              newestFirst: "Newest first",
              oldestFirst: "Oldest first",
            },
            referral: {
              copied: "Patient referral link copied to clipboard",
              copy: "Copy One-Time Link",
              copyError: "Error copying to clipboard",
              copyId: "Copy Referral ID",
              copyNewPatient: "Copy New Patient Signup Link",
              idCopied: "Referral ID copied to clipboard",
              newPatientCopied: "New patient signup link copied to clipboard",
              orgNameAvailable: "Organization name is available",
              orgNameLabel: "Organization Name",
              orgNamePlaceholder: "e.g. my-clinic-name",
              orgNameTaken: "This organization name is already taken",
              overrideActive: "Link will be generated using a different referral ID",
              overrideLabel: "Generate link for another ID",
              overridePlaceholder: "Paste another referral ID",
              title: "Patient Referral Link",
              yourId: "Your Referral ID",
              copyFor: "Copy referral link for",
            },
            stackBuilder: {
              copyLink: "Copy Stack Builder Link",
              generateQr: "Generate QR Code",
              generatingQr: "Generating...",
              linkCopied: "Stack Builder link copied to clipboard",
              regenerateQr: "New QR Code",
              sendLink: "Send Stack Builder",
              sendLinkDesc:
                "Share this link with your patient to complete the Stack Builder quiz. They'll receive a personalized peptide protocol recommendation, and a draft order will appear in your orders list.",
              sendLinkTitle: "Send Stack Builder Link",
              uniqueNote: "Each link and QR code is unique. Generate a new one for each patient.",
            },
            status: {
              cancelled: "Cancelled",
              confirmed: "Confirmed",
              delivered: "Delivered",
              draft: "Draft",
              processing: "Processing",
              shipped: "Shipped",
              declined: "Declined",
            },
            orderStatus: {
              draft: "Draft",
              delivered: "Delivered",
              shipped: "Shipped",
              confirmed: "Approved",
              readyForPickup: "Pickup",
              pickedUp: "Picked up",
              payment_pending: "Approved",
              payment_authorized: "Order placed",
              payment_capturing: "Approving",
              cancelled: "Cancelled",
              denied: "Denied",
              payment_failed: "Payment issue",
              awaiting_restock: "Awaiting restock",
            },
            toasts: {
              checkCardDetails: "Please check your card details",
              clinicAddressIncomplete: "Clinic address is incomplete. Please edit and fill in all fields.",
              copiedToClipboard: "Copied to clipboard",
              failedToCopy: "Failed to copy",
              distribPriceBelowCost: "Distributor price cannot be lower than cost",
              draftOrderArchived: "Draft order archived",
              draftOrderUnarchived: "Draft order unarchived",
              errorPlacingOrder: "Error placing order. Please try again.",
              failedToApproveOrder: "Failed to approve order",
              failedToArchiveOrder: "Failed to archive order",
              failedToCancelOrder: "Failed to cancel order",
              failedToConfirmPayment: "Failed to confirm payment",
              failedToDeleteProduct: "Failed to delete product",
              failedToLoadCatalog: "Failed to load catalog",
              failedToLoadDraftOrder: "Failed to load draft order",
              failedToLoadOrder: "Failed to load order",
              failedToLoadOrders: "Failed to load orders",
              failedToLoadPricingData: "Failed to load pricing data",
              failedToLoadProductCatalog: "Failed to load product catalog",
              failedToGenerateInvoice: "Failed to generate invoice",
              failedToGeneratePackingSlip: "Couldn't generate the packing slip — try again",
              failedToPrintOrder: "Failed to print order",
              failedToReadFile: "Failed to read file",
              failedToRefreshOrders: "Failed to refresh orders",
              failedToReloadOrder: "Failed to reload order",
              failedToSaveClinicalProfile: "Failed to save clinical profile. Please try again.",
              failedToSavePricingChanges: "Failed to save pricing changes",
              failedToSaveProduct: "Failed to save product",
              failedToSaveRevertedLocally: "Failed to save — prices reverted locally only",
              failedToShipOrder: "Failed to ship order",
              failedToSubmitIntakeForm: "Failed to submit intake form. Please try again.",
              failedToSubmitStackBuilder: "Failed to submit. Please try again.",
              failedToUpdateArchiveStatus: "Failed to update archive status",
              failedToUpdateOrder: "Failed to update order",
              failedToUpdateOrderStatus: "Failed to update order status",
              fileTooLarge: "File is too large. Maximum size is 10MB.",
              fillCarrierAndTracking: "Please fill in carrier and tracking number",
              fillPatientAndShippingInfo: "Please fill in patient and shipping information",
              fillPatientInfo: "Please fill in patient information",
              fillShippingAddress: "Please fill in shipping address",
              invalidFileType: "Invalid file type. Please upload a JPEG, PNG, WebP, or PDF file.",
              orderArchived: "Order archived",
              orderCancelled: "Order cancelled",
              orderIdCancelled: "Order {{orderId}} cancelled",
              orderMarkedAsShipped: "Order marked as shipped",
              orderMarkedReadyForPickup: "Order marked for pickup",
              readyMarkFailed: "Couldn't save the packed marker — try again",
              orderMarkedDelivered: "Order marked as delivered",
              orderMovedToStatus: "Order {{orderId}} moved to {{status}}",
              orderUnarchived: "Order unarchived",
              chargeDeclined: "Your card was declined. Please try another card.",
              chargeFailed: "We couldn't process your payment. Please try again.",
              orderNotChargeable: "This order can't be charged in its current state. Please contact support.",
              orderBlockedDiscontinued:
                "Some items are discontinued and out of stock, so they can't be ordered. Remove them to continue.",
              orderBlockedSoldOut: "Some items are sold out and can't be back-ordered. Remove them to continue.",
              orderBlockedCapReached:
                "Some items have hit their back-order limit. Reduce the quantity or remove them to continue.",
              orderBlockedGeneric:
                "Some items can't be ordered under the current back-order policy. Adjust your cart to continue.",
              paymentConfirmed: "Payment confirmed",
              paymentConfirmedAwaitingVerification: "Payment confirmed — awaiting manufacturer verification",
              paymentFailed: "Payment failed. Please try again.",
              paymentSystemLoading: "Payment system is loading. Please wait.",
              pricesRestoredToOriginal: "Prices restored to original",
              pricesSaved: "{{count}} price(s) saved",
              tierAssigned: "Tier {{tier}} assigned",
              productCreated: '"{{name}}" created',
              productDeleted: '"{{name}}" deleted',
              productUpdated: '"{{name}}" updated',
              legalDisclaimerSaved: "Legal disclaimer updated for all products",
              legalDisclaimerSaveFailed: "Failed to save legal disclaimer",
              promoCodesComingSoon: "Promo codes coming soon",
              provideCancellationReason: "Please provide a cancellation reason",
              provideCancellationReasonForPaidOrders: "Please provide a cancellation reason for paid orders",
              receiptUploadFailed:
                "Order created but receipt upload failed. Please upload the receipt from the order detail page.",
              selectFormTypeForAllItems: "Please select Active or Lyophilized for all items before placing your order.",
              selectOrderProvider: "Please select an order provider from the cart page",
              selectPatientForOrder: "Select a patient before placing this order.",
              selectShippingMethod: "Please select a shipping method",
              shippingMethodInvalid: "The selected shipping method is no longer available. Please choose another.",
              shippingMethodUnavailableState: "The selected shipping method isn't available for your shipping address.",
              selectPatientOrEnterInfo: "Please select a patient or enter patient information",
              uploadZelleReceipt: "Please upload your Zelle payment receipt",
              customPricesSaved: "{{count}} custom price saved",
              customPricesSaved_plural: "{{count}} custom prices saved",
              customPricesSavedBelowCost: "{{count}} saved ({{belowCost}} below cost)",
              customPricesSaveFailed: "Failed to save custom prices",
              customPricesPendingCount: "{{count}} price modified",
              customPricesPendingCount_plural: "{{count}} prices modified",
              customPriceRaisedToMin: "Custom price raised to {{price}} — it can't be below your tier cost.",
              attachmentsPartialDrop: "Comment saved, but {{count}} attachment(s) failed to upload: {{names}}",
              paymentDenied: "Payment denied. Provider has been notified.",
              paymentDeniedComment: "Payment Denied. Please upload a valid receipt.",
              failedToDenyPayment: "Failed to process payment denial.",
              pickupCannotShip: "This order is set for pickup and can't be marked shipped.",
              pickupGoesToReadyForPickup: "This order goes to Pickup, not Pending Shipment.",
              shipCannotPickup: "This order ships — it can't be marked for pickup.",
              draftReviewByCard: "Open the order to review and approve it.",
              failedToAddComment: "Failed to send comment. Please try again.",
            },
            paymentReview: {
              title: "Review Payment",
              orderLabel: "Order",
              loading: "Loading receipt...",
              receiptAlt: "Payment receipt",
              loadFailed: "Could not load receipt. Open the order to view it.",
              noReceipt: "No receipt has been uploaded for this order.",
              goBack: "Go Back",
              deny: "Deny Payment",
              confirm: "Confirm Payment",
              processing: "Processing...",
            },
            approveFinalize: {
              title: "Approve & Finalize",
              orderLabel: "Order",
              loading: "Loading order...",
              loadFailed: "Could not load the order. Close and try again.",
              productsLabel: "Products",
              itemFallback: "Item",
              total: "Total",
              cancel: "Cancel",
              approve: "Approve & Finalize",
              processing: "Processing...",
            },
            shipModal: {
              title: "Ship Order",
              confirmShipment: "Confirm Shipment",
              updating: "Updating...",
            },
            labels: {
              total: "Total",
              active: "Active",
              billingZip: "Billing ZIP",
              card: "Credit Card",
              cardholderName: "Cardholder Name",
              cardNumber: "Card Number",
              clinic: "Clinic",
              clinicName: "Clinic Name",
              clinicShip: "Ship to Clinic",
              clinicStock: "Clinic Stock",
              creditCard: "Credit Card",
              cvv: "CVV",
              expiration: "Expiration",
              dataEncrypted: "Data Encrypted",
              enterCode: "Enter Code",
              for: "For",
              forPatient: "For Patient",
              free: "Free",
              havePromoCode: "Have a Promo Code?",
              hipaaCompliant: "HIPAA Compliant",
              itemsFromLastSession: "Items From Last Session",
              loadingProviders: "Loading providers...",
              lyophilized: "Lyophilized",
              clickToEdit: "Click to edit",
              manufacturer: "Manufacturer",
              noPatientsFound: "No patients found",
              noProvidersFound: "No providers found",
              noProvidersMatch: "No providers match your search",
              manufacturerPickup: "Manufacturer Pickup",
              no: "No",
              orderFor: "Order For",
              organization: "Organization",
              orderingAs: "Ordering as",
              orderToProviderClinic: "Order for Provider",
              inStoreSale: "In-Store Sale",
              patient: "Patient",
              patientShip: "Ship to Patient",
              payWithZelle: "Pay with Zelle",
              provider: "Provider",
              salesRep: "Sales Rep",
              qty: "Qty",
              searchByName: "Search by name",
              searching: "Searching...",
              searchPatient: "Search patient",
              searchPatients: "Search patients",
              searchProviders: "Search providers",
              secureCheckout: "Secure Checkout",
              selectFormTypes: "Select form types",
              // Short forms for the fixed mobile checkout bar. Separate keys
              // rather than shortening the shared labels, which are also used
              // as standalone headings/warnings where the full wording reads
              // better.
              selectFormTypesShort: "Select form type",
              selectOrderProvider: "Select order provider",
              selectOrderProviderShort: "Select provider",
              selectPatient: "Select Patient",
              setAllProductsTo: "Set all products to",
              shipping: "Shipping",
              shipToClinic: "Ship to Clinic",
              shipToPatient: "Ship to Patient",
              ssl256: "256-bit SSL",
              stockInClinic: "Stock in Clinic",
              yes: "Yes",
              yourClinic: "Your Clinic",
              zelle: "Zelle",
              applyFormType: "Apply to all items",
              itemsRemaining: "{{count}} items remaining",
              chooseFormForItem: "Choose form for {{name}}",
              ship: "Ship",
              pickup: "Pickup",
              customPriceOverride: "Custom Price Override",
              customPricesSaved: "Saved",
              tierFilterAll: "All",
              tierFilterAriaLabel: "Filter providers by pricing tier",
              noProvidersInTier: "No providers in this tier",
              orderingFor: "Ordering for",
              customPrice: "Custom Price",
              tierPriceShort: "Tier {{tier}}",
              belowCost: "Below cost",
              groupPeptides: "Peptides",
              groupGlp: "GLP",
              groupSupplies: "Supplies",
              searchProvidersPlaceholder: "Search by name or email…",
              sortBy: "Sort by",
              sortNameAsc: "Name (A–Z)",
              sortOrdersDesc: "Most orders",
              sortTierAsc: "Best tier first",
              sortTierDesc: "Worst tier first",
              sortCustomDesc: "Most custom prices",
              providersShownCount: "{{shown}} of {{total}}",
            },
            hints: {
              leaveBlankForTier: "Leave blank to use tier pricing",
            },
            confirms: {
              resetOverridesForProvider:
                "Clear all custom price overrides for this provider? Future orders will fall back to tier pricing.",
              resetCartCustomPrices:
                "Reset all custom prices for {{provider}}? Items will revert to this provider's tier pricing.",
            },
            buttons: {
              cancel: "Cancel",
              apply: "Apply",
              applyAll: "Apply to All",
              backToCart: "Back to Cart",
              copy: "Copy",
              copied: "Copied",
              copyFailed: "Copy failed",
              clickToCopy: "Click to copy · {{value}}",
              dismiss: "Dismiss",
              done: "Done",
              edit: "Edit",
              pay: "Pay",
              remove: "Remove",
              restore: "Restore",
              selectFile: "Select File",
              skip: "Skip",
              submitOrder: "Submit Order",
              resetOverrides: "Reset overrides",
              resetToTier: "Reset to tier",
              change: "Change",
              reset: "Reset",
              saving: "Saving...",
              acceptChanges: "Accept Changes",
              clearSearch: "Clear search",
              invoice: "Invoice",
            },
            headings: {
              reviewYourOrder: "Review Your Order",
              assignedProvider: "Assigned Provider",
              clinicAddress: "Clinic Address",
              complete: "Complete",
              healthGoals: "Health Goals",
              information: "Information",
              medicalHistory: "Medical History",
              orderFor: "Order For",
              patientInformation: "Patient Information",
              payment: "Payment",
              pickupLocation: "Pickup Location",
              placedByProvider: "Placed By Provider",
              shippingAddress: "Shipping Address",
              shippingDestination: "Ship To",
              fulfillmentType: "Fulfillment Type",
              customPricingOverrides: "Saved Custom Prices",
              customPricingEditor: "Custom Prices",
              customPricingEditorHint:
                "Set a per-variant price for this provider. Leave blank to use their tier price. Custom prices are not bound by the tier grid.",
              resetToTierPrices: "Reset to tier prices",
            },
            descriptions: {
              imageOrPdfMax10MB: "Image or PDF, Max 10MB",
              assignToProvider: "Provider organization",
              inStoreSale: "Walk-in customer",
              cardPaymentsUnavailable: "Card payments are not available at this time. Please use Zelle.",
              shipToClinic: "Ship to Provider / Clinic",
              shipToPatient: "Ships directly to the patient — won't touch your clinic inventory",
              stockInClinic: "Will be added to your clinic inventory on delivery",
              uploadZelleReceipt: "Upload your Zelle transfer receipt",
              zelleRecipient: "Send your Zelle payment to alphabiopayments@gmail.com",
              shipViaCarrier: "Ship via carrier to address",
              pickupAtLocation: "Provider picks up from location",
              pickupFromManufacturer: "Collect this order from the manufacturer — no shipping fee",
              pickupAddressMissing: "Set your pickup address in Settings → Organization Info before placing pickup orders.",
            },
            home: {
              denied: "Order declined: {{reason}}",
              awaitingProvider: "Order submitted — awaiting provider approval",
              empty: "Your peptide orders will appear here once your provider approves your first order.",
              browseCatalog: "Browse catalog",
              requestRefill: "Request another fill from your provider",
              loadError: "Unable to load. Please try again.",
            },
            refill: {
              title: "Request another fill of {{name}}",
              product: "Product",
              explainer:
                "Your provider will review and approve this request. We'll authorize your saved card now and only charge it after they approve.",
              submit: "Submit refill request",
              submitting: "Submitting…",
              submitted: "Refill request submitted — awaiting provider approval",
              submitError: "Failed to submit. Please try again.",
              invalidTherapy: "We couldn't find that order. Please try again from your peptides list.",
              confirmTitle: "Confirm refill",
              confirmBody: "We'll authorize {{amount}} on your saved {{cardBrand}} ending {{last4}}.",
              cancelConfirm: "Cancel",
              confirm: "Confirm",
              cardInvalid: "Your saved card couldn't be authorized. Please enter a new payment method to continue.",
            },
            consent: {
              title: "Patient Peptide Consent",
              ack1: "I am purchasing this product with my provider's approval. I understand my provider is gating access to the product and is responsible for approving each order I place.",
              ack2: "I understand each order I place requires my provider's approval before it is fulfilled, and that my provider exercises their professional judgment under their organization's NPI in approving each order.",
              ack3: "I have an established relationship with the provider who will review my orders, and I am responsible for following any guidance they give me and for my own use of the product.",
              submit: "Accept and continue",
            },
            providerEsign: {
              title: "Provider Approval — Electronic Signature",
              checkboxPrefix: "I, ",
              checkboxSuffix:
                ", consent to electronically certify this peptide order. I understand my signature will be captured with a timestamp, IP address, device information, and consent text version, stored for a minimum of 7 years.",
              continue: "Continue",
            },
            review: {
              contact: {
                title: "Contact",
                callPatient: "Call this patient",
                copy: "Copy",
                noPhone: "No phone on file",
                prefers: "Prefers {{channel}}",
                channelSms: "text / SMS",
                channelEmail: "email",
                emergency: "Emergency: {{name}} {{phone}}",
              },
              patient: {
                placedByPatientBadge: "PLACED BY PATIENT",
                bannerTitle: "Provider review required",
                bannerBody:
                  "This order was placed by the patient. Approve to send to manufacturer fulfillment, or deny with a reason.",
                approve: "Approve",
                deny: "Deny…",
                approved: "Order approved",
                approvedMessage: "Your order has been approved. Your prescription is attached.",
                denied: "Order denied",
                approveError: "Failed to approve order",
                denyError: "Failed to deny order",
                raceCancelled: "Patient cancelled this order while you were reviewing — please refresh.",
                denyTitle: "Deny Patient Order",
                denyReason: "Reason for denial",
                denySubmit: "Submit",
                providerNameMissing: "Provider name unavailable. Please sign out and back in before approving.",
                cancel: "Cancel",
              },
            },
            deny: {
              title: "Deny Order",
              reason: "Reason for denial",
              reasonRequired: "Please provide a reason before submitting.",
              submit: "Submit",
              submitting: "Submitting…",
              buttonLabel: "Deny",
              cancel: "Cancel",
              successToast: "Order denied",
              errorToast: "Failed to deny order",
            },
            conversation: {
              heading: "Conversation",
              empty: "No messages yet.",
              placeholder: "Add a reply",
              button: "Conversation",
              reportPrompt: "Something wrong with this order? Send us a message.",
            },
            compliance: {
              highScrutiny: {
                tile: "This product is currently under FDA regulatory review. Your provider has approved this order under their clinical judgment — discuss continued use with them.",
                review:
                  "This product is on the high-scrutiny tier. Compounded GLP-1s are under active FDA review. Document your clinical reasoning.",
              },
              stateUnavailable: "Not available for delivery to your state. Please contact your provider for alternatives.",
              shippingStateMissing: "Add your shipping state to your profile to confirm availability.",
              supervision: "All orders require approval from your provider.",
              compoundedDisclaimer:
                "Products on this platform are compounded by licensed pharmacies. They are not FDA-approved drug products and are made for individual patients on the basis of provider approval.",
              selfAdmin: "You are responsible for following your provider's guidance and any product instructions.",
            },
            tile: {
              // Patient-safe fallbacks shown when a product hasn't yet had its
              // patientDescription / patientShortLabel populated by the
              // manufacturer (per spec line 261, manufacturer authors per-
              // product copy via the catalog management UI). These strings
              // are deliberately generic — no therapeutic claims, no
              // jargon — so they pass the patient-copy-claims audit.
              compoundedFallback: "Compounded product",
              aboutProduct: "About this product",
              descriptionFallback:
                "A compounded peptide product. Use only as directed by your provider, who reviews and approves every order.",
            },
            denial: {
              declinedBy: "Declined by {{name}}",
              yourProvider: "your provider",
              showMore: "Show more",
              showLess: "Show less",
              detailBanner:
                'Your provider didn\'t approve this order — Reason: "{{reason}}". Your {{amount}} authorization was released; refund will appear in 1–2 business days.',
              noReasonGiven: "No reason provided.",
            },
            refund: {
              pending: "Refund of {{amount}} releases in 1–2 business days",
              pendingShort: "refund pending",
              releasingTo: "Releasing back to your {{cardBrand}} ending {{last4}}",
            },
            paymentFailed: {
              bannerTitle: "We couldn't authorize your card",
              bannerBody:
                "Your card was declined when we tried to refresh your authorization. Update your payment method to keep this order active, or this order will be canceled.",
              updatePaymentButton: "Update payment",
              contactSupport: "Or contact support if you need help.",
            },
            cancel: {
              modalTitle: "Cancel this order?",
              modalBody:
                "Your {{amount}} authorization will be released within 1–2 business days. Your provider will be notified.",
              reasonLabel: "Reason for canceling (optional)",
              keepOrder: "Keep order",
              confirmCancel: "Cancel order",
              successToast: "Order canceled — refund pending",
              cancelling: "Canceling…",
              selfCancelBanner: "You canceled this order. Refund of {{amount}} will appear in 1–2 business days.",
            },
            stock: {
              inStock: "In stock",
              lowStock_one: "Only {{count}} left",
              lowStock_other: "Only {{count}} left",
              lowStockGeneric: "Low stock",
              backOrdered: "Back-order · ships when restocked",
              backOrderedWithDate: "Back-order · est. {{date}}",
              outOfStock: "Out of stock",
              discontinued: "Discontinued",
              notifyMe: "Notify me when restocked",
              notifyMeCta: "Notify me when back in stock",
              modal: {
                title: "Notify me when back in stock",
                description: "We'll send one email the moment this product is restocked. No marketing — just the alert.",
                emailLabel: "Email address",
                submit: "Notify me",
                submitting: "Saving…",
                cancel: "Cancel",
                success: "We'll email you when {{product}} is back in stock.",
                alreadySubscribed: "You're already on the list for this product.",
                error: "Couldn't save your alert. Please try again.",
                invalidEmail: "Enter a valid email address",
                thisProduct: "this product",
              },
              cart: {
                warning: "{{product}} ({{dosage}}) is no longer available — remove it to continue.",
                discontinued: "{{product}} ({{dosage}}) has been discontinued and can't be ordered. Remove it to continue.",
                disableCheckout: "Remove discontinued items to continue.",
                removeBlocked: "Remove discontinued items",
                // Short form for the fixed mobile checkout bar, where the full
                // string cannot fit next to the subtotal.
                removeBlockedShort: "Remove items",
                willBackOrder: "{{product}} ({{dosage}}) will be back-ordered — ships when restocked.",
                backOrderNotice_one: "{{count}} item will be back-ordered — ships when restocked.",
                backOrderNotice_other: "{{count}} items will be back-ordered — ship when restocked.",
              },
              editor: {
                openTitle: "Manage stock",
                title: "Stock — {{product}}",
                loadError: "Failed to load stock data",
                loadFailedBanner:
                  "Couldn't fetch saved stock. Showing defaults — your edits will still be submitted when you Save.",
                saveError: "Failed to save stock",
                saveSuccess: "Stock updated ({{count}} SKUs)",
                impactWarning: "{{lines}} order line(s) across {{orders}} order(s) will be back-ordered if you confirm.",
                cancel: "Cancel",
                save: "Save",
                saving: "Saving…",
                confirmDecrement: "Confirm and save",
                col: {
                  dosage: "Dosage",
                  onHand: "On hand",
                  reserved: "Reserved",
                  threshold: "Low threshold",
                  restockDate: "Expected restock",
                  discontinued: "Discontinued",
                },
              },
            },
            fulfillment: {
              editMethod: {
                button: "Change fulfillment method",
                title: "Change Fulfillment Method",
                address: "Street Address *",
                city: "City *",
                state: "State *",
                zip: "ZIP *",
                addressRequired: "A complete shipping address is required to switch to shipping",
                toPickupNote:
                  "The saved shipping address stays on file but won't be used. Any shipping fee already charged is not refunded automatically.",
                toShippingNote: "The order will ship to the address above. No shipping fee is added retroactively.",
                confirmPickup: "Change to Pickup",
                confirmShipping: "Change to Shipping",
                switchedToPickup: "Order switched to pickup",
                switchedToShipping: "Order switched to shipping",
                saving: "Saving…",
                failed: "Couldn't change the fulfillment method — try again",
              },
              line: {
                pending: "Pending",
                reserved: "Reserved",
                backOrdered: "Back-ordered",
                partiallyShipped: "Partially shipped",
                readyToShip: "Ready to ship",
                shipped: "Shipped",
                cancelled: "Cancelled",
                patient: {
                  processing: "Processing",
                  ready: "Ready",
                  waitingOnRestock: "Waiting on restock",
                  partiallyShipped: "Partially shipped",
                  shipped: "Shipped",
                  cancelled: "Cancelled",
                },
              },
              summary: {
                shippedCount: "{{shipped}} of {{total}} shipped",
                awaitingRestockCount_one: "{{count}} awaiting restock",
                awaitingRestockCount_other: "{{count}} awaiting restock",
                inFlight_one: "{{count}} in flight",
                inFlight_other: "{{count}} in flight",
                aria: "Fulfillment status: {{summary}}",
              },
              strip: {
                aria: "Per-line fulfillment status",
                unnamed: "Item",
              },
              providerContactMissing: "Clinic contact info not on file. Ask the provider to complete their clinic profile.",
              split: {
                button: "Ship Available Lines",
                title: "Ship available lines",
                description:
                  "Lines you select will ship now with the carrier and tracking below. Back-ordered lines stay queued until stock returns.",
                qty: "Qty {{qty}}",
                reserved: "Reserved",
                backOrdered: "Back-ordered — can't ship yet",
                alreadyShipped: "Already shipped",
                carrier: "Carrier",
                tracking: "Tracking number",
                cancel: "Cancel",
                shipping: "Shipping…",
                shipSelected_one: "Ship selected ({{count}})",
                shipSelected_other: "Ship selected ({{count}})",
                withChild_one: "Shipped {{count}} line · Back-order card created for #{{displayId}}",
                withChild_other: "Shipped {{count}} lines · Back-order card created for #{{displayId}}",
                withoutChild_one: "Shipped {{count}} line",
                withoutChild_other: "Shipped {{count}} lines",
                errors: {
                  noSelection: "Select at least one line to ship.",
                  carrierRequired: "Carrier is required.",
                  trackingRequired: "Tracking number is required.",
                  failed: "Couldn't ship the selected lines. Please try again.",
                },
              },
              confirmPayment: "Confirm Payment",
              markAsShipped: "Mark as Shipped",
              markReadyForPickup: "Mark for Pickup",
              markAsDelivered: "Mark as Delivered",
              markAsPickedUp: "Mark as Picked Up",
              print: "Print",
              packingSlip: "Packing Slip",
              unarchive: "Unarchive",
              archive: "Archive",
              shippingInformation: "Shipping Information",
              carrier: "Carrier *",
              selectCarrier: "Select carrier...",
              specifyCarrier: "Specify Carrier *",
              carrierNamePlaceholder: "Carrier name",
              uberDispatchHint: "Uber Direct will be used. Click below to dispatch.",
              trackingNumber: "Tracking Number *",
              trackingPlaceholder: "Enter tracking number",
              shipping: "Shipping...",
              dispatchViaUber: "Dispatch via Uber",
              confirmAndShip: "Confirm & Ship",
              paidCancelWarning: "This order has been paid. A refund will need to be processed.",
              cancelReasonRequired: "Cancellation Reason *",
              cancelReasonOptional: "Reason (optional)",
              cancelReasons: {
                customerRequest: "Customer request",
                refundInitiated: "Refund initiated",
                duplicateOrder: "Duplicate order",
                outOfStock: "Out of stock",
                incorrectItems: "Incorrect items",
                providerCancelled: "Provider cancelled",
              },
              cancelReasonPlaceholderPaid: "e.g. Refund initiated, Customer request",
              cancelReasonPlaceholderUnpaid: "Optional reason for cancellation",
              goBack: "Go Back",
              cancelling: "Cancelling...",
              confirmCancellation: "Confirm Cancellation",
              unarchiveOrder: "Unarchive Order",
              archiveOrder: "Archive Order",
              unarchiveDescription: "This will restore the order to the active view.",
              archiveDescription:
                "This will hide the order from the default view. You can restore it later from the archived filter.",
              processing: "Processing...",
              orderSummary: "Order Summary",
              datePlaced: "Date Placed",
              fulfillmentLabel: "Fulfillment",
              localPickup: "Local Pickup",
              shipToAddress: "Ship to Address",
              destination: "Destination",
              clinicPickup: "Clinic Pickup",
              patientAddress: "Patient Address",
              clinicAddress: "Clinic Address",
              payment: "Payment",
              zelle: "Zelle",
              creditCard: "Credit Card",
              organization: "Organization",
              email: "Email",
              phone: "Phone",
            },
            awaitingRestock: {
              patient: {
                bannerTitle: "One or more items are waiting on restock",
                bannerBody: "We'll email you the moment the rest of your order is ready. Already-shipped items are on their way.",
              },
            },
            inventory: {
              title: "Clinic Inventory",
              subtitle:
                "What's physically in your clinic. Record receipts when shipments arrive; record dispenses when units leave.",
              loading: "Loading…",
              emptyMessage: "No clinic inventory yet. When shipments arrive, click 'Record receipt' to track what's on hand.",
              belowThresholdBanner_one: "{{count}} item is at or below your low-inventory threshold.",
              belowThresholdBanner_other: "{{count}} items are at or below your low-inventory threshold.",
              reorderCta: "Order more",
              lowPill: "Low",
              recordReceipt: "Record receipt",
              recordDispense: "Record dispense",
              dispenseAmt: "Dispense qty",
              receiveAmt: "Receive qty",
              confirm: "Confirm",
              cancel: "Cancel",
              submitting: "Saving…",
              dispenseSuccess: "Dispense recorded.",
              receiptSuccess: "Receipt recorded.",
              col: {
                sku: "SKU",
                product: "Product",
                dosage: "Dosage",
                reserved: "Reserved",
                available: "Available",
                ordered: "Units Reserved",
                backOrdered: "Units Back Ordered",
                addStock: "Add Stock",
                lastStocked: "Last Stocked",
                onHand: "On Hand",
                threshold: "Threshold",
                restockDate: "Expected Restock",
                discontinued: "Discontinued",
                lastReceived: "Last received",
                lastDispensed: "Last dispensed",
                actions: "Actions",
              },
              errors: {
                loadFailed: "Couldn't load clinic inventory.",
                invalidQty: "Quantity must be positive.",
                notEnoughStock: "Not enough stock on hand to dispense that quantity.",
                submitFailed: "Couldn't record the change.",
              },
              settings: {
                title: "Inventory Settings",
                backToInventory: "Back to Inventory",
                save: "Save",
                saving: "Saving…",
                saveSuccess: "Inventory settings saved",
                saveError: "Failed to save inventory settings",
                loadFailedBanner:
                  "Couldn't fetch saved settings. Showing defaults — your edits will still be submitted when you Save.",
                defaultLowStockThreshold: {
                  label: "Default low-stock threshold",
                  help: "Used for new variants. Existing variants keep their saved threshold.",
                },
                defaultRestockLeadDays: {
                  label: "Default restock lead days (optional)",
                  help: "If set, new variants suggest an expected restock date this many days from today.",
                },
              },
              pageTitle: "Inventory",
              openSettings: "Inventory settings",
              loadFailedBanner:
                "Couldn't fetch saved stock. Showing defaults — your edits will still be submitted when you Save.",
              mode: {
                overview: "Overview",
                manage: "Manage Stock",
              },
              filter: {
                search: "Search product or dosage…",
                showLowStock: "Show low stock only",
                hideDiscontinued: "Hide discontinued",
                showDiscontinued: "Show discontinued",
              },
              empty: {
                noProducts: "No products in your catalog yet.",
                noMatches: "No variants match your filters.",
              },
              modeSwitchConfirm: {
                body: "Switching modes clears your pending changes. Continue?",
              },
              saveBar: {
                pending_one: "{{count}} pending change",
                pending_other: "{{count}} pending changes",
                save: "Save",
                cancel: "Cancel",
                saving: "Saving…",
              },
              saveSuccess_one: "Inventory updated ({{count}} SKU)",
              saveSuccess_other: "Inventory updated ({{count}} SKUs)",
              saveError: "Failed to save inventory",
              impactWarning_one: "{{lines}} order line will be back-ordered across {{orders}} order(s) if you confirm.",
              impactWarning_other: "{{lines}} order lines will be back-ordered across {{orders}} order(s) if you confirm.",
              confirmDecrement: "Confirm and save",
              overcommit: {
                over: "over",
                badgeTip: "Over-committed by {{count}} — reserved exceeds on-hand",
                banner_one:
                  "{{count}} product is over-committed — reserved exceeds on-hand. Restock or cancel orders to resolve.",
                banner_other:
                  "{{count}} products are over-committed — reserved exceeds on-hand. Restock or cancel orders to resolve.",
              },
              status: {
                outOfStock: "Out of stock",
                lowStock: "Low stock",
              },
              restockApplied: "{{count}} order(s) restocked and ready to fulfill",
              decrementApplied: "{{count}} order(s) moved to Awaiting Restock",
            },
            notify: {
              backInStock: {
                toast: "{{sku}} is back in stock.",
              },
              qtyBelow: {
                toast: "{{sku}} is at or below your low-stock threshold.",
              },
              daysRunwayBelow: {
                toast: "{{sku}} is projected to run out soon.",
              },
            },
            alerts: {
              loading: "Loading…",
              channel: {
                email: "Email",
                inApp: "In-app",
                both: "Both",
              },
              config: {
                title: "Stock alerts",
                titleForSku: "Alerts for {{product}}",
                subtitle:
                  "We'll send one alert per threshold per 24 hours, and never fire while you're already below the threshold without a recovery.",
                qtyBelowLabel: "Alert when on-hand drops below",
                runwayBelowLabel: "Alert when projected runout is under",
                qtyUnit: "units",
                daysUnit: "days",
                cancel: "Cancel",
                save: "Save",
                saving: "Saving…",
                saveSuccess: "Alert preferences saved.",
                defaultPill: "Default",
              },
              errors: {
                loadFailed: "Couldn't load alert preferences.",
                saveFailed: "Couldn't save alert preferences.",
              },
            },
            priority: {
              title: "Awaiting restock queue",
              subtitle: "Priority order. The allocator promotes top entries when stock returns; you can override here.",
              empty: "No back-ordered lines right now. Allocator has nothing to promote.",
              loading: "Loading queue…",
              qty: "× {{qty}}",
              order: "Order {{orderId}}",
              score: "Score {{score}}",
              queuedOn: "Queued {{date}}",
              promote: "Promote",
              promoting: "Promoting…",
              confirmPromote:
                "Manually promote this line ahead of the allocator? This will reserve {{qty}} units of {{sku}} for order {{orderId}}.",
              promoteSuccess: "Line promoted. Order {{orderId}} updated.",
              reasons: {
                refill: "Refill",
                paid: "Paid",
                authorized: "Authorized",
                patientContinuity: "Returning patient",
                age: "{{count}}d waiting",
              },
              errors: {
                loadFailed: "Couldn't load the restock queue.",
                promoteFailed: "Couldn't promote the line.",
                noHeadroom: "Not enough stock on hand to promote this line right now.",
              },
            },
            catalogManager: {
              bulkInventory: "Bulk Inventory",
              legalDisclaimer: "Legal Disclaimer",
              col: {
                stock: "Stock",
              },
              stockRollup: {
                noVariants: "—",
                noData: "No data",
                allInStock: "All in stock",
                outOfStock: "{{count}} OOS",
                backOrdered: "{{count}} back-order",
                lowStock: "{{count}} low",
                discontinued: "{{count}} disc.",
              },
            },
            legalDisclaimer: {
              title: "Legal Disclaimer",
              subtitle: "Applies to all products — new and existing",
              previewLabel: "Live preview",
              previewHint: "Exactly what buyers see beneath every product description.",
              reset: "Reset to standard text",
              cancel: "Cancel",
              save: "Save",
              saving: "Saving…",
              emptyNote: "Leave a section blank to restore its standard text — a product can never ship without a disclaimer.",
              section: {
                reconstitution: "Reconstitution",
                restrictedSale: "Restricted Sale",
                researchUseWarning: "Research Use Warning",
                manufacturingQuality: "Manufacturing & Quality",
              },
              resetConfirmTitle: "Reset to standard text",
              resetConfirmBody:
                "Reset all four sections to the standard legal text? Your custom edits in this editor will be replaced.",
              resetConfirmAction: "Reset",
              saveConfirmTitle: "Update legal disclaimer",
              saveConfirmBody: "This updates the legal disclaimer shown on every product — new and existing. Continue?",
              saveConfirmAction: "Save",
            },
            protocols: {
              attach: {
                title: "Protocol (optional)",
                hint: "Assign a dosing protocol to each product you're ordering.",
                assignedCount: "{{count}} of {{total}} products on a protocol",
                noPeptides: "Add a peptide to your order to assign a protocol.",
                noneForProduct: "No protocol available",
                none: "None",
                weeksShort: "wks",
                rxDose: "Dose",
                rxDraw: "Draw",
                rxFreq: "Frequency",
                rxRoute: "Route",
                rxDuration: "Duration",
                drawUnits: "{{u}} units",
                verifyDraw: "Verify",
                verifyDrawHint:
                  "Catalog vial differs from the protocol's intended strength, or the dose won't fit a 1 mL syringe — verify in the Reconstitution calculator.",
              },
              title: "Protocol Library",
              searchPlaceholder: "Search protocols or peptides",
              countProtocols_one: "{{count}} protocol",
              countProtocols_other: "{{count}} protocols",
              doseDaysLabel: "Dosing days",
              doseDaysAny: "Optional — leave blank for any {{count}} day(s) a week",
              day: { mon: "M", tue: "T", wed: "W", thu: "Th", fri: "F", sat: "Sa", sun: "Su" },
              dayFull: {
                mon: "Monday",
                tue: "Tuesday",
                wed: "Wednesday",
                thu: "Thursday",
                fri: "Friday",
                sat: "Saturday",
                sun: "Sunday",
              },
              available: "Available",
              unavailable: "Not in catalog",
              weeksTotal: "{{count}} weeks",
              phaseCount: "{{count}} phases",
              noIntake: "No intake on file",
              noIntakeLong: "No intake questionnaire on file for this patient, so contraindications can't be pre-checked.",
              patientContext: "Browsing for {{name}}. Protocols are pre-checked against their intake.",
              loadingPatient: "Loading patient context…",
              clearPatient: "Clear",
              patient: "Patient",
              refillsDue: "Protocol refills due",
              overdueDays: "{{count}}d overdue",
              daysLeft: "{{count}}d left",
              phase: "Phase",
              weeks: "Weeks",
              dose: "Dose",
              unitsAt: "Units @ {{ml}} mL",
              maintenanceTag: "maintenance",
              unitsCaveat:
                "Syringe units assume a {{ml}} mL bacteriostatic-water reconstitution on a U-100 syringe. Verify other dilutions in the Reconstitution calculator.",
              phaseOrder: "Order for {{phase}}",
              monitoringTitle: "Monitoring",
              disclaimer:
                "Protocols are clinical decision support with draft dosing for prescriber review. The prescribing provider is solely responsible for confirming suitability, dosing, and monitoring for each patient.",
              cancel: "Cancel",
              close: "Close",
              addPhase: "Add {{phase}} to cart",
              phaseAdded: "{{phase}} of {{protocol}} added to cart",
              orderingFor: "Ordering for {{name}}",
              safetyFlags: "Intake flags for this protocol",
              empty: "No protocols match this filter.",
              newProtocol: "New protocol",
              doseLab: {
                title: "Dose lab: {{phase}}",
                hint: "Adjust vial, dilution, and dose",
                save: "Save changes",
                saveFork: "Save as my protocol",
                savedFork: "Saved to My protocols as {{name}}",
                savedInPlace: "{{name}} updated",
                vial: "Vial (mg)",
                diluent: "BAC water (mL)",
                dose: "Dose (mg)",
                perWeek: "Doses / week",
                concentration: "Concentration",
                draw: "Draw",
                dosesPerVial: "Doses / vial",
                full: "full draws",
                lasts: "Vial lasts",
                days: "days",
                fillTitle: "Syringe fill on a 1 mL U-100 barrel",
              },
              customize: "Duplicate & customize",
              customBadge: "Custom",
              patientBadge: "Patient protocol",
              sectionPatient: "Protocols for {{name}}",
              sectionMine: "My protocols",
              sectionStandard: "Standard protocols",
              editProtocol: "Edit protocol",
              deleteProtocol: "Delete protocol",
              deletedToast: "{{name}} deleted",
              savedToast: "{{name}} saved",
              undo: "Undo",
              editor: {
                titleNew: "New protocol",
                titleClone: "Customize protocol",
                titleEdit: "Edit protocol",
                cloneName: "{{name}} (Custom)",
                name: "Protocol name",
                namePlaceholder: "e.g. BPC-157 Recovery Ramp",
                description: "Description",
                descPlaceholder: "What this protocol is for and how it ramps",
                goals: "Goals",
                scope: "Who is this protocol for?",
                scopeOrg: "All patients",
                scopePatient: "Specific patient",
                pickPatient: "Select patient",
                searchPatient: "Search by name or date of birth",
                noPatients: "No matching patients",
                startTyping: "Start typing a name or date of birth",
                noDob: "No DOB on file",
                intakeOnly: "intake",
                phases: "Phases",
                phaseDefault: "Phase 1",
                phaseN: "Phase {{n}}",
                weeksSpan: "wks (weeks {{from}}-{{to}})",
                removePhase: "Remove phase",
                addPhase: "Add phase",
                pickPeptide: "Select peptide",
                doseMg: "Dose mg",
                doseLabel: "Dose label",
                perWeek: "per week",
                removePeptide: "Remove peptide",
                addPeptide: "Add peptide",
                monitoringPlaceholder: "e.g. Track weight monthly",
                removeNote: "Remove note",
                addNote: "Add monitoring note",
                needName: "Give the protocol a name.",
                needPhase: "Add at least one phase.",
                needWeeks: "Every phase needs a duration of at least 1 week.",
                needDose: "Every phase needs a peptide with a dose above 0.",
                needPatient: "Pick the patient this protocol belongs to.",
                save: "Save protocol",
              },
              journeyTitle: "Protocol journey",
              journeyEmpty: "No protocol on record for this patient yet.",
              startProtocol: "Start protocol",
              statusActive: "Active",
              statusDue: "Refill due",
              statusOverdue: "Overdue",
              statusCompleted: "Completed",
              actionAdvance: "Advance",
              actionRepeat: "Repeat",
              actionMaintain: "Maintain",
              actionStepDown: "Step down",
              actionTimeOff: "Time off",
              actionResume: "Resume",
              statusPaused: "On break",
              resumeIn: "Back on in {{count}}d",
              pausedToast: "{{protocol}} paused for {{count}} days",
              timeOffHint: "Record a planned break; the journey resumes after it.",
              timeOffDays: "{{count}} days",
              approvalSection: "Protocol",
              approvalContinues: "Approving continues {{protocol}} ({{phase}}).",
              phaseOfShort: "phase {{n}}",
              noProtocol: "No protocol",
              noMatch: "No library protocol matches this order's items.",
              stampFailed: "Couldn't record the protocol on this order. Approval continues without it.",
              phaseOf: "{{label}}: phase {{n}} of {{total}}",
              limitsTitle: "Limits & cautions",
              limit: {
                vsLimit: "(limit {{limit}})",
                overSingle: "Dose exceeds the per-dose ceiling",
                overWeekly: "Weekly dose exceeds the ceiling",
                overMonthly: "More doses per month than allowed",
                tooFrequent: "Doses closer together than the minimum interval",
                overCycle: "Phase runs longer than the recommended cycle",
                titrateSlowly: "Escalate no faster than every 4 weeks; hold or step back for GI intolerance.",
                oralGlp1: "Oral GLP-1: take consistently; titrate to limit nausea.",
                cardioHighDose: "Doses above 500 mcg/day raise heart rate and blood pressure — monitor closely.",
                cycleOnOff: "Cycle on and off as directed to preserve response and limit tolerance.",
                researchOnly: "Narrow therapeutic window — do not stack with similar compounds.",
                hypoglycemia: "Can cause hypoglycemia — dose with food and monitor blood sugar.",
                mk677Effects: "May increase appetite, water retention, and fasting glucose — monitor.",
                loadThenMaintain: "Use a loading phase, then drop to a maintenance dose.",
                epitalonSpacing: "Short course only; repeat every 4–6 months, not continuously.",
                nadRate: "Push slowly — flushing and nausea are dose-rate related.",
                nmnCeiling: "Considered safe up to 1250 mg/day in healthy adults.",
                maoiSerotonin: "Avoid with SSRIs/SNRIs/MAOIs — serotonin-syndrome risk. Confirm medications.",
                pt141Limits: "Max 1 dose per 24 hours and 8 doses per month. May raise blood pressure transiently.",
                hormoneLabs: "Reassess testosterone and hormone labs before extending beyond a cycle.",
                mt2Caution: "Titrate from 0.25 mg; nausea/flushing are common. Monitor moles and pigmented lesions.",
                phenibutDependence: "High dependence and tolerance risk — limit frequency. Use caution above 700 mg.",
              },
              phases: {
                initiation: "Initiation",
                escalation1: "Escalation 1",
                escalation2: "Escalation 2",
                escalation3: "Escalation 3",
                maintenance: "Maintenance",
                loading: "Loading",
                consolidation: "Consolidation",
                build: "Build",
                fullDose: "Full dose",
                course: "Course",
                asNeeded: "As needed",
              },
              supplies: {
                bacWater: "Bacteriostatic water",
                syringes: "Insulin syringes",
                alcoholWipes: "Alcohol prep pads",
              },
              lib: {
                "wl-cagrilintide-titration": {
                  name: "Cagrilintide Titration",
                  desc: "Amylin analog escalated weekly from 0.25 mg to 1.7 mg every 4 weeks to limit nausea.",
                },
                "wl-mazdutide-titration": {
                  name: "Mazdutide Titration",
                  desc: "GLP-1/glucagon dual agonist ramped from 1.5 mg to 5 mg weekly over 12 weeks.",
                },
                "wl-orforglipron-oral": {
                  name: "Orforglipron Oral Titration",
                  desc: "Once-daily oral GLP-1 stepped from 12 mg to 36 mg as tolerated; no injection or refrigeration.",
                },
                "wl-tesofensine-oral": {
                  name: "Tesofensine Oral",
                  desc: "Triple monoamine reuptake inhibitor started at 250 mcg daily, increasing to 500 mcg with BP/HR monitoring.",
                },
                "wl-aod9604-12wk": {
                  name: "AOD-9604 Fat Loss",
                  desc: "HGH fragment 177-191 at 250-300 mcg each morning, fasted, for 12 weeks.",
                },
                "wl-amino1mq-oral": {
                  name: "5-Amino-1MQ Oral",
                  desc: "NNMT inhibitor at 50 mg three times daily with meals; one month off every two months.",
                },
                "wl-slupp332-intro": {
                  name: "SLU-PP-332 Introduction",
                  desc: "Exercise-mimetic ERR agonist started at 250 mcg to assess tolerance, then 500 mcg.",
                },
                "wl-bam15-oral": {
                  name: "BAM-15 Training Days",
                  desc: "Mitochondrial uncoupler at 15-30 mg on an empty stomach on training days.",
                },
                "energy-cardarine": {
                  name: "Cardarine (GW-501516)",
                  desc: "PPARδ agonist at 10-20 mg daily for endurance and lipid support, 8-week cycles.",
                },
                "energy-sr9011": {
                  name: "SR-9011 Circadian",
                  desc: "Rev-ErbA agonist at 15-30 mg daily to support metabolism and circadian rhythm.",
                },
                "wl-lcarnitine": {
                  name: "L-Carnitine",
                  desc: "Fatty-acid transporter at ~1000 mg daily to support fat metabolism and recovery.",
                },
                "wl-lipoc-mic": {
                  name: "Lipo-C / B12 (MIC)",
                  desc: "Lipotropic MIC + B12 injection weekly to support fat metabolism and energy.",
                },
                "gh-cjc1295-nodac": {
                  name: "CJC-1295 (No DAC)",
                  desc: "GHRH analog built from 100 mcg to 200 mcg nightly, 5 nights per week.",
                },
                "gh-cjc1295-dac": {
                  name: "CJC-1295 with DAC",
                  desc: "Long-acting GHRH analog at 1000 mcg twice weekly for sustained GH release.",
                },
                "gh-ipamorelin": {
                  name: "Ipamorelin",
                  desc: "Selective GH secretagogue at 200-300 mcg, 2-3 times daily on an empty stomach.",
                },
                "gh-sermorelin": {
                  name: "Sermorelin",
                  desc: "GHRH peptide at 200 mcg nightly at bedtime, with periodic 1-2 month breaks.",
                },
                "gh-tesamorelin": {
                  name: "Tesamorelin",
                  desc: "GHRH analog at 1 mg each morning, fasted, Monday through Friday for visceral fat.",
                },
                "muscle-igf1lr3": {
                  name: "IGF-1 LR3",
                  desc: "Long-acting IGF-1 at 50 mcg daily, 4 weeks on and 4 weeks off.",
                },
                "gh-mk677-oral": {
                  name: "MK-677 (Ibutamoren)",
                  desc: "Oral GH secretagogue started at 10-15 mg, building to a 25 mg daily standard dose.",
                },
                "gh-mk777-oral": {
                  name: "MK-777 (Acetamoren)",
                  desc: "Longer-acting ghrelin agonist at 25 mg daily for GH and IGF-1 support.",
                },
                "gh-somatropin": {
                  name: "Somatropin (HGH)",
                  desc: "Recombinant growth hormone at 2-4 IU nightly before bed.",
                },
                "rec-bpc157-standalone": {
                  name: "BPC-157 Repair",
                  desc: "Tissue-repair peptide at 250-500 mcg, 1-2 times daily, 4-6 weeks on then 2-4 weeks off.",
                },
                "rec-tb500-standalone": {
                  name: "TB-500 Repair",
                  desc: "Loading at 5 mg per week split into doses, then 2.5 mg weekly maintenance.",
                },
                "rec-kpv": {
                  name: "KPV Anti-Inflammatory",
                  desc: "Anti-inflammatory tripeptide at 200-400 mcg daily for 4-6 weeks.",
                },
                "skin-glow-blend": {
                  name: "Glow Blend",
                  desc: "BPC-157 / TB-500 / GHK-Cu blend, 5 units morning and 5 units evening.",
                },
                "rec-klow-blend": {
                  name: "KLOW Blend",
                  desc: "GHK-Cu / BPC-157 / TB-4 / KPV blend at 2-4 mg per dose, 1-2 times daily.",
                },
                "longevity-ss31": {
                  name: "SS-31 Mitochondrial",
                  desc: "Mitochondria-targeted peptide at ~5 mg daily for cellular-energy support.",
                },
                "immune-thymosin-a1": {
                  name: "Thymosin Alpha-1",
                  desc: "Immune-modulating peptide at 1.6 mg twice weekly; courses run 6-12 months.",
                },
                "energy-nmn-oral": {
                  name: "NMN Oral",
                  desc: "NAD+ precursor at 500 mg daily; well tolerated up to 1250 mg.",
                },
                "cog-methylene-blue": {
                  name: "Methylene Blue",
                  desc: "Mitochondrial cofactor at 50-100 mg daily for cognitive and energy support.",
                },
                "anti-glutathione": {
                  name: "Glutathione Antioxidant",
                  desc: "Master antioxidant at 200-600 mg per dose, 2-3 times weekly, IM or SubQ.",
                },
                "sex-hcg-trt": {
                  name: "HCG (TRT Adjunct)",
                  desc: "500 IU 2-3 times weekly to preserve testicular function alongside TRT.",
                },
                "sex-gonadorelin": {
                  name: "Gonadorelin",
                  desc: "GnRH agonist at 100-200 mcg twice daily to support endogenous testosterone.",
                },
                "sex-enclomiphene": {
                  name: "Enclomiphene",
                  desc: "Oral SERM at 12.5-25 mg daily for 14-28 days to assess testosterone response; cycle 3-6 months.",
                },
                "skin-melanotan2": {
                  name: "Melanotan 2",
                  desc: "Started at 0.25 mg daily to assess tolerance, increasing to 0.5 mg, then 0.5 mg 1-2x weekly to maintain.",
                },
                "cog-selank-standalone": {
                  name: "Selank Anxiolytic",
                  desc: "Anxiolytic nootropic at 250 mcg daily for 10-14 days, then a 2-4 week break.",
                },
                "cog-semax-standalone": {
                  name: "Semax Nootropic",
                  desc: "Focus nootropic at 250 mcg daily for 10-20 days, then a 2-4 week break.",
                },
                "cog-dihexa-oral": {
                  name: "Dihexa",
                  desc: "HGF/c-Met potentiator at 10-40 mg daily for cognitive support.",
                },
                "cog-fladrafinil-oral": {
                  name: "Fladrafinil",
                  desc: "Eugeroic nootropic at 50-100 mg per day for wakefulness and focus.",
                },
                "cog-phenibut-oral": {
                  name: "Phenibut",
                  desc: "GABA-B agonist at 200-500 mg, used sparingly; tolerance builds quickly.",
                },
                "skin-ahkcu": {
                  name: "AHK-Cu Hair Support",
                  desc: "Copper tripeptide at 1-2 mg daily for hair-follicle support.",
                },
                wlSema: {
                  name: "Semaglutide Weight Loss Titration",
                  desc: "Standard GLP-1 escalation from 0.25 mg to a 2.4 mg weekly maintenance dose, stepping every 4 weeks per tolerance.",
                },
                wlTirz: {
                  name: "Tirzepatide Weight Loss Titration",
                  desc: "Dual GIP/GLP-1 escalation from 2.5 mg to a 12.5 mg weekly maintenance dose, stepping every 4 weeks per tolerance.",
                },
                wlReta: {
                  name: "Retatrutide Introduction",
                  desc: "Triple-agonist introduction ramp from 1 mg to 4 mg weekly; titrate beyond per response and tolerance.",
                },
                recBpcTb: {
                  name: "Wolverine Stack (BPC-157 + TB-500)",
                  desc: "Soft-tissue repair stack: 4-week loading phase followed by a 4-week consolidation phase at reduced frequency.",
                },
                glowBlend: {
                  name: "Glow Blend Course (GHK-Cu / BPC / TB-500)",
                  desc: "Skin-quality and tissue-repair blend: 500 mcg daily for 6 weeks, then reassess.",
                },
                kisspeptin: {
                  name: "Kisspeptin Axis Support",
                  desc: "Hypothalamic LH / testosterone signaling support: 100 mcg daily for 8 weeks, then reassess with labs.",
                },
                ghCjcIpa: {
                  name: "CJC-1295 / Ipamorelin 12-Week Cycle",
                  desc: "GH-axis support: 4-week build at 100 mcg nightly, then 8 weeks at the full 200 mcg dose, 5 nights per week.",
                },
                epitalon: {
                  name: "Epitalon 20-Day Course",
                  desc: "Telomerase-support course: 10 mg daily for 20 days; may repeat every 4 to 6 months.",
                },
                nad: {
                  name: "NAD+ Restoration",
                  desc: "Cellular-energy support: 4-week loading at twice weekly, then weekly maintenance dosing.",
                },
                motscNad: {
                  name: "MOTS-c + NAD+ Metabolic Stack",
                  desc: "Mitochondrial and metabolic support: MOTS-c every 5 days alongside weekly NAD+ for 8 weeks.",
                },
                pt141: {
                  name: "PT-141 As-Needed Protocol",
                  desc: "On-demand dosing 45+ minutes before activity; maximum 1 dose per 24 hours and 8 doses per month.",
                },
                dsip: {
                  name: "DSIP 30-Day Sleep Protocol",
                  desc: "Sleep-onset support: 150 mcg nightly, 30 to 60 minutes before bedtime, for 30 days then reassess.",
                },
                ghkcu: {
                  name: "GHK-Cu 8-Week Skin Protocol",
                  desc: "Skin and tissue-quality course: 1.5 mg daily for up to 8 weeks, followed by a 2 to 4 week break.",
                },
                selankSemax: {
                  name: "Selank + Semax Cognitive Stack",
                  desc: "Focus and stress-resilience stack: 250 mcg of each daily for 6 weeks, then cycle off.",
                },
              },
              monitoring: {
                oralCaution: "Oral compound — confirm dosing and interactions before use.",
                assessTolerance: "Start low and assess tolerance before increasing.",
                fastedMorning: "Dose in the morning, fasted, for best response.",
                cycleBreak: "Cycle off periodically to avoid tolerance.",
                ghIgf1: "Reassess IGF-1 with labs periodically.",
                generic: "Reassess response and tolerance at each cycle boundary.",
                immuneLabs: "Reassess immune markers over the course.",
                hormoneLabs: "Reassess hormone labs every 3 months.",
                tanResponse: "Increase only after assessing skin response and tolerance.",
                giTolerance: "Assess GI tolerance before each dose escalation.",
                weightMonthly: "Track weight and response monthly; hold or step back per tolerance.",
                injurySite: "Reassess the injury site at each phase boundary.",
                labsReassess: "Reassess LH, total testosterone, and response with labs at the end of the course.",
                igf1Labs: "Consider IGF-1 labs at the end of the cycle before repeating.",
                epitalonSpacing: "Space repeat courses 4 to 6 months apart.",
                nadTolerance: "Titrate per tolerance; flushing and nausea are dose-rate related.",
                energyResponse: "Reassess energy and metabolic response at the end of the course.",
                pt141Limits: "Respect the 1-dose-per-24h and 8-doses-per-month limits.",
                sleepQuality: "Reassess sleep quality at 30 days before continuing.",
                ghkBreak: "Take a 2 to 4 week break between courses.",
                cycleOff: "Cycle 2 to 4 weeks off between courses.",
              },
            },
            notifSettings: {
              title: "Notification settings",
              subtitle: "Choose how you want to hear about your peptide orders.",
              orgNote:
                "Email destinations for org-level events stay in your org notification settings — this page governs your in-app alerts.",
              loading: "Loading…",
              save: "Save",
              saving: "Saving…",
              cancel: "Cancel",
              saveSuccess: "Notification settings saved.",
              emailLocked: "Email for these can't be turned off.",
              cat: {
                orderProgress: "Order progress",
                actionNeeded: "Action needed",
                payments: "Payments",
                messages: "Messages",
                confirmations: "Confirmations",
              },
              desc: {
                orderProgress: "Approved, preparing, shipped, delivered and restock updates",
                actionNeeded: "Orders and refill requests waiting on you",
                payments: "Payment issues, receipts and denials",
                messages: "New messages on your orders (max one email per 15 minutes per order)",
                confirmations: "Order placed and cancellation notices",
              },
              channel: {
                both: "Email + in-app",
                email: "Email only",
                in_app: "In-app only",
                none: "Off",
              },
              errors: {
                loadFailed: "Couldn't load notification settings.",
                saveFailed: "Couldn't save notification settings.",
              },
            },
            orderToasts: {
              order_placed_patient: "A patient placed a new order.",
              order_placed_provider: "A new peptide order was placed.",
              order_drafted_for_provider: "An order was drafted for you — review & pay.",
              draft_finalized: "An order was finalized — payment due.",
              payment_confirmed: "Payment confirmed — order in preparation.",
              order_approved: "Your order was approved!",
              order_denied_provider: "An order was not approved.",
              payment_failed: "A payment failed on a peptide order.",
              receipt_uploaded: "A payment receipt was uploaded.",
              order_denied_manufacturer: "An order was denied by the manufacturer.",
              order_shipped: "A peptide order has shipped.",
              order_partial_shipped: "Part of a peptide order has shipped.",
              order_ready_for_pickup: "A peptide order is ready for pickup.",
              order_delivered: "A peptide order was delivered.",
              order_backordered: "A peptide order is awaiting restock.",
              order_restocked: "A back-ordered peptide order is now processing.",
              order_cancelled: "A peptide order was cancelled.",
              new_message: "New message on a peptide order.",
              refill_requested: "A patient requested a refill.",
            },
            export: {
              button: "Export orders",
              title: "Export peptide orders",
              subtitle: "Download these orders as a spreadsheet or a printable PDF. Nothing leaves this page until you export.",
              sections: {
                dateRange: "Date placed",
                status: "Status",
                organizations: "Organizations",
                columns: "Columns",
                output: "Output",
              },
              placedBasis: "Placed",
              noOrganization: "(No organization)",
              orgAll: "All organizations",
              orgSelected: "{{count}} selected",
              orgSearch: "Search organizations",
              range: {
                all: "All time",
                last7: "Last 7 days",
                last30: "Last 30 days",
                last90: "Last 90 days",
                mtd: "Month to date",
                ytd: "Year to date",
                custom: "Custom",
                from: "From",
                to: "To",
              },
              status: {
                selectAll: "Select all",
                clear: "Clear",
                includeArchived: "Include archived orders",
                other: "Other",
              },
              columns: {
                selectAll: "All",
                none: "None",
                atLeastOne: "Pick at least one column to export.",
              },
              presets: {
                basic: "Basic",
                fulfillment: "Fulfillment",
                billing: "Billing",
                everything: "Everything",
              },
              categories: {
                customer: "Customer",
                order: "Order",
                fulfillment: "Fulfillment",
                payment: "Payment",
                organization: "Organization",
              },
              fields: {
                patientFirstName: "First name",
                patientLastName: "Last name",
                patientDOB: "Date of birth",
                patientAddress: "Address",
                patientCity: "City",
                patientState: "State",
                patientZip: "ZIP",
                patientId: "Patient ID",
                id: "Order #",
                placedAt: "Placed",
                status: "Status",
                lane: "Board column",
                origin: "Order source",
                products: "Products",
                unitCount: "Units",
                isRecurring: "Recurring",
                recurringIntervalDays: "Refill interval (days)",
                parentOrderId: "Parent order #",
                lastStateChangeAt: "Last status change",
                cancelReason: "Cancellation reason",
                isArchived: "Archived",
                fulfillmentType: "Fulfillment",
                carrier: "Carrier",
                trackingNumber: "Tracking #",
                deliveredAt: "Delivered",
                pickupLocation: "Pickup location",
                paymentMethod: "Payment method",
                orderTotalDollars: "Order total (USD)",
                totalDollars: "Products subtotal (USD)",
                shippingDollars: "Shipping (USD)",
                hasCustomPricing: "Custom pricing",
                organizationName: "Organization",
                organizationId: "Organization ID",
                placedByName: "Placed by (name)",
                productName: "Product",
                quantity: "Qty",
                unitPriceDollars: "Unit price (USD)",
                dosage: "Dosage",
                formType: "Form",
              },
              origin: {
                provider: "Provider",
                patient: "Patient",
                manufacturer: "Manufacturer",
                unknown: "Unknown",
              },
              values: {
                yes: "Yes",
                no: "No",
                ship: "Ship",
                pickup: "Pickup",
                card: "Card",
                zelle: "Zelle",
                none: "None",
              },
              rowShape: {
                label: "Rows",
                perOrder: "One row per order",
                perProduct: "One row per product line",
              },
              format: {
                label: "Format",
                csv: "CSV",
                pdf: "PDF",
              },
              matchCount_one: "{{count}} of {{total}} orders match",
              matchCount_other: "{{count}} of {{total}} orders match",
              noMatches: "No orders match these filters",
              namesLoading_one:
                "Product names are still loading for {{count}} order. You can export now; its product cells may be blank.",
              namesLoading_other:
                "Product names are still loading for {{count}} orders. You can export now; their product cells may be blank.",
              pdfColumnWarning: "{{count}} columns is a lot for one PDF page — CSV keeps every column readable.",
              exportAction: "Export",
              cancel: "Cancel",
              success_one: "Exported {{count}} order",
              success_other: "Exported {{count}} orders",
              errors: {
                failed: "Couldn't generate the export. Try a narrower date range or fewer columns.",
              },
              pdf: {
                title: "Peptide Orders Export",
                generated: "Generated {{date}}",
                page: "Page {{page}} of {{pages}}",
                empty: "No orders matched.",
              },
            },
          },
          clinicalProfile: {
            activationDelivery:
              "Check your email for a link to activate your patient dashboard. If it is not in your inbox, check your text messages for a backup copy.",
            editedByPatient: "Updated by patient · {{time}}",
            peptideOrders: {
              title: "Peptide Orders",
              countLabel_one: "{{count}} order",
              countLabel_other: "{{count}} orders",
              lifetime: "lifetime",
              lastOrdered: "Last ordered",
              orderedBy: "Ordered by",
              viewAll_one: "View all {{count}} order →",
              viewAll_other: "View all {{count}} orders →",
              emptyTitle: "No peptide orders yet",
              emptyBody1: "Orders placed for this patient will appear here.",
              emptyBody2: "To place a new order, select this patient at peptide checkout.",
              errorMessage: "Couldn't load peptide orders.",
              retry: "Try again",
            },
          },
          profile: {
            unsavedChanges: {
              title: "Unsaved changes",
              message: "You have unsaved changes. Would you like to exit or save before leaving?",
              saveAndClose: "Save & Close",
              exit: "Exit",
            },
            reviewChanges: {
              title: "Review your changes",
              subtitle: "Review what you'll save, or revert anything you didn't mean to change.",
              change: "change",
              changes: "changes",
              none: "No changes left to save.",
              revert: "Revert",
              keepEditing: "Keep editing",
              discardAll: "Discard all",
              saveClose: "Save & close",
              close: "Close",
            },
            npiVerification: {
              title: "Verify your NPI",
              subtitle:
                "Before placing orders, we verify your NPI against the public NPPES registry to confirm you are a licensed clinician.",
              subtitleRemediate:
                "Your previously entered NPI couldn't be verified against the NPPES registry. Please re-enter it below to continue.",
              label: "NPI Number",
              placeholder: "10-digit NPI",
              verify: "Verify",
              verifying: "Verifying…",
              success: "NPI verified successfully.",
              changeWarning:
                "Changing your NPI will clear your verified status. You'll be asked to re-verify against NPPES before placing your next order.",
              bannerTitle: "Verify your NPI",
              bannerBody: "Verify your NPI against the public NPPES registry to enable ordering.",
              bannerFailureTitle: "NPI verification required",
              bannerFailureBody:
                "We couldn't verify your NPI against the NPPES registry. Please re-enter it before placing orders.",
              bannerCta: "Verify now",
              errors: {
                format: "Please enter a valid 10-digit NPI number.",
                notFound: "We couldn't find this NPI in the NPPES registry. Please double-check the number.",
                inactive: "This NPI is marked inactive in NPPES. Please contact support if you believe this is an error.",
                nameMismatch:
                  "The name on this NPI doesn't match your account name. If this is a typo, update your profile. For legal name changes, please contact support.",
                wrongType: "This appears to be an organization NPI. Please enter your personal (Type 1) NPI.",
                network: "Verification service is temporarily unavailable. Please try again.",
                unknown: "Verification failed. Please try again.",
              },
            },
            modals: {
              complete: "Complete",
              completeNafTitle: "Complete New Account Form",
              enterPinToComplete: "Enter your PIN to complete",
              enterPinToSign: "Enter your PIN to sign",
              sign: "Sign",
              signAchAuthTitle: "Sign ACH Authorization",
              signCreditCardAuthTitle: "Sign Credit Card Authorization",
              signPurchaseAgreementTitle: "Sign Purchase Agreement",
            },
            ach: {
              accountName: "Account Name",
              accountNumber: "Bank Account Number",
              accountType: "Type of Account",
              attachVoidedCheck: "Please attach a voided check via the Required Files tab.",
              authorizationText:
                "I (we) hereby authorize the Seller named on this form to debit entries to my (our) account indicated below. I (we) acknowledge the origination of ACH transactions to my (our) account must comply with the provisions of U.S. law. The authority is to remain in full force and effect until the company has received written notification of its termination.",
              billingAddress: "Billing Street Address",
              billingCityStateZip: "Billing City, State, Zip",
              billingName: "Billing Name",
              checking: "Checking",
              emailAddress: "Email Address",
              financialInstitution: "Financial Institution Name (Branch)",
              fullLegalName: "Full legal name",
              no: "No",
              recurringPayment: "Recurring Payment",
              recurringRange: "Recurring Range: as low as $1.00 Minimum up to $1,500,000.00 Maximum",
              routingNumber: "Bank Routing Number",
              savings: "Savings",
              signature: "Signature",
              subtitle: "Authorization Agreement for Direct Payments (ACH Debits) to the Seller.",
              title: "ACH Authorization",
              yes: "Yes",
            },
            advancedTools: {
              actionsHeader: "Actions",
              addTemplate: "Add Template",
              confirmDeleteTemplate: 'Are you sure you want to delete "{{name}}"?',
              days: "days",
              deleteTemplate: "Delete Template",
              editTemplate: "Edit Template",
              every: "Every",
              nameHeader: "Name",
              other: "Other",
              reminderTemplates: "Reminder Templates",
              repeat: "Repeat",
              save: "Save",
              subjectHeader: "Subject",
              triggerHeader: "Trigger",
            },
            baa: {
              download: "Download PDF",
              exporting: "Exporting...",
              gtm: "GTM BAA",
              lucas: "Lucas Health BAA",
              meridian: "Meridian BAA",
              noneSigned: "No signed BAAs found.",
              shoreline: "Shoreline BAA",
            },
            creditCard: {
              amex: "AMEX",
              amount: "Amount ($)",
              authorizationText:
                "I authorize the Seller named on this form to charge the credit card indicated above according to the terms outlined. This authorization is valid for one (1) use only.",
              billingAddress: "Billing Address",
              billingInformation: "Billing Information",
              cardNumber: "Card Number",
              cardType: "Card Type",
              cardholderName: "Cardholder Name",
              cardholderSignature: "Cardholder Signature",
              cardholderZip: "Cardholder ZIP",
              chargeDate: "Charge Date (MM/DD/YYYY)",
              cityStateZip: "City, State, ZIP",
              creditCardInformation: "Credit Card Information",
              cvv: "CVV",
              discover: "Discover",
              email: "Email",
              expiration: "Expiration (MM/YY)",
              infoMessage:
                "Optional alternative to ACH. Subject to 3.5% credit card fees. This authorization is for a single transaction only.",
              mastercard: "Mastercard",
              otherCard: "Other",
              paymentDescription: "Payment Description",
              paymentDetails: "Payment Details",
              phone: "Phone",
              selectCardType: "Select Card Type",
              subtitle: "One-time credit card authorization (optional alternative to ACH).",
              title: "Credit Card Authorization",
              visa: "VISA",
            },
            customNotes: {
              buildNew: "Build a Custom Note",
              builder: {
                addToNote: "Add to note",
                added: "Added",
                createCustomSection: "Create Custom Section",
                dropHere: "Drag elements here to build your note",
                elements: "Elements",
                formattingOptions: "Formatting Options",
                general: "General",
                includedComponents: "Included Components",
                nameRequired: "Note name is required",
                noElements: "No elements match your search.",
                noFormattingOptions:
                  "This element does not have configurable formatting options yet. Additional formatting options will be available in a future update.",
                noSettings: "Select an element to view its settings",
                noteDescription: "Description (optional)",
                noteName: "Note name",
                noteNamePlaceholder: "Enter note name",
                patientType: "Patient",
                preview: "Note Preview",
                previewLabel: "Preview",
                previewPlaceholder: "Content will be generated based on the patient encounter and the formatting options below.",
                save: "Save Note",
                searchElements: "Search elements...",
                sectionDisabled: "Section disabled",
                separatorInfo: "Separators add a visual divider between note sections.",
                setting: "Setting",
                settings: "Element Settings",
                specialty: "Specialty",
                visitType: "Visit Type",
              },
              category: {
                assessmentPlan: "Assessment & Plan",
                objective: "Objective",
                other: "Other",
                subjective: "Subjective",
              },
              confirmDelete: 'Are you sure you want to delete "{{name}}"?',
              copySuffix: " (Copy)",
              createdByYou: "Created by you",
              customBadge: "Custom",
              customSection: {
                addField: "Add Field",
                category: "Section Category",
                createTitle: "Create Custom Section",
                describe: "Describe what you want",
                descriptionPlaceholder: "Describe the clinical information you want in this section...",
                editPrompt: "Edit custom section",
                editTitle: "Edit Custom Section",
                fieldLabel: "Field name",
                fieldNormal: "Normal / default value",
                inputMode: "Input Mode",
                maxFields: "Maximum of 20 fields reached.",
                outputFormat: "Output Format",
                saveSection: "Save Section",
                sectionTitle: "Section Title",
                templateFields: "Template Fields",
                templateHint:
                  "Define fields with their normal/default values. AI will replace defaults with actual patient data.",
                templateMinFields: "Add at least one field with a label and default value.",
                titlePlaceholder: "e.g., Wound Healing Progress",
              },
              sectionInstructions: {
                badge: "Instructions",
                buttonTitle: "Output instructions",
                clear: "Clear",
                editTitle: "Output Instructions",
                helper:
                  "These instructions refine how the AI writes this section. They can't change the note format or affect other sections.",
                phiWarning:
                  "Instructions apply to every patient using this template. Do not include patient names or other identifying information.",
                placeholder: "e.g. Default to 'All findings negative except as detailed in the HPI'",
                save: "Save",
              },
              deleteNote: "Delete Custom Note",
              description: "Build and manage custom note templates",
              duplicateNameError: 'A custom note named "{{name}}" already exists. Please use a different name.',
              duplicateNote: "Duplicate",
              editNote: "Edit Note",
              elementSettings: {
                hpiLengthMode: {
                  label: "Length",
                  values: {
                    comprehensive: "Comprehensive",
                    concise: "Concise",
                  },
                },
                hpiStyleMode: {
                  label: "Style",
                  values: {
                    bullets: "Bullet Points",
                    paragraph: "Paragraph",
                  },
                },
                mdmLengthMode: {
                  label: "Length",
                  values: {
                    comprehensive: "Comprehensive",
                    concise: "Concise",
                  },
                },
                mdmStyleMode: {
                  label: "Style",
                  values: {
                    bullets: "Bullet Points",
                    paragraph: "Paragraph",
                  },
                },
                physicalExamLengthMode: {
                  label: "Length",
                  values: {
                    comprehensive: "Comprehensive",
                    concise: "Concise",
                  },
                },
                planOfCareMode: {
                  label: "Length",
                  values: {
                    complex: "Problem Based",
                    concise: "Concise",
                  },
                },
                problemListMode: {
                  label: "Format",
                  values: {
                    numbered: "Numbered",
                    unnumbered: "Not Numbered",
                  },
                },
                rosMode: {
                  label: "Length",
                  values: {
                    complex: "Complex",
                    concise: "Concise",
                  },
                },
              },
              enterCopyName: "Enter a name for your custom copy:",
              format: {
                bulletPoints: "Bullet Points",
                bullets: "Bullets",
                numbered: "Numbered",
                numberedList: "Numbered List",
                paragraph: "Paragraph",
                table: "Table",
              },
              inputMode: {
                description: "Description",
                templateBuilder: "Template Builder",
              },
              myCopySuffix: " (My Copy)",
              noMatchingNotes: "No notes match your search.",
              noNotes: "No custom notes yet. Click 'Build a Custom Note' to get started.",
              noteNotFound: "Custom note not found. It may have been deleted.",
              searchNotes: "Search notes...",
              sections: "sections",
              shared: "Shared",
              title: "Custom Notes",
            },
            dotPhrases: {
              addDotPhrase: "Add Dot Phrase",
              cancel: "Cancel",
              category: "Category",
              categoryAP: "A/P",
              categoryAll: "All Categories",
              categoryCustom: "Custom",
              categoryHPI: "HPI",
              categoryOrders: "Orders",
              categoryPE: "PE",
              categoryProcedures: "Procedures",
              categoryROS: "ROS",
              confirmDelete: "Are you sure you want to delete the dot phrase '{{trigger}}'?",
              content: "Content",
              contentRequired: "Content is required",
              delete: "Delete",
              deleteDotPhrase: "Delete Dot Phrase",
              editDotPhrase: "Edit Dot Phrase",
              information: "Information",
              noAutocompleteMatches: "No matching phrases",
              noMatchingPhrases: "No phrases match your search.",
              noPhrasesFound: "No dot phrases found. Click 'Add Dot Phrase' to create one.",
              outputPreview: "Preview",
              phraseTitle: "Title",
              plan: "Plan",
              planRequired: "Plan content is required",
              preview: "Preview",
              procedureDescription: "Procedure Description",
              save: "Save",
              search: "Search phrases...",
              showTitleInOutput: "Show title in output",
              title: "Dot Phrases",
              titlePlaceholderAP: "Problem being addressed",
              titlePlaceholderGeneral: "HPI - General",
              titleRequired: "Title is required",
              trigger: "Trigger",
              triggerExists: "A phrase with this trigger already exists",
              triggerHelp: "Type this shortcut to insert the phrase (e.g. ..hpi)",
              triggerInvalid: "Trigger must be alphanumeric only",
              triggerRequired: "Trigger is required",
              varDateTimeNow: "Current Time",
              varDateTimeToday: "Today's Date",
              varEncounterChiefComplaint: "Chief Complaint",
              varEncounterDiagnosis: "Diagnosis",
              varGroupDateTime: "Date/Time",
              varGroupEncounter: "Encounter",
              varGroupPatient: "Patient",
              varGroupProvider: "Provider",
              varGroupVitals: "Vitals",
              varPatientAge: "Age",
              varPatientDOB: "DOB",
              varPatientFirstName: "First Name",
              varPatientLastName: "Last Name",
              varPatientSex: "Sex",
              varProviderNPI: "Provider NPI",
              varProviderName: "Provider Name",
              varVitalsBP: "Blood Pressure",
              varVitalsHR: "Heart Rate",
              varVitalsO2: "O2 Sat",
              varVitalsTemp: "Temperature",
              variables: "Variables",
            },
            edit: {
              address: "Practice Address",
              availableNotes: "Available Notes",
              city: "City",
              commission: "Commission",
              credentials: "Credentials",
              dateOfBirth: "Date Of Birth",
              disableOnboarding: "Disable Onboarding",
              email: "Email",
              enableMicrophone: "Enable Microphone",
              enableShareConversation: "Enable Share Conversation",
              enableVoiceRecognition: "Enable Voice Recognition",
              firstName: "First Name",
              lastName: "Last Name",
              location: "Location",
              notInUS: "Not in US",
              npiNumber: "NPI Number",
              npiComplete: "NPI complete",
              npiPlaceholder: "Enter your 10-digit NPI number",
              npiRemaining: "{{remaining}} more to go",
              phone: "Phone",
              practiceState: "Primary Practice State",
              practiceZip: "Practice Zip",
              practiceZipPlaceholder: "Enter your practice zip code",
              ptanNumber: "PTAN Number",
              ptanPlaceholder: "Enter your PTAN Number (optional, 6-10 characters)",
              roles: "Roles",
              selectState: "Select State",
              selectYourState: "Select your state",
              state: "State",
              taxonomyCode: "Taxonomy Code",
              update: "Update",
              userType: "User Type",
              zipCode: "Zip Code",
            },
            ehr: {
              apiUrl: "API URL",
              configureEHR: "Configure EHR",
              description:
                "Select the EHR software where you're copying the notes. The platform will optimize the content based on the selected EHR.",
              ehrSoftware: "EHR Software",
              ehrType: "EHR Type",
              password: "Password",
              saveConfiguration: "Save Configuration",
              testConnection: "Test Connection",
              title: "EHR Integration",
              update: "Update",
              username: "Username",
            },
            errorFetching: "Error fetching profile",
            errorUpdating: "Error updating profile",
            generation: {
              autoAssignToCreator: "Auto Assign To Creator",
              autoGenerateNote: "Auto Generate Note",
              autoLock: "Auto Lock",
              bulletPoints: "Bullet Points",
              complex: "Complex",
              comprehensive: "Comprehensive",
              concise: "Concise",
              generateAfterStop: "Generate After Stop",
              hpi: "HPI",
              length: "Length",
              mdm: "Medical Decision Making",
              paragraph: "Paragraph",
              physicalExam: "Physical Exam",
              planOfCare: "Plan of Care",
              ros: "Review of system",
              selectNoteType: "Select Note Type",
              smartNoteGeneration: "Smart Note Generation",
              style: "Style",
              styleDescription:
                'Select the style and length you prefer for each elements. You can always change them from the "Customize" button on the note.',
              title: "Note Style",
            },
            kpiDashboard: {
              add: "Add",
              addCustom: "Add Custom KPI",
              allNotes: "All",
              assigned: "Assigned",
              assignedKpis: "Assigned KPIs",
              clearAll: "Clear all",
              clinical: "Clinical",
              createCustom: "Create Custom KPI",
              custom: "Custom",
              kpiDefinition: "KPI definition",
              kpiDescLabel: "Description",
              kpiName: "KPI name",
              kpiTitleLabel: "Title",
              noKpis: "No KPIs assigned to this note type",
              noResults: "No KPIs match your search",
              noteTypes: "Note Types",
              removeFromAll: "From all note types",
              removeKpi: "Remove KPI",
              revenue: "Revenue",
              save: "Save",
              saveError: "Failed to save KPI settings",
              saved: "KPI settings saved",
              searchKpis: "Search KPIs...",
              selected: "Selected",
              specialtyLabel: "Specialty",
              subtitle: "Manage key performance indicators across note types",
              title: "KPI Dashboard",
              removeFromSelected: "From selected note type only",
              removeMessage: "Where should this KPI be removed from?",
            },
            labels: {
              effectiveDate: "Effective Date",
              plan: "PLAN",
              printIndividualName: "Print Individual Name",
              printedName: "Printed Name",
              purchaseAgreementAcknowledgment:
                "I have read, understood, and agree to all terms and conditions of this Purchase Agreement.",
              purchaserName: "Purchaser Name",
              taxpayerIdNumber: "Purchaser's Taxpayer I.D. Number",
              trigger: "Trigger",
            },
            codeOrdering: {
              title: "Code Ordering",
              orgDescription:
                "Sets the starting order for everyone in your organization. This is a starting point only, it never prevents a provider from reordering their own notes.",
              orgDefault: "Default for all members",
              saved: "Saved",
              custom: "Custom (build your own)",
              customHelp:
                "Drag the code types into the priority your organization prefers. This sets the starting order; providers can still reorder their own notes.",
              resultPreview: "Result preview",
              vsDefault: "Moved vs. the Fee-for-Service default:",
            },
            menu: {
              advancedTools: "Advanced Tools",
              baa: "BAA",
              billing: "Credentialing",
              credentialedDmes: "Credentialed DMEs",
              customNotes: "Custom Notes",
              codeOrdering: "Code Ordering",
              dmeNotifications: "Order Notifications",
              documentationSettings: "Documentation Settings",
              dotPhrases: "Dot Phrases",
              ehrIntegration: "EHR Integration",
              inboundNotifications: "Inbound Notifications",
              kpiDashboard: "KPI Dashboard",
              manageQCodes: "Manage Q Codes",
              manageSmartSheet: "Manage QA Assistant",
              manageSmartSheetHealcore: "Manage CoreGrid",
              newAccountForm: "New Account Form",
              formEditor: "Form Editor",
              nafAdminOverride: {
                button: "Override (admin)",
                saving: "Enabling…",
                confirm:
                  "This will enable the DME product line for this organization, unlocking the New Account Form and other DME features. Continue?",
                title: "Admin override — enable NAF for this org",
              },
              baaSigned: "Signed BAA",
              termsOfUseSigned: "Signed Terms of Use",
              noteStyle: "Note Style",
              notesSettings: "Notes Settings",
              orgSecurity: "Security Settings",
              organizationInfo: "Organization Info",
              practiceInfo: "Practice Info",
              preferences: "Preferences",
              productLines: "Product Lines",
              profile: "Profile",
              requiredDocuments: "Required Documents",
              security: "Security",
              terminologyLibrary: "Terminology Library",
              icd10Library: "ICD-10 Code Library",
              termsOfUse: "Terms Of Use",
              uberDirect: "Uber Direct",
              refillSettings: "Refill Settings",
              language: "Language",
              shippingAddress: "Shipping address",
              healthProfile: "Health profile",
              manageRefills: "Manage Refills",
              peptideNotifications: "Notification Settings",
              signAchAuthTitle: "Sign ACH Authorization",
              signCreditCardAuthTitle: "Sign Credit Card Authorization",
              signDocumentTitle: "Sign Document",
              signPurchaseAgreementTitle: "Sign Purchase Agreement",
            },
            manageRefills: {
              title: "Manage Refills",
              description:
                "View and manage your active auto-refills here. This area is under construction — for now, place a refill from your peptide dashboard.",
            },
            naf: {
              autosaving: "Changes saved automatically",
              clickToSign: "Click to sign",
              complete: "Complete",
              completedBy: "Completed by {{name}} on {{date}}",
              continueToDocument: "Continue to Document",
              downloadDisabledTip: "Complete every required field and signature before downloading the PDF.",
              doc: {
                pageOneHandled: "Page 1 is filled via the Form view. Review and sign the legal sections below.",
                pagesHandled: "Pages 1–3 are filled via the Form view. Review and sign the legal sections below.",
              },
              downloadPdf: "Download PDF",
              eSignedOn: "E-SIGNED {{date}}",
              electronicallySignedBy: "Electronically signed by {{name}}",
              emptyContent: "This form has no content to display.",
              loadingForm: "Loading form...",
              notConfigured: "A New Account Form has not been configured for your organization yet.",
              pageOf: "Page {{page}} of {{total}}",
              reopen: "Edit",
              sectionsComplete: "sections complete",
              title: "New Account Form",
              view: {
                document: "Document",
                form: "Form",
              },
              contract: {
                back: "Back to contracts",
                submit: "Submit & Sign",
                submitting: "Submitting…",
                signedBanner: "Submitted {{date}}",
              },
            },
            newnote: {
              description: "We added new note templates. Select the ones you want to enable or leave them disabled.",
              errorUpdating: "Unable to update note preferences",
              keepCurrentNotes: "Keep current note selections",
              save: "Save",
              saving: "Saving...",
              selectAllNotes: "Select all notes",
              title: "New Notes Available",
            },
            notes: {
              availableNotes: "Available Notes",
              confirmDelete: "Are you sure you want to delete this note?",
              defaultImportNote: "Default Import Note",
              defaultNewNote: "Default New Note",
              deleteNote: "Delete Note",
              description: "Description",
              doctorType: "Doctor Type",
              editNote: "Edit Note",
              enable: "Enable",
              newNote: "New Note",
              noteType: "Note Type",
              selectAllNotes: "Select All Notes",
              title: "Notes Settings",
              type: "Type",
            },
            notifications: {
              description:
                "Configure email notifications for order status changes. When enabled, the specified email address will receive a notification each time an order reaches the selected status.",
              emailLabel: "Email",
              emailPlaceholder: "Enter email address",
              messageDraft: "A new order has been created and is currently awaiting review in draft.",
              messageNewAttachment:
                "A new attachment has been uploaded to order {{orderId}}. View it in the Attachments tab of the order.",
              messageNewComment:
                "A new comment has been added by the provider to order {{orderId}}. View it in the Comments tab of the order.",
              messageProviderArchive:
                "Order {{orderId}} has been archived by the provider. Status at time of archive: {{orderStatus}}.",
              messageQrDelivery: "A QR code proof of delivery has been completed and signed by the patient.",
              messageStatusUpdate: "An order status has been updated.",
              sectionTitle: "Inbound Notifications",
              statusDraft: 'New Order in "Draft"',
              statusNewAttachment: "New Attachment",
              statusNewComment: "New Comment",
              statusProviderArchive: "Provider Archive",
              statusQrDelivery: "QR Code - Proof of Delivery",
              statusUpdate: "Order Status Update",
              subjectDraft: "New Order in Draft",
              subjectLabel: "Subject",
              subjectNewAttachment: "New Attachment Uploaded",
              subjectNewComment: "New Comment Added",
              subjectProviderArchive: "Order Archived by Provider",
              subjectQrDelivery: "Proof of Delivery Completed",
              subjectStatusUpdate: "Order Status Updated",
              updated: "Notification settings updated",
            },
            orgSecurity: {
              description: "These settings apply to all users in the organization.",
              sectionTitle: "Organization Security Defaults",
              setByOrg: "(Set by organization)",
            },
            pickup: {
              address: "Address",
              city: "City",
              enablePickup: "Enable Local Pickup",
              locationName: "Location Name",
              locationNamePlaceholder: "e.g. Miami Compounding Pharmacy",
              phone: "Phone",
              sectionTitle: "Local Pickup Settings",
              state: "State",
              zip: "Zip",
            },
            pleaseInsertZipcode: "Please insert the zipcode",
            preferences: {
              applicationLanguage: "Application Language",
              arabic: "Arabic",
              cantoneseTraditional: "Cantonese (Traditional)",
              celsius: "Celsius",
              chineseSimplified: "Chinese (Simplified)",
              chineseTraditional: "Chinese (Traditional)",
              cm: "cm",
              dontAskLocation: "Don't ask for Location",
              english: "English",
              englishOnly: "English Only",
              fahrenheit: "Fahrenheit",
              french: "French",
              german: "German",
              heightUnit: "Height Unit",
              hideUnavailableSections: "Hide Unavailable Sections",
              inches: "inches",
              kg: "kg",
              korean: "Korean",
              lbs: "lbs (pounds)",
              multiLanguage: "Multi-Language",
              noteLanguage: "Note Language",
              offlineMode: "Offline Mode",
              offlineModeDescription: "Uses on-device transcription for mobile app. Some medical/technical terms may be missed",
              sendToEHRAsDefault: "Send To EHR As Default",
              spanglish: "English/Spanish (Spanglish)",
              spanish: "Spanish",
              spanishOnly: "Spanish Only",
              temperatureUnit: "Temperature Unit",
              theme: "Appearance",
              themeDark: "Dark",
              themeLight: "Light",
              themeSystem: "System",
              transcriptionLanguage: "Transcription Language",
              weightUnit: "Weight Unit",
            },
            pricing: {
              accountNumber: "Account #",
              achWirePayments: "ACH/Wire Payments",
              bank: "Bank",
              bankAddress: "Bank Address",
              checkPayments: "Check Payments",
              cmsFee: "2026 CMS Fee",
              company: "Company",
              hcpcs: "HCPCS",
              mailTo: "Mail to",
              paymentInstructions: "Payment Instructions",
              pricePerUnit: "Price Per Unit",
              primaryDressings: "Primary Dressings",
              product: "Product",
              routingNumber: "Routing #",
              secondaryDressings: "Secondary Dressings",
              subtitle:
                "Reference pricing for your organization's collagen products. This information is provided for reference only.",
              title: "Products, Pricing & Fee Schedule",
            },
            profileUpdated: "Profile updated",
            psa: {
              notConfigured: "A Product Service Agreement has not been configured for your organization yet.",
            },
            purchaseAgreement: {
              signature: "Signature",
              title: "Purchase Agreement",
            },
            qcodes: {
              actions: "Actions",
              addQCode: "Add Q Code",
              cancel: "Cancel",
              code: "Q Code",
              confirmDelete: "Are you sure you want to delete the Q Code '{{code}}'?",
              deleteQCode: "Delete Q Code",
              editQCode: "Edit Q Code",
              name: "Name",
              price: "Price",
              pricePerSqCm: "Price per square CM",
              productName: "Product Name",
              qCodeAlreadyPresent: "Q Code already present",
              save: "Save",
              title: "Manage your Q Codes",
            },
            requiredFiles: {
              complete: "Complete",
              completion: "Completion",
              completionCount: "{{completed}} of {{total}} required files",
              description:
                "Track and upload required documents for your new account setup. Files marked as required must be completed before your account is fully onboarded.",
              missing: "Missing",
              preview: "Preview",
              remove: "Remove",
              replace: "Replace",
              shippingAddressList: "Shipping Address List",
              shippingAddressListDesc: "All shipping addresses for BAA covered entity",
              signBaaHint: "Sign the BAA via the BAA section in Settings.",
              signPurchaseAgreementHint: "Sign the Purchase Agreement in the Purchase Agreement section.",
              signedBAA: "Signed BAA",
              signedBAADesc: "Business Associate Agreement",
              signedPurchaseAgreement: "Signed Purchase Agreement",
              signedPurchaseAgreementDesc: "Signed Purchase Agreement",
              title: "Required Files",
              upload: "Upload",
              uploaded: "Uploaded",
              uploadedOn: "Uploaded {{date}}",
              voidedCheck: "Voided Check",
              voidedCheckDesc: "Required for ACH authorization",
              w9Form: "W-9 Form",
              w9FormDesc: "Tax identification form",
            },
            security: {
              after15Days: "After 15 days",
              after1Year: "After 1 year",
              after30Days: "After 30 days",
              after5Years: "After 5 years",
              after7Years: "After 7 years",
              autoDeleteLockedNotes: "Automatically delete locked notes after",
              autoDeleteTranscript: "Automatically delete the transcript after signing",
              cancel: "Cancel",
              change: "Change",
              changePassword: "Change Password",
              changePin: "Change PIN",
              changePinTitle: "Change PIN",
              confirmPassword: "Confirm Password",
              confirmPasswordPlaceholder: "Confirm Password",
              currentPassword: "Current Password",
              currentPasswordPlaceholder: "Current Password",
              currentPin: "Current 4-digit PIN",
              disable2FA: "Disable 2FA",
              email: "E-mail",
              enable2FA: "Enable 2FA",
              enterCurrentPassword: "Please enter your current password",
              enterCurrentPasswordPrompt: "Enter your current password to continue.",
              enterCurrentPin: "Please enter your current 4-digit PIN",
              enterCurrentPinPrompt: "Enter your current 4 digit PIN code to continue.",
              enterNewPinPrompt: "Enter the new 4 digit PIN code to lock the encounter and archive it.",
              errorChangingPassword: "Error changing password",
              errorChangingPin: "Error changing PIN",
              errorSendingLoginLink: "Error sending login link",
              errorSendingResetLink: "Error sending reset link",
              forgotPassword: "Forgot Password?",
              forgotPin: "Forgot PIN?",
              hide: "Hide",
              incorrectPassword: "Incorrect password",
              incorrectPin: "Incorrect PIN",
              loginLinkSent: "Login link sent successfully",
              never: "Never",
              newPassword: "New Password",
              newPasswordPlaceholder: "New Password",
              newPin: "New 4-digit PIN",
              no: "No",
              notesInTrash: "Notes in trash bin will be permanently deleted after",
              passwordChangedSuccessfully: "Password changed successfully",
              passwordDoesNotMatch: "Password does not match",
              passwordResetEmailSent: "Password reset email sent. Please check your inbox.",
              passwordUpdated: "Password updated",
              passwordsDoNotMatch: "Passwords do not match",
              pinSetSuccessfully: "PIN set successfully",
              pinUpdated: "Pin updated",
              pleaseVerifyCurrentPin: "Please verify your current PIN first.",
              resetPassword: "Reset Password",
              resetPasswordLinkSent: "Reset Password link sent successfully",
              save: "Save",
              sendLoginCodeBy: "Send login code by",
              sendLoginLink: "Send Login Link",
              sending: "Sending...",
              show: "Show",
              sms: "SMS",
              title: "Security",
              twoFactorAuth: "Two Factor Authentication",
              unableSendPasswordReset: "Unable to send password reset email. Please try again.",
              unableToVerifyPassword: "Unable to verify your password. Please try again.",
              verify: "Verify",
              verifyCurrentPin: "Verify Current PIN",
              verifyPassword: "Verify Password",
              verifyWithPassword: "Verify With Password",
              verifying: "Verifying...",
              yes: "Yes",
            },
            signWithPin: "Sign with PIN",
            signedByOn: "Signed by {{name}} on {{date}}",
            smartsheet: {
              actions: "Actions",
              addColumn: "Add Column",
              cancel: "Cancel",
              columnAlreadyPresent: "Column already present",
              columnName: "Column Name",
              columnType: "Column Type",
              confirmDelete: "Are you sure you want to delete the column '{{id}}'?",
              currency: "Currency",
              date: "Date",
              dateTime: "Date & Time",
              deleteColumn: "Delete Column",
              editColumn: "Edit Column",
              id: "Id",
              label: "Label",
              number: "Number",
              save: "Save",
              text: "Text",
              textarea: "Text Area",
              title: "Manage QA Assistant",
              titleHealcore: "Manage CoreGrid",
              type: "Type",
            },
            terminologyLibrary: {
              actionsColumn: "Actions",
              addTerm: "Add Term",
              addTermToLibrary: "Add Term to {{library}}",
              autoBadge: "Auto",
              brandColumn: "Brand",
              categoryColumn: "Category",
              dateColumn: "Date Added",
              description:
                "Activate medical terminology libraries for spell check. Libraries matching your specialty are auto-selected.",
              lockedGenericHint: "Always on for every provider",
              detailColumn: "Detail",
              duplicateTerm: "This term already exists in the library",
              emptyLibrary:
                "No terms in this library yet. Terms will be added with the spell check library, or you can add custom terms above.",
              expansionColumn: "Expansion",
              filterAbbreviations: "Abbreviations",
              filterAll: "All",
              filterMedications: "Medications",
              genericTitle: "Generic Libraries",
              lib: {
                abbreviations: "Medical Abbreviations",
                allergyImmunology: "Allergy & Immunology",
                anatomy: "Anatomy",
                behavioral: "Behavioral Health",
                cardiology: "Cardiology",
                chiropractic: "Chiropractic",
                dentistry: "Dentistry",
                dermatology: "Dermatology",
                emergencyMedicine: "Emergency Medicine",
                endocrinology: "Endocrinology",
                gastroenterology: "Gastroenterology",
                generalMedical: "General Medical",
                generalSurgery: "General Surgery",
                homeHealth: "Home Health",
                hospitalistMedicine: "Hospitalist Medicine",
                infectiousDiseases: "Infectious Diseases",
                nephrology: "Nephrology",
                neuroOrthoSpine: "Neuro/Ortho Spine",
                neurology: "Neurology",
                obgyn: "OB/GYN",
                oncology: "Medical Oncology",
                orthopedics: "Orthopedics",
                otolaryngology: "Otolaryngology (ENT)",
                painManagement: "Pain Management",
                paramedics: "Paramedics / EMS",
                pediatrics: "Pediatrics",
                peptides: "Peptides",
                pharmacology: "Generic Pharmacology",
                physicalTherapy: "Physical Therapy",
                podiatry: "Podiatry",
                primaryCare: "Primary Care",
                pulmonology: "Pulmonology",
                radiationOncology: "Radiation Oncology",
                rheumatology: "Rheumatology",
                urology: "Urology",
                woundCare: "Wound Care",
              },
              libDesc: {
                abbreviations: "Standard medical abbreviations and acronyms",
                allergyImmunology: "Allergy, immunotherapy, and hypersensitivity terms",
                anatomy: "Anatomical structures and body system terms",
                behavioral: "Psychiatric and behavioral health terminology",
                cardiology: "Cardiac procedures, diagnostics, and pharmacology",
                chiropractic: "Chiropractic adjustments, techniques, and musculoskeletal terms",
                dentistry: "Dental procedures and oral health terms",
                dermatology: "Skin conditions, procedures, and dermatologic agents",
                emergencyMedicine: "Emergency and acute care terminology",
                endocrinology: "Endocrine disorders, hormones, and metabolic terms",
                gastroenterology: "GI procedures, conditions, and diagnostics",
                generalMedical: "Common medical terms used across all specialties",
                generalSurgery: "Surgical procedures and perioperative terms",
                homeHealth: "Home health assessments and care terminology",
                hospitalistMedicine: "Inpatient medicine and hospital care terms",
                infectiousDiseases: "Infectious agents, antimicrobials, and diagnostics",
                nephrology: "Renal conditions, dialysis, and nephrology terms",
                neuroOrthoSpine: "Spine surgery and neuro-orthopedic terms",
                neurology: "Neurological conditions, diagnostics, and procedures",
                obgyn: "Obstetric and gynecological terminology",
                oncology: "Chemotherapy, immunotherapy, targeted therapy, and supportive oncology terms",
                orthopedics: "Musculoskeletal conditions and orthopedic procedures",
                otolaryngology: "ENT conditions, procedures, and diagnostics",
                painManagement: "Pain management procedures and pharmacology",
                paramedics: "EMS, pre-hospital, and paramedic terminology",
                pediatrics: "Pediatric conditions and developmental terms",
                peptides: "Peptide therapies, GLP-1 agonists, and bioactive compounds",
                pharmacology: "Common medications every clinician prescribes",
                physicalTherapy: "Rehabilitation and physical therapy terminology",
                podiatry: "Podiatric conditions and foot/ankle procedures",
                primaryCare: "General practice and primary care terminology",
                pulmonology: "Pulmonary conditions, ventilation, and respiratory terms",
                radiationOncology: "Radiation therapy and oncology terms",
                rheumatology: "Rheumatology, autoimmune, and inflammatory arthritis terms",
                urology: "Urological conditions and procedures",
                woundCare: "Wound care products, assessments, and treatments",
              },
              libraryTerms: "Library Terms",
              noTermsYet: "No terms yet",
              sectionTitle: "Terminology Library",
              specialtyTitle: "Specialty Libraries",
              termColumn: "Term",
              termCount: "{{count}} custom term(s)",
              termLabel: "Term",
              termPlaceholder: "Enter medical term",
              updated: "Terminology library updated",
              saveFailed: "Couldn't save your changes, they have been reverted. Please try again.",
              filter: "Filter",
            },
            icd10Library: {
              sectionTitle: "ICD-10 Code Library",
              description: "Your preferred ICD-10 codes replace the codes LucasAI produces in notes and EHR sync.",
              addCode: "Add Code",
              save: "Save",
              sourceColumn: "Source Code",
              preferredColumn: "Preferred Code",
              preferredDescColumn: "Preferred Description",
              descriptionColumn: "Description",
              enabledColumn: "Enabled",
              actionsColumn: "Actions",
              codeRequired: "A preferred code is required",
              purposeNote:
                "Use this library for code-set maintenance: descriptor updates, annual ICD-10-CM revisions, and equivalent-code migrations. It does not change what is clinically true. Every swap is shown to the clinician on the note with a one-click revert, and the note must support the final code.",
              clinicalSwapConfirm:
                "Swapping {{source}} to {{target}} changes the clinical meaning (a different condition family, or added severity). It will be flagged to clinicians on every note it touches, with a one-click revert, and each patient's documentation must support it. Create this swap?",
              duplicateSource: "Another entry already remaps this source code",
              emptyLibrary: "No custom codes yet. Add one to get started.",
              updated: "ICD-10 library updated",
              seedNote: "Pre-filled with {{count}} codes from your practice's encounters. Click Update to save.",
              loading: "Loading the codes your practice uses…",
              filterPlaceholder: "Filter codes…",
              importError: "Couldn't load your used codes. You can still add codes manually.",
              codeCount: "{{count}} codes",
              showAll: "Show all {{count}} codes",
              unsaved: "Unsaved changes",
              allChapter: "All",
              changedChip: "Changed",
              changedHint: "Show only the codes you swapped, so you can fine-tune or reset them",
              swapHint: "Choose a different code",
              resetAll: "Reset all to standard",
              resetAllHint: "Rebuild the library from your practice's standard indexed codes",
              resetAllConfirm:
                "Replace the whole library with your practice's standard indexed codes? All code swaps will be removed. Nothing is saved until you press Update.",
              resetRowHint: "Reset to the standard code",
              chapters: {
                infectious: "Infectious",
                neoplasms: "Neoplasms",
                blood: "Blood",
                endocrine: "Endocrine & metabolic",
                mental: "Mental health",
                nervous: "Nervous system",
                eye: "Eye",
                ear: "Ear",
                circulatory: "Circulatory",
                respiratory: "Respiratory",
                digestive: "Digestive",
                skin: "Skin",
                musculoskeletal: "Musculoskeletal",
                genitourinary: "Genitourinary",
                pregnancy: "Pregnancy",
                perinatal: "Perinatal",
                congenital: "Congenital",
                symptoms: "Symptoms & findings",
                injury: "Injury & poisoning",
                special: "Special codes",
                external: "External causes",
                zcodes: "Health factors (Z)",
                other: "Other",
              },
            },
            title: "Edit Profile",
            shippingAddress: {
              street: "Street address",
              streetPlaceholder: "123 Main St",
              apt: "Apartment / unit (optional)",
              aptPlaceholder: "Apt 4B",
              city: "City",
              state: "State",
              statePlaceholder: "Select your state",
              zip: "Zip",
              zipPlaceholder: "5-digit ZIP",
            },
            toasts: {
              achAuthorizationSaved: "ACH Authorization saved",
              achAuthorizationSigned: "ACH Authorization signed",
              acknowledgeBeforeSigning: "Please acknowledge the agreement before signing",
              allRequiredFieldsCompleted: "All required fields completed! You can now complete the form.",
              completeFailed: "Failed to complete. Please try again.",
              creditCardAuthorizationSaved: "Credit Card Authorization saved",
              creditCardAuthorizationSigned: "Credit Card Authorization signed",
              emailSubjectRequired: "Email subject is required",
              enterPrintedNameBeforeSigning: "Please enter the printed name before signing",
              fileRemoveFailed: "Failed to remove file",
              fileRemoved: "File removed",
              fileUploadFailed: "Failed to upload file. Please try again.",
              fileUploadedSuccessfully: "{{fileName}} uploaded successfully",
              messageBodyRequired: "Message body is required",
              nafCompletedAndLocked: "New Account Form completed and locked",
              orgInfoUpdateFailed: "Failed to update organization info. Please try again.",
              orgInfoUpdated: "Organization info updated",
              shippingAddressUpdated: "Shipping address updated",
              shippingAddressUpdateFailed: "Couldn't save shipping address",
              pdfExportError: "Error exporting PDF",
              pdfGenerationFailed: "Failed to generate PDF. Please try again.",
              formTemplateUnavailable: "This form's template has not been configured for your organization yet.",
              pleaseCompleteSections: "Please complete: {{sections}}",
              purchaseAgreementSigned: "Purchase Agreement signed",
              saveFailed: "Failed to save. Please try again.",
              signFailed: "Failed to sign. Please try again.",
              signedSuccessfully: "Signed successfully",
              templateCreateFailed: "Failed to create template",
              templateCreated: "Template created",
              templateDeleteFailed: "Failed to delete template",
              templateDeleted: "Template deleted",
              templateNameRequired: "Template name is required",
              templateUpdateFailed: "Failed to update template",
              templateUpdated: "Template updated",
            },
            welcomeMessage: {
              addNew: "Add New",
              content: "Content",
              customMessage: "Custom Message",
              modalTitle: "Welcome Message",
              name: "Name",
              namePlaceholder: "Enter message name",
              noMessages: "No welcome messages configured",
              sectionTitle: "Email Welcome Messages",
              selectTemplate: "Use Template",
            },
            orgInfo: {
              officeCountry: "Office Country",
              officeName: "Office Name",
              legalName: "Legal Name",
              officePhone: "Office Phone",
              officeEmail: "Office Email",
              officeAddress: "Office Address",
              officeCity: "Office City",
              officeState: "Office State",
              officeZip: "Office Zip",
            },
          },
          providerCredentialing: {
            approved: "Approved",
            clickToUpload: "Click to select a file",
            documentRequest: "Action Required",
            documentUploaded: "Document uploaded successfully",
            dragDrop: "or drag and drop",
            messageError: "Failed to send message",
            messageSent: "Message sent",
            noMessages: "No messages yet. The credentialing team will reach out soon.",
            noRequest: "No Credentialing Request",
            noRequestDesc: "You don't have an active credentialing request.",
            pendingReview: "Pending review",
            progress: "Progress",
            replaceDoc: "Replace document",
            status: {
              approved: "Approved",
              awaitingDocuments: "Awaiting Documents",
              pendingReview: "Pending Initial Review",
              processing: "Processing",
            },
            steps: {
              approved: "Approved",
              awaitingDocs: "Please upload required documents",
              documents: "Document Collection",
              inProgress: "Under review...",
              processing: "Processing",
              submitted: "Request Submitted",
            },
            tabs: {
              documents: "Documents",
              messages: "Messages",
            },
            title: "DME Credentialing Status",
            typePlaceholder: "Type a message...",
            uploadDoc: "Upload document",
            uploadError: "Failed to upload document",
            uploadInstructions: "Select a file to upload. Accepted formats: PDF, JPG, PNG",
            uploadNow: "Upload",
            uploaded: "uploaded",
            uploading: "Uploading...",
          },
          qcode: {
            pleaseEnterArea: "Please enter an area",
            pleaseSelectCode: "Please select a code",
          },
          reportCard: {
            errorGenerating: "Error generating report card",
            title: "Report Card for {{section}}",
          },
          admin: {
            templates: {
              title: "Form Editor",
              subtitle: "Edit the New Account Form, legal documents, and pricing schedules your providers see.",
              comingSoon: "Coming soon",
              tabs: {
                naf: "New Account Form",
                legal: "Legal Templates",
                pricing: "Pricing Schedules",
                history: "Versions & Audit",
              },
              legal: {
                baa: "Business Associate Agreement",
                pa: "Purchase Agreement",
                tou: "Terms of Use",
                variantLabel: "Variant:",
                own: "Your organization",
                ownBaa: "Business Associate Agreement (your organization)",
                variant: {
                  lucas: "Lucas Health Corp",
                  own: "Your organization",
                },
                simulating: "Simulating:",
                simulatingActive: "SIMULATING — view only",
                persona: {
                  current: "Current user",
                  lucas: "Lucas admin",
                },
              },
              rte: {
                placeholder: "Start typing your document...",
                heading1: "Heading 1",
                heading2: "Heading 2",
                heading3: "Heading 3",
                bold: "Bold",
                italic: "Italic",
                strike: "Strikethrough",
                bulletList: "Bulleted list",
                orderedList: "Numbered list",
                blockquote: "Quote",
                undo: "Undo",
                redo: "Redo",
              },
              saveDraft: "Save Draft",
              saving: "Saving...",
              publish: "Publish",
              publishing: "Publishing...",
              revert: "Revert",
              restoreDefault: "Restore Lucas default",
              saveBeforePublish: "Save the draft before publishing.",
              alreadyPublished: "This version is already published — make a change to publish again.",
              draftSaved: "Draft saved.",
              published: "Published. New signers will see this version.",
              saveFailed: "Failed to save draft. Please try again.",
              publishFailed: "Failed to publish. Please try again.",
              usingBundledDefault: "Editing an exact copy of your Organization's default — save to create your first version.",
              effectiveFrom: "Effective from {{date}}",
              status: {
                draft: "Draft",
                published: "Published",
                archived: "Archived",
                fallback: "Default",
              },
              readOnly: {
                title: "Read-only preview",
              },
              naf: {
                banner:
                  "Editing the New Account Form schema is the next phase. For now, this is the exact set of fields providers fill out today.",
                sections: "Sections",
                fields: "Fields",
                required: "Required",
                optional: "Optional",
                fieldKey: "Key",
                fieldLabel: "Label",
                fieldType: "Type",
              },
              standalone: {
                toggle: "Standalone packet (renders and prints from this schema alone)",
                supplier: "Supplier identity",
                supplierName: "Company name",
                supplierAddress: "Address",
                supplierEmail: "Billing email",
                newSection: "New Section",
                addSection: "Add section",
                removeSection: "Remove section",
                legalText: "Legal text",
                collapseClause: "Collapse clause",
                expandClause: "Expand clause",
                clauseHeading: "Clause heading",
                addClause: "Add clause group",
                removeClause: "Remove clause group",
                moveClauseUp: "Move clause up",
                moveClauseDown: "Move clause down",
                printedName: "Collect printed name",
                redact: "PDF redaction",
                redactNone: "No redaction",
                redactLast4: "Show last 4 only",
                redactOmit: "Omit from PDF",
                signatures: "Signature blocks",
                signatureLabel: "Signature label",
                addSignature: "Add signature block",
                moveUp: "Move up",
                moveDown: "Move down",
                removeSignature: "Remove signature",
                subtitle: "Section subtitle",
                optionalSection: "Optional section",
                header: "Document header",
                headerTitle: "Header title (e.g. Product Purchase and Services Agreement)",
                headerTag: "Header tag (e.g. Confidential)",
                headerLogo: "Upload logo",
                removeLogo: "Remove logo",
                logoTooLarge: "That image is larger than 2 MB. Please choose a smaller file.",
                logoBadType: "Please choose a PNG or JPEG image.",
                logoReadFailed: "Couldn't read that image. Try again.",
                pricingTable: "Pricing schedule",
                pricingTableHint: "This section renders your published pricing schedule.",
                pricingTableUnconfigured:
                  "No pricing schedule is configured yet — previews and packets will show a notice instead of a table.",
                openPricingEditor: "Open pricing editor",
                introText: "Intro text (before fields)",
                outroText: "Outro text (after fields)",
                downloadPreview: "Download blank preview",
                previewFailed: "Could not generate the preview: {{error}}",
                generatingPreview: "Generating…",
              },
              pricing: {
                banner:
                  "Editing pricing schedules with effective-from scheduling is the next phase after the NAF editor. Per-variant prices are managed today in the Peptides pricing module.",
                tiersHeading: "Pricing Tiers",
                tiersCount: "tiers",
                key: "Key",
                label: "Label",
                description: "Description",
                color: "Color",
              },
              history: {
                loading: "Loading history...",
                emptyTitle: "No saved versions yet",
                emptyBackendOff:
                  "The template backend isn't deployed yet — once it is, every draft and publish will appear here.",
                emptyReady:
                  "Save a draft from any tab to create your first version. Published versions and who changed what will appear here.",
                type: "Template",
                version: "Version",
                status: "Status",
                effective: "Effective",
                updated: "Updated",
                by: "By",
                view: "View",
                immutabilityBanner:
                  "Published versions below are immutable — content, publisher, and timestamp are frozen for audit. Click a row to inspect the diff.",
                detail: {
                  title: "{{type}} · v{{version}}",
                  immutable: "Immutable published record",
                  mutableDraft: "Draft — will be replaced when published",
                  publishedAt: "Published at",
                  publishedBy: "Published by",
                  createdAt: "Created at",
                  createdBy: "Created by",
                  priorVersion: "Compared against",
                  diffHeading: "Changes since v{{prior}}",
                  diffFirst: "First published version — no prior to compare",
                  loading: "Loading content...",
                  loadError: "Could not load this version's content. The template backend may not be deployed yet.",
                  emptyContent: "This version has no content.",
                  bankingMaskNote:
                    "Routing and account numbers are shown as last-4 only — the audit log itself must never leak full credentials.",
                  bankingChangedCount: "{{count}} of {{total}} fields changed since v{{prior}}.",
                  bankingFirstVersion: "First saved banking version — all values shown below are the initial entries.",
                  field: "Field",
                  before: "v{{prior}}",
                  before_first: "Before",
                  after: "v{{version}}",
                  changed: "Changed",
                  unchanged: "Same",
                  sensitiveTitle: "Masked — last 4 only",
                },
              },
              banking: {
                editInformation: "Edit information",
                changeAccount: "Change account info",
                cancelEdit: "Cancel — keep existing banking info",
                cancel: "Cancel",
                close: "Close",
                editingBanner: "You are editing payment credentials. Save and publish to apply.",
                confirmMatches: "Matches",
                pasteBlocked: "Paste is disabled on this field — type each digit to catch errors",
                saved: "Banking draft saved securely. Routing and account numbers are encrypted at rest.",
                savedToast: "Banking info saved (encrypted)",
                publishedToast: "Banking info published",
                activityTitle: "Activity log",
                activitySubtitle:
                  "Every draft and publish is recorded immutably. Click a row to see exactly what changed — sensitive fields stay masked.",
                activityLoading: "Loading activity…",
                activityEmpty: "No versions yet. The first Save Draft will appear here.",
                activityBackendOff: "The template backend isn't reachable. Once it is, every change will appear here.",
              },
            },
            testPractices: {
              menuLabel: "Test practices",
              title: "Test practices",
              intro:
                "Orders from a test practice are left out of the order feed our partner receives. Only mark a practice as a test practice if it is not a real customer.",
              betaWarning: "You are on optimal-beta. Do not mark practices here.",
              loading: "Loading practices…",
              empty: "No practices yet.",
              tryAgain: "Try again",
              errors: {
                noAccess: "You don't have access to this page.",
                notAvailable: "This feature is not available yet on this server.",
              },
              columns: {
                practice: "Practice",
                status: "Status",
                recentOrders: "Orders, last {{days}} days",
                lastChanged: "Last changed",
                action: "Action",
              },
              status: {
                test: "Test practice",
                real: "Real practice",
                mixed: "Partly flagged — fix this",
              },
              unknownCount: "unknown",
              never: "never",
              changedBy: "by {{name}}",
              actions: {
                set: "Mark as test practice",
                clear: "Clear test flag",
              },
              cannotToggle: "This practice cannot be changed from this screen.",
              saving: "Saving…",
              setSuccess: "{{name}} is now a test practice. Its orders will be left out of the partner feed.",
              clearSuccess: "{{name}} is a real practice again. Its orders will be sent to the partner feed.",
              saveError: "Could not change {{name}}. Please try again.",
              clearConfirm: "Orders from {{name}} will be sent to the partner feed again.",
              confirm: {
                title: "Mark {{name}} as a test practice?",
                consequence: "Its orders will no longer be sent to our partner's order feed.",
                placedLead: "This practice placed",
                placedOrders_one: "{{count}} order in the last {{days}} days",
                placedOrders_other: "{{count}} orders in the last {{days}} days",
                countUnknown: "We could not count this practice's recent orders.",
                warning:
                  "A real practice with orders will silently stop shipping. Only continue if you are sure this is not a real customer.",
                yes: "Yes, mark as test practice",
                clearTitle: "Clear the test flag for {{name}}?",
                cancel: "Cancel",
                close: "Close",
              },
            },
          },
          rightSidebar: {
            admin: "Admin",
            adminPortal: "Admin Portal",
            formEditor: "Form Editor",
            aiAgent: "AI Agent",
            aiSupport: "AI Support",
            analytics: "Analytics",
            classicApp: "Classic App",
            comingSoon: "Coming soon",
            demoMode: "Demo Mode",
            devSettings: "Dev Settings",
            dmeCredentialing: "Credentialing",
            dmeDashboard: "DME/Products/Product Dashboard",
            peptideCatalog: "Order Peptides",
            peptideDashboard: "Peptide Dashboard",
            ehrIntegration: "EHR Integration",
            encounters: "Encounters",
            exitDemo: "Exit Demo",
            generationInProgress: "Generation in progress for {{id}}",
            help: "Help",
            codeOrdering: "Code Ordering",
            hideTasks_one: "Hide Task",
            hideTasks_other: "Hide Tasks",
            localRecordings: "Local Recordings",
            locations: "Locations",
            logout: "Logout",
            myPlan: "My Plan",
            notesSettings: "Notes Settings",
            onboarding: "Onboarding",
            onboardingWizardSimulator: "Onboarding Wizard Simulator",
            patientPanel: "Patient Panel",
            peptides: "Peptides",
            preferences: "Preferences",
            profile: "Profile",
            qcodes: "Q Codes",
            refreshApp: "Refresh App",
            requests_one: "{{count}} request",
            requests_other: "{{count}} requests",
            salesDashboard: "Sales Dashboard",
            showTasks_one: "Show Task",
            showTasks_other: "Show Tasks",
            systemHealthCheck: "System Health Check",
            tasks_one: "{{count}} task",
            tasks_other: "{{count}} tasks",
            trainingWizard: "Training Wizard",
            userManagement: "User Management",
            welcome: "Welcome {{lastName}}",
            tasks: "Tasks",
            showTasks: "Show Tasks",
            hideTasks: "Hide Tasks",
            requests: "Requests",
          },
          salesDashboard: {
            accounts: {
              columns: {
                account: "Account / Provider",
                avgPerDay: "Avg/Day",
                avgPerWeek: "Avg/Week",
                delivered: "Delivered",
                onboarded: "Onboarded",
                tier: "Tier",
                totalOrders: "Signed",
                yearPrediction: "1 Year Est.",
              },
              loading: "Loading...",
              noAccountsFound: "No accounts found",
              period: "Period",
              productLine: "Product Line",
              refills: "Refills",
              search: "Search",
              subtitle: "Manage and track your provider accounts and rep performance",
              tier: "Tier",
              title: "Provider Accounts",
              view: "View",
              direct: "Direct",
              indirect: "Indirect",
              showMore: "Show more",
              showingCount: "Showing {{rendered}} of {{matching}} {{line}} accounts",
              showingAll: "Showing all {{matching}} {{line}} accounts",
              lineDme: "DME",
              linePeptide: "Peptide",
            },
            admin: {
              title: "Admin view",
              showInternalAccounts: "Show internal / test accounts",
            },
            audit: {
              tabLabel: "Audit",
              heading: "Sales audit log",
              subtitle: "Append-only record of rep and account moves in your organization. Visible to administrators only.",
              filters: {
                action: "Action",
                actionAll: "All",
                actionRepMove: "Rep moves",
                actionAccountMove: "Account moves",
                actorSearch: "Search actor...",
                subjectSearch: "Search subject...",
                subjectChipPrefix: "Subject:",
                clearSubject: "Clear",
              },
              columns: {
                when: "When",
                actor: "Actor",
                action: "Action",
                subject: "Subject",
                change: "Before → After",
                source: "Source",
              },
              action: {
                repReparent: "Rep moved",
                accountReassign: "Account moved",
              },
              source: {
                wrapper: "Wrapper",
                direct: "Direct API",
              },
              loadMore: "Load more",
              export: "Download CSV",
              exportTruncated: "Showing first 5,000 rows — narrow filters to see more.",
              empty: "No audit events match these filters.",
              error: "Couldn't load audit log.",
              errorNotDeployed: "Audit log is not yet available in this environment.",
              retry: "Retry",
              drawer: {
                actor: "Actor",
                subject: "Subject",
                change: "Change",
                metadata: "Request metadata",
                viewHistory: "Show full history for this subject",
                close: "Close",
              },
            },
            doctorHeading: "Doctor Earnings ({{count}} doc)",
            doctorHeading_other: "Doctor Earnings ({{count}} docs)",
            failedToLoadSupervisors: "Failed to load supervisors",
            fields: {
              daysPerMonth: "Days/Month",
              daysPerScript: "Days/Script",
              numberOfDoctors: "# Doctors",
              reimbursementPerDay: "Reimb/Day",
              repCommissionPer14Days: "Rep Comm (14d)",
              scriptsPerDay: "Scripts/Day",
            },
            media: {
              dropFilesToUpload: "Drop files to upload",
              folderEmpty: "This folder is empty",
              folderName: "Folder name",
              gridView: "Grid view",
              newFolder: "New Folder",
              tableView: "Table view",
              tryDifferentSearch: "Try a different search term",
              uploadHere: "Upload here",
            },
            mobile: {
              actions: {
                generateReport: "Generate Report",
                showInternalAccounts: "Show internal / test accounts",
              },
              filters: {
                searchPlaceholder: "Search providers…",
                searchRepsPlaceholder: "Search reps…",
                clearSearch: "Clear search",
                openFilters: "Open filters",
                filtersLabel: "Filters",
                reset: "Reset",
                productLine: "Product Line",
                peptide: "Peptide",
                view: "View",
                viewAll: "All",
                viewMine: "Mine",
                viewReps: "Reps",
                viewAllReps: "All Reps",
                viewMyTeam: "My Team",
                viewRelationships: "Relationships",
                tier: "Tier",
                tierAll: "All",
                status: "Status",
                statusAll: "All",
                statusActive: "Active",
                statusInactive: "Inactive",
                period: "Period",
                refills: "Refills",
                refillsNeeded: "Needs Refill",
                countAll_one: "{{count}} account",
                countAll_other: "{{count}} accounts",
                countFiltered: "{{filtered}} of {{total}}",
                repsCountAll_one: "{{count}} rep",
                repsCountAll_other: "{{count}} reps",
                repsCountFiltered: "{{filtered}} of {{total}} reps",
              },
              pipelineFilter: {
                title: "Pipeline Filter",
                dateRangeTitle: "Date range",
                done: "Done",
                showAll: "Show all",
                hideAll: "Hide all",
                customRange: "Custom range",
                allStages: "All stages",
                stageCount_one: "1 stage",
                stageCount_other: "{{count}} stages",
                subsetCount: "{{count}} of {{total}} stages",
                chipAriaDate: "Date range: {{label}}",
                chipAriaStatus: "Pipeline filter: {{label}}",
              },
              reps: {
                empty: "No sales representatives match these filters.",
              },
            },
            orderPeptides: "Order Peptides",
            perScript: {
              doctor: "Dr Profit/Script",
              rep: "Rep Comm/Script",
              total: "Script Total",
            },
            performanceChart: {
              activeProviders: "Providers",
              atRiskCommission: "At Risk",
              confirmedCommission: "Confirmed",
              subtitle: "Track your sales metrics over time",
              title: "Performance Over Time",
              totalCommission: "Total Est. Commission",
              totalOrders: "Total Orders",
            },
            placeholders: {
              searchByNameOrEmail: "Search by name or email...",
            },
            providerInfo: {
              dme: "DME",
              title: "Órdenes",
              allOrdersSubmitted: "Todas las órdenes enviadas por clínicas asociadas",
              ordersToManufacturer: "Órdenes para enviar al fabricante ({{manufacturer}})",
              orderCount_one: "{{count}} Orden",
              orderCount_other: "{{count}} Órdenes",
              loading: "Loading...",
              noDmeInfo: "No DME information available",
              noOrders: "No orders",
              noPatientData: "No patient data",
              noPeptideOrders: "No peptide orders",
              noPracticeInfo: "No practice information available",
              noProviderData: "No provider data available",
              noRefillsDue: "No refills due",
              performance: "Performance",
              pipeline: "Pipeline",
              practiceInfo: "Practice Info",
              showAll: "Show all",
              showLess: "Show less",
              docs: {
                signedExternally: "Signed externally — {{name}}, {{date}}",
                signoffSwitchLabel: "Signed outside the system — {{doc}}",
                signoffEnableTitle: "Mark as signed outside the system?",
                signoffEnableBody:
                  "{{doc}} will count as signed for this account and will no longer block it from signing or placing orders. Your name and today's date are recorded.",
                signoffNoteLabel: "Note (optional)",
                signoffConfirm: "Confirm",
                signoffDisableTitle: "Remove the external signature?",
                signoffDisableBody:
                  "{{doc}} will count as unsigned again. If its deadline has passed, this account will be blocked from signing or placing orders until it is signed in the app.",
                signoffErrors: {
                  not_supervisor: "Only manufacturer supervisors can change this.",
                  not_affiliated: "Your organization is not linked to this provider. Nothing was changed.",
                  not_configured: "Your organization isn't set up for this yet. Contact support. Nothing was changed.",
                  invalid_doc: "This document can't be marked as signed outside the system.",
                  contract_not_found: "This contract is no longer on the provider's account. Nothing was changed.",
                  not_contract_author: "Only the manufacturer that sent this contract can change it.",
                  unknown_error: "Couldn't update the document. Please try again.",
                },
              },
            },
            reassign: {
              noMatchingReps: "No matching reps found",
              title: "Reassign Organization",
            },
            referral: {
              copied: "Referral link copied to clipboard",
              copy: "Copy One-Time Link",
              copyError: "Error copying to clipboard",
              copyId: "Copy Referral ID",
              createSubRep: "Create Rep",
              downloadQR: "Download QR Code",
              idCopied: "Referral ID copied to clipboard",
              oneTimeNote: "The link is valid for one-time use and will expire after being used.",
              orgNameAvailable: "Organization name is available",
              orgNameCheckFailed: "Could not verify organization name. Please try again.",
              orgNameLabel: "Organization Name",
              orgNamePlaceholder: "e.g. my-clinic-name",
              orgNameTaken: "This organization name is already taken",
              overrideActive: "This link will be credited to the pasted referral ID",
              overrideLabel: "Generate link for another ID",
              overridePlaceholder: "Paste the other rep's referral ID",
              creditToggle: "This provider was referred by another rep",
              creditHint:
                "Generate the link with another rep's referral code so the new provider is credited to them — useful when a colleague brought the lead but you're setting up the account. Leave off to credit yourself.",
              tabProvider: "Invite Provider",
              tabInvite: "Invite Rep",
              repProductLineLabel: "Product Lines This Rep Can Sell",
              repCreateDescription:
                "Add a rep to your team. They'll get an email to finish setting up their account and are linked to you automatically.",
              repFirstName: "First Name",
              repLastName: "Last Name",
              repEmail: "Email",
              repFirstNamePlaceholder: "e.g. Jordan",
              repLastNamePlaceholder: "e.g. Reyes",
              repEmailPlaceholder: "rep@example.com",
              repCreating: "Creating…",
              repCreated: "Rep invited — they'll get an email to finish setting up their account.",
              repCreateFailed: "Couldn't create the rep. Please try again.",
              repNameRequired: "Enter the rep's first and last name.",
              repEmailInvalid: "Enter a valid email for the rep.",
              pricingTierRequired: "Pick a pricing tier for this rep.",
              splitPercentRequired: "Enter a split % greater than 0, or choose Delta.",
              noCapabilityShort: "You have no product line to grant — contact a supervisor.",
              repAdvanced: "Need commission or advanced settings? Open the full form",
              pricingTierLabel: "Pricing Tier",
              pricingTierPlaceholder: "Select a pricing tier",
              pricingTierHint: "Required when Peptides is selected",
              tierRetailHint: "Public pricing — no wholesale discount on this account.",
              pricingTierNoGrantable:
                "Your pricing tier doesn't allow granting any peptide tier. Contact a supervisor to adjust your ceiling.",
              productLineAccess: "Product Line Access",
              productLineDme: "DME Collagen",
              productLinePeptides: "Peptides",
              productLineBoth: "Both",
              productLineBothFull: "DME Collagen + Peptides",
              productLineSummaryReferral: "This link grants {{lines}} access.",
              productLineSummaryCapability: "This rep can sell {{lines}}.",
              productLineHintBoth: "At least one product line must be selected",
              noCapability:
                "You have no product-line capability to grant. Contact a supervisor to set up your product lines, or check that your org has at least one product line enabled.",
              providerTitle: "Provider Referral Link",
              qrDownloadFailed: "Failed to download QR code",
              resetOverride: "Reset to your ID",
              subRepTitle: "Invite Rep",
              title: "Referral Link",
              yourId: "Your Referral ID",
              copyFor: "Copy referral link for",
              copyDisabledOrgName: "Name the organization to unlock this link.",
              copyDisabledTier: "Pick a pricing tier to unlock this link.",
              copyDisabledCapability: "No product-line capability to grant — contact a supervisor.",
            },
            repCommission: {
              dmeLabel: "Collagen Commission",
              dmeLesserHint: "Rep earns the lesser of the flat $ or the % each order — both always apply.",
              peptideLabel: "Peptide Commission",
              peptideDelta: "Delta (full margin)",
              peptideSplit: "Split",
              percentOfDelta: "% of delta",
              deltaHint: "Rep keeps the full price gap between their tier and the provider's tier.",
              splitHint: "Rep keeps this % of the tier price gap; the manufacturer keeps the rest.",
            },
            relationshipTree: {
              editInvitedBy: "Edit who invited this rep",
              legendAccount: "Account ({{n}})",
              legendRep: "Rep ({{n}})",
              legendSupervisor: "Supervisor ({{n}})",
              noReps: "No reps in your tree",
              reassignToAnotherRep: "Reassign to another rep",
              scopeMyTeam: "Your Team",
              scopeAllAccounts: "All Accounts",
              scopeLabel: "Scope",
              title: "Relationship Tree",
            },
            repDrawer: {
              copyEmail: "Copy email",
            },
            repHeading: "Rep Commission ({{count}} doc)",
            repHeading_other: "Rep Commission ({{count}} docs)",
            reports: {
              allOrganizations: "All Organizations",
              backToDashboard: "Back to Dashboard",
              cancel: "Cancel",
              chooser: {
                title: "Generate Report",
                subhead: "Which report do you need today?",
                choose: "Choose",
                manufacturer: {
                  title: "Manufacturer Performance",
                  desc: "Orders, pipeline, commissions, and forecasts for your sales team.",
                },
                lucas: {
                  title: "Lucas Revenue Invoice",
                  desc: "Processing fee owed on delivered orders for the selected period.",
                },
              },
              close: "Close",
              configureReport: "Configure Report",
              deselectAll: "Deselect All",
              downloadCSV: "Download CSV",
              downloadPDF: "Download PDF",
              exportFormat: "Export Format",
              formatCSV: "CSV",
              formatPDF: "PDF",
              generateReport: "Generate Report",
              generated: "Generated",
              generating: "Generating...",
              includeSections: "Include Sections",
              lucasInvoice: {
                title: "Lucas Revenue Invoice",
                subhead: "Select a month, quarter, or custom range to compute the amount due to Lucas AI.",
                period: "Period",
                months: "Months",
                currentMonthTooltip: "In progress — totals will close at month end.",
                earliestRecord: "Earliest record: {{date}}",
                lastQuarter: "Last Quarter",
                thisQuarter: "This Quarter",
                ytd: "Year to Date",
                custom: "Custom",
                other: "Other",
                organization: "Organization",
                exportFormat: "Export Format",
                feeRate: {
                  label: "Commission rate",
                  otherPlaceholder: "Other",
                  otherAria: "Custom commission rate percentage",
                  helper: "Percentage charged on gross billed revenue.",
                },
                generatePdf: "Generate Invoice PDF",
                generateCsv: "Generate Invoice CSV",
                generationFailed: "Could not generate the invoice. Please try again.",
                empty: "No delivered products in this period.",
                excludeInternal: {
                  label: "Exclude Lucas Health internal orders",
                  helper_zero: "No internal orgs detected — toggle has no effect.",
                  helper_one: "Hides orders for orgs that look internal (currently 1 org excluded).",
                  helper_other: "Hides orders for orgs that look internal (currently {{count}} orgs excluded).",
                  helperWithNames_one: "Matches 1 internal org: {{names}}.",
                  helperWithNames_other: "Matches {{count}} internal orgs: {{names}}.",
                },
                summary: {
                  organizations: "Organizations",
                  deliveredProducts: "Delivered products",
                  grossBilled: "Total billed",
                  manualReview_one: "Line needing manual review (excluded)",
                  manualReview_other: "Lines needing manual review (excluded)",
                  amountDue: "Due to Lucas AI",
                },
              },
              metrics: {
                atRisk: "Revenue Needing Attention",
                confirmedRevenue: "Confirmed Revenue",
                deliveredOrders: "Delivered Orders",
                momGrowth: "MoM Growth",
                pipelineHealth: "Pipeline Health",
                totalEstRevenue: "Total Est. Revenue",
                totalOrders: "Total Orders",
                trend: "Trend",
              },
              noPHINote: "This report contains no patient health information (PHI). All data is aggregated and anonymized.",
              organization: "Organization",
              print: "Print",
              reportTitle: "Sales Performance Report",
              sections: {
                commissions: "Commission & Financial Analysis",
                executive: "Executive Summary",
                forecast: "Forecast & Predictions",
                kpis: "Key Performance Indicators",
                pipeline: "Order Pipeline Analysis",
                providers: "Provider / Account Performance",
                revenue: "Revenue Overview",
                salesReps: "Sales Rep Performance",
              },
              selectAll: "Select All",
              selectAtLeastOne: "Please select at least one section.",
              timePeriod: "Time Period",
            },
            reps: {
              accounts: "Accounts",
              commission: "Commission",
              delivered: "Delivered",
              loadError: "Couldn't load your team.",
              loadErrorNotDeployed: "Your team list is not yet available in this environment.",
              loading: "Loading...",
              noRepsFound: "No reps found",
              orders: "Orders",
              period: "Period",
              search: "Search",
              status: "Status",
              tier: "Tier",
              tierValue: "Tier {{tier}}",
              view: "View",
            },
            subtitle: "Estimate your commission and distributor revenue per order.",
            summary: {
              monthly: "Monthly",
              yearly: "Yearly",
            },
            title: "Sales Dashboard",
            toasts: {
              accountAlreadyAssigned: "Account is already assigned to this rep",
              accountReassignedTo: "Account reassigned to {{name}}",
              cannotMoveRepUnderSubRep: "Cannot move a rep under their own sub-rep",
              copiedToClipboard: "Copied to clipboard",
              emailCopied: "Email copied to clipboard",
              failedToCopy: "Failed to copy",
              failedToCopyEmail: "Failed to copy email",
              failedToLoadMediaFile: "Couldn't load file. Please try again.",
              failedToMoveRep: "Failed to move rep",
              failedToReassignAccount: "Failed to reassign account",
              failedToReassignOrganization: "Failed to reassign organization",
              failedToSaveUploads: "Failed to save uploads. Please try again.",
              failedToUpdateInvitedBy: "Failed to update Invited By",
              invitedByUpdated: "Invited By updated successfully",
              organizationReassignedTo: "Organization reassigned to {{name}}",
              partialUpdateBothReps: "Partial update: account may be assigned to both reps. Please fix manually.",
              pleaseSelectUserToReassign: "Please select a user to reassign to",
              repMovedUnder: "{{name}} moved under {{target}}",
              selectedUserNoLongerAvailable: "Selected user is no longer available",
            },
            viewMode: {
              both: "Both",
              doctor: "Doctor",
              rep: "Rep",
            },
            datePicker: {
              today: "Today",
              yesterday: "Yesterday",
              last7days: "Last 7 Days",
              last30days: "Last 30 Days",
              thisMonth: "This Month",
              thisQuarter: "This Quarter",
              ytd: "Year to Date",
              last12months: "Last 12 Months",
              custom: "Custom Range",
              update: "Update",
              cancel: "Cancel",
              selectDates: "Select dates",
              presets: "Date presets",
              prevMonth: "Previous month",
              nextMonth: "Next month",
            },
            commissions: {
              copyValue: "Copy {{value}}",
              heading: {
                simulation: "Simulation",
                profile: "My",
              },
              productLine: {
                dme: "DME",
                peptide: "Peptide",
              },
              peptide: {
                heading: "Peptide",
                titleSupervisor: "Peptide Revenue Calculator",
                titleRep: "Peptide Commission Calculator",
                simulator: {
                  productMixTitle: "Product Mix",
                  pricingTitle: "Pricing",
                  wholesaleTier: "Wholesale Tier",
                  unitsPerOrder: "Units / Order",
                  commissionTitle: "Commission Settings",
                  commissionTypeLabel: "Commission Type",
                  flatPerOrder: "Flat Commission per Order",
                  commissionPercent: "Commission % of Manufacturer Revenue",
                  volumeTitle: "Volume Projections",
                  inputMode: "Input Mode",
                  perDay: "Per Day",
                  perMonth: "Per Month",
                  ordersPerDay: "Orders per Day",
                  ordersPerMonth: "Orders per Month",
                  workingDays: "Working Days per Month",
                  recurringRate: "Recurring Rate %",
                  providers: "Providers / Patients",
                  providerSingular: "provider",
                  providerPlural: "providers",
                  flowTitle: "Money Flow (Per Order)",
                  flowTitleSupervisor: "Revenue Flow (Per Order)",
                  perOrderTitle: "Per Order Breakdown",
                  units: "Units",
                  patientPays: "Patient Pays",
                  manufacturer: "Manufacturer",
                  providerProfit: "Provider Profit",
                  rep: "Rep",
                  manufacturerRevenue: "Manufacturer Revenue",
                  netRevenue: "Net Revenue (after rep costs)",
                  netManufacturer: "Net Manufacturer Revenue (after rep costs)",
                  providerEarnings: "Provider Earnings",
                  repCommission: "Rep Commission",
                  repCommissionCost: "Rep Commission Cost",
                  ofMfrRevenue: "of Manufacturer Revenue",
                  repCostNote: "rep cost",
                  monthly: "Monthly",
                  yearly: "Yearly",
                  ordersPerMonthSuffix: "{{count}} orders/month",
                  recurringIncl: "(incl. +{{pct}}% recurring)",
                  wholesaleAtTier: "wholesale at tier {{tier}}",
                  repCostsDetailBasis: "Rep costs: {{amount}}/month ({{basis}})",
                  commissionHidden: "Commission details hidden",
                  commissionDetailFlat: "{{amount}} flat fee per delivered order",
                  commissionDetailLesser: "Lesser of {{amount}} flat / {{pct}}% of manufacturer revenue",
                  commissionDetailPercent: "{{pct}}% of manufacturer revenue per order",
                  hideCommission: "Hide commission values",
                  showCommission: "Show commission values",
                  revealCommission: "Reveal commission",
                  patientPaysContext: "Patient pays {{amount}} retail per order",
                  avgRetail: "Avg Retail (Patient)",
                  avgWholesale: "Avg Wholesale (Provider)",
                  retailShort: "retail",
                  wholesaleShort: "wholesale",
                  reset: "Reset",
                  unlock: "Unlock {{label}}",
                  mixWarning: "Mix must equal 100%",
                  tierOption: {
                    A: "Tier A (40%)",
                    B: "Tier B (45%)",
                    C: "Tier C (50%)",
                    D: "Tier D (55%)",
                  },
                  commissionType: {
                    flat: "Flat Fee",
                    percent: "Percentage",
                    lesser: "Lesser of",
                  },
                  category: {
                    glp: { label: "GLP", description: "Weight Loss", examples: "Tirzepatide, Semaglutide" },
                    recovery: { label: "Recovery", description: "Healing & Performance", examples: "BPC-157, TB-500" },
                    hormone: { label: "Hormone", description: "Anti-Aging & Growth", examples: "CJC-1295, Ipamorelin" },
                  },
                  flow: {
                    patient: "Patient Pays",
                    retail: "Retail",
                    manufacturer: "Manufacturer",
                    wholesale: "{{pct}}% wholesale",
                    wholesaleOfRetail: "{{pct}}% wholesale of retail",
                    provider: "Provider",
                    markup: "{{pct}}% markup",
                    rep: "Rep Commission",
                    perOrder: "Per Order",
                  },
                  disclaimer: {
                    important: "IMPORTANT",
                    title: "Peptide Commission Estimates",
                    requirementsLead: "Commission is paid when ALL conditions are met:",
                    requirements: {
                      0: "Order is DELIVERED to the patient",
                      1: "Payment captured successfully (card or Zelle receipt cleared)",
                      2: "Order is not refunded or cancelled post-delivery",
                      3: "Recurring orders renew commission only when each refill is paid & delivered",
                    },
                    pricingLead: "About Pricing:",
                    estimates: {
                      0: "Retail rates shown are representative MSRP — actual prices vary by variant and market",
                      1: "Wholesale tier (A–D) determines what the provider pays the manufacturer",
                      2: "Tier margins are illustrative; your contracted tier may differ",
                      3: "Recurring-rate boost is a planning multiplier, not a retention guarantee",
                    },
                    structureLead: "Commission Structure:",
                    commission: {
                      0: "Your commission rate is set at account creation",
                      1: "Flat-fee or %-of-manufacturer-revenue, per delivered order",
                      2: "Commission amounts shown are ESTIMATES, not guarantees",
                      3: "Lucas Health may modify terms at any time to remain compliant",
                    },
                  },
                },
                productMixTitle: "Top Peptide Variants",
                productMixHeader: "Items by Variant",
                productMixTotal: "{{count}} items delivered",
                productMixEmpty: "No delivered orders in the selected period.",
                productMixNoItems: "Delivered orders have no itemized variants in this period.",
                unitsLabel: "units",
                snapshotTitle: "Patient & Operations",
                snapshot: {
                  activePatients: "Active Patients",
                  avgOrderValue: "Avg Order Value",
                  recurring: "Recurring Rate",
                  fulfillment: "Avg Fulfillment",
                },
                activityTitle: "Activity",
                activity: {
                  delivered: "Delivered Orders",
                  pipeline: "Pipeline Orders",
                },
                summary: {
                  deliveredTitle: "Total Peptide Revenue",
                  deliveredDetail_one: "{{count}} order delivered",
                  deliveredDetail_other: "{{count}} orders delivered",
                  pipelineTitle: "Pipeline Revenue",
                  pipelineDetail_one: "{{count}} order in flight",
                  pipelineDetail_other: "{{count}} orders in flight",
                  attentionTitle: "Needs Attention",
                  attentionDetail_one: "{{count}} order needs action",
                  attentionDetail_other: "{{count}} orders need action",
                },
                empty: {
                  title: "No peptide orders yet",
                  subtitle: "Peptide revenue metrics will appear here once your first orders are delivered.",
                },
              },
            },
            providerDrawer: {
              peptidePricing: {
                heading: "Peptide Pricing",
                currentTierLabel: "Current tier",
                notSet: "Not set",
                changeTierLabel: "Change tier",
                saveButton: "Save",
                saving: "Saving…",
                cancelButton: "Cancel",
                saved: "Pricing tier updated",
                saveFailed: "Could not update pricing tier. Please try again.",
                readOnlyHint: "Sub-rep accounts can only be edited by the assigned rep or a supervisor.",
                lockedByManufacturerSuffix: "(current — locked by manufacturer)",
                noCustomPricesSet: "No custom prices set.",
              },
              productRestrictions: {
                heading: "DME Products",
                help: "Uncheck a product to stop this account from ordering it. Changes apply to new submissions; the account's order form updates on its next open.",
                loading: "Loading products…",
                loadError: "Could not load product settings for this account.",
                primaryGroup: "Primary dressings",
                secondaryGroup: "Secondary dressings",
                save: "Save",
                saving: "Saving…",
                saved: "Product settings saved",
                savedNotSynced: "Saved. The account's order form will update on the next successful sync — save again to retry.",
                saveError: "Could not save product settings. Please try again.",
                updatedBy: "Updated {{date}} by {{name}}",
                lastPushFailed: "The last sync to the account did not go through. Save again to retry.",
              },
            },
          },
          sidebar: {
            loadMore: "Load More",
            newChat: "New Encounter",
            noEnc: "No encounters found",
            search: "Search",
            searchMeta: {
              interpretedAs: "Searching:",
              chipName: 'Name "{{value}}"',
              chipDob: "DOB {{value}}",
              chipYear: "Year {{value}}",
              chipId: "MRN/FIN {{value}}",
              results: "{{count}} results",
              resultsOne: "{{count}} result",
              noResults: 'No matches for "{{term}}"',
              tipName: "Search by last name only",
              tipDob: "Check the date format (MM/DD/YYYY)",
              tipId: "Search by MRN or FIN",
              clear: "Clear search",
            },
          },
          spellCheck: {
            acceptAll: "Accept All",
            didYouMean: "Did you mean...",
            reviewMode: {
              exit: "Exit Review",
              fixed: "Fixed → {{word}}",
              fixedCount: "fixed",
              keyboardHint: "Tab: next · Space: skip · Enter: fix · Ctrl+Z: undo",
              noIssues: "No spelling issues found",
              occurrences: "({{count}})",
              progress: "{{reviewed}} of {{total}} reviewed",
              skip: "Skip",
              skipped: "Skipped",
              styleSectionTitle: "Style suggestions",
              styleHint: "Not errors, just style differences",
              styleTag: "style",
              title: "Spell Check Review",
              undo: "Undo",
              undoLast: "Undo Last",
            },
          },
          tableView: {
            colors: {
              blue: "Blue",
              green: "Green",
              orange: "Orange",
              pink: "Pink",
              purple: "Purple",
              red: "Red",
              yellow: "Yellow",
            },
            columns: {
              additionalClaimInformation: "Additional Claim Information",
              age: "Age",
              allergies: "Allergies",
              amountOutstanding: "Amount Outstanding",
              appealDeadline: "Appeal Deadline",
              appealLevel: "Appeal Level",
              attachments: "Attachments",
              authRemainedUnits: "Auth Remained Units",
              billedUnitsUsed: "Billed Units Used",
              billedUnitsWasted: "Billed Units Wasted",
              claimNumber: "Claim Number",
              cptLevelII: "CPT Level II",
              createdOn: "Created On",
              currentMedications: "Current Medications",
              dateAppealSent: "Date Appeal Sent",
              dateOfCurrentIllnessInjury: "Date of Current Illness/Injury",
              datesUnableToWorkFrom: "Dates Unable to Work From",
              datesUnableToWorkTo: "Dates Unable to Work To",
              denialReason: "Denial Reason",
              diagnosisCodesICD10: "Diagnosis codes ICD10",
              diagnostics: "Diagnostics",
              dob: "DOB",
              edit: "Edit",
              eftNumber: "EFT Number",
              encounterType: "Encounter Type",
              eobAttached: "EOB Attached",
              familyHistory: "Family History",
              finalStatusNote: "Final Status Note",
              gender: "Gender",
              groupNumber: "Group Number",
              hcfa1500: "1500",
              hospitalizationFrom: "Hospitalization From",
              hospitalizationTo: "Hospitalization To",
              hpi: "HPI",
              id: "ID",
              insuranceCarrier: "Insurance Carrier",
              insuredCity: "Insured City",
              insuredDob: "Insured DOB",
              insuredName: "Insured Name",
              insuredState: "Insured State",
              insuredStreetAddress: "Insured Street Address",
              insuredZip: "Insured Zip",
              invoiceAmount: "Invoice Amount",
              invoiceAmountPaid: "Invoice Amount Paid",
              invoiceNumber: "Invoice Number",
              lastUpdate: "Last Update",
              mdm: "MDM",
              medicaidOtherResubmissionCode: "Medicaid/Other Resubmission Code",
              miscCharge: "Misc Charge",
              netAmount: "Net Amount",
              nonBillableInjections: "Non-Billable Injections",
              noteReviewed: "Note Reviewed",
              noteStatus: "Note Status",
              officeAddress: "Office Address",
              officeProcedures: "Office Procedures",
              officeState: "Office State",
              officeZip: "Office Zip",
              originalReferenceNumber: "Original Reference Number",
              otherInsured: "Other Insured",
              otherInsuredPlanName: "Other Insured Plan Name",
              otherInsuredPolicyGroup: "Other Insured Policy Group",
              outsideLabCharges: "Outside Lab Charges ($)",
              pastMedicalHistory: "Past Medical History",
              pastSurgeries: "Past Surgeries",
              patientFirstName: "Patient First Name",
              patientLastName: "Patient Last Name",
              paymentDate: "Payment Date",
              percentImprovement: "% Improvement",
              physicalExams: "Physical Exams",
              planOfCare: "Plan Of Care",
              policyNumber: "Policy Number",
              previousTreatments: "Previous Treatments",
              priorAuthorizationNumber: "Prior Authorization Number",
              productApplicationDateOfService: "Product Application Date of Service",
              productPrice: "Product Price",
              projectAdjudicationDate: "Project Adjudication Date",
              provider: "Provider",
              resolution: "Resolution",
              reviewed: "Reviewed",
              ros: "ROS",
              similarIllnessDate: "Similar Illness Date",
              socialHistory: "Social History",
              sponsorInfo: "Sponsor Info",
              statusActionDate: "Status Action Date",
              totalAreaWithDepth: "Total Area w/ Depth",
              totalSurfaceArea: "Total Surface Area",
              totalWounds: "Total Wounds",
              trackingNumber: "Tracking Number",
              uploadedTotalLabs: "Uploaded Total Labs",
              verificationFinalStatus: "Verification Final Status",
              verificationNotes: "Verification Notes",
              verificationStatus: "Verification Status",
              viewEdit: "View / Edit",
              visitTime: "Visit Time",
              woundClassification: "Wound Classification",
              woundImagesAvailable: "Are there images of the wound",
              woundProductCode: "Wound Product Code",
              woundSiteLocation: "Wound Site Location",
            },
            deleted: "Deleted",
            draft: "Draft",
            edit: {
              addComment: "Add comment",
              addCommentButton: "Add Comment",
              changes: "Changes",
              close: "Close",
              customizeDescription: "Customize the table by enabling and disabling the columns to show",
              requestChange: "Request Change",
              reset: "Reset",
              tabComments: "Comments",
              tabEdit: "Edit",
              tabRequestHistory: "Request History",
              transcripting: "Transcripting...",
              update: "Update",
            },
            editTableView: "Edit Table View",
            filter: "Filter",
            generated: "Generated",
            group: "Group",
            icd10: {
              addCode: "Add Code",
            },
            insurance: "Insurance",
            loadMore: "Load more...",
            loading: "Loading...",
            loadingMore: "Loading more...",
            locked: "Locked",
            myPatients: "My Patients",
            noEncountersFound: "No encounters found.",
            options: {
              assistedLiving: "Assisted Living",
              clinicalToComplete: "Clinical to complete",
              clinicalToWork: "Clinical to work",
              down: "Down",
              home: "Home",
              notAssigned: "Not assigned",
              noteTypeNotFound: "note type not found",
              nursingHome: "Nursing Home",
              office: "Office",
              skilledNursingFacility: "Skilled Nursing Facility",
              unavailable: "Unavailable",
              yes: "Yes",
            },
            pdf: {
              download: "Download",
              editPdf: "1500 Form",
            },
            search: "Search",
            status: "Status",
            statuses: {
              acceptedForProcessing: "Accepted for Processing",
              aiGenerated: "AI Generated",
              appealCheckWithOffice: "Appeal – Check with Office",
              orderComplete: "Order complete — delivered to the clinic.",
              appealNeeded: "Appeal Needed",
              appealOverturned: "Appeal Overturned",
              appealSent: "Appeal Sent",
              billed: "Billed",
              billedCorrectedClaim: "Billed Corrected Claim",
              billingFollowUp: "Billing Follow up",
              billingQuestion: "Billing Question",
              buyAndBill: "Buy and Bill",
              canceled: "Canceled",
              claimNotShowing: "Claim not showing",
              confirmIfOfficeWantsHelp: "Confirm if office wants help",
              correctedClaimNeeded: "Corrected Claim Needed",
              denialUpheld: "Denial upheld",
              denied: "Denied",
              disapproved: "Disapproved",
              disapprovedCOB: "Disapproved COB",
              disapprovedCoverageTermed: "Disapproved Coverage Termed",
              disapprovedMedRecs: "Disapproved Med Recs",
              disapprovedMedicalNecessity: "Disapproved Medical Necessity",
              disapprovedNDC: "Disapproved NDC",
              disapprovedNotCovered: "Disapproved Not Covered",
              draft: "Draft",
              experimentalInvestigationalReview:
                "Experimental and/or investigational – reviewing to determine if denial is upheld or can be appealed",
              followUpCall: "Follow Up Call",
              hospiceModifiersMissing: "Hospice Modifiers Missing / Other Hospice Issue",
              incorrectPay: "Incorrect Pay",
              incorrectQCodeBilled: "Incorrect Q Code billed",
              insPartialPayment: "INS Partial Payment",
              insuranceChanged: "Insurance Changed",
              invoicePaidToHTP: "Invoice Paid to HTP",
              invoicePaidToIWC: "Invoice Paid to IWC",
              invoiceReceivedPartialPayment: "Invoice – Received Partial Payment",
              invoiceRequested: "Invoice Requested",
              lowPay: "Low Pay",
              lowPayOfficeSentBack: "Low Pay – Office Sent Back",
              medRecsAdditionalInfoSent: "Med Recs/Additional Info sent",
              medicalRecordsAudit: "Medical Records Audit",
              newInsuranceCarriersPolicyNotFollowed: "New Insurance Carrier's policy not followed",
              noAppealPayorPaid1Of2: "No Appeal – Payor paid 1 of the 2 products",
              noteNotComplete: "Note not complete",
              noteReviewedNoNote: "No note - need review when note is recieved",
              noteReviewedPerMgmt: "No - Per mgmt no note needed for this DOS",
              noteReviewedPreviouslyReviewed: "No - Note was previously reviewed for last visit",
              noteReviewedProviderApplication: "Yes - Provider sent note after application",
              noteReviewedProviderOrder: "Yes - Provider sent note after order",
              noteReviewedRequested: "Requested note to complete verification",
              noteReviewedYes: "Yes",
              officeAppealedWithoutAhmHelp: "Office Appealed w/o AHM Help",
              officeBilled: "Office Billed",
              officeDidNotFollowSampleHCFA: "Office did not follow sample HCFA",
              officeNotifiedToTakeAction: "Office notified to take action",
              overpayment: "Overpayment",
              paid: "Paid",
              paidAppliedToDeductible: "Paid applied to deductible",
              paidIncorrectlySeeResolution: "Paid Incorrectly – See Resolution Column for details",
              paidRecoupInProcess: "Paid Recoup in Process",
              partAAtTOS: "Part A at TOS",
              paymentAppliedToRecoup: "Payment applied to a recoup",
              paymentReapplied: "Payment Reapplied",
              perOfficeHandleInternally: "Per office they will handle internally",
              providerOonNoPayableBenefits: "Provider is OON with no payable benefits",
              rejectedNeverReceivedByCarrier: "Rejected as never received by carrier",
              reopeningDone: "Reopening Done",
              reopeningNeeded: "Reopening Needed",
              reprocessing: "Reprocessing",
              requestingRecordsAdditionalInformation: "Requesting Records/Additional Information",
              requiredLoopSegmentDetailMissing: "Required Loop/Segment Detail missing",
              signed: "Signed",
              specialWorkflow: "Special Workflow",
              twoProductsTwoSuppliersSameDay: "2 Products / 2 Suppliers Same Day",
              unableToObtainBillableInfo: "Unable to obtain billable information from office",
              unableToOverturn: "Unable to overturn",
              unbillable: "Unbillable",
            },
            team: "Team",
            toasts: {
              failedUnlockForm: "Failed to unlock 1500 form",
              failedUpdateReviewStatus: "Failed to update review status",
              formCleared: "1500 Form marked as reviewed and cleared",
              formIncompleteNoteAdded: "1500 Form marked as incomplete. Note added to Conversation.",
              formIncompleteOrderRejected: "1500 Form marked as incomplete. Order moved to Additional Info Needed.",
              formUnlocked: "1500 Form unlocked for editing",
              noOutputGenerated: "No output generated",
              trackingCopied: "Tracking number copied to clipboard",
            },
            verificationStatuses: {
              appealAuthInProcess: "appeal of auth in process",
              authExtensionRequested: "auth extension requested",
              authPredetermCompleted: "auth/predeterm completed",
              authPredetermInProcess: "auth/predeterm in process",
              authPredetermNeeded: "auth/predeterm needed",
              boxSaleOnly: "box sale only",
              compliancyReviewUnable: "compliancy review - unable to complete",
              foundNoVerification: "found - no verification done",
              graftNoLongerNeeded: "graft no longer needed",
              insuranceRequestedInfo: "insurance requested additional information",
              lessThan100DaysNF: "less than 100 consequetive day in NF/SNF",
              managementApprovedDoctorAware: "management approved -  doctor aware of needed information",
              ninetyDaysConservativeCare: "90 days of conservative care needed",
              pendingInfo: "Pending additional information",
              selectAll: "Select ALL",
              shipPerManagement: "ship per management",
              specialWorkflowNoDoc: "special workflow - no document for review",
              thirtyDaysConservativeCare: "30 days of conservative care needed",
              verification: "verification",
              verificationCompleted: "verification completed",
              verificationInProcess: "verification in process",
              woundInfectedFollowUp: "wound infected - fu in 2/3 weeks to see if",
            },
            woundClassifications: {
              arterial: "Arterial",
              dfu: "DFU",
              nonPressure: "Non Presure",
              other: "Other",
              pressure: "Pressure",
              surgical: "Surgical",
              trauma: "Trauma",
              vlu: "VLU",
            },
            woundLocations: {
              buttocks: "Buttocks",
              foot: "Foot",
              head: "Head",
              ischium: "Ischium",
              lowerExtremity: "Lower Extremity",
              sacrum: "Sacrum",
              trunk: "Trunk",
              upperExtremity: "Upper Extremity",
            },
          },
          terms: {
            acceptTitle: "Accept Terms of Use",
            notSigned: "Current Terms of Use not signed",
            sign: "Sign",
            signedBadge: "Version {{version}} signed on {{date}} by {{name}}",
            toast: {
              signError: "Error signing Terms of Use",
              signed: "Terms of Use signed",
            },
          },
          tickets: {
            aiSupport: {
              answering: "Answering...",
              howCanHelp: "How can I help you?",
              sendFailed: "Your message could not be sent. Please try again, or contact support directly.",
              title: "Ask for Help",
              typeMessage: "Type a message...",
            },
            create: {
              additionalDetails: "Additional details (optional)",
              categories: [
                "Note is incomplete",
                "Wrong information",
                "Missing section",
                "Note not generated",
                "Formatting issue",
                "Other",
              ],
              create: "Create",
              description: "Description",
              encounter: "Encounter",
              encounterOrOrder: "Encounter / Order",
              errorCreating: "Error creating ticket",
              issueType: "What's the issue?",
              order: "Order",
              requestPhoneCall: "Request Phone Call",
            },
            detail: {
              created: "Created",
              errorSending: "Error sending the message",
              estResolutionTime: "Est. Resolution Time",
              issueType: "Issue Type",
              messageSent: "Message sent",
              messages: "Messages",
              newIssue: "New Issue",
              resolutionProgress: "Resolution Progress",
              ticketCode: "Ticket TKT-{{code}}",
              typeMessage: "Type a message...",
            },
            list: {
              errorFetching: "Error fetching tickets",
              hideClosedTickets: "Hide Closed tickets",
              newTicketRequest: "New Ticket Request",
              noOpenTickets: "There are no open tickets",
              openTickets_one: "You have {{count}} open ticket",
              openTickets_other: "You have {{count}} open tickets",
              showClosedTickets_one: "Show {{count}} closed ticket",
              showClosedTickets_other: "Show {{count}} closed tickets",
              openTickets: "Open Tickets",
              showClosedTickets: "Show Closed Tickets",
            },
            modal: {
              createTicket: "Create Ticket",
              myTickets: "My Tickets",
              viewTicket: "View Ticket",
            },
          },
          tierRecommendation: {
            andMore: "and more",
            basedOnYourNotes: "Based on the note types you've created, these features are essential for your practice:",
            continue: "Continue",
            featuresYouUsed: "Features you've used during trial",
            includesAllFeatures: "Includes all features you need:",
            recommended: "Recommended",
            recommendedPlan: "Recommended plan for you",
            seePlans: "See plans",
          },
          uberDirect: {
            dispatch: {
              address: "Address",
              cancelConfirm: "Are you sure you want to cancel this delivery?",
              cancelDelivery: "Cancel Delivery",
              cancelFailed: "Failed to cancel delivery",
              cancelTitle: "Cancel Delivery",
              cancelYes: "Yes, Cancel",
              cancelled: "Delivery cancelled",
              city: "City",
              confirmDispatch: "Confirm & Dispatch",
              defaultPackageDesc: "Peptide medication",
              deliveryEta: "Delivery ETA",
              dispatchBtn: "Dispatch Delivery",
              dispatchFailed: "Failed to dispatch delivery",
              dispatched: "Delivery dispatched!",
              dropoffAddress: "Dropoff Address",
              edit: "Edit",
              fee: "Delivery Fee",
              getQuote: "Get Quote",
              name: "Name",
              packageDesc: "Package Description",
              phone: "Phone",
              pickupAddress: "Pickup Address",
              pickupEta: "Pickup ETA",
              quoteFailed: "Failed to get quote",
              state: "State",
              title: "Dispatch Delivery",
              trackDelivery: "Track Delivery",
              zip: "Zip",
            },
            history: {
              empty: "No deliveries for this order",
            },
            sandbox: "Sandbox Mode",
            settings: {
              allFieldsRequired: "All fields are required",
              clientIdLabel: "Client ID",
              clientIdPlaceholder: "Enter your Client ID",
              clientSecretLabel: "Client Secret",
              clientSecretPlaceholder: "Enter your Client Secret",
              connectFailed: "Failed to connect",
              connected: "Uber Direct connected successfully",
              connectedOn: "Connected on",
              customerIdLabel: "Customer ID",
              customerIdPlaceholder: "Enter your Uber Direct Customer ID",
              description: "Connect your Uber Direct account to dispatch on-demand courier deliveries.",
              disconnect: "Disconnect",
              disconnectFailed: "Failed to disconnect",
              disconnected: "Uber Direct disconnected",
              helpStep1: "Sign in to your Uber Direct Developer Dashboard",
              helpStep2: "Navigate to Credentials and copy your Customer ID, Client ID, and Client Secret",
              helpStep3: "Paste them above and click Save & Connect",
              helpTitle: "How to get your credentials",
              saveAndConnect: "Save & Connect",
              statusConnected: "Connected",
              statusDisconnected: "Not Connected",
              testConnection: "Test Connection",
              testFailed: "Connection test failed",
              testSuccess: "Connection successful!",
              title: "Uber Direct",
            },
          },
          upgradeRequired: {
            features: {
              analytics: {
                description: "Get powerful insights into your practice with detailed analytics and performance metrics.",
                title: "Analytics Dashboard",
              },
              cptCodes: {
                description: "Streamline billing with automated CPT code suggestions and validation.",
                title: "CPT Codes",
              },
              createFollowUp: {
                description:
                  "Never let a lead go cold. This feature automatically crafts personalized follow-ups at the perfect moment.",
                title: "Smart Follow-ups",
              },
              homeHealth: {
                description: "Specialized note types and workflows designed for home health care providers.",
                title: "Home Health",
              },
              icdCodes: {
                description: "Access comprehensive ICD code suggestions and optimization for accurate billing.",
                title: "ICD Codes",
              },
              levelOfServiceCodes: {
                description: "Ensure accurate reimbursement with intelligent level of service coding.",
                title: "Level of Service Codes",
              },
              locations: {
                description: "Manage multiple locations and streamline your practice operations across all sites.",
                title: "Locations Management",
              },
              managementGrid: {
                description: "Organize complex clinical data with customizable management grids and insurance tracking.",
                title: "Management Grid",
              },
              qCode: {
                description: "Manage quality measure codes for accurate reporting and compliance.",
                title: "Q Codes",
              },
              team: {
                description: "Collaborate seamlessly with your team and manage user permissions efficiently.",
                title: "Team Management",
              },
              transitionOfCare: {
                description: "Comprehensive documentation for seamless care transitions and referrals.",
                title: "Transition of Care",
              },
              uploadDocuments: {
                description: "Upload and manage documents directly in your encounters for comprehensive patient records.",
                title: "Upload Documents",
              },
              woundCare: {
                description: "Detailed wound care documentation with specialized templates and tracking.",
                title: "Wound Care",
              },
            },
            hoverToPeek: "Hover to peek",
            maybeLater: "Maybe later",
            proFeature: "Pro Feature",
            unlockFeature: "Unlock feature",
          },
          users: {
            actions: {
              createUser: "Create User",
            },
            columns: {
              email: "E-Mail",
              firstName: "First Name",
              lastName: "Last Name",
              status: "Status",
              type: "Type",
            },
            edit: {
              commission: "Commission",
              commissionBothRequired: "Both flat and percentage values are required for 'Lesser of Both'",
              commissionFlat: "Flat Commission ($/order)",
              commissionFlatHelp: "Fixed dollar amount per delivered order (0-500)",
              commissionHelp: "Commission amount for 14 days in USD (0-500)",
              commissionLesserHelp: "For each order, the lower of flat or percentage is used",
              commissionPercent: "Commission (% of Distributor Revenue)",
              commissionPercentHelp: "Percentage of distributor revenue per delivered order",
              commissionRequired: "Commission is required",
              commissionType: "Commission Type",
              commissionTypeFlat: "Flat ($)",
              commissionTypeLesser: "Lesser of Both",
              commissionTypePercent: "Percentage (%)",
              duplicateEmail: "User email already exists",
              editWelcomeMessage: "Edit Message",
              errorCreatingUser: "Error creating the user",
              errorUpdatingUser: "Error updating the user",
              successCreated: "Rep created",
              successUpdated: "Changes saved",
              invalidCommission: "Commission must be between $0 and $500",
              invalidEmail: "Please enter a valid email address",
              missingEmail: "Please add the email",
              missingFirstName: "Please add the first name",
              missingLastName: "Please add the last name",
              missingPhone: "Please add the mobile phone",
              missingType: "Please select a type",
              noWelcomeMessage: "No Welcome Message",
              pricingTier: {
                label: "Pricing Tier",
                placeholder: "Select a pricing tier",
                hint: "Required. Determines the maximum pricing tier this rep can grant to providers or sub-reps they invite.",
                required: "Pricing tier is required for sales reps",
                supervisorOnlyEdit: "Only supervisors can change a rep's pricing tier after creation.",
                errorUpdatingTier: "Failed to update pricing tier",
                partialFailure: "Other changes saved, but the pricing tier update failed. Please retry the tier change.",
                createPartialFailure:
                  "Rep created, but the pricing tier may not have saved. Re-open the rep to confirm and set the tier.",
                noGrantableTier: "Your pricing tier doesn't allow granting any peptide tier",
              },
              repCustomPricing: {
                label: "Custom product pricing",
                hint: "Optional. Set cheaper per-product prices for this rep. Overrides their tier; blank means use the tier price.",
                saveFailed: "Other changes saved, but the custom pricing update failed. Please retry.",
                createSaveFailed: "Rep created, but the custom pricing didn't save. Edit the rep to retry.",
              },
              productLines: {
                label: "Product Lines",
                dme: "DME Collagen",
                peptides: "Peptides",
                hint: "Which product lines this rep can sell. At least one must be selected. Peptides additionally requires a pricing tier.",
                noCapability:
                  "You have no product-line capability to grant. Configure product lines in Profile, or ask a supervisor to update your access, before inviting reps.",
                supervisorOnlyEdit: "Only supervisors can change product-line capability after creation.",
                atLeastOneRequired: "At least one product line must be selected for sales reps",
              },
              role: {
                administrator: "Administrator",
                provider: "Provider",
                salesRep: "Sales Rep",
                supervisor: "Supervisor",
                supportStaff: "Support Staff",
                teamMember: "Team Member",
              },
              selectType: "Select a type",
              status: {
                active: "Active",
                label: "Status",
                suspended: "Suspended",
              },
              tabs: {
                ehrIntegration: "EHR Integration",
                noteStyle: "Note Style",
                notesSettings: "Notes Settings",
                preferences: "Preferences",
                profile: "Profile",
                security: "Security",
              },
              type: "Type",
              welcomeMessage: "Welcome Message",
            },
            filters: {
              activeUsers: "Active Users",
              search: "Search",
              support: "Support",
              suspended: "Suspended",
            },
            status: {
              active: "Active",
              suspended: "Suspended",
            },
            roles: {
              supportStaff: "Support Staff",
              supervisor: "Supervisor",
              patient: "Patient",
              administrator: "Administrator",
              provider: "Provider",
              teamMember: "Team Member",
              salesRep: "Sales Rep",
            },
          },
          wizard: {
            baa: {
              signRequired: "Please sign the Business Associate Agreement at the bottom of the page",
            },
            buttons: {
              finish: "Finish",
              next: "Next",
            },
            clinicalRole: {
              clinical: "Clinical Provider - I provide medical services and may order DME products",
              description: "As a supervisor, please let us know if you provide clinical services or manage administrative tasks.",
              nonClinical: "Non-Clinical Staff - I manage administrative tasks only",
              roleTypeLabel: "Your Role Type",
              selectRoleType: "Select your role type",
              title: "Do you have a clinical role?",
            },
            credentials: {
              label: "Credentials",
              other: "Other",
              selectYourCredentials: "Select your credentials",
              toastEnter: "Please enter Your Credentials",
            },
            demo: {
              description:
                "Choose a user type to simulate their onboarding experience. This is demo mode - no changes will be saved.",
              launchOnboardingWizard: "Launch Onboarding Wizard (Demo)",
              launchPatientOnboardingWizard: "Launch Onboarding Patient Wizard (Demo)",
              manufacturerDescription: "Manufacturer supervisor flow with PIN but no address/NPI fields",
              manufacturerTitle: "Manufacturer Team Member",
              providerDescription: "Provider supervisor with clinical role selection, credentials, and address fields",
              providerTitle: "Provider Supervisor",
              salesRepDescription: "Sales rep with minimal onboarding steps (no PIN, credentials, or address)",
              salesRepTitle: "Sales Representative",
              selectUserType: "Select User Type to Simulate",
            },
            doctorType: {
              generalist: "Generalist",
              prompt: "Select your specialty. If it is not included, please leave it empty to access to all the notes.",
              providerType: "Provider Type",
            },
            language: {
              no: "No",
              options: {
                ar: "Arabic",
                auto: "Multi-Language",
                en: "English Only",
                es: "Spanish Only",
                ko: "Korean",
                spen: "English/Spanish (Spanglish)",
              },
              primaryQuestion: "What's the primary language you speak with your patients?",
              speakSpanishQuestion: "Do you speak Spanish with your patients?",
              yes: "Yes",
            },
            noteTypes: {
              title: "Pick the note types you use. You can always change it later under Preferences.",
            },
            password: {
              confirm: "Confirm Password",
              new: "New Password",
              req: {
                length: "Between 12 and 50 characters long",
                lowercase: "It must contains at least one lowercase letter",
                number: "It must contains at least one number",
                special: "It must contains at least one special character",
                uppercase: "It must contains at least one uppercase letter",
              },
              requirementsLead: "Select a password that satisfies the following requirements:",
              title: "Set your Password",
              toast: {
                length: "Password must be between 12 and 50 characters long",
                lowercase: "Password must contains at least one lowercase letter",
                mismatch: "Password must match",
                number: "Password must contains at least one number",
                special: "Password must contains at least one special char",
                uppercase: "Password must contains at least one uppercase letter",
              },
            },
            pin: {
              title: "Create the 4 digit PIN code you will use to sign the encounter and archive it.",
              toastEnter4Digits: "Please enter 4 digits PIN",
            },
            profile: {
              address: "Practice Address",
              firstName: "First Name",
              lastName: "Last Name",
              notInUS: "Not in US",
              npiNumber: "NPI Number",
              npiNumberPlaceholder: "Enter your NPI Number (required for MD, DO, ARNP, PA)",
              officeAddress: "Office Address",
              officeAddressPlaceholder: "Enter your practice or clinic address",
              officeName: "Office Name",
              officeNamePlaceholder: "Enter your practice or clinic name",
              phone: "Phone",
              ptanNumber: "PTAN Number",
              ptanNumberPlaceholder: "Enter your PTAN Number (optional, 6-10 characters)",
              selectStateOption: "Select State",
              state: "Primary Practice State",
              title: "Insert your profile data.",
              toast: {
                enterFirstName: "Insert your First Name",
                enterLastName: "Insert your Last Name",
                enterPhone: "Insert your Mobile Phone",
                insertZip: "Please insert the zipcode",
                selectState: "Please select a state",
              },
              zipcode: "Zipcode",
            },
            referral: {
              options: {
                Ad: "Ad Online",
                Conference: "Conference or Event",
                DoctorReferral: "Doctor or Medical Org Referral",
                Facebook: "Facebook",
                Friend: "From a Friend or Colleague",
                GoogleSearch: "Google Search",
                Instagram: "Instagram",
                LinkedIn: "LinkedIn",
                Podcast: "Podcast",
                TikTok: "TikTok",
                Twitter: "Twitter",
                WordOfMouth: "Word of Mouth",
                YouTube: "YouTube",
              },
              title: "How did you here about us?",
            },
            patientIdentity: {
              title: "Confirm your information",
              subtitle: "Please confirm what you submitted on your intake. Edit anything that's wrong.",
              dob: "Date of birth",
              preferredContact: "Preferred contact for updates",
              selectChannel: "Select…",
              channelEmail: "Email",
              channelSms: "Text message (SMS)",
              emergencyContactName: "Emergency contact name",
              emergencyContactPhone: "Emergency contact phone",
              toast: {
                dobRequired: "Please enter your date of birth.",
                channelRequired: "Please select a preferred contact channel.",
              },
            },
            patientShipping: {
              title: "Where do we ship?",
              subtitle: "We use this address for every peptide order. You can update it later from your profile.",
              street: "Street address",
              aptUnit: "Apt / unit",
              city: "City",
              state: "State",
              selectState: "Select state",
              zip: "ZIP code",
              sameAsBilling: "Billing address is the same as shipping",
              billingStreet: "Billing street",
              billingAptUnit: "Billing apt / unit",
              billingCity: "Billing city",
              billingState: "Billing state",
              billingZip: "Billing ZIP",
              toast: {
                requiredFields: "Please fill in your shipping street, city, state, and ZIP.",
                zipFormat: "ZIP must be 5 digits or 5+4 (e.g., 94110 or 94110-1234).",
                billingRequired: "Please fill in all billing-address fields.",
              },
            },
            styles: {
              bullets: "Bullet Points",
              complex: "Complex",
              comprehensive: "Comprehensive",
              concise: "Concise",
              hpi: "HPI",
              length: "Length",
              mdm: "Medical Decision Making",
              paragraph: "Paragraph",
              physicalExam: "Physical Exam",
              planOfCare: "Plan of Care",
              ros: "Review of system",
              style: "Style",
              title:
                'Select the style and length you prefer for each elements. You can always change them from the "Customize" button on the note.',
            },
            table: {
              enable: "Enable",
              type: "Type",
            },
            terms: {
              signRequired: "Please sign the term of use at the bottom of the page",
            },
            toast: {
              completeError: "An error occurred while completing the wizard. Please try again.",
              savedOffline: "Your setup was saved locally and will sync when your connection improves.",
              welcome: "Welcome!",
            },
            welcome: {
              subtitle1:
                "You have joined {{organization}}, an AI-powered medical assistant system designed to enhance your healthcare experience.",
              subtitle2: "Get started now by clicking Next to start filling up your data.",
              title: "Welcome!",
            },
            welcomeOrders: {
              subtitle1:
                "You have joined an AI-powered assistant system designed to enhance your healthcare experience. Lucas facilitates the ordering of DME, Peptides, and Exosomes using a compliance-enabled engine to streamline your purchasing, fulfillment, and product tracking.",
              subtitle2: "Get started now by clicking Next to start filling out your data.",
              title: "Welcome!",
            },
            welcomePatient: {
              title: "Welcome!",
              subtitle1:
                "Your provider invited you to Lucas for peptide therapy. We just need to confirm a couple of details and grab your shipping address — about two minutes.",
            },
            contracts: {
              received: {
                title: "Received Contracts",
                empty: "No contracts received yet.",
                signedOn: "Signed {{date}}",
                sentOn: "Sent {{date}} · awaiting signature",
                review: "Review & Sign",
              },
              sign: {
                title: "Sign Contract",
                agree: "I have read and agree to the contract above.",
                typedNameLabel: "Type your full name to sign",
                typedNameHint: "Must match your account name: {{name}}",
                submit: "Sign",
                signing: "Signing…",
                ok: "Signed.",
                failed: "Could not record your signature. Try again.",
                notFound: "This contract is no longer available.",
                emptyContent: "This contract has no content to display.",
                pinNote: "You'll enter your PIN to e-sign.",
                pinTitle: "Sign contract",
                pinHeader: "Enter your PIN to e-sign",
              },
            },
            myProfile: {
              title: "My profile",
              saved: "Saved",
              saveError: "Save failed — try again",
              empty: {
                providerOwned: "Your provider hasn't added this yet",
                patientCta: "Add your info",
              },
            },
            manageRefills: {
              title: "Manage Refills",
              description:
                "View and manage your active auto-refills here. This area is under construction — for now, place a refill from your peptide dashboard.",
            },
            refillSettings: {
              title: "Refill Settings",
              back: "Back",
              save: "Save",
              saving: "Saving…",
              saveSuccess: "Refill settings saved",
              saveError: "Failed to save refill settings",
              loadFailedBanner:
                "Couldn't fetch saved settings. Showing defaults — your edits will still be submitted when you Save.",
              refillTrackingEnabled: {
                label: "Refill tracking",
                help: "When enabled, the refill panel surfaces overdue and due-soon orders for your team.",
              },
              peptideRefillCycleDays: {
                label: "Refill cycle days",
                help: "Number of days between a peptide delivery and the patient's next refill due date.",
              },
              dueSoonThresholdDays: {
                label: "Due soon threshold (days)",
                help: "How many days before the refill due date an order is shown as 'due soon'.",
              },
              maxRefillsPerTherapy: {
                label: "Max refills per therapy (optional)",
                help: "Leave blank for unlimited. When set, refills beyond this cap are not surfaced automatically.",
              },
            },
            surchargeSettings: {
              title: "Active-Form Surcharge",
              help: "Turn the per-vial active-form surcharge on or off for individual providers. On by default.",
              on: "Surcharge on",
              off: "Surcharge off",
              empty: "No linked providers yet.",
              back: "Back",
              saveSuccess: "Surcharge setting saved",
              saveError: "Failed to save surcharge setting",
            },
            pay: {
              title: "Review & Pay",
              method: "Payment method",
              card: "Card",
              zelle: "Zelle",
              cardNumber: "Card number",
              expiry: "MM/YY",
              cvv: "CVV",
              cardholderName: "Cardholder name",
              billingZip: "Billing ZIP",
              pay: "Pay {{amount}}",
              processing: "Processing…",
              secureNote: "Payments are encrypted and processed securely.",
              zelleInstructions: "Send payment via Zelle to alphabiopayments@gmail.com, then upload your receipt below.",
              uploadReceipt: "Upload receipt",
              submitZelle: "Submit payment",
              receiptRequired: "Please upload your payment receipt.",
              zelleSubmitted: "Receipt submitted — the manufacturer will confirm your payment.",
              cardSuccess: "Payment successful.",
              declined: "Your card was declined. Please check the details and try again.",
              genericError: "We couldn't process the payment. Please try again.",
            },
          },
          myProfile: {
            title: "My profile",
            saved: "Saved",
            saveError: "Save failed — try again",
            loading: "Loading your profile…",
            loadError: {
              title: "Couldn't load your profile",
              description: "Try again in a moment. If this keeps happening, contact your provider.",
              retry: "Try again",
            },
            empty: {
              providerOwned: "Your provider hasn't added this yet",
              patientCta: "Add your info",
            },
          },
        },
      },
      es: {
        translation: {
          npiRoster: {
            columnHeader: "NPI",
            nameHint: "Escriba su nombre exactamente como aparece en el Registro Nacional de NPI (NPPES).",
            title: "Listado de NPI — {{name}}",
            viewRoster: "NPI del proveedor",
            edgeCaseHint:
              "Si la verificación no se completó pero el NPI es correcto, puede aprobarlo manualmente. Esto nunca afecta la capacidad de realizar pedidos.",
            loading: "Cargando proveedores…",
            noProviders: "No hay proveedores con un NPI registrado para esta cuenta.",
            noNpi: "Sin NPI registrado",
            orgNpi: "NPI de la organización",
            verified: "Verificado",
            manuallyCleared: "Aprobado manualmente",
            manuallyClearedBy: "Aprobado manualmente por {{name}}",
            unverified: "Sin verificar",
            manualClear: "Aprobar manualmente",
            clearing: "Aprobando…",
            clearedToast: "NPI del proveedor aprobado.",
            clearFailedToast: "No se pudo aprobar este NPI. Inténtelo de nuevo.",
            confirmTitle: "Aprobar NPI manualmente",
            confirmBody:
              "¿Confirma que el NPI de {{name}} es correcto y desea aprobarlo manualmente? Se registrará con su nombre.",
            allClearedTooltip: "Todos los proveedores aprobados",
            someUnverifiedTooltip: "{{n}} proveedor(es) requieren revisión",
            noProvidersTooltip: "Ningún proveedor con un NPI registrado",
            notApplicableTooltip: "No aplica",
            loadErrorTooltip: "No se pudo cargar el estado del NPI",
            registeredTo: "Registrado a nombre de",
            failureReason: {
              NOT_FOUND: "NPI no encontrado en NPPES",
              INACTIVE: "NPI inactivo en NPPES",
              NAME_MISMATCH: "El nombre no coincide con NPPES",
              WRONG_TYPE: "No es un NPI individual",
              UNKNOWN: "No se pudo verificar el NPI",
            },
          },
          aiAgent: {
            activeSwitch: {
              label: "Activo",
              active: "Activo",
              inactive: "Inactivo",
              activatedToast: "Agente activado",
              deactivatedToast: "Agente desactivado",
              supervisorOnly: "Solo los supervisores pueden activar agentes",
            },
            agentList: {
              addAgent: "Añadir Agente",
              backToAgents: "Volver a Agentes",
              defaultAgentName: "Agente Predeterminado",
              deleteForever: "Eliminar para siempre",
              deletedPrefix: "Eliminado",
              empty: "Aún no hay agentes",
              emptyTrashBtn: "Vaciar Papelera",
              newAgentName: "Nuevo Agente",
              noMatch: "Ningún agente coincide con tu búsqueda",
              restore: "Restaurar",
              searchPlaceholder: "Buscar agentes...",
              statusActive: "Activo",
              statusInactive: "Inactivo — no aceptará llamadas de pacientes",
              trash: "Papelera",
              trashEmpty: "La papelera está vacía",
              untitled: "Agente sin Título",
            },
            builder: {
              flow: {
                closingMessageLabel: "Mensaje de Cierre",
                closingMessagePlaceholder: "ej. Gracias por llamar. ¡Que tengas un excelente día!",
                hint: "Diseña el flujo paso a paso de cada conversación.",
                openingMessageLabel: "Mensaje de Apertura",
                openingMessagePlaceholder: "ej. Gracias por llamar a Clínica Sunrise. ¿En qué puedo ayudarte hoy?",
                rulesLabel: "Reglas de Conversación",
                rulesPlaceholder: "Agrega una regla de conversación...",
                stepsLabel: "Pasos de la Conversación",
                title: "Flujo de Conversación",
              },
              goals: {
                hint: "Define lo que tu agente debe lograr en cada conversación.",
                primaryGoalLabel: "Objetivo Principal",
                primaryGoalPlaceholder: "ej. Agendar citas para pacientes nuevos y recurrentes",
                secondaryGoalsLabel: "Objetivos Secundarios",
                secondaryGoalsPlaceholder: "Agrega un objetivo secundario...",
                successCriteriaLabel: "Criterios de Éxito",
                successCriteriaPlaceholder: "Agrega un criterio de éxito...",
                title: "Objetivos",
              },
              identity: {
                agentNameIntro: "Hola, mi nombre es",
                agentNameLabel: "Nombre del Agente",
                agentNameOutro: "el asistente virtual de tu doctor",
                agentNamePlaceholder: "ej. Sofía",
                hint: "Define quién es tu agente y qué rol cumple.",
                organizationLabel: "Organización",
                organizationPlaceholder: "ej. Clínica Sunrise",
                roleDescriptionLabel: "Descripción del Rol",
                roleDescriptionPlaceholder: "Describe con más detalle lo que hace este agente...",
                roleTitleLabel: "Título del Rol",
                roleTitlePlaceholder: "ej. Recepcionista",
                title: "Identidad",
              },
              personality: {
                communicationSpeedLabel: "Velocidad de Comunicación",
                customToneLabel: "Detalles de Tono Personalizado",
                customTonePlaceholder: "Agrega instrucciones específicas de tono...",
                emotionalBoundariesLabel: "Límites Emocionales",
                emotionalBoundariesPlaceholder: "ej. Mantén la calma si quien llama está molesto, nunca levantes la voz",
                hint: "Define cómo se comunica tu agente con quienes llaman.",
                languageStyleTagsLabel: "Etiquetas de Estilo del Lenguaje",
                speedConcise: "Concisa — Respuestas cortas y directas",
                speedModerate: "Moderada — Detalle equilibrado",
                speedThorough: "Detallada — Explicaciones extensas",
                title: "Personalidad y Tono",
                tonePresetLabel: "Tono Predefinido",
              },
              questions: {
                addPlaceholder: "Agrega una pregunta...",
                confirmTypeChange: "Cambiar este tipo eliminará todas las preguntas de seguimiento. ¿Continuar?",
                hint: "Crea las preguntas que tu agente hará durante las conversaciones.",
                title: "Preguntas",
              },
              responseTypes: {
                choice: "Opción",
                clarification: "Seguimiento",
                info_capture: "Captura de información",
                narrative: "Abierta",
                yes_no: "Sí / No",
              },
              rules: {
                additionalLabel: "Instrucciones Adicionales",
                additionalPlaceholder: "Cualquier otra instrucción o contexto para el agente...",
                conditionalLabel: "Reglas Condicionales",
                hint: "Establece las reglas y los límites estrictos que tu agente debe seguir o evitar.",
                mustAlwaysLabel: "Siempre Debe",
                mustAlwaysPlaceholder: "ej. Verifica la identidad de quien llama antes de compartir información",
                mustNeverLabel: "Nunca Debe",
                mustNeverPlaceholder: "ej. Nunca proporcionar diagnósticos médicos",
                title: "Reglas",
              },
              sections: {
                conversationFlow: "Flujo",
                goals: "Objetivos",
                identity: "Identidad",
                personality: "Personalidad",
                questions: "Preguntas",
                rules: "Reglas",
              },
              tonePresets: {
                authoritative: "Autoritario",
                casual: "Casual",
                clinical: "Clínico",
                custom: "Personalizado",
                empathetic: "Empático",
                friendly: "Amable",
                professional: "Profesional",
              },
            },
            config: {
              conversationStyle: {
                advanced: "Ajuste Avanzado",
                auto: "Automático",
                autoDesc: "Ajusta los tiempos automáticamente",
                hint: "Cómo toma turnos el agente en la conversación.",
                manual: "Manual",
                manualDesc: "Solo responde cuando se activa explícitamente",
                moderate: "Moderada",
                moderateDesc: "Tiempo de respuesta equilibrado",
                patient: "Paciente",
                patientDesc: "Espera más tiempo antes de responder",
                pauseBefore: "Pausa Antes de Hablar",
                quick: "Rápida",
                quickDesc: "Responde tan pronto como sea posible",
                replySpeedHint: "Qué tan rápido interviene el agente después de que dejas de hablar.",
                replySpeedLabel: "Velocidad de Respuesta",
                sensitivity: "Sensibilidad",
                silenceBefore: "Silencio Antes de Responder",
                smart: "Inteligente",
                smartDesc: "Espera a que termines tu idea antes de responder",
                standard: "Estándar",
                standardDesc: "Responde después de detectar pausas en el habla",
                title: "Estilo de Conversación",
              },
              creativity: {
                balanced: "Equilibrada",
                balancedDesc: "Buena mezcla de consistencia y variación natural",
                brief: "Breve",
                briefDesc: "Respuestas cortas y concisas",
                creative: "Creativa",
                creativeDesc: "Respuestas más naturales y variadas",
                detailed: "Detallada",
                detailedDesc: "Explicaciones completas",
                extended: "Extensa",
                extendedDesc: "Respuestas largas y exhaustivas",
                hint: "Controla qué tan predecibles o variadas son las respuestas del agente.",
                moderate: "Moderada",
                moderateDesc: "Longitud estándar de conversación",
                precise: "Precisa",
                preciseDesc: "Se apega estrictamente a las instrucciones, muy predecible",
                responseLengthHint: "Qué tan extensas deben ser las respuestas del agente.",
                responseLengthLabel: "Longitud de Respuesta",
                title: "Creatividad",
                veryCreative: "Muy Creativa",
                veryCreativeDesc: "Máxima variedad, menos predecible",
              },
              empty: "Selecciona un agente para configurarlo",
              languages: {
                auto: "Automático",
                en: "Inglés",
                es: "Español",
                it: "Italiano",
                ko: "Coreano",
                pt: "Portugués",
              },
              listening: {
                hint: "Cómo escucha el agente y qué idiomas entiende.",
                languageLabel: "Idioma",
                title: "Escucha e Idioma",
                transcriptionHint: "Qué tan precisamente el agente convierte el habla a texto.",
                transcriptionLabel: "Calidad de Transcripción",
              },
              noise: {
                closeRange: "Corto Alcance",
                closeRangeDesc: "Mejor para audífonos y micrófonos cercanos",
                hint: "Filtra los sonidos de fondo durante las llamadas.",
                off: "Apagado",
                offDesc: "Sin filtrado de ruido",
                room: "Habitación",
                roomDesc: "Mejor para altavoces y micrófonos de sala",
                title: "Ruido de Fondo",
              },
              phoneMode: "Modo Teléfono",
              phoneModeHint:
                "Habilítalo cuando este agente vaya a manejar llamadas telefónicas en lugar del chat de voz del navegador.",
              title: "Configuración",
              voiceIntelligence: {
                hint: "Elige cómo suena tu agente y qué tan inteligente es.",
                intelligenceHint: "Mayor inteligencia es más precisa pero cuesta más por llamada.",
                intelligenceLabel: "Inteligencia",
                title: "Voz e Inteligencia",
                voiceHint: "La voz que tu agente usará al hablar.",
                voiceLabel: "Voz",
              },
            },
            dialogs: {
              cancel: "Cancelar",
              emptyTrashConfirm: "Vaciar Papelera",
              emptyTrashMessage:
                "¿Eliminar permanentemente todos los {{count}} agente(s) en la papelera? Esta acción no se puede deshacer.",
              emptyTrashTitle: "Vaciar Papelera",
              fallbackAgent: "Agente",
              fallbackAgentName: "este agente",
              moveTrashConfirm: "Mover a la Papelera",
              moveTrashMessage: '¿Mover "{{name}}" a la papelera? Podrás restaurarlo más tarde.',
              moveTrashTitle: "Mover a la Papelera",
              movedToTrashToast: '"{{name}}" movido a la papelera',
              permanentDeleteConfirm: "Eliminar para Siempre",
              permanentDeleteMessage: '¿Eliminar permanentemente "{{name}}"? Esta acción no se puede deshacer.',
              permanentDeleteTitle: "Eliminar Permanentemente",
              permanentlyDeletedToast: '"{{name}}" eliminado permanentemente',
              restoredToast: '"{{name}}" restaurado',
              trashEmptiedToast: "Papelera vaciada",
              unsavedChanges: "Tienes cambios sin guardar. ¿Estás seguro de que quieres salir?",
            },
            encounterPortal: {
              inactive: "Este enlace de admisión aún no está listo. Por favor, contacta a tu proveedor.",
            },
            labels: {
              aiAgentSettings: "Configuración del agente IA",
              kpiMetricName: "Nombre de la métrica KPI",
              patientFirstName: "Nombre del paciente",
              phoneNumber: "Número de teléfono",
              prefixPadding: "Relleno de prefijo",
              silenceDuration: "Duración del silencio",
              stepInstructions: "Instrucciones del paso",
              stepInstructionsPlaceholder:
                'Guía de comportamiento para este paso, ej. "Haga una pregunta a la vez", lógica condicional, descripciones de marco...',
              threshold: "Umbral",
            },
            legacyActivationNotice:
              "Los agentes existentes se han establecido como Inactivos por seguridad. Activa cada uno antes de usarlo.",
            nav: {
              buildManage: "Crear y Administrar",
              campaigns: "Campañas",
              campaignsComingSoon: "Próximamente",
              patients: "Pacientes",
              sessionQueue: "Cola de Sesiones",
              test: "Probar",
            },
            patients: {
              agentLabel: "Agente de IA",
              backToSearch: "Volver a la búsqueda",
              defaultFirstName: "paciente",
              dobLabel: "Fecha de Nacimiento",
              encounterName: "Encuentro por Voz",
              launchDescription:
                "Se enviará un SMS al paciente con un enlace para iniciar una conversación por voz. El agente de IA recolectará la información del encuentro y generará automáticamente la nota del encuentro.",
              launchNote: "El enlace es de un solo uso y expira una vez que se envía el encuentro.",
              noPatients: "No se encontraron pacientes",
              panelTitle: "Pacientes",
              patientLabel: "Paciente",
              phoneLabel: "Número de Teléfono",
              remindersTitle: "Recordatorios",
              searchPlaceholder: "Buscar pacientes...",
              searching: "Buscando...",
              sendSms: "Enviar SMS",
              sending: "Enviando...",
              smsLabel: "Mensaje SMS",
              smsTemplate:
                "Hola {{name}}, tu proveedor te ha enviado un enlace para completar un check-in de voz previo a la visita. Haz clic en el enlace a continuación para comenzar:",
              toasts: {
                createFailed: "Error al crear el encuentro. Por favor, inténtalo de nuevo.",
                linkSent: "Enlace de encuentro por voz enviado por SMS",
                loadFailed: "Error al cargar los pacientes. Por favor, inténtalo de nuevo.",
                sendFailed: "Error al enviar el enlace. Por favor, inténtalo de nuevo.",
              },
            },
            promptEditor: {
              agentNameLabel: "Nombre del Agente",
              agentNamePlaceholder: "Ingresa el nombre del agente",
              builder: "Constructor",
              compiledPreviewTitle: "Previsualización de la Instrucción Compilada",
              configTitle: "Configuración",
              descriptionLabel: "Descripción",
              descriptionPlaceholder: "Descripción opcional",
              initializeBuilder: "Inicializar Constructor",
              previewEmpty:
                "Aún no hay contenido en la instrucción. Completa las secciones del constructor para generar una instrucción.",
              previewTitle: "Previsualizar instrucción",
              raw: "Texto",
              selectAgent: "Selecciona un agente para editar su instrucción",
              systemPromptLabel: "Instrucción del Sistema",
              systemPromptPlaceholder: "Ingresa las instrucciones del sistema para este agente...",
              title: "Editor de Instrucciones",
            },
            reminders: {
              durationLabel: "Duración",
              durationSuffix: "días",
              enableLabel: "Habilitar Recordatorios",
              errors: {
                duration: "La duración debe estar entre 1 y 14 días",
                message: "El mensaje debe contener {original_link}",
                window: "La hora de inicio debe ser anterior a la hora de fin",
              },
              exhaustedLabel: "Al Agotarse",
              exhaustionActions: {
                CLOSE: "Cerrar Sesión",
                NOTIFY: "Notificar al Proveedor",
                QUEUE: "Mover a Cola de Incompletos",
              },
              frequencies: {
                EVERY_OTHER_DAY: "Cada dos días",
                ONCE_DAILY: "Una vez al día",
                TWICE_DAILY: "Dos veces al día",
              },
              frequencyLabel: "Frecuencia",
              messageLabel: "Mensaje de Recordatorio",
              variables: {
                attempt: "Número del intento actual",
                maxAttempts: "Máximo de intentos",
                orgName: "Nombre de la organización",
                originalLink: "Enlace del encuentro por voz",
                patientFirstName: "Nombre del paciente",
              },
              windowLabel: "Horario de Recordatorios",
              windowSeparator: "a",
            },
            saveErrorToast: "Error al guardar la configuración del agente",
            savedToast: "Configuración del agente guardada",
            sessionQueue: {
              actions: {
                closeSession: "Cerrar Sesión",
                copyLink: "Copiar Enlace",
              },
              columns: {
                actions: "Acciones",
                agent: "Agente",
                lastActivity: "Última Actividad",
                patient: "Paciente",
                reminders: "Recordatorios",
                sent: "Enviado",
                status: "Estado",
              },
              defaultAgent: "Encuentro por Voz",
              empty: "No se encontraron sesiones",
              noEvents: "Sin eventos",
              remindersDisabled: "Deshabilitado",
              stats: {
                active: "Activas",
                exhausted: "Agotadas",
                inProgress: "En Progreso",
                notClicked: "Sin Clic",
              },
              tabs: {
                abandoned: "Abandonadas",
                all: "Todas",
                expired: "Expiradas",
                inProgress: "En Progreso",
                notClicked: "Sin Clic",
              },
              title: "Cola de Sesiones",
              toasts: {
                closeFailed: "Error al cerrar la sesión",
                closeTitle: "Cerrar Sesión",
                closed: "Sesión cerrada",
                confirmClose: "¿Cerrar esta sesión? Esta acción no se puede deshacer.",
                copyFailed: "Error al copiar el enlace",
                linkCopied: "Enlace copiado",
                loadFailed: "Error al cargar la cola de sesiones",
                noLink: "No hay un enlace disponible para esta sesión",
              },
              unknownPatient: "Desconocido",
            },
            sessionStatus: {
              ABANDONED: "Abandonado",
              CLICKED: "Clicado",
              COMPLETED: "Completado",
              DELIVERED: "Entregado",
              EXPIRED: "Expirado",
              FAILED: "Fallido",
              IN_PROGRESS: "En Progreso",
              SENT: "Enviado",
              UNDELIVERED: "No Entregado",
            },
            status: {
              connected: "Conectado",
              listening: "Escuchando...",
              speaking: "Hablando...",
              thinking: "Pensando...",
            },
            test: {
              agentsHeader: "Agentes",
              callScriptTitle: "Guion de Llamada",
              noAgents: "Aún no hay agentes — ve a <1>Crear y Administrar</1> para crear uno.",
              readyBody: "Haz clic en Iniciar Chat de Voz arriba para comenzar una conversación con tu Asistente de IA.",
              readyHeading: "Listo para escuchar",
              saveChanges: "Guardar Cambios",
              startVoiceChat: "Iniciar Chat de Voz",
              stopVoiceChat: "Detener Chat de Voz",
            },
            title: "Agente de IA",
          },
          attachments: {
            addDocument: "Agregar documento",
            noDocumentsUploaded: "No hay documentos subidos",
            openPdf: "Abrir PDF",
            rename: "Renombrar",
            renameDocument: "Renombrar documento",
            title: "Archivos subidos",
            titleLabel: "Título",
            toast: {
              documentDeleted: "Documento eliminado",
              errorDeletingDocument: "Error al eliminar el documento",
              errorLoadingFile: "Error al cargar el archivo",
              errorRenamingDocument: "Error al renombrar el documento",
            },
          },
          auth: {
            changePassword: {
              changeButton: "Cambiar contraseña",
              confirmPassword: "Confirmar contraseña",
              error: "Error al cambiar la contraseña",
              forUserInBrain: "Para {{user}} en {{brain}}",
              mismatch: "Las contraseñas no coinciden",
              newPassword: "Nueva contraseña",
              req: {
                length: "Entre 12 y 50 caracteres",
                lowercase: "Debe contener al menos una letra minúscula",
                number: "Debe contener al menos un número",
                special: "Debe contener al menos un carácter especial",
                uppercase: "Debe contener al menos una letra mayúscula",
              },
              requirementsLead: "Selecciona una contraseña que cumpla los siguientes requisitos:",
              success: "Contraseña cambiada",
              successSubtitle: "Vuelve e inicia sesión con la nueva contraseña",
              successTitle: "Contraseña cambiada",
              title: "Cambiar contraseña",
            },
            common: {
              backToLogin: "Volver al inicio de sesión",
            },
            resetPassword: {
              email: "Correo electrónico",
              error: "Error al enviar el enlace de restablecimiento",
              organization: "Organización",
              sendLink: "Enviar enlace",
              subtitle:
                "Ingresa el correo electrónico y la organización de tu cuenta y te enviaremos un enlace para restablecer la contraseña.",
              success: "Enlace de restablecimiento enviado a tu correo",
              title: "¿Olvidaste tu contraseña?",
            },
          },
          baa: {
            notSigned: "Acuerdo de Asociado Comercial no firmado",
            sign: "Firmar BAA",
            signedBadge: "BAA Versión {{version}} firmada el {{date}} por {{name}}",
          },
          chatDetail: {
            actions: "Acciones",
            addDocument: "Agregar documento",
            afterVisitSummary: "Resumen posterior a la visita",
            aiNote: "Nota IA",
            applyReportCard: "Aplicar reporte",
            assignedTo: "Asignado a:",
            createFollowUp: "Crear seguimiento",
            debug: "Depurar",
            delete: "Eliminar",
            discard: "Descartar",
            editEncounter: "Editar encuentro",
            generate: "Generar",
            generateLoader: "Generando nota",
            humanInputs: "Entradas humanas",
            lock: "Bloquear",
            orderDme: "Ordenar DME",
            outputData: "Datos de Salida",
            recording: "Grabando",
            restore: "Restaurar",
            sendToEHR: "Enviar al EHR",
            sexGate: {
              assignFailed: "No se pudo guardar el sexo del paciente. Por favor intente de nuevo.",
              tooltip:
                "Se detectaron códigos de diagnóstico específicos del sexo, pero este paciente no tiene sexo registrado. Configúrelo para habilitar la verificación de códigos incompatibles con el sexo.",
            },
            stopRecording: "Detener grabación",
            syncEHR: "Sincronizar EHR",
            tooltips: {
              accountNotEnabled: "Cuenta no habilitada para firmar",
              accountNotEnabledRestore: "Cuenta no habilitada para restaurar",
              alreadyLocked: "Ya bloqueado",
              disabled: "Deshabilitado",
              encounterDeleted: "Encuentro eliminado",
              encounterLocked: "Encuentro bloqueado",
              generationInProgress: "Generación en curso",
              lockToEnable: "Bloquear para habilitar",
              notAllowedToDelete: "No permitido eliminar",
              orderDmeComingSoon: "Próximamente",
              requiredActions: "Acciones requeridas antes de crear seguimiento",
              noteStale: "Se grabó audio nuevo después de generar esta nota. Vuelve a generarla para incluirlo.",
              stopRecordingToDelete: "Detén la grabación antes de eliminar",
              unlockEncounter: "Desbloquear encuentro",
              uploadNotSupported: "Carga no compatible con este tipo de nota",
              waitForGeneration: "Espera la generación",
              waitForTranscription: "Espera a que termine la transcripción",
            },
            unlock: "Desbloquear",
          },
          chatEdit: {
            dmeCheck: {
              missing: "Falta: {{label}} — {{hint}}",
              complete: "Documentación completa",
              dxNotInClaim: "El diagnóstico de soporte {{code}} no está en los códigos CIE-10",
              addToIcd: "Agregar a códigos CIE-10",
              dxAdded: "Se agregó {{code}} a los códigos CIE-10",
              dxNoCode: "La línea de diagnóstico no tiene código CIE-10",
              dxCategory: "{{code}} es un código de categoría — elija un código facturable más específico",
              labels: {
                diagnosis: "Diagnóstico",
                functionalLimitation: "Limitación funcional",
                durationOfNeed: "Duración de la necesidad",
                faceToFace: "Evaluación presencial",
                alternativesTried: "Alternativas probadas",
                dailyActivities: "Impacto en actividades diarias",
                safeUse: "Uso seguro",
                ambulationBenefit: "Beneficio para la marcha",
                caneWalkerInsufficient: "Bastón/andador insuficiente",
                homeAccessibility: "Accesibilidad del hogar",
                propulsion: "Propulsión",
                positioningNeed: "Necesidad de posicionamiento",
                medication: "Medicamento",
                frequency: "Frecuencia",
                confinement: "Confinamiento",
              },
              hints: {
                diagnosis: "el diagnóstico CIE-10 que respalda el equipo",
                functionalLimitation: "cómo la condición limita la movilidad o las actividades diarias",
                durationOfNeed: "por cuánto tiempo se necesita el equipo (meses o de por vida)",
                faceToFace: "la evaluación presencial que respalda la orden",
                alternativesTried: "equipos o tratamientos menores probados o descartados",
                dailyActivities:
                  "qué actividades diarias en el hogar (ir al baño, comer, vestirse, asearse, bañarse) están afectadas",
                safeUse: "que el paciente puede usar el dispositivo con seguridad",
                ambulationBenefit: "cómo mejora la marcha con el dispositivo",
                caneWalkerInsufficient: "por qué un bastón o andador no es suficiente",
                homeAccessibility: "que el hogar permite el uso de silla de ruedas",
                propulsion: "que el paciente o un cuidador puede y quiere impulsarla",
                positioningNeed: "la necesidad de posicionamiento que una cama común no cubre",
                medication: "el medicamento inhalado recetado",
                frequency: "con qué frecuencia se usa el nebulizador",
                confinement: "que el paciente está confinado a la cama o habitación, o no puede llegar al baño",
              },
            },
            icd10ClaimFold:
              "Los reclamos profesionales llevan 12 diagnósticos. Los códigos debajo de esta línea no llegarán al reclamo.",
            codeRemoved: "Código eliminado",
            undo: "Deshacer",
            deleteCode: "Eliminar código",
            labels: {
              allIcd10Codes: "Todos los códigos ICD-10",
              annualCode: "Código anual",
              code: "Código",
              dropToCreateGroup: "Suelta aquí para crear un nuevo grupo",
              emCode: "Código E/M",
              enableMicrophoneAccess: "Habilitar acceso al micrófono",
              noteInfo: "Información de la nota",
              noteSections: "Secciones de nota",
              pasteSequence: "Secuencia de pegado",
              visitTime: "Hora de visita",
            },
            qcodes: {
              area: "Área",
              areaWasted: "Área desperdiciada",
              cptHeader: "CPT",
              editTitle: "Editar código Q",
              icd10Header: "ICD-10",
              makePrimary: "Marcar principal",
              noCptAttached:
                "Sin código CPT asociado. Los reclamos que facturan un código Q sin su código CPT pueden ser rechazados.",
              noCptConfirmMessage:
                "Este código Q no tiene ningún código CPT asociado. Los reclamos que facturan un código Q sin su código CPT pueden ser rechazados. ¿Guardar de todos modos?",
              noCptConfirmTitle: "Sin código CPT asociado",
              noCptGoBack: "Volver",
              noCptSaveAnyway: "Guardar de todos modos",
              noIcd10Codes: "No se agregaron códigos ICD-10",
              noIcd10ForCpt: "No se agregaron códigos ICD-10 para este CPT",
              notSavedNoteChanged:
                "Código Q no guardado. La nota cambió o el editor se cerró mientras la confirmación estaba abierta.",
              reset: "Restablecer",
              used: "Usada",
              wasted: "Desperdiciada",
            },
            toasts: {
              errorChangingDisposition: "Error al cambiar la disposición",
              errorCreatingEncounter: "Error al crear el encuentro",
              fileDownloaded: "Archivo descargado",
              magicTransferLoaded: "Transferencia mágica cargada",
            },
            billingRules: {
              title: "Revisión de facturación",
              venipuncture: "La venopunción ({{code}}) no debe facturarse. Elimínela antes de sincronizar.",
              missingUnits: "{{code}} no tiene unidades. Configure las unidades en Editar códigos antes de sincronizar.",
              modifierMismatch:
                "{{code}}: la nota tiene el modificador {{actual}}, las reglas de facturación esperan {{expected}}.",
              modifierMissing: "{{code}}: las reglas de facturación esperan el modificador {{expected}}.",
              notBilled: "No facturado",
            },
          },
          chatInput: {
            conversation: {
              doctor: "Asistente",
              patient: "Paciente",
            },
            copyTranscript: "Copiar transcripción",
            deleteEntry: {
              auditNote:
                "Nota: La transcripción original se conservará en el registro de auditoría con fines de mantenimiento de registros.",
              cancel: "Cancelar",
              confirm: "Eliminar",
              message: "¿Estás seguro de que deseas eliminar esta entrada de transcripción?",
              title: "Eliminar entrada de transcripción",
              tooltip: "Eliminar esta entrada de transcripción",
            },
            documents: {
              title: "Documentos",
            },
            historicalContext: {
              title: "Contexto histórico",
            },
            manualTranscription: {
              addCurrent: "Agregar contexto actual",
              addHistorical: "Agregar contexto histórico",
              placeholder: "Ingresa aquí una transcripción ",
              title: "Transcripción manual",
            },
            toast: {
              entryDeleted: "Entrada de transcripción eliminada",
              errorDeletingEntry: "Error al eliminar la entrada de transcripción",
              errorDeletingReassessment: "Error al eliminar la reevaluación",
              errorGeneratingReassessment: "Error al generar la reevaluación",
              generatingReassessment: "Generando reevaluación",
              reassessmentDeleted: "Reevaluación eliminada",
            },
            transcript: {
              recordPromptAfter: " para ver la transcripción.",
              recordPromptBefore: "Por favor ",
              recordPromptLink: "graba una nota",
              title: "Transcripción",
              totalTime: "Tiempo total de grabación: ",
              transcribing: "Transcribiendo",
            },
          },
          chatList: {
            errorLoading: "Error al cargar la nota {{id}}",
            noteTypeNotFound: "Tipo de nota {{type}} no ubicado",
            today: "Hoy",
            unknownDate: "Fecha desconocida",
            upcoming: "Próximas",
          },
          autoCorrect: {
            title: "Correcciones aplicadas",
            reviewTitle: "Elementos para revisar",
            undo: "Deshacer",
            undoAll: "Deshacer todo",
            dismiss: "Descartar",
            locateHint: "Haga clic para buscar en la nota",
            unifiedTag: "ortografía unificada",
            replacedTag: "reemplazado en todo",
            allergyTitle: "No corregido automáticamente: posible conflicto de alergia",
            allergyLooksLike: "parece ser",
            allergyConflict: "Sin cambios. Puede entrar en conflicto con una alergia indicada",
            allergyReview: "Por favor revise y corrija manualmente.",
            why: {
              "in-note": "escrito correctamente en otra parte de esta nota",
              route: "coincide con la vía de administración",
              class: "coincide con la clase del medicamento",
              consistency: "unificado con la ortografía usada en otra parte",
              match: "coincidencia de medicamento más cercana",
            },
          },
          noteCorrect: {
            replaceEverywhere: "Reemplazar en todo…",
            replaceLabel: 'Reemplazar "{{word}}" en todo por:',
            replacePlaceholder: "Palabra correcta",
            replaceApply: "Reemplazar todo",
            notRecognized: '"{{word}}" no está en la biblioteca de medicamentos',
            lowConfidence: "confianza baja",
            addToLibrary: "Agregar a la biblioteca de medicamentos",
            addedToLibrary: '"{{name}}" se agregó a su biblioteca de terminología',
            addFailed: "No se pudo actualizar la biblioteca de terminología",
          },
          seriousDx: {
            title: "Confirme estos diagnósticos",
            locate: "Buscar",
            confirm: "Confirmar",
          },
          signGate: {
            title: "Confirmar cambios de nombres de medicamentos por IA",
            body: "Lucas corrigió automáticamente estos nombres de medicamentos en esta nota. Confirme antes de firmar:",
            review: "Revisar primero",
            confirm: "Confirmar y firmar",
          },
          prevent: {
            title: "Riesgo Cardiovascular PREVENT (10 y 30 años)",
            model: {
              base: "Modelo base AHA PREVENT",
            },
            section: {
              demographics: "Datos demográficos",
              labs: "Valores de laboratorio",
              vitals: "Signos vitales e historia",
            },
            field: {
              sex: "Sexo",
              age: "Edad",
              totalC: "Colesterol total",
              hdlC: "Colesterol HDL",
              sbp: "Presión arterial sistólica",
              dm: "Diabetes",
              smoking: "Fumador actual",
              egfr: "eGFR",
              bpTx: "En medicación para la presión arterial",
              statin: "En estatina",
              bmi: "Índice de masa corporal (IMC)",
            },
            value: {
              select: "Seleccionar",
              female: "Femenino",
              male: "Masculino",
            },
            unit: {
              years: "años",
              mgdl: "mg/dL",
              mmhg: "mm Hg",
              egfr: "mL/min/1.73m²",
              bmi: "kg/m²",
            },
            yes: "Sí",
            no: "No",
            fromChart: "del expediente",
            fromCodes: "de los códigos del encuentro",
            fromLabs: "de laboratorio {{value}}",
            fromLabsEarlier: "de laboratorio {{value}} (visita anterior)",
            fromLabsUndated: "de laboratorio",
            fromMedList: "de la lista de medicamentos",
            fromNote: "de la nota",
            fromA1c: "de A1c {{value}}",
            fromA1cEarlier: "de A1c {{value}} (visita anterior)",
            results: {
              heading: "Riesgo estimado",
              tenYear: "10 años",
              thirtyYear: "30 años",
              spectrum: "ASCVD 10 años",
              spectrum30: "ASCVD 30 años",
              yr10: "10 años",
              yr30: "30 años",
              longTerm:
                "El riesgo a largo plazo (30 años) es más útil en pacientes jóvenes, donde el riesgo a 10 años subestima la exposición de por vida.",
            },
            scale: {
              lower: "Menor riesgo",
              higher: "Mayor riesgo",
            },
            outcome: {
              totalCvd: "Enfermedad cardiovascular total",
              ascvd: "ECV aterosclerótica (ASCVD)",
              heartFailure: "Insuficiencia cardíaca",
            },
            outcomeShort: {
              totalCvd: "ECV total",
              ascvd: "ASCVD",
              heartFailure: "Insuf. cardíaca",
            },
            band: {
              low: "Bajo",
              borderline: "Límite",
              intermediate: "Intermedio",
              high: "Alto",
            },
            guidance: {
              low: "Por debajo del nivel donde una estatina se justifica solo por el riesgo; priorice el estilo de vida.",
              borderline: "Zona de decisión compartida — considere factores que aumentan el riesgo antes de iniciar tratamiento.",
              intermediate: "Generalmente se favorece una estatina junto con asesoría sobre estilo de vida.",
              high: "Se recomienda modificación intensiva de factores de riesgo, incluida una estatina de alta intensidad.",
            },
            hf: {
              needsBmi: "Requiere IMC 18.5–39.9 para estimar",
            },
            notice: {
              ageRange: "PREVENT aplica a edades de 30 a 79 años. Ingrese una edad en este rango para ver los resultados.",
            },
            missing: {
              heading: "Complete los campos requeridos para ver los resultados",
            },
            empty: {
              hint: "Ingrese los valores restantes para calcular el riesgo a 10 y 30 años.",
            },
            range: {
              between: "Debe estar entre {{min}} y {{max}}",
            },
            disclaimer:
              "Las estimaciones de riesgo apoyan la toma de decisiones compartida y no reemplazan el juicio clínico — AHA PREVENT™.",
            copy: {
              button: "Copiar resultados",
              copying: "Copiando…",
              success: "Los resultados de PREVENT se copiaron al portapapeles.",
              error: "No se pudieron copiar los resultados de PREVENT. Inténtelo de nuevo.",
              summaryHeading: "RESUMEN DE RESULTADOS PREVENT:",
              totalCvd10: "Riesgo cardiovascular total a 10 años {{value}}",
              ascvd10: "Riesgo de ASCVD a 10 años: {{value}}",
              heartFailure10: "Riesgo de insuficiencia cardíaca a 10 años: {{value}}",
              totalCvd30: "Riesgo cardiovascular total a 30 años {{value}}",
              ascvd30: "Riesgo de ASCVD a 30 años: {{value}}",
              heartFailure30: "Riesgo de insuficiencia cardíaca a 30 años: {{value}}",
              ageUnavailable30: "Riesgo a 30 años: No disponible para personas de 60 a 79 años.",
              bmiUnavailable: "No disponible — se requiere un IMC entre 18.5 y 39.9.",
            },
            download: "Descargar folleto para el paciente (PDF)",
            pdf: {
              heading: "Sus Números de Salud Cardíaca",
              subtitle: "Un resumen de su riesgo cardíaco a 10 y 30 años",
              patient: "Paciente",
              date: "Fecha",
              heroLabel: "Su riesgo cardíaco a 10 años",
              ascvdCaption: "Riesgo a 10 años de ataque cardíaco o derrame (ASCVD)",
              numbersHeading: "Sus números",
              tenYear: "Próximos 10 años",
              thirtyYear: "Próximos 30 años",
              spectrumHeading: "Dónde se ubica",
              yourPosition: "Su riesgo a 10 años de ataque cardíaco o derrame es",
              meaningHeading: "Qué significa esto",
              interpretationLead:
                "De cada 100 personas con números como los suyos, alrededor de {{count}} podrían tener un problema del corazón o de los vasos sanguíneos en los próximos 10 años.",
              interpretationLeadRare:
                "Menos de 1 de cada 100 personas con números como los suyos podría tener un problema del corazón o de los vasos sanguíneos en los próximos 10 años.",
              bandExplanation: {
                low: "Se considera un nivel de riesgo bajo. Mantenga sus hábitos saludables.",
                borderline: "Se considera un nivel de riesgo límite. Pequeños cambios pueden ayudar a mantenerlo bajo.",
                intermediate: "Se considera un nivel de riesgo intermedio. Pregunte a su proveedor sobre cómo reducirlo.",
                high: "Se considera un nivel de riesgo alto. Su proveedor podría recomendar tratamiento para reducirlo.",
              },
              tipsHeading: "Formas de proteger su corazón",
              tips: {
                smoking: "Evite fumar y vapear",
                move: "Manténgase activo casi todos los días",
                eat: "Coma más verduras, frutas y granos integrales",
                numbers: "Conozca su presión arterial y colesterol",
                meds: "Tome los medicamentos según le indiquen",
              },
              inputsHeading: "Los números que usamos",
              notProvided: "No proporcionado",
              footer: "Hable con su proveedor antes de hacer cualquier cambio.",
              citation: "Basado en las ecuaciones de riesgo PREVENT™ de la American Heart Association.",
              error: "No se pudo generar el folleto para el paciente",
              ageUnavailable30: "El riesgo a 30 años no está disponible para personas de 60 a 79 años.",
            },
          },
          chatNote: {
            addAssessment: "Agregar evaluación",
            addAssessmentPick: "Elija el diagnóstico",
            addAssessmentNoCodes: "Agregue primero un código ICD-10 y luego agregue su evaluación aquí.",
            addAssessmentFailed: "No se pudo guardar la evaluación. Inténtelo de nuevo.",
            assignedTo: "Asignado a:",
            changeDispo: "Cambiar Disposición",
            procedureNote: "Nota de Procedimiento",
            sectionErrorHint: "Toca el botón de regenerar resaltado arriba para reconstruir esta sección",
            copy: {
              all: "Copiar todo",
              ap: "Copiar A/P",
              course: "Copiar curso",
              custom: "Copiar selección",
              obj: "Copiar Obj",
              subj: "Copiar Subj",
            },
            customizeNote: "Personalizar nota",
            edit: "Editar",
            editEncounter: "Editar encuentro",
            exportPdf: "Exportar PDF",
            preventCta: "Riesgo CV PREVENT",
            filters: {
              missingOnly: "Mostrar solo información faltante",
              suggestionsOnly: "Mostrar solo sugerencias",
            },
            insuranceGrid: "Cuadrícula de seguros",
            notAssigned: "Sin asignar",
            notGenerated: {
              after: " botón.",
              before: "La nota aún no ha sido generada, agrega contexto o ",
              generateLink: "generar",
              middle: " y luego haz clic en ",
              recordLink: "graba una nota",
            },
            noteFallback: {
              title: "No se pudo mostrar esta nota",
              refresh: "Actualizar",
              regenerate: "Regenerar nota",
            },
            oasis: {
              complete: "Sección completa",
              missing: "{{count}} faltantes",
            },
            orderDme: {
              comingSoon: "Próximamente",
              create: "Ordenar DME",
            },
            originEncounters: "Encuentros de origen",
            patientProfile: {
              medications: "Medicamentos",
              none: "No hay perfil del paciente disponible",
              problems: "Problemas",
              title: "Perfil del paciente",
            },
            previousEncounters: {
              back: "Volver a la lista",
              backShort: "Volver",
              close: "Cerrar historial del paciente",
              drawerTitle: "Historial del paciente",
              hide: "Ocultar",
              loadError: "No se pudieron cargar los encuentros",
              loadMore: "Cargar más",
              noteFallback: "Nota del encuentro",
              none: "No hay encuentros previos",
              openFull: "Abrir encuentro completo",
              openShort: "Abrir",
              previewError: "No se pudo cargar esta nota",
              retry: "Reintentar",
              showMore: "Mostrar más",
              signed: "Firmado",
              title: "Encuentros previos",
              viewAll: "Ver todos",
            },
            priorAuth: {
              create: "Crear autorización previa",
              lockToEnable: "Bloquear para habilitar",
            },
            reassign: {
              assignedTo: "Este chat está asignado a",
              confirm: "Reasignar",
              confirmQuestion: "¿Deseas reasignarlo?",
              inOrderToEdit: "Para editarlo debes asignártelo a ti mismo.",
              title: "Reasignar chat",
            },
            reportCard: "Reporte",
            requests: {
              review: "Revisar",
              title: "Solicitudes para aprobar",
            },
            reviewSpelling: "Revisar ortografía",
            toast: {
              originalRestored: "Contenido original restaurado",
            },
            errors: {
              regenerateFailed: "No se pudo regenerar {{section}}. Se restauró el contenido original.",
            },
            regenStatus: {
              phaseDrafting: "Redactando",
              phaseComposing: "Componiendo",
              phaseWriting: "Escribiendo",
              phaseOutlining: "Estructurando",
              phaseThinking: "Pensando",
              phaseAnalyzing: "Analizando",
              phaseReviewing: "Revisando",
              phaseReasoning: "Razonando",
              phaseThinkingHarder: "Analizando con más detalle",
              phaseCrossReferencing: "Cruzando referencias",
              phaseConsidering: "Considerando opciones",
              phaseConnectingDots: "Conectando ideas",
              phaseReasoningCarefully: "Razonando con cuidado",
              phaseStillWorking: "Seguimos trabajando",
              phasePolishing: "Puliendo",
              phaseRefining: "Refinando la redacción",
              phaseDoubleChecking: "Verificando todo",
              phaseAlmostThere: "Casi terminamos",
              phaseHangTight: "Un momento, ya casi",
              phaseWorkingNuance: "Trabajando los matices",
              phaseDone: "Listo",
              phaseAborted: "Edite manualmente",
            },
            tooltips: {
              copySection: "Copiar sección",
              editByVoice: "Editar sección por voz",
              editICD10: "Editar código",
              editSection: "Editar sección",
              editVitals: "Editar signos vitales",
              optimizeFromICD10: "Optimizar nota desde códigos",
              optimizeICD10: "Optimizar códigos",
              regenerateSection: "Regenerar sección",
              revertSection: "Revertir sección",
            },
            visitSummary: "Resumen de la visita",
            vitals: {
              bmi: "IMC",
              bp: "Presión",
              height: "Altura",
              none: "No hay signos vitales disponibles",
              pulse: "Pulso",
              rr: "FR",
              spO2: "Oxígeno",
              temp: "Temp",
              title: "Signos vitales",
              weight: "Peso",
            },
            trends: {
              viewButton: "Ver tendencias",
              viewButtonDisabledTooltip: "Se necesitan al menos 2 encuentros con datos de signos vitales o heridas",
              title: "Tendencias del paciente",
              historyCap: "Basado en los 50 encuentros más recientes registrados para este paciente.",
              tabs: {
                vitals: "Signos vitales",
                wound: "Herida",
              },
              rangeLabel: "Rango de tiempo",
              range: {
                all: "Todo el historial",
                90: "Últimos 90 días",
                180: "Últimos 6 meses",
                365: "Último año",
              },
              metrics: {
                temp: "Temp",
                hr: "Pulso",
                bpSystolic: "Presión (sistólica)",
                bpDiastolic: "Presión (diastólica)",
                spo2: "Oxígeno",
                rr: "FR",
                weight: "Peso",
                bmi: "IMC",
                totalSurfaceArea: "Área de superficie total",
                totalAreaWithDepth: "Área total con profundidad",
                percentImprovement: "% de mejora",
                percentImprovementDerived: "% de mejora (vs. inicial)",
                lengthCm: "Largo (cm)",
                widthCm: "Ancho (cm)",
                depthCm: "Profundidad (cm)",
                areaCm2: "Área de superficie (cm²)",
                areaWithDepthCm3: "Área con profundidad (cm³)",
                granulationPct: "Granulación (%)",
                sloughPct: "Esfacelo (%)",
                necroticPct: "Tejido necrótico (%)",
                epitheliumPct: "Epitelio (%)",
                escharPct: "Escara (%)",
                exudateAmount: "Cantidad de exudado",
                odor: "Olor",
                percentImprovementBaseline: "% de mejora (vs. inicial)",
                percentImprovementInterval: "% de mejora (vs. última visita)",
                percentImprovementRecorded: "% de mejora (registrado en la visita, no específico por herida)",
                painLevel: "Nivel de dolor (0–10)",
                progress: "Progreso",
                infectionSigns: "Signos de infección",
                tunneling: "Tunelización",
                undermining: "Socavamiento",
                drainageType: "Tipo de drenaje",
              },
              table: {
                date: "Fecha",
              },
              noData: "Aún no hay suficientes datos para graficar.",
              deltaUp: "Aumentó desde la última visita",
              deltaDown: "Disminuyó desde la última visita",
              deltaFlat: "Sin cambios desde la última visita",
              woundSelector: "Herida",
              axisPercent: "%",
              woundAmbiguous:
                "Se documentaron dos heridas en este sitio, por lo que los cambios en el tiempo no pueden atribuirse a una de ellas.",
              tissueIncomplete: "Solo se muestra el tejido documentado; el total puede ser inferior al 100%.",
              legacyHistoryHeading: "Mediciones adicionales registradas",
              flagOnset: "Inicio: {{flag}}",
              flagResolved: "Resolución: {{flag}}",
            },
            skeletonSimulation: {
              phaseTranscript: "Revisando la transcripción…",
              phaseChiefComplaint: "Identificando motivo de consulta…",
              phaseHPI: "Redactando historia de la enfermedad actual…",
              phaseROS: "Revisando sistemas…",
              phaseExam: "Resumiendo hallazgos del examen…",
              phaseAssessment: "Compilando evaluación…",
              phasePlan: "Redactando plan de atención…",
              phaseCoding: "Asignando códigos ICD-10…",
              phaseRefinement: "Verificando la nota…",
              phaseFinalizing: "Finalizando la nota…",
            },
          },
          common: {
            all: "Todas",
            areYouSure: "¿Está seguro?",
            back: "Atrás",
            cancel: "Cancelar",
            changeIsSaved: "Cambio guardado",
            confirm: "Confirmar",
            create: "Crear",
            creating: "Creando...",
            delete: "Eliminar",
            dismiss: "Descartar",
            done: "Listo",
            edit: "Editar",
            errorLoadingContent: "Error al cargar el contenido",
            errorReference: "Referencia",
            isRequired: "es obligatorio",
            labels: {
              completeRequiredDocuments: "Completar documentos requeridos",
              dataFields: "Campos de datos",
              emailSubject: "Asunto del correo",
              messageBody: "Cuerpo del mensaje",
              templateName: "Nombre de la plantilla",
            },
            loadMore: "Cargar más...",
            loading: "Cargando...",
            messageBuilder: {
              charCount: "{{count}} caracteres",
              composePlaceholder: "Escriba su mensaje...",
              noFieldsMatch: "Ningún campo coincide con su búsqueda.",
              searchFields: "Buscar campos...",
              subjectPlaceholder: "ej. Acción requerida: Autorización previa por vencer",
              templateNamePlaceholder: "ej. Aviso de expiración de autorización",
            },
            medicalLicense: {
              statePlaceholder: "Buscar estado…",
              numberPlaceholder: "Número de licencia",
              add: "Agregar",
              primary: "Principal",
              setPrimary: "Marcar principal",
              removeAria: "Eliminar licencia",
              hint: "Agregue una licencia por cada estado en el que la tenga. Volver a agregar un estado la actualiza.",
            },
            icd10Picker: {
              searchPlaceholder: "Busque por código o nombre (pruebe HTN, e119, presión alta)",
              typeToSearch: "Escriba al menos 2 caracteres para buscar en el índice",
              noResults: "No hay códigos coincidentes",
              loading: "Buscando códigos…",
              searchError: "No se pudo acceder al índice de códigos. Verifique su conexión e intente de nuevo.",
              familyHeader: "Códigos de la familia {{root}}",
              orgBadge: "Org",
              nonBillableBadge: "No facturable",
              nonBillableHidden: "{{count}} código(s) no facturable(s) oculto(s)",
              matchedVia: "coincide con {{term}}",
              pickCode: "Elegir código",
              swapHint: "Elegir un código diferente",
              noteCompliance: "Elija solo códigos que la documentación de esta nota respalde.",
            },
            mustBeValidYear: "Debe ser un año válido",
            next: "Siguiente",
            noItemsToShow: "No hay elementos para mostrar",
            noResults: "Sin resultados",
            offlineActionNotAllowed: "Acción no permitida sin conexión",
            openCalendar: "Abrir calendario",
            phoneNumber: "Número de teléfono",
            pleaseWait: "Por favor espera...",
            reloadApp: "Recargar app",
            searching: "Buscando...",
            remove: "Eliminar",
            requiredDocs: {
              benefit1: "Complete la configuración de su nueva cuenta",
              benefit2: "Firme los acuerdos requeridos digitalmente",
              benefit3: "Habilite pedidos de productos para su organización",
              completeNow: "Completar ahora",
              message:
                "Su organización tiene documentos requeridos que deben completarse. Esto incluye el Formulario de nueva cuenta, Autorización ACH, BAA y Acuerdo de compra.",
            },
            psaReminder: {
              title: "Firme su Acuerdo de Servicio de Productos",
              message:
                "Su fabricante requiere un Acuerdo de Servicio de Productos electrónico registrado antes de que se puedan enviar los pedidos. Firmar toma alrededor de un minuto.",
              benefit1: "Activa su capacidad de pedidos de DME",
              benefit2: "Registrado con marca de tiempo y auditoría para cumplimiento",
              benefit3: "Puede revisar el contrato completo antes de firmar",
              later: "Más tarde",
              signNow: "Firmar ahora",
            },
            receivedContractsReminder: {
              title: "Tiene un contrato por firmar",
              message:
                "Su fabricante le envió un contrato para revisar y firmar antes de que se puedan enviar los pedidos. Toma alrededor de un minuto.",
              messagePlural:
                "Su fabricante le envió {{count}} contratos para revisar y firmar antes de que se puedan enviar los pedidos.",
              benefit1: "Requerido antes de que se puedan procesar sus pedidos",
              benefit2: "Registrado con marca de tiempo y auditoría para cumplimiento",
              benefit3: "Puede revisar el contrato completo antes de firmar",
              later: "Más tarde",
              reviewNow: "Revisar y firmar",
            },
            save: "Guardar",
            saving: "Guardando...",
            search: "Buscar",
            today: "Hoy",
            skip: "Omitir",
            toasts: {
              copiedToClipboard: "Copiado al portapapeles",
              errorCopyingNotAuthorized: "Error al copiar al portapapeles: No Autorizado",
            },
            unknown: "Desconocido",
            update: "Actualizar",
            upload: {
              browseFolder: "Explorar carpeta",
              singlePageWarning: "Este tipo de archivo solo admite la carga de una sola página",
            },
            name: "Nombre",
            requiredDocsLock: {
              badge: {
                actionRequired: "Acción requerida",
                daysLeft_one: "Queda {{count}} día",
                daysLeft_other: "Quedan {{count}} días",
              },
              buttons: {
                close: "Cerrar",
                maybeLater: "Más tarde",
                signNow: "Firmar ahora",
              },
              description: {
                locked:
                  "Su plazo para firmar terminó. Hasta que firme los documentos de abajo, no se pueden firmar ni realizar pedidos.",
                nonSigner:
                  "El titular de la cuenta debe firmar estos documentos para que su organización pueda firmar o realizar pedidos.",
                reminder:
                  "Su plazo para firmar está por terminar. Firme los documentos de abajo para seguir firmando y realizando pedidos.",
              },
              docs: {
                contract: "Contrato",
                naf: "Formulario de Nueva Cuenta",
                psa: "Acuerdo de Servicio de Productos",
              },
              orderBlocked: "Sus documentos requeridos están vencidos. Fírmelos para firmar o realizar pedidos.",
              pill: {
                locked: "Bloqueado hasta firmar",
                reminder: "Firme para seguir ordenando",
              },
              status: {
                due: "Vence {{date}}",
                outstanding: "Pendiente",
                overdueSince: "Vencido desde {{date}}",
                signed: "Firmado",
                signedExternally: "Firmado externamente",
              },
              title: "Firme sus documentos requeridos",
            },
          },
          demo: {
            bannerMessage: "Estás viendo la plataforma en modo demo — sin datos reales ni llamadas a la API",
            exitDemo: "Salir de la demostración",
            roles: {
              manufacturer: "Fabricante",
              manufacturerDesc: "Gestión de pedidos y envíos",
              peptidesManufacturer: "Fabricante de Péptidos",
              peptidesManufacturerDesc: "Catálogo, precios, cumplimiento, analítica",
              peptidesPatient: "Paciente de Péptidos",
              peptidesPatientDesc: "Flujo de catálogo y pago para pacientes",
              peptidesProvider: "Proveedor de Péptidos",
              peptidesProviderDesc: "Clínica que ordena péptidos para pacientes",
              peptidesSalesDashboard: "Rep de Ventas de Péptidos",
              peptidesSalesDashboardDesc: "Panel de ventas + pedidos personales de péptidos",
              provider: "Proveedor",
              providerDesc: "Pedidos DME y cuidado de heridas",
              salesDashboard: "Panel de ventas",
              salesDashboardDesc: "Cuentas y rendimiento",
            },
            roleGroups: {
              dme: "DME",
              peptides: "Péptidos",
            },
            switchRole: "Cambiar rol",
          },
          impersonation: {
            badge: "SESIÓN DE SOPORTE",
            bannerMessage: "Estás viendo esta cuenta como {{user}}. Todo lo que hagas se registra bajo {{impersonator}}.",
            exit: "Salir",
            leaving: "Saliendo…",
          },
          subscriptionLapsed: {
            message:
              "Tu suscripción ha vencido, por lo que no puedes generar nuevos encuentros. Haz clic en Suscripción para renovar tu plan o contacta a {{email}}.",
            askAdmin:
              "Tu suscripción ha vencido, por lo que no puedes generar nuevos encuentros. Pide al administrador de tu cuenta que renueve el plan o contacta a {{email}}.",
            subscription: "Suscripción",
          },
          dmeBilling: {
            reminder: {
              benefit1: "Habilitar pedidos de productos para su organización",
              benefit2: "Configurar arreglos de facturación conformes",
              benefit3: "Obtener soporte de credenciales si es necesario",
              later: "Recordar más tarde",
              message:
                "Para comenzar a ordenar productos de colágeno, necesita completar su configuración de facturación DME. Esto solo toma unos minutos.",
              setupNow: "Configurar ahora",
              title: "Complete su configuración de facturación DME",
            },
            settings: {
              configured: {
                address: "Dirección",
                companyName: "Empresa",
                defaultButton: "Predeterminada",
                editButton: "Editar facturación DME",
                email: "Correo de facturación",
                manufacturerDme: "DME del fabricante",
                npi: "NPI del DME",
                nscNumber: "Número NSC",
                ownDme: "Empresa DME propia",
                ptan: "PTAN",
                removeButton: "Eliminar facturación DME",
                setDefaultButton: "Establecer como predeterminada",
                setupDate: "Fecha de configuración",
                status: "Estado",
                statusButton: "Completar configuración",
                taxId: "ID fiscal",
                title: "Facturación configurada",
                type: "Tipo de facturación",
                usingManufacturer: "Usando DME del fabricante para facturación",
              },
              info: {
                credentialing: "Nuestro equipo puede ayudarle a obtener la certificación DME si es necesario.",
                description:
                  "La facturación de Equipo Médico Duradero (DME) es necesaria para ordenar productos de colágeno. Esta configuración aplica a todos los proveedores de su organización.",
                manufacturerDme: "Si no tiene una empresa DME, el DME del fabricante manejará la facturación.",
                ownDme: "Si tiene su propia empresa DME, la facturación se procesará a través de su empresa.",
                title: "Acerca de la facturación DME",
              },
              notConfigured: {
                button: "Configurar facturación DME",
                description:
                  "Configure su facturación DME para comenzar a ordenar productos de colágeno. Esta configuración aplica a toda su organización.",
                supervisorOnly: "Solo los supervisores pueden configurar la facturación DME. Por favor contacte a su supervisor.",
                title: "Facturación no configurada",
              },
              title: "Facturación DME",
            },
            wizard: {
              confirmation: {
                address: "Dirección",
                credentialingPending: "El equipo de credenciales se comunicará con usted para la certificación DME",
                manufacturerDme: "DME del fabricante",
                ownDme: "Empresa DME propia",
                status: "Estado",
                title: "Confirme su configuración de facturación DME",
                type: "Tipo de facturación",
              },
              error: "Error al guardar la información DME",
              manufacturer: {
                bridgeText:
                  "Mientras no tenga su propia empresa DME, puede usar el DME del fabricante para facturar productos de colágeno. Nuestro equipo de credenciales le asistirá en obtener la certificación DME para que eventualmente pueda facturar bajo su propio DME.",
                bridgeTitle: "Solución puente",
                complianceText:
                  "Las regulaciones federales Anti-Soborno prohíben compartir ganancias de la facturación DME. Esto significa que no podemos proporcionar ninguna porción de los reembolsos DME a su práctica.",
                complianceTitle: "Cumplimiento Anti-Soborno",
                disclaimer:
                  "Al proceder, autoriza al equipo de credenciales a iniciar el proceso de certificación DME para su práctica. El fabricante será notificado para iniciar el flujo de credenciales.",
                helpText:
                  "Nuestro equipo le guiará a través del proceso de certificación DME sin costo adicional. Esto típicamente toma 90-120 días.",
                helpTitle: "Soporte de credenciales",
                title: "Usar DME del fabricante",
              },
              ownDme: {
                address: "Dirección",
                city: "Ciudad",
                companyName: "Nombre de la empresa",
                email: "Correo de facturación",
                nscNumber: "Número NSC",
                nscNumberPlaceholder: "10 dígitos",
                phone: "Teléfono",
                ptan: "PTAN #",
                ptanPlaceholder: "6-10 caracteres",
                selectState: "Seleccionar estado",
                state: "Estado",
                subtitle: "Por favor proporcione los detalles de su empresa DME para facturación.",
                taxId: "ID fiscal / EIN",
                title: "Información de la empresa DME",
                zip: "Código postal",
              },
              question: {
                no: "No, no tengo una empresa DME",
                noShort: "No",
                subtitle: "Esto nos ayuda a configurar el método de facturación correcto para productos de colágeno.",
                title: "¿Tiene su propia empresa DME?",
                yes: "Sí, tengo mi propia empresa DME",
                yesShort: "Sí",
              },
              success: "Configuración de facturación DME completada",
              title: "Configuración de facturación DME",
              validation: {
                address: "La dirección es requerida",
                agreement: "Por favor acepte los términos para continuar",
                city: "La ciudad es requerida",
                companyName: "El nombre de la empresa es requerido",
                email: "El correo de facturación es requerido",
                nscNumber: "El número NSC debe tener exactamente 10 dígitos",
                phone: "El teléfono es requerido",
                ptan: "El PTAN debe tener entre 6 y 10 caracteres",
                selectOption: "Por favor seleccione una opción",
                state: "El estado es requerido",
                taxId: "El ID fiscal debe estar en formato XX-XXXXXXX",
                zip: "El código postal es requerido",
              },
            },
          },
          dmeCredentialing: {
            actions: {
              approve: "Aprobar Acreditación",
              completed: "Completado",
              markComplete: "Marcar Completado",
              startProcess: "Iniciar Procesamiento",
            },
            checklist: {
              accreditation: {
                accreditationCert: "Certificación aprobada por CMS (ACHC, HQAA, BOC, etc.)",
                financialProFormas: "Pro Formas Financieros (si lo requiere el estado)",
                liabilityInsurance: "Certificado de Seguro de Responsabilidad ($300K mín)",
                policyManual: "Manual de Políticas y Procedimientos (SOPs)",
                suretyBond: "Fianza DMEPOS ($50,000)",
                title: "Certificación y Estándares de Calidad",
              },
              add: "Agregar",
              addError: "Error al agregar tarea",
              addTask: "Agregar Tarea Personalizada",
              cancel: "Cancelar",
              completed: "completados",
              completedBy: "Completado por",
              corporate: {
                articles: "Artículos de Incorporación / Organización",
                ein: "ID Fiscal Federal (EIN) - Carta IRS CP-575 o Formulario 147-C",
                lease: "Contrato de Arrendamiento (ubicación física)",
                npi: "Número NPI (Identificador Nacional de Proveedor)",
                title: "Fundación Corporativa y Empresarial",
                zoning: "Permiso de Zonificación",
              },
              deleteError: "Error al eliminar tarea",
              deleteTask: "Eliminar tarea",
              documentUploaded: "Documento subido",
              medicare: {
                backgroundCheck: "Verificación de Antecedentes / Huellas Dactilares",
                cms588: "Formulario CMS-588 (Autorización EFT)",
                cms855s: "Formulario CMS-855S",
                title: "Inscripción en Medicare (CMS-855S)",
                voidedCheck: "Cheque Anulado de la Empresa",
              },
              of: "de",
              other: {
                title: "Otros",
              },
              replaceDoc: "Reemplazar documento",
              state: {
                dmeStateLicense: "Licencia Estatal de Proveedor DME",
                foreignEntity: "Registro de Entidad Extranjera (si opera en múltiples estados)",
                professionalLicense: "Licencias Profesionales (si aplica)",
                salesTax: "Permiso de Impuesto sobre Ventas / Certificado de Reventa",
                title: "Licencias a Nivel Estatal",
              },
              taskAdded: "Tarea agregada",
              taskDeleted: "Tarea eliminada",
              taskLabel: "Ingrese descripción de la tarea...",
              updateError: "Error al actualizar lista de verificación",
              uploadDoc: "Subir documento",
            },
            documents: {
              accreditation: "Certificado de Certificación",
              businessLicense: "Licencia Comercial",
              liability: "Seguro de Responsabilidad",
              npi: "Documentación NPI",
              other: "Otros Documentos",
              taxId: "ID Fiscal / W-9",
            },
            drawer: {
              accreditationComplete: "Aprobado",
              awaitingDocs: "Recolección de Documentos",
              awaitingDocsInfo: "Esperando que el proveedor suba los documentos requeridos",
              contactInfo: "Información de Contacto",
              contactName: "Nombre de Contacto",
              credentialingComplete: "Acreditación Aprobada",
              documentRequest: "Solicitud de Documento",
              documentRequested: "Documento solicitado",
              email: "Correo Electrónico",
              inReview: "En Revisión",
              messageError: "Error al enviar mensaje",
              messageSent: "Mensaje enviado",
              needsDocs: "Esperando subidas",
              noMessages: "No hay mensajes aún. Inicie la conversación para comenzar el proceso de acreditación.",
              notUploaded: "No subido",
              phone: "Teléfono",
              processing: "Procesando",
              request: "Solicitar",
              requestDate: "Fecha de Solicitud",
              requestDoc: "Solicitar:",
              requestError: "Error al solicitar documento",
              submitted: "Solicitud Enviada",
              tabs: {
                checklist: "Lista de Verificación",
                conversation: "Conversación",
                details: "Detalles",
                documents: "Documentos",
              },
              timeline: "Línea de Tiempo",
              typePlaceholder: "Escriba un mensaje...",
              uploadedOn: "Subido",
              view: "Ver",
              reminderSent: "Recordatorio enviado",
            },
            errorFetching: "Error al obtener solicitudes de acreditación",
            errorUpdating: "Error al actualizar el estado",
            filter: {
              all: "Todas",
              approved: "Aprobada",
              awaitingDocuments: "Esperando Documentos",
              completed: "Completadas",
              inProgress: "En Progreso",
              pending: "Pendientes",
              pendingReview: "Revisión Pendiente",
              processing: "Procesando",
            },
            kanban: {
              dropHere: "Suelte aquí para cambiar el estado",
              emptyColumn: "Sin solicitudes",
            },
            noRequests: "Sin solicitudes de acreditación",
            noRequestsDescription: "Ninguna organización de proveedores ha solicitado acreditación DME aún.",
            noRequestsFiltered: "Ninguna solicitud coincide con el filtro actual.",
            requestedOn: "Solicitado",
            requests: "Solicitudes",
            status: {
              approved: "Aprobado",
              awaitingDocuments: "Esperando Documentos",
              completed: "Completado",
              inProgress: "En Progreso",
              pending: "Pendiente",
              pendingReview: "Revisión Inicial Pendiente",
              processing: "Procesando",
            },
            statusUpdated: "Estado actualizado exitosamente",
            subtitle: "Organizaciones de proveedores que han solicitado asistencia de acreditación DME",
            table: {
              actions: "Acciones",
              contact: "Contacto",
              email: "Correo Electrónico",
              organization: "Organización",
              phone: "Teléfono",
              requestDate: "Fecha de Solicitud",
              status: "Estado",
            },
            title: "Solicitudes de Acreditación DME",
            viewMode: {
              grid: "Vista de Tabla",
              kanban: "Vista Kanban",
            },
            reminder: {
              email: "Correo electrónico (cuentas de supervisor)",
            },
          },
          doctorTypes: {
            allergyImmunology: "Alergólogo/Inmunólogo",
            behavioral: "Especialista en Salud Conductual",
            cardiologist: "Cardiólogo",
            dentist: "Dentista",
            dermatology: "Dermatólogo",
            endocrinologist: "Endocrinólogo",
            er: "Médico de Urgencias",
            gastroenterologist: "Gastroenterólogo",
            generalSubspecialty: "Subespecialista General",
            generalSurgery: "Cirujano General",
            homeHealth: "Médico de Salud en el Hogar",
            hospitalist: "Hospitalista",
            infectiousDiseases: "Infectólogo",
            intensivist: "Intensivista",
            internist: "Internista",
            medicalOncology: "Oncología Médica",
            nephrologist: "Nefrólogo",
            neuroOrthoSpine: "Neurocirujano/Cirujano de Columna",
            neurologist: "Neurólogo",
            obgyn: "Ginecólogo/Obstetra",
            oncologist: "Oncólogo Médico",
            orthopedicSurgeon: "Cirujano Ortopédico",
            otolaryngologists: "Otorrinolaringólogo",
            painmgmt: "Especialista en Manejo del Dolor",
            paramedics: "Paramédico",
            pediatrician: "Pediatra",
            physicalTherapist: "Fisioterapeuta",
            podiatry: "Podólogo",
            primaryCare: "Médico de Atención Primaria",
            radonc: "Radio-Oncólogo",
            rheumatologist: "Reumatólogo",
            urologist: "Urólogo",
            woundCare: "Especialista en Cuidado de Heridas",
          },
          ehr: {
            editField: {
              alwaysInclude: "Incluir siempre",
              conditionType: "Tipo de condición",
              conditionValue: "Valor de condición",
              description: "Descripción",
              ehrExistingElements: "Elementos existentes del Registro Electrónico",
              ehrNewElement: "Nuevo elemento del Registro Electrónico",
              element: "Elemento",
              elementType: "Tipo de elemento",
              enabled: "Habilitada",
              enabledHint: "Desactivar salta esta acción durante la sincronización sin eliminarla de la plantilla.",
              enterJSCode: "Ingrese código JavaScript aquí...",
              eventType: "Tipo de evento",
              execute: "Ejecutar",
              expression: "Expresión",
              expressionInJS: "Expresión en JS",
              fingerprint: {
                cssSelector: "Selector CSS",
                dataAttributes: "Atributos de datos",
                fieldType: "Tipo de campo",
                hash: "Hash de huella digital",
                label: "Etiqueta (detectada)",
                noData: "No se capturó huella digital. Reasigne este campo para capturar datos de huella digital.",
              },
              fingerprintData: "Datos de huella digital",
              getFieldFromPanel: "Obtener campo del panel izquierdo",
              highlightInPanel: "Resaltar campo en el panel izquierdo",
              javascript: "Javascript",
              javascriptCode: "Código JavaScript",
              jsonConfiguration: "Configuración JSON",
              milliseconds: "Milisegundos",
              notEmpty: "No vacío",
              options: {
                blur: "Desenfocar",
                class: "Clase",
                click: "Clic",
                clickIfExists: "Clic si existe",
                focus: "Enfocar",
                focusout: "Salir de foco",
                id: "Id",
                input: "Entrada",
                keydown: "Tecla abajo",
                keyup: "Tecla arriba",
                name: "Nombre",
                tinymce: "Tinymce",
                wysihtml: "WYSIHTML",
                xpath: "XPath",
              },
              pageConfiguration: "Configuración de página (JSON)",
              prompt: "Indicación",
              rawJson: "JSON de la acción",
              rawJsonApply: "Aplicar JSON",
              rawJsonFallbackInfo:
                'No existe un editor dedicado para el tipo de acción "{{type}}". Edita el JSON sin formato a continuación y haz clic en Aplicar para guardar.',
              rawJsonMustBeArray: "Este campo debe ser un arreglo JSON.",
              rawJsonMustBeObject: "El JSON de la acción debe ser un objeto.",
              rawJsonRequiresType: 'El JSON de la acción debe incluir un campo "type".',
              rawJsonSaved: "Guardado",
              rawJsonUnsaved: "Cambios JSON sin guardar",
              sectionName: "Nombre de sección",
              title: "Editar {{type}}",
              unsupportedActionType: "Tipo de acción no compatible: {{type}}",
              useCDP: "Usar CDP (clic de confianza)",
              verifySelector: "Selector de verificación",
              verifySelectorHint: "Elemento que debe aparecer después del clic",
              verifyElementType: "Tipo de elemento de verificación",
              verifyTimeoutMs: "Tiempo de espera de verificación (ms)",
              verifyTimeoutMsHint: "Predeterminado 10000, máx. 60000",
              retryClicks: "Intentos de reclic",
              retryClicksHint: "0–20, 0 = un solo clic (+1 clic CDP si la escalación está activada)",
              retryWaitMs: "Espera entre reclics (ms)",
              retryWaitMsHint: "Predeterminado 2000",
              allowCdpEscalation: "Permitir escalamiento a CDP",
              disabledSelector: "Selector de deshabilitado",
              disabledSelectorHint: "Opcional. Una coincidencia visible significa que el control está en gris (deshabilitado)",
              useCopyAll: "Usar formato Copy All (omite Valor, formatea la nota como el botón Copy All)",
              value: "Valor",
              valueIgnoredCopyAll: "Ignorado — se usa el formateador Copy All",
              variableName: "Nombre de variable",
              valueSource: "Fuente de valor",
              codeProperty: "Propiedad de código",
              valueProperty: "Propiedad de valor",
              fixedValue: "Valor fijo",
              numericOnly: "Solo numérico",
              fieldSelectorTemplate: "Plantilla de selector de campo",
              treatAsSingle: "Tratar como único",
              waitTime: "Tiempo de espera",
              targetVariable: "Variable destino",
              carrierSources: "Fuentes de lectura de aseguradora (JSON)",
              planSources: "Fuentes de lectura de plan (JSON)",
              dobSources: "Fuentes de lectura de fecha de nacimiento (JSON)",
              insuranceRules: "Tabla de reglas de seguro (JSON)",
            },
            executeTestEHR: {
              chatLabel: "Chat",
              description: "Esto ejecutará solo los pasos de configuración.",
              execute: "Ejecutar",
              selectTab: "Seleccionar una pestaña",
              tabLabel: "Pestaña",
              testDescription: "Esto es útil para probar la configuración sin ejecutar la plantilla completa.",
              title: "Ejecutar configuración",
              tooltip: {
                highlightInPanel: "Resaltar en el panel izquierdo",
              },
            },
            selectTab: {
              chatLabel: "Chat",
              execute: "Ejecutar",
              selectTab: "Seleccionar una pestaña",
              tabLabel: "Pestaña",
              title: "Seleccionar parámetros de ejecución",
              toast: {
                selectChat: "Por favor seleccione un chat para ejecutar",
                selectTab: "Por favor seleccione una pestaña para ejecutar",
              },
            },
            smartPaste: {
              appliedSuccess: "{{section}} aplicado exitosamente. Haga clic en Siguiente.",
              apply: "Aplicar",
              applyFailed:
                "Error al aplicar. {{section}} copiado al portapapeles. Pegue en su EHR, luego haga clic en Siguiente.",
              applying: "Aplicando...",
              confirmDismiss: "¿Está seguro? Las secciones no fueron sincronizadas.",
              copiedToClipboard: "{{section}} copiado al portapapeles. Pegue en su EHR, luego haga clic en Siguiente.",
              copyAgain: "Copiar de nuevo",
              description: "Pegado inteligente le guiará a través de cada sección. Aplique o pegue cada una en su EHR.",
              navigateAndApply: "Navegue a {{section}} en su EHR, luego haga clic en Aplicar.",
              sectionsNotSynced: "{{count}} sección no se pudo sincronizar",
              selectDropdown: "Seleccione {{content}} del menú desplegable {{section}} en su EHR, luego haga clic en Siguiente.",
              title: "Pegado inteligente",
            },
            syncEhr: {
              close: "Cerrar",
              currentStep: "Paso actual: {{current}} / {{total}}",
              doNotChangeTab: "No cambies de pestaña",
              errorOccurred: "Ocurrió un error durante la sincronización",
              errors_one: "{{count}} Error:",
              errors_other: "{{count}} Errores:",
              retry: "Reintentar",
              section: "Sección: {{section}}",
              showTab: "Mostrar pestaña",
              stop: "Detener",
              synchronized: "El encuentro se ha sincronizado con el Registro Electrónico",
              synchronizing: "El encuentro se está sincronizando con el Registro Electrónico.",
              title: "Sincronizar Registro Electrónico",
              errors: "Errores",
            },
          },
          ehrTemplates: {
            actions: {
              createNewTemplate: "Crear nueva plantilla",
            },
            columns: {
              encounterType: "Tipo de encuentro",
            },
            filters: {
              encounterType: "Tipo de encuentro",
              name: "Nombre",
              system: "Sistema",
            },
            title: "Plantillas Registro Electrónico",
          },
          filters: {
            filterBy: "Filtrar por",
            group: {
              label: "Grupo",
              myPatients: "Mis Pacientes",
              team: "Equipo",
            },
            order: {
              alphabetical: "Alfabético",
              createdOn: "Creado en",
              lastUpdate: "Última Actualización",
              visitTime: "Fecha de visita",
            },
            orderBy: "Ordenar por",
            reverse: "Invertir orden",
            status: {
              deleted: "Eliminado",
              draft: "Borrador",
              generated: "Generado",
              locked: "Finalizado",
            },
          },
          header: {
            importingEncounter: "Importando encuentro...",
            notesLeft: "{{count}} notas restantes",
            switchToDark: "Cambiar a modo oscuro",
            switchToLight: "Cambiar a modo claro",
            upgradeNow: "Actualizar ahora",
          },
          healthCheck: {
            close: "Cerrar",
            internet: {
              belowRecommended: "Conexión por debajo de la velocidad recomendada",
              connectionIssue: "Problema de conexión",
              download: "Descarga",
              failed: "La prueba de velocidad falló",
              fix: {
                apps: "Cierre aplicaciones que consumen mucho ancho de banda",
                restart: "Reinicie el enrutador si es necesario",
                router: "Acérquese a su enrutador",
                wifi: "Verifique la conexión WiFi o Ethernet",
              },
              label: "Internet",
              latency: "Latencia",
              measuringLatency: "Midiendo latencia...",
              testingDownload: "Probando velocidad de descarga...",
              timedOut: "La prueba expiró",
              warmingUp: "Preparando...",
            },
            mic: {
              accessDenied: "Acceso al micrófono denegado",
              busy: "El micrófono está en uso",
              checkedOnRecord: "El permiso del micrófono se comprobará al iniciar la grabación",
              checkFailed: "La verificación del micrófono falló",
              stopped: "La verificación del micrófono se detuvo",
              notCurrent: "La verificación del micrófono ya no está activa",
              checking: "Verificando micrófono...",
              fix: {
                allowPermissions: "Permita los permisos del micrófono",
                lockIcon: "Haga clic en el icono de candado en la barra de direcciones",
                mobileOtherApp: "Asegúrese de que ninguna otra aplicación esté usando el micrófono",
                mobileRestart: "Reinicie la aplicación e intente de nuevo",
                mobileSettings: "Vaya a Configuración y permita los permisos del micrófono",
                pluggedIn: "Verifique que el micrófono esté conectado",
                refreshPage: "Actualice la página después de otorgar acceso",
              },
              label: "Micrófono",
              noAudio: "No se detectó audio",
              noDevice: "No se encontró ningún micrófono",
              notConfirmed: "No confirmado",
              notSupported: "Micrófono no compatible",
              speakToTest: "Hable para probar...",
              timedOut: "La verificación del micrófono expiró. Inténtelo de nuevo.",
              unavailable: "El micrófono no está disponible. Cierre otras aplicaciones e inténtelo de nuevo.",
              working: "Micrófono funcionando",
            },
            notTested: "No probado",
            recheck: "Verificar",
            recheckSystem: "Verificar de nuevo",
            runningChecks: "Ejecutando verificaciones...",
            services: {
              checking: "Verificando...",
              connected: "Conectado",
              degraded: "Degradado",
              fix: {
                contactIT: "Contacte a soporte técnico si el problema persiste",
                logOut: "Intente cerrar sesión y volver a iniciar",
                verifyNetwork: "Verifique la conexión de red",
              },
              label: "Servicios de {{brand}}",
              labelGeneric: "Servicios",
              unavailable: "No disponible",
              unreachable: "No se puede conectar a los servicios",
            },
            summary: {
              allReady: "Todos los sistemas listos",
              criticalIssues: "Se detectaron problemas críticos",
              fixIssues: "Por favor corrija los problemas a continuación antes de grabar",
              moment: "Esto solo tomará un momento",
              readyToRecord: "Está listo para comenzar a grabar",
              reviewIssues: "Por favor revise los problemas a continuación",
              running: "Ejecutando verificaciones del sistema",
              someIssues: "Se detectaron algunos problemas",
              subtitle: "Ejecutamos una prueba rápida de su conexión y dispositivos",
              title: "Verificación del sistema",
            },
            test: "Probar",
          },
          hooks: {
            useChats: {
              changesStoredOffline: "Cambios guardados sin conexion",
              chatNotFoundForGeneration: "Chat no encontrado para generacion",
              customNoteTemplateNotFound: "Plantilla de nota personalizada no encontrada. Puede haber sido eliminada.",
              encounterNotSelected: "Encuentro no seleccionado",
              emptyTranscriptCantGenerate:
                "La transcripción está vacía — es posible que la grabación no se haya guardado. Grabe de nuevo, revise Grabaciones Locales o agregue una entrada manual.",
              errorProcessingRecording: "Error al procesar la grabacion",
              errorTranscribing: "Error al transcribir: {{error}}",
              errorUpdatingChat: "Error al actualizar el chat",
              errorUpdatingEncounter: "Error al actualizar el encuentro",
              generateNoteFirst: "Por favor genere la nota primero",
              generatingNote: "Generando nota para {{lastName}} {{firstName}}",
              generationComplete: "Generacion completada",
              generationError: "Error de generacion",
              loadingError: "Error de carga",
              noOptionsFoundToUpdate: "No se encontraron opciones para actualizar",
              noteSigned: "Nota firmada para {{lastName}} {{firstName}}",
              noteUpdated: "Nota actualizada",
              encounterAssignedToYou: "Encuentro asignado a usted",
              encounterStaysAssignedOffline:
                "Guardado sin conexión. Su cambio se sincronizará, pero este encuentro sigue asignado a su clínico actual.",
              encounterAssignmentRefused: "No se pudo asignar este encuentro a usted, por lo que su cambio no se guardó",
              icd10Updated: "Se actualizaron los códigos ICD-10",
              processingRecording: "Procesando grabacion...",
              recordNoteFirstOrAddDocument: "Por favor grabe una nota primero o agregue un documento",
              recordingParsedWhenOnline: "La grabacion se procesara cuando este en linea",
              recordingReady: "Grabacion lista",
              reportCardUpdated: "Boletin actualizado exitosamente",
              selectEncounterTypeFirst: "Por favor seleccione un tipo de encuentro primero",
              transcriptionCompleted: "Transcripcion completada",
              transcriptionReady: "Su transcripción está lista",
              transcriptionNotSaved:
                "La transcripción no se guardó — tu audio se conserva en el dispositivo. Reintenta desde Grabaciones Locales.",
              transcriptionStalled: "La transcripción no terminó — tu audio está guardado. Toca aquí para recargar.",
              unableToLoadEncounters: "No se pudieron cargar los encuentros",
              wrongPin: "PIN incorrecto",
            },
            useEHR: {
              cannotFindActiveTab: "No se puede encontrar la pestana activa",
              chromeExtensionNotAvailable: "Extension de Chrome no disponible",
              errorDuringImport: "Error durante la importacion, por favor intente de nuevo.",
              errorFindingFields: "Error al encontrar los campos solicitados en el panel izquierdo",
              errorParsingTemplateConfig: "Error al analizar la configuracion de la plantilla de EHR",
              extensionNotAvailable: "Extension no disponible",
              extensionNotAvailableInstall: "Extension LucasAI no disponible, por favor instalela desde la tienda de Chrome.",
              extensionNotConnected: "Extension no conectada",
              fieldNotFound: "Campo no encontrado",
              fieldsHighlighted: "Campos resaltados en la interfaz del EHR",
              importNotSupported: "Importacion no soportada para EHR {{ehrSystem}}.",
              noEhrTemplatesFound: "No se encontraron plantillas de EHR para nota '{{encounterType}}' en EHR '{{ehrSystem}}'.",
              noElementSelected: "No se selecciono ningun elemento en el panel izquierdo",
              noEncountersFound: "No se encontraron encuentros, por favor abra el horario en el EHR",
              templateNoActions: "Esta plantilla no tiene acciones, por favor editela en la pagina de configuracion.",
            },
            useIndexDb: {
              recordingUndecodable:
                "No se pudo procesar el audio de una grabación. Permanece en este dispositivo: abra Grabaciones locales para guardarla o reintentar.",
              errorAddingRecording: "Error al agregar la grabacion al almacen",
              errorSavingRecording: "Error al guardar la grabacion",
              recordingSyncedLater: "La grabacion se sincronizara despues",
              recordingUploadPending:
                "Una grabacion aun no se pudo subir. Esta guardada y se seguira reintentando automaticamente.",
              sessionExpiredRelogin: "Tu sesion expiro. Inicia sesion de nuevo para subir tus grabaciones guardadas.",
              recordingEncounterGone:
                "Una grabación guardada pertenece a una consulta que ya no existe. No se reintentará automáticamente — puedes revisarla o eliminarla en Grabaciones.",
              recordingIdentityParked:
                "Una grabación guardada no parece pertenecer a su consulta, por lo que no se adjuntó. Permanece en Grabaciones para que la revises.",
              recordingPartiallyProcessed:
                "Parte de esta grabación no se pudo procesar. La nota se guardó con el audio que pudimos leer; por favor revísala por si faltan partes.",
              recordingsUploadSummary: "Grabaciones aún subiendo ({{count}}) — toca para administrar",
              recoveredCouldNotAttachSigned: "No se pudo adjuntar una grabación recuperada: la nota ya está firmada.",
              recoverFailed: "No se pudo recuperar la grabación. Inténtalo de nuevo o abre el dispositivo donde se grabó.",
            },
            useJobs: {
              newRequestReceived: "Nueva solicitud recibida",
            },
            useMediaLibrary: {
              cannotMoveIntoSelf: "No se puede mover una carpeta dentro de si misma",
              cannotMoveIntoSubfolder: "No se puede mover una carpeta dentro de su propia subcarpeta",
              failedToCreateFolder: "Error al crear la carpeta",
              failedToDelete: "Error al eliminar",
              failedToMoveItems: "Error al mover los elementos",
              failedToRename: "Error al renombrar",
              failedToUpload: 'Error al subir "{{filename}}"',
              folderCreated: "Carpeta creada",
              itemDeleted: "Elemento eliminado",
              itemMoved: "Elemento movido",
              itemsDeleted: "{{count}} elementos eliminados",
              itemsMoved: "{{count}} elementos movidos",
              renamedSuccessfully: "Renombrado exitosamente",
            },
            useOrdersStats: {
              failedToLoadAccountData: "Error al cargar datos de la cuenta",
            },
            usePeptideCart: {
              itemsFromLastSession: "{{count}} articulo(s) de su ultima sesion",
              selectFormTypeMigration: "Selecciona Activo o Liofilizado para cada producto antes de pagar.",
            },
            usePeptidePricing: {
              failedToSaveProviderTier: "Error al guardar el nivel del proveedor",
              failedToSaveCustomPricing: "Error al guardar los precios personalizados",
              failedToLoadOwnedCustomPricing:
                "No se pudieron cargar los precios personalizados guardados. Actualiza para reintentar.",
              failedToSaveRetailPricing: "No se pudieron guardar los precios del paciente.",
            },
            usePostMessages: {
              backOnline: "Esta de vuelta en linea",
              done: "Listo",
              encountersSynced: "{{count}} encuentro(s) sincronizado(s)",
              errorSyncingOfflineData: "Error al sincronizar datos sin conexion para {{chatId}}",
              offlineDiffGivenUp:
                "Los cambios sin conexión de la consulta {{chatId}} no se pudieron guardar tras varios intentos y se descartaron. Por favor vuelve a ingresarlos.",
              errorSyncingRecording: "Error al sincronizar grabacion {{recordingId}}",
              recordingEncounterGone:
                "La grabación {{recordingId}} pertenece a una consulta que ya no existe. No se reintentará automáticamente; el audio permanece en tu dispositivo.",
              microphoneNotAvailable: "Microfono no disponible",
              nowOffline: "Ahora esta sin conexion",
              optimizingRecording: "Optimizando su grabación",
              preparingTranscription: "Preparando su transcripción",
              reAuthRequired: "Se requiere re-autenticacion",
              recordingNotSavedRetry:
                "Esta grabación aún no se ha guardado. Su audio está seguro en este dispositivo — toque para reintentar ahora.",
              savedOfflineWillSync: "Guardado en este dispositivo — se sincronizará cuando vuelva a estar en línea",
              syncingRecording: "Sincronizando grabacion {{recordingId}}...",
              uploadingRecording: "Subiendo su grabación",
            },
            useRecorder: {
              cannotStartRecording: "No se puede iniciar la grabacion",
              cannotStartRecordingDevice: "No se puede iniciar la grabacion con el dispositivo seleccionado",
              errorSavingRecording: "Error al guardar la grabacion",
              errorSavingRecordingWeb: "Error al guardar la grabacion desde la web",
              lostRecordingTitle: "Grabación no guardada",
              lostRecordingBody:
                "No hemos confirmado que la grabación iniciada a las {{when}} se haya guardado. Es posible que aún se pueda recuperar en este dispositivo.",
              lostRecordingStartBlocked:
                "Las nuevas grabaciones están pausadas hasta que se recupere esta grabación. Cerrar este mensaje mantiene esa protección.",
              lostRecordingTryRecover: "Intentar recuperar",
              lostRecordingRecovering: "Recuperando…",
              lostRecordingCheckLocal: "Revisar Grabaciones Locales",
              lostRecordingDismiss: "Cerrar",
              lostRecordingVerifyTitle: "Verificar grabación recuperada",
              lostRecordingVerifyBody:
                "Se guardó una grabación de esta consulta. Compruebe que la transcripción de su grabación iniciada a las {{when}} esté completa. Al confirmar, podrá iniciar nuevas grabaciones.",
              lostRecordingConfirmRecovered: "Verifiqué la transcripción",
              lostRecordingStartFailedTitle: "Revisar el inicio de la grabación",
              lostRecordingStartFailedBody:
                "El micrófono informó de un problema al iniciar su grabación a las {{when}}. Si no se grabó audio, confirme abajo para borrar este intento y permitir una nueva grabación. Si se grabó algún audio, revise Grabaciones Locales en su lugar.",
              lostRecordingStartFailedBlocked:
                "Las nuevas grabaciones están pausadas hasta que confirme que no se grabó audio o recupere la grabación. Cerrar este mensaje mantiene esa protección.",
              lostRecordingConfirmEmptyStart: "No se grabó audio",
              lostRecordingNotRecovered:
                "La recuperación automática no terminó. Revise Grabaciones Locales. Si la grabación sigue bloqueada, contacte a soporte para obtener ayuda con su recuperación.",
              lostRecordingNoAudioHint:
                "Primero revise Grabaciones Locales. Si la grabación ({{when}}) no aparece en la lista, puede confirmarlo abajo.",
              lostRecordingRelease: "No hay grabación para recuperar",
              lostRecordingReleaseArm: "Toque de nuevo para confirmar",
              lostRecordingReleaseWarning:
                "Esto deja de proteger la grabación ({{when}}) para que pueda volver a grabar. Si el audio aparece más adelante en este dispositivo, igual se guardará.",
              lostRecordingUnknownTime: "hora desconocida",
              micDisconnectedSwitching: "Microfono desconectado. Cambiando al microfono predeterminado.",
              micRequestTimedOut: "La solicitud del micrófono expiró. Permita el acceso al micrófono e inténtelo de nuevo.",
              notSupportedOnBrowser: "No soportado en su navegador!",
              recordingNotQueuedOffline:
                "El servidor no está disponible y esta grabación NO se pudo guardar para más tarde — no se conservó. Por favor, vuelva a grabarla cuando esté de nuevo en línea.",
              recordingUploadedWhenOnline: "La grabacion se subira cuando este en linea",
              recordingSavedAfterSignIn:
                "Se cerró la sesión antes de guardar esta grabación. Está segura en este teléfono y se subirá cuando inicies sesión.",
              previousRecordingSaving: "Tu grabación anterior aún se está guardando. Espera antes de iniciar otra grabación.",
              webRecordingBusy:
                "Hay una grabación activa o que aún se está guardando en otra ventana de LucasAI. Vuelva a esa ventana para detenerla y terminar de guardarla.",
              webRecordingUnavailable:
                "La grabación está pausada porque este navegador no pudo protegerla. Recargue e inténtelo de nuevo. Si el problema continúa, contacte a soporte.",
              webRecordingOtherAccount:
                "Una grabación interrumpida pertenece a otra cuenta. Vuelva a iniciar sesión en esa cuenta para revisarla antes de iniciar una nueva grabación.",
              webRecordingRecoveryTitle: "Revisar grabación interrumpida",
              webRecordingSaveTitle: "La grabación aún no se ha guardado",
              webRecordingSaveBody:
                "El audio aún no se ha terminado de guardar. Mantenga esta ventana abierta e intente guardarlo de nuevo.",
              webRecordingSaveRetry: "Reintentar guardar",
              webRecordingSaveRetrying: "Guardando…",
              webRecordingRecoveryBody:
                "La grabación iniciada a las {{when}} se interrumpió. El audio guardado puede estar incompleto, incluido el final de la grabación. Revise el audio guardado y la transcripción de la consulta antes de continuar.",
              webRecordingRecoveryMissingAudio:
                "No se encontró audio guardado en este dispositivo para esta grabación. Revise la transcripción de la consulta antes de continuar.",
              webRecordingRecoveryUnknownAudio:
                "No pudimos comprobar el audio guardado en este dispositivo. Cierre este mensaje e intente iniciar una grabación de nuevo para comprobarlo antes de continuar.",
              webRecordingRecoveryBlocked:
                "Las nuevas grabaciones están pausadas hasta que revise esta interrupción. Continuar permite una nueva grabación y conserva el audio que ya se haya guardado. Cerrar este mensaje mantiene esa protección.",
              webRecordingRecoveryReview: "Revisar audio guardado",
              webRecordingRecoveryContinue: "Revisé la grabación interrumpida",
              webRecordingRecoveryClose: "Cerrar",
              lowStorageWarning:
                "Este dispositivo tiene poco almacenamiento: quedan unos {{minutes}} min de grabación. Libere espacio antes de una consulta larga.",
              microphoneWentSilent:
                "Su micrófono dejó de enviar audio; puede que otra aplicación lo esté usando. Revíselo ahora: no se está grabando nada.",
              segmentStorageFailed:
                "No se pudo guardar parte de la grabación; revise el almacenamiento del dispositivo y su conexión.",
            },
            useSalesRepsData: {
              failedToLoadSalesRepData: "Error al cargar datos del representante de ventas",
            },
          },
          icd10Optimizer: {
            docs: "Docs",
            evidence: "Evidencia",
            hpi: "HPI",
            quality: "Calidad",
            reset: "Restablecer",
            save: "Guardar",
            selectAlternative: "Seleccionar alternativa",
            selectBest: "Seleccionar mejor",
            specificity: "Especificidad",
            title: "Optimizar códigos ICD-10",
            v28Codes: "Códigos V28",
          },
          icd10OptimizerNote: {
            clinicalGuidelines: "Estas sugerencias se basan en pautas clínicas y requisitos de documentación.",
            createAddendums: "Crear anexos",
            deselectAll: "Deseleccionar todo",
            generatingNote: "Generando un mejor HPI y Plan de Cuidado basado en los códigos ICD-10:",
            hpi: "HPI",
            newHPI: "Nuevo HPI",
            newPlanOfCare: "Nuevo Plan de Cuidado",
            noSuggestions: "No pudimos crear sugerencias para estos códigos. Por favor, inténtalo de nuevo.",
            planOfCare: "Plan de Cuidado",
            reviewAddendums: "Revisar anexos",
            reviewing: "Revisando...",
            save: "Guardar",
            selectAll: "Seleccionar todo",
            selectICD10Description:
              "Selecciona los códigos ICD10 para los que deseas crear anexos en las notas de HPI y Plan de Cuidado.",
            selectItems: "Selecciona los elementos que deseas agregar a tu nota.",
            title: "Optimizar documentos desde códigos ICD-10",
          },
          importEvent: {
            fileUploaded: "1 archivo subido",
            form: {
              import: "Importar",
              type: "Tipo",
              visitTime: "Hora de visita",
            },
            importFromEHR: "Importar desde Registro Electrónico",
            or: "O",
            title: "Crear agenda",
            search: "Buscar pacientes…",
            colPatient: "Paciente",
            sortBy: "Ordenar",
            sort: { lastName: "Apellido", firstName: "Nombre", visitTime: "Hora de visita" },
            summary: {
              selected: "{{selected}} de {{total}} seleccionados",
              needInfo: "{{count}} necesitan datos",
              footerNote: "{{count}} aún necesitan datos antes de poder crearse",
            },
            needsInfo: "faltan datos",
            selectAll: "Seleccionar todos",
            createCount: "Crear {{count}} encuentros",
            selectPrompt: "Selecciona un paciente para editar",
            editor: {
              editing: "Editando — {{name}}",
              attention: "{{count}} campos necesitan atención antes de importar",
              unnamed: "Paciente sin nombre",
              sexGuessed: "Deducido del nombre — por favor verifique",
            },
            sexGuessedShort: "deducido",
            missingLabel: {
              firstName: "nombre",
              lastName: "apellido",
              dob: "fecha de nac.",
              sex: "sexo",
              type: "tipo",
              visitDate: "fecha de visita",
              visitDateRange: "fecha de visita fuera de hoy a {{days}} días adelante",
            },
            bulkDate: {
              label: "Fecha de visita para todas las filas",
              apply: "Aplicar a todas las filas",
              hint: "Conserva la hora de cada fila",
            },
            toast: {
              errorImportingData: "Error al importar los datos",
              errorImportingSchedule: "Error al importar la agenda. Inténtalo de nuevo.",
              importingSchedule: "Importando agenda. Esto puede tardar...",
            },
            uploadDescription:
              "Sube una imagen o un documento de tu agenda y crearemos los encuentros por ti. Funciona para hoy o cualquier día de las próximas dos semanas.",
            scheduleDate: {
              label: "Fecha de la agenda",
              hint: "Por defecto es hoy. Cámbiala cuando esta agenda sea de un día futuro.",
              invalid: "Elige una fecha de agenda entre hoy y {{days}} días adelante.",
            },
            uploadTitle: {
              desktop: "Sube una imagen",
              mobile: "Sube una imagen o toma una foto",
            },
            duplicateInList: "El mismo paciente aparece en otra fila",
            duplicateExisting: "Ya tiene un encuentro ese día a las {{time}}",
            duplicateThirdVisit: "El paciente ya tiene 2 encuentros ese día",
            duplicateSecondVisit: "2.ª visita ese día",
            duplicatesSkipped: "{{count}} duplicados omitidos",
            alreadyImportedBanner:
              "Parece que este horario ya fue importado — {{dup}} de {{total}} pacientes ya tienen encuentros ese día.",
            creatingProgress: "Creando {{done}} de {{total}}…",
            retryFailed: "Reintentar {{count}} fallidos",
            createdBadge: "Creado",
            partialFailToast: "No se pudieron crear {{count}} encuentros. Revise la lista y reintente.",
            needInfoSkipped: "No se crearon {{count}}: aún necesitan información obligatoria.",
          },
          layout: {
            appUpdate: {
              laterButton: "Más Tarde",
              message:
                "Se requiere una nueva versión de la aplicación. Por favor actualiza para continuar usando Lucas AI.\n\nVersión actual: {{current}}\nVersión requerida: {{required}}",
              title: "Actualización Requerida",
              titleOptional: "Actualización Disponible",
              updateButton: "Actualizar Ahora",
            },
            devSettings: {
              auth: "Autenticación",
              enableDebug: "Habilitar depuración",
              env: "Entorno",
              envVars: "Variables de entorno",
              goLocal: "Ir al sitio local",
              iframeUrl: "URL de IFrame",
              isOnline: "En línea",
              save: "Guardar",
              saveExtensionId: "Guardar ID de extensión",
              title: "Configuración de desarrollo",
            },
            mobileAppAlert: {
              android:
                "¡Lucas AI está disponible en Google Play! Descarga nuestra aplicación para una mejor experiencia con soporte sin conexión y grabación nativa.\n\n¿Te gustaría descargar la aplicación?",
              ios: "¡Lucas AI está disponible en la App Store! Descarga nuestra aplicación para una mejor experiencia con soporte sin conexión y grabación nativa.\n\n¿Te gustaría descargar la aplicación?",
            },
            offlineBar: "Modo sin conexión",
            serverUnreachableBar:
              "Servidor no disponible — trabajando sin conexión. Su trabajo se guarda en este dispositivo y se sincronizará automáticamente.",
            recordingRecovery: {
              message: "Una grabación ({{when}}) sigue en tu {{device}}. Abre ese dispositivo para terminar de guardarla.",
              messageFor:
                "La grabación de {{name}} ({{when}}) sigue en tu {{device}}. Abre ese dispositivo para terminar de guardarla.",
              anotherDevice: "otro dispositivo",
              hide: "No volver a mostrar",
              recoverNudge:
                "Parte de una grabación ({{when}}) quedó guardada desde otro dispositivo. ¿Recuperar la parte guardada? Puede faltar el resto.",
              recoverNudgeFor:
                "Parte de la grabación de {{name}} ({{when}}) quedó guardada desde otro dispositivo. ¿Recuperar la parte guardada? Puede faltar el resto.",
              recover: "Recuperar",
              recovering: "Recuperando…",
              openOriginDevice: "Esta grabación se hizo en otro dispositivo: ábrelo para terminarla ({{device}}).",
              openEncounter: "Abrir esta nota",
            },
            recordingsBacklog: {
              title: "Grabaciones aún en este dispositivo",
              body: "Encontramos unos {{duration}} de audio en {{count}} grabación(es) que todavía no ha llegado a tus encuentros.",
              approx: "Las duraciones son aproximadas.",
              explain:
                "Permanece en este dispositivo hasta que se suba. Revísalo para reintentar o guardarlo, o elimínalo si ya no lo necesitas.",
              review: "Revisar grabaciones",
              later: "Ahora no",
              saveAll: "Guardarlas primero",
              deleteAll: "Eliminar las {{count}}",
              deleteAllConfirm:
                "¿Eliminar las {{count}} grabación(es), unos {{duration}} de audio? No se puede deshacer, y lo que nunca se subió se perderá definitivamente.",
              confirmDeleteAll: "Eliminar las {{count}} definitivamente",
              deleteAllDone: "Se eliminaron {{count}} grabación(es) de este dispositivo.",
              deleteAllFailed: "No se pudieron eliminar las grabaciones.",
            },
            recordingsManager: {
              title: "Grabaciones locales",
              empty: "No hay grabaciones guardadas.",
              close: "Cerrar",
              retry: "Reintentar ahora",
              retryAll: "Reintentar todo",
              saveAudio: "Guardar audio",
              saving: "Guardando…",
              saveFailed: "No se pudo guardar el archivo de audio en este dispositivo.",
              saveAll: "Guardar todo ({{count}})",
              savingProgress: "Guardando {{done}} de {{total}}…",
              saveAllDone: "Se guardaron {{count}} grabación(es) en este dispositivo.",
              saveAllPartial: "Se guardaron {{saved}}, pero {{failed}} no se pudieron guardar. No las elimines todavía.",
              saveAllHandedToBrowser:
                "Se entregaron {{count}} archivo(s) a las descargas de tu navegador. Revisa tu carpeta de Descargas antes de eliminar nada.",
              saveAllHandedToBrowserPartial:
                "Se entregaron {{count}} archivo(s) a las descargas de tu navegador, pero {{failed}} no se pudieron guardar. Revisa tu carpeta de Descargas antes de eliminar nada.",
              unfinished: "Sin terminar",
              unfinishedNoRetry: "No se puede reintentar: guarda el audio o elimínala",
              deleteOld: "Eliminar {{count}} con más de {{days}} días",
              deleteOldConfirm:
                "¿Eliminar {{count}} grabación(es) con más de {{days}} días? El audio no se podrá recuperar. Guárdalas primero si aún las necesitas.",
              confirmDeleteOld: "Eliminar {{count}} definitivamente",
              deleteOldDone: "Se eliminaron {{count}} grabación(es) antiguas.",
              deleteOldFailed: "No se pudieron eliminar las grabaciones antiguas.",
              delete: "Eliminar",
              confirmDelete: "Eliminar definitivamente",
              cancel: "Cancelar",
              deleteConfirm: "¿Eliminar esta grabación? El audio no se podrá recuperar.",
              attempts: "Intentos: {{count}}",
              parked: "No adjuntada",
              parkedPredatesEncounter:
                "Grabada el {{recorded}}, antes de que existiera este encuentro ({{created}}). No se adjuntó.",
              parkedPatientMismatch: "Grabada para un paciente distinto al de este encuentro. No se adjuntó.",
              parkedEncounterMismatch: "Grabada para un encuentro que ya no existe. No se adjuntó.",
              parkedTooOld: "Grabada el {{recorded}}, hace más de 15 días. No se adjuntó automáticamente.",
              attachConfirm: "Esta grabación puede pertenecer a otra consulta. ¿Adjuntarla a este encuentro de todos modos?",
              attachRecording: "Grabación: {{date}} · {{patient}}",
              attachTarget: "Encuentro: {{date}} · {{patient}}",
              attachUnknown: "desconocido",
              keepParked: "Mantener apartada",
              attachAnyway: "Adjuntar de todos modos",
              patientFromEncounter: "Nombre tomado del encuentro al que está asignada la grabación, no guardado con la grabación",
              status: {
                pending: "Pendiente",
                retrying: "Reintentando",
                error: "Error al subir",
              },
            },
            recorder: {
              generate: "Generar",
              microphone: "Micrófono {{id}}",
              noAudioWarning: "No se detectó audio - verifica tu micrófono",
              ruralMode: "Modo sin conexión",
              stop: "Detener",
            },
            toasts: {
              officeAddressRequired: "La dirección de la oficina es obligatoria para supervisores",
              officeNameRequired: "El nombre de la oficina es obligatorio para supervisores",
              selectClinicalRole: "Por favor seleccione si tiene un rol clínico o no clínico",
              stateRequired: "El estado es obligatorio para supervisores en EE.UU.",
              zipCodeRequired: "El código postal es obligatorio para supervisores en EE.UU.",
            },
          },
          locationSelect: {
            ariaSelect: "Selecciona una ubicación",
            continue: "Continuar",
            doNotAsk: "No volver a preguntar",
            lastUsedAccount: "Última usada en tu cuenta:",
            lastUsedDevice: "Última usada en este dispositivo:",
            preferenceStoredMessage:
              "Seleccionaste no pedir el cambio de ubicación al iniciar. Puedes revertir esta configuración en cualquier momento desde tu perfil.",
            preferenceStoredTitle: "Preferencia guardada",
            choosePlaceholder: "Selecciona una ubicación...",
            requiredSubtitle:
              "Tu organización tiene varias ubicaciones. Elige aquella en la que trabajas: los nuevos encuentros se registran en ella, y un encuentro sin ubicación no aparecerá en ninguna lista filtrada por ubicación.",
            requiredTitle: "Configura tu ubicación",
            subtitle: "Selecciona la ubicación en la que quieres trabajar durante esta sesión.",
            title: "Elige tu ubicación",
          },
          locations: {
            actions: {
              createLocation: "Crear ubicación",
            },
            allLocations: "Todas las ubicaciones",
            encounterRequiresLocation:
              "Este encuentro necesita una ubicación antes de poder crearse. Elige tu ubicación en el selector del encabezado e inténtalo de nuevo.",
            filters: {
              search: "Buscar",
            },
            title: "Ubicaciones",
            subtitle: "Lista completa de ubicaciones",
            locationCount_one: "{{count}} Ubicación",
            locationCount_other: "{{count}} Ubicaciones",
          },
          login: {
            btn: "Iniciar Sesión",
            checkSpamFolder: "Si no ves el correo en el próximo minuto, por favor revisa tu carpeta de spam.",
            confirm: "Confirmar",
            didntGetCode: "¿No recibiste el código?",
            email: "Correo electrónico",
            forgotPassword: "¿Olvidaste tu contraseña?",
            insertPinCode: "INGRESA EL CÓDIGO PIN",
            loginByEmail: "Iniciar sesión por correo electrónico",
            loginBySms: "Iniciar sesión por texto",
            loginWithFaceId: "Iniciar sesión con reconocimineto facial",
            noCodeOnClipboard: "No se encontró ningún código de verificación en el portapapeles.",
            openEmail: "Abrir correo",
            organization: "Organización",
            password: "Contraseña",
            pasteCode: "Pegar código",
            pasteCodeManually: "Ahora mantén presionado o usa Ctrl+V para pegar tu código.",
            rememberLogin: "Recordar inicio de sesión",
            resendCodeByEmail: "Reenviar código por correo electrónico",
            resendCodeBySms: "Reenviar código por texto",
            resendEmail: "Reenviar correo",
            resendSms: "Reenviar SMS",
            verificationEmailSent: "Se ha enviado un correo electrónico a tu dirección con el código de verificación.",
            verifyCodeSentNeutral: "Enviamos un código de 6 dígitos a tu correo o teléfono registrado.",
            verifyCodeSentSms: "Enviamos un código de 6 dígitos a tu teléfono",
            verifyCodeSentEmail: "Enviamos un código de 6 dígitos a tu correo electrónico",
            codeMayAutofill: "Tu código puede completarse automáticamente.",
            codeIncorrect: "Ese código no es correcto. Verifícalo e inténtalo de nuevo, o solicita uno nuevo.",
            codeExpired: "Este código ha expirado. Toca reenviar para obtener uno nuevo.",
            verifyServerError: "No pudimos conectar con el servidor. Verifica tu conexión e inténtalo de nuevo.",
            noMobileOnFile: 'No hay número de móvil registrado. Usa "Reenviar por correo" para recibir tu código.',
            resendInSeconds: "Reenviar en {{n}} s",
            verifyDevice: "Verificar el dispositivo actual",
          },
          modals: {
            afterVisitSummary: {
              charsLimit: "{{count}} / 1600 caracteres",
              email: "Correo electrónico",
              generating: "Generando resumen posterior a la visita...",
              language: "Idioma",
              phoneNumber: "Número de teléfono",
              regenerate: "Regenerar",
              selectLanguagePrompt: "Selecciona el idioma al que traducir el resumen posterior a la visita:",
              selectTranslationLanguage: "Seleccionar idioma de traducción",
              send: "Enviar",
              sendBy: "Enviar por",
              sms: "SMS",
              title: "Resumen posterior a la visita",
              toast: {
                sendError: "Error al enviar el resumen posterior a la visita: {{error}}",
                sentTo: "Resumen posterior a la visita enviado a {{recipient}}",
                smsLimitExceeded: "El contenido del SMS excede el límite de 1600 caracteres.",
              },
              translate: "Traducir",
              translating: "Traduciendo resumen posterior a la visita...",
            },
            changeDispo: {
              description: "Selecciona una nueva disposición. Las secciones de disposición actuales serán reemplazadas.",
              title: "Cambiar Disposición",
            },
            copySelection: {
              copySelected: "Copiar seleccionados",
              separator: "--- Separador ---",
              title: "Copiar selección",
            },
            createFollowUp: {
              creating: "Creando nota de seguimiento...",
              title: "Crear nota de seguimiento",
              toast: {
                createError: "Error al crear el encuentro",
                selectNoteType: "Selecciona un tipo de nota",
              },
              typeLabel: "Tipo {{type}}",
            },
            createPriorAuth: {
              reasonLabel: "Ingresa el motivo de la autorización",
              start: "Iniciar",
              title: "Crear autorización previa",
              toast: {
                specifyReason: "Especifica un motivo",
              },
            },
            customizeNote: {
              changesSaved: "Los cambios guardados aquí se aplicarán a todos los tipos de notas",
              customizePrompt: "Personaliza la nota habilitando y deshabilitando las secciones",
              resetAll: "Restablecer todo",
              save: "Guardar",
              separator: "--- Separador ---",
              title: "Personalizar nota",
            },
            editContextVariable: {
              toast: {
                selectValue: "Selecciona un valor",
              },
              update: "Actualizar",
              updateWithCount: "Actualizar ({{count}})",
              moreSimilarCodes: "{{count}} más",
              hideAlternatives: "Ocultar",
              pickOneOf: "1 de {{total}}",
              pickAnyOf: "cualquiera de {{total}}",
              alternativesAffordance: "Mostrar códigos alternativos",
              keepCurrent: "Mantener selección actual",
              alternativesHeading: "Códigos alternativos para {{description}}",
              confirmTitle: "Confirmar códigos de diagnóstico",
              confirmedCount_one: "{{count}} confirmado",
              confirmedCount_other: "{{count}} confirmados",
              suggestedCount_one: "{{count}} sugerido",
              suggestedCount_other: "{{count}} sugeridos",
              tapToRemove: "toca una fila para quitarla",
              dismissSuggestions: "Descartar sugerencias",
              optimizeDocs: "Optimizar documentación",
            },
            editInlineVariable: {
              title: "Editar valor",
              update: "Actualizar",
            },
            editPatient: {
              assignedTo: "Asignado a",
              fin: "ID Financiero",
              identification: "Número de Cuarto",
              incidentDate: "Fecha del incidente",
              location: "Ubicación",
              notDefined: "No definido",
              noteInfo: "Información de la nota",
              title: "Editar paciente",
              toast: {
                completeInfo: "Completa la información del paciente antes de continuar",
                errorFetching: "Error al obtener el paciente",
                errorUpdatingChat: "Error al actualizar el chat",
                errorUpdatingPatient: "Error al actualizar el paciente",
                patientUpdated: "Paciente actualizado",
              },
              type: "Tipo",
              update: "Actualizar",
              visitTime: "Hora de visita",
              warning: {
                anonymousName: "El nombre del paciente no debe ser anónimo para crear un seguimiento.",
                dobRequired: "La fecha de nacimiento del paciente es obligatoria para crear un encuentro de seguimiento.",
              },
            },
            erPhase: {
              defaultTitle: "Selecciona un tipo de grabación",
              phase: {
                erAdmit: "Disposición: Alta",
                erCriticalCare: "Cuidado Crítico",
                erDischarge: "Disposición: Ingreso",
                erHPI: "Historia Clínica y Evaluación",
                erHandoff: "Disposición: Transferencia a otro Doctor",
                erPreHospital: "Prehospitalario",
                erProcedure: "Procedimiento",
                erReassessment: "Reevaluación",
                erTransfer: "Disposición: Transferencia a otra ubicación",
              },
            },
            procedureNote: {
              title: "Agregar Nota de Procedimiento",
              searchPlaceholder: "Buscar procedimientos...",
              dictate: "Dictar procedimiento",
              inserted: "Nota de procedimiento agregada, regenera la nota para incluirla",
              insertError: "Error al agregar la nota de procedimiento",
              noMatches: "No hay procedimientos coincidentes",
              templates: {
                lacerationRepair: "Reparación de Laceración",
                incisionDrainage: "Incisión y Drenaje",
                splintApplication: "Aplicación de Férula",
                reduction: "Reducción de Fractura/Luxación",
                centralLine: "Catéter Venoso Central",
                intubation: "Intubación Endotraqueal",
                lumbarPuncture: "Punción Lumbar",
                cardioversion: "Cardioversión Sincronizada",
                proceduralSedation: "Sedación para Procedimiento",
                foreignBodyRemoval: "Extracción de Cuerpo Extraño",
                chestTube: "Tubo de Tórax (Toracostomía)",
              },
            },
            icd10AddCode: {
              actuals: "Actuales",
              add: "Agregar",
              addCodePlaceholder: "Agregar un código",
              codeAdded: "Código agregado",
              codeAlreadyPresent: "El código ya está presente",
              codesToAdd: "Códigos para agregar",
              createNewGroup: "Crear nuevo grupo...",
              editCodes: "Editar códigos",
              favorites: "Favoritos",
              groupName: "Nombre del grupo",
              hideFavorites: "Ocultar favoritos",
              moveToGroup: "Mover al grupo",
              noCodes: "Aún no hay códigos para agregar",
              noCodesAdded: "No hay códigos agregados",
              noFavorites: "No hay códigos favoritos guardados",
              save: "Guardar",
              orgTag: "Org",
              sexConflict:
                "{{code}} es un diagnóstico exclusivo del sexo {{codeSex}}, pero este paciente está registrado como sexo {{recordedSex}}. Actualice el sexo del paciente desde el lápiz junto a su nombre o elija otro código.",
              sexConflictMirror:
                "{{code}} es un diagnóstico exclusivo del sexo {{codeSex}}, pero este paciente está registrado como sexo {{recordedSex}}. Use {{mirrorCode}} - {{mirrorDescription}} en su lugar o actualice el sexo del paciente desde el lápiz junto a su nombre.",
              sexFemale: "femenino",
              sexMale: "masculino",
              showFavorites: "Mostrar favoritos",
              title: "Agregar código",
              tooltip: {
                addCode: "Agregar código",
                moveGroup: "Mover grupo de favoritos",
                removeFavorite: "Eliminar de favoritos",
              },
              units: "Unidades",
              unitsPlaceholder: "Unid.",
              unitsRange: "Unidades: de 1 a {{max}}",
              modifier: "Modificador",
              noModifier: "Sin mod.",
              nonBillableHint: "Las inyecciones facturables van en Procedimientos en consultorio.",
            },
            icd10Optimizer: {
              docs: "Docs",
              hpi: "HPI",
              meta: "Selecciona los códigos ICD-10 más apropiados basados en la puntuación generada, v28, especificidad y evidencia en HPI y PLAN",
              noAlternatives: "No se encontraron códigos alternativos",
              original: "Original",
              plan: "PLAN",
              quality: "Calidad",
              reset: "Restablecer",
              save: "Guardar",
              selectBest: "Seleccionar los mejores códigos",
              showAlternatives_one: "Mostrar {{count}} alternativa",
              showAlternatives_other: "Mostrar {{count}} alternativas",
              spec: "ESPEC",
              specificity: "Especificidad",
              title: "Optimizar códigos ICD-10",
              v28: "V28",
              v28Codes: "Códigos V28",
            },
            icd10OptimizerNote: {
              createAddendums: "Crear Addendums",
              generating: "Generando una mejor nota de HPI y Plan de cuidados basada en los códigos ICD-10:",
              hpi: "HPI",
              meta: "Selecciona los códigos ICD10 para los que deseas crear un addendum en la nota de HPI y Plan de cuidados.",
              metaGuidelines: "Estas sugerencias se basan en pautas clínicas y requisitos de documentación.",
              metaSelect: "Selecciona los elementos que te gustaría agregar a tu nota.",
              planOfCare: "Plan de cuidados",
              pleaseWait: "Por favor espera...",
              reviewAddendums: "Revisar Addendums",
              title: "Optimizar documentos desde códigos ICD-10",
              updateNote: "Actualizar nota",
            },
            installExtension: {
              download: "Descargar",
              message:
                "La extensión de Chrome LucasAI es necesaria para sincronizar con el EHR. Instálala desde Chrome Web Store.",
              title: "Extensión LucasAI",
            },
            legalCopyAcknowledgment: {
              accept: "Reconozco",
              accepting: "Procesando...",
              acknowledgment:
                "Al hacer clic en 'Reconozco', usted confirma que comprende y acepta la responsabilidad total de revisar y validar todo el contenido generado por IA antes de su uso.",
              cancel: "Cancelar",
              disclaimerBody:
                "Nuestro sistema de IA está diseñado para asistir a los proveedores de atención médica, pero no reemplaza su juicio médico profesional ni sus responsabilidades clínicas.",
              disclaimerTitle: "Aviso Legal Importante",
              point1:
                "Usted es el único responsable de revisar todas las notas clínicas generadas por IA para verificar su exactitud, integridad y pertinencia.",
              point2:
                "El sistema de IA no lo exime de responsabilidad por errores, omisiones o documentación médica inapropiada.",
              point3:
                "Usted tiene una obligación profesional y legal de asegurar que toda la documentación cumpla con los estándares clínicos y refleje con precisión la atención al paciente.",
              signedBadge: "Reconocido el {{date}} por {{name}}",
              title: "Reconocimiento de Documentación Clínica",
              toast: {
                error: "Error al registrar el reconocimiento. Por favor, inténtelo de nuevo.",
                success: "Reconocimiento legal registrado exitosamente",
              },
            },
            outputData: {
              aliasPlaceholder: "Renombrar campo...",
              collapseAll: "Contraer Todo",
              configureEndpoint: "Configure un endpoint MLLP en la configuración de la organización para habilitar el envío",
              copiedToClipboard: "Copiado al portapapeles",
              copy: "Copiar",
              copyFailed: "Error al copiar",
              deselectAll: "Ninguno",
              download: "Descargar",
              expandAll: "Expandir Todo",
              globalDeselectAll: "Deseleccionar Todo",
              globalSelectAll: "Seleccionar Todo",
              hl7AssigningAuthority: "Autoridad Asignadora",
              hl7BuildError: "Error al construir el mensaje HL7",
              hl7DeselectAllSections: "Ninguno",
              hl7FacilitySystem: "Instalación y Sistema",
              hl7MissingFields: "Campos requeridos faltantes",
              hl7Mrn: "MRN",
              hl7MrnHelper: "El MRN del paciente nunca se guarda — ingréselo cada vez",
              hl7NoSections: "No hay secciones disponibles",
              hl7NoteSections: "Secciones de la Nota",
              hl7ObxDivider: "Observaciones Clínicas",
              hl7PatientIdentifiers: "Identificadores del Paciente",
              hl7Provider: "Proveedor",
              hl7ProviderFirstName: "Nombre",
              hl7ProviderLastName: "Apellido",
              hl7ProviderNpi: "NPI",
              hl7ProviderPrefix: "Prefijo",
              hl7ReceivingApplication: "Aplicación Receptora",
              hl7ReceivingFacility: "Instalación Receptora",
              hl7SelectAllSections: "Todo",
              hl7SendingFacility: "Instalación de Envío",
              hl7Version: "Versión HL7",
              noFieldsSelected: "No hay campos seleccionados",
              preview: "Vista Previa",
              previewStats: "{{fields}} campos | {{kb}} KB",
              resetDefaults: "Restablecer Valores",
              selectAll: "Todo",
              sendToEndpoint: "Enviar",
              sendToEndpointDisabled: "Endpoint no configurado",
              stripHtml: "Eliminar HTML",
              stripHtmlHelper: "Eliminar etiquetas HTML de los campos de texto exportados",
              title: "Exportar Datos",
            },
            previousEncounter: {
              cancel: "Cancelar",
              createFollowUp: "Crear seguimiento",
              createFollowUpInfo:
                "Para crear un seguimiento de tipo {{type}}, el paciente debe tener un encuentro anterior de los siguientes tipos:",
              encounterPreview: "Vista previa del encuentro",
              goBack: "Volver",
              last30Days: "Últimos 30 días",
              last60Days: "Últimos 60 días",
              last90Days: "Últimos 90 días",
              loading: "Cargando encuentros anteriores...",
              noEncounters: "No hay encuentros anteriores disponibles.",
              noEncountersTimeframe: "No hay encuentros anteriores disponibles en este período de tiempo.",
              noteContext: "Selecciona los encuentros a incluir en la nota:",
              preview: "Vista previa",
              selectAll: "Seleccionar todo",
              selectEncounter: "Selecciona el encuentro que deseas usar como referencia para este seguimiento.",
              timeframe: "Período de tiempo",
              title: "Crear seguimiento",
            },
            reviewUserAction: {
              approve: "Aprobar",
              cancelEdit: "Cancelar edición",
              changes: "Cambios",
              date: "Fecha",
              edit: "Editar",
              edited: "Editado",
              from: "De",
              label: "Etiqueta",
              new: "Nuevo",
              original: "Original",
              reject: "Rechazar",
              rejectReason: {
                options: {
                  clinicalDisagree: "No estoy de acuerdo clínicamente con esta sugerencia en este momento",
                  needExplanation: "No entiendo por qué quieres este cambio, puedes explicar",
                  putInError: "Creo que esto se puso por error y no es aplicable",
                },
                placeholder: "Por favor seleccione o ingrese un motivo para el rechazo...",
                required: "Por favor proporcione un motivo para el rechazo",
                title: "Motivo del rechazo",
              },
              revertToAI: "Revertir a sugerencia de IA",
              saveChanges: "Aceptar con modificaciones",
              showComparison: "Mostrar comparación",
              showOriginal: "Mostrar original",
              title: "Revisar solicitud",
              toast: {
                approved: "Solicitud aprobada exitosamente",
                error: "Error al aprobar la solicitud",
                rejected: "Solicitud rechazada exitosamente",
              },
            },
            selectEHRTemplate: {
              selectTemplate: "Selecciona una plantilla",
              syncToEHR: "Sincronizar con Registro Electrónico",
              title: "Seleccionar una plantilla",
              toast: {
                downloadLink: "Descargar extensión",
                generateNoteFirst: "Por favor genera la nota de AI antes de sincronizar con el EHR.",
                installExtension: "Extensión LucasAI no detectada.",
                selectTemplate: "Selecciona una plantilla",
              },
            },
            selectEncounterType: {
              addType: "Agregar un tipo de encuentro",
              title: "Seleccionar tipo de encuentro",
              toast: {
                error: "Error al actualizar el chat",
                updated: "Chat actualizado",
              },
              type: "Tipo",
              update: "Actualizar",
            },
            uploadDocument: {
              addPage: "Agregar una página",
              additionalAngle: "Ángulo Adicional",
              billingWorksheet: "Hoja de trabajo de facturación",
              browseComputer: "Buscar archivos",
              cancel: "Cancelar",
              clinicalDocumentation: "Documentación clínica",
              deleteWound: "Eliminar herida",
              discardBody: "Tiene un archivo que aún no se ha subido. Si cierra ahora, se descartará.",
              discardConfirm: "Descartar",
              discardKeep: "Seguir editando",
              discardTitle: "¿Descartar documento?",
              documentType: "Tipo de documento",
              dropFiles: "Arrastra y suelta archivos aquí",
              dropFilesSubtitle: "o haz clic para buscarlos en tu dispositivo",
              eob: "EOB",
              existing: "Existente",
              faceSheet: "Hoja de identificación",
              getScreenshot: "Obtener captura de pantalla",
              hcfaForms: "Formularios HCFA",
              imaging: "Radiología",
              insuranceCard: "Tarjeta de seguro",
              invoices: "Facturas",
              labs: "Laboratorios",
              linkPostImage: "Vincular Imagen Post",
              medList: "Lista de medicamentos",
              newWound: "Nueva Herida",
              noImagesYet: "Aún no hay imágenes",
              orderForms: "Formularios de orden",
              others: "Otros",
              pickTypeFirst: "Seleccione primero un tipo de documento",
              postLabel: "Post",
              preLabel: "Pre",
              records: "Registros",
              submit: "Enviar",
              submitAs: "Enviar como {{type}}",
              title: "Subir un documento",
              toast: {
                parseError: "Error al analizar el documento",
                passwordProtected:
                  "Este PDF está protegido con contraseña. Elimine la contraseña (por ejemplo, imprímalo o guárdelo como un PDF nuevo) e inténtelo de nuevo.",
                screenshotError: "Error al obtener captura de pantalla de la extensión",
                uploadError: "Error al subir el documento",
                woundDeleted: "Herida eliminada",
                deleteError: "Error al eliminar",
              },
              togglePrePost: "Haga clic para alternar entre PRE y POST",
              upload: "Subir",
              uploadPhoto: "Subir Foto",
              uploadTitle: {
                desktop: "Sube una imagen",
                mobile: "Sube una imagen o toma una foto",
              },
              uploaded_one: "Subido un documento de {{count}} página",
              uploaded_other: "Subido un documento de {{count}} páginas",
              vob: "VOB",
              woundDefaultLabel: "Herida {{count}}",
              woundPhotos: "Fotos de heridas",
              wounds: "Heridas",
            },
            userActions: {
              noRequests: "No hay solicitudes para aprobar",
              title: "Solicitudes para aprobar",
            },
            vitals: {
              allergies: "Alergias",
              bmi: "IMC",
              bp: "PA",
              currentMedications: "Medicamentos actuales",
              height: "Altura",
              patientProfile: "Perfil del paciente",
              problems: "Problemas",
              pulse: "Pulso",
              rr: "FR",
              save: "Guardar",
              spo2: "SpO2",
              surgeries: "Cirugías",
              temp: "Temp",
              title: "Signos vitales",
              titleWithSummary: "Signos vitales y resumen",
              toast: {
                storedOffline: "Cambios almacenados sin conexión",
              },
              visitSummary: "Resumen de visita",
              vitalsTitle: "Signos vitales",
              weight: "Peso",
            },
            inviteToDashboard: {
              title: "Invitar paciente al panel",
              titleRelink: "Renovar acceso al precio",
              bodyPending: "Envía una invitación a {{email}} para que reclame este perfil y acceda a su panel.",
              bodyAlreadyInvited: "Ya se envió una invitación. Puedes reenviarla o generar un nuevo enlace.",
              bodyLinked:
                "Este paciente ya tiene una cuenta. Enviar un nuevo enlace renueva su acceso al precio — no afecta su cuenta ni sus pedidos existentes.",
              copyLinkOnly: "Obtener enlace para compartir",
              sendEmail: "Enviar correo",
              resendEmail: "Reenviar correo",
              generateNewLink: "Generar nuevo enlace",
              confirmRegenerate:
                "Esto invalidará el enlace de invitación anterior. El paciente no podrá usar correos anteriores. ¿Enviar un nuevo correo con un enlace nuevo?",
              copyLink: "Copiar",
              linkCopied: "Enlace copiado al portapapeles",
              linkReady: "Enlace listo para copiar",
              emailSent: "Invitación enviada a {{email}}",
              emailDelivered: "Correo entregado a {{email}}",
              errorPromoting: "No se pudo generar la invitación. Intenta de nuevo.",
              errorCopying: "No se pudo copiar el enlace. Intenta seleccionar la URL manualmente.",
              done: "Listo",
            },
          },
          newChat: {
            createFollowUp: "Crear seguimiento",
            form: {
              assignedTo: "Asignado a",
              context: "Contexto",
              dob: "Fecha de nacimiento",
              dobUnknown: "Desconocido",
              duplicatePatientFound: "Paciente duplicado encontrado",
              encounterType: "Tipo de encuentro",
              female: "Femenino",
              firstName: "Nombre",
              hideDuplicateList: "Ocultar duplicados",
              identification: "Número de Cuarto",
              incidentDate: "Fecha del incidente",
              lastName: "Apellido",
              location: "Ubicación",
              male: "Masculino",
              multiplePatientsSameName: "Varios pacientes con el mismo nombre",
              patient: "Paciente",
              patientSelectedFromDuplicates: "Paciente seleccionado de la verificación de duplicados",
              phone: "Teléfono",
              selectNoteType: "Selecciona un tipo de nota",
              selectPatient: "Buscar por nombre o fecha de nacimiento",
              selectPatientDuplicate: "Mostrar duplicados",
              sex: "Sexo",
              similarPatientFound:
                "Paciente similar encontrado — '{{name}}' (Fecha de nacimiento: {{dob}}). Verifique que es un paciente nuevo.",
              switchToEstablished: "Cambiar a paciente existente",
            },
            newProblem: "Nuevo problema",
            notAssigned: "Sin asignar",
            patientType: "Tipo de paciente",
            title: "Paciente",
            toast: {
              encounterNotCreated: "Encuentro no creado, intenta de nuevo",
              encounterWithoutId: "Encuentro creado sin identificador",
              enterFirstName: "Ingresa un nombre",
              enterLastName: "Ingresa un apellido",
              errorCreatingEncounter: "Error al crear el encuentro",
              errorCreatingPatient: "Error al crear el paciente",
              errorImportingFile: "Error al importar el archivo",
              errorUpdatingEncounter: "Error al actualizar el encuentro",
              importingFile: "Importando archivo...",
              selectLocation: "Selecciona una ubicación",
              selectNoteType: "Selecciona un tipo de nota",
              selectPatient: "Selecciona un paciente",
              uploadImage: "Sube una imagen",
            },
            type: {
              anonymous: "Anónimo",
              established: "Establecido",
              establishedSubtitle: "en sistema Lucas",
              import: "Importar",
              newPatient: "Nuevo paciente",
              newPatientSubtitle: "a Lucas",
            },
            uploadDescription:
              "Importa documentación previa para que este encuentro comience con el historial completo del paciente.",
            uploadTitle: {
              desktop: "Sube una imagen",
              mobile: "Sube una imagen o toma una foto",
            },
            uploaded_one: "{{count}} documento subido",
            uploaded_other: "{{count}} documentos subidos",
          },
          noteElementCategories: {
            assessmentPlan: "Evaluación y Plan",
            billingCoding: "Facturación y Codificación",
            clinicalCourse: "Curso Clínico",
            examination: "Examen",
            formatting: "Formato",
            history: "Historia",
            ordersFollowup: "Órdenes y Seguimiento",
            specialty: "Especialidad",
          },
          noteElements: {
            allergies: {
              description: "Alergias conocidas y reacciones adversas",
              title: "Alergias",
            },
            assessmentPlan: {
              description: "Evaluación clínica",
              title: "Evaluación",
            },
            barriersToDischarge: {
              description: "Impedimentos para el alta del paciente",
              title: "Barreras para el alta",
            },
            billableCodesICD10: {
              description: "Códigos de diagnóstico ICD-10",
              title: "Códigos ICD-10",
            },
            categories: {
              assessment: "Evaluación",
              billing: "Facturación y codificación",
              clinicalCourse: "Curso clínico",
              custom: "Personalizado",
              exam: "Examen",
              formatting: "Formato",
              history: "Historial",
              orders: "Órdenes y seguimiento",
              specialty: "Especialidad",
            },
            chiefComplaint: {
              description: "Razón principal de la visita del paciente",
              title: "Motivo de consulta",
            },
            consent: {
              description: "Consentimiento informado con procedimiento, riesgos, beneficios y alternativas",
              title: "Consentimiento informado",
            },
            cpt2codes: {
              description: "Códigos de procedimiento CPT",
              title: "Códigos CPT",
            },
            cptLevel2: {
              description: "Códigos HCPCS Nivel II para suministros y servicios",
              title: "CPT Nivel II / HCPCS",
            },
            criticalCareInterventions: {
              description: "Intervenciones de cuidados intensivos realizadas",
              title: "Intervenciones de cuidados intensivos",
            },
            criticalCareTime: {
              description: "Documentación del tiempo de cuidados intensivos (facturación por tiempo)",
              title: "Tiempo de cuidados intensivos",
            },
            currentMedications: {
              description: "Medicamentos activos y dosificaciones",
              title: "Medicamentos actuales",
            },
            customSection: {
              description: "Cree una sección personalizada generada por IA con su propia descripción",
              title: "Sección personalizada",
            },
            diagnostics: {
              description: "Pruebas diagnósticas y resultados revisados",
              title: "Diagnósticos",
            },
            differentialDiagnosis: {
              description: "Lista de posibles diagnósticos en consideración",
              title: "Diagnóstico diferencial",
            },
            dischargeCondition: {
              description: "Condición del paciente al momento del alta",
              title: "Condición al alta",
            },
            dischargeDisposition: {
              description: "Disposición de alta del paciente",
              title: "Disposición de alta",
            },
            dischargeInstructions: {
              description: "Instrucciones de alta y seguimiento del paciente",
              title: "Instrucciones de alta",
            },
            educationCounseling: {
              description: "Documentación de educación al paciente, consejería y tiempo dedicado",
              title: "Educación y consejería",
            },
            familyHistory: {
              description: "Historial médico familiar relevante",
              title: "Antecedentes familiares",
            },
            followUp: {
              description: "Instrucciones y cronograma de la cita de seguimiento",
              title: "Seguimiento",
            },
            handoff: {
              description: "Resumen de transferencia clínica para transiciones de atención",
              title: "Transferencia de cuidado",
            },
            hospitalCourse: {
              description: "Resumen de la estancia hospitalaria del paciente",
              title: "Curso hospitalario",
            },
            hpi: {
              description: "Narrativa detallada de la enfermedad actual del paciente",
              title: "Historia de la enfermedad actual",
            },
            imagingOrdered: {
              description: "Estudios de imágenes ordenados",
              title: "Imágenes ordenadas",
            },
            inOfficeProcedures: {
              description: "Códigos de procedimientos realizados hoy en consultorio",
              title: "Procedimientos en consultorio",
            },
            labsImaging: {
              description: "Resultados de laboratorio y hallazgos de imágenes",
              title: "Laboratorios / Imágenes",
            },
            labsOrdered: {
              description: "Pruebas y estudios de laboratorio ordenados",
              title: "Laboratorios ordenados",
            },
            legalDisclaimer: {
              description: "Aviso legal de documentación de IA para registros de pacientes",
              title: "Aviso legal",
            },
            levelOfService: {
              description: "Documentación del nivel de servicio E&M",
              title: "Nivel de servicio",
            },
            mccCcCodes: {
              description: "Códigos de complicación/comorbilidad mayor y CC para GRD",
              title: "Designación MCC / CC",
            },
            medicalDecisionMaking: {
              description: "Documentación de la complejidad de la toma de decisiones clínicas",
              title: "Toma de decisiones médicas",
            },
            pastMedicalHistory: {
              description: "Condiciones médicas y diagnósticos previos del paciente",
              title: "Antecedentes médicos",
            },
            pastSurgicalHistory: {
              description: "Procedimientos quirúrgicos previos del paciente",
              title: "Antecedentes quirúrgicos",
            },
            patientComplexity: {
              description: "Nivel general de complejidad del paciente (Bajo, Moderado, Alto)",
              title: "Complejidad del paciente",
            },
            physicalExam: {
              description: "Documentación de los hallazgos del examen físico",
              title: "Examen físico",
            },
            planOfCare: {
              description: "Plan detallado de tratamiento y seguimiento",
              title: "Plan de atención",
            },
            prescriptionsOrdered: {
              description: "Nuevas recetas y cambios de medicamentos",
              title: "Recetas ordenadas",
            },
            problemList: {
              description: "Lista de problemas activos y resueltos",
              title: "Lista de problemas",
            },
            procedures: {
              description: "Documentación de procedimientos",
              title: "Procedimientos",
            },
            referrals: {
              description: "Referencias a especialistas y órdenes de consulta",
              title: "Referencias",
            },
            ros: {
              description: "Revisión sistemática de los sistemas corporales",
              title: "Revisión por sistemas",
            },
            safetyPlan: {
              description: "Documentación del plan de seguridad del paciente",
              title: "Plan de seguridad",
            },
            separator: {
              description: "Divisor visual entre secciones de la nota",
              title: "Separador",
            },
            socialHistory: {
              description: "Factores sociales y de estilo de vida del paciente",
              title: "Historia social",
            },
            summaryPrescriptionsOrders: {
              description: "Resumen combinado de todas las recetas y órdenes realizadas",
              title: "Resumen de recetas y órdenes",
            },
            timeSpent: {
              description: "Documentación del tiempo total del encuentro",
              title: "Tiempo dedicado",
            },
            vitals: {
              bloodPressure: "Presión arterial",
              bmi: "IMC",
              description: "Signos vitales del paciente",
              heartRate: "Frecuencia cardíaca",
              height: "Altura",
              respiratoryRate: "Frecuencia respiratoria",
              spo2: "SpO2",
              temperature: "Temperatura",
              title: "Signos vitales",
              weight: "Peso",
            },
            woundAssessment: {
              description: "Mediciones de heridas, características del tejido y estadificación",
              title: "Evaluación de heridas",
            },
          },
          noteNotEnabled: {
            body1: "El tipo de nota {{type}} no está habilitado actualmente en tus preferencias de cuenta.",
            body2: "¿Te gustaría activarlo para poder crear y administrar este tipo de nota en el futuro?",
            enable: "Habilitar",
            title: "Tipo de nota no habilitado",
          },
          notePatientTypes: {
            established: "Paciente Establecido",
            new: "Paciente Nuevo",
          },
          noteSettings: {
            ed: "Departamento de Emergencias",
            inpatient: "Hospitalizado",
            outpatient: "Ambulatorio / Consultorio",
          },
          noteSpecialties: {
            allergy: "Alergia e Inmunología",
            behavioral: "Salud Conductual",
            cardiology: "Cardiología",
            dental: "Odontología",
            dermatology: "Dermatología",
            endocrinology: "Endocrinología",
            ent: "ORL / Otorrinolaringología",
            er: "Medicina de Emergencia",
            gastroenterology: "Gastroenterología",
            generalSurgery: "Cirugía General",
            homeHealth: "Salud Domiciliaria",
            hospitalist: "Hospitalista",
            infectiousDiseases: "Enfermedades Infecciosas",
            nephrology: "Nefrología",
            neuroOrthoSpine: "Neuro/Orto Columna",
            neurology: "Neurología",
            obgyn: "Obstetricia/Ginecología",
            orthopedics: "Ortopedia",
            painManagement: "Manejo del Dolor",
            pediatrics: "Pediatría",
            physicalTherapy: "Fisioterapia",
            podiatry: "Podología",
            primaryCare: "Atención Primaria",
            psychiatry: "Psiquiatría",
            pulmonology: "Neumología",
            radonc: "Oncología Radioterápica",
            rheumatology: "Reumatología",
            urology: "Urología",
            woundCare: "Cuidado de Heridas",
          },
          noteTypes: {
            "alf-home-followup": {
              description: "Seguimiento clínico en ancianato/ALF",
              label: "Ancianato - Cita Seg.",
            },
            "alf-home-new": {
              description: "Admisión en ancianato con evaluación inicial",
              label: "Ancianato - Admisión",
            },
            "allergy-followup": {
              description: "Seguimiento en alergología e inmunología",
              label: "Alergista - Cita Seg.",
            },
            "allergy-new": {
              description: "Evaluación inicial en alergología e inmunología",
              label: "Alergista - Cita Inicial",
            },
            "annual-wellness": {
              description: "Visita anual de bienestar con tamizajes y prevención",
              label: "Chequeo ejecutivo anual",
            },
            "attending-att-dc": {
              description: "Atestación del médico responsable en el resumen de Epicrisis",
              label: "Nota de Professor - Resumen Epicrisis",
            },
            "attending-att": {
              description: "Atestación del médico responsable sobre la atención brindada",
              label: "Nota de Professor",
            },
            "case-conference": {
              description: "Reunión clínica multidisciplinaria con acuerdos y plan",
              label: "Junta Medica",
            },
            chat: {
              description: "Interacción por chat iniciada por el paciente con resumen clínico",
              label: "Chat",
            },
            "clinic-followup-cardiology": {
              description: "Consulta de seguimiento en cardiología",
              label: "Cardio - Cita Seg.",
            },
            "clinic-followup-gastroenterology": {
              description: "Seguimiento en gastroenterología",
              label: "Gastro - Cita Seg.",
            },
            "clinic-followup-nephrology": {
              description: "Seguimiento ambulatorio en nefrología",
              label: "Nefrología - Cita Seg.",
            },
            "clinic-followup-podiatry": {
              description: "Seguimiento ambulatorio en podología",
              label: "Podología - Cita Seg.",
            },
            "clinic-followup-pulmonology": {
              description: "Seguimiento ambulatorio en neumología",
              label: "Neumología - Cita Seg.",
            },
            "clinic-new-cardiology": {
              description: "Evaluación inicial ambulatoria por cardiología",
              label: "Cardio - Cita Inicial",
            },
            "clinic-new-gastroenterology": {
              description: "Evaluación inicial en gastroenterología",
              label: "Gastro - Cita Inicial",
            },
            "clinic-new-nephrology": {
              description: "Evaluación ambulatoria inicial por nefrología",
              label: "Nefrología - Cita Inicial",
            },
            "clinic-new-podiatry": {
              description: "Evaluación ambulatoria inicial en podología",
              label: "Podología - Cita Inicial",
            },
            "clinic-new-pulmonology": {
              description: "Evaluación ambulatoria inicial en neumología",
              label: "Neumología - Cita Inicial",
            },
            "clinic-new-subspecialty": {
              description: "Evaluación inicial en subespecialidad con historia y examen",
              label: "Subespecialidad - Cita Inicial",
            },
            "clinic-new": {
              description: "Evaluación inicial en atención primaria con historia completa",
              label: "Medicina General - Cita Inicial",
            },
            "clinic-phone": {
              description: "Registro de conversación telefónica con indicaciones/plan",
              label: "Consulta Teléfonica",
            },
            "clinic-subspecialty": {
              description: "Seguimiento en subespecialidad con revisión de estudios",
              label: "Subespecialidad - Cita Seg.",
            },
            "clinic-telemed-audio": {
              description: "Consulta de telemedicina solo por audio con indicaciones",
              label: "Telemedicina Solo Audio",
            },
            "clinic-telemed": {
              description: "Consulta de telemedicina por videollamada con plan",
              label: "Telemedicina",
            },
            clinic: {
              description: "Consulta de seguimiento, agudos y mantenimiento de salud",
              label: "Medicina General - Cita Seg.",
            },
            "code-rescue": {
              description: "Documentación en tiempo real de eventos críticos (p. ej., código azul), acciones y participantes",
              label: "Código",
            },
            "concierge-medicine": {
              description: "Consulta ejecutiva integral con tamizajes y plan personalizado",
              label: "Consulta Ejecutiva",
            },
            "consult-hp-cardiology": {
              description: "Interconsulta de cardiología con historia clínica",
              label: "Cardio - Interconsulta",
            },
            "consult-hp-nephrology": {
              description: "Interconsulta inicial por nefrología con historia clínica",
              label: "Nefrología - Interconsulta",
            },
            "consult-hp-podiatry": {
              description: "Interconsulta inicial en podología con historia clínica",
              label: "Podología - Interconsulta",
            },
            "consult-progress-cardiology": {
              description: "Nota de evolución clínica por cardiología",
              label: "Cardio - Evulocion",
            },
            "consult-progress-nephrology": {
              description: "Evolución por nefrología con ajustes terapéuticos",
              label: "Nefrología - Evolucion.",
            },
            "consult-progress-podiatry": {
              description: "Evolución por podología",
              label: "Podología - Evolucion",
            },
            "consult-progress": {
              description: "Evolución intrahospitalaria por el servicio consultor",
              label: "Internista - Evolucion",
            },
            consult: {
              description: "Interconsulta intrahospitalaria por medicina interna",
              label: "Internista - Interconsulta",
            },
            cpe: {
              description: "Nota de evaluación física completa y hallazgos",
              label: "Examen Físico Completo",
            },
            "critical-care-hp": {
              description: "Ingreso a UCI o unidad intermedia con evaluación inicial",
              label: "Cuidado Crítico - Admisión",
            },
            "critical-care-progress": {
              description: "Evolución en cuidado crítico",
              label: "Cuidado Crítico - Evolucion",
            },
            death: {
              description: "Resumen clínico y eventos finales del paciente fallecido",
              label: "Medicina - Epicrisis - Nota de fallecido",
            },
            "dental-care-progress": {
              description: "Seguimiento odontológico y plan",
              label: "Dental",
            },
            "derm-followup": {
              description: "Seguimiento dermatológico con evaluación de lesiones y tratamiento",
              label: "Dermatologica - Cita Seg.",
            },
            "derm-new": {
              description: "Evaluación dermatológica inicial con historia y examen de piel",
              label: "Dermatologica - Cita Inicial",
            },
            "derm-procedure": {
              description: "Procedimiento dermatológico (biopsias, escisiones, tratamientos)",
              label: "Dermatologica - Procedimiento",
            },
            "derm-soap": {
              description: "Nota dermatológica simplificada (SOAP abreviado)",
              label: "Dermatologica - Nota",
            },
            "diagnostic-cath": {
              description: "Cateterismo/angiografía diagnóstica sin intervención",
              label: "Cardio - Cateterismo",
            },
            discharge: {
              description: "Resumen de alta hospitalaria con diagnósticos y tratamiento",
              label: "Medicina - Epicrisis",
            },
            "discseel-eval": {
              description: "Evaluación para intervención terapéutica con Discseel",
              label: "Discseel - Evaluación",
            },
            "endocrinology-followup": {
              description: "Seguimiento en endocrinología con control metabólico",
              label: "Endocrino - Cita Seg.",
            },
            "endocrinology-new": {
              description: "Evaluación inicial en endocrinología con historia y examen",
              label: "Endocrino - Cita Inicial",
            },
            "ent-followup": {
              description: "Seguimiento en otorrinolaringología",
              label: "Otorrino - Cita Seg.",
            },
            "ent-new": {
              description: "Evaluación inicial en otorrinolaringología",
              label: "Otorrino - Cita Inicial",
            },
            er: {
              description: "Atención en sala de urgencias con evaluación y manejo",
              label: "Nota de Urgencias",
            },
            "gynecology-followup": {
              description: "Seguimiento en ginecología",
              label: "Gineco - Cita Seg.",
            },
            "gynecology-new": {
              description: "Evaluación inicial en ginecología",
              label: "Gineco - Cita Inicial",
            },
            handoff: {
              description: "Transferencia estructurada de cuidado entre profesionales",
              label: "Entrega de Turno",
            },
            history: {
              description: "Ingreso hospitalario con historia clínica y plan terapéutico",
              label: "Internista - Nota de Admisión",
            },
            "hospice-discharge": {
              description: "Resumen de alta de paciente en hospicio",
              label: "Hospicio - Epicrisis",
            },
            "hospice-his": {
              description: "Registro de enfermería (HIS) en admisión y seguimiento de hospicio",
              label: "Hospicio - Nota De Efermeria",
            },
            "hospice-hp": {
              description: "Admisión a hospicio con evaluación inicial y objetivos de cuidado",
              label: "Hospicio - Admisión",
            },
            "hospice-progress": {
              description: "Evolución clínica en hospicio con control de síntomas",
              label: "Hospicio - Evolucion",
            },
            "hospice-recert": {
              description: "Recertificación de criterios de hospicio y continuidad de cuidados",
              label: "Hospicio - Recertificación",
            },
            "infection-followup": {
              description: "Seguimiento ambulatorio en infectología",
              label: "Infectologia - Cita Seg.",
            },
            "infection-initial": {
              description: "Interconsulta de infectología con historia clínica inicial",
              label: "Infectologia - Interconsulta",
            },
            "infection-new": {
              description: "Evaluación ambulatoria inicial en infectología",
              label: "Infectologia - Cita Inicial",
            },
            "infection-progress": {
              description: "Nota de evolución por infectología",
              label: "Infectologia - Evolucion",
            },
            "ivim-therapy": {
              description: "Administración y seguimiento de terapias intravenosas/intramusculares",
              label: "Terapia IV/IM",
            },
            "ltach-discharge": {
              description: "Resumen de alta de LTACH con evolución y recomendaciones",
              label: "Clinica de rehibilitation - Epicrisis",
            },
            "ltach-hp": {
              description: "Ingreso a LTACH con historia clínica y plan inicial",
              label: "Clinica de rehibilitation - Admisión",
            },
            "ltach-progress": {
              description: "Evolución en LTACH con objetivos funcionales",
              label: "Clinica de rehibilitation - Cita Seg.",
            },
            "medicare-wellness-initial": {
              description: "Visita inicial de bienestar para beneficiarios de Medicare",
              label: "Medicare - Bienestar Inicial",
            },
            "medicare-wellness-welcome": {
              description: "Visita de bienvenida a Medicare con revisión inicial",
              label: "Cita Medica anual > 65 - Primera Inicial",
            },
            "medicare-wellness": {
              description: "Visita subsecuente de bienestar para Medicare",
              label: "Cita Seg. Medica anual > 65.",
            },
            "neuro-followup": {
              description: "Seguimiento en neurología con revisión neurológica",
              label: "Neuro - Cita Seg.",
            },
            "neuro-new": {
              description: "Evaluación inicial por neurología con examen neurológico",
              label: "Neuro - Cita Inicial",
            },
            "neuro-ortho-spine-followup-complex": {
              description: "Seguimiento complejo de patología de columna por especialista",
              label: "Ortho-Columna - Complejo",
            },
            "neuro-ortho-spine-followup": {
              description: "Seguimiento para cirugía de columna (neuro/ortopedia)",
              label: "Neurocirugia - Cita Seg.",
            },
            "neuro-ortho-spine-new": {
              description: "Evaluación inicial para cirugía de columna (neuro/ortopedia)",
              label: "Neurocirugia - Cita Inicial",
            },
            "neuro-ortho-spine-preop": {
              description: "Evaluación preoperatoria para cirugía de columna",
              label: "Neurocirugia - Preoperatoria",
            },
            "neuro-telestroke": {
              description: "Atención neurológica remota para evento cerebrovascular agudo",
              label: "Neuro - Telemedicina",
            },
            "oasis-pt-soc": {
              description: "Inicio de cuidado en terapia física con formulario OASIS",
              label: "Therapia física - Oasis - Inicial",
            },
            "oasis-start": {
              description: "Inicio de atención con evaluación OASIS",
              label: "Enfermería - Nota de Emfernera Inicio",
            },
            "obstetrics-followup": {
              description: "Seguimiento obstétrico",
              label: "Obstetrica - Cita Seg.",
            },
            "obstetrics-new": {
              description: "Evaluación obstétrica inicial",
              label: "Obstetrica - Cita Inicial",
            },
            "ortho-injury-followup": {
              description: "Seguimiento de lesión ortopédica con control funcional",
              label: "Lesión Ortopédica - Cita Seg.",
            },
            "ortho-injury-new": {
              description: "Evaluación inicial de lesión ortopédica",
              label: "Lesión Ortopédica - Cita Inicial",
            },
            "ortho-surgery-followup": {
              description: "Seguimiento ortopédico/quirúrgico con evaluación y plan",
              label: "Ortopédica - Cita Seg.",
            },
            "ortho-surgery-new": {
              description: "Evaluación inicial para cirugía ortopédica",
              label: "Ortopédica - Cita Inicial",
            },
            "ortho-surgery-postop": {
              description: "Control postoperatorio con evaluación de herida y función",
              label: "Ortopédica - Cuidado posoperatorio",
            },
            "ortho-surgery-preop": {
              description: "Evaluación preoperatoria para lesión ortopédica",
              label: "Lesión Ortopédica - Preoperativa",
            },
            "pah-followup": {
              description: "Seguimiento de hipertensión arterial pulmonar en neumología",
              label: "Neumología - Cita Seg. - Hipertension Pulm",
            },
            "pah-new": {
              description: "Evaluación inicial de hipertensión arterial pulmonar",
              label: "Neumología - Cita Inicial - Hipertension Pulm",
            },
            "painmgmt-followup": {
              description: "Seguimiento en clínica del dolor con ajuste analgésico",
              label: "Manejo del Dolor - Cita Seg.",
            },
            "painmgmt-new": {
              description: "Evaluación inicial en manejo del dolor con plan terapéutico",
              label: "Manejo del Dolor - Cita Inicial",
            },
            paramedics: {
              description: "Registro clínico realizado por personal paramédico",
              label: "Nota Paramédicos",
            },
            "patient-meeting": {
              description: "Documentación de conversaciones (riesgos/beneficios, consentimientos, metas y plan de cuidado)",
              label: "Reunión Paciente y Familia",
            },
            "pediatric-followup": {
              description: "Seguimiento pediátrico con control de crecimiento y síntomas",
              label: "Pediatría - Cita Seg.",
            },
            "pediatric-new": {
              description: "Evaluación inicial en pediatría con historia y examen",
              label: "Pediatría - Cita Inicial",
            },
            "pediatric-wellchild-followup": {
              description: "Seguimiento de control sano con vacunas y desarrollo",
              label: "Pediatría - Chequeo Preventivo - Cita Seg.",
            },
            "pediatric-wellchild-new": {
              description: "Visita inicial de control sano con tamizajes",
              label: "Pediatría - Chequeo Preventivo - Cita Inicial",
            },
            "prior-auth": {
              description: "Solicitud y justificación clínica para autorización previa",
              label: "Autorización Previa",
            },
            "procedure-bronch": {
              description: "Procedimiento de broncoscopia diagnóstica/terapéutica",
              label: "Neumología - Broncoscopia",
            },
            "procedure-egd": {
              description: "Procedimiento de endoscopia digestiva alta (EGD)",
              label: "Gastro - Endoscopia",
            },
            "procedure-generic": {
              description: "Registro de procedimiento general y consentimiento",
              label: "Nota Cirujica - General",
            },
            progress: {
              description: "Evolución hospitalaria con respuesta al tratamiento",
              label: "Medicina - evolucion",
            },
            "psych-birp": {
              description: "Nota BIRP: conducta, intervención, respuesta y plan terapéutico",
              label: "Psiquiatría - BIRP",
            },
            "psych-followup": {
              description: "Seguimiento psiquiátrico con evaluación de síntomas y plan",
              label: "Psiquiatría - Cita Seg.",
            },
            "psych-full-assessment": {
              description: "Evaluación diagnóstica completa con historia y escalas",
              label: "Psiquiatría - Evaluación",
            },
            "psych-girp": {
              description: "Nota GIRP: metas, intervención, respuesta y plan de cuidado",
              label: "Psiquiatría - GIRP",
            },
            "psych-icanotes": {
              description: "Documentación psiquiátrica en formato ICANotes",
              label: "Psiquiatría - ICANotes",
            },
            "psych-intake": {
              description: "Interconsulta/ingreso con historia psicosocial y plan",
              label: "Psiquiatría - Interconsulta",
            },
            "pt-assessment": {
              description: "Evaluación de terapia física con objetivos y plan",
              label: "Enfermería - Evaluación de Terapia Física",
            },
            "pt-followup": {
              description: "Seguimiento en fisioterapia con progreso y ajustes",
              label: "Terapia Física - Cita Seg.",
            },
            "pt-new": {
              description: "Evaluación inicial en fisioterapia con plan de tratamiento",
              label: "Terapia Física - Cita Inicial",
            },
            "pulmonology-consult-hp": {
              description: "Interconsulta inicial por neumología con historia clínica",
              label: "Neumología - Interconsulta",
            },
            "pulmonology-consult-progress": {
              description: "Nota de evolución por neumología",
              label: "Neumología - Evolucion",
            },
            "radonc-followup": {
              description: "Seguimiento en radioterapia con toxicidad y respuesta",
              label: "Radiacion Oncologíca - Cita Seg.",
            },
            "radonc-new": {
              description: "Evaluación inicial para radioterapia con planificación",
              label: "Radiacion Oncologíca - Cita Inicial",
            },
            "rehab-hp": {
              description: "Ingreso a rehabilitación con valoración funcional inicial",
              label: "Rehabilitación - Admisión",
            },
            "rehab-progress": {
              description: "Evolución en rehabilitación con metas y progreso",
              label: "Rehabilitación - evolucion",
            },
            "rheumatology-followup": {
              description: "Consulta de seguimiento en reumatología",
              label: "Reumatología - Seguimiento",
            },
            "rheumatology-new": {
              description: "Primera consulta de paciente nuevo en reumatología",
              label: "Reumatología - Paciente Nuevo",
            },
            "snf-discharge": {
              description: "Resumen de alta desde SNF",
              label: "SNF - Epicrisis",
            },
            "snf-new": {
              description: "Ingreso a centro de enfermería especializada (SNF)",
              label: "SNF - Admisión",
            },
            "snf-progress": {
              description: "Evolución en SNF con estado funcional y cuidados",
              label: "SNF - Evolucion",
            },
            soap: {
              description: "Nota clínica en formato SOAP abreviado",
              label: "Nota Simplificada",
            },
            "surgery-followup": {
              description: "Seguimiento quirúrgico ambulatorio",
              label: "Cirugía - Evolucion",
            },
            "surgery-hp": {
              description: "Ingreso quirúrgico con valoración inicial y plan",
              label: "Cirugía - Nota de ingreso",
            },
            "surgery-new": {
              description: "Evaluación quirúrgica inicial con opciones terapéuticas",
              label: "Cirugía - Cita Inicial",
            },
            "surgery-preop": {
              description: "Evaluación preoperatoria y optimización de riesgo",
              label: "Cirugía - Nota Preoperatoria",
            },
            "surgery-progress": {
              description: "Evolución posquirúrgica/quirúrgica con plan",
              label: "Cirugía - evolucion",
            },
            "team-meeting": {
              description: "Reunión del equipo quirúrgico con acuerdos, tareas y plazos",
              label: "Junta Cirujanos",
            },
            test: {
              description: "Registro de prueba o verificación de sistema",
              label: "Prueba",
            },
            "therapy-followup": {
              description: "Seguimiento psicoterapéutico con técnicas aplicadas y plan",
              label: "Psicoterapia - Cita Seg",
            },
            "therapy-intake": {
              description: "Ingreso a psicoterapia con historia clínica y objetivos",
              label: "Psicoterapia - Ingreso",
            },
            transfer: {
              description: "Traslado a otra institución con resumen y motivos",
              label: "Medicina - Nota de Epicrisis y Tranferencia",
            },
            "transition-care": {
              description: "Coordinación de transición entre niveles/servicios con plan",
              label: "Nota de Transferencia",
            },
            "transitionalist-followup": {
              description: "Atención de seguimiento para pacientes en transición entre entornos de atención",
              label: "Seguimiento Transicional",
            },
            "urgent-care-simplified": {
              description: "Atención urgente con documentación abreviada",
              label: "Cuidado de Urgencia - simple",
            },
            "urology-followup": {
              description: "Seguimiento urológico con revisión de síntomas y estudios",
              label: "Urología - Cita Seg",
            },
            "urology-new": {
              description: "Evaluación urológica inicial con historia y examen",
              label: "Urología - Cita Inicial",
            },
            "well-woman-gyn": {
              description: "Consulta anual preventiva ginecológica con tamizajes",
              label: "Cita Prevencion - Ginicolocica",
            },
            "well-woman": {
              description: "Consulta anual preventiva con tamizajes para mujer",
              label: "Cita Prevencion - Mujer",
            },
            "woundcare-followup": {
              description: "Seguimiento de heridas con evaluación de evolución y curación",
              label: "Cuidado de Heridas - Cita Seg",
            },
            "woundcare-home-visit": {
              description: "Atención de heridas en domicilio con curación y plan",
              label: "Cuidado de Heridas - Domicilio",
            },
            "woundcare-new": {
              description: "Evaluación inicial para manejo de heridas",
              label: "Cuidado de Heridas - Cita Inicial",
            },
            "woundcare-procedure": {
              description: "Procedimiento para manejo de heridas (desbridamiento, curación)",
              label: "Cuidado de Heridas - Nota Cirujica",
            },
          },
          noteVisitTypes: {
            annualWellness: "Bienestar anual",
            standard: "Estándar",
            wellChild: "Control del niño sano",
            wellWoman: "Bienestar femenino",
          },
          orders: {
            form: {
              activeVasculitis: "¿Vasculitis activa o quemaduras de 3er grado presentes en el sitio de la herida?",
              anemia: "Anemia",
              anotherProvider: "otro proveedor",
              anteriorPosterior: "Anterior/Posterior",
              areaCm2: "Área (cm²)",
              autoLinkedToWound: "Vinculado automáticamente a las características de la herida",
              bloodLossPlaceholder: "ej., 400 mL",
              bothExudateNoneError:
                'Tanto el tipo como la cantidad de exudado son "Ninguno". Este pedido no se puede enviar — LCD L33831 requiere exudado documentado para la cobertura de apósitos de colágeno. Cambie los valores de exudado o proporcione documentación de cobertura alternativa.',
              cellulitis: "Celulitis",
              chf: "ICC",
              chiefComplaint: "Motivo de consulta",
              chills: "Escalofríos",
              classification: "Clasificación",
              collagenContraindicated: "El colágeno está contraindicado",
              confirm: "Confirmar",
              copd: "EPOC",
              cvd: "ECV",
              dateOfService: "Fecha de servicio",
              decreasedMobility: "Movilidad reducida",
              depthCm: "Profundidad (cm)",
              depthExposure: "Exposición de profundidad",
              describePlanAndMaterials: "Describir plan y materiales",
              diabetes: "Diabetes",
              dorsalPlantar: "Dorsal/Plantar",
              drainage: "Drenaje",
              edema: "Edema",
              enterPinToConfirm: "Ingrese el PIN para confirmar",
              erythema: "Eritema",
              eschar: "Escara",
              estimatedBloodLoss: "Pérdida estimada de sangre (mL)",
              exudateAmt: "Cantidad de exudado",
              exudateType: "Tipo de exudado",
              fever: "Fiebre",
              followUpDays: "Seguimiento (Días)",
              frequencyOtherPlaceholder: "ej., Según sea necesario, Cada 4 días",
              heavyExudateWarning: "Esta herida puede no ser admisible debido al exudado abundante.",
              homeHealthShipWarning:
                "Paciente de atención domiciliaria — los apósitos deben enviarse antes de la fecha de inicio del episodio de atención domiciliaria. La fecha de envío se validará contra la fecha de inicio en el cumplimiento.",
              homeHealthStartDate: "Fecha de inicio de atención domiciliaria",
              icd10Codes: "Códigos ICD-10",
              infection: "Infección",
              inferiorSuperior: "Inferior/Superior",
              isPatientAtSNF: "¿El paciente está en un centro de enfermería especializada?",
              isReceivingHomeHealth: "¿Recibe atención domiciliaria?",
              isUsingShorelineInsurance: "Usa seguro Shoreline",
              lengthCm: "Largo (cm)",
              markAsPrimaryCode: "Marcar como código primario",
              medialLateral: "Medial/Lateral",
              medicalNecessity: "Necesidad médica y justificación",
              nausea: "Náuseas",
              no: "No",
              noExudateAmountWarningChronic:
                "No se documentó cantidad de exudado. Si esta es una herida estancada o sin progreso, asegúrese de que se capturen el estado y la documentación de herida estancada.",
              noExudateAmountWarningSurgical:
                "LCD L33831 generalmente requiere exudado leve a moderado para cobertura de apósitos de colágeno en heridas quirúrgicas. Considere si la herida cumple con otros criterios de cobertura (espesor completo, estancada).",
              noExudateTypeWarningChronic:
                "No se documentó tipo de exudado. Si esta es una herida estancada o sin progreso, asegúrese de que se capturen el estado y la documentación de herida estancada.",
              noExudateTypeWarningSurgical:
                "LCD L33831 generalmente requiere exudado leve a moderado para cobertura de apósitos de colágeno en heridas quirúrgicas. Considere si la herida cumple con otros criterios de cobertura (espesor completo, estancada).",
              noProductSelected: "Ningún producto seleccionado",
              noneOfAbove: "Ninguno de los anteriores",
              notesOnDrainage: "Notas sobre drenaje",
              numbness: "Entumecimiento",
              odor: "Olor",
              orderAssignedTo: "Este pedido está asignado actualmente a {{name}}.",
              other: "Otro",
              otherMedicalConditions: "Otras condiciones médicas",
              pain: "Dolor",
              partialThicknessWarning: "Esta herida puede no ser admisible debido a la profundidad de espesor parcial.",
              patientFirstName: "Nombre del paciente",
              patientLastName: "Apellido del paciente",
              pinConfirmation: "Confirmación de PIN",
              pleaseSelectProvider: "Por favor seleccione un proveedor para reasignar este pedido.",
              probableDischargeDate: "Fecha probable de alta",
              productSelectionDisabled: "Selección de producto deshabilitada debido a contraindicación",
              proximalDistal: "Proximal/Distal",
              qualifyingWoundType: "Tipo de herida calificante",
              reassignOrder: "Reasignar pedido",
              reassignSubtitle: "Reasigne a usted mismo para firmar, o reasigne a otro proveedor para su firma.",
              reassignToAnotherProvider: "Reasignar a otro proveedor",
              reassignToMeAndSign: "Reasignar a mí y firmar",
              reassignToOtherAndSubmit: "Reasignar a otro y enviar",
              relink: "Re-vincular",
              relinkToAutoCalc: "Re-vincular para calcular automáticamente según características de la herida",
              secondaryNotRecommendedHeavy: "Apósito secundario no recomendado para exudado abundante",
              selectAllThatApply: "Seleccione todo lo que aplique",
              selectBloodThinners: "Seleccionar anticoagulantes",
              selectDMEProvider: "Seleccionar proveedor de DME",
              useManufacturersDme: "Usar el DME del fabricante",
              selectManufacturerDmeProvider: "Seleccionar proveedor de DME del fabricante",
              manufacturerDmeRequired: "Seleccione un DME acreditado antes de aprobar",
              addCredentialedDmeHint: "Agregue DMEs acreditados en Configuración",
              selectCredentialedDme: "Seleccione un DME acreditado",
              selectOption: "Seleccionar...",
              selectProduct: "Seleccionar un producto...",
              selectProviderPlaceholder: "Seleccionar un proveedor...",
              selectSecondaryDressing: "Seleccionar apósito secundario...",
              side: "Lado",
              site: "Sitio",
              sitePlaceholder: "ej. Pierna inferior izquierda",
              skinAtrophic: "Atrófica",
              skinCondition: "Condición de la piel",
              skinIschemic: "Isquémica",
              skinNormal: "Normal",
              skinSealantBarrier: "Sellador/Barrera de piel (Dermabond)",
              skinStasis: "Estasis",
              skinThin: "Delgada",
              snfAdmissionDate: "Fecha de admisión al centro de enfermería",
              specifyOtherBloodThinner: "Especificar otro anticoagulante",
              stage1: "Etapa 1",
              stage2: "Etapa 2",
              stage3: "Etapa 3",
              stage4: "Etapa 4",
              stagingWarning: "Esta herida puede no ser admisible debido a su estadificación identificada actualmente.",
              surgicalProcedureDate: "Fecha del procedimiento quirúrgico",
              surgicalProcedureName: "Nombre del procedimiento quirúrgico",
              surrSkin: "Piel circundante",
              temperature: "Temperatura",
              treatmentPlan: "Plan de tratamiento",
              tunneling: "Tunelización",
              undermining: "Socavamiento",
              useBloodThinners: "Uso de anticoagulantes",
              widthCm: "Ancho (cm)",
              withSecondaryDressings: "{{count}} con apósitos secundarios",
              woundNumber: "Herida {{number}}",
              woundStaging: "Estadificación de herida",
              woundVisit: "Visita de herida #",
              woundsHaveProducts: "{{count}} de {{total}} heridas tienen productos",
              yes: "Sí",
            },
            toasts: {
              addendumSaveFailed: "Error al guardar la adenda. Por favor intente de nuevo.",
              addendumSignFailed: "Error al firmar la adenda",
              addendumSignedSuccess: "Adenda firmada exitosamente",
              allFieldsCompleted: "¡Todos los campos requeridos completados! Ahora puede enviar el pedido.",
              approveFailed: "Error al aprobar el pedido",
              archiveFailed: "Error al archivar el pedido",
              assignOrderFailed: "Error al asignar el pedido",
              auditPacketDownloaded: "Paquete de auditoría descargado",
              auditPacketFailed: "Error al generar el paquete de auditoría",
              cameraAccessDenied: "No se puede acceder a la cámara. Por favor permita los permisos de cámara.",
              clinicalDocsRequired: "Por favor cargue la documentación clínica antes de enviar el pedido.",
              clinicalNoteSaveFailed: "Error al guardar la nota clínica.",
              clinicalNoteSignFailed: "Error al firmar la nota clínica",
              clinicalNoteSignedSuccess: "Nota clínica firmada exitosamente",
              commentAdded: "Comentario agregado exitosamente",
              commentFailed: "Error al agregar comentario",
              attachmentsPartialDrop: "Comentario guardado, pero {{count}} adjunto(s) no se pudieron cargar: {{names}}",
              dateOfServiceRequired: "La fecha de servicio es requerida",
              demoOrderCreated: "Pedido de demostración creado exitosamente",
              discardDraftFailed: "Error al descartar el borrador.",
              documentLoadFailed: "Error al cargar el documento",
              documentProcessing:
                "El documento se está procesando. Puede tardar unos momentos en aparecer en los detalles del pedido.",
              documentProcessingComplete: "Procesamiento del documento completado.",
              documentProcessingLong:
                "El procesamiento del documento está tardando más de lo esperado. Actualice para verificar el estado.",
              documentReplaceLogFailed: "Documento reemplazado, pero no se pudo registrar el cambio en el historial del pedido",
              documentReplaced: "Documento reemplazado y registrado en el historial del pedido",
              facesheetRequired: "Por favor cargue una hoja de datos antes de enviar el pedido.",
              invalidAddendumData: "Datos de adenda inválidos",
              ivrSaveFailed: "Error al guardar la información IVR. Por favor intente de nuevo.",
              markDeliveredFailed: "Error al marcar el pedido como entregado. Por favor intente de nuevo.",
              markedNotUrgent: "Pedido marcado como no urgente",
              markedUrgent: "Pedido marcado como urgente",
              noteAdded: "Nota interna agregada exitosamente",
              noteFailed: "Error al agregar nota interna",
              npiRequiredForAddendum: "Solo los proveedores con NPI pueden firmar adendas",
              operationFailed: "Operación fallida",
              orderApprovedSuccess: "Pedido aprobado exitosamente",
              orderArchived: "Pedido archivado",
              orderAssignedToAnother: "Este pedido está asignado a otro proveedor. Abra el pedido para reasignar y firmar.",
              orderCreationFailed: "Error al crear el pedido",
              orderMovedTo: "Pedido movido a {{status}}",
              orderReassignedAndSubmitted: "Pedido reasignado a {{name}} y movido a Pendiente de Firma.",
              orderRestoredFromArchive: "Pedido restaurado del archivo",
              orderSignFailed: "Error al firmar el pedido",
              orderSignedSuccess: "Pedido firmado exitosamente",
              orderStatusUpdated: "Estado del pedido actualizado",
              orderSubmitFailed: "Error al enviar el pedido",
              orderSubmittedForSignature: "Pedido enviado para firma",
              orderSubmittedSuccess: "Pedido enviado exitosamente",
              orderUnarchived: "Pedido desarchivado",
              packingSlipCleared: "Guía de empaque revisada y aprobada",
              packingSlipGenerateFailed: "Error al generar la guía de empaque",
              packingSlipGenerated: "Guía de empaque generada",
              packingSlipGenerationFailed: "Pedido enviado pero la guía de empaque no se generó",
              packingSlipUploadFailed: "Guía de empaque generada pero la carga falló",
              pdfGenerationFailed: "Error al generar el PDF",
              photoAttestationRequired: "Por favor confirme la atestación de la foto de herida",
              podSubmitFailed: "Error al enviar. Por favor intente de nuevo.",
              printFailed: "Error al imprimir",
              providerProfileNotFound: "No se pudo encontrar su perfil de proveedor",
              reassignFailed: "Error al reasignar el pedido",
              reminderCancelFailed: "Error al cancelar el recordatorio",
              reminderCancelled: "Recordatorio cancelado",
              manufacturerDmeAutoSuggested:
                "DME del fabricante autocompletado de su última selección: {{name}}. Puede cambiarlo antes de aprobar.",
              reminderMessageRequired: "Por favor proporcione un mensaje de recordatorio",
              reminderScheduleFailed: "Error al programar recordatorios",
              remindersScheduled: "{{count}} recordatorio(s) programado(s)",
              saveChangesFailed: "Error al guardar los cambios",
              secondaryDressingAutoUpdated:
                "Herida {{woundNumber}}: Apósito secundario actualizado automáticamente para coincidir con el tamaño del producto primario.",
              selectReminderInterval: "Seleccione al menos un intervalo de recordatorio",
              deliveryInfoUpdateFailed: "Error al actualizar la información de entrega",
              deliveryInfoUpdated: "Información de entrega actualizada y registrada en el historial del pedido",
              shipmentDateUpdateFailed: "Error al actualizar la fecha de envío",
              shipmentDateUpdated: "Fecha de envío actualizada y registrada en el historial del pedido",
              shipmentInfoUpdateFailed: "Error al actualizar la información de envío",
              shipmentInfoUpdated: "Información de envío actualizada y registrada en el historial del pedido",
              signatureRequired: "Por favor proporcione su firma",
              statusUpdateFailed: "Error al actualizar el estado del pedido",
              suspensionNoticeFailed: "Error al enviar aviso de suspensión",
              suspensionNoticeSent: "Aviso de suspensión enviado al proveedor",
              urgentStatusFailed: "Error al actualizar el estado de urgencia",
              urlDataLoadFailed: "Error al cargar datos desde la URL",
              verificationPhotoRequired: "Por favor tome una foto de verificación",
              woundAssessmentRequired: "Por favor agregue al menos una evaluación de herida antes de enviar el pedido.",
              woundPicturesRequired: "Las fotos de heridas son requeridas para heridas crónicas",
              woundTypeRequired: "Por favor seleccione el tipo de herida",
              orderUnlockedForEditing: "Orden desbloqueada. Edítela y pida al médico que la vuelva a firmar.",
              orderAssignedForResign: "Orden asignada a {{name}}. Ahora puede volver a firmarla.",
              unlockFailed: "No se pudo desbloquear la orden. Inténtelo de nuevo.",
              unlockStatusChanged:
                "Esta orden ya no está en Información adicional requerida, por lo que no se puede desbloquear. Actualice para ver su estado actual.",
              medicalNecessityRefreshedSign:
                "La necesidad médica se actualizó con el formulario completo. Revísela y vuelva a hacer clic en Firmar.",
              medicalNecessityRefreshedSubmit:
                "La necesidad médica se actualizó con el formulario completo. Revísela y vuelva a hacer clic en Enviar.",
              medicalNecessityRefreshFailed:
                "No se pudo actualizar la necesidad médica. Reintente con Regenerar o continúe con el texto actual.",
              medicalNecessityOpenToSign:
                "La necesidad médica está desactualizada. Abra el pedido para actualizarla antes de firmar.",
              shipToUpdated: "Dirección de envío actualizada y registrada en el historial del pedido",
              shipToCleared: "Envío restablecido a la dirección del paciente y registrado en el historial del pedido",
              shipToUpdateFailed: "Error al actualizar la dirección de envío",
            },
            narrativeFreshness: {
              title: "La necesidad médica está desactualizada",
              body: "El pedido cambió después de que se escribió este texto de necesidad médica, y el texto fue editado a mano. Regenérelo a partir del formulario completo o conserve su texto y continúe.",
              bodyAfterFailure:
                "El pedido cambió después de que se escribió este texto de necesidad médica, y el último intento de regenerarlo no se completó. Intente de nuevo o conserve el texto actual y continúe.",
              bodyUnverified:
                "No hay registro de cuándo se escribió este texto de necesidad médica, por lo que puede no coincidir con el formulario completo. Regenérelo a partir del formulario completo o conserve el texto actual y continúe.",
              regenerate: "Regenerar desde el formulario completo",
              keep: "Conservar mi texto y continuar",
            },
            errors: {
              attachmentTooLarge: "Demasiado grande para adjuntar (máx 10 MB): {{names}}",
              attachmentTypeNotAllowed: "Tipo de archivo no permitido: {{names}}",
              attachmentMaxCount: "Se alcanzó el máximo de 5 adjuntos por comentario — omitidos: {{names}}",
              attachmentMaxAggregate: "Los adjuntos combinados superan los 20 MB — omitidos: {{names}}",
              attachmentOpenFailed: "No se pudo abrir el archivo adjunto",
              attachmentScanPending: "Aún escaneando — intenta de nuevo en un momento",
              attachmentInfected: "Archivo en cuarentena — contacta a soporte",
              attachmentNotFound: "Adjunto ya no disponible",
              voiceNotSupported: "La entrada de voz no es compatible con este navegador. Prueba Chrome o Safari.",
              voicePermissionDenied: "Permiso de micrófono denegado",
              voiceFailed: "Error de entrada de voz: {{error}}",
              micBlocked: "El acceso al micrófono está bloqueado. Actívelo en la configuración de su navegador.",
              micNoDevice: "No se encontró ningún micrófono.",
              voiceUnsupported: "La entrada de voz no es compatible con este navegador. Pruebe Chrome, Edge o Safari.",
            },
            mic: {
              noDeviceTitle: "No se detectó micrófono",
              noDeviceBody:
                "No encontramos un micrófono conectado a este dispositivo. Conecta un micrófono o revisa la configuración de audio del sistema, e inténtalo de nuevo.",
              unsupportedTitle: "Entrada de voz no disponible",
              unsupportedBody: "Este navegador no admite entrada de voz. Cambia a Chrome, Edge o Safari para dictar comentarios.",
              deniedTitle: "El acceso al micrófono está bloqueado",
              deniedBody:
                "Tu navegador está bloqueando el acceso al micrófono para este sitio. Sigue los pasos a continuación para habilitarlo y luego haz clic en Reintentar.",
              tryAgain: "Reintentar",
              steps: {
                chrome1: "Haz clic en el ícono de candado a la izquierda de la URL",
                chrome2: "Busca Micrófono en el menú desplegable",
                chrome3: "Cámbialo a Permitir",
                chrome4: "Recarga la página",
                safari1: "Abre Safari → Configuración (Cmd+,)",
                safari2: "Ve a la pestaña Sitios web → Micrófono",
                safari3: "Configura este sitio en Permitir",
                safari4: "Recarga la página",
                generic1: "Abre la configuración del sitio en tu navegador para esta página",
                generic2: "Cambia el permiso de Micrófono a Permitir",
                generic3: "Recarga la página",
              },
            },
            labels: {
              addCommentPlaceholder: "Agregar un comentario...",
              attachment: "Adjunto",
              attachments: "Adjuntos",
              addNotePlaceholder: "Agregar una nota interna...",
              addendumSignedSubmitted: "Este adéndum ha sido firmado y enviado.",
              additionalDocs: "Documentos adicionales",
              additionalDocument: "Documento adicional",
              additionalIvrInfo: "Información IVR adicional",
              allClinicalAddendums: "Todos los adendas clínicas para esta orden.",
              amendRequired:
                "Esta orden cambió después de firmar el adéndum. Los nuevos elementos marcados requieren una enmienda firmada:",
              amendSubtitle:
                "La orden cambió después de firmar el adéndum. Justifique los nuevos elementos marcados a continuación y firme una enmienda aparte; el adéndum original firmado no se modifica.",
              andTrackingCode: "y código de seguimiento",
              approvedOn: "Aprobada el",
              archiveDescription: "Esto moverá la orden al archivo. No se enviarán notificaciones.",
              archived: "Archivada",
              by: "por",
              chooseHowToHandle: "Elija cómo desea gestionar esta orden:",
              chronic: "Crónica",
              clinic: "Clínica",
              correctedToNo: "Corregido a No en el formulario de la orden",
              clinicalDocs: "Documentos clínicos",
              clinicalDocumentation: "Documentación clínica",
              clinicalNoteSignedSubmitted: "Esta nota clínica ha sido firmada y enviada.",
              commercial: "Comercial",
              completeFollowingItems: "Complete los siguientes elementos para enviar a firma:",
              conditionalSuspensionDesc: "Notificar al proveedor. Se restaura automáticamente cuando responden.",
              creatingOrder: "Creando orden",
              criteriaProgress: "Progreso de los criterios:",
              dateOfService: "Fecha de servicio",
              deliveredOn: "Entregada el",
              dragAndDropFiles: "Arrastra y suelta archivos",
              enterClinicalNote: "Ingrese su nota clínica abajo. Se firmará y adjuntará a la orden.",
              eob: "EOB",
              facesheet: "Hoja de datos",
              fedexLabel: "Etiqueta FedEx",
              form1500: "Formulario 1500",
              generating: "Generando...",
              govtIns: "Seguro gub.",
              insuranceDemographics: "Demografía del seguro",
              invoiceReceipt: "Recibo de factura",
              ivrVerification: "Verificación IVR",
              insuranceAutoVerify: "El seguro se verificará automáticamente.",
              ivrStatusPending: "Verificando cobertura con pVerify…",
              ivrStatusVerified: "Autocompletado por pVerify el {{timestamp}}",
              ivrStatusDiscovered:
                "Pagador original no encontrado — pVerify Insurance Discovery sugirió {{payerName}}. ¿Aplicar los valores sugeridos?",
              ivrStatusFailed: "Verificación no disponible. Por favor, complete manualmente.",
              ivrApply: "Aplicar valores sugeridos",
              ivrDismiss: "Descartar",
              ivrRerun: "Reejecutar verificación",
              ivrRunDiscovery: "Ejecutar Insurance Discovery",
              ivrDiscoveryRunning: "Discovery en curso…",
              manufacturer: "Fabricante",
              manufacturerDmeBilling: "Facturado por su DME",
              markUrgentDesc: "Interruptor rápido para marcar esta orden como urgente",
              multipleImagesAllowed: "Se permiten múltiples imágenes",
              multiplePagesAllowed: "Se permiten múltiples páginas",
              newOrder: "Nueva orden",
              noCommentsYet: "Aún no hay comentarios",
              noHistory: "No hay historial disponible",
              signatureVoided: "Firma anulada",
              noIcd10Codes: "No se agregaron códigos ICD-10",
              icd10CodeMissing: "Falta el código",
              noInternalNotes: "Aún no hay notas internas",
              noWoundPhotos: "No se han subido fotos de heridas",
              notArchived: "No archivada",
              orderArchivedReadOnly: "La orden está archivada y no se puede modificar.",
              orderAuditReady: "La orden está lista para auditoría",
              orderForm: "Formulario de orden",
              orderSentForSignature: "La orden será enviada al proveedor seleccionado para revisión y firma.",
              otherRecords: "Otros registros",
              packagingSlip: "Lista de empaque",
              packingSlip: "Lista de empaque",
              patientFacesheet: "Hoja de datos del paciente",
              photoAttestation:
                "Doy fe de que estas fotografías de heridas fueron tomadas dentro de los 30 días de la fecha de servicio",
              postSurgical: "Post-quirúrgica",
              proofOfDelivery: "Prueba de entrega",
              provideClinicalJustification:
                "Proporcione justificación clínica para los elementos marcados y/o notas clínicas adicionales.",
              reasons: "Motivos:",
              removeUrgentDesc: "Quitar el indicador urgente de esta orden",
              requestingProviderSignature: "Está solicitando la firma del proveedor para la orden DME",
              requiredForChronicWounds: "Obligatorio para heridas crónicas",
              salesReceipt: "Recibo de venta",
              scheduleRemindersDesc: "Programar recordatorios por correo en intervalos personalizados",
              scrollDownToSign: "Desplácese hacia abajo para firmar",
              selectPlanType: "Seleccionar tipo de plan",
              carrier: "Transportista",
              deliveryDate: "Fecha de entrega",
              editShipmentDateNote: "Los cambios se registran en el historial del pedido.",
              shipmentDate: "Fecha de envío",
              shippedOn: "Enviada el",
              shippingQrCode: "Código QR de envío",
              specifyCarrier: "Especificar transportista",
              trackingCode: "Código de seguimiento",
              signedOn: "Firmada el",
              standardArchiveDesc: "Archivado permanente. No se envían notificaciones.",
              system: "Sistema",
              updated: "Actualizado",
              useShorelineInsurance: "Usar seguro Shoreline",
              withCarrier: "con transportista",
              withTrackingCode: "con código de seguimiento",
              wouldYouLikeToRestore: "¿Desea restaurarla?",
              wound: "Herida",
              woundPhotosOptional: "Las fotos de heridas son opcionales para heridas post-quirúrgicas",
              woundPhotosRequired: "Las fotos de heridas son obligatorias para heridas crónicas",
              woundPicture: "Foto de herida",
              woundPictures: "Fotos de heridas",
              woundType: "Tipo de herida",
              tracking: "Seguimiento",
              trackingComingSoon: "Información de seguimiento próximamente",
              unlockReason: "Motivo del desbloqueo",
              unlockReasonHelp:
                "Esto anula la firma actual. La orden permanece en Información adicional requerida y debe firmarse de nuevo antes de que el fabricante pueda aprobarla.",
              shipsTo: "Se envía a",
              shipToOverride: "Dirección alterna",
              shippingAddress: "Dirección",
              shippingCity: "Ciudad",
              shippingState: "Estado/Provincia",
              shippingZip: "Código postal",
              editShipToNote:
                "Esto registra la dirección de envío corregida en el pedido y en su historial. No redirige un paquete que ya está con la transportadora, y las etiquetas de envío de DME se generan fuera de la aplicación. La dirección del paciente en el expediente no cambia.",
            },
            validation: {
              completedCount: "{{completed}} de {{total}} completados",
              completed: "Completado",
              clickToComplete: "Haga clic para completar",
              clickToSelectDoctor: "Haga clic para seleccionar un médico",
              nextIncomplete: "Siguiente incompleto",
              labels: {
                assignToDoctor: "Asignar a médico",
                patientFirstName: "Nombre del paciente",
                patientLastName: "Apellido del paciente",
                dateOfService: "Fecha de servicio",
                woundVisitNumber: "Número de visita de herida",
                chiefComplaint: "Queja principal",
                hasContraindications: "Estado de contraindicaciones",
                isReceivingHomeCare: "Estado de salud en casa",
                homeHealthStartDate: "Fecha de inicio de salud en casa",
                isAtSNF: "Estado SNF",
                snfAdmissionDate: "Fecha de admisión SNF",
                subjectiveSymptoms: "Síntomas subjetivos",
                medicalConditions: "Condiciones médicas",
                bloodThinnersEnabled: "Uso de anticoagulantes",
                bloodThinners: "Selección de anticoagulantes",
                bloodThinnersOther: "Detalles de otro anticoagulante",
                woundAssessment: "Evaluación de heridas",
                medicalNecessity: "Necesidad médica",
                icd10Codes: "Códigos ICD-10",
                followUpDays: "Plan de seguimiento",
                clinicalDocumentationFile: "Carga de documentación clínica",
                faceSheetFile: "Carga de hoja de paciente",
                woundField: "Herida {{num}}: {{field}}",
                site: "Sitio",
                side: "Lado",
                length: "Longitud",
                width: "Ancho",
                depthExposure: "Exposición de profundidad",
                exudateType: "Tipo de exudado",
                exudateAmount: "Cantidad de exudado",
                exudateConflict: "Conflicto de exudado",
                cgsWoundType: "Tipo de herida CGS",
                surgicalProcedureName: "Nombre del procedimiento quirúrgico",
                skinSealantBarrier: "Sellante de piel / barrera",
                product: "Producto",
                dressingChangeFrequency: "Frecuencia de cambio de apósito",
                treatmentDuration: "Duración del tratamiento",
                secondaryDressing: "Apósito secundario",
              },
            },
            buttons: {
              addIcd10Code: "Agregar código ICD-10",
              addNote: "Agregar nota",
              addWound: "Agregar herida",
              addWoundPhoto: "Agregar foto de herida",
              additionalInfoNeeded: "Información adicional requerida",
              approveOrder: "Aprobar orden",
              archive: "Archivar",
              archiveOrder: "Archivar orden",
              backToList: "Volver a la lista",
              amendAddendum: "Enmendar adéndum",
              signAmendment: "Firmar enmienda",
              confirmReceipt: "Confirmo la recepción de los artículos anteriores",
              continue: "Continuar",
              continueAddendum: "Continuar adéndum",
              createReminders: "Crear recordatorios",
              deliveryConfirmedArchive: "Entrega confirmada, archivar",
              undo: "Deshacer",
              discard: "Descartar",
              downloadPdf: "Descargar PDF",
              downloadZip: "Descargar ZIP",
              editAndSubmitOrder: "Editar y enviar orden",
              generateAddendum: "Generar adéndum",
              generatePackingSlip: "Generar lista de empaque",
              manageSuspension: "Gestionar suspensión",
              markIncomplete: "Marcar como incompleto",
              needsAttention: "Necesita atención",
              noAddendumSubmitted: "Sin adéndum enviado",
              orderShipped: "Orden enviada",
              moveToShipped: "Marcar como enviada",
              pendingAddendum: "Adéndum pendiente",
              regenerate: "Regenerar",
              remove: "Eliminar",
              requestSignature: "Solicitar firma",
              reviewAndSignOrder: "Revisar y firmar orden",
              reviewDenied: "Revisado y denegado",
              reviewedCleared: "Revisado y aprobado",
              sendComment: "Enviar comentario",
              attachFiles: "Adjuntar archivos",
              openAttachment: "Abrir adjunto: {{name}}",
              removeAttachment: "Quitar adjunto",
              dismiss: "Descartar",
              signAddendum: "Firmar adéndum",
              signOrder: "Firmar orden",
              suspendOrder: "Suspender orden",
              unarchive: "Desarchivar",
              view1500Form: "Ver formulario 1500",
              viewAddendum: "Ver adéndum",
              viewAddendums: "Ver adendas ({{count}})",
              amendmentNeeded: "Se Necesita Enmienda",
              viewOrder: "Ver orden",
              viewIncompleteOrder: "Ver orden incompleta",
              reviewOrderBeforeSig: "Revisar orden antes de enviar a firma",
              viewRejectionReasons: "Ver motivos de rechazo",
              generating: "Generando…",
              copyTracking: "Copiar número de seguimiento",
              trackOnCarrier: "Seguir en {{carrier}}",
              dictate: "Dictar",
              done: "Listo",
              stopDictation: "Detener dictado",
              emoji: "Agregar emoji",
              unlockToEdit: "Desbloquear para editar",
              editOrder: "Editar orden",
              unlock: "Desbloquear",
              usePatientAddress: "Usar la dirección del paciente",
            },
            banner: {
              assignedToProvider: "Asignado a {{name}}",
              assignedToYou: "Asignado a usted",
              signedByProvider: "Firmado por {{name}}",
              signedByYou: "Firmado por ti",
              changeAssignee: "Cambiar",
              disabledReasonArchived: "Esta orden está archivada. Desarchive para editar.",
              disabledReasonManufacturer: "Solo lectura — está viendo esta orden como el fabricante.",
              disabledReasonStatusLocked: "Solo lectura — esta orden está {{statusLabel}}. Ya no se permiten cambios.",
              signatureVoided: "Firma anulada por {{name}} el {{date}}: {{reason}}. Edite y vuelva a firmar.",
              providerRevising:
                "El proveedor está revisando esta orden. La aprobación está deshabilitada hasta que se vuelva a firmar.",
            },
            statusLabels: {
              draft: "Borrador",
              submitted: "Pendiente de firma",
              signed: "Firmada",
              rejected: "Rechazada",
              approved: "Aprobada",
              shipped: "Enviada",
              delivered: "Entregada",
            },
            signProgress: {
              completeRequiredFields: "Complete los campos obligatorios",
              formComplete: "Formulario completo",
              progressLabel: "{{done}} de 2 — {{status}}",
              reviewed: "Revisada",
              reviewToSign: "Revisar orden para firmar",
              scrollToReview: "Desplácese para revisar la orden completa",
              signOrder: "Firmar orden",
            },
            autocalc: {
              dropdownNarrowed: "Mostrando tallas para herida de {{L}} × {{W}} cm. Cambie las medidas para ver otras tallas.",
              linkedToProduct: "Vinculado al producto",
              linkExplain: "Cuando está vinculado, se actualiza automáticamente con el producto principal.",
              partialDimensions: "Ingrese largo y ancho para ver tallas recomendadas.",
              secondaryAdjusted: "Ajustado automáticamente para cubrir el producto principal.",
              supervisorSizeOverride:
                "La talla seleccionada está fuera de la matriz de tallas de herida — anulación del supervisor. Esto puede generar mayor escrutinio en una auditoría.",
              undo: "Deshacer",
              unlinked: "Desvinculado",
            },
            productRestrictions: {
              currentProductUnavailable:
                "{{product}} ya no está disponible para esta cuenta. Elija otro producto antes de enviar.",
              powderUnavailable:
                "El polvo de colágeno no está habilitado para esta cuenta, así que el apósito se dimensionó según las medidas de la herida.",
              matrixSizeUnavailable:
                "El colágeno {{size}} no está habilitado para esta cuenta. Elija entre los tamaños disponibles.",
              noSecondaryAvailable: "No hay ningún apósito secundario habilitado para esta cuenta para esta herida.",
              submitBlocked: "Esta cuenta no puede pedir los productos seleccionados:",
              submitBlockedItem: "Herida {{wound}}: {{product}}",
            },
            sectionIndex: {
              ariaLabel: "Secciones de la orden",
              history: "Historial",
              necessity: "Necesidad",
              patient: "Paciente",
              sign: "Firma",
              wounds: "Heridas",
            },
            tunneling: {
              confirmTitle: "Confirmar cambio",
              confirmBody: "Cambiar tunelización a No borrará el producto seleccionado y el apósito secundario. ¿Continuar?",
              confirmContinue: "Sí, borrar producto",
              confirmCancel: "Mantener tunelización en Sí",
            },
            headings: {
              additionalClinicalNotes: "Notas clínicas adicionales",
              additionalDocumentation: "Documentación adicional",
              archiveThisOrder: "¿Archivar esta orden?",
              auditLog: "Registro de auditoría",
              authorizationReferral: "Requisitos de autorización y referencia",
              characteristics: "Características",
              claimLinePreview: "Vista previa de línea de reclamación",
              clinicalJustification: "Justificación clínica",
              amendedAddendum: "Enmienda del adéndum",
              coinsurance: "Coaseguro",
              complianceDetails: "Detalles de cumplimiento",
              coverageDetails: "Detalles de cobertura",
              deductible: "Deducible",
              dmeContactInfo: "Información de contacto DME",
              dmeSupplierInformation: "Información del proveedor DME",
              documents: "Documentos",
              electronicSignatureConsent: "Consentimiento de firma electrónica",
              existingAuthorization: "Autorización existente",
              financialResponsibility: "Responsabilidad financiera",
              frequencyOfDressingChange: "Frecuencia de cambio de apósito",
              identityVerification: "Verificación de identidad",
              internalNotes: "Notas internas",
              location: "Ubicación",
              measurements: "Medidas",
              medicalHistory: "Historia médica",
              notes: "Notas",
              orderDeliveryInformation: "Información de orden y entrega",
              orderSubjectiveSymptoms: "Síntomas subjetivos de la orden",
              originalClinicalAddendum: "Adéndum clínico original",
              outOfPocketMax: "Máximo de gastos de bolsillo",
              patientInformation: "Información del paciente",
              podRecorded: "Prueba de entrega registrada",
              prescriberInformation: "Información del prescriptor",
              productForWound: "Producto para esta herida",
              productOrderSummary: "Resumen de la orden de productos",
              productsDelivered: "Productos entregados",
              providerFacilitySpecifics: "Detalles de proveedor e instalación",
              reviewDeliveryDetails: "Revisar detalles de entrega",
              secondaryDressing: "Apósito secundario",
              signBelow: "Firme a continuación",
              skinAndStaging: "Piel y estadificación",
              somethingWentWrong: "Algo salió mal",
              status: "Estado",
              treatmentDuration: "Duración del tratamiento (días)",
              verificationMetadata: "Metadatos de verificación",
              woundPhotos: "Fotos de heridas",
              woundType: "Tipo de herida",
              wounds: "Heridas",
            },
            statuses: {
              approvedByManufacturer: "Esta orden ha sido aprobada por el fabricante",
              completeAndSubmit: "Por favor complete todos los campos requeridos y envíe la orden para su procesamiento.",
              draftStatus: "Esta orden está en estado borrador",
              needsManufacturerReview: "Esta orden necesita ser revisada por el fabricante",
              needsReview: "Esta orden necesita ser revisada",
              orderApproved: "Esta orden ha sido aprobada",
              orderArchived: "Esta orden está archivada.",
              orderDelivered: "Esta orden ha sido entregada",
              orderIsArchived: "Esta orden está archivada",
              orderShipped: "Esta orden ha sido enviada",
              orderSuspended: "Esta orden está suspendida",
              requiresAdditionalInfo: "Esta orden requiere información adicional",
              review1500AndDeliver: "Por favor revise el formulario 1500 y notifique si se entregó.",
              review1500AndShip: "Por favor revise el formulario 1500 y notifique si se envió.",
              reviewAndSign: "Por favor revise y firme la orden para su procesamiento.",
              reviewAndSubmitAdditionalInfo:
                "Por favor revise la orden y envíela para su procesamiento con la información adicional solicitada.",
              reviewAndTakeAction: "Por favor revise los detalles de la orden y tome las acciones necesarias.",
              shippedByManufacturer: "Esta orden ha sido enviada por el fabricante",
              suspended: "Suspendida",
              waitForClinicAdditionalInfo:
                "Por favor espere a que la clínica revise y envíe la orden con la información adicional.",
              waitForClinicSubmit: "Por favor espere a que la clínica revise y envíe la orden.",
              waitForDelivery: "Por favor espere la fecha de entrega.",
              waitForDoctorSign: "Por favor espere a que el médico revise y firme la orden.",
              waitForShipping: "Por favor espere la fecha de envío.",
              waitingForSignature: "Esta orden está esperando firma",
            },
            tabs: {
              attachments: "Archivos adjuntos",
              conversation: "Conversación",
              history: "Historial",
              internalNotes: "Notas internas",
              overview: "Resumen",
            },
            titles: {
              activeReminders: "Recordatorios activos",
              additionalClinicalNotes: "Notas clínicas adicionales",
              additionalIvrInfo: "Información IVR adicional",
              archiveOrSuspend: "Archivar o suspender orden",
              archiveOrder: "Archivar orden",
              clinicalAddendum: "Adéndum clínico",
              amendAddendum: "Enmendar adéndum",
              clinicalAddendums: "Adendas clínicas",
              clinicalDocsUploaded: "Documentación clínica subida",
              conditionalSuspension: "Suspensión condicional",
              createOrder: "Crear orden",
              editDeliveryInfo: "Editar información de entrega",
              editOrder: "Editar orden",
              editShipmentDate: "Editar fecha de envío",
              editShipmentInfo: "Editar información de envío",
              facesheetUploaded: "Hoja de datos subida",
              ivrCleared: "IVR aprobado",
              ivrDenied: "IVR denegado",
              ivrInReview: "IVR en revisión",
              ivrNotStarted: "IVR no iniciado",
              markNotUrgent: "Marcar como no urgente",
              markUrgent: "Marcar como urgente",
              notUrgent: "No urgente",
              orderArchived: "Orden archivada",
              orderCompletionGuide: "Guía de finalización de orden",
              regenerateWithUpdatedInfo: "Regenerar con información actualizada",
              removeUrgentFlag: "Quitar indicador urgente",
              replaceDocument: "Reemplazar documento",
              replaceProofOfDelivery: "Reemplazar comprobante de entrega",
              reviewOrderDraft: "Revisar orden - Borrador",
              reviewSignedOrder: "Revisar orden firmada",
              setUpReminders: "Configurar recordatorios",
              standardArchive: "Archivado estándar",
              suspendOrder: "Suspender orden",
              unreviewedComments: "Comentarios sin revisar",
              urgent: "Urgente",
              urgentOptions: "Opciones de urgencia",
              viewActiveReminders: "Ver recordatorios activos",
              woundPhotos: "Fotos de heridas",
              medicalNecessityRegenerateFailed: "No se pudo regenerar la necesidad médica — intente de nuevo.",
              unlockSignedOrder: "Desbloquear orden para editar",
              signatureVoidedAwaiting: "Firma anulada — pendiente de nueva firma",
              editShipTo: "Editar dirección de envío",
            },
            list: {
              searchFilter: "Filtro de búsqueda",
            },
            openOrder: "Abrir orden",
            sinceYouveBeenGone: {
              buttonLabel: "Actividad reciente",
              buttonTitle: "{{newCount}} nuevos de {{totalCount}} en los últimos 7 días",
              drawerTitle: "Actividad reciente",
              subtitle: "Últimos 7 días",
              unknownPatient: "Paciente desconocido",
              emptySeen: "Aún no hay actividad revisada.",
              narrative: {
                empty: "Sin actividad en los últimos 7 días.",
                noNew: "{{total}} eventos en los últimos 7 días. Estás al día.",
                newCount_one: "{{count}} nuevo",
                newCount_other: "{{count}} nuevos",
                totalInWindow: "de {{total}} en los últimos 7 días",
              },
              sections: {
                needsAttention: "Requiere atención",
                allActivity: "Toda la actividad",
              },
              tabs: {
                new: "Nuevos",
                recentlySeen: "Vistos recientemente",
              },
              row: {
                newMessages_one: "{{count}} mensaje",
                newMessages_other: "{{count}} mensajes",
                newNotes_one: "{{count}} nota",
                newNotes_other: "{{count}} notas",
                newCardChip: "Creada",
                newPill_one: "{{count}} nuevo",
                newPill_other: "{{count}} nuevos",
                reviewedBy: "Revisado por {{name}} · {{time}}",
                unknownReviewer: "Revisor desconocido",
                reviewedChip: "Revisado",
              },
              timeline: {
                movedTo: "{{actor}} movió a {{status}}",
                commented: "{{actor}} agregó un comentario",
                addedNote: "{{actor}} agregó una nota",
                urgent: "{{actor}} marcó como urgente",
                created: "{{actor}} creó esta orden",
                ivrApproved: "{{actor}} aprobó el IVR",
                ivrDenied: "{{actor}} rechazó el IVR",
                ivrReopened: "{{actor}} reabrió el IVR",
                ivrUpdated: "{{actor}} actualizó el IVR",
                auditPacketApproved: "{{actor}} aprobó el paquete de auditoría",
                auditPacketDenied: "{{actor}} rechazó el paquete de auditoría",
                auditPacketReopened: "{{actor}} reabrió el paquete de auditoría",
                auditPacketUpdated: "{{actor}} actualizó el paquete de auditoría",
                addendumAdded: "{{actor}} agregó un addendum",
                documentUploaded: "{{actor}} subió {{doc}}",
                documentReplaced: "{{actor}} reemplazó {{doc}}",
                archived: "{{actor}} retiró la orden del tablero",
                unarchived: "{{actor}} restauró la orden al tablero",
              },
              footer: {
                markNewSeen: "Marcar nuevos como vistos",
                close: "Cerrar",
              },
              toasts: {
                reviewFailed: "No se pudo actualizar el estado de revisión. Inténtalo de nuevo.",
              },
              orderDrawerBackLink: "← Volver a actividad reciente",
            },
            lane: {
              // Las etiquetas replican statusLabels.* para que los encabezados del kanban y las insignias de estado muestren el mismo texto.
              // "pending" corresponde al estado backend "pending" cuyo nombre de visualización es "Creando..."
              pending: { label: "Creando...", caption: "Esperando acción" },
              draft: { label: "Borrador", caption: "Aún no enviado" },
              submitted: { label: "Pendiente de firma", caption: "Esperando revisión" },
              signed: { label: "Revisión del fabricante", caption: "Con firma del proveedor" },
              approved: { label: "Aprobada", caption: "Lista para enviar" },
              shipped: { label: "Enviada", caption: "En camino" },
              delivered: { label: "Entregada", caption: "Recepción confirmada" },
              rejected: { label: "Información adicional requerida", caption: "Acción requerida" },
              fallback: { label: "Otro" },
            },
            filterSheet: {
              title: "Filtros",
              status: "Estado",
              sort: "Ordenar",
              view: "Vista",
              apply: "Aplicar",
              reset: "Restablecer",
              close: "Cerrar",
              archived: "Mostrar archivados",
              allLabel: "Todos",
              urgent: "Solo urgentes",
            },
            statusArt: {
              decorativeAriaLabel: "Ilustración de estado",
            },
            kanban: {
              emptyColumn: "Sin órdenes {{status}}",
              pills: {
                pending: "Pendiente",
                draft: "Borrador",
                submitted: "Acción requerida",
                signed: "En proceso",
                approved: "Aprobada",
                shipped: "En tránsito",
                delivered: "Completa",
                rejected: "Acción requerida",
              },
              descriptions: {
                pending: "Esperando acción",
                draft: "Aún no enviado",
                submitted: "Esperando firma del proveedor",
                signed: "En revisión del fabricante",
                approved: "Lista para enviar",
                shipped: "Su orden está en camino",
                rejected: "Se requiere respuesta del proveedor",
              },
              captions: {
                pending: "Esperando acción",
                draft: "Borrador",
                submitted: "Pendiente de firma",
                signed: "Revisión del fabricante",
                approved: "Lista para enviar",
                shipped: "En tránsito",
                rejected: "Información adicional requerida",
              },
            },
            notifSettings: {
              title: "Notificaciones de pedidos DME",
              userSectionTitle: "Mis notificaciones de pedidos DME",
              userSectionDesc: "Configuración personal de cómo recibe avisos sobre pedidos DME.",
              assignedOnly: {
                label: "Notificarme solo sobre pedidos asignados a mí",
                desc: "Las alertas en la aplicación sobre revisiones de pedidos y EOB se muestran solo cuando el pedido está asignado a usted.",
              },
              subtitle: "Elija cómo su consultorio recibe avisos sobre revisiones de pedidos y EOB recién recibidos.",
              loading: "Cargando…",
              save: "Guardar",
              saving: "Guardando…",
              saveSuccess: "Configuración de notificaciones guardada.",
              emailLocked: "El correo electrónico para estos no se puede desactivar.",
              cat: {
                orderProgress: "Progreso del pedido",
                actionNeeded: "Acción requerida",
                eobReceived: "EOB recibido",
              },
              desc: {
                orderProgress: "IVR aprobado y formulario 1500 aprobado",
                actionNeeded: "IVR denegado y formulario 1500 devuelto para correcciones",
                eobReceived: "Se adjunta una Explicación de Beneficios a un pedido",
              },
              channel: {
                both: "Correo + en la aplicación",
                email: "Solo correo",
                in_app: "Solo en la aplicación",
                none: "Desactivado",
              },
              toast: {
                ivrCompleted: "IVR aprobado para el pedido {{orderId}}",
                ivrDenied: "IVR denegado para el pedido {{orderId}}",
                form1500Cleared: "Formulario 1500 aprobado para el pedido {{orderId}}",
                form1500Incomplete: "El formulario 1500 necesita correcciones para el pedido {{orderId}}",
                eobReceived: "EOB recibido para el pedido {{orderId}}",
              },
              errors: {
                loadFailed: "No se pudo cargar la configuración de notificaciones.",
                saveFailed: "No se pudo guardar la configuración de notificaciones.",
              },
            },
            export: {
              button: "Exportar pedidos",
              title: "Exportar pedidos",
              subtitle:
                "Exporte estos pedidos a una hoja de cálculo o a un PDF imprimible. Nada sale de esta página hasta que exporte.",
              sections: {
                dateRange: "Rango de fechas",
                status: "Estado",
                organizations: "Organizaciones",
                columns: "Columnas",
                output: "Salida",
              },
              noOrganization: "(Sin organización)",
              orgAll: "Todas las organizaciones",
              orgSelected: "{{count}} seleccionadas",
              orgSearch: "Buscar organizaciones",
              dateBasis: {
                label: "Filtrar fechas por",
                dateOfService: "Fecha de servicio",
                createdOn: "Fecha de creación",
              },
              range: {
                all: "Todo el tiempo",
                last7: "Últimos 7 días",
                last30: "Últimos 30 días",
                last90: "Últimos 90 días",
                mtd: "Mes hasta la fecha",
                ytd: "Año hasta la fecha",
                custom: "Personalizado",
                from: "Desde",
                to: "Hasta",
              },
              status: {
                selectAll: "Seleccionar todo",
                clear: "Limpiar",
                includeArchived: "Incluir pedidos archivados",
              },
              columns: {
                selectAll: "Todas",
                none: "Ninguna",
                atLeastOne: "Elija al menos una columna para exportar.",
              },
              presets: {
                basic: "Básico",
                shipping: "Envío",
                billing: "Facturación",
                everything: "Todo",
              },
              categories: {
                patient: "Paciente",
                order: "Pedido",
                clinical: "Clínico",
                office: "Proveedor / consultorio",
              },
              fields: {
                patientFirstName: "Nombre",
                patientLastName: "Apellido",
                patientDOB: "Fecha de nacimiento",
                patientAddress: "Dirección",
                patientCity: "Ciudad",
                patientState: "Estado/Provincia",
                patientZipCode: "Código postal",
                id: "N.º de pedido",
                dateOfService: "Fecha de servicio",
                createdOn: "Fecha de creación",
                status: "Estado",
                isUrgent: "Urgente",
                signedOn: "Fecha de firma",
                signedBy: "Firmado por",
                signedUserNPI: "NPI del firmante",
                approvedOn: "Fecha de aprobación",
                shipmentDate: "Fecha de envío",
                trackingCode: "N.º de seguimiento",
                deliveryDate: "Fecha de entrega",
                products: "Productos",
                icd10Codes: "Códigos ICD-10",
                woundCount: "Heridas",
                lengthOfNeedDays: "Duración necesaria (días)",
                organization: "Organización",
                officeName: "Nombre del consultorio",
                officeAddress: "Dirección del consultorio",
                officeCity: "Ciudad del consultorio",
                officeState: "Estado/Provincia del consultorio",
                officeZip: "Código postal del consultorio",
                assignedTo: "Asignado a",
                productName: "Producto",
                productSize: "Tamaño",
                productHcpcs: "HCPCS",
                productQuantity: "Cant.",
              },
              rowShape: {
                label: "Filas",
                perOrder: "Una fila por pedido",
                perProduct: "Una fila por línea de producto",
              },
              format: {
                label: "Formato",
                csv: "CSV",
                pdf: "PDF",
              },
              matchCount_one: "{{count}} pedido coincide",
              matchCount_other: "{{count}} pedidos coinciden",
              noMatches: "Ningún pedido coincide con estos filtros",
              pdfColumnWarning:
                "{{count}} columnas son muchas para una página PDF — el CSV mantiene todas las columnas legibles.",
              exportAction: "Exportar",
              cancel: "Cancelar",
              errors: {
                failed: "No se pudo generar la exportación. Pruebe con un rango de fechas más corto o menos columnas.",
              },
              pdf: {
                title: "Exportación de pedidos",
                generated: "Generado {{date}}",
                page: "Página {{page}} de {{pages}}",
                empty: "Ningún pedido coincide.",
              },
            },
            fieldNames: {
              signature: "Firma",
              shippingAddress: "Dirección de envío",
              shippingCity: "Ciudad de envío",
              shippingState: "Estado/Provincia de envío",
              shippingZip: "Código postal de envío",
            },
            badges: {
              revising: "En revisión",
            },
          },
          pages: {
            analytics: {
              allEncountersCompliant: "Todos los encuentros son conformes",
              avgEfficiencyTooltip: "Eficiencia promedio de encuentros",
              avgEncounters: "Encuentros promedio",
              avgEncountersTooltip: "Encuentros promedio generados por día",
              avgTime: "Tiempo promedio",
              avgTimeTooltip: "Tiempo promedio de grabación de transcripción (mm:ss)",
              compliance: "Cumplimiento",
              complianceMeasures: "Medidas de cumplimiento",
              compliant: "Conforme",
              efficiency: "Eficiencia",
              efficiencyTooltip: "Tiempo dedicado sobre brechas en medidas de cumplimiento",
              elapsed: "transcurrido",
              encounters: "Encuentros",
              encountersGeneratedTooltip: "Encuentros generados en el período seleccionado",
              expected: "esperado",
              good: "Bueno",
              id: "ID",
              kpi: "KPI",
              kpiMetrics: "métricas KPIs",
              kpiPoints: "puntos KPI",
              metricA1c: "Detección de A1c",
              metricBMI: "Detección de IMC",
              metricBP: "Detección de presión arterial",
              metricBreast: "Detección de cáncer de mama",
              metricColonoscopy: "Detección por colonoscopía",
              metricDepression: "Detección de depresión",
              metricFall: "Evaluación de riesgo de caídas",
              metricFlu: "Vacuna contra la influenza",
              metricMedAdherence: "Reconciliación de medicamentos",
              metricTobacco: "Evaluación de tabaquismo",
              missingV28: "V28 faltante",
              missingV28Tooltip: "Encuentros sin código V28",
              name: "Nombre",
              needsAttention: "Necesita atención",
              noKPIMetrics: "No hay métricas KPI disponibles",
              notCompliant: "No conforme",
              notCompliantHeader: "No conforme",
              notCompliantTooltip: "KPIs no conformes",
              openCharts: "Gráficos abiertos",
              openChartsTooltip: "Encuentros no sincronizados con EHR o copiados a secciones",
              openChat: "Abrir note",
              patient: "Paciente",
              period: "Período",
              physician: "Médico",
              quality: "Calidad",
              monitorPhysician: "Monitoree la eficiencia, el cumplimiento y las métricas de calidad de los médicos",
              providerPerformance: "Desempeño del proveedor",
              qualityMetrics: "Métricas de calidad",
              recentEncounters: "Encuentros recientes",
              singleV28Code: "Código V28 único",
              singleV28CodeTooltip: "Encuentros con un solo código V28",
              speciality: "Especialidad",
              status: "Estado",
              thisMonth: "Este mes",
              thisQuarter: "Este trimestre",
              thisWeek: "Esta semana",
              timeEfficiency: "Eficiencia de tiempo",
              today: "Hoy",
              totalTime: "Tiempo total",
              tresholdEfficiency: "Umbral de eficiencia",
              tresholdGaps: "Umbral de brechas",
              twoOrMoreV28: "2+ códigos V28",
              twoOrMoreV28Tooltip: "Encuentros con 2 o más códigos V28",
              type: "Tipo",
              unableToLoad: "No se pueden cargar analíticas",
              viewChat: "Ver note",
              year: "Año",
              ytd: "Año hasta la fecha",
              deployAgent: {
                deploySelected: "Desplegar seleccionados",
              },
            },
            clinicalProfileDetail: {
              accountCreationFailed: "La creación de la cuenta falló — no se devolvió un ID de usuario",
              couldNotLoadProfile: "No se pudo cargar el perfil clínico",
              failedToCreateAccount: "Error al crear la cuenta del paciente",
              groups: {
                activity: "Actividad",
                lifestyle: "Estilo de vida y sistemas",
                medicalHistory: "Historia clínica",
                overview: "Resumen",
              },
              patientAccountCreated: "Cuenta del paciente creada",
              profileNotFound: "Perfil clínico no encontrado",
              inviteToDashboard: "Invitar al panel",
              resendInvite: "Reenviar invitación",
              relinkPricingAccess: "Renovar acceso al precio",
              statusPending: "Pendiente",
              statusInvited: "Invitado",
              statusLinked: "Vinculado",
              statusArchived: "Archivado",
              archive: "Archivar",
              permanentlyDelete: "Eliminar permanentemente",
              confirmArchive: "¿Archivar este perfil? Quedará oculto de la lista activa.",
              confirmPermanentDelete: "¿Eliminar permanentemente este perfil? Esta acción no se puede deshacer.",
              archivedSuccess: "Perfil archivado",
              deletedSuccess: "Perfil eliminado",
              archiveFailed: "No se pudo archivar el perfil",
              deleteFailed: "No se pudo eliminar el perfil",
            },
            bootstrap: {
              inviteInvalid: "Tu invitación al perfil clínico ya no es válida. Por favor pídele a tu proveedor un nuevo enlace.",
            },
            createAccount: {
              emailPlaceholder: "Tu correo electrónico",
              errorCreatingAccount: "Error al crear la cuenta",
              errorInvalidEmail: "Por favor ingresa un correo electrónico válido",
              errorInvalidPracticeName: "Por favor ingrese el nombre de su práctica",
              practiceNamePlaceholder: "Nombre de la Práctica",
              registerButton: "Registrarse",
              successCheckEmail: "Por favor revisa tu correo electrónico",
              title: "Crear una cuenta",
            },
            ehrTemplates: {
              enterJSON: "Por favor ingresa JSON para importar",
              errorDeleting: "Error al eliminar la plantilla",
              errorImporting: "Error al importar la plantilla. Asegúrate de que el JSON sea válido.",
              errorSaving: "Error al guardar la plantilla",
              invalidJSON: "JSON de plantilla inválido",
              saveBeforeCloning: "Por favor guarda tus cambios antes de clonar",
              templateDeleted: "Plantilla eliminada",
              templateImported: "Plantilla importada",
              templateSaved: "Plantilla guardada",
            },
            ehrTemplatesEdit: {
              dragToReorder: "Arrastrar para reordenar",
              sectionDuplicated: "Sección duplicada",
              templateNotFound: "Plantilla no encontrada",
              cloneTemplateTitle: "Clonar plantilla a otras plantillas",
              cloneTo: "Clonar a",
              cloneModalSearchPlaceholder: "Buscar plantillas",
              cloneModalSelectAllShown: "Seleccionar todas las visibles",
              cloneModalEmptyValue: "—",
              cloneModalNoOtherTemplates: "No hay otras plantillas a las que clonar.",
              cloneModalNoMatches: "Ninguna plantilla coincide con tu búsqueda.",
              cloneModalConfirm: "Esto sobrescribirá las siguientes {{count}} plantilla(s):\n\n{{names}}\n\n¿Deseas continuar?",
              cloneModalConfirmSystemSwitch: "Las siguientes también se cambiarán a {{system}}:\n\n{{names}}",
              cloneModalPartialFailureToast: "Clonado en {{succeeded}} de {{total}}. Fallidas: {{names}}",
              cloneModalButton_one: "Clonar a {{count}} plantilla",
              cloneModalButton_other: "Clonar a {{count}} plantillas",
              cloneModalSuccessToast_one: "Clonado en {{count}} plantilla",
              cloneModalSuccessToast_other: "Clonado en {{count}} plantillas",
              presetCptModifier: "Establecer modificador por línea (procedimientos en consultorio)",
              presetOpUnits: "Establecer unidades por código (procedimientos en consultorio)",
              presetAnnualModifier: "Establecer modificador de la línea preventiva",
            },
            home: {
              cancel: "Cancelar",
              deleteEncounter: "¿Quieres eliminar este encuentro?",
              deleteEncounters: "¿Quieres eliminar {{count}} encuentros?",
              deleteSelected: "Eliminar ({{count}})",
              deselectAll: "Deseleccionar todos",
              encounterDeleted: "Encuentro eliminado exitosamente",
              encountersDeleted: "{{count}} encuentros eliminados exitosamente",
              enterPin: "Ingresa el código PIN de 4 dígitos para bloquear el encuentro y archivarlo.",
              errorDeletingEncounter: "Error al eliminar el encuentro. Por favor intenta de nuevo.",
              generate: "Generar",
              howToStart: "Cómo empezar",
              lock: "Bloquear",
              lockAndFinalize: "Bloquear y finalizar el encuentro",
              newPatient: "Nuevo paciente",
              no: "No",
              pleaseUpgrade: "Por favor actualiza tu plan",
              reachedLimit: "Alcanzaste el límite de notas de tu plan",
              subscriptionInactive: "Tu suscripción no está activa. Agrega un método de pago para seguir generando notas.",
              recordButton: "Botón de grabar",
              selectAll: "Seleccionar todos",
              selectedCount: "{{count}} seleccionados",
              step1: "Haz clic en el botón",
              step1b: "para iniciar un encuentro.",
              step2: "Selecciona el tipo de nota y luego haz clic en",
              step3:
                "Si estás grabando desde tu teléfono, asegúrate de colocarlo entre tú y el paciente para obtener la mejor calidad de audio.",
              step4: "Habla con el paciente",
              step4b:
                ". Incluye detalles sobre el paciente, sus síntomas, etc. Recuerda, la plataforma está escuchando para crear una nota detallada. Habla sobre todo lo que quieres que la plataforma tenga en cuenta sobre el encuentro.",
              step5: "Cuando termines, haz clic en el botón",
              step5b: "para crear la nota.",
              upgrade: "Actualizar",
              upgradePlan: "Actualizar plan",
              yesDelete: "Sí, eliminar",
            },
            locations: {
              cancel: "Cancelar",
              confirmDelete: "¿Estás seguro de que deseas eliminar esta ubicación?",
              createLocation: "Crear ubicación",
              delete: "Eliminar",
              deleteLocation: "Eliminar ubicación",
              editLocation: "Editar ubicación",
              errorCreating: "Error al crear la ubicación",
              errorDeleting: "Error al eliminar la ubicación",
              errorUpdating: "Error al actualizar la ubicación",
              locationName: "Nombre de la ubicación",
              pleaseAddName: "Por favor agrega el nombre de la ubicación",
              save: "Guardar",
              update: "Actualizar",
            },
            login: {
              errorDuringLogin: "Error durante el inicio de sesión",
              errorSendingLoginLink: "Error al enviar el enlace de inicio de sesión.",
              loginLinkSentEmail: "Se ha enviado un enlace de inicio de sesión a su correo electrónico.",
              loginLinkSentPhone: "Se ha enviado un enlace de inicio de sesión a su teléfono.",
              loginNotValid: "Inicio de sesión no válido",
              credentialsOrOrgInvalid: "El correo, la contraseña o la organización son incorrectos.",
              serverUnreachable: "No podemos conectarnos al servidor en este momento. Verifica tu conexión e inténtalo de nuevo.",
              serverError: "Algo salió mal de nuestro lado. Por favor, inténtalo de nuevo en un momento.",
              tooManyAttempts: "Demasiados intentos. Por favor, espera un momento e inténtalo de nuevo.",
              capsLockOn: "Bloq Mayús está activado",
              sessionLimit:
                "Esta cuenta ya tiene la sesión iniciada en {{max}} dispositivos a la vez, el máximo permitido. Cierra la sesión en uno de ellos, o espera {{minutes}} minutos desde su último uso, y vuelve a intentarlo. Si otras personas usan esta cuenta, cada una necesita su propio acceso.",
              signOutOtherDevices: "Cerrar sesión en mis otros dispositivos y entrar aquí",
            },
            orders: {
              allOrdersSubmitted: "Todas las órdenes enviadas por clínicas asociadas",
              clinicalDocUploadedSuccess: "Documentación clínica subida exitosamente",
              createdOn: "Creado el",
              dateOfService: "Fecha de servicio",
              dme: "DME",
              errorCreatingOrder: "Error al crear la orden",
              facesheetUploadedSuccess: "Hoja de datos subida exitosamente",
              failedToFetchOrders: "Error al obtener las órdenes",
              firstName: "Nombre",
              lastName: "Apellido",
              newOrder: "Nueva orden",
              onlyArchived: "Solo archivadas",
              onlyUrgent: "Solo urgentes",
              newest: "Más recientes",
              oldest: "Más antiguos",
              filterBy: "Filtrar por",
              orderCount_one: "{{count}} orden",
              orderCount_other: "{{count}} órdenes",
              orderCreatedSuccess: "Orden creada exitosamente",
              orderId: "ID de orden",
              ordersToManufacturer: "Órdenes para enviar al fabricante ({{manufacturer}})",
              peptides: "Péptidos",
              showStatus: "Mostrar estado",
              status: "Estado",
              statusApproved: "Aprobada",
              statusDelivered: "Entregada",
              statusDraft: "Borrador",
              statusPending: "Creando...",
              statusRejected: "Información adicional requerida",
              statusShipped: "Enviada",
              statusSigned: "Revisión del fabricante",
              statusSubmitted: "Pendiente de firma",
              title: "Órdenes",
              viewBoard: "Ver tablero",
              viewLabel: "Vista",
              viewTable: "Ver tabla",
            },
            patients: {
              cachedAsOf: "Lista de pacientes al {{date}}",
              checkDuplicates: "Verificar duplicados",
              loadFailed: "No se pudieron cargar los pacientes. Inténtelo de nuevo.",
              patient: "Paciente",
              patientCount: "Paciente",
              profileCount: "Perfil",
              status: "Estado",
              title: "Pacientes",
            },
            patientsEdit: {
              couldNotLoadProfile: "No se pudo cargar el perfil del paciente",
            },
            settings: {
              pleaseInsertZipcode: "Por favor ingrese el código postal",
              pleaseSelectState: "Por favor seleccione un estado",
            },
          },
          patients: {
            detail: {
              address: "Dirección",
              age: "Edad",
              call: "Llamada telefónica",
              city: "Ciudad",
              country: "País",
              dateOfBirth: "Fecha de nacimiento",
              email: "Correo electrónico",
              female: "Femenino",
              firstName: "Nombre",
              groupNumber: "Número de grupo",
              insuranceCarrier: "Aseguradora",
              insuredCity: "Ciudad del asegurado",
              insuredDob: "Fecha de nacimiento del asegurado",
              insuredName: "Nombre del asegurado",
              insuredState: "Estado del asegurado",
              insuredStreetAddress: "Dirección del asegurado",
              insuredZip: "Código postal del asegurado",
              language: "Idioma",
              lastName: "Apellido",
              male: "Masculino",
              patientSaved: "Paciente guardado",
              phone: "Teléfono",
              policyNumber: "Número de póliza",
              prefComm: "Comunicación preferida",
              save: "Guardar",
              sex: "Sexo",
              state: "Estado",
              text: "Mensaje de texto",
              zip: "Código postal",
            },
            edit: {
              assignedTo: "Asignado a",
              cancel: "Cancelar",
              completePatientInfo: "Completa la información del paciente antes de continuar",
              dateOfBirth: "Fecha de nacimiento",
              encounterType: "Tipo de encuentro",
              errorFetchingPatient: "Error al obtener paciente",
              errorUpdatingChat: "Error al actualizar el chat",
              errorUpdatingPatient: "Error al actualizar el paciente",
              fin: "ID Financiero",
              firstName: "Nombre",
              gender: "Género",
              identityWarningAnonymous: "El nombre del paciente no debe ser anónimo para crear un seguimiento.",
              identityWarningDOB: "Se requiere la fecha de nacimiento del paciente para crear un encuentro de seguimiento.",
              lastName: "Apellido",
              mobilePhone: "Teléfono móvil",
              notAssigned: "No asignado",
              patientIdentification: "Cuarto del paciente",
              patientUpdated: "Paciente actualizado",
              title: "Editar paciente",
              update: "Actualizar",
              visitTime: "Hora de visita",
            },
            list: {
              dob: "Fecha de nacimiento",
              firstName: "Nombre",
              gender: "Género",
              lastName: "Apellido",
              phone: "Teléfono",
              search: "Buscar",
              searchFilter: "Buscar con el filtro para ver todos los pacientes",
            },
            modal: {
              title: "Editar paciente",
            },
            toasts: {
              failedCloseSession: "Error al cerrar la sesión",
              failedCreateEncounter: "Error al crear el encuentro. Por favor, inténtelo de nuevo.",
              failedLoadDuplicates: "Error al cargar pacientes duplicados. Por favor, reintente.",
              failedLoadSessions: "Error al cargar las sesiones salientes.",
              failedMergePatients: "No se pudieron fusionar los pacientes seleccionados. Por favor, reintente.",
              failedResendSms: "Error al reenviar SMS",
              failedSendLink: "Error al enviar el enlace. Por favor, inténtelo de nuevo.",
              failedUpdateReminders: "Error al actualizar los recordatorios",
              remindersUpdated: "Recordatorios actualizados",
              sessionClosed: "Sesión cerrada",
              smsResentSuccess: "SMS reenviado exitosamente",
              usersMergedSuccess: "{{count}} usuarios fusionados exitosamente",
              voiceLinkSent: "Enlace de encuentro de voz enviado por SMS",
            },
          },
          recon: {
            title: "Calculadora de Reconstitución y Dosificación",
            subtitle:
              "Ingrese la concentración del vial y el diluyente para obtener la concentración, luego una dosis objetivo para ver las unidades a cargar en una jeringa U-100.",
            viewDisclaimer: "Ver el aviso legal firmado",
            reset: "Restablecer",
            toolsLabel: "Herramientas",
            footnote:
              "Solo apoyo a la decisión clínica. Verifique de forma independiente cada valor con la información de prescripción del fabricante antes de usarlo.",
            step1: { label: "¿Qué contiene el vial?", hint: "Seleccione la concentración impresa en el vial del péptido." },
            step2: {
              label: "¿Cuánto diluyente?",
              hint: "Agua bacteriostática agregada — esto define la concentración.",
              mixture: "La mezcla será de",
            },
            step3: {
              label: "Dosis objetivo por administración",
              hint: "Elija la dosis que desea cargar cada vez.",
              conversion: "Conversión de unidades",
            },
            conclusion: {
              title: "Conclusión",
              empty: "Seleccione la concentración del vial, el volumen de diluyente y la dosis objetivo para ver la carga.",
              tagPrep: "Preparación única",
              tagDose: "Cada dosis",
              diluent: "Agregar al vial",
              diluentSub: "Agua bacteriostática — mézclela en el vial una sola vez. Nunca se inyecta sola.",
              draw: "Cargar en la jeringa",
              units: "unidades",
              drawSub: "En una jeringa de insulina U-100 — esto es lo que se inyecta.",
              dose: "Esto administra",
              dosesPerVial: "dosis por vial",
              barrel: "Tamaño de la jeringa",
              howto:
                "El paso 1 es un mezclado único: agregue el agua bacteriostática al vial y agítelo suavemente. Para cada dosis, cargue en la jeringa solo las unidades del paso 2. Nunca inyecte el agua bacteriostática sola.",
            },
            warning: {
              doseExceedsVial: "La dosis objetivo es mayor que todo el vial. Revise los datos ingresados.",
              exceedsBarrel:
                "Esta dosis supera la capacidad de la jeringa seleccionada. Use más diluyente o una jeringa más grande.",
            },
            tech: {
              show: "Mostrar detalles técnicos",
              hide: "Ocultar detalles técnicos",
              concentration: "Concentración",
              volume: "Volumen a cargar",
            },
            disclaimer: {
              title: "Calculadora de Reconstitución — Términos de Uso",
              captureNotice:
                "Para verificar su aceptación, registramos su nombre, la fecha y hora, su dirección IP y la información de su dispositivo y navegador, y los conservamos en nuestros registros internos.",
              scrollToContinue: "Desplácese hasta el final para continuar",
              ack: "He leído, entiendo y acepto quedar legalmente obligado por estos Términos de Uso, incluida la renuncia de garantías, la limitación de responsabilidad, la indemnización, la renuncia a juicio por jurado y la renuncia a demandas colectivas.",
              effective: "Vigente desde",
              agree: "Acepto",
              maybeLater: "Quizás más tarde",
              cancel: "Cancelar",
              saving: "Registrando…",
              saveError: "No se pudo registrar su aceptación. Inténtelo de nuevo.",
            },
            records: {
              menuLabel: "Aviso de la Calculadora de Reconstitución",
              statusSigned: "Aceptado",
              signedBadge: "Aceptado v{{version}} el {{date}} por {{name}}",
              revokedBadge: "Revocado el {{date}} — abra la calculadora para aceptar de nuevo.",
              outdated: "Hay una nueva versión vigente. Abra la calculadora para revisar y aceptar de nuevo.",
              notSigned: "Aún no aceptado. Abra la Calculadora de Reconstitución para revisar y aceptar.",
              openCalculator: "Abrir la calculadora",
              revoke: "Revocar acceso",
              revoking: "Revocando…",
              revoked: "Su aceptación ha sido revocada.",
              revokeConfirm:
                "¿Revocar su aceptación? Perderá el acceso a la Calculadora de Reconstitución hasta que vuelva a aceptar.",
              revokeError: "No se pudo revocar. Inténtelo de nuevo.",
            },
          },
          peptides: {
            productLines: {
              collagen: "Colágeno (DME)",
              collagenDesc: "Pedidos de cuidado de heridas basados en seguro.",
              comingSoon: "Próximamente",
              confirmDisableDme:
                "¿Desactivar pedidos de DME / Colágeno para su organización? Los proveedores ya no podrán crear pedidos de cuidado de heridas basados en seguro.",
              description: "Habilite o deshabilite líneas de productos para su organización.",
              dmeLockedHelp: "Contacte a su representante de ventas para habilitar DME en esta cuenta.",
              exosomes: "Exosomas",
              manageCatalog: "Administrar Catálogo",
              neuroStim: "Estimulador Neuro para el Dolor",
              peptidesDesc: "Pedidos directos de péptidos con pago en efectivo y pago en línea.",
              peptidesLockedHelp: "Contacte a su representante de ventas para habilitar Péptidos en esta cuenta.",
              peptidesToggle: "Péptidos (Pago en Efectivo)",
              saved: "Líneas de productos actualizadas",
              title: "Líneas de Productos",
            },
            orderStatus: {
              draft: "Borrador",
              delivered: "Entregado",
              shipped: "Enviado",
              confirmed: "Aprobado",
              readyForPickup: "Recoger",
              pickedUp: "Recogido",
              payment_pending: "Aprobado",
              payment_authorized: "Pedido realizado",
              payment_capturing: "Procesando aprobación",
              cancelled: "Cancelado",
              denied: "Rechazado",
              payment_failed: "Problema con el pago",
              awaiting_restock: "Esperando restock",
            },
            toasts: {
              checkCardDetails: "Por favor verifique los datos de su tarjeta",
              clinicAddressIncomplete: "La dirección de la clínica está incompleta. Por favor edite y complete todos los campos.",
              copiedToClipboard: "Copiado al portapapeles",
              failedToCopy: "No se pudo copiar",
              distribPriceBelowCost: "El precio de distribuidor no puede ser menor que el costo",
              draftOrderArchived: "Borrador de pedido archivado",
              draftOrderUnarchived: "Borrador de pedido desarchivado",
              errorPlacingOrder: "Error al realizar el pedido. Por favor intente de nuevo.",
              failedToApproveOrder: "Error al aprobar el pedido",
              failedToArchiveOrder: "Error al archivar el pedido",
              failedToCancelOrder: "Error al cancelar el pedido",
              failedToConfirmPayment: "Error al confirmar el pago",
              failedToDeleteProduct: "Error al eliminar el producto",
              failedToLoadCatalog: "Error al cargar el catálogo",
              failedToLoadDraftOrder: "Error al cargar el borrador del pedido",
              failedToLoadOrder: "Error al cargar el pedido",
              failedToLoadOrders: "Error al cargar los pedidos",
              failedToLoadPricingData: "Error al cargar los datos de precios",
              failedToLoadProductCatalog: "Error al cargar el catálogo de productos",
              failedToGenerateInvoice: "No se pudo generar la factura",
              failedToGeneratePackingSlip: "No se pudo generar la lista de empaque — intenta de nuevo",
              failedToPrintOrder: "Error al imprimir el pedido",
              failedToReadFile: "Error al leer el archivo",
              failedToRefreshOrders: "Error al actualizar los pedidos",
              failedToReloadOrder: "Error al recargar el pedido",
              failedToSaveClinicalProfile: "Error al guardar el perfil clínico. Por favor intente de nuevo.",
              failedToSavePricingChanges: "Error al guardar los cambios de precios",
              failedToSaveProduct: "Error al guardar el producto",
              failedToSaveRevertedLocally: "Error al guardar — los precios se revirtieron solo localmente",
              failedToShipOrder: "Error al enviar el pedido",
              failedToSubmitIntakeForm: "Error al enviar el formulario de ingreso. Por favor intente de nuevo.",
              failedToSubmitStackBuilder: "Error al enviar. Por favor intente de nuevo.",
              failedToUpdateArchiveStatus: "Error al actualizar el estado de archivo",
              failedToUpdateOrder: "Error al actualizar el pedido",
              failedToUpdateOrderStatus: "Error al actualizar el estado del pedido",
              fileTooLarge: "El archivo es demasiado grande. El tamaño máximo es 10MB.",
              fillCarrierAndTracking: "Por favor ingrese el transportista y el número de seguimiento",
              fillPatientAndShippingInfo: "Por favor complete la información del paciente y de envío",
              fillPatientInfo: "Por favor complete la información del paciente",
              fillShippingAddress: "Por favor complete la dirección de envío",
              invalidFileType: "Tipo de archivo inválido. Por favor suba un archivo JPEG, PNG, WebP o PDF.",
              orderArchived: "Pedido archivado",
              orderCancelled: "Pedido cancelado",
              orderIdCancelled: "Pedido {{orderId}} cancelado",
              orderMarkedAsShipped: "Pedido marcado como enviado",
              orderMarkedReadyForPickup: "Pedido marcado para recoger",
              readyMarkFailed: "No se pudo guardar el marcador de empaque — intenta de nuevo",
              orderMarkedDelivered: "Pedido marcado como entregado",
              orderMovedToStatus: "Pedido {{orderId}} movido a {{status}}",
              orderCleared: "Pedido quitado del tablero",
              orderUnarchived: "Pedido desarchivado",
              chargeDeclined: "Su tarjeta fue rechazada. Por favor intente con otra tarjeta.",
              chargeFailed: "No pudimos procesar su pago. Por favor intente de nuevo.",
              orderNotChargeable: "Este pedido no se puede cobrar en su estado actual. Por favor contacte a soporte.",
              orderBlockedDiscontinued:
                "Algunos artículos están descontinuados y agotados, por lo que no se pueden pedir. Elimínelos para continuar.",
              orderBlockedSoldOut:
                "Algunos artículos están agotados y no se pueden reservar (back-order). Elimínelos para continuar.",
              orderBlockedCapReached:
                "Algunos artículos alcanzaron su límite de reserva (back-order). Reduzca la cantidad o elimínelos para continuar.",
              orderBlockedGeneric:
                "Algunos artículos no se pueden pedir según la política de back-order actual. Ajuste su carrito para continuar.",
              paymentConfirmed: "Pago confirmado",
              paymentConfirmedAwaitingVerification: "Pago confirmado — esperando verificación del fabricante",
              paymentFailed: "El pago falló. Por favor intente de nuevo.",
              paymentSystemLoading: "El sistema de pago se está cargando. Por favor espere.",
              pricesRestoredToOriginal: "Precios restaurados al original",
              pricesSaved: "{{count}} precio(s) guardado(s)",
              tierAssigned: "Nivel {{tier}} asignado",
              productCreated: '"{{name}}" creado',
              productDeleted: '"{{name}}" eliminado',
              productUpdated: '"{{name}}" actualizado',
              legalDisclaimerSaved: "Aviso legal actualizado para todos los productos",
              legalDisclaimerSaveFailed: "No se pudo guardar el aviso legal",
              promoCodesComingSoon: "Códigos promocionales próximamente",
              provideCancellationReason: "Por favor proporcione una razón de cancelación",
              provideCancellationReasonForPaidOrders: "Por favor proporcione una razón de cancelación para pedidos pagados",
              receiptUploadFailed:
                "Pedido creado pero la carga del recibo falló. Por favor suba el recibo desde la página de detalles del pedido.",
              selectFormTypeForAllItems:
                "Por favor seleccione Activo o Liofilizado para todos los artículos antes de realizar su pedido.",
              selectOrderProvider: "Por favor seleccione un proveedor de pedidos desde la página del carrito",
              selectPatientForOrder: "Selecciona un paciente antes de realizar este pedido.",
              selectShippingMethod: "Por favor selecciona un método de envío",
              shippingMethodInvalid: "El método de envío seleccionado ya no está disponible. Por favor elige otro.",
              shippingMethodUnavailableState: "El método de envío seleccionado no está disponible para tu dirección de envío.",
              selectPatientOrEnterInfo: "Por favor seleccione un paciente o ingrese la información del paciente",
              uploadZelleReceipt: "Por favor suba su comprobante de pago de Zelle",
              customPricesSaved: "{{count}} precio personalizado guardado",
              customPricesSaved_plural: "{{count}} precios personalizados guardados",
              customPricesSavedBelowCost: "{{count}} guardados ({{belowCost}} bajo costo)",
              customPricesSaveFailed: "Error al guardar precios personalizados",
              customPricesPendingCount: "{{count}} precio modificado",
              customPricesPendingCount_plural: "{{count}} precios modificados",
              customPriceRaisedToMin:
                "Precio personalizado ajustado a {{price}}: no puede estar por debajo de su costo de nivel.",
              attachmentsPartialDrop: "Comentario guardado, pero {{count}} adjunto(s) no se pudieron cargar: {{names}}",
              paymentDenied: "Pago denegado. Se ha notificado al proveedor.",
              paymentDeniedComment: "Pago Denegado. Por favor, suba un comprobante válido.",
              failedToDenyPayment: "Error al procesar la denegación del pago.",
              pickupCannotShip: "Este pedido es para recogida y no se puede marcar como enviado.",
              pickupGoesToReadyForPickup: "Este pedido va a Recoger, no a Envío pendiente.",
              shipCannotPickup: "Este pedido se envía: no se puede marcar para recoger.",
              draftReviewByCard: "Abra el pedido para revisarlo y aprobarlo.",
              failedToAddComment: "No se pudo enviar el mensaje. Inténtalo de nuevo.",
            },
            paymentReview: {
              title: "Revisar pago",
              orderLabel: "Pedido",
              loading: "Cargando comprobante...",
              receiptAlt: "Comprobante de pago",
              loadFailed: "No se pudo cargar el comprobante. Abra el pedido para verlo.",
              noReceipt: "No se ha subido ningún comprobante para este pedido.",
              goBack: "Volver",
              deny: "Denegar pago",
              confirm: "Confirmar pago",
              processing: "Procesando...",
            },
            approveFinalize: {
              title: "Aprobar y finalizar",
              orderLabel: "Pedido",
              loading: "Cargando pedido...",
              loadFailed: "No se pudo cargar el pedido. Cierre e inténtelo de nuevo.",
              productsLabel: "Productos",
              itemFallback: "Artículo",
              total: "Total",
              cancel: "Cancelar",
              approve: "Aprobar y finalizar",
              processing: "Procesando...",
            },
            shipModal: {
              title: "Enviar pedido",
              confirmShipment: "Confirmar envío",
              updating: "Actualizando...",
            },
            labels: {
              total: "Total",
              active: "Activo",
              billingZip: "Código postal de facturación",
              card: "Tarjeta de crédito",
              cardholderName: "Nombre del titular",
              cardNumber: "Número de tarjeta",
              clinic: "Clínica",
              clinicName: "Nombre de la clínica",
              clinicShip: "Enviar a la clínica",
              clinicStock: "Inventario de la clínica",
              creditCard: "Tarjeta de crédito",
              cvv: "CVV",
              expiration: "Vencimiento",
              dataEncrypted: "Datos encriptados",
              enterCode: "Ingrese el código",
              for: "Para",
              forPatient: "Para el paciente",
              free: "Gratis",
              havePromoCode: "¿Tiene un código promocional?",
              hipaaCompliant: "Compatible con HIPAA",
              itemsFromLastSession: "Artículos de la sesión anterior",
              loadingProviders: "Cargando proveedores...",
              lyophilized: "Liofilizado",
              clickToEdit: "Haz clic para editar",
              manufacturer: "Fabricante",
              manufacturerPickup: "Recogida en fabricante",
              noPatientsFound: "No se encontraron pacientes",
              noProvidersFound: "No se encontraron proveedores",
              noProvidersMatch: "Ningún proveedor coincide con su búsqueda",
              no: "No",
              orderFor: "Orden para",
              organization: "Organización",
              orderingAs: "Ordenando como",
              orderToProviderClinic: "Orden para proveedor",
              inStoreSale: "Venta en tienda",
              patient: "Paciente",
              patientShip: "Enviar al paciente",
              payWithZelle: "Pagar con Zelle",
              provider: "Proveedor",
              salesRep: "Rep de Ventas",
              qty: "Cant.",
              searchByName: "Buscar por nombre",
              searching: "Buscando...",
              searchPatient: "Buscar paciente",
              searchPatients: "Buscar pacientes",
              searchProviders: "Buscar proveedores",
              secureCheckout: "Pago seguro",
              selectFormTypes: "Seleccionar tipos de formulario",
              selectFormTypesShort: "Elegir forma",
              selectOrderProvider: "Seleccionar proveedor de la orden",
              selectOrderProviderShort: "Elegir proveedor",
              selectPatient: "Seleccionar paciente",
              setAllProductsTo: "Establecer todos los productos a",
              shipping: "Envío",
              shipToClinic: "Enviar a la clínica",
              shipToPatient: "Enviar al paciente",
              ssl256: "SSL de 256 bits",
              stockInClinic: "Inventario en clínica",
              yes: "Sí",
              yourClinic: "Su clínica",
              zelle: "Zelle",
              applyFormType: "Aplicar a todos los artículos",
              itemsRemaining: "{{count}} artículos restantes",
              chooseFormForItem: "Elegir forma para {{name}}",
              ship: "Envío",
              pickup: "Recogida",
              customPriceOverride: "Precio personalizado",
              customPricesSaved: "Guardado",
              tierFilterAll: "Todos",
              tierFilterAriaLabel: "Filtrar proveedores por nivel de precios",
              noProvidersInTier: "No hay proveedores en este nivel",
              orderingFor: "Ordenando para",
              customPrice: "Precio personalizado",
              tierPriceShort: "Nivel {{tier}}",
              belowCost: "Bajo costo",
              groupPeptides: "Péptidos",
              groupGlp: "GLP",
              groupSupplies: "Suministros",
              searchProvidersPlaceholder: "Buscar por nombre o correo…",
              sortBy: "Ordenar por",
              sortNameAsc: "Nombre (A–Z)",
              sortOrdersDesc: "Más pedidos",
              sortTierAsc: "Mejor nivel primero",
              sortTierDesc: "Peor nivel primero",
              sortCustomDesc: "Más precios personalizados",
              providersShownCount: "{{shown}} de {{total}}",
            },
            hints: {
              leaveBlankForTier: "Déjelo en blanco para usar el precio del nivel",
            },
            confirms: {
              resetOverridesForProvider:
                "¿Borrar todos los precios personalizados de este proveedor? Las próximas órdenes usarán el precio del nivel.",
              resetCartCustomPrices:
                "¿Restablecer todos los precios personalizados de {{provider}}? Los productos volverán al precio del nivel de este proveedor.",
            },
            buttons: {
              cancel: "Cancelar",
              apply: "Aplicar",
              applyAll: "Aplicar a todos",
              backToCart: "Volver al carrito",
              copy: "Copiar",
              copied: "Copiado",
              copyFailed: "No se pudo copiar",
              clickToCopy: "Clic para copiar · {{value}}",
              dismiss: "Descartar",
              done: "Listo",
              edit: "Editar",
              pay: "Pagar",
              remove: "Eliminar",
              restore: "Restaurar",
              selectFile: "Seleccionar archivo",
              skip: "Omitir",
              submitOrder: "Enviar pedido",
              resetOverrides: "Restablecer",
              resetToTier: "Restablecer al nivel",
              change: "Cambiar",
              reset: "Restablecer",
              saving: "Guardando...",
              acceptChanges: "Aceptar cambios",
              clearSearch: "Limpiar búsqueda",
              invoice: "Factura",
            },
            headings: {
              reviewYourOrder: "Revisa tu orden",
              assignedProvider: "Proveedor asignado",
              clinicAddress: "Dirección de la clínica",
              complete: "Completo",
              healthGoals: "Metas de salud",
              information: "Información",
              medicalHistory: "Historia médica",
              orderFor: "Orden para",
              patientInformation: "Información del paciente",
              payment: "Pago",
              pickupLocation: "Lugar de recogida",
              placedByProvider: "Realizado por proveedor",
              shippingAddress: "Dirección de envío",
              shippingDestination: "Enviar a",
              fulfillmentType: "Tipo de entrega",
              customPricingOverrides: "Precios personalizados guardados",
              customPricingEditor: "Precios personalizados",
              customPricingEditorHint:
                "Establezca un precio por variante para este proveedor. Déjelo en blanco para usar el precio de su nivel. Los precios personalizados no están limitados por la matriz de niveles.",
              resetToTierPrices: "Restablecer al precio del nivel",
            },
            recs: {
              completeProtocol: "Complete su protocolo",
              completeProtocolSub: "Agregue estos productos complementarios para completar su protocolo.",
              otherAddOns: "Otros complementos",
              pairsWith: "Combina bien con su pedido",
              pairsWithSub: "Productos que suelen elegirse con los artículos de su carrito.",
              addAll: "Agregar todos",
              addedAll: "{{count}} productos agregados al carrito",
              addProduct: "Agregar {{name}}",
              addAllAria: "Agregar todos los productos recomendados",
              productFallback: "Producto",
              dosageUnavailable: "Dosis no disponible",
              selectForm: "Seleccionar forma de {{name}}",
            },
            quickAdd: {
              addMore: "Agregar más productos",
              addProduct: "Agregar {{name}}",
              increaseProduct: "Aumentar la cantidad de {{name}}",
              decreaseProduct: "Disminuir la cantidad de {{name}}",
              removeProduct: "Quitar {{name}} del carrito",
              selectDosage: "Seleccionar la dosis de {{name}}",
            },
            cart: {
              perUnit: "unidad",
              lineTotal: "total",
              clearToTier: "borrar",
              editUnitPrice: "Editar precio unitario",
              customPricing: "Precios personalizados",
              customBadge: "Personalizado",
              activeForm: "activo",
              pricingTier: "Nivel de precio",
              tierAutoApplied: "Nivel aplicado automáticamente desde la asignación del proveedor",
              recurringOrder: "Pedido recurrente",
              recurringHint: "Reabastecer automáticamente según un cronograma",
              formActive: "Activo",
              formLyophilized: "Liofilizado",
              formLabel: "Tipo",
              chooseFormType: "Elegir tipo",
              activeSurchargeNote: "Incluye recargo de preparación de {{amount}}/unidad.",
              bacWaterPrompt:
                "Los péptidos liofilizados necesitan agua bacteriostática para la reconstitución. ¿Agregarla a tu pedido?",
              addBacWater: "Agregar agua bacteriostática",
              bacWaterAdded: "Agua bacteriostática agregada al carrito",
              reconKitPrompt:
                "Este vial necesita reconstitución. El kit de reconstitución incluye el agua bacteriostática, las jeringas y la aguja de carga. ¿Agregarlo?",
              addReconKit: "Agregar kit de reconstitución",
              reconKitAdded: "Kit de reconstitución agregado al carrito",
              addedToCart: "{{name}} agregado al carrito",
              itemRemoved: "{{name}} eliminado del carrito",
              recommendedTitle: "Complementos recomendados",
              recommendedSubtitle: "Seleccionados por tu fabricante",
              addToCart: "Agregar",
              backOrder: {
                summary_one:
                  "{{count}} de {{total}} artículo quedará en pedido pendiente — se te cobrará ahora y te notificaremos cuando se envíe.",
                summary_other:
                  "{{count}} de {{total}} artículos quedarán en pedido pendiente — se te cobrará ahora y te notificaremos cuando se envíen.",
                noticeHeading: "Quedará en pedido pendiente",
                noticeBody: "se te cobra ahora y se envía en cuanto vuelva el stock.",
                removeFromCart: "Quitar del carrito",
              },
              // Phase 1 split-ship cart UX
              splitShip: {
                noticeHeading: "Se enviará parcialmente",
                noticeBody: "{{shipNow}}, {{backOrder}}. Se cobra ahora y se envía cuando vuelva el stock.",
                shipNowClause_one: "enviar {{count}} unidad ahora",
                shipNowClause_other: "enviar {{count}} unidades ahora",
                backOrderClause_one: "{{count}} unidad pendiente",
                backOrderClause_other: "{{count}} unidades pendientes",
                radioSplit: "Enviar {{available}} ahora, pendiente {{deficit}}",
                radioRemove: "Eliminar del carrito",
                summaryChip_one:
                  "{{count}} artículo se enviará parcialmente — se te cobrará ahora y te notificaremos cuando el resto se envíe.",
                summaryChip_other:
                  "{{count}} artículos se enviarán parcialmente — se te cobrará ahora y te notificaremos cuando el resto se envíe.",
                hint: "Las unidades pendientes se enviarán cuando vuelva el stock.",
              },
            },
            descriptions: {
              imageOrPdfMax10MB: "Imagen o PDF, máximo 10MB",
              assignToProvider: "Organización de proveedor",
              inStoreSale: "Cliente sin cita",
              cardPaymentsUnavailable: "Los pagos con tarjeta no están disponibles en este momento. Por favor use Zelle.",
              shipToClinic: "Enviar al proveedor / clínica",
              shipToPatient: "Se envía directo al paciente — no afecta tu inventario de clínica",
              stockInClinic: "Se agregará a tu inventario de clínica al recibirse",
              uploadZelleReceipt: "Suba su comprobante de transferencia Zelle",
              zelleRecipient: "Envía tu pago por Zelle a alphabiopayments@gmail.com",
              shipViaCarrier: "Enviar por transportista a la dirección",
              pickupAtLocation: "El proveedor recoge en la ubicación",
              pickupFromManufacturer: "Recoge este pedido del fabricante — sin costo de envío",
              pickupAddressMissing:
                "Configure su dirección de recogida en Configuración → Información de la organización antes de realizar pedidos de recogida.",
            },
            orders: {
              archiveDescription:
                "Esto ocultará la orden de la vista predeterminada. Podrás restaurarla más tarde desde el filtro de archivadas.",
              archiveOrder: "Archivar orden",
              cancel: "Cancelar",
              cancelling: "Cancelando...",
              cancelOrder: "Cancelar orden",
              cancelOrderRefund: "Cancelar orden y procesar reembolso",
              cancelReasonOptional: "Motivo (opcional)",
              cancelReasonPlaceholder: "Motivo de cancelación (opcional)",
              cancelReasonPlaceholderOptional: "Motivo opcional para la cancelación",
              cancelReasonPlaceholderPaid: "ej., Reembolso iniciado, Solicitud del cliente",
              cancelReasonRequired: "Motivo de cancelación *",
              cancelError: "No se pudo cancelar el pedido",
              clearFilter: "Quitar filtro",
              confirmCancellation: "Confirmar cancelación",
              empty: "Aún no hay órdenes de péptidos",
              filterBy: "Filtrar por",
              filteredByPatient: "Filtrado por paciente",
              goBack: "Volver",
              kanbanView: "Vista Kanban",
              newOrder: "Nueva orden",
              onlyArchived: "Solo archivadas",
              orderCount_one: "{{count}} orden",
              orderCount_other: "{{count}} órdenes",
              orderLabel: "Orden",
              pageTitle: "Órdenes",
              paidCancelWarning: "Esta orden ha sido pagada. La cancelación requerirá procesar un reembolso.",
              processing: "Procesando...",
              refreshOrders: "Actualizar órdenes",
              searchPlaceholder: "Buscar pedidos, pacientes, productos…",
              newest: "Más recientes",
              oldest: "Más antiguos",
              viewListShort: "Lista",
              viewTableShort: "Tabla",
              // viewLabel belongs in peptides.orders (consumed as
              // peptides.orders.viewLabel); viewBoard/viewTable already live in
              // this block below. Previously viewLabel was only in pages.orders.
              viewLabel: "Vista",
              showStatus: "Mostrar estado",
              tabDme: "DME",
              tabPeptides: "Péptidos",
              tableView: "Vista de tabla",
              tabAll: "Todos",
              tabActive: "Activos",
              tabDelivered: "Entregados",
              tabCanceled: "Cancelados",
              emptyAll: "Aún no tiene pedidos. Empiece con el catálogo.",
              emptyActive: "Nada activo en este momento.",
              emptyDelivered: "Aún no tiene pedidos entregados.",
              emptyCanceled: "Sin pedidos cancelados.",
              loadError: "No se pudieron cargar sus pedidos. Intente de nuevo.",
              loadErrorRetry: "Actualizar",
              loadEventsRetry: "Reintentar",
              today: "Hoy",
              yesterday: "Ayer",
              notCharged: "no cobrado",
              unarchive: "Desarchivar",
              unarchiveDescription: "Esto restaurará la orden a la vista activa.",
              unarchiveOrder: "Desarchivar orden",
              viewBoard: "Ver tablero",
              viewTable: "Ver tabla",
              sortBy: "Ordenar por",
              filtersTitle: "Filtros",
              done: "Listo",
              showAll: "Mostrar todos",
              hideAll: "Ocultar todos",
              statusCount: "{{count}}/{{total}}",
              total: "Total",
              browseCatalog: "Explorar catálogo",
              orderPlacedLabel: "Pedido realizado",
              reportProblem: "Reportar un problema",
              messagesHeading: "Mensajes",
              orderNumberLabel: "Pedido",
              forLabel: "Para",
              sortByLabel: "Ordenar por",
              sortPlacedAt: "Fecha de realización",
              sortTotal: "Total",
              sortStatus: "Estado",
              sortDirectionAsc: "Dirección de orden: ascendente",
              sortDirectionDesc: "Dirección de orden: descendente",
              expandOrder: "Expandir pedido {{id}}",
              collapseOrder: "Contraer pedido {{id}}",
              moreItems: "{{count}} artículos más",
              headline: {
                draft: "Borrador — aún no procesado",
                awaitingApproval: "Esperando aprobación del proveedor",
                approving: "Aprobando tu pedido",
                preparing: "Aprobado — preparando tu pedido",
                awaitingRestock: "Esperando reabastecimiento",
                onItsWay: "En camino",
                readyForPickup: "Recoger",
                deliveredToday: "Entregado hoy",
                deliveredYesterday: "Entregado ayer",
                deliveredOn: "Entregado el {{date}}",
                canceled: "Cancelado",
                denied: "No aprobado por tu proveedor",
                paymentIssue: "Problema con el pago — se requiere acción",
              },
            },
            reorder: {
              buyAgain: "Volver a pedir",
              buyAllAgain: "Volver a pedir todo",
              buyItemAgain: "Volver a pedir {{name}}",
              reviewTitle: "Revisa tu nuevo pedido",
              reviewIntro: "Algunos artículos cambiaron desde tu último pedido. Elige cuáles agregar al carrito.",
              priceChanged: "Precio cambiado",
              unavailable: "Ya no disponible",
              addToCart: "Agregar al carrito",
              cancel: "Cancelar",
              noneAvailable: "Ninguno de estos artículos está disponible para volver a pedir.",
              catalogUnavailable: "El catálogo de productos aún se está cargando; inténtalo de nuevo en un momento.",
            },
            orderHistory: {
              title: "Historial de pedidos",
              empty: "Aún no has realizado ningún pedido.",
              noPatient: "—",
              loadError: "No se pudo cargar tu historial de pedidos. Inténtalo de nuevo.",
              loadErrorRetry: "Actualizar",
              mobileSearch: "Buscar pedidos",
              mobileClearSearch: "Borrar búsqueda",
              mobileFilterOrders: "Filtrar pedidos. {{status}}",
              mobileFilteredCount: "{{count}} de {{total}} pedidos",
              mobileCount_one: "{{count}} pedido",
              mobileCount_other: "{{count}} pedidos",
              mobileClear: "Borrar",
              mobileFiltersTitle: "Filtros",
              mobileStatusLabel: "Estado",
              mobileSortLabel: "Ordenar por",
              mobileSortNewest: "Más recientes primero",
              mobileSortOldest: "Más antiguos primero",
              mobileSortHighest: "Mayor total",
              mobileSortLowest: "Menor total",
              mobileSortStatus: "Estado",
              mobileReset: "Restablecer",
              mobileShowOrders_one: "Mostrar {{count}} pedido",
              mobileShowOrders_other: "Mostrar {{count}} pedidos",
              mobileItemCount_one: "{{count}} artículo",
              mobileItemCount_other: "{{count}} artículos",
              mobileClinicStock: "inventario de la clínica",
              mobileNoSearchMatches: 'Ningún pedido coincide con "{{query}}".',
              mobileNoFilteredSearchMatches: 'Ningún pedido {{status}} coincide con "{{query}}".',
              mobileSearchAll_one: "Buscar en el {{count}} pedido",
              mobileSearchAll_other: "Buscar en los {{count}} pedidos",
            },
            journey: {
              progress: "Progreso del pago",
              itemCount: "{{count}} artículos",
              placing: "Realizando pedido…",
              step: {
                items: "Artículos",
                orderFor: "Pedido para",
                payment: "Pago",
                review: "Revisar",
              },
              cta: {
                chooseFormTypes: "Elegir tipo de fórmula",
                removeUnavailable: "Quitar artículos no disponibles",
                continueToOrderDetails: "Continuar a los detalles",
                chooseOrderType: "Elegir tipo de pedido",
                selectProvider: "Seleccionar un proveedor",
                selectPatient: "Seleccionar un paciente",
                continueToCheckout: "Continuar al pago",
                addPaymentDetails: "Agregar datos de pago",
                continueToReview: "Continuar a revisar",
                placeOrder: "Realizar pedido",
              },
            },
            nav: {
              navigationLabel: "Navegación de péptidos",
              protocols: "Protocolos",
              analytics: "Analítica",
              approvals: "Aprobaciones",
              approvalsWithCount_one: "Aprobaciones, {{count}} aprobación pendiente",
              approvalsWithCount_other: "Aprobaciones, {{count}} aprobaciones pendientes",
              cart: "Carrito",
              cartWithCount_one: "Carrito, {{count}} artículo",
              cartWithCount_other: "Carrito, {{count}} artículos",
              catalog: "Catálogo",
              directToPatient: "Directo al paciente",
              myOrders: "Mis órdenes",
              orders: "Órdenes",
              patientPanel: "Panel de pacientes",
              pricing: "Precios",
              providerOnboarding: "Incorporación de proveedor",
              inventory: "Inventario",
              manageCatalog: "Administrar catálogo",
              orderHistory: "Historial de pedidos",
              more: "Más",
              surchargeSettings: "Recargo por forma activa",
              notifications: "Notificaciones",
              mobileOrders: "Órdenes",
              mobileOrderHistory: "Historial",
              mobileApprovals: "Aprobar",
              mobileMyOrders: "Órdenes",
              mobileProtocols: "Protocolos",
              mobileCatalog: "Catálogo",
              mobileCart: "Carrito",
              mobileTools: "Herram.",
              mobileMore: "Más",
            },
            providerPricing: {
              title: "Precios para sus pacientes",
              help: "Defina lo que pagan sus pacientes por producto. Usted conserva el margen por encima de su costo; esto nunca cambia lo que le paga al fabricante.",
            },
            patientPricing: {
              retail: "Precio de venta de la clínica",
              customSingular: "1 precio personalizado",
              customPlural: "{{count}} precios personalizados",
              custom: "Personalizado",
              retailShort: "Precio de la clínica",
              fallback:
                "Los campos vacíos usan el precio de venta de la clínica. Los cambios aplican solo a este paciente y a pedidos futuros.",
              lastUpdated: "Última actualización por",
              authorizedUser: "Usuario autorizado",
              loading: "Cargando precios del paciente…",
              readOnlyLimit: "Los precios son de solo lectura porque el límite del procesador de pagos no está disponible.",
              authorizationExpired: "Su acceso a los precios del paciente venció. Inicie sesión nuevamente para continuar.",
              loadFailed: "No se pudieron cargar de forma segura los precios del paciente.",
              history: "Historial",
              edit: "Editar precios",
              relinkAccessHint: "Administrar acceso al precio",
              cardLabel: "Precios del paciente",
              backToPatient: "Volver al paciente",
              unnamedProduct: "Producto sin nombre",
              unavailableProduct: "Producto no disponible",
              clinicRetail: "Precio de la clínica",
              minimum: "Mínimo",
              estimatedEarnings: "Ganancia estimada",
              customPrice: "Precio personalizado",
              inputLabel: "Precio personalizado para {{product}}",
              editorLabel: "Precios del paciente",
              editorTitle: "Definir precios personalizados",
              editorHint:
                "Deje el precio vacío para usar el precio de la clínica. Puede superar el precio de la clínica, pero no el mínimo.",
              guardrail: "Protecciones financieras activas",
              limitBlocked: "La edición está deshabilitada porque los límites oficiales de precio no están disponibles.",
              uncertainSave:
                "No pudimos confirmar si se guardaron los cambios. Revise los valores actuales antes de intentar nuevamente.",
              authSaveFailed: "Su acceso a precios venció. Inicie sesión nuevamente.",
              saveFailed: "No se guardaron los precios. Revise las filas resaltadas.",
              saveAnnouncing: "Guardando precios del paciente",
              saveComplete: "Precios del paciente guardados",
              catalogUnavailableTitle: "Catálogo de productos no disponible",
              catalogUnavailable:
                "No se pueden editar los precios hasta que el catálogo actual de péptidos cargue de forma segura.",
              conflictTitle: "Los precios cambiaron en otra sesión",
              conflictCopy:
                "Sus datos siguen aquí. Cargue la última versión guardada, concilie las diferencias y vuelva a revisar.",
              yourPrice: "Su precio",
              latestSaved: "Último guardado",
              reconcile: "Cargar lo más reciente y conciliar",
              search: "Buscar productos",
              searchPlaceholder: "Buscar producto o dosis",
              retiredCopy: "Este producto guardado ya no está en el catálogo activo. Borre su precio antes de guardar.",
              retiredProduct: "Producto no disponible",
              groupPeptides: "Péptidos",
              groupGlp: "GLP-1",
              groupSupplies: "Suministros",
              groupUnavailable: "No disponible / retirado",
              changedCount: "{{count}} con cambios",
              attentionCount: "{{count}} requiere atención",
              noMatch: "No hay productos coincidentes en este grupo.",
              attentionSummary_one: "1 precio requiere atención",
              attentionSummary_other: "{{count}} precios requieren atención",
              changeSummary_one: "1 cambio listo para revisar",
              changeSummary_other: "{{count}} cambios listos para revisar",
              noUnsavedChanges: "No hay cambios sin guardar",
              returnAll: "Volver todos al precio de la clínica",
              reviewSave: "Revisar y guardar",
              reviewTitle: "Revisar cambios de precios",
              futureOrdersOnly: "Estos precios aplican solo a pedidos futuros. Los pedidos existentes no cambiarán.",
              saving: "Guardando…",
              savePrices: "Guardar precios",
              resetTitle: "¿Volver todos los precios a los de la clínica?",
              resetCopy: "Esto elimina {{countLabel}} de este paciente.",
              resetFuture: "Los pedidos futuros usarán los precios de la clínica.",
              keepCustom: "Conservar precios personalizados",
              returnRetail: "Volver al precio de la clínica",
              oneCustomPrice: "1 precio personalizado",
              customPriceCount: "{{count}} precios personalizados",
              unsavedTitle: "Precios del paciente sin guardar",
              unsavedCopy: "¿Descartar los cambios de precios personalizados de este paciente?",
              keepEditing: "Seguir editando",
              discardChanges: "Descartar cambios",
              historyTitle: "Historial de precios del paciente",
              historyIntro: "Los cambios guardados en precios específicos del paciente aparecen aquí.",
              historyLoading: "Cargando historial de precios…",
              historyFailed: "No se pudo cargar de forma segura el historial de precios.",
              noHistory: "Aún no hay cambios de precios guardados.",
              historyChange: "Cambio de precio",
              historyActionCreate: "Precios personalizados creados",
              historyActionUpdate: "Precios personalizados actualizados",
              historyActionReturnToRetail: "Se volvió al precio de la clínica",
              historyActionFloorAdjustment: "Ajuste del precio mínimo",
              historyActionIdentityLink: "Identidad del paciente vinculada",
              roleProvider: "Proveedor",
              roleSupervisor: "Supervisor",
              roleSystem: "Sistema",
              dateUnavailable: "Fecha no disponible",
              identityLinked: "Cuenta autorizada",
              errorUnavailableOverride: "Este producto ya no está disponible. Borre su precio personalizado.",
              errorRejected: "Este precio fue rechazado. Revise los límites actuales.",
              errorRetailUnavailable: "El precio de la clínica no está disponible para este producto.",
              noticeRetailUnavailable: "Sin precio minorista de la clínica: defínelo aquí o en precios de la clínica.",
              errorMinimumUnavailable: "El precio mínimo no está disponible para este producto.",
              errorLimitUnavailable: "El límite del procesador de pagos no está disponible.",
              errorMaximum: "El máximo es {{price}}.",
              errorPositive: "Ingrese un valor superior a $0,00.",
              errorOutOfRange: "Este valor es demasiado alto.",
              errorFormat: "Ingrese un precio sin comas, signos ni más de dos decimales.",
              errorMinimum: "El mínimo es {{price}}.",
              paymentLink: {
                creating: "Creando enlace de pago seguro…",
                ready: "Enlace de pago listo",
                expired: "Este enlace de pago venció. Cree uno nuevo.",
                failed: "No se pudo crear el enlace de pago.",
              },
            },
            patientPanel: {
              title: "Panel de pacientes",
              backToList: "Todos los pacientes",
              close: "Cerrar",
              profileCount_one: "{{count}} perfil",
              profileCount_other: "{{count}} perfiles",
              openFullChart: "Abrir expediente completo",
              contactInfo: "Contacto y datos demográficos",
              intakeAnswers: "Resumen clínico",
              noIntake: "Sin respuestas clínicas registradas",
              noResults: "No se encontraron pacientes",
              noProfiles: "No se encontraron perfiles clínicos",
              create: {
                newPatient: "Nuevo paciente",
                title: "Nuevo paciente",
                dob: "Fecha de nacimiento",
                possibleMatch: "Es posible que este paciente ya exista",
                selectInstead: "Seleccionar existente",
                duplicateEmail: "Ya existe una cuenta con este correo.",
                invalidEmail: "Ingresa un correo electrónico válido",
                invalidPhone: "Ingresa un número de celular válido",
                success: "Paciente creado.",
                chartFailed:
                  "Se creó el paciente, pero no se pudo crear su expediente: los precios del paciente no cargarán hasta que exista.",
                failed: "No se pudo crear el paciente. Inténtalo de nuevo.",
                cancel: "Cancelar",
                save: "Crear paciente",
                saving: "Creando…",
                intakeDescription:
                  "Envíe un enlace seguro. El paciente ingresará sus datos demográficos y clínicos antes de activar su cuenta de péptidos.",
                deliveryMethod: "Enviar por",
                deliveryEmail: "Correo electrónico",
                deliverySms: "Mensaje de texto (SMS)",
                sendIntake: "Enviar formulario clínico",
                sendingIntake: "Enviando…",
                intakeSent: "Formulario clínico enviado a {{destination}}.",
                intakeFailed: "No se pudo enviar el formulario clínico. Inténtalo de nuevo.",
              },
            },
            screening: {
              sectionTitle: "Preguntas de salud",
              sectionSubtitle: "Su proveedor revisa estas respuestas antes de aprobar su pedido.",
              loadingOnFile: "Cargando su información de salud…",
              onFileTitle: "Información de salud en archivo",
              onFileSubtitle: "Usaremos las respuestas de salud de su cuenta. Actualícelas si algo ha cambiado.",
              onFileUpdate: "Actualizar",
              conditionsLabel: "¿Tiene alguna de las siguientes condiciones? (Seleccione todas las que apliquen)",
              conditionsOther: "Especifique otra(s) condición(es)",
              allergies: "Alergias",
              allergiesPlaceholder: "Indique sus alergias conocidas (o escriba 'Ninguna')",
              currentMedications: "Medicamentos actuales",
              medicationsPlaceholder: "Indique todos sus medicamentos y suplementos actuales (o escriba 'Ninguno')",
              pregnant: "¿Está embarazada o planea quedar embarazada?",
              previousPeptideUse: "¿Ha usado terapia con péptidos antes?",
              glpNote:
                "Su pedido incluye un medicamento GLP-1. Estas preguntas son necesarias para la revisión de seguridad de su proveedor.",
              incomplete: "Responda todas las preguntas de salud antes de realizar su pedido",
              thyroidCancerHistory: "¿Alguna vez le diagnosticaron carcinoma medular de tiroides (cáncer de tiroides)?",
              men2FamilyHistory: "¿Usted o algún familiar tiene síndrome de Neoplasia Endocrina Múltiple tipo 2 (MEN2)?",
              pancreatitisHistory: "¿Alguna vez tuvo pancreatitis (inflamación del páncreas)?",
              gallbladderDisease: "¿Tiene enfermedad de la vesícula biliar o le extirparon la vesícula?",
              eatingDisorderHistory: "¿Tiene antecedentes de un trastorno alimentario (p. ej. anorexia, bulimia)?",
              breastfeeding: "¿Está amamantando actualmente?",
              conditionOptions: {
                diabetes: "Diabetes",
                heartDisease: "Enfermedad cardíaca",
                highBloodPressure: "Presión arterial alta",
                thyroidDisorder: "Trastorno de tiroides",
                kidneyDisease: "Enfermedad renal",
                liverDisease: "Enfermedad hepática",
                cancer: "Cáncer",
                autoimmuneDisorder: "Trastorno autoinmune",
                seizuresEpilepsy: "Convulsiones / Epilepsia",
                bleedingDisorder: "Trastorno de coagulación",
                depressionAnxiety: "Depresión / Ansiedad / Salud mental",
                other: "Otra",
              },
            },
            approvals: {
              callLog: {
                title: "Registro de llamadas",
                logCall: "Registrar llamada",
                save: "Guardar llamada",
                min: "min",
                durationPlaceholder: "Minutos (opcional)",
                notesPlaceholder: "Qué se discutió, consentimiento, decisión…",
                calledBadge: "Llamado",
                reminder: "En espera de una llamada de {{callType}}. Registre el resultado para documentar la consulta.",
                outcomeCompleted: "Se contactó al paciente",
                outcomeVoicemail: "Buzón de voz",
                outcomeNoAnswer: "Sin respuesta",
                outcomeDeclined: "El paciente declinó",
                outcomeRescheduled: "Reprogramada",
              },
              historyTitle: "Decisiones recientes",
              historySearch: "Buscar aprobaciones y rechazos anteriores",
              historyWindow: "Mostrando los últimos 3 días. Busque para encontrar registros más antiguos.",
              historyEmpty: "No hay decisiones recientes.",
              historyApproved: "Aprobado",
              historyDenied: "Rechazado",
              title: "Aprobación de pedidos",
              subtitle: "Pedidos realizados por pacientes en espera de su revisión clínica",
              sortLabel: "Ordenar pedidos",
              sortOldest: "Más antiguos primero",
              sortNewest: "Más recientes primero",
              emptyTitle: "No hay pedidos en espera de revisión",
              emptyBody: "Los nuevos pedidos de pacientes aparecerán aquí para revisión clínica.",
              viewBoard: "Ver tablero de pedidos",
              paymentReady: "Tarjeta autorizada, lista para revisar",
              paymentPending: "Esperando autorización del pago",
              noQuestionnaire: "Sin cuestionario",
              noFlags: "Sin alertas",
              criticalCount_one: "{{count}} crítica",
              criticalCount_other: "{{count}} críticas",
              highCount_one: "{{count}} alta",
              highCount_other: "{{count}} altas",
              infoCount_one: "{{count}} informativa",
              infoCount_other: "{{count}} informativas",
              ageDays_one: "hace {{count}} día",
              ageDays_other: "hace {{count}} días",
              loadingItems: "Cargando productos…",
              clinicalTab: "Revisión clínica",
              orderTab: "Pedido",
              noneReported: "Nada reportado",
              noIntakeCallout:
                "No hay cuestionario registrado. Este pedido es anterior a la evaluación clínica, revise con sus propios registros.",
              dismiss: "Descartar",
              dismissTitle: "Descartar esta alerta",
              dismissed: "Descartada",
              removeFlag: "Quitar",
              flagAnswer: "Marcar",
              flagTitle: "Marcar esta respuesta",
              flagNotePlaceholder: "Agregue una nota (obligatoria)",
              flagsNotPersisted:
                "Las alertas se guardaron localmente, pero el servidor aún no las almacenó. Se perderán al recargar.",
              flagSaveFailed: "No se pudo guardar la alerta. Inténtelo de nuevo.",
              requestInfo: "Pedir más información",
              requestInfoTitle: "Pedir más información",
              requestInfoLabel: "Mensaje para el paciente",
              requestInfoPlaceholder:
                "p. ej. ¿Puede contarme más sobre su historial de tiroides? Su pedido queda en espera hasta recibir su respuesta.",
              requestInfoSend: "Enviar",
              infoRequested: "Mensaje enviado al paciente",
              criticalAck_one: "{{count}} alerta crítica activa. He revisado las respuestas marcadas.",
              criticalAck_other: "{{count}} alertas críticas activas. He revisado las respuestas marcadas.",
              notActionable: "Aprobar/Denegar se habilita cuando se complete la autorización de la tarjeta del paciente.",
              severity: {
                critical: "Crítica",
                high: "Alta",
                info: "Informativa",
              },
              flags: {
                mtcHistory:
                  "Antecedente personal de carcinoma medular de tiroides. Contraindicación de advertencia de caja para agonistas GLP-1.",
                men2Family:
                  "Antecedente personal o familiar de MEN2. Contraindicación de advertencia de caja para agonistas GLP-1.",
                pancreatitis: "Antecedente de pancreatitis. Los agonistas GLP-1 conllevan riesgo de pancreatitis.",
                pregnant: "La paciente reporta embarazo o planes de embarazo. La terapia con péptidos está contraindicada.",
                breastfeeding: "La paciente reporta lactancia. No se recomienda la terapia con péptidos.",
                cancer: "Antecedente de cáncer reportado. Confirme tipo y estado antes de aprobar.",
                eatingDisorder:
                  "Antecedente de trastorno alimentario. La terapia para pérdida de peso requiere evaluación cuidadosa.",
                gallbladder: "Enfermedad de vesícula reportada. Los agonistas GLP-1 aumentan el riesgo de eventos biliares.",
                thyroidDisorder: "Trastorno de tiroides reportado. Confirme que no sea carcinoma medular de tiroides.",
                kidney:
                  "Enfermedad renal reportada. Los efectos GI de los GLP-1 pueden empeorar la función renal por deshidratación.",
              },
            },
            kanban: {
              approved: "Pendiente de envío",
              archive: "Archivar",
              cancelled: "Cancelada",
              custom: "Personalizado",
              d2c: "D2C:",
              delivered: "Entregada",
              denied: "Denegada",
              dob: "FDN:",
              draft: "Borrador",
              emptyColumn: "No hay órdenes {{status}}",
              scrollToTop: "Desplazarse al inicio de {{status}}",
              scrollToBottom: "Desplazarse al final de {{status}}",
              itemsCount_one: "{{count}} artículo",
              itemsCount_other: "{{count}} artículos",
              unitsCount_one: "{{count}} artículo",
              unitsCount_other: "{{count}} artículos",
              moveFailed: "Error al actualizar el estado del pedido",
              moveSuccess: "Pedido movido exitosamente",
              needsReview: "Requiere revisión del fabricante",
              noPatientInfo: "Sin información del paciente",
              orderPlaced: "Pendiente de pago",
              paid: "Pagada",
              patient: "Paciente:",
              paymentIssues: "Problemas de pago",
              pickup: "Recoger",
              practice: "Práctica:",
              processing: "Procesando",
              readyForPickup: "Recoger",
              receipt: "Recibo",
              review: "Revisar",
              searchPlaceholder: "Buscar pedidos...",
              ship: "Envío",
              shipped: "Enviada",
              clearFromBoard: "Quitar del tablero",
              restoreToBoard: "Restaurar al tablero",
              undo: "Deshacer",
              filterByDate: "Filtrar por fecha",
              filterLast30: "Últimos 30 días",
              filterLast60: "Últimos 60 días",
              filterLast90: "Últimos 90 días",
              filterAll: "Todo el tiempo",
              unarchive: "Desarchivar",
              patientTag: "PACIENTE",
              hasConversation: "Tiene conversación — abrir para ver detalles",
              commentsCount_one: "{{count}} comentario — abrir conversación",
              commentsCount_other: "{{count}} comentarios — abrir conversación",
              toPatientShort: "D2C",
              toPatientFull: "Directo al consumidor — se envía al paciente",
              awaitingRestock: "Esperando restock",
              // Títulos de columna abreviados, mostrados cuando la columna es muy
              // angosta para el título completo (responsivo — ver _kanban.scss).
              abbr: {
                review: "Revisar",
                orderPlaced: "Pago $",
                approved: "Pend. Envío",
                awaitingRestock: "Pend. Stock",
                readyForPickup: "Recoger",
                shipped: "Enviada",
                delivered: "Entregada",
                cancelled: "Canc.",
              },
              placedBy: "Realizado por",
              orderFor: "Orden para:",
              awaitingRestockChip: "Esperando restock",
              pills: {
                review: "Requiere revisión",
                draft: "Borrador",
                orderPlaced: "Acción requerida",
                approved: "Procesando",
                readyForPickup: "En tu clínica",
                awaitingRestock: "En cola",
                shipped: "En tránsito",
                delivered: "Completado",
                cancelled: "Revisar reembolsos",
                archive: "Archivado",
              },
              descriptions: {
                review: "Esta orden necesita tu revisión.",
                draft: "Termina de realizar esta orden.",
                orderPlaced: "Estamos esperando que se complete tu pago.",
                approved: "Tu orden se está preparando para el envío.",
                readyForPickup: "Tu orden está lista en la clínica.",
                awaitingRestock: "Algunos artículos están en reabastecimiento y en cola.",
                shipped: "Tu orden está en camino.",
                archive: "Esta orden ha sido archivada.",
              },
              captions: {
                review: "Necesita revisión",
                draft: "Orden borrador",
                orderPlaced: "Esperando pago",
                approved: "Preparando envío",
                readyForPickup: "Recoger",
                awaitingRestock: "Esperando restock",
                shipped: "En tránsito",
                archive: "Archivado",
              },
              metaLabel: {
                for: "Para",
                by: "Por",
                patient: "Paciente",
                clinic: "Clínica",
                instore: "Venta en tienda",
                dob: "FN",
                paidVia: "Pagado vía",
                qty: "Cant",
              },
              card: {
                boChip: "PP",
                boChipAriaLabel: "Tarjeta de pedido pendiente",
              },
              restocked: "REABASTECIDO",
              restockedTooltip: "En espera desde {{date}}",
              restockedNew: "De nuevo en stock — pedido de reabastecimiento obligatorio",
              restockedAck: "Reabastecimiento confirmado",
              fromManufacturer: "Del fabricante",
              fromManufacturerFull: "Realizado por el fabricante para tu clínica",
              readyButton: "Listo",
              readyTooltip: "Marcar como empacado — solo un indicador visual, no cambia el pedido",
              readyMarkedTooltip: "Empacado por {{name}} · {{date}}",
              readyUnknownPacker: "personal",
              units_one: "{{count}} unidad",
              units_other: "{{count}} unidades",
            },
            internalNotes: {
              title: "Notas internas",
              staffOnly: "Solo para el personal — nunca visible para los clientes",
              empty: "Aún no hay notas internas. Agrega contexto de empaque, pago o entrega para tu equipo.",
              placeholder: "Escribe una nota interna…",
              add: "Agregar nota",
              saveEdit: "Guardar cambios",
              cancelEdit: "Cancelar edición",
              edit: "Editar nota",
              saving: "Guardando…",
              added: "Nota interna agregada",
              updated: "Nota interna actualizada",
              updatedBy: "Actualizada {{date}} · {{name}}",
              unknownAuthor: "Personal",
              saveFailed: "No se pudo guardar la nota — intenta de nuevo",
            },
            filter: {
              all: "Todas",
              myOrders: "Mis pedidos",
              patientOrders: "Pedidos de pacientes",
              providerOrders: "Pedidos del proveedor",
            },
            confirmation: {
              backToCatalog: "Volver al catálogo",
            },
            orderDetail: {
              archiveDescription:
                "Esto ocultará la orden de la vista predeterminada. Podrás restaurarla más tarde desde el filtro de archivadas.",
              archiveOrder: "Archivar orden",
              productPickList: "Lista de selección de productos",
              backToOrders: "Volver a órdenes",
              cancel: "Cancelar",
              cancelling: "Cancelando...",
              cancelOrder: "Cancelar orden",
              cancelOrderRefund: "Cancelar orden (reembolso)",
              cancelOrderRefundTitle: "Cancelar orden e iniciar reembolso",
              cancelReasonOptional: "Motivo (opcional)",
              cancelReasonPlaceholder: "Motivo de cancelación (opcional)",
              cancelReasonPlaceholderOptional: "Motivo opcional para la cancelación",
              cancelReasonPlaceholderPaid: "ej., Reembolso iniciado, Solicitud del cliente",
              cancelReasonRequired: "Motivo de cancelación *",
              cancellationReason: "Motivo de cancelación",
              carrierNamePlaceholder: "Nombre del transportista",
              carrierOther: "Otro",
              carrierRequired: "Transportista *",
              clinic: "Clínica",
              confirmAndShip: "Confirmar y enviar",
              confirmCancellation: "Confirmar cancelación",
              confirmPayment: "Confirmar pago",
              contactInfo: "Información de contacto",
              customPrice: "Precio personalizado",
              datePlaced: "Fecha de realización",
              deliverHere: "Entregar aquí",
              deliveriesTab: "Entregas",
              detailsTab: "Detalles",
              reviewTab: "Revisión",
              dispatchViaUber: "Despachar vía Uber",
              dosage: "Dosificación",
              everyNDays: "Cada {{count}} días",
              form: "Forma",
              formActive: "Activo",
              formLyophilized: "Liofilizado",
              fulfillment: "Cumplimiento",
              goBack: "Volver",
              items: "Artículos",
              lineItems: "Artículos",
              loadError: "No se pudieron cargar los detalles del pedido",
              localPickup: "Recogida local",
              markAsShipped: "Marcar como enviada",
              markReadyForPickup: "Marcar para recoger",
              orderNumber: "Orden #{{id}}",
              organization: "Organización",
              overviewTab: "Resumen",
              paidRefundWarning: "Esta orden ha sido pagada. Se deberá procesar un reembolso.",
              patient: "Paciente",
              pickupHere: "Recoger aquí",
              pickupLocation: "Ubicación de recogida",
              price: "Precio",
              pricing: "Precios",
              processing: "Procesando...",
              product: "Producto",
              qty: "Cant.",
              status: "Estado",
              receiptAwaitingConfirmation: "Recibo subido — esperando confirmación del fabricante",
              selectCarrier: "Seleccionar transportista...",
              shipTo: "Enviar a",
              shipToAddress: "Enviar a dirección",
              shipping: "Enviando...",
              shippingAddress: "Dirección de envío",
              shippingDetails: "Detalles de envío",
              shippingInformation: "Información de envío",
              specifyCarrierRequired: "Especificar transportista *",
              subscription: "Suscripción",
              total: "Total",
              totalUnits: "Total de artículos",
              tracking: "Seguimiento",
              trackingNumberPlaceholder: "Ingrese el número de seguimiento",
              trackingNumberRequired: "Número de seguimiento *",
              uberDirectHint: "Se usará Uber Direct. Haga clic abajo para despachar.",
              unarchiveDescription: "Esto restaurará la orden a la vista activa.",
              unarchiveOrder: "Desarchivar orden",
              cancelButton: "Cancelar pedido",
              eventsHeading: "Eventos",
              eventOrderPlaced: "Pedido realizado · {{amount}} autorizado",
              eventApproved: "Aprobado por {{providerName}} · pago cobrado",
              eventShipped: "Enviado vía {{carrier}} · ETA {{eta}}",
              eventDelivered: "Entregado",
              eventReAuthorized: "Tarjeta re-autorizada (ventana de autorización renovada)",
              eventCanceledByPatient: "Cancelado por usted · autorización liberada",
              eventDenied: "Rechazado por {{providerName}} · autorización liberada",
              eventPaymentFailed: "Falló la autorización de la tarjeta",
              payment: "Pago",
              paymentAuthorized: "Autorizado",
              paymentCaptured: "Cobrado",
              paymentCardEnding: "{{cardBrand}} terminada en {{last4}}",
              pickup: "Recogida",
              pickupAt: "Recoger en {{location}}",
              pickupReadySince: "Listo desde {{date}}",
              pickupInstructions: "Traiga una identificación con foto. Horario: {{hours}}.",
              eventReadyForPickup: "Recoger en {{location}}",
              eventPickedUp: "Recogido",
              trackingWithValue: "Seguimiento · {{value}}",
              deliveredOn: "Entregado {{date}}",
              placedOn: "Realizado el {{date}}",
              yourProvider: "su proveedor",
              cardSuffix: "{{brand}} terminada en {{last4}}",
              backToMyOrders: "Volver a mis pedidos",
              linkedBackOrder: "Pedido pendiente vinculado: #{{displayId}} →",
              backToParent: "← Volver al pedido principal #{{displayId}}",
              paidVia: "Pagado mediante #{{displayId}}",
              paidViaTooltip: "El pago está vinculado al pedido principal.",
              destDropShip: "Enviado directamente al paciente",
              destClinicStock: "Inventario de la clínica",
              copyEmailAria: "Copiar correo — {{email}}",
              copyEmailTitle: "Haga clic para copiar {{email}}",
              emailCopyFailed: "No se pudo copiar — inténtelo de nuevo",
              emailCopiedShort: "Copiado",
              email: "Correo electrónico",
            },
            receipt: {
              fileTooLarge: "El archivo es demasiado grande. El tamaño máximo es 10MB.",
              imageAlt: "Recibo de pago",
              invalidType: "Tipo de archivo inválido. Por favor suba un archivo JPEG, PNG, WebP o PDF.",
              loading: "Cargando recibo...",
              selectFile: "Seleccionar archivo",
              title: "Recibo de pago",
              uploadFailed: "Error al subir el recibo",
              uploadHint: "Imagen o PDF, máx. 10MB",
              uploadPrompt: "Suba su comprobante de transferencia Zelle",
              zelleRecipient: "Envía tu pago por Zelle a alphabiopayments@gmail.com",
              uploadSuccess: "Recibo de pago subido",
              uploaded: "Recibo subido",
              uploadedOn: "Subido",
              uploading: "Subiendo...",
              viewPdf: "Ver recibo en PDF",
              viewReceipt: "Ver recibo",
              view: "Ver",
              download: "Descargar",
              downloadUnavailable: "El recibo aún no está disponible para descargar.",
              downloadFailed: "No se pudo descargar el recibo.",
              viewFailed: "No se pudo abrir el recibo.",
            },
            clinicalProfile: {
              review: {
                nkda: "NKDA (Sin alergias conocidas a medicamentos)",
                edit: "Editar",
                additionalInfo: "Información adicional",
              },
            },
            detail: {
              dosingProtocol: "Protocolo de dosificación",
              howItWorks: "Cómo funciona",
              keyBenefits: "Beneficios clave",
            },
            intake: {
              allergies: "Alergias",
              approveFinalize: "Aprobar y finalizar",
              approving: "Aprobando...",
              conditions: "Condiciones",
              copyError: "Error al copiar al portapapeles",
              copyLink: "Copiar enlace de ingreso",
              dob: "Fecha de nacimiento",
              downloadQr: "Descargar",
              draftReview: "Revisión de borrador de orden",
              generateQr: "Generar código QR",
              generatingQr: "Generando...",
              goals: "Objetivos de salud",
              linkCopied: "Enlace de ingreso copiado al portapapeles",
              loading: "Cargando...",
              medicalHistory: "Historia médica",
              medications: "Medicamentos",
              name: "Nombre",
              orderNotFound: "Orden no encontrada",
              patientInfo: "Información del paciente",
              shippingInfo: "Información de envío",
              collectPayment: "Cobrar pago",
              collectPaymentNow: "Cobrar pago ahora",
              collectPaymentDesc:
                "Cobrar al comprador al enviar el pedido. Déjalo desactivado para guardar como borrador y que el destinatario pague después.",
              popupBlocked: "Ventana emergente bloqueada. Por favor permita las ventanas emergentes para este sitio.",
              pregnant: "Embarazada",
              previousUse: "Uso previo de péptidos",
              printQr: "Imprimir",
              products: "Productos",
              qrError: "Error al generar el código QR",
              regenerateQr: "Nuevo código QR",
              sendLink: "Enviar enlace de ingreso",
              sendLinkDesc:
                "Comparta este enlace con su paciente para que complete su perfil clínico. Una vez enviado, el perfil estará disponible para su revisión.",
              sendLinkTitle: "Enviar enlace de ingreso al paciente",
              uniqueNote: "Cada enlace y código QR es único. Genere uno nuevo para cada paciente.",
            },
            catalog: {
              recommended: "Producto recomendado",
              markAsRecommended: "Marcar como recomendado",
              recommendedHint: "Se muestra en el carrito del comprador como complemento sugerido.",
              addBenefit: "Agregar beneficio",
              addProduct: "Agregar producto",
              addToCart: "Agregar al carrito",
              addVariant: "Agregar variante",
              added: "Agregado al carrito",
              all: "Todos",
              badge: "Insignia",
              badges: {
                "Best Seller": "Más vendido",
                Blend: "Mezcla",
                New: "Nuevo",
                Popular: "Popular",
              },
              basicInfo: "Información básica",
              benefits: "Beneficios",
              blends: "Mezclas",
              cancel: "Cancelar",
              categories: {
                all: "Todos",
                antiAging: "Antienvejecimiento",
                cognitive: "Cognitivo",
                energy: "Energía",
                glp: "GLP",
                immune: "Soporte inmunológico",
                muscleGrowth: "Crecimiento muscular",
                popular: "Popular",
                recovery: "Recuperación y sanación",
                sexualHealth: "Salud sexual",
                skinHair: "Piel y cabello",
                sleep: "Sueño",
                supplies: "Suministros",
                weightLoss: "Pérdida de peso",
              },
              category: "Categoría",
              filterCategories: "Filtrar categorías",
              activeCategory: "Categoría: {{category}}",
              createProduct: "Crear producto",
              description: "Descripción",
              dosage: "Dosificación",
              dosingProtocol: "Protocolo de dosificación",
              editProduct: "Editar producto",
              howItWorks: "Cómo funciona",
              noResults: "No se encontraron péptidos",
              productCount_one: "{{count}} producto",
              productCount_other: "{{count}} productos",
              productImage: "Imagen del producto",
              replace: "Reemplazar",
              saveChanges: "Guardar cambios",
              search: "Buscar péptidos...",
              seeMore: "Ver más",
              selectDosage: "Seleccionar dosificación",
              singles: "Individuales",
              subtitle: "Subtítulo",
              tags: "Etiquetas",
              title: "Catálogo de péptidos",
              viewGrid: "Cuadrícula",
              viewList: "Lista",
              viewMode: "Vista del catálogo",
              uploadImage: "Subir imagen",
              uploading: "Subiendo...",
              variantsPricing: "Variantes y precios",
              productIdentity: "Identidad",
              dropImageOrClick: "Suelta una imagen o haz clic para subir",
              dropImageHint: "PNG · JPG · hasta 5MB",
              idAuto: "auto",
              crumbNew: "Catálogo · Nuevo producto",
              crumbEditing: "Catálogo · Editando {{name}}",
              tierFlowsToProviders: "Los precios por nivel se aplican a los proveedores",
              name: "Nombre",
              namePlaceholder: "Nombre del producto",
              subtitlePlaceholder: "Subtítulo corto",
              id: "ID",
              supplies: "Suministros",
              badgeNone: "Ninguno",
              benefitPlaceholder: "Beneficio...",
              dosagePlaceholder: "ej. 10MG",
              retailColumn: "Minorista ($)",
              tierColumn: "Nivel {{tier}} ($)",
              distribColumn: "Distrib ($)",
              variantCount_one: "1 variante",
              variantCount_other: "{{count}} variantes",
              variantsInfoLabel: "Acerca de variantes y precios",
              variantsInfoTip:
                "Cada variante es una dosis con un precio específico. Minorista ($) es lo que pagan los pacientes. Las columnas Nivel A a W son tarifas mayoristas que se aplican a los proveedores según su plan. Distrib ($) es el costo del distribuidor.",
              removeImage: "Eliminar imagen",
              remove: "Eliminar",
              errorAtLeastOneVariant: "Por favor agrega al menos una variante con dosis",
              errorRetailRequired: "Por favor establece un precio minorista para todas las variantes",
              errorCostFlushFailed: "Error al guardar el costo — por favor intenta de nuevo.",
              errorImageUpload: "Error al subir la imagen — por favor intenta de nuevo.",
              errorSaveFailed: "Error al guardar — por favor intenta de nuevo",
              creating: "Creando...",
              saving: "Guardando...",
              cost: "Costo ($)",
              costHintExtended:
                "Tu costo por unidad — determina todos los márgenes. Los precios por nivel pueden establecerse por debajo del costo; verás una advertencia si estás perdiendo margen.",
              dosageRequiredHint: "Primero establece una dosis",
              recalculateMarginsPrompt: "Costo modificado. ¿Recalcular todos los precios por nivel a los márgenes recomendados?",
              recalculateMarginsApply: "Aplicar",
              recalculateMarginsDismiss: "Descartar",
              // eslint-disable-next-line no-template-curly-in-string
              belowCostWarn: "Bajo el costo — pierdes ${{loss}} por unidad",
              adjustAllTiers: "Ajustar todos los niveles juntos",
              lockSpreadHelp: "¿Qué hace esto?",
              lockSpreadTip:
                "Cuando está activado, arrastrar cualquier nivel ajusta todos los niveles al mismo margen — una forma rápida de establecer un descuento uniforme en todos los niveles de socios.",
              lockStatusOn:
                "Los niveles se mueven juntos — arrastra cualquier control deslizante y todos los niveles coinciden con su valor.",
              lockStatusOff: "Los niveles se mueven independientemente — configura cada uno por separado.",
              tierLadderCostHint:
                "Ingresa el Costo arriba para ver los márgenes de cada nivel. Puedes establecer los precios de cada nivel de forma independiente o todos juntos con el control de arriba.",
              variantLabel: "Variante",
              removeVariant: "Eliminar variante",
              tierMarginSlider: "Margen del nivel {{tier}}",
              tierName: {
                min: "Mínimo",
                A: "Preferido",
                B: "Establecido",
                C: "Estándar",
                D: "Nuevo",
                W: "Minorista",
              },
              tierDesc: {
                min: "Precio de piso",
                A: "Socios principales",
                B: "Socios establecidos",
                C: "Socios estándar",
                D: "Socios nuevos",
                W: "Precio público del sitio web",
              },
              manage: "Administrar",
            },
            referral: {
              copyFor: "Copiar enlace de referencia para",
            },
            checkout: {
              redesign: {
                yourCart: "Su carrito",
                reviewOrder: "Revisar pedido",
                stepItems: "Artículos",
                stepOrderFor: "Destinatario",
                stepReview: "Revisar",
                setAllProducts: "Establecer todos los productos a",
                chooseForm: "Elegir forma",
                addAnother: "Agregar otro producto",
                addOnsTitle: "Complementos recomendados",
                addOnsBy: "Seleccionado por su fabricante",
                add: "Agregar",
                recipientTitle: "Pedido para",
                recipientProvider: "Proveedor",
                recipientPatient: "Paciente",
                recipientInStore: "Venta en tienda",
                recipientChoose: "Elegir destinatario",
                recipientWalkIn: "Venta de mostrador",
                deliveryTitle: "Método de entrega",
                ship: "Envío",
                shipDesc: "Enviar por mensajería",
                pickup: "Recoger",
                pickupDesc: "Recoger en el local",
                addressShip: "Dirección de envío",
                addressPickup: "Lugar de recogida",
                edit: "Editar",
                done: "Listo",
                promoTitle: "Código promocional",
                addACode: "Agregar un código",
                apply: "Aplicar",
                promoComingSoon: "Los códigos promocionales estarán disponibles pronto.",
                shippingTo: "Enviar a",
                payment: "Pago",
                paymentDraft: "Facturado al proveedor",
                arrives: "Llega",
                subtotal: "Subtotal",
                shipping: "Envío",
                free: "Gratis",
                tax: "Impuesto",
                calculatedAtCheckout: "Calculado al finalizar",
                total: "Total",
                continue: "Continuar",
                placeOrder: "Realizar pedido",
                itemOne: "artículo",
                itemOther: "artículos",
                selectFormFirst: "Seleccione una forma para cada producto primero.",
                selectRecipient: "Primero elija para quién es este pedido.",
                completeAddress: "Complete primero la dirección de envío.",
                noAddress: "Sin dirección",
              },
              cardIncomplete: "Por favor completa los datos de la tarjeta",
              submitFailed: "No se pudo realizar el pedido",
              demoNotice: "Modo demo — no se cobrará ninguna tarjeta real.",
              payAtSubmitNotice:
                "Su tarjeta será autorizada por {{amount}} hoy. Solo cobraremos después de que su proveedor apruebe su pedido — generalmente dentro de 1 a 3 días hábiles. Si rechaza el pedido, la autorización se libera de vuelta a su tarjeta.",
              authorizeButton: "Autorizar {{amount}}",
              authorizing: "Autorizando…",
              authorizeError: "No se pudo autorizar su tarjeta. Por favor, verifique sus datos e intente de nuevo.",
              paymentMethodSection: "Método de pago",
              orderReceived: "Pedido recibido — revisión del proveedor en 1 a 3 días hábiles",
              useSavedAddress: "Usar dirección guardada",
              savedShippingAddress: "Dirección de envío guardada",
              shipSomewhereElse: "Enviar a otro lugar",
              shipSomewhereElseSubtitle: "Usar una dirección diferente para este pedido",
              alternateShippingAddress: "Dirección de envío",
              shipToPickup: "Recoger con el proveedor",
              shipToPickupSubtitle: "{{clinicName}}",
              subtotal: "Subtotal",
              shipping: "Envío",
              shippingMethod: "Método de envío",
              estimatedDelivery: "Entrega estimada",
              selectState: "Selecciona el estado",
              noShippingMethodsForState:
                "No hay métodos de envío disponibles para tu dirección. Verifica la dirección o contacta a tu proveedor.",
              free: "Gratis",
              total: "Total",
              shipToProvider: "Enviar al proveedor",
              shipToMe: "Enviar a mi dirección",
              chargeTodayNotice:
                "Se cobrará {{amount}} a tu tarjeta hoy. Tu proveedor revisará tu pedido en un plazo de 1 a 3 días hábiles.",
              pay: "Pagar {{amount}}",
              cardDeclined: "Tu tarjeta fue rechazada. Verifica los datos e inténtalo de nuevo.",
              processing: "Procesando…",
              totalUpdated: "El total se actualizó a {{amount}}. Revísalo y confirma antes de pagar.",
              totalUpdatedBanner:
                "El total se actualizó a {{amount}} según los precios actuales de tu proveedor. Revísalo y toca Pagar para confirmar.",
            },
            home: {
              denied: "Pedido rechazado: {{reason}}",
              awaitingProvider: "Pedido enviado — esperando aprobación del proveedor",
              empty: "Sus pedidos de péptidos aparecerán aquí una vez que su proveedor apruebe su primer pedido.",
              browseCatalog: "Explorar catálogo",
              requestRefill: "Solicitar otra recarga a su proveedor",
              loadError: "No se pudo cargar. Por favor, inténtelo de nuevo.",
            },
            refill: {
              title: "Solicitar otra recarga de {{name}}",
              product: "Producto",
              explainer:
                "Tu proveedor revisará y aprobará esta solicitud. Autorizaremos tu tarjeta guardada ahora y solo te cobraremos cuando ellos aprueben.",
              submit: "Enviar solicitud de recarga",
              submitting: "Enviando…",
              submitted: "Solicitud de recarga enviada — esperando aprobación del proveedor",
              submitError: "No se pudo enviar. Por favor, inténtelo de nuevo.",
              invalidTherapy: "No pudimos encontrar ese pedido. Por favor, inténtelo de nuevo desde su lista de péptidos.",
              confirmTitle: "Confirmar reabastecimiento",
              confirmBody: "Autorizaremos {{amount}} en su {{cardBrand}} guardada terminada en {{last4}}.",
              cancelConfirm: "Cancelar",
              confirm: "Confirmar",
              cardInvalid: "No se pudo autorizar su tarjeta guardada. Por favor, ingrese un nuevo método de pago para continuar.",
            },
            consent: {
              title: "Consentimiento del paciente para péptidos",
              ack1: "Estoy comprando este producto con la aprobación de mi proveedor. Entiendo que mi proveedor controla el acceso al producto y es responsable de aprobar cada pedido que realizo.",
              ack2: "Entiendo que cada pedido que realizo requiere la aprobación de mi proveedor antes de ser cumplido, y que mi proveedor ejerce su juicio profesional bajo el NPI de su organización al aprobar cada pedido.",
              ack3: "Tengo una relación establecida con el proveedor que revisará mis pedidos, y soy responsable de seguir cualquier indicación que me dé y de mi propio uso del producto.",
              submit: "Aceptar y continuar",
            },
            providerEsign: {
              title: "Aprobación del Proveedor — Firma Electrónica",
              checkboxPrefix: "Yo, ",
              checkboxSuffix:
                ", doy mi consentimiento para certificar electrónicamente este pedido de péptidos. Entiendo que mi firma será capturada con marca de tiempo, dirección IP, información del dispositivo y versión del texto de consentimiento, y será almacenada por un mínimo de 7 años.",
              continue: "Continuar",
            },
            review: {
              contact: {
                title: "Contacto",
                callPatient: "Llamar a este paciente",
                copy: "Copiar",
                noPhone: "Sin teléfono en el expediente",
                prefers: "Prefiere {{channel}}",
                channelSms: "texto / SMS",
                channelEmail: "correo electrónico",
                emergency: "Emergencia: {{name}} {{phone}}",
              },
              patient: {
                placedByPatientBadge: "REALIZADO POR EL PACIENTE",
                bannerTitle: "Revisión del proveedor requerida",
                bannerBody:
                  "Este pedido fue realizado por el paciente. Apruebe para enviarlo al cumplimiento del fabricante, o rechácelo con un motivo.",
                approve: "Aprobar",
                deny: "Rechazar…",
                approved: "Pedido aprobado",
                approvedMessage: "Su pedido ha sido aprobado. Su receta está adjunta.",
                denied: "Pedido rechazado",
                approveError: "Error al aprobar el pedido",
                denyError: "Error al rechazar el pedido",
                raceCancelled: "El paciente canceló este pedido mientras lo revisaba — por favor actualice.",
                denyTitle: "Rechazar pedido del paciente",
                denyReason: "Motivo del rechazo",
                denySubmit: "Enviar",
                providerNameMissing:
                  "Nombre del proveedor no disponible. Por favor, cierre sesión y vuelva a iniciar antes de aprobar.",
                cancel: "Cancelar",
              },
            },
            deny: {
              title: "Rechazar orden",
              reason: "Motivo del rechazo",
              reasonRequired: "Por favor, proporcione un motivo antes de enviar.",
              submit: "Enviar",
              submitting: "Enviando…",
              buttonLabel: "Rechazar",
              cancel: "Cancelar",
              successToast: "Orden rechazada",
              errorToast: "No se pudo rechazar la orden",
            },
            conversation: {
              heading: "Conversación",
              empty: "No hay mensajes aún.",
              placeholder: "Añadir respuesta",
              button: "Conversación",
              reportPrompt: "¿Algo salió mal con este pedido? Envíanos un mensaje.",
            },
            compliance: {
              highScrutiny: {
                tile: "Este producto está actualmente bajo revisión regulatoria de la FDA. Su proveedor ha aprobado este pedido bajo su juicio clínico — discuta el uso continuado con su proveedor.",
                review:
                  "Este producto está en el nivel de alta vigilancia. Los GLP-1 compuestos están bajo revisión activa de la FDA. Documente su razonamiento clínico.",
              },
              stateUnavailable: "No disponible para entrega en su estado. Por favor, contacte a su proveedor para alternativas.",
              shippingStateMissing: "Agregue su estado de envío a su perfil para confirmar la disponibilidad.",
              supervision: "Todos los pedidos requieren la aprobación de su proveedor.",
              compoundedDisclaimer:
                "Los productos en esta plataforma son compuestos por farmacias con licencia. No son medicamentos aprobados por la FDA y se elaboran para pacientes individuales con base en la aprobación del proveedor.",
              selfAdmin: "Usted es responsable de seguir las indicaciones de su proveedor y las instrucciones del producto.",
            },
            tile: {
              compoundedFallback: "Producto compuesto",
              aboutProduct: "Acerca de este producto",
              descriptionFallback:
                "Un producto de péptido compuesto. Úselo solo como lo indique su proveedor, quien revisa y aprueba cada pedido.",
            },
            denial: {
              declinedBy: "Rechazado por {{name}}",
              yourProvider: "su proveedor",
              showMore: "Ver más",
              showLess: "Ver menos",
              detailBanner:
                'Su proveedor no aprobó este pedido — Motivo: "{{reason}}". Su autorización de {{amount}} fue liberada; el reembolso aparecerá en 1 a 2 días hábiles.',
              noReasonGiven: "No se proporcionó motivo.",
            },
            refund: {
              pending: "Reembolso de {{amount}} se liberará en 1 a 2 días hábiles",
              pendingShort: "reembolso pendiente",
              releasingTo: "Liberando a su {{cardBrand}} terminada en {{last4}}",
            },
            paymentFailed: {
              bannerTitle: "No se pudo autorizar su tarjeta",
              bannerBody:
                "Su tarjeta fue rechazada al intentar renovar la autorización. Actualice su método de pago para mantener este pedido activo, de lo contrario será cancelado.",
              updatePaymentButton: "Actualizar pago",
              contactSupport: "O contacte a soporte si necesita ayuda.",
            },
            cancel: {
              modalTitle: "¿Cancelar este pedido?",
              modalBody:
                "Su autorización de {{amount}} será liberada dentro de 1 a 2 días hábiles. Se notificará a su proveedor.",
              reasonLabel: "Motivo de la cancelación (opcional)",
              keepOrder: "Mantener pedido",
              confirmCancel: "Cancelar pedido",
              successToast: "Pedido cancelado — reembolso pendiente",
              cancelling: "Cancelando…",
              selfCancelBanner: "Cancelaste este pedido. El reembolso de {{amount}} aparecerá en 1 a 2 días hábiles.",
            },
            status: {
              cancelled: "Cancelado",
              confirmed: "Confirmado",
              delivered: "Entregado",
              draft: "Borrador",
              processing: "Procesando",
              shipped: "Enviado",
              declined: "Rechazado",
            },
            stock: {
              inStock: "En stock",
              lowStock_one: "Queda solo {{count}}",
              lowStock_other: "Quedan solo {{count}}",
              lowStockGeneric: "Stock bajo",
              backOrdered: "Bajo pedido · se envía cuando llegue el inventario",
              backOrderedWithDate: "Bajo pedido · est. {{date}}",
              outOfStock: "Agotado",
              discontinued: "Descontinuado",
              notifyMe: "Avísame cuando vuelva a estar disponible",
              notifyMeCta: "Avísame cuando vuelva a estar disponible",
              modal: {
                title: "Avísame cuando vuelva a estar disponible",
                description: "Te enviaremos un correo en cuanto este producto vuelva al stock. Sin promociones — solo la alerta.",
                emailLabel: "Correo electrónico",
                submit: "Avísame",
                submitting: "Guardando…",
                cancel: "Cancelar",
                success: "Te enviaremos un correo cuando {{product}} vuelva al stock.",
                alreadySubscribed: "Ya estás en la lista para este producto.",
                error: "No se pudo guardar la alerta. Inténtalo de nuevo.",
                invalidEmail: "Ingresa un correo electrónico válido",
                thisProduct: "este producto",
              },
              cart: {
                warning: "{{product}} ({{dosage}}) ya no está disponible — elimínalo para continuar.",
                discontinued: "{{product}} ({{dosage}}) fue descontinuado y no se puede pedir. Elimínalo para continuar.",
                disableCheckout: "Elimina los productos descontinuados para continuar.",
                removeBlocked: "Eliminar productos descontinuados",
                removeBlockedShort: "Eliminar productos",
                willBackOrder: "{{product}} ({{dosage}}) se ordenará a pedido — se envía cuando llegue el inventario.",
                backOrderNotice_one: "{{count}} producto se ordenará a pedido — se envía cuando llegue el inventario.",
                backOrderNotice_other: "{{count}} productos se ordenarán a pedido — se envían cuando llegue el inventario.",
              },
              editor: {
                openTitle: "Gestionar stock",
                title: "Stock — {{product}}",
                loadError: "No se pudo cargar el stock",
                loadFailedBanner:
                  "No se pudo cargar el stock guardado. Mostrando valores por defecto — tus cambios se enviarán al Guardar.",
                saveError: "No se pudo guardar el stock",
                saveSuccess: "Stock actualizado ({{count}} SKUs)",
                impactWarning: "{{lines}} línea(s) de pedido en {{orders}} pedido(s) quedarán en espera si confirmas.",
                cancel: "Cancelar",
                save: "Guardar",
                saving: "Guardando…",
                confirmDecrement: "Confirmar y guardar",
                col: {
                  dosage: "Dosis",
                  onHand: "Disponible",
                  reserved: "Reservado",
                  threshold: "Umbral bajo",
                  restockDate: "Restock esperado",
                  discontinued: "Descontinuado",
                },
              },
            },
            fulfillment: {
              editMethod: {
                button: "Cambiar método de entrega",
                title: "Cambiar método de entrega",
                address: "Dirección *",
                city: "Ciudad *",
                state: "Estado *",
                zip: "Código postal *",
                addressRequired: "Se requiere una dirección de envío completa para cambiar a envío",
                toPickupNote:
                  "La dirección de envío guardada se conserva pero no se usará. Cualquier costo de envío ya cobrado no se reembolsa automáticamente.",
                toShippingNote:
                  "El pedido se enviará a la dirección de arriba. No se agrega ningún costo de envío retroactivamente.",
                confirmPickup: "Cambiar a recogida",
                confirmShipping: "Cambiar a envío",
                switchedToPickup: "Pedido cambiado a recogida",
                switchedToShipping: "Pedido cambiado a envío",
                saving: "Guardando…",
                failed: "No se pudo cambiar el método de entrega — intenta de nuevo",
              },
              line: {
                pending: "Pendiente",
                reserved: "Reservado",
                backOrdered: "En espera",
                partiallyShipped: "Parcialmente enviado",
                readyToShip: "Listo para envío",
                shipped: "Enviado",
                cancelled: "Cancelado",
                patient: {
                  processing: "Procesando",
                  ready: "Listo",
                  waitingOnRestock: "Esperando restock",
                  partiallyShipped: "Parcialmente enviado",
                  shipped: "Enviado",
                  cancelled: "Cancelado",
                },
              },
              summary: {
                shippedCount: "{{shipped}} de {{total}} enviados",
                awaitingRestockCount_one: "{{count}} esperando restock",
                awaitingRestockCount_other: "{{count}} esperando restock",
                inFlight_one: "{{count}} en curso",
                inFlight_other: "{{count}} en curso",
                aria: "Estado de cumplimiento: {{summary}}",
              },
              strip: {
                aria: "Estado de cumplimiento por línea",
                unnamed: "Artículo",
              },
              providerContactMissing:
                "Información de contacto de la clínica no registrada. Pide al proveedor que complete el perfil de su clínica.",
              split: {
                button: "Enviar líneas disponibles",
                title: "Enviar líneas disponibles",
                description:
                  "Las líneas que selecciones se enviarán ahora con el transportador y número de seguimiento de abajo. Las líneas en espera quedan en cola.",
                qty: "Cant. {{qty}}",
                reserved: "Reservado",
                backOrdered: "En espera — no se puede enviar todavía",
                alreadyShipped: "Ya enviado",
                carrier: "Transportador",
                tracking: "Número de seguimiento",
                cancel: "Cancelar",
                shipping: "Enviando…",
                shipSelected_one: "Enviar seleccionada ({{count}})",
                shipSelected_other: "Enviar seleccionadas ({{count}})",
                withChild_one: "{{count}} línea enviada · Tarjeta de pedido pendiente creada para #{{displayId}}",
                withChild_other: "{{count}} líneas enviadas · Tarjeta de pedido pendiente creada para #{{displayId}}",
                withoutChild_one: "{{count}} línea enviada",
                withoutChild_other: "{{count}} líneas enviadas",
                errors: {
                  noSelection: "Selecciona al menos una línea para enviar.",
                  carrierRequired: "El transportador es obligatorio.",
                  trackingRequired: "El número de seguimiento es obligatorio.",
                  failed: "No se pudieron enviar las líneas. Inténtalo de nuevo.",
                },
              },
              confirmPayment: "Confirmar pago",
              markAsShipped: "Marcar como enviado",
              markReadyForPickup: "Marcar para recoger",
              markAsDelivered: "Marcar como entregado",
              markAsPickedUp: "Marcar como recogido",
              print: "Imprimir",
              packingSlip: "Lista de empaque",
              unarchive: "Desarchivar",
              archive: "Archivar",
              shippingInformation: "Información de envío",
              carrier: "Transportador *",
              selectCarrier: "Seleccionar transportador...",
              specifyCarrier: "Especificar transportador *",
              carrierNamePlaceholder: "Nombre del transportador",
              uberDispatchHint: "Se usará Uber Direct. Haz clic abajo para despachar.",
              trackingNumber: "Número de seguimiento *",
              trackingPlaceholder: "Ingresa el número de seguimiento",
              shipping: "Enviando...",
              dispatchViaUber: "Despachar vía Uber",
              confirmAndShip: "Confirmar y enviar",
              paidCancelWarning: "Esta orden ha sido pagada. Se deberá procesar un reembolso.",
              cancelReasonRequired: "Motivo de cancelación *",
              cancelReasonOptional: "Motivo (opcional)",
              cancelReasons: {
                customerRequest: "Solicitud del cliente",
                refundInitiated: "Reembolso iniciado",
                duplicateOrder: "Pedido duplicado",
                outOfStock: "Agotado",
                incorrectItems: "Artículos incorrectos",
                providerCancelled: "Proveedor canceló",
              },
              cancelReasonPlaceholderPaid: "ej. Reembolso iniciado, Solicitud del cliente",
              cancelReasonPlaceholderUnpaid: "Motivo opcional para la cancelación",
              goBack: "Volver",
              cancelling: "Cancelando...",
              confirmCancellation: "Confirmar cancelación",
              unarchiveOrder: "Desarchivar orden",
              archiveOrder: "Archivar orden",
              unarchiveDescription: "Esto restaurará la orden a la vista activa.",
              archiveDescription:
                "Esto ocultará la orden de la vista predeterminada. Puedes restaurarla más tarde desde el filtro de archivadas.",
              processing: "Procesando...",
              orderSummary: "Resumen del pedido",
              datePlaced: "Fecha de pedido",
              fulfillmentLabel: "Cumplimiento",
              localPickup: "Recoger localmente",
              shipToAddress: "Enviar a dirección",
              destination: "Destino",
              clinicPickup: "Recoger en clínica",
              patientAddress: "Dirección del paciente",
              clinicAddress: "Dirección de clínica",
              payment: "Pago",
              zelle: "Zelle",
              creditCard: "Tarjeta de crédito",
              organization: "Organización",
              email: "Correo",
              phone: "Teléfono",
            },
            awaitingRestock: {
              patient: {
                bannerTitle: "Uno o más artículos están esperando restock",
                bannerBody:
                  "Te enviaremos un correo cuando el resto de tu pedido esté listo. Los artículos ya enviados están en camino.",
              },
            },
            inventory: {
              title: "Inventario de la clínica",
              subtitle:
                "Lo que está físicamente en tu clínica. Registra recepciones cuando lleguen envíos; registra dispensaciones cuando salgan unidades.",
              loading: "Cargando…",
              emptyMessage:
                "Aún no hay inventario. Cuando lleguen envíos, haz clic en 'Registrar recepción' para registrar lo que tienes.",
              belowThresholdBanner_one: "{{count}} artículo está en o por debajo del umbral.",
              belowThresholdBanner_other: "{{count}} artículos están en o por debajo del umbral.",
              reorderCta: "Ordenar más",
              lowPill: "Bajo",
              recordReceipt: "Registrar recepción",
              recordDispense: "Registrar dispensación",
              dispenseAmt: "Cant. dispensada",
              receiveAmt: "Cant. recibida",
              confirm: "Confirmar",
              cancel: "Cancelar",
              submitting: "Guardando…",
              dispenseSuccess: "Dispensación registrada.",
              receiptSuccess: "Recepción registrada.",
              col: {
                sku: "SKU",
                product: "Producto",
                dosage: "Dosis",
                reserved: "Reservado",
                available: "Libre",
                ordered: "Unidades reservadas",
                backOrdered: "Por pedido",
                addStock: "Agregar stock",
                lastStocked: "Último reabastecimiento",
                onHand: "Disponible",
                threshold: "Umbral",
                restockDate: "Reposición esperada",
                discontinued: "Descontinuado",
                lastReceived: "Última recepción",
                lastDispensed: "Última dispensación",
                actions: "Acciones",
              },
              errors: {
                loadFailed: "No se pudo cargar el inventario.",
                invalidQty: "La cantidad debe ser positiva.",
                notEnoughStock: "No hay suficiente stock para dispensar esa cantidad.",
                submitFailed: "No se pudo registrar el cambio.",
              },
              settings: {
                title: "Configuración de Inventario",
                backToInventory: "Volver al Inventario",
                save: "Guardar",
                saving: "Guardando…",
                saveSuccess: "Configuración de inventario guardada",
                saveError: "No se pudo guardar la configuración de inventario",
                loadFailedBanner:
                  "No se pudo obtener la configuración guardada. Mostrando valores predeterminados — sus cambios se enviarán al guardar.",
                defaultLowStockThreshold: {
                  label: "Umbral predeterminado de stock bajo",
                  help: "Se usa para nuevas variantes. Las variantes existentes mantienen su umbral guardado.",
                },
                defaultRestockLeadDays: {
                  label: "Días predeterminados para reposición (opcional)",
                  help: "Si se establece, las nuevas variantes sugieren una fecha estimada de reposición a estos días desde hoy.",
                },
              },
              pageTitle: "Inventario",
              openSettings: "Configuración de inventario",
              loadFailedBanner:
                "No se pudo obtener el stock guardado. Mostrando valores predeterminados — sus cambios se enviarán al guardar.",
              mode: {
                overview: "Resumen",
                manage: "Administrar Stock",
              },
              filter: {
                search: "Buscar producto o dosis…",
                showLowStock: "Mostrar solo stock bajo",
                hideDiscontinued: "Ocultar descontinuados",
                showDiscontinued: "Mostrar descontinuados",
              },
              empty: {
                noProducts: "Aún no hay productos en tu catálogo.",
                noMatches: "Ningún producto coincide con los filtros.",
              },
              modeSwitchConfirm: {
                body: "Cambiar de modo descarta tus cambios pendientes. ¿Continuar?",
              },
              saveBar: {
                pending_one: "{{count}} cambio pendiente",
                pending_other: "{{count}} cambios pendientes",
                save: "Guardar",
                cancel: "Cancelar",
                saving: "Guardando…",
              },
              saveSuccess_one: "Inventario actualizado ({{count}} SKU)",
              saveSuccess_other: "Inventario actualizado ({{count}} SKUs)",
              saveError: "No se pudo guardar el inventario",
              impactWarning_one: "{{lines}} línea de pedido pasará a pendiente entre {{orders}} pedido(s) si confirmas.",
              impactWarning_other: "{{lines}} líneas de pedido pasarán a pendiente entre {{orders}} pedido(s) si confirmas.",
              confirmDecrement: "Confirmar y guardar",
              overcommit: {
                over: "de más",
                badgeTip: "Sobrecomprometido por {{count}} — lo reservado supera lo disponible",
                banner_one:
                  "{{count}} producto está sobrecomprometido — lo reservado supera lo disponible. Reabastece o cancela pedidos para resolver.",
                banner_other:
                  "{{count}} productos están sobrecomprometidos — lo reservado supera lo disponible. Reabastece o cancela pedidos para resolver.",
              },
              status: {
                outOfStock: "Agotado",
                lowStock: "Stock bajo",
              },
              restockApplied: "{{count}} pedido(s) reabastecido(s) y listo(s) para preparar",
              decrementApplied: "{{count}} pedido(s) movidos a Esperando Reposición",
            },
            notify: {
              backInStock: {
                toast: "{{sku}} vuelve a estar disponible.",
              },
              qtyBelow: {
                toast: "{{sku}} está en o por debajo del umbral de stock bajo.",
              },
              daysRunwayBelow: {
                toast: "{{sku}} se proyecta a agotarse pronto.",
              },
            },
            alerts: {
              loading: "Cargando…",
              channel: {
                email: "Correo",
                inApp: "En la app",
                both: "Ambos",
              },
              config: {
                title: "Alertas de stock",
                titleForSku: "Alertas para {{product}}",
                subtitle:
                  "Enviaremos una alerta por umbral cada 24 horas y no se disparará mientras ya estés bajo el umbral sin una recuperación.",
                qtyBelowLabel: "Avisar cuando el stock baje de",
                runwayBelowLabel: "Avisar cuando la proyección de agotamiento sea menor a",
                qtyUnit: "unidades",
                daysUnit: "días",
                cancel: "Cancelar",
                save: "Guardar",
                saving: "Guardando…",
                saveSuccess: "Preferencias guardadas.",
                defaultPill: "Por defecto",
              },
              errors: {
                loadFailed: "No se pudieron cargar las preferencias.",
                saveFailed: "No se pudieron guardar las preferencias.",
              },
            },
            priority: {
              title: "Cola esperando restock",
              subtitle:
                "Orden por prioridad. El allocator promueve las entradas superiores cuando vuelve el stock; aquí puedes anular.",
              empty: "No hay líneas en espera ahora mismo.",
              loading: "Cargando cola…",
              qty: "× {{qty}}",
              order: "Pedido {{orderId}}",
              score: "Puntuación {{score}}",
              queuedOn: "En cola desde {{date}}",
              promote: "Promover",
              promoting: "Promoviendo…",
              confirmPromote:
                "¿Promover esta línea manualmente, antes que el allocator? Esto reservará {{qty}} unidades de {{sku}} para el pedido {{orderId}}.",
              promoteSuccess: "Línea promovida. Pedido {{orderId}} actualizado.",
              reasons: {
                refill: "Refill",
                paid: "Pagado",
                authorized: "Autorizado",
                patientContinuity: "Paciente recurrente",
                age: "{{count}}d en espera",
              },
              errors: {
                loadFailed: "No se pudo cargar la cola.",
                promoteFailed: "No se pudo promover la línea.",
                noHeadroom: "No hay suficiente stock disponible para promover esta línea ahora.",
              },
            },
            catalogManager: {
              bulkInventory: "Inventario Masivo",
              legalDisclaimer: "Aviso Legal",
              col: {
                stock: "Stock",
              },
              stockRollup: {
                noVariants: "—",
                noData: "Sin datos",
                allInStock: "Todo en stock",
                outOfStock: "{{count}} agotado",
                backOrdered: "{{count}} en pedido",
                lowStock: "{{count}} bajo",
                discontinued: "{{count}} desc.",
              },
            },
            legalDisclaimer: {
              title: "Aviso Legal",
              subtitle: "Se aplica a todos los productos — nuevos y existentes",
              previewLabel: "Vista previa en vivo",
              previewHint: "Exactamente lo que ven los compradores debajo de la descripción de cada producto.",
              reset: "Restablecer al texto estándar",
              cancel: "Cancelar",
              save: "Guardar",
              saving: "Guardando…",
              emptyNote:
                "Deje una sección en blanco para restaurar su texto estándar — un producto nunca puede publicarse sin aviso legal.",
              section: {
                reconstitution: "Reconstitución",
                restrictedSale: "Venta Restringida",
                researchUseWarning: "Advertencia de Uso en Investigación",
                manufacturingQuality: "Fabricación y Calidad",
              },
              resetConfirmTitle: "Restablecer al texto estándar",
              resetConfirmBody:
                "¿Restablecer las cuatro secciones al texto legal estándar? Sus ediciones personalizadas en este editor serán reemplazadas.",
              resetConfirmAction: "Restablecer",
              saveConfirmTitle: "Actualizar aviso legal",
              saveConfirmBody: "Esto actualiza el aviso legal que se muestra en cada producto — nuevos y existentes. ¿Continuar?",
              saveConfirmAction: "Guardar",
            },
            analytics: {
              title: "Analíticas de Péptidos",
              subtitle: "Operaciones, reorden y revenue de un vistazo.",
              tabs: {
                overview: "Resumen",
                operations: "Operaciones",
                reorder: "Reorden",
                customers: "Clientes",
                products: "Productos",
                reps: "Representantes",
                payments: "Pagos",
                reports: "Informes",
              },
              phase2: {
                stageTiming: "Los tiempos por etapa requieren el log de transiciones — llegan en la Fase 2.",
                scheduledReports: "La programación requiere un cron + plantilla de correo — llega en la Fase 2.",
                customReports: "Las definiciones de informes guardadas requieren un nuevo store — llega en la Fase 2.",
              },
              export: {
                trigger: "Exportar",
                csv: "Descargar CSV",
                pdf: "Descargar PDF",
              },
              period: {
                dateRangeLabel: "Rango de fechas",
                granularityLabel: "Granularidad",
              },
              operations: {
                kpi: {
                  totalOrders: "Pedidos totales",
                  totalOrdersDetail: "en el periodo seleccionado",
                  medianFulfillment: "Tiempo de cumplimiento (mediana)",
                  estBadge: "Est.",
                  medianFulfillmentTitle:
                    "Derivado de updatedAt — cualquier edición posterior a la entrega altera este número. Pendiente integración con el log de auditoría.",
                  medianFulfillmentDetail_one: "basado en {{count}} enviado/entregado",
                  medianFulfillmentDetail_other: "basado en {{count}} enviados/entregados",
                  onTime: "A tiempo (≤ {{days}}d)",
                  onTimeDetail: "{{onTime}} de {{total}}",
                  lostRevenue: "Ingresos perdidos (cancelados)",
                  lostRevenueDetail_one: "{{paid}} de {{total}} cancelación fue pagada",
                  lostRevenueDetail_other: "{{paid}} de {{total}} cancelaciones fueron pagadas",
                },
                sections: {
                  fulfillmentTime: "Tiempo de cumplimiento",
                  fulfillmentTimeSubtitle: "Días desde el pedido hasta el envío o la entrega.",
                  pipeline: "Embudo del pipeline",
                  pipelineSubtitle:
                    "El tronco (pago → confirmado) se divide en pistas de recogida y envío. La conversión de cada pista se lee de forma independiente.",
                  cancellations: "Cancelaciones",
                  cancellationsSubtitle_one: "{{count}} cancelado este periodo.",
                  cancellationsSubtitle_other: "{{count}} cancelados este periodo.",
                },
                track: { ship: "Pista de envío", pickup: "Pista de recogida" },
                cancel: {
                  prePayment: "Antes del pago (borrador)",
                  prePaymentDetail: "Sin impacto en ingresos",
                  postPayment: "Después del pago",
                  postPaymentDetail: "{{amount}} perdidos",
                  topReasons: "Motivos principales",
                  emptyReasons: "Sin datos de motivos.",
                },
                empty: {
                  fulfillment: "Aún no hay pedidos enviados o entregados en este periodo.",
                  funnel: "Ningún pedido pasó por el pipeline en este periodo.",
                  cancellations: "Sin cancelaciones en este periodo.",
                },
                chart: { orders: "Pedidos" },
              },
              products: {
                kpi: {
                  skusSold: "SKUs vendidos",
                  skusSoldDetail: "en el periodo seleccionado",
                  belowCost: "SKUs bajo costo",
                  belowCostDetail_one: "{{count}} SKU con precio bajo costo",
                  belowCostDetail_other: "{{count}} SKUs con precio bajo costo",
                  periodRevenue: "Ingresos del periodo",
                  avgMargin: "Margen promedio",
                  avgMarginDetail: "ponderado entre SKUs",
                },
                sections: {
                  bundles: "Comprados frecuentemente juntos",
                  bundlesSubtitle: "Pares de SKUs que aparecen juntos en pedidos multi-artículo.",
                },
                empty: { bundles: "Sin pedidos multi-artículo en este periodo." },
                bundle: { orders_one: "{{count}} pedido", orders_other: "{{count}} pedidos" },
                table: { product: "Producto", dosage: "Dosis" },
              },
              reorder: {
                rate: {
                  daily: "unidades/día",
                  weekly: "unidades/semana",
                  monthly: "unidades/mes",
                },
              },
              customers: {
                kpi: {
                  totalClients: "Clientes totales",
                  totalClientsDetail: "con un pedido entregado",
                  newestCohort: "Cohorte más reciente",
                  churnRisk: "Riesgo de pérdida",
                  topRegion: "Región principal",
                },
                sections: {
                  cohort: "Retención por cohorte",
                  cohortSubtitle: "Porcentaje de clientes nuevos de cada mes que siguen activos en los meses posteriores.",
                  ltv: "Valor de vida por nivel",
                  ltvSubtitle:
                    "Promedio de ingresos entregados de por vida por cliente, agrupados por el nivel del proveedor de sus pedidos. No filtrado por periodo — incluye el historial completo del cliente.",
                  geography: "Distribución geográfica",
                  geographySubtitle: "Principales estados de EE.UU. por ingresos cobrados, donde las direcciones son parseables.",
                },
                table: {
                  cohort: "Cohorte",
                  size: "Tamaño",
                  client: "Cliente",
                  cadence: "Cadencia",
                  lastOrder: "Último pedido",
                  score: "Puntaje",
                  lifetime: "De por vida",
                },
                empty: {
                  cohorts: "Aún no hay cohortes para mostrar.",
                  ltv: "Aún no hay pedidos con nivel asignado.",
                  geo: "Sin datos de dirección disponibles para el mapa.",
                },
                client: { one: "cliente", other: "clientes" },
              },
              reps: {
                kpi: {
                  activeReps: "Representantes activos",
                  activeRepsDetail: "Representantes con pedidos en este periodo",
                  periodRevenue: "Ingresos del periodo",
                  periodRevenueDetail: "Entre todos los portafolios",
                  commission: "Comisión estimada",
                  commissionDetail: "Suma de comisiones por pedido",
                  topRep: "Representante principal",
                  topRepDetailDelivered: "{{amount}} entregado",
                  topRepDetailNoFirst: "Sin pedidos aún",
                },
                sections: {
                  performance: "Desempeño de representantes",
                  performanceSubtitle:
                    "Portafolio de cada representante en el periodo seleccionado. La comisión usa la configuración fija/porcentual/menor de cada uno.",
                },
                empty: { reps: "Aún no hay representantes en el directorio." },
                table: {
                  rep: "Representante",
                  accounts: "Cuentas",
                  orders: "Pedidos",
                  conversion: "Conversión",
                  revenue: "Ingresos",
                  commission: "Comisión",
                  tierMix: "Mezcla de niveles",
                  lastOrder: "Último pedido",
                  conversionNoData:
                    "Aún no hay pedidos en estado terminal — espera la primera entrega o una cancelación post-pago",
                  conversionTitle: "{{delivered}} entregados / {{terminal}} en estado terminal",
                },
              },
              reports: {
                quickExports: "Exportaciones rápidas",
                quickExportsSubtitle:
                  "Datos de cada pestaña en un solo lugar. CSV abre en Numbers/Excel; PDF está listo para imprimir.",
                scheduled: "Informes programados",
                custom: "Informes personalizados",
                comingSoon: "Próximamente",
                loading: "Cargando datos…",
                csv: "CSV",
                pdf: "PDF",
                cards: {
                  operations: {
                    title: "Operaciones",
                    desc: "Tiempo de cumplimiento, tasa a tiempo, embudo del pipeline, motivos de cancelación.",
                  },
                  reorder: {
                    title: "Pronóstico de reorden",
                    desc: "Cadencia por cliente, días desde el último pedido, puntaje de riesgo.",
                  },
                  customers: {
                    title: "Clientes y retención",
                    desc: "Retención por cohorte, LTV por nivel, riesgo de pérdida, geografía.",
                  },
                  products: { title: "Productos y márgenes", desc: "Velocidad, cobertura de margen, pares comprados juntos." },
                  reps: {
                    title: "Representantes de ventas",
                    desc: "Ingresos por representante, conversión, comisión, mezcla de niveles.",
                  },
                },
              },
              payments: {
                kpi: {
                  pending: "Pendientes",
                  pendingDetail: "histórico",
                  card: "Tarjeta",
                  cardDetail_one: "{{count}} pedido",
                  cardDetail_other: "{{count}} pedidos",
                  zelle: "Zelle",
                  zelleDetail_one: "{{count}} pedido",
                  zelleDetail_other: "{{count}} pedidos",
                  fees: "Comisiones",
                  feesDetail: "{{rate}} efectiva",
                  feesBadge: "est.",
                  netRevenue: "Ingreso neto",
                  netRevenueDetail: "cobrado − comisiones",
                },
                sections: {
                  paymentsOverTime: "Pagos en el tiempo",
                  paymentsOverTimeSubtitle: "Cobrado por método de pago, agrupado según la granularidad elegida.",
                  methodBreakdown: "Método de pago",
                  methodBreakdownSubtitle: "Participación del ingreso cobrado.",
                  pending: "Pagos pendientes",
                  pendingSubtitle: "Pedidos abiertos sin pago. Es un estado, no un período.",
                  aging: "Antigüedad",
                  agingSubtitle: "Hace cuánto esperan los pendientes.",
                  feesTrend: "Tendencia de comisiones",
                  feesTrendSubtitle: "Comisiones estimadas y tasa efectiva.",
                  failedRetry: "Reintentos de tarjeta",
                  failedRetrySubtitle: "Tarjetas pendientes con al menos un intento de cobro previo.",
                  recent: "Transacciones recientes",
                  recentSubtitle: "Últimos pagos cobrados en el período seleccionado.",
                  byRep: "Pagos por representante",
                  byRepSubtitle: "Cobrado, comisiones e ingreso neto por representante.",
                  byOrg: "Pagos por organización",
                  byOrgSubtitle: "Cobrado, comisiones e ingreso neto por organización proveedora.",
                },
                table: {
                  customer: "Cliente",
                  org: "Organización",
                  rep: "Representante",
                  method: "Método",
                  age: "Antigüedad",
                  ageDays_one: "{{count}} día",
                  ageDays_other: "{{count}} días",
                  attempts: "Intentos",
                  amount: "Monto",
                  fee: "Comisión (est.)",
                  net: "Neto",
                  date: "Fecha",
                  orders: "Pedidos",
                  collected: "Cobrado",
                  actions: "Acciones",
                  emptyPending: "Sin pagos pendientes.",
                  emptyFailed: "Sin reintentos de tarjeta en curso.",
                  emptyRecent: "Sin pagos cobrados en este período.",
                  emptyByRep: "Sin pedidos pagos atribuidos a representantes en este período.",
                  emptyByOrg: "Sin pedidos pagos en este período.",
                },
                actions: {
                  charge: "Cobrar pedido",
                  retry: "Reintentar cobro",
                  remind: "Enviar recordatorio",
                  viewOrder: "Ver pedido",
                },
                methodBadge: {
                  card: "Tarjeta",
                  zelle: "Zelle",
                  unknown: "—",
                },
                aging: {
                  bucket0to3: "0–3d",
                  bucket4to7: "4–7d",
                  bucket8to14: "8–14d",
                  bucket15plus: "15d+",
                },
                reminder: {
                  title: "Enviar recordatorio de pago",
                  subtitle:
                    "Copia este mensaje y envíalo al proveedor por el canal que prefieras. Aún no contamos con envío integrado.",
                  emailLabel: "Correo",
                  smsLabel: "SMS",
                  copy: "Copiar",
                  copied: "Copiado al portapapeles",
                  copyFailed: "No se pudo copiar — selecciona el texto manualmente",
                  close: "Cerrar",
                  emailSubject: "Falta comprobante de pago — Pedido #{{orderId}}",
                  emailBody:
                    "Hola {{name}},\n\nAún necesitamos el comprobante Zelle del pedido #{{orderId}} ({{amount}}). ¿Podrías subirlo cuando puedas?\n\nGracias,\nLucas Health",
                  smsBody:
                    "Hola {{name}}, necesitamos el comprobante Zelle del pedido #{{orderId}} ({{amount}}). Súbelo cuando puedas. — Lucas Health",
                },
                chart: {
                  collected: "Cobrado",
                  fees: "Comisiones",
                  rate: "Tasa efectiva",
                  count: "Cantidad",
                  noData: "Sin pagos en este período.",
                },
                feeNote:
                  "Las comisiones se estiman en {{rate}} para tarjeta y $0 para Zelle. Las comisiones reales de Maverick pueden variar.",
              },
              provider: {
                title: "Sus análisis",
                subtitle: "Controle sus ganancias y ventas de un vistazo.",
                totalProfit: "Ganancia total",
                revenue: "Ingresos",
                margin: "Margen",
                units: "Unidades vendidas",
                aov: "Valor promedio de pedido",
                profit: "Ganancia",
                product: "Producto",
                topProducts: "Productos más rentables",
                deliveredDetail: "Pedidos entregados en este período",
              },
            },
            protocols: {
              attach: {
                title: "Protocolo (opcional)",
                hint: "Asigne un protocolo de dosificación a cada producto que esté pidiendo.",
                assignedCount: "{{count}} de {{total}} productos en un protocolo",
                noPeptides: "Agregue un péptido a su pedido para asignar un protocolo.",
                noneForProduct: "Sin protocolo disponible",
                none: "Ninguno",
                weeksShort: "sem",
                rxDose: "Dosis",
                rxDraw: "Cargar",
                rxFreq: "Frecuencia",
                rxRoute: "Vía",
                rxDuration: "Duración",
                drawUnits: "{{u}} unidades",
                verifyDraw: "Verificar",
                verifyDrawHint:
                  "El vial del catálogo difiere de la concentración prevista del protocolo, o la dosis no cabe en una jeringa de 1 mL — verifique en la calculadora de reconstitución.",
              },
              title: "Biblioteca de protocolos",
              searchPlaceholder: "Buscar protocolos o péptidos",
              countProtocols_one: "{{count}} protocolo",
              countProtocols_other: "{{count}} protocolos",
              doseDaysLabel: "Días de dosificación",
              doseDaysAny: "Opcional: deje en blanco para cualquier {{count}} día(s) a la semana",
              day: { mon: "L", tue: "M", wed: "X", thu: "J", fri: "V", sat: "S", sun: "D" },
              dayFull: {
                mon: "Lunes",
                tue: "Martes",
                wed: "Miércoles",
                thu: "Jueves",
                fri: "Viernes",
                sat: "Sábado",
                sun: "Domingo",
              },
              available: "Disponible",
              unavailable: "No está en el catálogo",
              weeksTotal: "{{count}} semanas",
              phaseCount: "{{count}} fases",
              noIntake: "Sin cuestionario en el expediente",
              noIntakeLong:
                "Este paciente no tiene cuestionario de admisión en el expediente, así que las contraindicaciones no se pueden preverificar.",
              patientContext: "Explorando para {{name}}. Los protocolos se preverifican contra su cuestionario de admisión.",
              loadingPatient: "Cargando contexto del paciente…",
              clearPatient: "Quitar",
              patient: "Paciente",
              refillsDue: "Resurtidos de protocolo pendientes",
              overdueDays: "{{count}} d de retraso",
              daysLeft: "{{count}} d restantes",
              phase: "Fase",
              weeks: "Semanas",
              dose: "Dosis",
              unitsAt: "Unidades @ {{ml}} mL",
              maintenanceTag: "mantenimiento",
              unitsCaveat:
                "Las unidades de jeringa asumen una reconstitución con {{ml}} mL de agua bacteriostática en jeringa U-100. Verifique otras diluciones en la calculadora de reconstitución.",
              phaseOrder: "Pedido para {{phase}}",
              monitoringTitle: "Monitoreo",
              disclaimer:
                "Los protocolos son apoyo a la decisión clínica con dosis preliminares para revisión del médico. El médico prescriptor es el único responsable de confirmar la idoneidad, la dosificación y el monitoreo de cada paciente.",
              cancel: "Cancelar",
              close: "Cerrar",
              addPhase: "Agregar {{phase}} al carrito",
              phaseAdded: "{{phase}} de {{protocol}} agregada al carrito",
              orderingFor: "Ordenando para {{name}}",
              safetyFlags: "Alertas del cuestionario para este protocolo",
              empty: "Ningún protocolo coincide con este filtro.",
              newProtocol: "Nuevo protocolo",
              doseLab: {
                title: "Laboratorio de dosis: {{phase}}",
                hint: "Ajuste el vial, la dilución y la dosis",
                save: "Guardar cambios",
                saveFork: "Guardar como mi protocolo",
                savedFork: "Guardado en Mis protocolos como {{name}}",
                savedInPlace: "{{name}} actualizado",
                vial: "Vial (mg)",
                diluent: "Agua bacteriostática (mL)",
                dose: "Dosis (mg)",
                perWeek: "Dosis / semana",
                concentration: "Concentración",
                draw: "Extracción",
                dosesPerVial: "Dosis / vial",
                full: "extracciones completas",
                lasts: "El vial dura",
                days: "días",
                fillTitle: "Llenado de la jeringa en un barril U-100 de 1 mL",
              },
              customize: "Duplicar y personalizar",
              customBadge: "Personalizado",
              patientBadge: "Protocolo del paciente",
              sectionPatient: "Protocolos para {{name}}",
              sectionMine: "Mis protocolos",
              sectionStandard: "Protocolos estándar",
              editProtocol: "Editar protocolo",
              deleteProtocol: "Eliminar protocolo",
              deletedToast: "{{name}} eliminado",
              savedToast: "{{name}} guardado",
              undo: "Deshacer",
              editor: {
                titleNew: "Nuevo protocolo",
                titleClone: "Personalizar protocolo",
                titleEdit: "Editar protocolo",
                cloneName: "{{name}} (Personalizado)",
                name: "Nombre del protocolo",
                namePlaceholder: "p. ej. Rampa de recuperación BPC-157",
                description: "Descripción",
                descPlaceholder: "Para qué sirve este protocolo y cómo escala",
                goals: "Objetivos",
                scope: "¿Para quién es este protocolo?",
                scopeOrg: "Todos los pacientes",
                scopePatient: "Paciente específico",
                pickPatient: "Seleccionar paciente",
                searchPatient: "Buscar por nombre o fecha de nacimiento",
                noPatients: "No hay pacientes que coincidan",
                startTyping: "Empiece a escribir un nombre o fecha de nacimiento",
                noDob: "Sin fecha de nacimiento en el expediente",
                intakeOnly: "admisión",
                phases: "Fases",
                phaseDefault: "Fase 1",
                phaseN: "Fase {{n}}",
                weeksSpan: "sem (semanas {{from}}-{{to}})",
                removePhase: "Eliminar fase",
                addPhase: "Agregar fase",
                pickPeptide: "Seleccionar péptido",
                doseMg: "Dosis mg",
                doseLabel: "Etiqueta de dosis",
                perWeek: "por semana",
                removePeptide: "Quitar péptido",
                addPeptide: "Agregar péptido",
                monitoringPlaceholder: "p. ej. Registrar el peso cada mes",
                removeNote: "Quitar nota",
                addNote: "Agregar nota de monitoreo",
                needName: "Asigne un nombre al protocolo.",
                needPhase: "Agregue al menos una fase.",
                needWeeks: "Cada fase necesita una duración de al menos 1 semana.",
                needDose: "Cada fase necesita un péptido con una dosis mayor a 0.",
                needPatient: "Seleccione el paciente al que pertenece este protocolo.",
                save: "Guardar protocolo",
              },
              journeyTitle: "Trayecto del protocolo",
              journeyEmpty: "Este paciente aún no tiene un protocolo registrado.",
              startProtocol: "Iniciar protocolo",
              statusActive: "Activo",
              statusDue: "Resurtido pendiente",
              statusOverdue: "Atrasado",
              statusCompleted: "Completado",
              actionAdvance: "Avanzar",
              actionRepeat: "Repetir",
              actionMaintain: "Mantener",
              actionStepDown: "Bajar dosis",
              actionTimeOff: "Pausa",
              actionResume: "Reanudar",
              statusPaused: "En pausa",
              resumeIn: "Retoma en {{count}} d",
              pausedToast: "{{protocol}} en pausa por {{count}} días",
              timeOffHint: "Registre un descanso planificado; el trayecto se reanuda al terminar.",
              timeOffDays: "{{count}} días",
              approvalSection: "Protocolo",
              approvalContinues: "Aprobar continúa {{protocol}} ({{phase}}).",
              phaseOfShort: "fase {{n}}",
              noProtocol: "Sin protocolo",
              noMatch: "Ningún protocolo de la biblioteca coincide con los artículos de este pedido.",
              stampFailed: "No se pudo registrar el protocolo en este pedido. La aprobación continúa sin él.",
              phaseOf: "{{label}}: fase {{n}} de {{total}}",
              limitsTitle: "Límites y precauciones",
              limit: {
                vsLimit: "(límite {{limit}})",
                overSingle: "La dosis supera el tope por dosis",
                overWeekly: "La dosis semanal supera el tope",
                overMonthly: "Más dosis por mes de las permitidas",
                tooFrequent: "Dosis más juntas que el intervalo mínimo",
                overCycle: "La fase dura más que el ciclo recomendado",
                titrateSlowly: "No escale más rápido que cada 4 semanas; pause o reduzca por intolerancia gastrointestinal.",
                oralGlp1: "GLP-1 oral: tome de forma constante; titule para limitar las náuseas.",
                cardioHighDose:
                  "Dosis por encima de 500 mcg/día elevan la frecuencia cardíaca y la presión arterial: controle de cerca.",
                cycleOnOff: "Cicle activo y de descanso según indicación para preservar la respuesta y limitar la tolerancia.",
                researchOnly: "Ventana terapéutica estrecha: no combine con compuestos similares.",
                hypoglycemia: "Puede causar hipoglucemia: administre con comida y controle la glucosa.",
                mk677Effects: "Puede aumentar el apetito, la retención de líquidos y la glucosa en ayunas: controle.",
                loadThenMaintain: "Use una fase de carga y luego baje a una dosis de mantenimiento.",
                epitalonSpacing: "Solo cursos cortos; repita cada 4–6 meses, no de forma continua.",
                nadRate: "Avance lentamente: el rubor y las náuseas dependen de la velocidad de la dosis.",
                nmnCeiling: "Considerado seguro hasta 1250 mg/día en adultos sanos.",
                maoiSerotonin: "Evite con ISRS/IRSN/IMAO: riesgo de síndrome serotoninérgico. Confirme la medicación.",
                pt141Limits:
                  "Máx. 1 dosis cada 24 horas y 8 dosis al mes. Puede elevar la presión arterial de forma transitoria.",
                hormoneLabs: "Reevalúe la testosterona y los laboratorios hormonales antes de extender más allá de un ciclo.",
                mt2Caution: "Titule desde 0.25 mg; náuseas/rubor son comunes. Vigile lunares y lesiones pigmentadas.",
                phenibutDependence:
                  "Alto riesgo de dependencia y tolerancia: limite la frecuencia. Use precaución por encima de 700 mg.",
              },
              phases: {
                initiation: "Inicio",
                escalation1: "Escalada 1",
                escalation2: "Escalada 2",
                escalation3: "Escalada 3",
                maintenance: "Mantenimiento",
                loading: "Carga",
                consolidation: "Consolidación",
                build: "Adaptación",
                fullDose: "Dosis completa",
                course: "Curso",
                asNeeded: "Según necesidad",
              },
              supplies: {
                bacWater: "Agua bacteriostática",
                syringes: "Jeringas de insulina",
                alcoholWipes: "Toallitas de alcohol",
              },
              lib: {
                "wl-cagrilintide-titration": {
                  name: "Titulación de cagrilintida",
                  desc: "Análogo de amilina escalado semanalmente de 0.25 mg a 1.7 mg cada 4 semanas para limitar las náuseas.",
                },
                "wl-mazdutide-titration": {
                  name: "Titulación de mazdutida",
                  desc: "Agonista dual GLP-1/glucagón escalado de 1.5 mg a 5 mg semanales durante 12 semanas.",
                },
                "wl-orforglipron-oral": {
                  name: "Titulación oral de orforglipron",
                  desc: "GLP-1 oral una vez al día escalado de 12 mg a 36 mg según tolerancia; sin inyección ni refrigeración.",
                },
                "wl-tesofensine-oral": {
                  name: "Tesofensina oral",
                  desc: "Inhibidor triple de la recaptación de monoaminas iniciado a 250 mcg al día, aumentando a 500 mcg con control de PA/FC.",
                },
                "wl-aod9604-12wk": {
                  name: "Pérdida de grasa con AOD-9604",
                  desc: "Fragmento de HGH 177-191 a 250-300 mcg cada mañana, en ayunas, durante 12 semanas.",
                },
                "wl-amino1mq-oral": {
                  name: "5-Amino-1MQ oral",
                  desc: "Inhibidor de NNMT a 50 mg tres veces al día con las comidas; un mes de descanso cada dos meses.",
                },
                "wl-slupp332-intro": {
                  name: "Introducción de SLU-PP-332",
                  desc: "Agonista ERR mimético del ejercicio iniciado a 250 mcg para evaluar tolerancia, luego 500 mcg.",
                },
                "wl-bam15-oral": {
                  name: "BAM-15 en días de entrenamiento",
                  desc: "Desacoplador mitocondrial a 15-30 mg en ayunas en los días de entrenamiento.",
                },
                "energy-cardarine": {
                  name: "Cardarina (GW-501516)",
                  desc: "Agonista PPARδ a 10-20 mg al día para resistencia y soporte lipídico, ciclos de 8 semanas.",
                },
                "energy-sr9011": {
                  name: "SR-9011 circadiano",
                  desc: "Agonista Rev-ErbA a 15-30 mg al día para apoyar el metabolismo y el ritmo circadiano.",
                },
                "wl-lcarnitine": {
                  name: "L-Carnitina",
                  desc: "Transportador de ácidos grasos a ~1000 mg al día para apoyar el metabolismo de grasas y la recuperación.",
                },
                "wl-lipoc-mic": {
                  name: "Lipo-C / B12 (MIC)",
                  desc: "Inyección lipotrópica MIC + B12 semanal para apoyar el metabolismo de grasas y la energía.",
                },
                "gh-cjc1295-nodac": {
                  name: "CJC-1295 (sin DAC)",
                  desc: "Análogo de GHRH escalado de 100 mcg a 200 mcg cada noche, 5 noches por semana.",
                },
                "gh-cjc1295-dac": {
                  name: "CJC-1295 con DAC",
                  desc: "Análogo de GHRH de acción prolongada a 1000 mcg dos veces por semana para liberación sostenida de GH.",
                },
                "gh-ipamorelin": {
                  name: "Ipamorelina",
                  desc: "Secretagogo selectivo de GH a 200-300 mcg, 2-3 veces al día en ayunas.",
                },
                "gh-sermorelin": {
                  name: "Sermorelina",
                  desc: "Péptido GHRH a 200 mcg cada noche al acostarse, con descansos periódicos de 1-2 meses.",
                },
                "gh-tesamorelin": {
                  name: "Tesamorelina",
                  desc: "Análogo de GHRH a 1 mg cada mañana, en ayunas, de lunes a viernes para grasa visceral.",
                },
                "muscle-igf1lr3": {
                  name: "IGF-1 LR3",
                  desc: "IGF-1 de acción prolongada a 50 mcg al día, 4 semanas activo y 4 de descanso.",
                },
                "gh-mk677-oral": {
                  name: "MK-677 (Ibutamoren)",
                  desc: "Secretagogo oral de GH iniciado a 10-15 mg, escalando a una dosis estándar de 25 mg al día.",
                },
                "gh-mk777-oral": {
                  name: "MK-777 (Acetamoren)",
                  desc: "Agonista de grelina de acción más prolongada a 25 mg al día para soporte de GH e IGF-1.",
                },
                "gh-somatropin": {
                  name: "Somatropina (HGH)",
                  desc: "Hormona de crecimiento recombinante a 2-4 IU cada noche antes de dormir.",
                },
                "rec-bpc157-standalone": {
                  name: "Reparación con BPC-157",
                  desc: "Péptido de reparación de tejidos a 250-500 mcg, 1-2 veces al día, 4-6 semanas activo y 2-4 de descanso.",
                },
                "rec-tb500-standalone": {
                  name: "Reparación con TB-500",
                  desc: "Carga de 5 mg por semana repartida en dosis, luego mantenimiento de 2.5 mg semanales.",
                },
                "rec-kpv": {
                  name: "KPV antiinflamatorio",
                  desc: "Tripéptido antiinflamatorio a 200-400 mcg al día durante 4-6 semanas.",
                },
                "skin-glow-blend": {
                  name: "Mezcla Glow",
                  desc: "Mezcla de BPC-157 / TB-500 / GHK-Cu, 5 unidades por la mañana y 5 por la noche.",
                },
                "rec-klow-blend": {
                  name: "Mezcla KLOW",
                  desc: "Mezcla de GHK-Cu / BPC-157 / TB-4 / KPV a 2-4 mg por dosis, 1-2 veces al día.",
                },
                "longevity-ss31": {
                  name: "SS-31 mitocondrial",
                  desc: "Péptido dirigido a las mitocondrias a ~5 mg al día para soporte de energía celular.",
                },
                "immune-thymosin-a1": {
                  name: "Timosina alfa-1",
                  desc: "Péptido inmunomodulador a 1.6 mg dos veces por semana; los ciclos duran 6-12 meses.",
                },
                "energy-nmn-oral": {
                  name: "NMN oral",
                  desc: "Precursor de NAD+ a 500 mg al día; bien tolerado hasta 1250 mg.",
                },
                "cog-methylene-blue": {
                  name: "Azul de metileno",
                  desc: "Cofactor mitocondrial a 50-100 mg al día para soporte cognitivo y energético.",
                },
                "anti-glutathione": {
                  name: "Glutatión antioxidante",
                  desc: "Antioxidante maestro a 200-600 mg por dosis, 2-3 veces por semana, IM o SubQ.",
                },
                "sex-hcg-trt": {
                  name: "HCG (adjunto a TRT)",
                  desc: "500 IU 2-3 veces por semana para preservar la función testicular junto con la TRT.",
                },
                "sex-gonadorelin": {
                  name: "Gonadorelina",
                  desc: "Agonista de GnRH a 100-200 mcg dos veces al día para apoyar la testosterona endógena.",
                },
                "sex-enclomiphene": {
                  name: "Enclomifeno",
                  desc: "SERM oral a 12.5-25 mg al día durante 14-28 días para evaluar la respuesta de testosterona; ciclo 3-6 meses.",
                },
                "skin-melanotan2": {
                  name: "Melanotán 2",
                  desc: "Iniciado a 0.25 mg al día para evaluar tolerancia, aumentando a 0.5 mg, luego 0.5 mg 1-2 veces por semana para mantener.",
                },
                "cog-selank-standalone": {
                  name: "Selank ansiolítico",
                  desc: "Nootrópico ansiolítico a 250 mcg al día durante 10-14 días, luego un descanso de 2-4 semanas.",
                },
                "cog-semax-standalone": {
                  name: "Semax nootrópico",
                  desc: "Nootrópico de enfoque a 250 mcg al día durante 10-20 días, luego un descanso de 2-4 semanas.",
                },
                "cog-dihexa-oral": {
                  name: "Dihexa",
                  desc: "Potenciador de HGF/c-Met a 10-40 mg al día para soporte cognitivo.",
                },
                "cog-fladrafinil-oral": {
                  name: "Fladrafinil",
                  desc: "Nootrópico eugeroico a 50-100 mg al día para vigilia y enfoque.",
                },
                "cog-phenibut-oral": {
                  name: "Fenibut",
                  desc: "Agonista GABA-B a 200-500 mg, de uso esporádico; la tolerancia se desarrolla rápidamente.",
                },
                "skin-ahkcu": {
                  name: "AHK-Cu para el cabello",
                  desc: "Tripéptido de cobre a 1-2 mg al día para soporte del folículo capilar.",
                },
                wlSema: {
                  name: "Titulación de semaglutida para pérdida de peso",
                  desc: "Escalada estándar de GLP-1 de 0.25 mg a una dosis de mantenimiento de 2.4 mg semanales, aumentando cada 4 semanas según tolerancia.",
                },
                wlTirz: {
                  name: "Titulación de tirzepatida para pérdida de peso",
                  desc: "Escalada del agonista dual GIP/GLP-1 de 2.5 mg a una dosis de mantenimiento de 12.5 mg semanales, aumentando cada 4 semanas según tolerancia.",
                },
                wlReta: {
                  name: "Introducción a retatrutida",
                  desc: "Rampa de introducción del triple agonista de 1 mg a 4 mg semanales; titule más allá según respuesta y tolerancia.",
                },
                recBpcTb: {
                  name: "Stack Wolverine (BPC-157 + TB-500)",
                  desc: "Stack de reparación de tejidos blandos: fase de carga de 4 semanas seguida de una fase de consolidación de 4 semanas con frecuencia reducida.",
                },
                glowBlend: {
                  name: "Curso Glow Blend (GHK-Cu / BPC / TB-500)",
                  desc: "Mezcla para calidad de piel y reparación de tejidos: 500 mcg diarios durante 6 semanas y luego reevaluar.",
                },
                kisspeptin: {
                  name: "Apoyo del eje con Kisspeptina",
                  desc: "Apoyo a la señalización hipotalámica de LH / testosterona: 100 mcg diarios durante 8 semanas y luego reevaluar con laboratorios.",
                },
                ghCjcIpa: {
                  name: "Ciclo de 12 semanas CJC-1295 / Ipamorelina",
                  desc: "Apoyo al eje de hormona de crecimiento: 4 semanas de adaptación a 100 mcg nocturnos y luego 8 semanas con la dosis completa de 200 mcg, 5 noches por semana.",
                },
                epitalon: {
                  name: "Curso de Epitalón de 20 días",
                  desc: "Curso de apoyo a la telomerasa: 10 mg diarios durante 20 días; puede repetirse cada 4 a 6 meses.",
                },
                nad: {
                  name: "Restauración de NAD+",
                  desc: "Apoyo a la energía celular: carga de 4 semanas dos veces por semana y luego dosis semanal de mantenimiento.",
                },
                motscNad: {
                  name: "Stack metabólico MOTS-c + NAD+",
                  desc: "Apoyo mitocondrial y metabólico: MOTS-c cada 5 días junto con NAD+ semanal durante 8 semanas.",
                },
                pt141: {
                  name: "Protocolo PT-141 según necesidad",
                  desc: "Dosis a demanda 45+ minutos antes de la actividad; máximo 1 dosis cada 24 horas y 8 dosis al mes.",
                },
                dsip: {
                  name: "Protocolo de sueño DSIP de 30 días",
                  desc: "Apoyo para conciliar el sueño: 150 mcg cada noche, 30 a 60 minutos antes de acostarse, durante 30 días y luego reevaluar.",
                },
                ghkcu: {
                  name: "Protocolo de piel GHK-Cu de 8 semanas",
                  desc: "Curso para calidad de piel y tejidos: 1.5 mg diarios hasta por 8 semanas, seguido de un descanso de 2 a 4 semanas.",
                },
                selankSemax: {
                  name: "Stack cognitivo Selank + Semax",
                  desc: "Stack de enfoque y resiliencia al estrés: 250 mcg de cada uno al día durante 6 semanas y luego un descanso.",
                },
              },
              monitoring: {
                oralCaution: "Compuesto oral: confirme la dosis y las interacciones antes de usar.",
                assessTolerance: "Comience bajo y evalúe la tolerancia antes de aumentar.",
                fastedMorning: "Administre por la mañana, en ayunas, para mejor respuesta.",
                cycleBreak: "Descanse periódicamente para evitar la tolerancia.",
                ghIgf1: "Reevalúe IGF-1 con laboratorios periódicamente.",
                generic: "Reevalúe la respuesta y la tolerancia al final de cada ciclo.",
                immuneLabs: "Reevalúe los marcadores inmunitarios durante el curso.",
                hormoneLabs: "Reevalúe los laboratorios hormonales cada 3 meses.",
                tanResponse: "Aumente solo después de evaluar la respuesta de la piel y la tolerancia.",
                giTolerance: "Evalúe la tolerancia gastrointestinal antes de cada escalada de dosis.",
                weightMonthly: "Controle el peso y la respuesta cada mes; pause o reduzca según tolerancia.",
                injurySite: "Reevalúe la zona de la lesión al final de cada fase.",
                labsReassess: "Reevalúe LH, testosterona total y la respuesta con laboratorios al final del curso.",
                igf1Labs: "Considere laboratorios de IGF-1 al final del ciclo antes de repetir.",
                epitalonSpacing: "Espacie los cursos repetidos de 4 a 6 meses.",
                nadTolerance: "Titule según tolerancia; el rubor y las náuseas dependen de la velocidad de la dosis.",
                energyResponse: "Reevalúe la energía y la respuesta metabólica al final del curso.",
                pt141Limits: "Respete los límites de 1 dosis por 24 h y 8 dosis al mes.",
                sleepQuality: "Reevalúe la calidad del sueño a los 30 días antes de continuar.",
                ghkBreak: "Tome un descanso de 2 a 4 semanas entre cursos.",
                cycleOff: "Descanse de 2 a 4 semanas entre cursos.",
              },
            },
            notifSettings: {
              title: "Configuración de notificaciones",
              subtitle: "Elige cómo quieres enterarte de tus pedidos de péptidos.",
              orgNote:
                "Los destinos de correo para eventos de la organización permanecen en la configuración de notificaciones de la organización — esta página controla tus alertas en la aplicación.",
              loading: "Cargando…",
              save: "Guardar",
              saving: "Guardando…",
              cancel: "Cancelar",
              saveSuccess: "Configuración de notificaciones guardada.",
              emailLocked: "El correo para estos no se puede desactivar.",
              cat: {
                orderProgress: "Progreso del pedido",
                actionNeeded: "Acción requerida",
                payments: "Pagos",
                messages: "Mensajes",
                confirmations: "Confirmaciones",
              },
              desc: {
                orderProgress: "Aprobado, en preparación, enviado, entregado y reabastecimiento",
                actionNeeded: "Pedidos y solicitudes de resurtido que esperan por ti",
                payments: "Problemas de pago, recibos y rechazos",
                messages: "Mensajes nuevos en tus pedidos (máximo un correo cada 15 minutos por pedido)",
                confirmations: "Avisos de pedido realizado y cancelaciones",
              },
              channel: {
                both: "Correo + en la app",
                email: "Solo correo",
                in_app: "Solo en la app",
                none: "Desactivado",
              },
              errors: {
                loadFailed: "No se pudo cargar la configuración de notificaciones.",
                saveFailed: "No se pudo guardar la configuración de notificaciones.",
              },
            },
            orderToasts: {
              order_placed_patient: "Un paciente realizó un pedido nuevo.",
              order_placed_provider: "Se realizó un nuevo pedido de péptidos.",
              order_drafted_for_provider: "Se creó un borrador de pedido para ti — revisa y paga.",
              draft_finalized: "Un pedido fue finalizado — pago pendiente.",
              payment_confirmed: "Pago confirmado — pedido en preparación.",
              order_approved: "¡Tu pedido fue aprobado!",
              order_denied_provider: "Un pedido no fue aprobado.",
              payment_failed: "Falló un pago en un pedido de péptidos.",
              receipt_uploaded: "Se subió un recibo de pago.",
              order_denied_manufacturer: "El fabricante rechazó un pedido.",
              order_shipped: "Un pedido de péptidos fue enviado.",
              order_partial_shipped: "Parte de un pedido de péptidos fue enviada.",
              order_ready_for_pickup: "Un pedido de péptidos está listo para recoger.",
              order_delivered: "Un pedido de péptidos fue entregado.",
              order_backordered: "Un pedido de péptidos está en espera de existencias.",
              order_restocked: "Un pedido en espera ya está en proceso.",
              order_cancelled: "Un pedido de péptidos fue cancelado.",
              new_message: "Mensaje nuevo en un pedido de péptidos.",
              refill_requested: "Un paciente solicitó un resurtido.",
            },
            export: {
              button: "Exportar pedidos",
              title: "Exportar pedidos de péptidos",
              subtitle:
                "Descarga estos pedidos como hoja de cálculo o PDF imprimible. Nada sale de esta página hasta que exportes.",
              sections: {
                dateRange: "Fecha del pedido",
                status: "Estado",
                organizations: "Organizaciones",
                columns: "Columnas",
                output: "Salida",
              },
              placedBasis: "Fecha del pedido",
              noOrganization: "(Sin organización)",
              orgAll: "Todas las organizaciones",
              orgSelected: "{{count}} seleccionadas",
              orgSearch: "Buscar organizaciones",
              range: {
                all: "Todo el tiempo",
                last7: "Últimos 7 días",
                last30: "Últimos 30 días",
                last90: "Últimos 90 días",
                mtd: "Mes en curso",
                ytd: "Año en curso",
                custom: "Personalizado",
                from: "Desde",
                to: "Hasta",
              },
              status: {
                selectAll: "Seleccionar todo",
                clear: "Limpiar",
                includeArchived: "Incluir pedidos archivados",
                other: "Otros",
              },
              columns: {
                selectAll: "Todas",
                none: "Ninguna",
                atLeastOne: "Elige al menos una columna para exportar.",
              },
              presets: {
                basic: "Básico",
                fulfillment: "Despacho",
                billing: "Facturación",
                everything: "Todo",
              },
              categories: {
                customer: "Cliente",
                order: "Pedido",
                fulfillment: "Despacho",
                payment: "Pago",
                organization: "Organización",
              },
              fields: {
                patientFirstName: "Nombre",
                patientLastName: "Apellido",
                patientDOB: "Fecha de nacimiento",
                patientAddress: "Dirección",
                patientCity: "Ciudad",
                patientState: "Estado/Departamento",
                patientZip: "Código postal",
                patientId: "ID del paciente",
                id: "N.º de pedido",
                placedAt: "Fecha del pedido",
                status: "Estado",
                lane: "Columna del tablero",
                origin: "Origen del pedido",
                products: "Productos",
                unitCount: "Unidades",
                isRecurring: "Recurrente",
                recurringIntervalDays: "Intervalo de resurtido (días)",
                parentOrderId: "N.º de pedido principal",
                lastStateChangeAt: "Último cambio de estado",
                cancelReason: "Motivo de cancelación",
                isArchived: "Archivado",
                fulfillmentType: "Despacho",
                carrier: "Transportadora",
                trackingNumber: "N.º de guía",
                deliveredAt: "Entregado",
                pickupLocation: "Punto de recogida",
                paymentMethod: "Método de pago",
                orderTotalDollars: "Total del pedido (USD)",
                totalDollars: "Subtotal de productos (USD)",
                shippingDollars: "Envío (USD)",
                hasCustomPricing: "Precio personalizado",
                organizationName: "Organización",
                organizationId: "ID de la organización",
                placedByName: "Realizado por (nombre)",
                productName: "Producto",
                quantity: "Cant.",
                unitPriceDollars: "Precio unitario (USD)",
                dosage: "Dosis",
                formType: "Presentación",
              },
              origin: {
                provider: "Proveedor",
                patient: "Paciente",
                manufacturer: "Fabricante",
                unknown: "Desconocido",
              },
              values: {
                yes: "Sí",
                no: "No",
                ship: "Envío",
                pickup: "Recogida",
                card: "Tarjeta",
                zelle: "Zelle",
                none: "Ninguno",
              },
              rowShape: {
                label: "Filas",
                perOrder: "Una fila por pedido",
                perProduct: "Una fila por línea de producto",
              },
              format: {
                label: "Formato",
                csv: "CSV",
                pdf: "PDF",
              },
              matchCount_one: "{{count}} de {{total}} pedidos coincide",
              matchCount_other: "{{count}} de {{total}} pedidos coinciden",
              noMatches: "Ningún pedido coincide con estos filtros",
              namesLoading_one:
                "Los nombres de producto aún se están cargando para {{count}} pedido. Puedes exportar ya; sus celdas de producto pueden quedar vacías.",
              namesLoading_other:
                "Los nombres de producto aún se están cargando para {{count}} pedidos. Puedes exportar ya; sus celdas de producto pueden quedar vacías.",
              pdfColumnWarning:
                "{{count}} columnas son muchas para una página PDF — el CSV mantiene todas las columnas legibles.",
              exportAction: "Exportar",
              cancel: "Cancelar",
              success_one: "Se exportó {{count}} pedido",
              success_other: "Se exportaron {{count}} pedidos",
              errors: {
                failed: "No se pudo generar la exportación. Prueba con un rango de fechas más corto o menos columnas.",
              },
              pdf: {
                title: "Exportación de pedidos de péptidos",
                generated: "Generado el {{date}}",
                page: "Página {{page}} de {{pages}}",
                empty: "Ningún pedido coincidió.",
              },
            },
          },
          clinicalProfile: {
            activationDelivery:
              "Revisa tu correo electrónico para encontrar el enlace de activación de tu panel de paciente. Si no está en tu bandeja de entrada, revisa tus mensajes de texto para ver la copia de respaldo.",
            editedByPatient: "Actualizado por el paciente · hace {{time}}",
            peptideOrders: {
              title: "Pedidos de péptidos",
              countLabel_one: "{{count}} pedido",
              countLabel_other: "{{count}} pedidos",
              lifetime: "histórico",
              lastOrdered: "Último pedido",
              orderedBy: "Pedido por",
              viewAll_one: "Ver el {{count}} pedido →",
              viewAll_other: "Ver los {{count}} pedidos →",
              emptyTitle: "Sin pedidos de péptidos todavía",
              emptyBody1: "Los pedidos para este paciente aparecerán aquí.",
              emptyBody2: "Para realizar un nuevo pedido, selecciona a este paciente al pagar.",
              errorMessage: "No se pudieron cargar los pedidos de péptidos.",
              retry: "Reintentar",
            },
          },
          profile: {
            unsavedChanges: {
              title: "Cambios sin guardar",
              message: "Tiene cambios sin guardar. ¿Desea salir o guardar antes de irse?",
              saveAndClose: "Guardar y cerrar",
              exit: "Salir",
            },
            reviewChanges: {
              title: "Revisa tus cambios",
              subtitle: "Revisa lo que guardarás, o revierte cualquier cosa que no quisieras cambiar.",
              change: "cambio",
              changes: "cambios",
              none: "No quedan cambios por guardar.",
              revert: "Revertir",
              keepEditing: "Seguir editando",
              discardAll: "Descartar todo",
              saveClose: "Guardar y cerrar",
              close: "Cerrar",
            },
            npiVerification: {
              title: "Verifica tu NPI",
              subtitle:
                "Antes de realizar pedidos, verificamos tu NPI con el registro público NPPES para confirmar que eres un clínico autorizado.",
              subtitleRemediate:
                "Tu NPI anterior no pudo verificarse en el registro NPPES. Por favor, vuelve a ingresarlo para continuar.",
              label: "Número de NPI",
              placeholder: "NPI de 10 dígitos",
              verify: "Verificar",
              verifying: "Verificando…",
              success: "NPI verificado correctamente.",
              changeWarning:
                "Cambiar tu NPI eliminará tu estado verificado. Deberás verificarlo nuevamente con NPPES antes de tu próximo pedido.",
              bannerTitle: "Verifica tu NPI",
              bannerBody: "Verifica tu NPI con el registro público NPPES para habilitar los pedidos.",
              bannerFailureTitle: "Verificación de NPI requerida",
              bannerFailureBody:
                "No pudimos verificar tu NPI con el registro NPPES. Por favor, vuelve a ingresarlo antes de realizar pedidos.",
              bannerCta: "Verificar ahora",
              errors: {
                format: "Por favor, ingresa un NPI válido de 10 dígitos.",
                notFound: "No encontramos este NPI en el registro NPPES. Verifica el número.",
                inactive: "Este NPI figura como inactivo en NPPES. Si crees que es un error, contacta a soporte.",
                nameMismatch:
                  "El nombre asociado a este NPI no coincide con el de tu cuenta. Si es un error tipográfico, actualiza tu perfil. Para cambios legales de nombre, contacta a soporte.",
                wrongType: "Esto parece ser un NPI de organización. Por favor, ingresa tu NPI personal (Tipo 1).",
                network: "El servicio de verificación no está disponible. Inténtalo nuevamente.",
                unknown: "La verificación falló. Inténtalo nuevamente.",
              },
            },
            modals: {
              complete: "Completar",
              completeNafTitle: "Completar formulario de nueva cuenta",
              enterPinToComplete: "Ingrese su PIN para completar",
              enterPinToSign: "Ingrese su PIN para firmar",
              sign: "Firmar",
              signAchAuthTitle: "Firmar autorización ACH",
              signCreditCardAuthTitle: "Firmar autorización de tarjeta de crédito",
              signPurchaseAgreementTitle: "Firmar contrato de compra",
            },
            ach: {
              accountName: "Nombre de la Cuenta",
              accountNumber: "Numero de Cuenta Bancaria",
              accountType: "Tipo de Cuenta",
              attachVoidedCheck: "Por favor adjunte un cheque anulado a traves de la pestana de Archivos Requeridos.",
              authorizationText:
                "Yo (nosotros) por la presente autorizo(amos) al Vendedor indicado en este formulario a realizar debitos en mi (nuestra) cuenta indicada a continuacion. Yo (nosotros) reconozco(emos) que la originacion de transacciones ACH en mi (nuestra) cuenta debe cumplir con las disposiciones de la ley de EE.UU. La autoridad permanecera en plena vigencia y efecto hasta que la empresa haya recibido notificacion escrita de su terminacion.",
              billingAddress: "Direccion de Facturacion",
              billingCityStateZip: "Ciudad, Estado, Codigo Postal de Facturacion",
              billingName: "Nombre de Facturacion",
              checking: "Corriente",
              emailAddress: "Correo Electronico",
              financialInstitution: "Nombre de la Institucion Financiera (Sucursal)",
              fullLegalName: "Nombre legal completo",
              no: "No",
              recurringPayment: "Pago Recurrente",
              recurringRange: "Rango Recurrente: desde $1.00 Minimo hasta $1,500,000.00 Maximo",
              routingNumber: "Numero de Ruta Bancaria",
              savings: "Ahorros",
              signature: "Firma",
              subtitle: "Acuerdo de Autorizacion para Pagos Directos (Debitos ACH) al Vendedor.",
              title: "Autorizacion ACH",
              yes: "Si",
            },
            advancedTools: {
              actionsHeader: "Acciones",
              addTemplate: "Agregar Plantilla",
              confirmDeleteTemplate: 'Esta seguro de que desea eliminar "{{name}}"?',
              days: "dias",
              deleteTemplate: "Eliminar Plantilla",
              editTemplate: "Editar Plantilla",
              every: "Cada",
              nameHeader: "Nombre",
              other: "Otro",
              reminderTemplates: "Plantillas de Recordatorio",
              repeat: "Repetir",
              save: "Guardar",
              subjectHeader: "Asunto",
              triggerHeader: "Disparador",
            },
            baa: {
              download: "Descargar PDF",
              exporting: "Exportando...",
              gtm: "BAA de GTM",
              lucas: "BAA de Lucas Health",
              meridian: "BAA de Meridian",
              noneSigned: "No se encontraron BAA firmados.",
              shoreline: "BAA de Shoreline",
            },
            creditCard: {
              amex: "AMEX",
              amount: "Monto ($)",
              authorizationText:
                "Autorizo al Vendedor indicado en este formulario a cobrar la tarjeta de credito indicada arriba de acuerdo con los terminos descritos. Esta autorizacion es valida para un (1) uso unicamente.",
              billingAddress: "Direccion de Facturacion",
              billingInformation: "Informacion de Facturacion",
              cardNumber: "Numero de Tarjeta",
              cardType: "Tipo de Tarjeta",
              cardholderName: "Nombre del Titular",
              cardholderSignature: "Firma del Titular",
              cardholderZip: "Codigo Postal del Titular",
              chargeDate: "Fecha de Cobro (MM/DD/AAAA)",
              cityStateZip: "Ciudad, Estado, Codigo Postal",
              creditCardInformation: "Informacion de Tarjeta de Credito",
              cvv: "CVV",
              discover: "Discover",
              email: "Correo Electronico",
              expiration: "Vencimiento (MM/AA)",
              infoMessage:
                "Alternativa opcional al ACH. Sujeta a una tarifa de 3.5% por tarjeta de credito. Esta autorizacion es solo para una transaccion unica.",
              mastercard: "Mastercard",
              otherCard: "Otra",
              paymentDescription: "Descripcion del Pago",
              paymentDetails: "Detalles de Pago",
              phone: "Telefono",
              selectCardType: "Seleccionar Tipo de Tarjeta",
              subtitle: "Autorizacion unica de tarjeta de credito (alternativa opcional al ACH).",
              title: "Autorizacion de Tarjeta de Credito",
              visa: "VISA",
            },
            customNotes: {
              buildNew: "Crear una Nota Personalizada",
              builder: {
                addToNote: "Agregar a la nota",
                added: "Agregado",
                createCustomSection: "Crear Sección Personalizada",
                dropHere: "Arrastra elementos aquí para construir tu nota",
                elements: "Elementos",
                formattingOptions: "Opciones de Formato",
                general: "General",
                includedComponents: "Componentes Incluidos",
                nameRequired: "El nombre de la nota es obligatorio",
                noElements: "Ningún elemento coincide con tu búsqueda.",
                noFormattingOptions:
                  "Este elemento aún no tiene opciones de formato configurables. Opciones adicionales estarán disponibles en una actualización futura.",
                noSettings: "Selecciona un elemento para ver su configuración",
                noteDescription: "Descripción (opcional)",
                noteName: "Nombre de la nota",
                noteNamePlaceholder: "Ingresa el nombre de la nota",
                patientType: "Paciente",
                preview: "Vista Previa de la Nota",
                previewLabel: "Vista Previa",
                previewPlaceholder:
                  "El contenido se generará basándose en el encuentro del paciente y las opciones de formato a continuación.",
                save: "Guardar Nota",
                searchElements: "Buscar elementos...",
                sectionDisabled: "Sección deshabilitada",
                separatorInfo: "Los separadores agregan un divisor visual entre las secciones de la nota.",
                setting: "Entorno",
                settings: "Configuración del Elemento",
                specialty: "Especialidad",
                visitType: "Tipo de visita",
              },
              category: {
                assessmentPlan: "Evaluacion y Plan",
                objective: "Objetivo",
                other: "Otro",
                subjective: "Subjetivo",
              },
              confirmDelete: '¿Estás seguro de que deseas eliminar "{{name}}"?',
              copySuffix: " (Copia)",
              createdByYou: "Creada por ti",
              customBadge: "Personalizado",
              customSection: {
                addField: "Agregar campo",
                category: "Categoría de la sección",
                createTitle: "Crear sección personalizada",
                describe: "Describa lo que desea",
                descriptionPlaceholder: "Describa la información clínica que desea en esta sección...",
                editPrompt: "Editar sección personalizada",
                editTitle: "Editar sección personalizada",
                fieldLabel: "Nombre del campo",
                fieldNormal: "Valor normal / predeterminado",
                inputMode: "Modo de entrada",
                maxFields: "Se alcanzó el máximo de 20 campos.",
                outputFormat: "Formato de salida",
                saveSection: "Guardar sección",
                sectionTitle: "Título de la sección",
                templateFields: "Campos de plantilla",
                templateHint:
                  "Defina campos con sus valores normales/predeterminados. La IA reemplazará los valores predeterminados con datos reales del paciente.",
                templateMinFields: "Agregue al menos un campo con una etiqueta y un valor predeterminado.",
                titlePlaceholder: "ej., Progreso de cicatrización de heridas",
              },
              sectionInstructions: {
                badge: "Instrucciones",
                buttonTitle: "Instrucciones de salida",
                clear: "Borrar",
                editTitle: "Instrucciones de salida",
                helper:
                  "Estas instrucciones refinan cómo la IA redacta esta sección. No pueden cambiar el formato de la nota ni afectar otras secciones.",
                phiWarning:
                  "Las instrucciones se aplican a todos los pacientes que usen esta plantilla. No incluya nombres de pacientes ni otra información que los identifique.",
                placeholder: "ej., Por defecto: 'Todos los hallazgos negativos excepto lo detallado en el HPI'",
                save: "Guardar",
              },
              deleteNote: "Eliminar Nota Personalizada",
              description: "Crea y administra plantillas de notas personalizadas",
              duplicateNameError: 'Ya existe una nota personalizada llamada "{{name}}". Por favor usa un nombre diferente.',
              duplicateNote: "Duplicar",
              editNote: "Editar Nota",
              elementSettings: {
                hpiLengthMode: {
                  label: "Longitud",
                  values: {
                    comprehensive: "Completa",
                    concise: "Concisa",
                  },
                },
                hpiStyleMode: {
                  label: "Estilo",
                  values: {
                    bullets: "Viñetas",
                    paragraph: "Párrafo",
                  },
                },
                mdmLengthMode: {
                  label: "Longitud",
                  values: {
                    comprehensive: "Completa",
                    concise: "Concisa",
                  },
                },
                mdmStyleMode: {
                  label: "Estilo",
                  values: {
                    bullets: "Viñetas",
                    paragraph: "Párrafo",
                  },
                },
                physicalExamLengthMode: {
                  label: "Longitud",
                  values: {
                    comprehensive: "Completa",
                    concise: "Concisa",
                  },
                },
                planOfCareMode: {
                  label: "Longitud",
                  values: {
                    complex: "Basado en problemas",
                    concise: "Conciso",
                  },
                },
                problemListMode: {
                  label: "Formato",
                  values: {
                    numbered: "Numerada",
                    unnumbered: "Sin numerar",
                  },
                },
                rosMode: {
                  label: "Longitud",
                  values: {
                    complex: "Complejo",
                    concise: "Conciso",
                  },
                },
              },
              enterCopyName: "Ingresa un nombre para tu copia personalizada:",
              format: {
                bulletPoints: "Puntos",
                bullets: "Puntos",
                numbered: "Numerado",
                numberedList: "Lista Numerada",
                paragraph: "Parrafo",
                table: "Tabla",
              },
              inputMode: {
                description: "Descripcion",
                templateBuilder: "Constructor de Plantilla",
              },
              myCopySuffix: " (Mi Copia)",
              noMatchingNotes: "Ninguna nota coincide con tu búsqueda.",
              noNotes: "No hay notas personalizadas aún. Haz clic en 'Crear una Nota Personalizada' para comenzar.",
              noteNotFound: "Nota personalizada no encontrada. Es posible que haya sido eliminada.",
              searchNotes: "Buscar notas...",
              sections: "secciones",
              shared: "Compartida",
              title: "Notas Personalizadas",
            },
            dotPhrases: {
              addDotPhrase: "Agregar Frase Rápida",
              cancel: "Cancelar",
              category: "Categoría",
              categoryAP: "A/P",
              categoryAll: "Todas las categorías",
              categoryCustom: "Personalizado",
              categoryHPI: "HPI",
              categoryOrders: "Órdenes",
              categoryPE: "PE",
              categoryProcedures: "Procedimientos",
              categoryROS: "ROS",
              confirmDelete: "¿Estás seguro de que deseas eliminar la frase rápida '{{trigger}}'?",
              content: "Contenido",
              contentRequired: "El contenido es obligatorio",
              delete: "Eliminar",
              deleteDotPhrase: "Eliminar Frase Rápida",
              editDotPhrase: "Editar Frase Rápida",
              information: "Información",
              noAutocompleteMatches: "No hay frases coincidentes",
              noMatchingPhrases: "Ninguna frase coincide con tu búsqueda.",
              noPhrasesFound: "No se encontraron frases rápidas. Haz clic en 'Agregar Frase Rápida' para crear una.",
              outputPreview: "Vista Previa",
              phraseTitle: "Título",
              plan: "Plan",
              planRequired: "El contenido del plan es obligatorio",
              preview: "Vista previa",
              procedureDescription: "Descripción del Procedimiento",
              save: "Guardar",
              search: "Buscar frases...",
              showTitleInOutput: "Mostrar título en el resultado",
              title: "Frases Rápidas",
              titlePlaceholderAP: "Problema a tratar",
              titlePlaceholderGeneral: "HPI - General",
              titleRequired: "El título es obligatorio",
              trigger: "Atajo",
              triggerExists: "Ya existe una frase con este atajo",
              triggerHelp: "Escribe este atajo para insertar la frase (ej. ..hpi)",
              triggerInvalid: "El atajo debe ser solo alfanumérico",
              triggerRequired: "El atajo es obligatorio",
              varDateTimeNow: "Hora actual",
              varDateTimeToday: "Fecha de hoy",
              varEncounterChiefComplaint: "Motivo de consulta",
              varEncounterDiagnosis: "Diagnóstico",
              varGroupDateTime: "Fecha/Hora",
              varGroupEncounter: "Encuentro",
              varGroupPatient: "Paciente",
              varGroupProvider: "Proveedor",
              varGroupVitals: "Signos Vitales",
              varPatientAge: "Edad",
              varPatientDOB: "Fecha de nacimiento",
              varPatientFirstName: "Nombre",
              varPatientLastName: "Apellido",
              varPatientSex: "Sexo",
              varProviderNPI: "NPI del proveedor",
              varProviderName: "Nombre del proveedor",
              varVitalsBP: "Presión arterial",
              varVitalsHR: "Frecuencia cardíaca",
              varVitalsO2: "Saturación O2",
              varVitalsTemp: "Temperatura",
              variables: "Variables",
            },
            edit: {
              address: "Dirección de la práctica",
              availableNotes: "Notas disponibles",
              city: "Ciudad",
              commission: "Tu comisión",
              credentials: "Credenciales",
              dateOfBirth: "Fecha de nacimiento",
              disableOnboarding: "Desactivar incorporación",
              email: "Correo electrónico",
              enableMicrophone: "Habilitar micrófono",
              enableShareConversation: "Habilitar compartir conversación",
              enableVoiceRecognition: "Habilitar reconocimiento de voz",
              firstName: "Nombre",
              lastName: "Apellido",
              location: "Ubicación",
              notInUS: "No en EE. UU.",
              npiNumber: "Número NPI",
              npiComplete: "NPI completo",
              npiPlaceholder: "Ingrese su número NPI de 10 dígitos",
              npiRemaining: "Faltan {{remaining}}",
              phone: "Teléfono",
              practiceState: "Estado de Práctica Principal",
              practiceZip: "Codigo Postal de la Practica",
              practiceZipPlaceholder: "Ingrese el codigo postal de su practica",
              ptanNumber: "Número PTAN",
              ptanPlaceholder: "Ingrese su Numero PTAN (opcional, 6-10 caracteres)",
              roles: "Roles",
              selectState: "Seleccionar estado",
              selectYourState: "Seleccione su estado",
              state: "Estado",
              taxonomyCode: "Código de taxonomía",
              update: "Actualizar",
              userType: "Tipo de usuario",
              zipCode: "Código postal",
            },
            ehr: {
              apiUrl: "URL de API",
              configureEHR: "Configurar Registro Electrónico",
              description:
                "Selecciona el software Registro Electrónico donde copias las notas. La plataforma optimizará el contenido según el Registro Electrónico seleccionado.",
              ehrSoftware: "Registro Electrónico",
              ehrType: "Tipo de Registro Electrónico",
              password: "Contraseña",
              saveConfiguration: "Guardar configuración",
              testConnection: "Probar conexión",
              title: "Integración Registro Electrónico",
              update: "Actualizar",
              username: "Nombre de usuario",
            },
            errorFetching: "Error al obtener el perfil",
            errorUpdating: "Error al actualizar el perfil",
            generation: {
              autoAssignToCreator: "Asignar automáticamente al creador",
              autoGenerateNote: "Generar nota automáticamente",
              autoLock: "Bloquear automáticamente",
              bulletPoints: "Lista de puntos",
              complex: "Complejo",
              comprehensive: "Completo",
              concise: "Conciso",
              generateAfterStop: "Generar después de detener",
              hpi: "HPI",
              length: "Longitud",
              mdm: "Toma de decisiones médicas",
              paragraph: "Párrafo",
              physicalExam: "Examen físico",
              planOfCare: "Plan de cuidado",
              ros: "Revisión de sistemas",
              selectNoteType: "Seleccionar tipo de nota",
              smartNoteGeneration: "Generación de nota inteligente",
              style: "Estilo",
              styleDescription:
                'Selecciona el estilo y la longitud que prefieres para cada elemento. Siempre puedes cambiarlos desde el botón "Personalizar" en la nota.',
              title: "Estilo de nota",
            },
            labels: {
              effectiveDate: "Fecha de vigencia",
              plan: "PLAN",
              printIndividualName: "Nombre impreso del individuo",
              printedName: "Nombre impreso",
              purchaseAgreementAcknowledgment:
                "He leído, comprendido y acepto todos los términos y condiciones de este Acuerdo de Compra.",
              purchaserName: "Nombre del comprador",
              taxpayerIdNumber: "Número de identificación fiscal del comprador",
              trigger: "Disparador",
            },
            codeOrdering: {
              title: "Orden de Códigos",
              orgDescription:
                "Establece el orden inicial para todos en su organización. Es solo un punto de partida, nunca impide que un proveedor reordene sus propias notas.",
              orgDefault: "Predeterminado para todos los miembros",
              saved: "Guardado",
              custom: "Personalizado (cree el suyo)",
              customHelp:
                "Arrastre los tipos de código a la prioridad que prefiera su organización. Esto define el orden inicial; los proveedores aún pueden reordenar sus propias notas.",
              resultPreview: "Vista previa del resultado",
              vsDefault: "Cambios respecto al predeterminado de pago por servicio:",
            },
            menu: {
              advancedTools: "Herramientas avanzadas",
              baa: "BAA",
              billing: "Acreditación",
              credentialedDmes: "DMEs acreditados",
              customNotes: "Notas Personalizadas",
              codeOrdering: "Orden de Códigos",
              dmeNotifications: "Notificaciones de pedidos",
              documentationSettings: "Configuración de Documentación",
              dotPhrases: "Frases Rápidas",
              ehrIntegration: "Integración Registro Electrónico",
              inboundNotifications: "Notificaciones Entrantes",
              kpiDashboard: "Panel de KPI",
              manageQCodes: "Administrar códigos Q",
              manageSmartSheet: "Administrar QA Assistant",
              manageSmartSheetHealcore: "Administrar CoreGrid",
              newAccountForm: "Formulario de Nueva Cuenta",
              formEditor: "Editor de formularios",
              nafAdminOverride: {
                button: "Habilitar (admin)",
                saving: "Activando…",
                confirm:
                  "Esto activará la línea de productos DME para esta organización, desbloqueando el New Account Form y otras funciones de DME. ¿Continuar?",
                title: "Habilitación manual (admin) — activar NAF para esta organización",
              },
              baaSigned: "BAA firmado",
              termsOfUseSigned: "Términos de uso firmados",
              noteStyle: "Estilo de nota",
              notesSettings: "Configuración de notas",
              orgSecurity: "Configuracion de seguridad",
              organizationInfo: "Informacion de la organizacion",
              practiceInfo: "Informacion de la practica",
              preferences: "Preferencias",
              productLines: "Líneas de Productos",
              profile: "Perfil",
              requiredDocuments: "Documentos Requeridos",
              security: "Seguridad",
              terminologyLibrary: "Biblioteca de Terminología",
              icd10Library: "Biblioteca de Códigos ICD-10",
              termsOfUse: "Términos de uso",
              uberDirect: "Uber Direct",
              refillSettings: "Configuración de reabastecimiento",
              language: "Idioma",
              shippingAddress: "Dirección de envío",
              healthProfile: "Perfil clínico",
              manageRefills: "Gestionar reabastecimientos",
              peptideNotifications: "Configuración de notificaciones",
              signAchAuthTitle: "Firmar autorización ACH",
              signCreditCardAuthTitle: "Firmar autorización de tarjeta de crédito",
              signDocumentTitle: "Firmar documento",
              signPurchaseAgreementTitle: "Firmar acuerdo de compra",
            },
            manageRefills: {
              title: "Gestionar reabastecimientos",
              description:
                "Consulta y gestiona tus reabastecimientos automáticos aquí. Esta sección está en construcción — por ahora, solicita un reabastecimiento desde tu panel de péptidos.",
            },
            naf: {
              autosaving: "Cambios guardados automáticamente",
              clickToSign: "Haga clic para firmar",
              complete: "Completar",
              completedBy: "Completado por {{name}} el {{date}}",
              continueToDocument: "Continuar al Documento",
              downloadDisabledTip: "Complete todos los campos obligatorios y firmas antes de descargar el PDF.",
              doc: {
                pageOneHandled:
                  "La página 1 se completa en la vista de Formulario. Revise y firme las secciones legales a continuación.",
                pagesHandled:
                  "Las páginas 1–3 se completan en la vista de Formulario. Revise y firme las secciones legales a continuación.",
              },
              downloadPdf: "Descargar PDF",
              eSignedOn: "FIRMADO ELECTRÓNICAMENTE {{date}}",
              electronicallySignedBy: "Firmado electronicamente por {{name}}",
              emptyContent: "Este formulario no tiene contenido para mostrar.",
              notConfigured: "Aún no se ha configurado un Formulario de Nueva Cuenta para su organización.",
              loadingForm: "Cargando formulario...",
              pageOf: "Pagina {{page}} de {{total}}",
              reopen: "Editar",
              sectionsComplete: "secciones completas",
              title: "Formulario de Nueva Cuenta",
              view: {
                document: "Documento",
                form: "Formulario",
              },
              contract: {
                back: "Volver a contratos",
                submit: "Enviar y Firmar",
                submitting: "Enviando…",
                signedBanner: "Enviado {{date}}",
              },
            },
            newnote: {
              description: "Agregamos nuevas plantillas de notas. Selecciona las que deseas habilitar o déjalas deshabilitadas.",
              errorUpdating: "No se pudieron actualizar las preferencias de notas",
              keepCurrentNotes: "Mantener selecciones de notas actuales",
              save: "Guardar",
              saving: "Guardando...",
              selectAllNotes: "Seleccionar todas las notas",
              title: "Nuevas notas disponibles",
            },
            notes: {
              availableNotes: "Notas disponibles",
              confirmDelete: "¿Estás seguro de que deseas eliminar esta nota?",
              defaultImportNote: "Nota de importación predeterminada",
              defaultNewNote: "Nota nueva predeterminada",
              deleteNote: "Eliminar nota",
              description: "Descripción",
              doctorType: "Tipo de doctor",
              editNote: "Editar nota",
              enable: "Habilitar",
              newNote: "Nueva nota",
              noteType: "Tipo de nota",
              selectAllNotes: "Seleccionar todas las notas",
              title: "Configuración de notas",
              type: "Tipo",
            },
            notifications: {
              description:
                "Configure las notificaciones por correo electrónico para los cambios de estado de los pedidos. Cuando esté habilitado, la dirección de correo electrónico especificada recibirá una notificación cada vez que un pedido alcance el estado seleccionado.",
              emailLabel: "Correo electrónico",
              emailPlaceholder: "Ingrese la dirección de correo electrónico",
              messageDraft: "Se ha creado una nueva orden y actualmente esta esperando revision en borrador.",
              messageNewAttachment:
                "Se ha subido un nuevo archivo adjunto a la orden {{orderId}}. Velo en la pestana de Adjuntos de la orden.",
              messageNewComment:
                "El proveedor ha agregado un nuevo comentario a la orden {{orderId}}. Velo en la pestaña de Comentarios de la orden.",
              messageProviderArchive:
                "La orden {{orderId}} ha sido archivada por el proveedor. Estado al momento del archivo: {{orderStatus}}.",
              messageQrDelivery: "Se ha completado y firmado por el paciente una prueba de entrega con codigo QR.",
              messageStatusUpdate: "El estado de una orden ha sido actualizado.",
              sectionTitle: "Notificaciones Entrantes",
              statusDraft: 'Nuevo Pedido en "Borrador"',
              statusNewAttachment: "Nuevo Adjunto",
              statusNewComment: "Nuevo Comentario",
              statusProviderArchive: "Archivo del Proveedor",
              statusQrDelivery: "Código QR - Prueba de Entrega",
              statusUpdate: "Actualización de Estado",
              subjectDraft: "Nueva Orden en Borrador",
              subjectLabel: "Asunto",
              subjectNewAttachment: "Nuevo Archivo Adjunto Subido",
              subjectNewComment: "Nuevo Comentario Agregado",
              subjectProviderArchive: "Orden Archivada por Proveedor",
              subjectQrDelivery: "Prueba de Entrega Completada",
              subjectStatusUpdate: "Estado de Orden Actualizado",
              updated: "Configuración de notificaciones actualizada",
            },
            orgSecurity: {
              description: "Estas configuraciones se aplican a todos los usuarios de la organizacion.",
              sectionTitle: "Valores predeterminados de seguridad de la organizacion",
              setByOrg: "(Establecido por la organizacion)",
            },
            pickup: {
              locationNamePlaceholder: "ej. Farmacia de Compuestos Miami",
            },
            pleaseInsertZipcode: "Por favor ingresa el código postal",
            preferences: {
              applicationLanguage: "Idioma de la aplicación",
              arabic: "Árabe",
              cantoneseTraditional: "Cantonés (Tradicional)",
              celsius: "Celsius",
              chineseSimplified: "Chino (Simplificado)",
              chineseTraditional: "Chino (Tradicional)",
              cm: "cm",
              dontAskLocation: "No preguntar por ubicación",
              english: "Inglés",
              englishOnly: "Solo inglés",
              fahrenheit: "Fahrenheit",
              french: "Francés",
              german: "Alemán",
              heightUnit: "Unidad de altura",
              hideUnavailableSections: "Ocultar secciones no disponibles",
              inches: "pulgadas",
              kg: "kg",
              korean: "Coreano",
              lbs: "lbs (libras)",
              multiLanguage: "Multilingüe",
              noteLanguage: "Idioma de nota",
              offlineMode: "Modo sin conexión",
              offlineModeDescription:
                "Utiliza transcripción en el dispositivo para la aplicación móvil. Es posible que se omitan algunos términos médicos/técnicos",
              sendToEHRAsDefault: "Enviar al Registro Electrónico por defecto",
              spanglish: "Inglés/español (Spanglish)",
              spanish: "Español",
              spanishOnly: "Solo español",
              temperatureUnit: "Unidad de temperatura",
              theme: "Apariencia",
              themeDark: "Oscuro",
              themeLight: "Claro",
              themeSystem: "Sistema",
              transcriptionLanguage: "Idioma de transcripción",
              weightUnit: "Unidad de peso",
            },
            pricing: {
              accountNumber: "Numero de Cuenta",
              achWirePayments: "Pagos ACH/Transferencia",
              bank: "Banco",
              bankAddress: "Direccion del Banco",
              checkPayments: "Pagos con Cheque",
              cmsFee: "Tarifa CMS 2026",
              company: "Empresa",
              hcpcs: "HCPCS",
              mailTo: "Enviar a",
              paymentInstructions: "Instrucciones de Pago",
              pricePerUnit: "Precio por Unidad",
              primaryDressings: "Apositos Primarios",
              product: "Producto",
              routingNumber: "Numero de Ruta",
              secondaryDressings: "Apositos Secundarios",
              subtitle:
                "Precios de referencia para los productos de colageno de su organizacion. Esta informacion se proporciona solo como referencia.",
              title: "Productos, Precios y Programa de Tarifas",
            },
            profileUpdated: "Perfil actualizado",
            psa: {
              notConfigured: "Aún no se ha configurado un Acuerdo de Servicio de Productos para su organización.",
            },
            purchaseAgreement: {
              signature: "Firma",
              title: "Acuerdo de Compra",
            },
            qcodes: {
              actions: "Acciones",
              addQCode: "Agregar código Q",
              cancel: "Cancelar",
              code: "Código Q",
              confirmDelete: "¿Estás seguro de que deseas eliminar el código Q '{{code}}'?",
              deleteQCode: "Eliminar código Q",
              editQCode: "Editar código Q",
              name: "Nombre",
              price: "Precio",
              pricePerSqCm: "Precio por cm cuadrado",
              productName: "Nombre del producto",
              qCodeAlreadyPresent: "Código Q ya existe",
              save: "Guardar",
              title: "Administrar tus códigos Q",
            },
            requiredFiles: {
              complete: "Completo",
              completion: "Completado",
              completionCount: "{{completed}} de {{total}} archivos requeridos",
              description:
                "Rastree y suba documentos requeridos para la configuracion de su nueva cuenta. Los archivos marcados como requeridos deben completarse antes de que su cuenta este completamente incorporada.",
              missing: "Faltante",
              preview: "Vista Previa",
              remove: "Eliminar",
              replace: "Reemplazar",
              shippingAddressList: "Lista de Direcciones de Envio",
              shippingAddressListDesc: "Todas las direcciones de envio para la entidad cubierta por BAA",
              signBaaHint: "Firme el BAA a traves de la seccion BAA en Configuracion.",
              signPurchaseAgreementHint: "Firme el Acuerdo de Compra en la seccion de Acuerdo de Compra.",
              signedBAA: "BAA Firmado",
              signedBAADesc: "Acuerdo de Asociado Comercial",
              signedPurchaseAgreement: "Acuerdo de Compra Firmado",
              signedPurchaseAgreementDesc: "Acuerdo de Compra firmado",
              title: "Archivos Requeridos",
              upload: "Subir",
              uploaded: "Subido",
              uploadedOn: "Subido el {{date}}",
              voidedCheck: "Cheque Anulado",
              voidedCheckDesc: "Requerido para autorizacion ACH",
              w9Form: "Formulario W-9",
              w9FormDesc: "Formulario de identificacion fiscal",
            },
            security: {
              after15Days: "Después de 15 días",
              after1Year: "Después de 1 año",
              after30Days: "Después de 30 días",
              after5Years: "Después de 5 años",
              after7Years: "Después de 7 años",
              autoDeleteLockedNotes: "Eliminar automáticamente notas bloqueadas después de",
              autoDeleteTranscript: "Eliminar automáticamente la transcripción después de firmar",
              cancel: "Cancelar",
              change: "Cambiar",
              changePassword: "Cambiar contraseña",
              changePin: "Cambiar PIN",
              changePinTitle: "Cambiar PIN",
              confirmPassword: "Confirmar contraseña",
              confirmPasswordPlaceholder: "Confirmar contraseña",
              currentPassword: "Contraseña actual",
              currentPasswordPlaceholder: "Contraseña actual",
              currentPin: "PIN actual de 4 dígitos",
              disable2FA: "Desactivar 2FA",
              email: "Correo electrónico",
              enable2FA: "Habilitar 2FA",
              enterCurrentPassword: "Por favor ingresa tu contraseña actual",
              enterCurrentPasswordPrompt: "Ingresa tu contraseña actual para continuar.",
              enterCurrentPin: "Por favor ingresa tu PIN actual de 4 dígitos",
              enterCurrentPinPrompt: "Ingresa tu código PIN actual de 4 dígitos para continuar.",
              enterNewPinPrompt: "Ingresa el nuevo código PIN de 4 dígitos para bloquear el encuentro y archivarlo.",
              errorChangingPassword: "Error al cambiar la contraseña",
              errorChangingPin: "Error al cambiar PIN",
              errorSendingLoginLink: "Error al enviar enlace de inicio de sesión",
              errorSendingResetLink: "Error al enviar enlace de restablecimiento",
              forgotPassword: "¿Olvidaste tu contraseña?",
              forgotPin: "¿Olvidaste tu PIN?",
              hide: "Ocultar",
              incorrectPassword: "Contraseña incorrecta",
              incorrectPin: "PIN incorrecto",
              loginLinkSent: "Enlace de inicio de sesión enviado correctamente",
              never: "Nunca",
              newPassword: "Nueva contraseña",
              newPasswordPlaceholder: "Nueva contraseña",
              newPin: "Nuevo PIN de 4 dígitos",
              no: "No",
              notesInTrash: "Las notas en la papelera se eliminarán permanentemente después de",
              passwordChangedSuccessfully: "Contraseña cambiada correctamente",
              passwordDoesNotMatch: "La contraseña no coincide",
              passwordResetEmailSent: "Correo de restablecimiento de contraseña enviado. Por favor revisa tu bandeja de entrada.",
              passwordUpdated: "Contraseña actualizada",
              passwordsDoNotMatch: "Las contraseñas no coinciden",
              pinSetSuccessfully: "PIN establecido correctamente",
              pinUpdated: "PIN actualizado",
              pleaseVerifyCurrentPin: "Por favor verifica tu PIN actual primero.",
              resetPassword: "Restablecer contraseña",
              resetPasswordLinkSent: "Enlace de restablecimiento de contraseña enviado correctamente",
              save: "Guardar",
              sendLoginCodeBy: "Enviar código de inicio de sesión por",
              sendLoginLink: "Enviar enlace de inicio de sesión",
              sending: "Enviando...",
              show: "Mostrar",
              sms: "SMS",
              title: "Seguridad",
              twoFactorAuth: "Autenticación de dos factores",
              unableSendPasswordReset:
                "No se pudo enviar el correo de restablecimiento de contraseña. Por favor intenta de nuevo.",
              unableToVerifyPassword: "No se pudo verificar tu contraseña. Por favor intenta de nuevo.",
              verify: "Verificar",
              verifyCurrentPin: "Verificar PIN actual",
              verifyPassword: "Verificar contraseña",
              verifyWithPassword: "Verificar con contraseña",
              verifying: "Verificando...",
              yes: "Sí",
            },
            signWithPin: "Firmar con PIN",
            signedByOn: "Firmado por {{name}} el {{date}}",
            smartsheet: {
              actions: "Acciones",
              addColumn: "Agregar columna",
              cancel: "Cancelar",
              columnAlreadyPresent: "Columna ya existe",
              columnName: "Nombre de columna",
              columnType: "Tipo de columna",
              confirmDelete: "¿Estás seguro de que deseas eliminar la columna '{{id}}'?",
              currency: "Moneda",
              date: "Fecha",
              dateTime: "Fecha y hora",
              deleteColumn: "Eliminar columna",
              editColumn: "Editar columna",
              id: "Id",
              label: "Etiqueta",
              number: "Número",
              save: "Guardar",
              text: "Texto",
              textarea: "Área de texto",
              title: "Administrar QA Assistant",
              titleHealcore: "Administrar CoreGrid",
              type: "Tipo",
            },
            terminologyLibrary: {
              actionsColumn: "Acciones",
              addTerm: "Agregar Término",
              addTermToLibrary: "Agregar Término a {{library}}",
              autoBadge: "Auto",
              brandColumn: "Marca",
              categoryColumn: "Categoría",
              dateColumn: "Fecha de Adición",
              description:
                "Active las bibliotecas de terminología médica para la revisión ortográfica. Las bibliotecas que coinciden con su especialidad se seleccionan automáticamente.",
              lockedGenericHint: "Siempre activa para todos los profesionales",
              detailColumn: "Detalle",
              duplicateTerm: "Este término ya existe en la biblioteca",
              emptyLibrary:
                "No hay términos en esta biblioteca aún. Los términos se agregarán con la biblioteca de revisión ortográfica, o puede agregar términos personalizados arriba.",
              expansionColumn: "Expansión",
              filterAbbreviations: "Abreviaturas",
              filterAll: "Todos",
              filterMedications: "Medicamentos",
              genericTitle: "Bibliotecas Genéricas",
              lib: {
                abbreviations: "Abreviaturas Médicas",
                allergyImmunology: "Alergia e Inmunología",
                anatomy: "Anatomía",
                behavioral: "Salud Conductual",
                cardiology: "Cardiología",
                chiropractic: "Quiropráctica",
                dentistry: "Odontología",
                dermatology: "Dermatología",
                emergencyMedicine: "Medicina de Emergencia",
                endocrinology: "Endocrinología",
                gastroenterology: "Gastroenterología",
                generalMedical: "Medicina General",
                generalSurgery: "Cirugía General",
                homeHealth: "Salud en el Hogar",
                hospitalistMedicine: "Medicina Hospitalaria",
                infectiousDiseases: "Enfermedades Infecciosas",
                nephrology: "Nefrología",
                neuroOrthoSpine: "Neuro/Ortho Columna",
                neurology: "Neurología",
                obgyn: "Ginecología/Obstetricia",
                oncology: "Oncología Médica",
                orthopedics: "Ortopedia",
                otolaryngology: "Otorrinolaringología",
                painManagement: "Manejo del Dolor",
                paramedics: "Paramédicos / SEM",
                pediatrics: "Pediatría",
                peptides: "Péptidos",
                pharmacology: "Farmacología General",
                physicalTherapy: "Fisioterapia",
                podiatry: "Podología",
                primaryCare: "Atención Primaria",
                pulmonology: "Neumología",
                radiationOncology: "Radio-Oncología",
                rheumatology: "Reumatología",
                urology: "Urología",
                woundCare: "Cuidado de Heridas",
              },
              libDesc: {
                abbreviations: "Abreviaturas y acrónimos médicos estándar",
                allergyImmunology: "Términos de alergia, inmunoterapia e hipersensibilidad",
                anatomy: "Estructuras anatómicas y términos de sistemas corporales",
                behavioral: "Terminología de salud psiquiátrica y conductual",
                cardiology: "Procedimientos cardíacos, diagnósticos y farmacología",
                chiropractic: "Ajustes quiroprácticos, técnicas y términos musculoesqueléticos",
                dentistry: "Procedimientos dentales y términos de salud oral",
                dermatology: "Condiciones cutáneas, procedimientos y agentes dermatológicos",
                emergencyMedicine: "Terminología de emergencia y cuidado agudo",
                endocrinology: "Trastornos endocrinos, hormonas y términos metabólicos",
                gastroenterology: "Procedimientos GI, condiciones y diagnósticos",
                generalMedical: "Términos médicos comunes usados en todas las especialidades",
                generalSurgery: "Procedimientos quirúrgicos y términos perioperatorios",
                homeHealth: "Evaluaciones de salud en el hogar y terminología de cuidado",
                hospitalistMedicine: "Medicina hospitalaria y términos de cuidado del paciente",
                infectiousDiseases: "Agentes infecciosos, antimicrobianos y diagnósticos",
                nephrology: "Condiciones renales, diálisis y términos nefrológicos",
                neuroOrthoSpine: "Cirugía de columna y términos neuro-ortopédicos",
                neurology: "Condiciones neurológicas, diagnósticos y procedimientos",
                obgyn: "Terminología obstétrica y ginecológica",
                oncology: "Quimioterapia, inmunoterapia, terapia dirigida y términos de oncología de soporte",
                orthopedics: "Condiciones musculoesqueléticas y procedimientos ortopédicos",
                otolaryngology: "Condiciones, procedimientos y diagnósticos de ORL",
                painManagement: "Procedimientos y farmacología de manejo del dolor",
                paramedics: "Terminología de SEM, pre-hospitalaria y paramédicos",
                pediatrics: "Condiciones pediátricas y términos del desarrollo",
                peptides: "Terapias peptídicas, agonistas GLP-1 y compuestos bioactivos",
                pharmacology: "Medicamentos comunes que todo clínico receta",
                physicalTherapy: "Terminología de rehabilitación y fisioterapia",
                podiatry: "Condiciones podológicas y procedimientos de pie/tobillo",
                primaryCare: "Práctica general y terminología de atención primaria",
                pulmonology: "Condiciones pulmonares, ventilación y términos respiratorios",
                radiationOncology: "Términos de radioterapia y oncología",
                rheumatology: "Términos de reumatología, autoinmunidad y artritis inflamatoria",
                urology: "Condiciones y procedimientos urológicos",
                woundCare: "Productos, evaluaciones y tratamientos de cuidado de heridas",
              },
              libraryTerms: "Términos de la Biblioteca",
              noTermsYet: "Sin términos aún",
              sectionTitle: "Biblioteca de Terminología",
              specialtyTitle: "Bibliotecas de Especialidad",
              termColumn: "Término",
              termCount: "{{count}} término(s) personalizado(s)",
              termLabel: "Término",
              termPlaceholder: "Ingrese término médico",
              updated: "Biblioteca de terminología actualizada",
              saveFailed: "No se pudieron guardar los cambios, se revirtieron. Intenta de nuevo.",
              filter: "Filtrar",
            },
            icd10Library: {
              sectionTitle: "Biblioteca de Códigos ICD-10",
              description:
                "Sus códigos ICD-10 preferidos reemplazan los códigos que genera LucasAI en las notas y la sincronización con el EHR.",
              addCode: "Agregar Código",
              save: "Guardar",
              sourceColumn: "Código de Origen",
              preferredColumn: "Código Preferido",
              preferredDescColumn: "Descripción Preferida",
              descriptionColumn: "Descripción",
              enabledColumn: "Activo",
              actionsColumn: "Acciones",
              codeRequired: "Se requiere un código preferido",
              purposeNote:
                "Use esta biblioteca para el mantenimiento del conjunto de códigos: actualizaciones de descriptores, revisiones anuales de ICD-10-CM y migraciones de códigos equivalentes. No cambia lo que es clínicamente cierto. Cada cambio se muestra al clínico en la nota con reversión de un clic, y la nota debe respaldar el código final.",
              clinicalSwapConfirm:
                "Cambiar {{source}} por {{target}} modifica el significado clínico (otra familia de condición o mayor severidad). Se marcará a los clínicos en cada nota que toque, con reversión de un clic, y la documentación de cada paciente debe respaldarlo. ¿Crear este cambio?",
              duplicateSource: "Otra entrada ya reasigna este código de origen",
              emptyLibrary: "Aún no hay códigos personalizados. Agregue uno para comenzar.",
              updated: "Biblioteca ICD-10 actualizada",
              seedNote:
                "Pre-cargado con {{count}} códigos de los encuentros de su práctica. Haga clic en Actualizar para guardar.",
              loading: "Cargando los códigos que usa su práctica…",
              filterPlaceholder: "Filtrar códigos…",
              importError: "No se pudieron cargar sus códigos usados. Aún puede agregar códigos manualmente.",
              codeCount: "{{count}} códigos",
              showAll: "Mostrar los {{count}} códigos",
              unsaved: "Cambios sin guardar",
              allChapter: "Todos",
              changedChip: "Modificados",
              changedHint: "Muestre solo los códigos que cambió, para ajustarlos o restablecerlos rápidamente",
              swapHint: "Elegir un código diferente",
              resetAll: "Restablecer todo al estándar",
              resetAllHint: "Reconstruir la biblioteca con los códigos indexados estándar de su práctica",
              resetAllConfirm:
                "¿Reemplazar toda la biblioteca con los códigos indexados estándar de su práctica? Se eliminarán todos los cambios de código. Nada se guarda hasta que presione Actualizar.",
              resetRowHint: "Restablecer al código estándar",
              chapters: {
                infectious: "Infecciosas",
                neoplasms: "Neoplasias",
                blood: "Sangre",
                endocrine: "Endocrino y metabólico",
                mental: "Salud mental",
                nervous: "Sistema nervioso",
                eye: "Ojo",
                ear: "Oído",
                circulatory: "Circulatorio",
                respiratory: "Respiratorio",
                digestive: "Digestivo",
                skin: "Piel",
                musculoskeletal: "Musculoesquelético",
                genitourinary: "Genitourinario",
                pregnancy: "Embarazo",
                perinatal: "Perinatal",
                congenital: "Congénitas",
                symptoms: "Síntomas y hallazgos",
                injury: "Lesiones e intoxicaciones",
                special: "Códigos especiales",
                external: "Causas externas",
                zcodes: "Factores de salud (Z)",
                other: "Otros",
              },
            },
            title: "Editar perfil",
            shippingAddress: {
              street: "Dirección",
              streetPlaceholder: "Calle 123 # 4-56",
              apt: "Apartamento / unidad (opcional)",
              aptPlaceholder: "Apt. 4B",
              city: "Ciudad",
              state: "Estado",
              statePlaceholder: "Selecciona tu estado",
              zip: "Código postal",
              zipPlaceholder: "Código postal de 5 dígitos",
            },
            toasts: {
              achAuthorizationSaved: "Autorización ACH guardada",
              achAuthorizationSigned: "Autorización ACH firmada",
              acknowledgeBeforeSigning: "Por favor acepte el acuerdo antes de firmar",
              allRequiredFieldsCompleted: "Todos los campos obligatorios completados. Ya puede completar el formulario.",
              completeFailed: "Error al completar. Por favor intente de nuevo.",
              creditCardAuthorizationSaved: "Autorización de tarjeta de crédito guardada",
              creditCardAuthorizationSigned: "Autorización de tarjeta de crédito firmada",
              emailSubjectRequired: "El asunto del correo es obligatorio",
              enterPrintedNameBeforeSigning: "Por favor ingrese el nombre impreso antes de firmar",
              fileRemoveFailed: "Error al eliminar el archivo",
              fileRemoved: "Archivo eliminado",
              fileUploadFailed: "Error al subir el archivo. Por favor intente de nuevo.",
              fileUploadedSuccessfully: "{{fileName}} subido exitosamente",
              messageBodyRequired: "El cuerpo del mensaje es obligatorio",
              nafCompletedAndLocked: "Formulario de nueva cuenta completado y bloqueado",
              orgInfoUpdateFailed: "Error al actualizar la información de la organización. Por favor intente de nuevo.",
              orgInfoUpdated: "Información de la organización actualizada",
              shippingAddressUpdated: "Dirección de envío actualizada",
              shippingAddressUpdateFailed: "No se pudo guardar la dirección de envío",
              pdfExportError: "Error al exportar el PDF",
              pdfGenerationFailed: "Error al generar el PDF. Por favor intente de nuevo.",
              formTemplateUnavailable: "Aún no se ha configurado la plantilla de este formulario para su organización.",
              pleaseCompleteSections: "Por favor complete: {{sections}}",
              purchaseAgreementSigned: "Acuerdo de compra firmado",
              saveFailed: "Error al guardar. Por favor intente de nuevo.",
              signFailed: "Error al firmar. Por favor intente de nuevo.",
              signedSuccessfully: "Firmado exitosamente",
              templateCreateFailed: "Error al crear la plantilla",
              templateCreated: "Plantilla creada",
              templateDeleteFailed: "Error al eliminar la plantilla",
              templateDeleted: "Plantilla eliminada",
              templateNameRequired: "El nombre de la plantilla es obligatorio",
              templateUpdateFailed: "Error al actualizar la plantilla",
              templateUpdated: "Plantilla actualizada",
            },
            welcomeMessage: {
              addNew: "Agregar nuevo",
              content: "Contenido",
              customMessage: "Mensaje personalizado",
              modalTitle: "Mensaje de bienvenida",
              name: "Nombre",
              namePlaceholder: "Ingrese el nombre del mensaje",
              noMessages: "No hay mensajes de bienvenida configurados",
              sectionTitle: "Mensajes de bienvenida por correo",
              selectTemplate: "Usar plantilla",
            },
            orgInfo: {
              officeCountry: "País de la oficina",
              officeName: "Nombre de la oficina",
              legalName: "Nombre legal",
              officePhone: "Teléfono de la oficina",
              officeEmail: "Correo electrónico de la oficina",
              officeAddress: "Dirección de la oficina",
              officeCity: "Ciudad de la oficina",
              officeState: "Estado de la oficina",
              officeZip: "Código postal de la oficina",
            },
            kpiDashboard: {
              add: "Agregar",
              addCustom: "Agregar KPI personalizado",
              allNotes: "Todas",
              assigned: "Asignado",
              assignedKpis: "KPIs asignados",
              clearAll: "Borrar todo",
              clinical: "Clínico",
              createCustom: "Crear KPI personalizado",
              custom: "Personalizado",
              kpiDefinition: "Definición del KPI",
              kpiDescLabel: "Descripción",
              kpiName: "Nombre del KPI",
              kpiTitleLabel: "Título",
              kpis: {
                c1: {
                  definition: "% de pacientes con PA < 140/90 mmHg en la última visita",
                  name: "Control de presión arterial",
                },
                c2: {
                  definition: "% de pacientes diabéticos con HbA1c < 7%",
                  name: "Manejo de HbA1c",
                },
                c3: {
                  definition: "% de pacientes evaluados con PHQ-9 anualmente",
                  name: "Detección de depresión",
                },
                c4: {
                  definition: "% de visitas con reconciliación de medicamentos completada",
                  name: "Reconciliación de medicamentos",
                },
                c5: {
                  definition: "% de pacientes con IMC registrado en los últimos 12 meses",
                  name: "Documentación de IMC",
                },
                c6: {
                  definition: "% de pacientes cardíacos con perfil lipídico anual",
                  name: "Monitoreo de perfil lipídico",
                },
                c7: {
                  definition: "% de mujeres elegibles con mamografía en los últimos 2 años",
                  name: "Tamizaje de mamografía",
                },
                c8: {
                  definition: "% de pacientes de 65+ con evaluación de riesgo de caídas documentada",
                  name: "Evaluación de riesgo de caídas",
                },
                c9: {
                  definition: "% de pacientes con ERC con eGFR evaluado semestralmente",
                  name: "Monitoreo de función renal",
                },
                c10: {
                  definition: "% de pacientes con EPOC con espirometría anual",
                  name: "Pruebas de función pulmonar",
                },
                c11: {
                  definition: "% de pacientes al día con las vacunas recomendadas",
                  name: "Tasa de vacunación",
                },
                c12: {
                  definition: "% de pacientes entre 45 y 75 años con tamizaje de cáncer colorrectal",
                  name: "Tamizaje de colonoscopia",
                },
                c13: {
                  definition: "% de pacientes embarazadas que completan todas las visitas prenatales programadas",
                  name: "Cumplimiento de visitas prenatales",
                },
                c14: {
                  definition: "% de pacientes con insuficiencia cardíaca con ecocardiograma anual",
                  name: "Seguimiento con ecocardiograma",
                },
                c15: {
                  definition: "% de pacientes con 5+ medicamentos con revisión anual",
                  name: "Revisión de polifarmacia",
                },
                r1: {
                  definition: "Media de unidades de valor relativo generadas por encuentro con el paciente",
                  name: "RVU promedio por visita",
                },
                r2: {
                  definition: "% de servicios prestados que se facturan exitosamente",
                  name: "Tasa de captura de cargos",
                },
                r3: {
                  definition: "% de reclamaciones enviadas que son denegadas por los pagadores",
                  name: "Tasa de denegación de reclamaciones",
                },
                r4: {
                  definition: "Promedio de días desde el servicio hasta la recepción del pago",
                  name: "Días en cuentas por cobrar",
                },
                r5: {
                  definition: "% de citas programadas a las que el paciente no asistió",
                  name: "Tasa de inasistencia del paciente",
                },
                r6: {
                  definition: "Número de nuevos pacientes atendidos por mes",
                  name: "Adquisición de nuevos pacientes",
                },
                r7: {
                  definition: "% de cargos facturados cobrados exitosamente",
                  name: "Tasa de cobro",
                },
                r8: {
                  definition: "% de pacientes de Medicare elegibles con Visita Anual de Bienestar completada",
                  name: "Tasa de finalización de AWV",
                },
              },
              noKpis: "No hay KPIs asignados a este tipo de nota",
              noResults: "Ningún KPI coincide con tu búsqueda",
              noteTypes: "Tipos de nota",
              removeFromAll: "De todos los tipos de nota",
              removeFromSelected: "Solo del tipo de nota seleccionado",
              removeKpi: "Eliminar KPI",
              removeMessage: "¿De dónde desea eliminar este KPI?",
              revenue: "Ingresos",
              save: "Guardar",
              saveError: "Error al guardar la configuración de KPI",
              saved: "Configuración de KPI guardada",
              searchKpis: "Buscar KPIs...",
              selected: "Seleccionados",
              specialties: {
                cardiology: "Cardiología",
                endocrine: "Endocrinología",
                geriatrics: "Geriatría",
                medicationSafety: "Medicación/Seguridad",
                nephrology: "Nefrología",
                obgyn: "Ginecobstetricia",
                primaryCare: "Atención primaria",
                pulmonology: "Neumología",
              },
              specialtyLabel: "Especialidad",
              subtitle: "Administre los indicadores clave de rendimiento por tipo de nota",
              title: "Panel de KPI",
            },
          },
          qcode: {
            pleaseEnterArea: "Por favor ingresa un área",
            pleaseSelectCode: "Por favor selecciona un código",
          },
          reportCard: {
            errorGenerating: "Error al generar el reporte",
            title: "Reporte para {{section}}",
          },
          admin: {
            templates: {
              title: "Editor de formularios",
              subtitle:
                "Edita el Formulario de Nueva Cuenta, los documentos legales y las tablas de precios que ven tus proveedores.",
              comingSoon: "Próximamente",
              tabs: {
                naf: "Formulario de Nueva Cuenta",
                legal: "Plantillas legales",
                pricing: "Tablas de precios",
                history: "Versiones y auditoría",
              },
              legal: {
                baa: "Acuerdo de Asociado Comercial",
                pa: "Acuerdo de Compra",
                tou: "Términos de uso",
                variantLabel: "Variante:",
                own: "Su organización",
                ownBaa: "Acuerdo de Asociado Comercial (su organización)",
                variant: {
                  lucas: "Lucas Health Corp",
                  own: "Su organización",
                },
                simulating: "Simulando:",
                simulatingActive: "SIMULANDO — solo vista",
                persona: {
                  current: "Usuario actual",
                  lucas: "Admin de Lucas",
                },
              },
              rte: {
                placeholder: "Empieza a escribir tu documento...",
                heading1: "Título 1",
                heading2: "Título 2",
                heading3: "Título 3",
                bold: "Negrita",
                italic: "Cursiva",
                strike: "Tachado",
                bulletList: "Lista con viñetas",
                orderedList: "Lista numerada",
                blockquote: "Cita",
                undo: "Deshacer",
                redo: "Rehacer",
              },
              saveDraft: "Guardar borrador",
              saving: "Guardando...",
              publish: "Publicar",
              publishing: "Publicando...",
              revert: "Revertir",
              restoreDefault: "Restaurar valor predeterminado de Lucas",
              saveBeforePublish: "Guarda el borrador antes de publicar.",
              alreadyPublished: "Esta versión ya está publicada — realiza un cambio para volver a publicar.",
              draftSaved: "Borrador guardado.",
              published: "Publicado. Los nuevos firmantes verán esta versión.",
              saveFailed: "No se pudo guardar el borrador. Inténtalo de nuevo.",
              publishFailed: "No se pudo publicar. Inténtalo de nuevo.",
              usingBundledDefault:
                "Editando una copia exacta del valor predeterminado de Lucas: guarda para crear tu primera versión.",
              effectiveFrom: "Vigente desde {{date}}",
              status: {
                draft: "Borrador",
                published: "Publicado",
                archived: "Archivado",
                fallback: "Predeterminado",
              },
              readOnly: {
                title: "Vista previa de solo lectura",
              },
              naf: {
                banner:
                  "La edición del esquema del Formulario de Nueva Cuenta es la siguiente fase. Por ahora, este es el conjunto exacto de campos que los proveedores completan hoy.",
                sections: "Secciones",
                fields: "Campos",
                required: "Obligatorio",
                optional: "Opcional",
                fieldKey: "Clave",
                fieldLabel: "Etiqueta",
                fieldType: "Tipo",
              },
              standalone: {
                toggle: "Paquete independiente (se genera e imprime solo con este esquema)",
                supplier: "Identidad del proveedor",
                supplierName: "Nombre de la empresa",
                supplierAddress: "Dirección",
                supplierEmail: "Correo de facturación",
                newSection: "Nueva sección",
                addSection: "Agregar sección",
                removeSection: "Eliminar sección",
                legalText: "Texto legal",
                collapseClause: "Contraer cláusula",
                expandClause: "Expandir cláusula",
                clauseHeading: "Título de la cláusula",
                addClause: "Agregar grupo de cláusulas",
                removeClause: "Eliminar grupo de cláusulas",
                moveClauseUp: "Subir cláusula",
                moveClauseDown: "Bajar cláusula",
                printedName: "Recopilar nombre impreso",
                redact: "Redacción en PDF",
                redactNone: "Sin redacción",
                redactLast4: "Mostrar solo los últimos 4",
                redactOmit: "Omitir del PDF",
                signatures: "Bloques de firma",
                signatureLabel: "Etiqueta de la firma",
                addSignature: "Agregar bloque de firma",
                moveUp: "Subir",
                moveDown: "Bajar",
                removeSignature: "Eliminar firma",
                subtitle: "Subtítulo de la sección",
                optionalSection: "Sección opcional",
                header: "Encabezado del documento",
                headerTitle: "Título del encabezado (p. ej. Contrato de compra y servicios)",
                headerTag: "Etiqueta del encabezado (p. ej. Confidencial)",
                headerLogo: "Subir logotipo",
                removeLogo: "Quitar logotipo",
                logoTooLarge: "Esa imagen supera los 2 MB. Elija un archivo más pequeño.",
                logoBadType: "Elija una imagen PNG o JPEG.",
                logoReadFailed: "No se pudo leer la imagen. Inténtelo de nuevo.",
                pricingTable: "Tabla de precios",
                pricingTableHint: "Esta sección muestra su tabla de precios publicada.",
                pricingTableUnconfigured:
                  "Aún no hay una tabla de precios configurada — las vistas previas y los paquetes mostrarán un aviso en lugar de una tabla.",
                openPricingEditor: "Abrir el editor de precios",
                introText: "Texto de introducción (antes de los campos)",
                outroText: "Texto de cierre (después de los campos)",
                downloadPreview: "Descargar vista previa en blanco",
                previewFailed: "No se pudo generar la vista previa: {{error}}",
                generatingPreview: "Generando…",
              },
              pricing: {
                banner:
                  "La edición de tablas de precios con fecha de vigencia es la siguiente fase después del editor de NAF. Los precios por variante se gestionan hoy en el módulo de precios de péptidos.",
                tiersHeading: "Niveles de precios",
                tiersCount: "niveles",
                key: "Clave",
                label: "Etiqueta",
                description: "Descripción",
                color: "Color",
              },
              history: {
                loading: "Cargando historial...",
                emptyTitle: "Aún no hay versiones guardadas",
                emptyBackendOff:
                  "El backend de plantillas aún no está desplegado: una vez que lo esté, cada borrador y publicación aparecerá aquí.",
                emptyReady:
                  "Guarda un borrador desde cualquier pestaña para crear tu primera versión. Las versiones publicadas y los cambios aparecerán aquí.",
                type: "Plantilla",
                version: "Versión",
                status: "Estado",
                effective: "Vigencia",
                updated: "Actualizado",
                by: "Por",
                view: "Ver",
                immutabilityBanner:
                  "Las versiones publicadas a continuación son inmutables: el contenido, el publicador y la fecha quedan congelados para auditoría. Haz clic en una fila para ver las diferencias.",
                detail: {
                  title: "{{type}} · v{{version}}",
                  immutable: "Registro publicado inmutable",
                  mutableDraft: "Borrador: se reemplazará al publicar",
                  publishedAt: "Publicado el",
                  publishedBy: "Publicado por",
                  createdAt: "Creado el",
                  createdBy: "Creado por",
                  priorVersion: "Comparado contra",
                  diffHeading: "Cambios desde v{{prior}}",
                  diffFirst: "Primera versión publicada: no hay anterior para comparar",
                  loading: "Cargando contenido...",
                  loadError: "No se pudo cargar el contenido de esta versión. Es posible que el backend aún no esté desplegado.",
                  emptyContent: "Esta versión no tiene contenido.",
                  bankingMaskNote:
                    "Los números de ruta y cuenta se muestran solo con los últimos 4 dígitos — el registro de auditoría no debe filtrar credenciales completas.",
                  bankingChangedCount: "{{count}} de {{total}} campos cambiaron desde v{{prior}}.",
                  bankingFirstVersion: "Primera versión bancaria guardada — todos los valores debajo son las entradas iniciales.",
                  field: "Campo",
                  before: "v{{prior}}",
                  before_first: "Antes",
                  after: "v{{version}}",
                  changed: "Cambiado",
                  unchanged: "Igual",
                  sensitiveTitle: "Enmascarado — solo últimos 4",
                },
              },
              banking: {
                editInformation: "Editar información",
                changeAccount: "Cambiar información de la cuenta",
                cancelEdit: "Cancelar — mantener la información bancaria actual",
                cancel: "Cancelar",
                close: "Cerrar",
                editingBanner: "Estás editando los datos de pago. Guarda y publica para aplicar.",
                confirmMatches: "Coincide",
                pasteBlocked: "Pegar está deshabilitado en este campo — escribe cada dígito para evitar errores",
                saved: "Borrador bancario guardado de forma segura. Los números de ruta y cuenta se cifran en reposo.",
                savedToast: "Información bancaria guardada (cifrada)",
                publishedToast: "Información bancaria publicada",
                activityTitle: "Registro de actividad",
                activitySubtitle:
                  "Cada borrador y publicación se registra de forma inmutable. Haz clic en una fila para ver qué cambió — los campos sensibles permanecen ocultos.",
                activityLoading: "Cargando actividad…",
                activityEmpty: "Aún no hay versiones. El primer Guardar borrador aparecerá aquí.",
                activityBackendOff: "El backend de plantillas no está disponible. Cuando lo esté, cada cambio aparecerá aquí.",
              },
            },
            testPractices: {
              menuLabel: "Prácticas de prueba",
              title: "Prácticas de prueba",
              intro:
                "Los pedidos de una práctica de prueba no se incluyen en el listado de pedidos que recibe nuestro socio. Marca una práctica como de prueba solo si no es un cliente real.",
              betaWarning: "Estás en optimal-beta. No marques prácticas aquí.",
              loading: "Cargando prácticas…",
              empty: "Aún no hay prácticas.",
              tryAgain: "Intentar de nuevo",
              errors: {
                noAccess: "No tienes acceso a esta página.",
                notAvailable: "Esta función aún no está disponible en este servidor.",
              },
              columns: {
                practice: "Práctica",
                status: "Estado",
                recentOrders: "Pedidos, últimos {{days}} días",
                lastChanged: "Último cambio",
                action: "Acción",
              },
              status: {
                test: "Práctica de prueba",
                real: "Práctica real",
                mixed: "Marcada solo en parte — corrígelo",
              },
              unknownCount: "desconocido",
              never: "nunca",
              changedBy: "por {{name}}",
              actions: {
                set: "Marcar como práctica de prueba",
                clear: "Quitar marca de prueba",
              },
              cannotToggle: "Esta práctica no se puede cambiar desde esta pantalla.",
              saving: "Guardando…",
              setSuccess: "{{name}} ahora es una práctica de prueba. Sus pedidos no se incluirán en el listado del socio.",
              clearSuccess: "{{name}} vuelve a ser una práctica real. Sus pedidos se enviarán al listado del socio.",
              saveError: "No se pudo cambiar {{name}}. Inténtalo de nuevo.",
              clearConfirm: "Los pedidos de {{name}} se volverán a enviar al listado del socio.",
              confirm: {
                title: "¿Marcar {{name}} como práctica de prueba?",
                consequence: "Sus pedidos ya no se enviarán al listado de pedidos de nuestro socio.",
                placedLead: "Esta práctica hizo",
                placedOrders_one: "{{count}} pedido en los últimos {{days}} días",
                placedOrders_other: "{{count}} pedidos en los últimos {{days}} días",
                countUnknown: "No pudimos contar los pedidos recientes de esta práctica.",
                warning:
                  "Una práctica real con pedidos dejará de recibir envíos sin ningún aviso. Continúa solo si estás seguro de que no es un cliente real.",
                yes: "Sí, marcar como práctica de prueba",
                clearTitle: "¿Quitar la marca de prueba de {{name}}?",
                cancel: "Cancelar",
                close: "Cerrar",
              },
            },
          },
          rightSidebar: {
            admin: "Administración",
            adminPortal: "Portal de administración",
            formEditor: "Editor de formularios",
            aiAgent: "Agente IA",
            aiSupport: "Soporte IA",
            analytics: "Analítica",
            classicApp: "Aplicación clásica",
            comingSoon: "Próximamente",
            demoMode: "Modo demostración",
            devSettings: "Configuración de desarrollo",
            dmeCredentialing: "Acreditación",
            dmeDashboard: "Panel de DME/Productos",
            peptideCatalog: "Pedir Péptidos",
            peptideDashboard: "Panel de Péptidos",
            ehrIntegration: "Integración Registro Electrónico",
            encounters: "Encuentros",
            exitDemo: "Salir de demostración",
            generationInProgress: "Generación en curso para {{id}}",
            help: "Ayuda",
            codeOrdering: "Orden de Códigos",
            hideTasks_one: "Ocultar tarea",
            hideTasks_other: "Ocultar tareas",
            localRecordings: "Grabaciones locales",
            locations: "Ubicaciones",
            logout: "Cerrar sesión",
            notesSettings: "Configuración de notas",
            onboarding: "Incorporación",
            onboardingWizardSimulator: "Simulador del asistente de incorporación",
            patientPanel: "Panel de pacientes",
            preferences: "Preferencias",
            profile: "Perfil",
            qcodes: "Códigos Q",
            refreshApp: "Actualizar aplicación",
            requests_one: "{{count}} solicitud",
            requests_other: "{{count}} solicitudes",
            salesDashboard: "Panel de Ventas",
            showTasks_one: "Mostrar tarea",
            showTasks_other: "Mostrar tareas",
            systemHealthCheck: "Verificación del sistema",
            tasks_one: "{{count}} tarea",
            tasks_other: "{{count}} tareas",
            trainingWizard: "Asistente de Entrenamiento",
            userManagement: "Gestión de usuarios",
            welcome: "Bienvenido {{lastName}}",
            tasks: "Tareas",
            showTasks: "Mostrar tareas",
            hideTasks: "Ocultar tareas",
            requests: "Solicitudes",
          },
          salesDashboard: {
            doctorHeading: "Ganancias del Doctor ({{count}} doc)",
            doctorHeading_other: "Ganancias del Doctor ({{count}} docs)",
            fields: {
              daysPerMonth: "Días/Mes",
              daysPerScript: "Días/Script",
              numberOfDoctors: "# Doctores",
              reimbursementPerDay: "Reimb/Día",
              repCommissionPer14Days: "Comis Rep (14d)",
              scriptsPerDay: "Scripts/Día",
            },
            mobile: {
              actions: {
                generateReport: "Generar informe",
                showInternalAccounts: "Mostrar cuentas internas / de prueba",
              },
              filters: {
                searchPlaceholder: "Buscar proveedores…",
                searchRepsPlaceholder: "Buscar representantes…",
                clearSearch: "Borrar búsqueda",
                openFilters: "Abrir filtros",
                filtersLabel: "Filtros",
                reset: "Restablecer",
                productLine: "Línea de producto",
                peptide: "Péptidos",
                view: "Vista",
                viewAll: "Todas",
                viewMine: "Mías",
                viewReps: "Reps",
                viewAllReps: "Todos los reps",
                viewMyTeam: "Mi equipo",
                viewRelationships: "Relaciones",
                tier: "Nivel",
                tierAll: "Todos",
                status: "Estado",
                statusAll: "Todos",
                statusActive: "Activo",
                statusInactive: "Inactivo",
                period: "Período",
                refills: "Recargas",
                refillsNeeded: "Necesita recarga",
                countAll_one: "{{count}} cuenta",
                countAll_other: "{{count}} cuentas",
                countFiltered: "{{filtered}} de {{total}}",
                repsCountAll_one: "{{count}} rep",
                repsCountAll_other: "{{count}} reps",
                repsCountFiltered: "{{filtered}} de {{total}} reps",
              },
              pipelineFilter: {
                title: "Filtro de pipeline",
                dateRangeTitle: "Rango de fechas",
                done: "Listo",
                showAll: "Mostrar todo",
                hideAll: "Ocultar todo",
                customRange: "Rango personalizado",
                allStages: "Todas las etapas",
                stageCount_one: "1 etapa",
                stageCount_other: "{{count}} etapas",
                subsetCount: "{{count}} de {{total}} etapas",
                chipAriaDate: "Rango de fechas: {{label}}",
                chipAriaStatus: "Filtro de pipeline: {{label}}",
              },
              reps: {
                empty: "Ningún representante coincide con estos filtros.",
              },
            },
            orderPeptides: "Pedir Péptidos",
            perScript: {
              doctor: "Ganancia Dr/Script",
              rep: "Comis Rep/Script",
              total: "Total Script",
            },
            placeholders: {
              searchByNameOrEmail: "Buscar por nombre o correo electrónico...",
            },
            providerInfo: {
              docs: {
                signedExternally: "Firmado externamente — {{name}}, {{date}}",
                signoffSwitchLabel: "Firmado fuera del sistema — {{doc}}",
                signoffEnableTitle: "¿Marcar como firmado fuera del sistema?",
                signoffEnableBody:
                  "{{doc}} contará como firmado para esta cuenta y ya no le impedirá firmar ni realizar pedidos. Se registran su nombre y la fecha de hoy.",
                signoffNoteLabel: "Nota (opcional)",
                signoffConfirm: "Confirmar",
                signoffDisableTitle: "¿Quitar la firma externa?",
                signoffDisableBody:
                  "{{doc}} volverá a contar como no firmado. Si su plazo ya venció, esta cuenta no podrá firmar ni realizar pedidos hasta que se firme en la aplicación.",
                signoffErrors: {
                  not_supervisor: "Solo los supervisores del fabricante pueden cambiar esto.",
                  not_affiliated: "Su organización no está vinculada a este proveedor. No se realizó ningún cambio.",
                  not_configured:
                    "Su organización aún no está configurada para esto. Contacte a soporte. No se realizó ningún cambio.",
                  invalid_doc: "Este documento no se puede marcar como firmado fuera del sistema.",
                  contract_not_found: "Este contrato ya no está en la cuenta del proveedor. No se realizó ningún cambio.",
                  not_contract_author: "Solo el fabricante que envió este contrato puede cambiarlo.",
                  unknown_error: "No se pudo actualizar el documento. Inténtelo de nuevo.",
                },
              },
            },
            referral: {
              copy: "Copiar enlace",
              downloadQR: "Descargar código QR",
              qrDownloadFailed: "Error al descargar el código QR",
              title: "Enlace de referencia",
              copyFor: "Copiar enlace de referencia para",
              tabProvider: "Invitar proveedor",
              tabInvite: "Invitar representante",
              repProductLineLabel: "Líneas de producto que este representante puede vender",
              repCreateDescription:
                "Agrega un representante a tu equipo. Recibirá un correo para terminar de configurar su cuenta y queda vinculado a ti automáticamente.",
              repFirstName: "Nombre",
              repLastName: "Apellido",
              repEmail: "Correo electrónico",
              repFirstNamePlaceholder: "ej. Jordan",
              repLastNamePlaceholder: "ej. Reyes",
              repEmailPlaceholder: "representante@ejemplo.com",
              repCreating: "Creando…",
              repCreated: "Representante invitado — recibirá un correo para terminar de configurar su cuenta.",
              repCreateFailed: "No se pudo crear el representante. Inténtalo de nuevo.",
              repNameRequired: "Ingresa el nombre y apellido del representante.",
              repEmailInvalid: "Ingresa un correo electrónico válido para el representante.",
              pricingTierRequired: "Elige un nivel de precios para este representante.",
              splitPercentRequired: "Ingresa un % de división mayor que 0, o elige Delta.",
              noCapabilityShort: "No tienes ninguna línea de producto para otorgar — contacta a un supervisor.",
              repAdvanced: "¿Necesitas comisión o configuración avanzada? Abre el formulario completo",
              creditToggle: "Este proveedor fue referido por otro representante",
              creditHint:
                "Genera el enlace con el código de referencia de otro representante para que el nuevo proveedor se le acredite a él — útil cuando un colega trajo el contacto pero tú estás configurando la cuenta. Déjalo desactivado para acreditarte a ti.",
              overrideActive: "Este enlace se acreditará al ID de referencia ingresado",
              overridePlaceholder: "Pega el ID de referencia del otro representante",
              resetOverride: "Borrar",
              pricingTierLabel: "Nivel de precios",
              pricingTierPlaceholder: "Seleccione un nivel de precios",
              pricingTierHint: "Requerido cuando Peptides está seleccionado",
              tierRetailHint: "Precio público — esta cuenta no recibe descuento mayorista.",
              pricingTierNoGrantable:
                "Tu nivel de precios no permite otorgar ningún nivel de peptidos. Contacta a un supervisor para ajustar tu límite.",
              productLineAccess: "Acceso a líneas de producto",
              productLineDme: "Colágeno DME",
              productLinePeptides: "Péptidos",
              productLineBoth: "Ambos",
              productLineBothFull: "Colágeno DME + Péptidos",
              productLineSummaryReferral: "Este enlace otorga acceso a {{lines}}.",
              productLineSummaryCapability: "Este representante puede vender {{lines}}.",
              productLineHintBoth: "Debe seleccionarse al menos una línea de producto",
              noCapability:
                "No tienes capacidad de línea de producto para otorgar. Contacta a un supervisor para configurar tus líneas de producto, o verifica que tu organización tenga al menos una línea de producto habilitada.",
              copyDisabledOrgName: "Nombra la organización para desbloquear el enlace.",
              copyDisabledTier: "Elige un nivel de precios para desbloquear el enlace.",
              copyDisabledCapability: "Sin capacidad de línea de producto para otorgar — contacta a un supervisor.",
            },
            repCommission: {
              dmeLabel: "Comisión de colágeno",
              dmeLesserHint: "El representante gana el menor entre el $ fijo o el % en cada orden — ambos siempre aplican.",
              peptideLabel: "Comisión de péptidos",
              peptideDelta: "Delta (margen completo)",
              peptideSplit: "División",
              percentOfDelta: "% del delta",
              deltaHint: "El representante se queda con toda la diferencia de precio entre su nivel y el del proveedor.",
              splitHint: "El representante se queda con este % de la diferencia de precio; el fabricante se queda con el resto.",
            },
            relationshipTree: {
              editInvitedBy: "Editar quién invitó a este rep",
              legendAccount: "Cuenta ({{n}})",
              legendRep: "Rep ({{n}})",
              legendSupervisor: "Supervisor ({{n}})",
              noReps: "No hay reps en tu árbol",
              reassignToAnotherRep: "Reasignar a otro rep",
              scopeMyTeam: "Tu equipo",
              scopeAllAccounts: "Todas las cuentas",
              scopeLabel: "Alcance",
              title: "Árbol de relaciones",
            },
            repHeading: "Comisión del Rep ({{count}} doc)",
            repHeading_other: "Comisión del Rep ({{count}} docs)",
            reports: {
              allOrganizations: "Todas las Organizaciones",
              backToDashboard: "Volver al Panel",
              cancel: "Cancelar",
              chooser: {
                title: "Generar Informe",
                subhead: "¿Qué informe necesitas hoy?",
                choose: "Elegir",
                manufacturer: {
                  title: "Rendimiento del Fabricante",
                  desc: "Pedidos, pipeline, comisiones y pronósticos para tu equipo de ventas.",
                },
                lucas: {
                  title: "Factura de Ingresos de Lucas",
                  desc: "Cargo de procesamiento sobre pedidos entregados en el período seleccionado.",
                },
              },
              close: "Cerrar",
              configureReport: "Configurar Informe",
              deselectAll: "Deseleccionar Todo",
              downloadCSV: "Descargar CSV",
              downloadPDF: "Descargar PDF",
              exportFormat: "Formato de Exportación",
              formatCSV: "CSV",
              formatPDF: "PDF",
              generateReport: "Generar Informe",
              generated: "Generado",
              generating: "Generando...",
              includeSections: "Incluir Secciones",
              lucasInvoice: {
                title: "Factura de Ingresos de Lucas",
                subhead: "Selecciona un mes, trimestre o rango personalizado para calcular el monto adeudado a Lucas AI.",
                period: "Período",
                months: "Meses",
                currentMonthTooltip: "En curso — los totales se cerrarán al final del mes.",
                earliestRecord: "Registro más antiguo: {{date}}",
                lastQuarter: "Trimestre Anterior",
                thisQuarter: "Trimestre Actual",
                ytd: "Año a la Fecha",
                custom: "Personalizado",
                other: "Otro",
                organization: "Organización",
                exportFormat: "Formato de Exportación",
                feeRate: {
                  label: "Tasa de comisión",
                  otherPlaceholder: "Otro",
                  otherAria: "Porcentaje de comisión personalizado",
                  helper: "Porcentaje cobrado sobre los ingresos brutos facturados.",
                },
                generatePdf: "Generar Factura PDF",
                generateCsv: "Generar Factura CSV",
                generationFailed: "No se pudo generar la factura. Por favor, intenta de nuevo.",
                empty: "No hay productos entregados en este período.",
                excludeInternal: {
                  label: "Excluir pedidos internos de Lucas Health",
                  helper_zero: "No se detectaron organizaciones internas — el interruptor no tiene efecto.",
                  helper_one: "Oculta pedidos de organizaciones que parecen internas (actualmente 1 organización excluida).",
                  helper_other:
                    "Oculta pedidos de organizaciones que parecen internas (actualmente {{count}} organizaciones excluidas).",
                  helperWithNames_one: "Coincide con 1 organización interna: {{names}}.",
                  helperWithNames_other: "Coincide con {{count}} organizaciones internas: {{names}}.",
                },
                summary: {
                  organizations: "Organizaciones",
                  deliveredProducts: "Productos entregados",
                  grossBilled: "Total facturado",
                  manualReview_one: "Línea que requiere revisión manual (excluida)",
                  manualReview_other: "Líneas que requieren revisión manual (excluidas)",
                  amountDue: "Adeudado a Lucas AI",
                },
              },
              metrics: {
                atRisk: "Ingresos en Riesgo",
                confirmedRevenue: "Ingresos Confirmados",
                deliveredOrders: "Pedidos Entregados",
                momGrowth: "Crecimiento MoM",
                pipelineHealth: "Salud del Pipeline",
                totalEstRevenue: "Ingresos Estimados Totales",
                totalOrders: "Total de Pedidos",
                trend: "Tendencia",
              },
              noPHINote:
                "Este informe no contiene información de salud del paciente (PHI). Todos los datos son agregados y anonimizados.",
              organization: "Organización",
              print: "Imprimir",
              reportTitle: "Informe de Rendimiento de Ventas",
              sections: {
                commissions: "Análisis de Comisiones y Finanzas",
                executive: "Resumen Ejecutivo",
                forecast: "Pronóstico y Predicciones",
                kpis: "Indicadores Clave de Rendimiento",
                pipeline: "Análisis del Pipeline de Pedidos",
                providers: "Rendimiento de Proveedores / Cuentas",
                revenue: "Resumen de Ingresos",
                salesReps: "Rendimiento de Representantes",
              },
              selectAll: "Seleccionar Todo",
              selectAtLeastOne: "Por favor selecciona al menos una sección.",
              timePeriod: "Período de Tiempo",
            },
            reps: {
              loadError: "No se pudo cargar tu equipo.",
              loadErrorNotDeployed: "La lista de tu equipo aún no está disponible en este entorno.",
            },
            subtitle: "Estima tu comisión e ingresos del distribuidor por pedido.",
            summary: {
              monthly: "Mensual",
              yearly: "Anual",
            },
            title: "Panel de Ventas",
            toasts: {
              accountAlreadyAssigned: "La cuenta ya está asignada a este representante",
              accountReassignedTo: "Cuenta reasignada a {{name}}",
              cannotMoveRepUnderSubRep: "No se puede mover un representante debajo de su propio sub-representante",
              copiedToClipboard: "Copiado al portapapeles",
              emailCopied: "Correo electrónico copiado al portapapeles",
              failedToCopy: "Error al copiar",
              failedToCopyEmail: "Error al copiar el correo electrónico",
              failedToLoadMediaFile: "No se pudo cargar el archivo. Por favor, inténtalo de nuevo.",
              failedToMoveRep: "Error al mover representante",
              failedToReassignAccount: "Error al reasignar la cuenta",
              failedToReassignOrganization: "Error al reasignar la organización",
              failedToSaveUploads: "Error al guardar las cargas. Por favor, inténtelo de nuevo.",
              failedToUpdateInvitedBy: "Error al actualizar Invitado por",
              invitedByUpdated: "Invitado por actualizado exitosamente",
              organizationReassignedTo: "Organización reasignada a {{name}}",
              partialUpdateBothReps:
                "Actualización parcial: la cuenta puede estar asignada a ambos representantes. Por favor, corríjalo manualmente.",
              pleaseSelectUserToReassign: "Por favor seleccione un usuario para reasignar",
              repMovedUnder: "{{name}} movido debajo de {{target}}",
              selectedUserNoLongerAvailable: "El usuario seleccionado ya no está disponible",
            },
            viewMode: {
              both: "Ambos",
              doctor: "Doctor",
              rep: "Rep",
            },
            accounts: {
              indirect: "Indirecto",
              showMore: "Cargar más",
              showingCount: "Mostrando {{rendered}} de {{matching}} cuentas de {{line}}",
              showingAll: "Mostrando las {{matching}} cuentas de {{line}}",
              lineDme: "DME",
              linePeptide: "Péptidos",
            },
            admin: {
              title: "Vista de administrador",
              showInternalAccounts: "Mostrar cuentas internas / de prueba",
            },
            audit: {
              tabLabel: "Auditoría",
              heading: "Registro de auditoría de ventas",
              subtitle:
                "Registro inalterable de reasignaciones de reps y cuentas en su organización. Visible solo para administradores.",
              filters: {
                action: "Acción",
                actionAll: "Todas",
                actionRepMove: "Reasignaciones de rep",
                actionAccountMove: "Reasignaciones de cuenta",
                actorSearch: "Buscar usuario...",
                subjectSearch: "Buscar sujeto...",
                subjectChipPrefix: "Sujeto:",
                clearSubject: "Limpiar",
              },
              columns: {
                when: "Cuándo",
                actor: "Usuario",
                action: "Acción",
                subject: "Sujeto",
                change: "Antes → Después",
                source: "Origen",
              },
              action: {
                repReparent: "Rep reasignado",
                accountReassign: "Cuenta reasignada",
              },
              source: {
                wrapper: "Wrapper",
                direct: "API directa",
              },
              loadMore: "Cargar más",
              export: "Descargar CSV",
              exportTruncated: "Mostrando las primeras 5,000 filas — refine los filtros para ver más.",
              empty: "Ningún evento coincide con estos filtros.",
              error: "No se pudo cargar el registro de auditoría.",
              errorNotDeployed: "El registro de auditoría aún no está disponible en este entorno.",
              retry: "Reintentar",
              drawer: {
                actor: "Usuario",
                subject: "Sujeto",
                change: "Cambio",
                metadata: "Metadatos de la solicitud",
                viewHistory: "Ver historial completo de este sujeto",
                close: "Cerrar",
              },
            },
            datePicker: {
              today: "Hoy",
              yesterday: "Ayer",
              last7days: "Últimos 7 días",
              last30days: "Últimos 30 días",
              thisMonth: "Este mes",
              thisQuarter: "Este trimestre",
              ytd: "Año a la fecha",
              last12months: "Últimos 12 meses",
              custom: "Rango personalizado",
              update: "Actualizar",
              cancel: "Cancelar",
              selectDates: "Seleccionar fechas",
              presets: "Filtros de fecha",
              prevMonth: "Mes anterior",
              nextMonth: "Mes siguiente",
            },
            commissions: {
              copyValue: "Copiar {{value}}",
              heading: {
                simulation: "Simulación",
                profile: "Mis",
              },
              productLine: {
                dme: "DME",
                peptide: "Péptido",
              },
              peptide: {
                heading: "Péptido",
                titleSupervisor: "Calculadora de ingresos por péptidos",
                titleRep: "Calculadora de comisiones por péptidos",
                simulator: {
                  productMixTitle: "Mezcla de productos",
                  pricingTitle: "Precios",
                  wholesaleTier: "Nivel mayorista",
                  unitsPerOrder: "Unidades / orden",
                  commissionTitle: "Configuración de comisión",
                  commissionTypeLabel: "Tipo de comisión",
                  flatPerOrder: "Comisión fija por orden",
                  commissionPercent: "% de los ingresos del fabricante",
                  volumeTitle: "Proyecciones de volumen",
                  inputMode: "Modo de entrada",
                  perDay: "Por día",
                  perMonth: "Por mes",
                  ordersPerDay: "Órdenes por día",
                  ordersPerMonth: "Órdenes por mes",
                  workingDays: "Días laborables por mes",
                  recurringRate: "Tasa recurrente %",
                  providers: "Proveedores / pacientes",
                  providerSingular: "proveedor",
                  providerPlural: "proveedores",
                  flowTitle: "Flujo de dinero (por orden)",
                  flowTitleSupervisor: "Flujo de ingresos (por orden)",
                  perOrderTitle: "Desglose por orden",
                  units: "Unidades",
                  patientPays: "El paciente paga",
                  manufacturer: "Fabricante",
                  providerProfit: "Ganancia del proveedor",
                  rep: "Representante",
                  manufacturerRevenue: "Ingresos del fabricante",
                  netRevenue: "Ingresos netos (después de costos de rep.)",
                  netManufacturer: "Ingresos netos del fabricante (después de costos de rep.)",
                  providerEarnings: "Ganancias del proveedor",
                  repCommission: "Comisión del representante",
                  repCommissionCost: "Costo de comisión del representante",
                  ofMfrRevenue: "de los ingresos del fabricante",
                  repCostNote: "costo de rep.",
                  monthly: "Mensual",
                  yearly: "Anual",
                  ordersPerMonthSuffix: "{{count}} órdenes/mes",
                  recurringIncl: "(incl. +{{pct}}% recurrente)",
                  wholesaleAtTier: "mayorista en nivel {{tier}}",
                  repCostsDetailBasis: "Costos de rep.: {{amount}}/mes ({{basis}})",
                  commissionHidden: "Detalles de comisión ocultos",
                  commissionDetailFlat: "{{amount}} tarifa fija por orden entregada",
                  commissionDetailLesser: "El menor entre {{amount}} fijo / {{pct}}% de los ingresos del fabricante",
                  commissionDetailPercent: "{{pct}}% de los ingresos del fabricante por orden",
                  hideCommission: "Ocultar valores de comisión",
                  showCommission: "Mostrar valores de comisión",
                  revealCommission: "Mostrar comisión",
                  patientPaysContext: "El paciente paga {{amount}} retail por orden",
                  avgRetail: "Retail promedio (paciente)",
                  avgWholesale: "Mayorista promedio (proveedor)",
                  retailShort: "retail",
                  wholesaleShort: "mayorista",
                  reset: "Restablecer",
                  unlock: "Desbloquear {{label}}",
                  mixWarning: "La mezcla debe sumar 100%",
                  tierOption: {
                    A: "Nivel A (40%)",
                    B: "Nivel B (45%)",
                    C: "Nivel C (50%)",
                    D: "Nivel D (55%)",
                  },
                  commissionType: {
                    flat: "Tarifa fija",
                    percent: "Porcentaje",
                    lesser: "El menor de",
                  },
                  category: {
                    glp: { label: "GLP", description: "Pérdida de peso", examples: "Tirzepatida, Semaglutida" },
                    recovery: { label: "Recuperación", description: "Curación y rendimiento", examples: "BPC-157, TB-500" },
                    hormone: {
                      label: "Hormonas",
                      description: "Antienvejecimiento y crecimiento",
                      examples: "CJC-1295, Ipamorelin",
                    },
                  },
                  flow: {
                    patient: "El paciente paga",
                    retail: "Retail",
                    manufacturer: "Fabricante",
                    wholesale: "{{pct}}% mayorista",
                    wholesaleOfRetail: "{{pct}}% mayorista del retail",
                    provider: "Proveedor",
                    markup: "{{pct}}% de margen",
                    rep: "Comisión del representante",
                    perOrder: "Por orden",
                  },
                  disclaimer: {
                    important: "IMPORTANTE",
                    title: "Estimaciones de comisión por péptidos",
                    requirementsLead: "La comisión se paga cuando TODAS las condiciones se cumplen:",
                    requirements: {
                      0: "La orden es ENTREGADA al paciente",
                      1: "Pago capturado exitosamente (tarjeta o comprobante de Zelle confirmado)",
                      2: "La orden no es reembolsada ni cancelada después de la entrega",
                      3: "Las órdenes recurrentes generan comisión solo cuando cada refill se paga y entrega",
                    },
                    pricingLead: "Acerca de los precios:",
                    estimates: {
                      0: "Las tarifas retail mostradas son MSRP representativas — los precios reales varían por variante y mercado",
                      1: "El nivel mayorista (A–D) determina lo que el proveedor paga al fabricante",
                      2: "Los márgenes por nivel son ilustrativos; su nivel contratado puede diferir",
                      3: "El multiplicador de tasa recurrente es para planificación, no una garantía de retención",
                    },
                    structureLead: "Estructura de comisión:",
                    commission: {
                      0: "Su tasa de comisión se establece al crear la cuenta",
                      1: "Tarifa fija o %-de-ingresos-del-fabricante, por orden entregada",
                      2: "Los montos de comisión mostrados son ESTIMACIONES, no garantías",
                      3: "Lucas Health puede modificar los términos en cualquier momento para mantener cumplimiento",
                    },
                  },
                },
                productMixTitle: "Variantes principales de péptidos",
                productMixHeader: "Unidades por variante",
                productMixTotal: "{{count}} unidades entregadas",
                productMixEmpty: "No hay órdenes entregadas en el período seleccionado.",
                productMixNoItems: "Las órdenes entregadas no tienen variantes detalladas en este período.",
                unitsLabel: "unidades",
                snapshotTitle: "Pacientes y operaciones",
                snapshot: {
                  activePatients: "Pacientes activos",
                  avgOrderValue: "Valor promedio por orden",
                  recurring: "Tasa de recurrencia",
                  fulfillment: "Entrega promedio",
                },
                activityTitle: "Actividad",
                activity: {
                  delivered: "Órdenes entregadas",
                  pipeline: "Órdenes en proceso",
                },
                summary: {
                  deliveredTitle: "Ingresos totales por péptidos",
                  deliveredDetail_one: "{{count}} orden entregada",
                  deliveredDetail_other: "{{count}} órdenes entregadas",
                  pipelineTitle: "Ingresos en proceso",
                  pipelineDetail_one: "{{count}} orden en proceso",
                  pipelineDetail_other: "{{count}} órdenes en proceso",
                  attentionTitle: "Requiere atención",
                  attentionDetail_one: "{{count}} orden requiere acción",
                  attentionDetail_other: "{{count}} órdenes requieren acción",
                },
                empty: {
                  title: "Aún no hay órdenes de péptidos",
                  subtitle: "Las métricas de ingresos por péptidos aparecerán aquí cuando se entreguen sus primeras órdenes.",
                },
              },
            },
            providerDrawer: {
              peptidePricing: {
                heading: "Precios de péptidos",
                currentTierLabel: "Nivel actual",
                notSet: "No establecido",
                changeTierLabel: "Cambiar nivel",
                saveButton: "Guardar",
                saving: "Guardando…",
                cancelButton: "Cancelar",
                saved: "Nivel de precios actualizado",
                saveFailed: "No se pudo actualizar el nivel de precios. Inténtelo de nuevo.",
                readOnlyHint: "Las cuentas de sub-reps solo pueden ser editadas por el rep asignado o un supervisor.",
                lockedByManufacturerSuffix: "(actual — bloqueado por el fabricante)",
                noCustomPricesSet: "No hay precios personalizados.",
              },
              productRestrictions: {
                heading: "Productos DME",
                help: "Desmarque un producto para impedir que esta cuenta lo pida. Los cambios aplican a nuevos envíos; el formulario de pedido de la cuenta se actualiza la próxima vez que se abra.",
                loading: "Cargando productos…",
                loadError: "No se pudo cargar la configuración de productos de esta cuenta.",
                primaryGroup: "Apósitos primarios",
                secondaryGroup: "Apósitos secundarios",
                save: "Guardar",
                saving: "Guardando…",
                saved: "Configuración de productos guardada",
                savedNotSynced:
                  "Guardado. El formulario de pedido de la cuenta se actualizará en la próxima sincronización exitosa; guarde de nuevo para reintentar.",
                saveError: "No se pudo guardar la configuración de productos. Inténtelo de nuevo.",
                updatedBy: "Actualizado el {{date}} por {{name}}",
                lastPushFailed: "La última sincronización con la cuenta no se completó. Guarde de nuevo para reintentar.",
              },
            },
          },
          sidebar: {
            loadMore: "Cargar Más",
            newChat: "Nuevo Encuentro",
            noEnc: "No se encontraron encuentros",
            search: "Buscar",
            searchMeta: {
              interpretedAs: "Buscando:",
              chipName: 'Nombre "{{value}}"',
              chipDob: "Fecha nac. {{value}}",
              chipYear: "Año {{value}}",
              chipId: "MRN/FIN {{value}}",
              results: "{{count}} resultados",
              resultsOne: "{{count}} resultado",
              noResults: 'Sin coincidencias para "{{term}}"',
              tipName: "Busca solo por apellido",
              tipDob: "Revisa el formato de fecha (MM/DD/AAAA)",
              tipId: "Busca por MRN o FIN",
              clear: "Borrar búsqueda",
            },
          },
          spellCheck: {
            acceptAll: "Aceptar todo",
            didYouMean: "¿Quiso decir...?",
            reviewMode: {
              exit: "Salir de revisión",
              fixed: "Corregido → {{word}}",
              fixedCount: "corregidos",
              keyboardHint: "Tab: siguiente · Espacio: omitir · Enter: corregir · Ctrl+Z: deshacer",
              noIssues: "No se encontraron errores ortográficos",
              occurrences: "({{count}})",
              progress: "{{reviewed}} de {{total}} revisados",
              skip: "Omitir",
              skipped: "Omitido",
              styleSectionTitle: "Sugerencias de estilo",
              styleHint: "No son errores, solo diferencias de estilo",
              styleTag: "estilo",
              title: "Revisión ortográfica",
              undo: "Deshacer",
              undoLast: "Deshacer último",
            },
          },
          tableView: {
            colors: {
              blue: "Azul",
              green: "Verde",
              orange: "Naranja",
              pink: "Rosa",
              purple: "Morado",
              red: "Rojo",
              yellow: "Amarillo",
            },
            columns: {
              additionalClaimInformation: "Informacion adicional del reclamo",
              age: "Edad",
              allergies: "Alergias",
              amountOutstanding: "Monto pendiente",
              appealDeadline: "Fecha limite de apelacion",
              appealLevel: "Nivel de apelacion",
              attachments: "Archivos adjuntos",
              authRemainedUnits: "Unidades restantes de autorizacion",
              billedUnitsUsed: "Unidades facturadas usadas",
              billedUnitsWasted: "Unidades facturadas desperdiciadas",
              claimNumber: "Numero de reclamo",
              cptLevelII: "CPT Nivel II",
              createdOn: "Fecha de creacion",
              currentMedications: "Medicamentos actuales",
              dateAppealSent: "Fecha de envio de apelacion",
              dateOfCurrentIllnessInjury: "Fecha de enfermedad/lesion actual",
              datesUnableToWorkFrom: "Fechas sin poder trabajar desde",
              datesUnableToWorkTo: "Fechas sin poder trabajar hasta",
              denialReason: "Razon de denegacion",
              diagnosisCodesICD10: "Codigos de diagnostico ICD10",
              diagnostics: "Diagnosticos",
              dob: "Fecha de nacimiento",
              edit: "Editar",
              eftNumber: "Numero de EFT",
              encounterType: "Tipo de encuentro",
              eobAttached: "EOB adjunto",
              familyHistory: "Historial familiar",
              finalStatusNote: "Nota de estado final",
              gender: "Genero",
              groupNumber: "Numero de grupo",
              hcfa1500: "1500",
              hospitalizationFrom: "Hospitalizacion desde",
              hospitalizationTo: "Hospitalizacion hasta",
              hpi: "HPI",
              id: "ID",
              insuranceCarrier: "Aseguradora",
              insuredCity: "Ciudad del asegurado",
              insuredDob: "Fecha de nacimiento del asegurado",
              insuredName: "Nombre del asegurado",
              insuredState: "Estado del asegurado",
              insuredStreetAddress: "Direccion del asegurado",
              insuredZip: "Codigo postal del asegurado",
              invoiceAmount: "Monto de factura",
              invoiceAmountPaid: "Monto de factura pagado",
              invoiceNumber: "Numero de factura",
              lastUpdate: "Ultima actualizacion",
              mdm: "MDM",
              medicaidOtherResubmissionCode: "Codigo de reenvio de Medicaid/Otro",
              miscCharge: "Cargo miscelaneo",
              netAmount: "Monto neto",
              nonBillableInjections: "Inyecciones no facturables",
              noteReviewed: "Nota revisada",
              noteStatus: "Estado de la nota",
              officeAddress: "Direccion de oficina",
              officeProcedures: "Procedimientos de oficina",
              officeState: "Estado de oficina",
              officeZip: "Codigo postal de oficina",
              originalReferenceNumber: "Numero de referencia original",
              otherInsured: "Otro asegurado",
              otherInsuredPlanName: "Nombre del plan de otro asegurado",
              otherInsuredPolicyGroup: "Grupo de poliza de otro asegurado",
              outsideLabCharges: "Cargos de laboratorio externo ($)",
              pastMedicalHistory: "Historial medico anterior",
              pastSurgeries: "Cirugias anteriores",
              patientFirstName: "Nombre del paciente",
              patientLastName: "Apellido del paciente",
              paymentDate: "Fecha de pago",
              percentImprovement: "% de mejora",
              physicalExams: "Examenes fisicos",
              planOfCare: "Plan de cuidado",
              policyNumber: "Numero de poliza",
              previousTreatments: "Tratamientos anteriores",
              priorAuthorizationNumber: "Numero de autorizacion previa",
              productApplicationDateOfService: "Fecha de servicio de aplicacion del producto",
              productPrice: "Precio del producto",
              projectAdjudicationDate: "Fecha de adjudicacion del proyecto",
              provider: "Proveedor",
              resolution: "Resolucion",
              reviewed: "Revisado",
              ros: "ROS",
              similarIllnessDate: "Fecha de enfermedad similar",
              socialHistory: "Historial social",
              sponsorInfo: "Informacion del patrocinador",
              statusActionDate: "Fecha de accion de estado",
              totalAreaWithDepth: "Area total con profundidad",
              totalSurfaceArea: "Area superficial total",
              totalWounds: "Total de heridas",
              trackingNumber: "Numero de rastreo",
              uploadedTotalLabs: "Total de laboratorios cargados",
              verificationFinalStatus: "Estado final de verificacion",
              verificationNotes: "Notas de verificacion",
              verificationStatus: "Estado de verificacion",
              viewEdit: "Ver / Editar",
              visitTime: "Hora de visita",
              woundClassification: "Clasificacion de herida",
              woundImagesAvailable: "Hay imagenes de la herida",
              woundProductCode: "Codigo de producto para herida",
              woundSiteLocation: "Ubicacion del sitio de la herida",
            },
            customizeDescription: "Personaliza la tabla habilitando y deshabilitando las columnas a mostrar",
            deleted: "Eliminado",
            draft: "Incompleto",
            edit: {
              addComment: "Agregar comentario",
              addCommentButton: "Agregar comentario",
              comments: "Comentarios",
              edit: "Editar",
              requestChange: "Solicitar cambio",
              requestHistory: "Historial de solicitudes",
              transcripting: "Transcribiendo...",
              update: "Actualizar",
            },
            editTableView: "Editar vista de tabla",
            filter: "Filtro",
            generated: "Generado",
            group: "Grupo",
            icd10: {
              addCode: "Agregar código",
            },
            insurance: "Seguro",
            items_one: "{{count}} elemento",
            items_other: "{{count}} elementos",
            loadMore: "Cargar más...",
            loading: "Cargando...",
            loadingMore: "Cargando más...",
            locked: "Finalizado",
            myPatients: "Mis pacientes",
            noEncountersFound: "No se encontraron encuentros.",
            options: {
              assistedLiving: "Vida asistida",
              clinicalToComplete: "Clinico para completar",
              clinicalToWork: "Clinico para trabajar",
              down: "No disponible",
              home: "Hogar",
              notAssigned: "No asignado",
              noteTypeNotFound: "tipo de nota no encontrado",
              nursingHome: "Hogar de ancianos",
              office: "Oficina",
              skilledNursingFacility: "Centro de enfermeria especializada",
              unavailable: "No disponible",
              yes: "Si",
            },
            pdf: {
              download: "Descargar",
              editPdf: "Editar PDF",
            },
            reset: "Restablecer",
            search: "Buscar",
            status: "Estado",
            statuses: {
              acceptedForProcessing: "Aceptado para procesamiento",
              aiGenerated: "Generado por IA",
              appealCheckWithOffice: "Apelacion - Verificar con oficina",
              orderComplete: "Orden completa — entregada a la clínica.",
              appealNeeded: "Apelacion necesaria",
              appealOverturned: "Apelacion revocada",
              appealSent: "Apelacion enviada",
              billed: "Facturado",
              billedCorrectedClaim: "Reclamo corregido facturado",
              billingFollowUp: "Seguimiento de facturacion",
              billingQuestion: "Pregunta de facturacion",
              buyAndBill: "Comprar y facturar",
              canceled: "Cancelado",
              claimNotShowing: "Reclamo no aparece",
              confirmIfOfficeWantsHelp: "Confirmar si la oficina quiere ayuda",
              correctedClaimNeeded: "Reclamo corregido necesario",
              denialUpheld: "Denegacion confirmada",
              denied: "Denegado",
              disapproved: "Desaprobado",
              disapprovedCOB: "COB desaprobado",
              disapprovedCoverageTermed: "Cobertura terminada desaprobada",
              disapprovedMedRecs: "Registros medicos desaprobados",
              disapprovedMedicalNecessity: "Necesidad medica desaprobada",
              disapprovedNDC: "NDC desaprobado",
              disapprovedNotCovered: "No cubierto desaprobado",
              draft: "Borrador",
              experimentalInvestigationalReview:
                "Experimental y/o investigacional - revisando para determinar si la denegacion se mantiene o puede apelarse",
              followUpCall: "Llamada de seguimiento",
              hospiceModifiersMissing: "Modificadores de hospicio faltantes / Otro problema de hospicio",
              incorrectPay: "Pago incorrecto",
              incorrectQCodeBilled: "Codigo Q incorrecto facturado",
              insPartialPayment: "Pago parcial del seguro",
              insuranceChanged: "Seguro cambiado",
              invoicePaidToHTP: "Factura pagada a HTP",
              invoicePaidToIWC: "Factura pagada a IWC",
              invoiceReceivedPartialPayment: "Factura - Pago parcial recibido",
              invoiceRequested: "Factura solicitada",
              lowPay: "Pago bajo",
              lowPayOfficeSentBack: "Pago bajo - Oficina devolvio",
              medRecsAdditionalInfoSent: "Registros medicos/informacion adicional enviados",
              medicalRecordsAudit: "Auditoria de registros medicos",
              newInsuranceCarriersPolicyNotFollowed: "Poliza de nueva aseguradora no seguida",
              noAppealPayorPaid1Of2: "Sin apelacion - Pagador pago 1 de los 2 productos",
              noteNotComplete: "Nota incompleta",
              noteReviewedNoNote: "Sin nota - necesita revision cuando se reciba la nota",
              noteReviewedPerMgmt: "No - Segun gerencia no se necesita nota para esta fecha de servicio",
              noteReviewedPreviouslyReviewed: "No - La nota fue revisada previamente en la ultima visita",
              noteReviewedProviderApplication: "Si - El proveedor envio la nota despues de la solicitud",
              noteReviewedProviderOrder: "Si - El proveedor envio la nota despues de la orden",
              noteReviewedRequested: "Nota solicitada para completar verificacion",
              noteReviewedYes: "Si",
              officeAppealedWithoutAhmHelp: "Oficina apelo sin ayuda de AHM",
              officeBilled: "Oficina facturada",
              officeDidNotFollowSampleHCFA: "La oficina no siguio el ejemplo de HCFA",
              officeNotifiedToTakeAction: "Oficina notificada para tomar accion",
              overpayment: "Sobrepago",
              paid: "Pagado",
              paidAppliedToDeductible: "Pago aplicado al deducible",
              paidIncorrectlySeeResolution: "Pago incorrecto - Ver columna de resolucion para detalles",
              paidRecoupInProcess: "Recuperacion de pago en proceso",
              partAAtTOS: "Parte A en TOS",
              paymentAppliedToRecoup: "Pago aplicado a una recuperacion",
              paymentReapplied: "Pago reaplicado",
              perOfficeHandleInternally: "Segun oficina lo manejaran internamente",
              providerOonNoPayableBenefits: "Proveedor fuera de red sin beneficios pagables",
              rejectedNeverReceivedByCarrier: "Rechazado como nunca recibido por la aseguradora",
              reopeningDone: "Reapertura completada",
              reopeningNeeded: "Reapertura necesaria",
              reprocessing: "Reprocesando",
              requestingRecordsAdditionalInformation: "Solicitando registros/informacion adicional",
              requiredLoopSegmentDetailMissing: "Detalle de bucle/segmento requerido faltante",
              signed: "Firmado",
              specialWorkflow: "Flujo de trabajo especial",
              twoProductsTwoSuppliersSameDay: "2 Productos / 2 Proveedores el mismo dia",
              unableToObtainBillableInfo: "No se pudo obtener informacion facturable de la oficina",
              unableToOverturn: "No se puede revocar",
              unbillable: "No facturable",
            },
            team: "Equipo",
            toasts: {
              failedUnlockForm: "Error al desbloquear el formulario 1500",
              failedUpdateReviewStatus: "Error al actualizar el estado de revisión",
              formCleared: "Formulario 1500 marcado como revisado y aprobado",
              formIncompleteNoteAdded: "Formulario 1500 marcado como incompleto. Nota agregada a la Conversación.",
              formIncompleteOrderRejected:
                "Formulario 1500 marcado como incompleto. Orden movida a Información Adicional Necesaria.",
              formUnlocked: "Formulario 1500 desbloqueado para edición",
              noOutputGenerated: "No se generó ningún resultado",
              trackingCopied: "Número de seguimiento copiado al portapapeles",
            },
            verificationStatuses: {
              appealAuthInProcess: "apelacion de autorizacion en proceso",
              authExtensionRequested: "extension de autorizacion solicitada",
              authPredetermCompleted: "autorizacion/predeterminacion completada",
              authPredetermInProcess: "autorizacion/predeterminacion en proceso",
              authPredetermNeeded: "autorizacion/predeterminacion necesaria",
              boxSaleOnly: "solo venta de caja",
              compliancyReviewUnable: "revision de cumplimiento - no se pudo completar",
              foundNoVerification: "encontrado - sin verificacion realizada",
              graftNoLongerNeeded: "injerto ya no es necesario",
              insuranceRequestedInfo: "seguro solicito informacion adicional",
              lessThan100DaysNF: "menos de 100 dias consecutivos en NF/SNF",
              managementApprovedDoctorAware: "gerencia aprobada - doctor al tanto de informacion necesaria",
              ninetyDaysConservativeCare: "90 dias de cuidado conservador necesarios",
              pendingInfo: "Pendiente de informacion adicional",
              selectAll: "Seleccionar TODO",
              shipPerManagement: "enviar segun gerencia",
              specialWorkflowNoDoc: "flujo de trabajo especial - sin documento para revision",
              thirtyDaysConservativeCare: "30 dias de cuidado conservador necesarios",
              verification: "verificacion",
              verificationCompleted: "verificacion completada",
              verificationInProcess: "verificacion en proceso",
              woundInfectedFollowUp: "herida infectada - seguimiento en 2/3 semanas para ver si",
            },
            woundClassifications: {
              arterial: "Arterial",
              dfu: "UPD",
              nonPressure: "Sin presion",
              other: "Otro",
              pressure: "Presion",
              surgical: "Quirurgica",
              trauma: "Trauma",
              vlu: "ULV",
            },
            woundLocations: {
              buttocks: "Gluteos",
              foot: "Pie",
              head: "Cabeza",
              ischium: "Isquion",
              lowerExtremity: "Extremidad inferior",
              sacrum: "Sacro",
              trunk: "Tronco",
              upperExtremity: "Extremidad superior",
            },
          },
          terms: {
            acceptTitle: "Aceptar Términos de Uso",
            notSigned: "Términos de uso actuales no firmados",
            sign: "Firmar",
            signedBadge: "Versión {{version}} firmada el {{date}} por {{name}}",
            toast: {
              signError: "Error al firmar los Términos de uso",
              signed: "Términos de uso firmados",
            },
          },
          tickets: {
            aiSupport: {
              answering: "Respondiendo...",
              howCanHelp: "¿Cómo puedo ayudarte?",
              sendFailed: "No se pudo enviar tu mensaje. Vuelve a intentarlo o contacta directamente con soporte.",
              title: "Pedir ayuda",
              typeMessage: "Escribe un mensaje...",
            },
            create: {
              additionalDetails: "Detalles adicionales (opcional)",
              categories: [
                "Nota incompleta",
                "Información incorrecta",
                "Sección faltante",
                "Nota no generada",
                "Problema de formato",
                "Otro",
              ],
              create: "Crear",
              description: "Descripción",
              encounter: "Encuentro",
              encounterOrOrder: "Encuentro / Orden",
              errorCreating: "Error al crear el ticket",
              issueType: "¿Cuál es el problema?",
              order: "Orden",
              requestPhoneCall: "Solicitar llamada telefónica",
            },
            detail: {
              created: "Creado",
              errorSending: "Error al enviar el mensaje",
              estResolutionTime: "Tiempo estimado de resolución",
              issueType: "Tipo de problema",
              messageSent: "Mensaje enviado",
              messages: "Mensajes",
              newIssue: "Nuevo problema",
              resolutionProgress: "Progreso de resolución",
              ticketCode: "Ticket TKT-{{code}}",
              typeMessage: "Escribe un mensaje...",
            },
            list: {
              errorFetching: "Error al obtener tickets",
              hideClosedTickets: "Ocultar tickets cerrados",
              newTicketRequest: "Nueva solicitud de ticket",
              noOpenTickets: "No hay tickets abiertos",
              openTickets_one: "Tienes {{count}} ticket abierto",
              openTickets_other: "Tienes {{count}} tickets abiertos",
              showClosedTickets_one: "Mostrar {{count}} ticket cerrado",
              showClosedTickets_other: "Mostrar {{count}} tickets cerrados",
              openTickets: "Tickets abiertos",
              showClosedTickets: "Mostrar tickets cerrados",
            },
            modal: {
              createTicket: "Crear ticket",
              myTickets: "Mis tickets",
              viewTicket: "Ver ticket",
            },
          },
          tierRecommendation: {
            andMore: "y más",
            basedOnYourNotes: "Basándonos en los tipos de notas que has creado, estas funciones son esenciales para tu práctica:",
            continue: "Continuar",
            featuresYouUsed: "Funciones que has usado durante la prueba",
            includesAllFeatures: "Incluye todas las funciones que necesitas:",
            recommended: "Recomendado",
            recommendedPlan: "Plan recomendado para ti",
            seePlans: "Ver planes",
          },
          uberDirect: {
            dispatch: {
              address: "Dirección",
              cancelConfirm: "¿Está seguro de que desea cancelar esta entrega?",
              cancelDelivery: "Cancelar entrega",
              cancelFailed: "Error al cancelar la entrega",
              cancelTitle: "Cancelar entrega",
              cancelYes: "Sí, cancelar",
              cancelled: "Entrega cancelada",
              city: "Ciudad",
              confirmDispatch: "Confirmar y enviar",
              defaultPackageDesc: "Medicamento de péptidos",
              deliveryEta: "Tiempo estimado de entrega",
              dispatchBtn: "Enviar entrega",
              dispatchFailed: "Error al enviar la entrega",
              dispatched: "¡Entrega enviada!",
              dropoffAddress: "Dirección de entrega",
              edit: "Editar",
              fee: "Tarifa de entrega",
              getQuote: "Obtener cotización",
              name: "Nombre",
              packageDesc: "Descripción del paquete",
              phone: "Teléfono",
              pickupAddress: "Dirección de recogida",
              pickupEta: "Tiempo estimado de recogida",
              quoteFailed: "Error al obtener la cotización",
              state: "Estado",
              title: "Enviar entrega",
              trackDelivery: "Rastrear entrega",
              zip: "Código postal",
            },
            history: {
              empty: "No hay entregas para este pedido",
            },
            sandbox: "Modo de prueba",
            settings: {
              allFieldsRequired: "Todos los campos son obligatorios",
              clientIdLabel: "Client ID",
              clientIdPlaceholder: "Ingrese su Client ID",
              clientSecretLabel: "Client Secret",
              clientSecretPlaceholder: "Ingrese su Client Secret",
              connectFailed: "Error al conectar",
              connected: "Uber Direct conectado exitosamente",
              connectedOn: "Conectado el",
              customerIdLabel: "Customer ID",
              customerIdPlaceholder: "Ingrese su Customer ID de Uber Direct",
              description: "Conecta tu cuenta de Uber Direct para despachar entregas de mensajería a demanda.",
              disconnect: "Desconectar",
              disconnectFailed: "Error al desconectar",
              disconnected: "Uber Direct desconectado",
              helpStep1: "Inicia sesión en tu Panel de Desarrollador de Uber Direct",
              helpStep2: "Navega a Credenciales y copia tu Customer ID, Client ID y Client Secret",
              helpStep3: "Pégalos arriba y haz clic en Guardar y conectar",
              helpTitle: "Cómo obtener tus credenciales",
              saveAndConnect: "Guardar y conectar",
              statusConnected: "Conectado",
              statusDisconnected: "No conectado",
              testConnection: "Probar conexión",
              testFailed: "Prueba de conexión fallida",
              testSuccess: "¡Conexión exitosa!",
              title: "Uber Direct",
            },
          },
          upgradeRequired: {
            features: {
              analytics: {
                description: "Obtén información poderosa sobre tu práctica con analíticas detalladas y métricas de rendimiento.",
                title: "Panel de Analíticas",
              },
              cptCodes: {
                description: "Optimiza la facturación con sugerencias y validación automatizada de códigos CPT.",
                title: "Códigos CPT",
              },
              createFollowUp: {
                description: "Nunca pierdas un contacto. Esta función crea seguimientos personalizados en el momento perfecto.",
                title: "Seguimientos Inteligentes",
              },
              homeHealth: {
                description:
                  "Tipos de notas especializadas y flujos de trabajo diseñados para proveedores de atención domiciliaria.",
                title: "Salud en el Hogar",
              },
              icdCodes: {
                description: "Accede a sugerencias completas de códigos ICD y optimización para facturación precisa.",
                title: "Códigos ICD",
              },
              levelOfServiceCodes: {
                description: "Asegura el reembolso preciso con codificación inteligente del nivel de servicio.",
                title: "Códigos de Nivel de Servicio",
              },
              locations: {
                description: "Gestiona múltiples ubicaciones y optimiza las operaciones de tu práctica en todos los sitios.",
                title: "Gestión de Ubicaciones",
              },
              managementGrid: {
                description:
                  "Organiza datos clínicos complejos con cuadrículas de gestión personalizables y seguimiento de seguros.",
                title: "Cuadrícula de Gestión",
              },
              qCode: {
                description: "Gestiona códigos de medidas de calidad para reportes precisos y cumplimiento.",
                title: "Códigos Q",
              },
              team: {
                description: "Colabora sin problemas con tu equipo y gestiona permisos de usuario eficientemente.",
                title: "Gestión de Equipo",
              },
              transitionOfCare: {
                description: "Documentación completa para transiciones de atención y referencias sin interrupciones.",
                title: "Transición de Cuidado",
              },
              uploadDocuments: {
                description: "Sube y gestiona documentos directamente en tus encuentros para registros completos del paciente.",
                title: "Subir Documentos",
              },
              woundCare: {
                description: "Documentación detallada del cuidado de heridas con plantillas especializadas y seguimiento.",
                title: "Cuidado de Heridas",
              },
            },
            hoverToPeek: "Pasa el cursor para ver",
            maybeLater: "Quizás más tarde",
            proFeature: "Función Pro",
            unlockFeature: "Desbloquear función",
          },
          users: {
            actions: {
              createUser: "Crear usuario",
            },
            columns: {
              email: "Correo electrónico",
              firstName: "Nombre",
              lastName: "Apellido",
              status: "Estado",
              type: "Tipo",
            },
            edit: {
              commission: "Comisión",
              commissionBothRequired: "Se requieren ambos valores (fijo y porcentaje) para 'Menor de ambos'",
              commissionFlat: "Comisión Fija ($/orden)",
              commissionFlatHelp: "Monto fijo en dólares por orden entregada (0-500)",
              commissionHelp: "Monto de comisión para 14 días en USD (0-500)",
              commissionLesserHelp: "Para cada orden, se usa el menor entre fijo y porcentaje",
              commissionPercent: "Comisión (% de ingresos del distribuidor)",
              commissionPercentHelp: "Porcentaje de ingresos del distribuidor por orden entregada",
              commissionRequired: "La comisión es obligatoria",
              commissionType: "Tipo de Comisión",
              commissionTypeFlat: "Fijo ($)",
              commissionTypeLesser: "Menor de ambos",
              commissionTypePercent: "Porcentaje (%)",
              duplicateEmail: "El correo del usuario ya existe",
              editWelcomeMessage: "Editar mensaje",
              errorCreatingUser: "Error al crear el usuario",
              errorUpdatingUser: "Error al actualizar el usuario",
              successCreated: "Representante creado",
              successUpdated: "Cambios guardados",
              invalidCommission: "La comisión debe estar entre $0 y $500",
              invalidEmail: "Por favor ingresa un correo electrónico válido",
              missingEmail: "Por favor agrega el correo electrónico",
              missingFirstName: "Por favor agrega el nombre",
              missingLastName: "Por favor agrega el apellido",
              missingPhone: "Por favor agrega el teléfono móvil",
              missingType: "Por favor selecciona un tipo",
              noWelcomeMessage: "Sin mensaje de bienvenida",
              pricingTier: {
                label: "Nivel de Precio",
                placeholder: "Seleccione un nivel de precio",
                hint: "Obligatorio. Determina el nivel de precio máximo que este representante puede otorgar a los proveedores o sub-representantes que invite.",
                required: "El nivel de precio es obligatorio para los representantes de ventas",
                supervisorOnlyEdit:
                  "Solo los supervisores pueden cambiar el nivel de precio de un representante después de la creación.",
                errorUpdatingTier: "Error al actualizar el nivel de precio",
                partialFailure:
                  "Otros cambios se guardaron, pero la actualización del nivel de precio falló. Por favor vuelva a intentar el cambio de nivel.",
                createPartialFailure:
                  "Representante creado, pero es posible que el nivel de precio no se haya guardado. Vuelva a abrir el representante para confirmar y establecer el nivel.",
                noGrantableTier: "Tu nivel de precios no permite otorgar ningún nivel de peptidos",
              },
              repCustomPricing: {
                label: "Precios personalizados por producto",
                hint: "Opcional. Define precios más bajos por producto para este representante. Anula su nivel; en blanco usa el precio del nivel.",
                saveFailed:
                  "Se guardaron los otros cambios, pero la actualización de precios personalizados falló. Inténtalo de nuevo.",
                createSaveFailed:
                  "Representante creado, pero los precios personalizados no se guardaron. Edita el representante para reintentarlo.",
              },
              productLines: {
                label: "Líneas de Producto",
                dme: "Colágeno DME",
                peptides: "Péptidos",
                hint: "Qué líneas de producto puede vender este representante. Debe seleccionarse al menos una. Péptidos requiere además un nivel de precio.",
                noCapability:
                  "No tienes capacidad de línea de producto para otorgar. Configura las líneas de producto en Perfil, o pide a un supervisor que actualice tu acceso, antes de invitar representantes.",
                supervisorOnlyEdit:
                  "Solo los supervisores pueden cambiar la capacidad de línea de producto después de la creación.",
                atLeastOneRequired: "Debe seleccionarse al menos una línea de producto para los representantes de ventas",
              },
              role: {
                administrator: "Administrador",
                provider: "Proveedor",
                salesRep: "Rep de Ventas",
                salesRepMaster: "Rep de Ventas Master",
                supervisor: "Supervisor",
                supportStaff: "Personal de apoyo",
              },
              selectType: "Selecciona un tipo",
              status: {
                active: "Activo",
                label: "Estado",
                suspended: "Suspendido",
              },
              tabs: {
                ehrIntegration: "Integración EHR",
                noteStyle: "Estilo de nota",
                notesSettings: "Configuración de notas",
                preferences: "Preferencias",
                profile: "Perfil",
                security: "Seguridad",
              },
              type: "Tipo",
              welcomeMessage: "Mensaje de bienvenida",
            },
            filters: {
              activeUsers: "Usuarios activos",
              search: "Buscar",
              support: "Soporte",
              suspended: "Suspendidos",
            },
            status: {
              active: "Activo",
              suspended: "Suspendido",
            },
            roles: {
              supportStaff: "Personal de soporte",
              supervisor: "Supervisor",
              patient: "Paciente",
              administrator: "Administrador",
              provider: "Proveedor",
              teamMember: "Miembro del equipo",
              salesRep: "Representante de ventas",
            },
          },
          wizard: {
            baa: {
              signRequired: "Firma el Acuerdo de Asociado Comercial al final de la página",
            },
            buttons: {
              finish: "Finalizar",
              next: "Siguiente",
            },
            clinicalRole: {
              clinical: "Proveedor clínico - Proporciono servicios médicos y puedo ordenar productos DME",
              description: "Como supervisor, indíquenos si proporciona servicios clínicos o gestiona tareas administrativas.",
              nonClinical: "Personal no clínico - Solo gestiono tareas administrativas",
              roleTypeLabel: "Su tipo de rol",
              selectRoleType: "Seleccione su tipo de rol",
              title: "Tiene un rol clínico?",
            },
            credentials: {
              label: "Credenciales",
              other: "Otro",
              selectYourCredentials: "Selecciona tus credenciales",
              toastEnter: "Ingresa tus credenciales",
            },
            demo: {
              description:
                "Elija un tipo de usuario para simular su experiencia de incorporación. Este es el modo demostración - no se guardarán cambios.",
              launchOnboardingWizard: "Iniciar asistente de incorporación (Demostración)",
              launchPatientOnboardingWizard: "Iniciar asistente de incorporación del paciente (Demostración)",
              manufacturerDescription: "Flujo de supervisor del fabricante con PIN pero sin campos de dirección/NPI",
              manufacturerTitle: "Miembro del equipo del fabricante",
              providerDescription: "Supervisor proveedor con selección de rol clínico, credenciales y campos de dirección",
              providerTitle: "Supervisor proveedor",
              salesRepDescription:
                "Representante de ventas con pasos mínimos de incorporación (sin PIN, credenciales ni dirección)",
              salesRepTitle: "Representante de ventas",
              selectUserType: "Seleccione el tipo de usuario a simular",
            },
            doctorType: {
              generalist: "Generalista",
              prompt: "Selecciona tu especialidad. Si no está incluida, déjalo vacío para acceder a todas las notas.",
              providerType: "Tipo de proveedor",
            },
            language: {
              no: "No",
              options: {
                ar: "Árabe",
                auto: "Multiidioma",
                en: "Solo inglés",
                es: "Solo español",
                ko: "Coreano",
                spen: "Inglés/Español (Spanglish)",
              },
              primaryQuestion: "¿Cuál es el idioma principal con el que hablas con tus pacientes?",
              speakSpanishQuestion: "¿Hablas español con tus pacientes?",
              yes: "Sí",
            },
            noteTypes: {
              title: "Elige los tipos de notas que usas. Puedes cambiarlos luego en Preferencias.",
            },
            password: {
              confirm: "Confirmar contraseña",
              new: "Nueva contraseña",
              req: {
                length: "Entre 12 y 50 caracteres",
                lowercase: "Debe contener al menos una letra minúscula",
                number: "Debe contener al menos un número",
                special: "Debe contener al menos un carácter especial",
                uppercase: "Debe contener al menos una letra mayúscula",
              },
              requirementsLead: "Selecciona una contraseña que cumpla los siguientes requisitos:",
              title: "Configura tu contraseña",
              toast: {
                length: "La contraseña debe tener entre 12 y 50 caracteres",
                lowercase: "La contraseña debe contener al menos una letra minúscula",
                mismatch: "Las contraseñas deben coincidir",
                number: "La contraseña debe contener al menos un número",
                special: "La contraseña debe contener al menos un carácter especial",
                uppercase: "La contraseña debe contener al menos una letra mayúscula",
              },
            },
            pin: {
              title: "Crea el PIN de 4 dígitos que usarás para firmar y archivar el encuentro.",
              toastEnter4Digits: "Ingresa un PIN de 4 dígitos",
            },
            profile: {
              address: "Dirección de la práctica",
              firstName: "Nombre",
              lastName: "Apellido",
              notInUS: "Fuera de EE. UU.",
              npiNumber: "Número NPI",
              npiNumberPlaceholder: "Ingrese su número NPI (obligatorio para MD, DO, ARNP, PA)",
              officeAddress: "Dirección de la oficina",
              officeAddressPlaceholder: "Ingrese la dirección de su consultorio o clínica",
              officeName: "Nombre de la oficina",
              officeNamePlaceholder: "Ingrese el nombre de su consultorio o clínica",
              phone: "Teléfono",
              ptanNumber: "Número PTAN",
              ptanNumberPlaceholder: "Ingrese su número PTAN (opcional, 6-10 caracteres)",
              selectStateOption: "Selecciona un estado",
              state: "Estado de Práctica Principal",
              title: "Ingresa tus datos de perfil.",
              toast: {
                enterFirstName: "Ingresa tu nombre",
                enterLastName: "Ingresa tu apellido",
                enterPhone: "Ingresa tu teléfono móvil",
                insertZip: "Ingresa el código postal",
                selectState: "Selecciona un estado",
              },
              zipcode: "Código postal",
            },
            referral: {
              options: {
                Ad: "Anuncio en línea",
                Conference: "Conferencia o evento",
                DoctorReferral: "Referencia de médico u organización",
                Facebook: "Facebook",
                Friend: "De un amigo o colega",
                GoogleSearch: "Búsqueda de Google",
                Instagram: "Instagram",
                LinkedIn: "LinkedIn",
                Podcast: "Podcast",
                TikTok: "TikTok",
                Twitter: "Twitter",
                WordOfMouth: "Recomendación",
                YouTube: "YouTube",
              },
              title: "¿Cómo nos conociste?",
            },
            patientIdentity: {
              title: "Confirma tu información",
              subtitle: "Confirma lo que enviaste en tu admisión. Edita cualquier dato que no sea correcto.",
              dob: "Fecha de nacimiento",
              preferredContact: "Contacto preferido para actualizaciones",
              selectChannel: "Selecciona…",
              channelEmail: "Correo electrónico",
              channelSms: "Mensaje de texto (SMS)",
              emergencyContactName: "Nombre del contacto de emergencia",
              emergencyContactPhone: "Teléfono del contacto de emergencia",
              toast: {
                dobRequired: "Por favor ingresa tu fecha de nacimiento.",
                channelRequired: "Por favor selecciona un canal de contacto preferido.",
              },
            },
            patientShipping: {
              title: "¿A dónde enviamos?",
              subtitle: "Usamos esta dirección para cada pedido de péptidos. Puedes actualizarla luego desde tu perfil.",
              street: "Dirección",
              aptUnit: "Apto / unidad",
              city: "Ciudad",
              state: "Estado",
              selectState: "Selecciona estado",
              zip: "Código postal",
              sameAsBilling: "La dirección de facturación es la misma que la de envío",
              billingStreet: "Dirección de facturación",
              billingAptUnit: "Apto de facturación",
              billingCity: "Ciudad de facturación",
              billingState: "Estado de facturación",
              billingZip: "Código postal de facturación",
              toast: {
                requiredFields: "Completa la dirección, ciudad, estado y código postal de envío.",
                zipFormat: "El código postal debe tener 5 dígitos o 5+4 (por ej., 94110 o 94110-1234).",
                billingRequired: "Completa todos los campos de la dirección de facturación.",
              },
            },
            styles: {
              bullets: "Viñetas",
              complex: "Complejo",
              comprehensive: "Exhaustivo",
              concise: "Conciso",
              hpi: "HPI",
              length: "Longitud",
              mdm: "Toma de decisiones médicas",
              paragraph: "Párrafo",
              physicalExam: "Examen físico",
              planOfCare: "Plan de atención",
              ros: "Revisión de sistemas",
              style: "Estilo",
              title:
                'Selecciona el estilo y la longitud que prefieres para cada elemento. Puedes cambiarlos desde el botón "Personalizar" en la nota.',
            },
            table: {
              enable: "Habilitar",
              type: "Tipo",
            },
            terms: {
              signRequired: "Firma los términos de uso al final de la página",
            },
            toast: {
              completeError: "Ocurrió un error al completar el asistente. Inténtalo de nuevo.",
              welcome: "¡Bienvenido!",
            },
            welcome: {
              subtitle1:
                "Te has unido a {{organization}}, un sistema de asistente médico con IA diseñado para mejorar tu experiencia de atención médica.",
              subtitle2: "Comienza ahora haciendo clic en Siguiente para completar tus datos.",
              title: "¡Bienvenido!",
            },
            welcomeOrders: {
              subtitle1:
                "Te has unido a un sistema de asistente impulsado por IA diseñado para mejorar tu experiencia de atención médica. Lucas facilita el pedido de DME, péptidos y exosomas utilizando un motor habilitado para el cumplimiento para agilizar tus compras, cumplimiento y seguimiento de productos.",
              subtitle2: "Comienza ahora haciendo clic en Siguiente para comenzar a completar tus datos.",
              title: "¡Bienvenido!",
            },
            welcomePatient: {
              title: "¡Bienvenido!",
              subtitle1:
                "Tu proveedor te invitó a Lucas para terapia con péptidos. Solo necesitamos confirmar un par de detalles y agregar tu dirección de envío — unos dos minutos.",
            },
            contracts: {
              received: {
                title: "Contratos Recibidos",
                empty: "Aún no hay contratos recibidos.",
                signedOn: "Firmado {{date}}",
                sentOn: "Enviado {{date}} · pendiente de firma",
                review: "Revisar y Firmar",
              },
              sign: {
                title: "Firmar Contrato",
                agree: "He leído y acepto el contrato anterior.",
                typedNameLabel: "Escribe tu nombre completo para firmar",
                typedNameHint: "Debe coincidir con el nombre de tu cuenta: {{name}}",
                submit: "Firmar",
                signing: "Firmando…",
                ok: "Firmado.",
                failed: "No se pudo registrar tu firma. Inténtalo de nuevo.",
                notFound: "Este contrato ya no está disponible.",
                emptyContent: "Este contrato no tiene contenido para mostrar.",
                pinNote: "Ingresarás tu PIN para firmar electrónicamente.",
                pinTitle: "Firmar contrato",
                pinHeader: "Ingresa tu PIN para firmar electrónicamente",
              },
            },
            myProfile: {
              title: "Mi perfil",
              saved: "Guardado",
              saveError: "Error al guardar — inténtalo de nuevo",
              empty: {
                providerOwned: "Tu profesional médico aún no ha agregado esto",
                patientCta: "Agregar tu información",
              },
            },
            manageRefills: {
              title: "Gestionar reabastecimientos",
              description:
                "Consulta y gestiona tus reabastecimientos automáticos aquí. Esta sección está en construcción — por ahora, solicita un reabastecimiento desde tu panel de péptidos.",
            },
            refillSettings: {
              title: "Configuración de reabastecimiento",
              back: "Volver",
              save: "Guardar",
              saving: "Guardando…",
              saveSuccess: "Configuración de reabastecimiento guardada",
              saveError: "No se pudo guardar la configuración de reabastecimiento",
              loadFailedBanner:
                "No se pudo obtener la configuración guardada. Mostrando valores predeterminados — sus cambios se enviarán al guardar.",
              refillTrackingEnabled: {
                label: "Seguimiento de reabastecimiento",
                help: "Cuando está activado, el panel de reabastecimiento muestra los pedidos vencidos y próximos a vencer.",
              },
              peptideRefillCycleDays: {
                label: "Días del ciclo de reabastecimiento",
                help: "Número de días entre la entrega de un péptido y la próxima fecha de reabastecimiento del paciente.",
              },
              dueSoonThresholdDays: {
                label: "Umbral de próximo vencimiento (días)",
                help: "Cuántos días antes de la fecha de reabastecimiento se muestra un pedido como 'próximo a vencer'.",
              },
              maxRefillsPerTherapy: {
                label: "Máximo de reabastecimientos por terapia (opcional)",
                help: "Déjalo en blanco para ilimitado. Cuando se establece, los reabastecimientos que superan este límite no se muestran automáticamente.",
              },
            },
            surchargeSettings: {
              title: "Recargo por forma activa",
              help: "Activa o desactiva el recargo por vial de forma activa para proveedores individuales. Activado de forma predeterminada.",
              on: "Recargo activado",
              off: "Recargo desactivado",
              empty: "Aún no hay proveedores vinculados.",
              back: "Atrás",
              saveSuccess: "Configuración de recargo guardada",
              saveError: "No se pudo guardar la configuración de recargo",
            },
            pay: {
              title: "Revisar y pagar",
              method: "Método de pago",
              card: "Tarjeta",
              zelle: "Zelle",
              cardNumber: "Número de tarjeta",
              expiry: "MM/AA",
              cvv: "CVV",
              cardholderName: "Nombre del titular",
              billingZip: "Código postal de facturación",
              pay: "Pagar {{amount}}",
              processing: "Procesando…",
              secureNote: "Los pagos se cifran y procesan de forma segura.",
              zelleInstructions: "Envía el pago por Zelle a alphabiopayments@gmail.com y luego sube tu comprobante abajo.",
              uploadReceipt: "Subir comprobante",
              submitZelle: "Enviar pago",
              receiptRequired: "Sube tu comprobante de pago.",
              zelleSubmitted: "Comprobante enviado: el fabricante confirmará tu pago.",
              cardSuccess: "Pago exitoso.",
              declined: "Tu tarjeta fue rechazada. Verifica los datos e inténtalo de nuevo.",
              genericError: "No pudimos procesar el pago. Inténtalo de nuevo.",
            },
          },
          myProfile: {
            title: "Mi perfil",
            saved: "Guardado",
            saveError: "Error al guardar — inténtalo de nuevo",
            loading: "Cargando tu perfil…",
            loadError: {
              title: "No pudimos cargar tu perfil",
              description: "Inténtalo de nuevo en un momento. Si el problema persiste, contacta a tu profesional médico.",
              retry: "Intentar de nuevo",
            },
            empty: {
              providerOwned: "Tu profesional médico aún no ha agregado esto",
              patientCta: "Agregar tu información",
            },
          },
        },
      },
    },
  });
export default i18n;
